/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export type CheckEmailBody = {
    /**
     * @description Email address to check
     * @type string
    */
    email: string;
};

export const checkEmailOutputStatusEnum = {
    CONFIRMED: "CONFIRMED",
    PASSWORD_SETUP_REQUIRED: "PASSWORD_SETUP_REQUIRED",
    SSO_REQUIRED: "SSO_REQUIRED"
} as const;

export type CheckEmailOutputStatusEnumKey = (typeof checkEmailOutputStatusEnum)[keyof typeof checkEmailOutputStatusEnum];

export const checkEmailOutputProvidersEnum = {
    Google: "Google",
    Apple: "Apple"
} as const;

export type CheckEmailOutputProvidersEnumKey = (typeof checkEmailOutputProvidersEnum)[keyof typeof checkEmailOutputProvidersEnum];

export type CheckEmailOutput = {
    /**
     * @description Email status
     * @type string
    */
    status: CheckEmailOutputStatusEnumKey;
    /**
     * @description SSO providers linked to this email when status is SSO_REQUIRED
     * @type array | undefined
    */
    providers?: CheckEmailOutputProvidersEnumKey[];
};

export type Metadata = {
    /**
     * @description the key of the metadata
     * @type string
    */
    key: string;
    /**
     * @description the value of the metadata
     * @type string
    */
    value: string;
};

export const documentWithSignedUrlTypeEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated",
    generated: "generated"
} as const;

export type DocumentWithSignedUrlTypeEnumKey = (typeof documentWithSignedUrlTypeEnum)[keyof typeof documentWithSignedUrlTypeEnum];

export type DocumentWithSignedUrl = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description The stored document role.
     * @type string
    */
    type: DocumentWithSignedUrlTypeEnumKey | null;
    /**
     * @description The stored document category, or null while unclassified.
     * @type string
    */
    category: string | null;
    /**
     * @description the id of the document
     * @type string
    */
    id: string;
    /**
     * @description the name of the document
     * @type string
    */
    name: string;
    /**
     * @description the path of the document on the Korint CDN
     * @type string
    */
    path: string;
    /**
     * @description the date of creation of the document
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description the signed url to download the document
     * @type string
    */
    signedUrl: string;
};

export type GetDocumentsOutput = {
    /**
     * @description the documents retrieved
     * @type array
    */
    documents: DocumentWithSignedUrl[];
};

export type CustomFieldDto = {
    /**
     * @type string
    */
    key: string;
    value: (string | number | boolean | {
        [key: string]: (string | number | boolean) | null;
    }[]);
};

export const aikanAssetDtoStatusEnum = {
    ASSET_CREATED: "ASSET_CREATED",
    ASSET_REMOVED: "ASSET_REMOVED",
    ASSET_QUOTED: "ASSET_QUOTED",
    ASSET_CONFIRMED: "ASSET_CONFIRMED",
    ASSET_STARTED: "ASSET_STARTED",
    ASSET_STOPPED: "ASSET_STOPPED",
    ASSET_CANCELLED: "ASSET_CANCELLED"
} as const;

export type AikanAssetDtoStatusEnumKey = (typeof aikanAssetDtoStatusEnum)[keyof typeof aikanAssetDtoStatusEnum];

export type AikanAssetDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description assetId
     * @type string
    */
    id: string;
    /**
     * @description Last modified date of the asset
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Creation date of the asset
     * @type string
    */
    createdAt: string;
    /**
     * @description Status of the asset
     * @type string
    */
    status: AikanAssetDtoStatusEnumKey;
    /**
     * @description Date the asset starts
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description Date the asset stops
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @description Date the asset was cancelled
     * @type string | undefined
    */
    cancelledAt?: string;
    /**
     * @description policyId of asset owner
     * @type string
    */
    policyId: string;
    /**
     * @description Contract number
     * @type string | undefined
    */
    contractNumber?: string;
};

export type AikanBatchGetAssetsOutput = {
    /**
     * @description the assets retrieved
     * @type array
    */
    assets: AikanAssetDto[];
};

export type NullableCustomFieldDto = {
    /**
     * @type string
    */
    key: string;
    value: (string | number | boolean | {
        [key: string]: (string | number | boolean) | null;
    }[]) | null;
};

export type BatchCreateAssetItem = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description externalAssetId
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @description startedAt
     * @type string | undefined
    */
    startedAt?: string;
};

export type BatchCreateAssetBody = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type array
    */
    assets: BatchCreateAssetItem[];
};

export type BatchCreateAssetOutput = object;

export type BatchEditAssetItem = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description externalAssetId
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @description startedAt
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description stoppedAt
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @type string
    */
    assetId: string;
};

export type BatchEditAssetBody = {
    /**
     * @description policyId owning every edited asset
     * @type string
    */
    policyId: string;
    /**
     * @type array
    */
    assets: BatchEditAssetItem[];
};

export type BatchEditAssetOutput = object;

export type BatchRemoveAssetInputBody = {
    /**
     * @description policyId owning every removed asset
     * @type string
    */
    policyId: string;
    /**
     * @type array
    */
    assetIds: string[];
};

export type BatchRemoveAssetOutput = object;

export type InvalidCustomFieldsDetailsErrorsDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type array
    */
    errorDetails: string[];
    /**
     * @type object | undefined
    */
    value?: object;
};

export type InvalidCustomFieldsDetailsDto = {
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @type array
    */
    errors: InvalidCustomFieldsDetailsErrorsDto[];
};

export const invalidCustomFieldsErrorDtoCodeEnum = {
    INVALID_CUSTOM_FIELDS: "INVALID_CUSTOM_FIELDS"
} as const;

export type InvalidCustomFieldsErrorDtoCodeEnumKey = (typeof invalidCustomFieldsErrorDtoCodeEnum)[keyof typeof invalidCustomFieldsErrorDtoCodeEnum];

export type InvalidCustomFieldsErrorDto = {
    /**
     * @type string
    */
    code: InvalidCustomFieldsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidCustomFieldsDetailsDto;
};

export type InvalidEventCreationDateDetailsDto = {
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    latestCreatedAt: string;
};

export const invalidEventCreationDateErrorDtoCodeEnum = {
    INVALID_EVENT_CREATION_DATE: "INVALID_EVENT_CREATION_DATE"
} as const;

export type InvalidEventCreationDateErrorDtoCodeEnumKey = (typeof invalidEventCreationDateErrorDtoCodeEnum)[keyof typeof invalidEventCreationDateErrorDtoCodeEnum];

export type InvalidEventCreationDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidEventCreationDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEventCreationDateDetailsDto;
};

export type InvalidProductDetailsDto = {
    /**
     * @type string | undefined
    */
    tenant?: string;
    /**
     * @type string
    */
    product: string;
    /**
     * @type string | undefined
    */
    expectedProduct?: string;
};

export const invalidProductErrorDtoCodeEnum = {
    INVALID_PRODUCT: "INVALID_PRODUCT"
} as const;

export type InvalidProductErrorDtoCodeEnumKey = (typeof invalidProductErrorDtoCodeEnum)[keyof typeof invalidProductErrorDtoCodeEnum];

export type InvalidProductErrorDto = {
    /**
     * @type string
    */
    code: InvalidProductErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidProductDetailsDto;
};

export type InvalidAssetStartedAtDetailsDto = {
    /**
     * @type string
    */
    givenDate: string;
    /**
     * @type string | undefined
    */
    limitDate?: string;
    /**
     * @type string | undefined
    */
    userHelp?: string;
};

export const invalidAssetStartedAtErrorDtoCodeEnum = {
    INVALID_ASSET_STARTED_AT: "INVALID_ASSET_STARTED_AT"
} as const;

export type InvalidAssetStartedAtErrorDtoCodeEnumKey = (typeof invalidAssetStartedAtErrorDtoCodeEnum)[keyof typeof invalidAssetStartedAtErrorDtoCodeEnum];

export type InvalidAssetStartedAtErrorDto = {
    /**
     * @type string
    */
    code: InvalidAssetStartedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidAssetStartedAtDetailsDto;
};

export type ForbiddenDetailsDto = {
    /**
     * @type string
    */
    message: string;
    /**
     * @type string
    */
    documentKey: string;
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    ownerId: string;
};

export const forbiddenErrorDtoCodeEnum = {
    FORBIDDEN: "FORBIDDEN"
} as const;

export type ForbiddenErrorDtoCodeEnumKey = (typeof forbiddenErrorDtoCodeEnum)[keyof typeof forbiddenErrorDtoCodeEnum];

export type ForbiddenErrorDto = {
    /**
     * @type string
    */
    code: ForbiddenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ForbiddenDetailsDto;
};

export type PolicyNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type string | undefined
    */
    simulatedAt?: string;
};

export const policyNotFoundErrorDtoCodeEnum = {
    POLICY_NOT_FOUND: "POLICY_NOT_FOUND"
} as const;

export type PolicyNotFoundErrorDtoCodeEnumKey = (typeof policyNotFoundErrorDtoCodeEnum)[keyof typeof policyNotFoundErrorDtoCodeEnum];

export type PolicyNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PolicyNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyNotFoundDetailsDto;
};

export const operationRequirementEnum = {
    "must be": "must be",
    "must NOT be": "must NOT be",
    "must contain": "must contain",
    "must NOT contain": "must NOT contain"
} as const;

export type OperationRequirementEnumKey = (typeof operationRequirementEnum)[keyof typeof operationRequirementEnum];

export type OperationRequirement = OperationRequirementEnumKey;

export const actionEnum = {
    "PERFORM THIS ACTION": "PERFORM THIS ACTION",
    "CREATE POLICY": "CREATE POLICY",
    "CREATE ASSET": "CREATE ASSET",
    "CREATE ASSET WITH START DATE": "CREATE ASSET WITH START DATE",
    "REPLACE ASSET": "REPLACE ASSET",
    "REMOVE ASSET": "REMOVE ASSET",
    "CHOOSE ASSET OPTIONS": "CHOOSE ASSET OPTIONS",
    "STOP ASSET": "STOP ASSET",
    "EDIT ASSET": "EDIT ASSET",
    "EDIT ASSET WITH START DATE": "EDIT ASSET WITH START DATE",
    "CREATE BRANCH": "CREATE BRANCH",
    "CREATE DEROGATION": "CREATE DEROGATION",
    "CREATE MTA BRANCH": "CREATE MTA BRANCH",
    "FORK TO NEW MTA BRANCH": "FORK TO NEW MTA BRANCH",
    "FORK TO NEW NB BRANCH": "FORK TO NEW NB BRANCH",
    "FORK TO NEW RENEWAL BRANCH": "FORK TO NEW RENEWAL BRANCH",
    "FORK TO NEW REPRICING BRANCH": "FORK TO NEW REPRICING BRANCH",
    "DEFINE PARENT POLICY ID": "DEFINE PARENT POLICY ID",
    "INITIALIZE CUSTOMER": "INITIALIZE CUSTOMER",
    "EDIT CUSTOMER": "EDIT CUSTOMER",
    "DELETE CUSTOMER FROM POLICY": "DELETE CUSTOMER FROM POLICY",
    SIGN: "SIGN",
    "EDIT POLICY": "EDIT POLICY",
    "EDIT POLICY EXTERNAL ID": "EDIT POLICY EXTERNAL ID",
    "CONFIRM POLICY": "CONFIRM POLICY",
    "QUOTE POLICY": "QUOTE POLICY",
    "RETRIEVING QUOTE": "RETRIEVING QUOTE",
    "STOP POLICY": "STOP POLICY",
    "SUSPEND POLICY": "SUSPEND POLICY",
    "ACTIVATE POLICY": "ACTIVATE POLICY",
    "GENERATE MANDATE SIGNATURE REQUEST": "GENERATE MANDATE SIGNATURE REQUEST",
    "GENERATE PAYMENT METHOD SECRET": "GENERATE PAYMENT METHOD SECRET",
    "CREATE CLAIM": "CREATE CLAIM",
    "FINALIZE RENEWAL": "FINALIZE RENEWAL",
    "SEND CONTRACT TO SIGNATURE": "SEND CONTRACT TO SIGNATURE",
    "GENERATE SIGNATURE REQUEST": "GENERATE SIGNATURE REQUEST",
    "GENERATE DOCUMENTS FOR SIGNATURE": "GENERATE DOCUMENTS FOR SIGNATURE",
    "APPROVE DISTRIBUTION REQUEST": "APPROVE DISTRIBUTION REQUEST",
    "DENY DISTRIBUTION REQUEST": "DENY DISTRIBUTION REQUEST",
    REVOKED_DISTRIBUTION_REQUEST: "REVOKED_DISTRIBUTION_REQUEST",
    "DELETE DISTRIBUTION REQUEST": "DELETE DISTRIBUTION REQUEST",
    "WAITING FOR SIGNATURE DISTRIBUTION REQUEST": "WAITING FOR SIGNATURE DISTRIBUTION REQUEST",
    "UPDATE POLICY QUOTE": "UPDATE POLICY QUOTE"
} as const;

export type ActionEnumKey = (typeof actionEnum)[keyof typeof actionEnum];

export type Action = ActionEnumKey;

export type ConflictContractTypeDetailsDto = {
    /**
     * @type string
    */
    contractType: string;
    requirement: OperationRequirement;
    action: Action;
};

export const conflictingContractTypeErrorDtoCodeEnum = {
    CONFLICTING_CONTRACT_TYPE: "CONFLICTING_CONTRACT_TYPE"
} as const;

export type ConflictingContractTypeErrorDtoCodeEnumKey = (typeof conflictingContractTypeErrorDtoCodeEnum)[keyof typeof conflictingContractTypeErrorDtoCodeEnum];

export type ConflictingContractTypeErrorDto = {
    /**
     * @type string
    */
    code: ConflictingContractTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictContractTypeDetailsDto;
};

export const businessEntityEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type BusinessEntityEnumKey = (typeof businessEntityEnum)[keyof typeof businessEntityEnum];

export type BusinessEntity = BusinessEntityEnumKey;

export const fieldQualifierEnum = {
    DEFINED: "DEFINED",
    AFTER: "AFTER",
    BEFORE: "BEFORE",
    "ON or AFTER": "ON or AFTER",
    "BEFORE or ON": "BEFORE or ON",
    ON: "ON",
    EMPTY: "EMPTY",
    in: "in"
} as const;

export type FieldQualifierEnumKey = (typeof fieldQualifierEnum)[keyof typeof fieldQualifierEnum];

export type FieldQualifier = FieldQualifierEnumKey;

export type ConflictingBusinessEntityFieldDefinitionDetailsDto = {
    entity: BusinessEntity;
    /**
     * @type string | undefined
    */
    id?: string;
    /**
     * @type string
    */
    field: string;
    requirement: OperationRequirement;
    qualifier: FieldQualifier;
    /**
     * @type string | undefined
    */
    additionalData?: string;
    /**
     * @type object | undefined
    */
    rawData?: {
        [key: string]: any;
    };
};

export const conflictingFieldDefinitionErrorDtoCodeEnum = {
    CONFLICTING_FIELD_DEFINITION: "CONFLICTING_FIELD_DEFINITION"
} as const;

export type ConflictingFieldDefinitionErrorDtoCodeEnumKey = (typeof conflictingFieldDefinitionErrorDtoCodeEnum)[keyof typeof conflictingFieldDefinitionErrorDtoCodeEnum];

export type ConflictingFieldDefinitionErrorDto = {
    /**
     * @type string
    */
    code: ConflictingFieldDefinitionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingBusinessEntityFieldDefinitionDetailsDto;
};

export const conflictingPolicyStatusDetailsDtoPolicyStatusEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type ConflictingPolicyStatusDetailsDtoPolicyStatusEnumKey = (typeof conflictingPolicyStatusDetailsDtoPolicyStatusEnum)[keyof typeof conflictingPolicyStatusDetailsDtoPolicyStatusEnum];

export type ConflictingPolicyStatusDetailsDto = {
    /**
     * @description The status the operation requires, or the list of statuses that would have allowed it.
    */
    policyStatus: (ConflictingPolicyStatusDetailsDtoPolicyStatusEnumKey | ConflictingPolicyStatusDetailsDtoPolicyStatusEnumKey[]);
    /**
     * @type string
    */
    policyId: string;
    requirement: OperationRequirement;
    action: Action;
    /**
     * @type object | undefined
    */
    additionalData?: {
        [key: string]: any;
    };
};

export const conflictingPolicyStatusErrorDtoCodeEnum = {
    CONFLICTING_POLICY_STATUS: "CONFLICTING_POLICY_STATUS"
} as const;

export type ConflictingPolicyStatusErrorDtoCodeEnumKey = (typeof conflictingPolicyStatusErrorDtoCodeEnum)[keyof typeof conflictingPolicyStatusErrorDtoCodeEnum];

export type ConflictingPolicyStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingPolicyStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingPolicyStatusDetailsDto;
};

export type CreateAssetBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description policyId of asset owner
     * @type string
    */
    policyId: string;
    /**
     * @description externalAssetId
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @description startedAt
     * @type string | undefined
    */
    startedAt?: string;
};

export type CreateAssetOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type BranchNotFoundDetailsDto = {
    /**
     * @type string
    */
    branchId: string;
};

export const branchNotFoundErrorDtoCodeEnum = {
    BRANCH_NOT_FOUND: "BRANCH_NOT_FOUND"
} as const;

export type BranchNotFoundErrorDtoCodeEnumKey = (typeof branchNotFoundErrorDtoCodeEnum)[keyof typeof branchNotFoundErrorDtoCodeEnum];

export type BranchNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BranchNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BranchNotFoundDetailsDto;
};

export type ConflictingConfigDetailsDto = {
    /**
     * @type string
    */
    configField: string;
    requirement: OperationRequirement;
    /**
     * @type string
    */
    value: string;
    action: Action;
};

export const conflictingConfigErrorDtoCodeEnum = {
    CONFLICTING_CONFIG: "CONFLICTING_CONFIG"
} as const;

export type ConflictingConfigErrorDtoCodeEnumKey = (typeof conflictingConfigErrorDtoCodeEnum)[keyof typeof conflictingConfigErrorDtoCodeEnum];

export type ConflictingConfigErrorDto = {
    /**
     * @type string
    */
    code: ConflictingConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingConfigDetailsDto;
};

export type MaxActiveAssetConflictDetailsTimePeriodsDto = {
    /**
     * @type string, date-time
    */
    startedAt: string;
    /**
     * @type string | undefined, date-time
    */
    stoppedAt?: string;
};

export type MaxActiveAssetConflictDetailsDto = {
    /**
     * @type number
    */
    activeAssetsLimit: number;
    /**
     * @type array
    */
    timePeriods: MaxActiveAssetConflictDetailsTimePeriodsDto[];
};

export const maxActiveAssetsReachedErrorDtoCodeEnum = {
    MAX_ACTIVE_ASSETS_REACHED: "MAX_ACTIVE_ASSETS_REACHED"
} as const;

export type MaxActiveAssetsReachedErrorDtoCodeEnumKey = (typeof maxActiveAssetsReachedErrorDtoCodeEnum)[keyof typeof maxActiveAssetsReachedErrorDtoCodeEnum];

export type MaxActiveAssetsReachedErrorDto = {
    /**
     * @type string
    */
    code: MaxActiveAssetsReachedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MaxActiveAssetConflictDetailsDto;
};

export const branchStatusEnum = {
    BRANCH_OPEN: "BRANCH_OPEN",
    BRANCH_MERGED: "BRANCH_MERGED",
    BRANCH_CLOSED: "BRANCH_CLOSED"
} as const;

export type BranchStatusEnumKey = (typeof branchStatusEnum)[keyof typeof branchStatusEnum];

export type BranchStatus = BranchStatusEnumKey;

export type ConflictingBranchStatusDetailsDto = {
    branchStatus: BranchStatus;
    requirement: OperationRequirement;
    action: Action;
};

export const conflictingBranchStatusErrorDtoCodeEnum = {
    CONFLICTING_BRANCH_STATUS: "CONFLICTING_BRANCH_STATUS"
} as const;

export type ConflictingBranchStatusErrorDtoCodeEnumKey = (typeof conflictingBranchStatusErrorDtoCodeEnum)[keyof typeof conflictingBranchStatusErrorDtoCodeEnum];

export type ConflictingBranchStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingBranchStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingBranchStatusDetailsDto;
};

export const branchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type BranchTypeEnumKey = (typeof branchTypeEnum)[keyof typeof branchTypeEnum];

export type BranchType = BranchTypeEnumKey;

export type ConflictingBranchTypeDetailsDto = {
    branchType: BranchType;
    requirement: OperationRequirement;
    action: Action;
};

export const conflictingBranchTypeErrorDtoCodeEnum = {
    CONFLICTING_BRANCH_TYPE: "CONFLICTING_BRANCH_TYPE"
} as const;

export type ConflictingBranchTypeErrorDtoCodeEnumKey = (typeof conflictingBranchTypeErrorDtoCodeEnum)[keyof typeof conflictingBranchTypeErrorDtoCodeEnum];

export type ConflictingBranchTypeErrorDto = {
    /**
     * @type string
    */
    code: ConflictingBranchTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingBranchTypeDetailsDto;
};

export const assetStatusEnum = {
    ASSET_CREATED: "ASSET_CREATED",
    ASSET_REMOVED: "ASSET_REMOVED",
    ASSET_QUOTED: "ASSET_QUOTED",
    ASSET_CONFIRMED: "ASSET_CONFIRMED",
    ASSET_STARTED: "ASSET_STARTED",
    ASSET_STOPPED: "ASSET_STOPPED",
    ASSET_CANCELLED: "ASSET_CANCELLED"
} as const;

export type AssetStatusEnumKey = (typeof assetStatusEnum)[keyof typeof assetStatusEnum];

export type AssetStatus = AssetStatusEnumKey;

export type ConflictingAssetStatusDetailsDto = {
    assetStatus: AssetStatus;
    requirement: OperationRequirement;
    action: Action;
    /**
     * @type object | undefined
    */
    additionalData?: {
        [key: string]: any;
    };
};

export const conflictingAssetStatusErrorDtoCodeEnum = {
    CONFLICTING_ASSET_STATUS: "CONFLICTING_ASSET_STATUS"
} as const;

export type ConflictingAssetStatusErrorDtoCodeEnumKey = (typeof conflictingAssetStatusErrorDtoCodeEnum)[keyof typeof conflictingAssetStatusErrorDtoCodeEnum];

export type ConflictingAssetStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingAssetStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingAssetStatusDetailsDto;
};

export type ReplaceAssetBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description policyId of asset owner
     * @type string
    */
    policyId: string;
    /**
     * @description externalAssetId
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @description original asset stoppedAt
     * @type string | undefined
    */
    replacedAt?: string;
};

export type ReplaceAssetOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type AssetNotFoundDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type string | undefined
    */
    simulatedAt?: string;
};

export const assetNotFoundErrorDtoCodeEnum = {
    ASSET_NOT_FOUND: "ASSET_NOT_FOUND"
} as const;

export type AssetNotFoundErrorDtoCodeEnumKey = (typeof assetNotFoundErrorDtoCodeEnum)[keyof typeof assetNotFoundErrorDtoCodeEnum];

export type AssetNotFoundErrorDto = {
    /**
     * @type string
    */
    code: AssetNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AssetNotFoundDetailsDto;
};

export type FieldsRequirementsErrorDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type array
    */
    errorDetails: string[];
};

export type FieldsRequirementsConflictDto = {
    /**
     * @type string
    */
    product: string;
    /**
     * @type array
    */
    errors: FieldsRequirementsErrorDto[];
};

export const fieldsDoNotMeetRequirementsErrorDtoCodeEnum = {
    FIELDS_DO_NOT_MEET_REQUIREMENTS: "FIELDS_DO_NOT_MEET_REQUIREMENTS"
} as const;

export type FieldsDoNotMeetRequirementsErrorDtoCodeEnumKey = (typeof fieldsDoNotMeetRequirementsErrorDtoCodeEnum)[keyof typeof fieldsDoNotMeetRequirementsErrorDtoCodeEnum];

export type FieldsDoNotMeetRequirementsErrorDto = {
    /**
     * @type string
    */
    code: FieldsDoNotMeetRequirementsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FieldsRequirementsConflictDto;
};

export type EditAssetBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description externalAssetId
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @description startedAt
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description stoppedAt
     * @type string | undefined
    */
    stoppedAt?: string;
};

export type EditAssetOutput = object;

export type QuoteProviderDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    version: string;
};

export type RateInputDto = {
    /**
     * @description id
     * @type string
    */
    id: string;
    /**
     * @description value
    */
    value: (string | number);
};

export type RateDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type integer
    */
    rate: number;
    /**
     * @type array
    */
    inputs: RateInputDto[];
};

export const feeDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type FeeDtoChargeTypeEnumKey = (typeof feeDtoChargeTypeEnum)[keyof typeof feeDtoChargeTypeEnum];

export type FeeDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    label?: string;
    /**
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @type string
    */
    chargeType: FeeDtoChargeTypeEnumKey;
    /**
     * @type integer
    */
    amount: number;
};

export const taxDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type TaxDtoChargeTypeEnumKey = (typeof taxDtoChargeTypeEnum)[keyof typeof taxDtoChargeTypeEnum];

export type TaxDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    label?: string;
    /**
     * @type string
    */
    chargeType: TaxDtoChargeTypeEnumKey;
    /**
     * @type integer
    */
    amount: number;
};

export type AmountDto = {
    /**
     * @type integer
    */
    amountPreFeesAndTaxes: number;
    /**
     * @type array
    */
    fees: FeeDto[];
    /**
     * @type integer
    */
    totalFees: number;
    /**
     * @type integer
    */
    amountWithFeesPreTaxes: number;
    /**
     * @type array
    */
    taxes: TaxDto[];
    /**
     * @type integer
    */
    totalTaxes: number;
    /**
     * @type integer
    */
    amountWithFeesAndTaxes: number;
};

export const quoteComponentDtoTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type QuoteComponentDtoTypeEnumKey = (typeof quoteComponentDtoTypeEnum)[keyof typeof quoteComponentDtoTypeEnum];

export const quoteComponentDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type QuoteComponentDtoInsurerEnumKey = (typeof quoteComponentDtoInsurerEnum)[keyof typeof quoteComponentDtoInsurerEnum];

export const quoteComponentDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type QuoteComponentDtoChargeTypeEnumKey = (typeof quoteComponentDtoChargeTypeEnum)[keyof typeof quoteComponentDtoChargeTypeEnum];

export type QuoteComponentDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: QuoteComponentDtoTypeEnumKey;
    /**
     * @description insurer of the quote that priced it
     * @type string | undefined
    */
    insurer?: QuoteComponentDtoInsurerEnumKey;
    /**
     * @type object
    */
    premium: AmountDto;
    /**
     * @description Charge type of component
     * @type string
    */
    chargeType: QuoteComponentDtoChargeTypeEnumKey;
};

export type ConfigQuoteChosenWarrantyDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    option?: string;
    /**
     * @type boolean | undefined
    */
    available?: boolean;
    /**
     * @type string | undefined
    */
    unavailabilityMessage?: string;
};

export type BrokerageFeeOnPolicy = {
    /**
     * @description Brokerage firm id
     * @minLength 0
     * @maxLength 100
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Fee
     * @minLength 0
     * @maxLength 100
     * @type number
    */
    fee: number;
};

export type AssetQuoteOptionsDto = {
    /**
     * @description The tier selected for this asset, as listed by GET /policies/{policyId}/available-pricing. Tiers are computed per policy, so there is no fixed list.
     * @type string
    */
    tier: string;
    /**
     * @description The excess selected for this asset, from the chosen tier\'s available excesses.
     * @type string
    */
    excess: string;
    /**
     * @description The optional perils selected for this asset. Perils always included in the tier are not listed here.
     * @type array | undefined
    */
    perils?: ConfigQuoteChosenWarrantyDto[];
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type array | undefined
    */
    brokerageFees?: BrokerageFeeOnPolicy[];
};

export type AssetQuoteDto = {
    /**
     * @description Quote id
     * @type string
    */
    id: string;
    /**
     * @description Entity the quote is for
     * @type string
    */
    entityId: string;
    /**
     * @type object
    */
    provider: QuoteProviderDto;
    /**
     * @type integer | undefined
    */
    basePrice?: number;
    /**
     * @type array
    */
    rates: RateDto[];
    /**
     * @type object
    */
    totalPremium: AmountDto;
    /**
     * @description components of the quote
     * @type array
    */
    components: QuoteComponentDto[];
    /**
     * @description Quote options chosen by client
    */
    options: AssetQuoteOptionsDto;
    /**
     * @description Price band resolved by the pricing engine, when the product exposes one (e.g. STANDARD/STANDARD_2/LUXE_1/LUXE_2)
     * @type string | undefined
    */
    priceBand?: string;
};

export const assetDtoStatusEnum = {
    ASSET_CREATED: "ASSET_CREATED",
    ASSET_REMOVED: "ASSET_REMOVED",
    ASSET_QUOTED: "ASSET_QUOTED",
    ASSET_CONFIRMED: "ASSET_CONFIRMED",
    ASSET_STARTED: "ASSET_STARTED",
    ASSET_STOPPED: "ASSET_STOPPED",
    ASSET_CANCELLED: "ASSET_CANCELLED"
} as const;

export type AssetDtoStatusEnumKey = (typeof assetDtoStatusEnum)[keyof typeof assetDtoStatusEnum];

export type AssetDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description assetId
     * @type string
    */
    id: string;
    /**
     * @description Last modified date of the asset
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Creation date of the asset
     * @type string
    */
    createdAt: string;
    /**
     * @description Status of the asset
     * @type string
    */
    status: AssetDtoStatusEnumKey;
    /**
     * @description Whether the asset was created on a branch
     * @type boolean | undefined
    */
    createdOnBranch?: boolean;
    /**
     * @description Whether the asset was edited on a branch
     * @type boolean | undefined
    */
    editedOnBranch?: boolean;
    /**
     * @description Date the asset starts
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description Date the asset stops
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @description Date the asset was cancelled
     * @type string | undefined
    */
    cancelledAt?: string;
    /**
     * @description Id of the asset this asset replaces, if any
     * @type string | undefined
    */
    originAssetId?: string;
    /**
     * @description externalAssetId
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @description asset quote
    */
    quote?: AssetQuoteDto;
    /**
     * @description Prorated asset quote based on the invoicing frequency of the policy
    */
    proratedQuote?: AssetQuoteDto;
    /**
     * @description policyId of asset owner
     * @type string
    */
    policyId: string;
};

export type AssetNotCreatedOnThisBranchDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string
    */
    creationBranchId: string;
    /**
     * @type string
    */
    currentBranchId: string;
};

export const assetNotCreatedOnThisBranchErrorDtoCodeEnum = {
    ASSET_NOT_CREATED_ON_THIS_BRANCH: "ASSET_NOT_CREATED_ON_THIS_BRANCH"
} as const;

export type AssetNotCreatedOnThisBranchErrorDtoCodeEnumKey = (typeof assetNotCreatedOnThisBranchErrorDtoCodeEnum)[keyof typeof assetNotCreatedOnThisBranchErrorDtoCodeEnum];

export type AssetNotCreatedOnThisBranchErrorDto = {
    /**
     * @type string
    */
    code: AssetNotCreatedOnThisBranchErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AssetNotCreatedOnThisBranchDetailsDto;
};

export type RemoveAssetOutput = object;

export type InvalidEventTypeDetailsDto = {
    /**
     * @type string
    */
    eventType: string;
    /**
     * @type string
    */
    productId: string;
};

export const invalidEventTypeErrorDtoCodeEnum = {
    INVALID_EVENT_TYPE: "INVALID_EVENT_TYPE"
} as const;

export type InvalidEventTypeErrorDtoCodeEnumKey = (typeof invalidEventTypeErrorDtoCodeEnum)[keyof typeof invalidEventTypeErrorDtoCodeEnum];

export type InvalidEventTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidEventTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEventTypeDetailsDto;
};

export type PushAssetEventInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
    /**
     * @description The event type
     * @type string
    */
    eventType: string;
};

export type PushAssetEventOutput = object;

export type ExternalQuoteNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const externalQuoteNotFoundErrorDtoCodeEnum = {
    EXTERNAL_QUOTE_NOT_FOUND: "EXTERNAL_QUOTE_NOT_FOUND"
} as const;

export type ExternalQuoteNotFoundErrorDtoCodeEnumKey = (typeof externalQuoteNotFoundErrorDtoCodeEnum)[keyof typeof externalQuoteNotFoundErrorDtoCodeEnum];

export type ExternalQuoteNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ExternalQuoteNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ExternalQuoteNotFoundDetailsDto;
};

export type QuoteNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const quoteNotFoundErrorDtoCodeEnum = {
    QUOTE_NOT_FOUND: "QUOTE_NOT_FOUND"
} as const;

export type QuoteNotFoundErrorDtoCodeEnumKey = (typeof quoteNotFoundErrorDtoCodeEnum)[keyof typeof quoteNotFoundErrorDtoCodeEnum];

export type QuoteNotFoundErrorDto = {
    /**
     * @type string
    */
    code: QuoteNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: QuoteNotFoundDetailsDto;
};

export type GetAssetExternalQuoteOutput = {
    /**
     * @type object
    */
    externalQuoteId: object;
    /**
     * @type object
    */
    data: object;
};

export type Period = {
    /**
     * @description the start date of the period
     * @type string
    */
    startedAt: string;
    /**
     * @description the end date of the period
     * @type string
    */
    endedAt: string;
};

export const billingComponentDtoTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type BillingComponentDtoTypeEnumKey = (typeof billingComponentDtoTypeEnum)[keyof typeof billingComponentDtoTypeEnum];

export const billingComponentDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type BillingComponentDtoInsurerEnumKey = (typeof billingComponentDtoInsurerEnum)[keyof typeof billingComponentDtoInsurerEnum];

export type BillingComponentDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: BillingComponentDtoTypeEnumKey;
    /**
     * @description insurer of the quote that priced it
     * @type string | undefined
    */
    insurer?: BillingComponentDtoInsurerEnumKey;
    /**
     * @type object
    */
    premium: AmountDto;
    /**
     * @type boolean
    */
    reconciliation: boolean;
};

export const invoiceLineDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type InvoiceLineDtoInsurerEnumKey = (typeof invoiceLineDtoInsurerEnum)[keyof typeof invoiceLineDtoInsurerEnum];

export type InvoiceLineDto = {
    /**
     * @type string
    */
    label: string;
    /**
     * @type object
    */
    total: AmountDto;
    /**
     * @type string | undefined
    */
    insurer?: InvoiceLineDtoInsurerEnumKey;
};

export const manualPaymentDtoMethodEnum = {
    check: "check",
    wire_transfer: "wire_transfer",
    cash: "cash"
} as const;

export type ManualPaymentDtoMethodEnumKey = (typeof manualPaymentDtoMethodEnum)[keyof typeof manualPaymentDtoMethodEnum];

export type ManualPaymentDto = {
    /**
     * @description how the payment was settled outside the platform
     * @type string
    */
    method: ManualPaymentDtoMethodEnumKey;
    /**
     * @description accounting application date of the settlement
     * @type string
    */
    appliedAt: string;
    /**
     * @description user who recorded the payment
     * @type string
    */
    markedByUserId: string;
};

export const invoiceRefundNotHandledReasonEnum = {
    SEPA_PAYMENT_180_DAYS_EXCEEDED: "SEPA_PAYMENT_180_DAYS_EXCEEDED",
    INSUFFICIENT_AMOUNT: "INSUFFICIENT_AMOUNT"
} as const;

export type InvoiceRefundNotHandledReasonEnumKey = (typeof invoiceRefundNotHandledReasonEnum)[keyof typeof invoiceRefundNotHandledReasonEnum];

/**
 * @description Reason for refund not handled
*/
export type InvoiceRefundNotHandledReason = InvoiceRefundNotHandledReasonEnumKey;

export const invoiceDtoTypeEnum = {
    INVOICE: "INVOICE"
} as const;

export type InvoiceDtoTypeEnumKey = (typeof invoiceDtoTypeEnum)[keyof typeof invoiceDtoTypeEnum];

export const invoiceDtoStatusEnum = {
    DRAFTED: "DRAFTED",
    ISSUED: "ISSUED",
    PAID: "PAID",
    FINALIZED: "FINALIZED",
    PAYMENT_DISPUTED: "PAYMENT_DISPUTED",
    PAYMENT_IN_PROGRESS: "PAYMENT_IN_PROGRESS",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    RECONCILED: "RECONCILED",
    CANCELLED: "CANCELLED",
    REFUND_NOT_HANDLED: "REFUND_NOT_HANDLED",
    PARTIALLY_FINALIZED: "PARTIALLY_FINALIZED",
    REFUND_IN_PROGRESS: "REFUND_IN_PROGRESS",
    WRITTEN_OFF: "WRITTEN_OFF"
} as const;

export type InvoiceDtoStatusEnumKey = (typeof invoiceDtoStatusEnum)[keyof typeof invoiceDtoStatusEnum];

export type InvoiceDto = {
    /**
     * @description invoice issuance date
     * @type string
    */
    issuedAt: string;
    /**
     * @type object
    */
    period: Period;
    /**
     * @type array
    */
    components: BillingComponentDto[];
    /**
     * @type array
    */
    lines: InvoiceLineDto[];
    /**
     * @type object
    */
    total: AmountDto;
    /**
     * @description Invoice ids that have been reconciled
     * @type array | undefined
    */
    reconciledInvoiceIds?: any[][];
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the invoice id
     * @type string
    */
    id: string;
    /**
     * @description entity type
     * @type string
    */
    type: InvoiceDtoTypeEnumKey;
    /**
     * @description invoice status
     * @type string
    */
    status: InvoiceDtoStatusEnumKey;
    /**
     * @description invoice creation date
     * @type string
    */
    createdAt: string;
    /**
     * @description has invoice failed at least once
     * @type boolean | undefined
    */
    hasFailedOnce?: boolean;
    /**
     * @description first invoice payment failure date
     * @type string | undefined
    */
    firstFailedAt?: string;
    /**
     * @description Incremental invoice id
     * @type number | undefined
    */
    incrementalId?: number;
    /**
     * @description External invoice id
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @description Invoice payment id, if PAID
     * @type string | undefined
    */
    paymentId?: string;
    /**
     * @description Payment date, if PAID
     * @type string | undefined
    */
    paidAt?: string;
    /**
     * @type string | undefined
    */
    paidEventCreatedAt?: string;
    /**
     * @description Finalization date, if FINALIZED
     * @type string | undefined
    */
    finalizedAt?: string;
    /**
     * @description Offline settlement details, if the invoice was marked manually
    */
    manualPayment?: ManualPaymentDto;
    /**
     * @description Original invoice that we are crediting
     * @type string | undefined
    */
    creditedInvoiceId?: string;
    /**
     * @description Original invoice that we are replacing
     * @type string | undefined
    */
    replacedInvoiceId?: string;
    /**
     * @description Reason for refund not handled
    */
    refundNotHandledReason?: InvoiceRefundNotHandledReason;
};

export type ResponsePageInfo = {
    /**
     * @description whether this is the first page
     * @type boolean | undefined
    */
    first?: boolean;
    /**
     * @description whether this is the last page
     * @type boolean | undefined
    */
    last?: boolean;
};

export type GetInvoicesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: InvoiceDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type InvoiceNotFoundDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export const invoiceNotFoundErrorDtoCodeEnum = {
    INVOICE_NOT_FOUND: "INVOICE_NOT_FOUND"
} as const;

export type InvoiceNotFoundErrorDtoCodeEnumKey = (typeof invoiceNotFoundErrorDtoCodeEnum)[keyof typeof invoiceNotFoundErrorDtoCodeEnum];

export type InvoiceNotFoundErrorDto = {
    /**
     * @type string
    */
    code: InvoiceNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceNotFoundDetailsDto;
};

export type InvoiceEventMetadata = {
    /**
     * @description Optional: tenantId
     * @type string
    */
    tenantId: string;
    /**
     * @description createdAt of event
     * @type string
    */
    createdAt: string;
    /**
     * @description Optional: applied date of the invoice
     * @type string | undefined
    */
    appliedAt?: string;
};

export const invoiceEventAggregateTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type InvoiceEventAggregateTypeEnumKey = (typeof invoiceEventAggregateTypeEnum)[keyof typeof invoiceEventAggregateTypeEnum];

export type InvoiceEvent = {
    /**
     * @description invoice event aggregate id
     * @type string
    */
    aggregateId: string;
    /**
     * @description invoice event aggregate type
     * @type string
    */
    aggregateType: InvoiceEventAggregateTypeEnumKey;
    /**
     * @description invoice event version
     * @type number
    */
    version: number;
    /**
     * @description invoice event createdAt
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description invoice event updatedAt
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description invoice event type
     * @type string
    */
    type: string;
    /**
     * @description invoice event data
     * @type object
    */
    data: object;
    /**
     * @description invoice event metadata
    */
    metadata: InvoiceEventMetadata;
};

export type ListInvoiceEventsOutput = {
    /**
     * @description Array of invoice events
     * @type array
    */
    data: InvoiceEvent[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
    /**
     * @description Optional: Total number of invoice events
     * @type number | undefined
    */
    total?: number;
    /**
     * @description Optional: Number of invoice events the array has to star after
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description Optional: Number of invoice events in the array
     * @type number | undefined
    */
    limit?: number;
};

export type PageInfo = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type OrderDto = {
    /**
     * @description the sort key
     * @type string
    */
    by: string;
    /**
     * @description the sort direction
     * @type string
    */
    direction: string;
};

export type MetadataSearch = {
    /**
     * @type array | undefined
    */
    and?: Metadata[];
    /**
     * @type array | undefined
    */
    or?: Metadata[];
};

export const listInvoicesInputBodyStatusesEnum = {
    DRAFTED: "DRAFTED",
    ISSUED: "ISSUED",
    PAID: "PAID",
    FINALIZED: "FINALIZED",
    PAYMENT_DISPUTED: "PAYMENT_DISPUTED",
    PAYMENT_IN_PROGRESS: "PAYMENT_IN_PROGRESS",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    RECONCILED: "RECONCILED",
    CANCELLED: "CANCELLED",
    REFUND_NOT_HANDLED: "REFUND_NOT_HANDLED",
    PARTIALLY_FINALIZED: "PARTIALLY_FINALIZED",
    REFUND_IN_PROGRESS: "REFUND_IN_PROGRESS",
    WRITTEN_OFF: "WRITTEN_OFF"
} as const;

export type ListInvoicesInputBodyStatusesEnumKey = (typeof listInvoicesInputBodyStatusesEnum)[keyof typeof listInvoicesInputBodyStatusesEnum];

export type ListInvoicesInputBody = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @description retrieve invoices issued after this date (inclusive)
     * @type string | undefined, date-time
    */
    issuedFrom?: string;
    /**
     * @description retrieve invoices issued before this date (exclusive)
     * @type string | undefined, date-time
    */
    issuedTo?: string;
    /**
     * @type array | undefined
    */
    statuses?: ListInvoicesInputBodyStatusesEnumKey[];
    /**
     * @type boolean | undefined
    */
    hasFailedOnce?: boolean;
};

export type ListInvoicesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: InvoiceDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CreateManualInvoiceInputBody = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type array
    */
    components: BillingComponentDto[];
    /**
     * @type object | undefined
    */
    period?: Period;
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
};

export type CreateManualInvoiceOutputDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export type SetInvoiceCleanupInputBody = {
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @type boolean
    */
    cleanup: boolean;
    /**
     * @type boolean
    */
    dryRun: boolean;
};

export const setInvoiceCleanupChangedEventFieldsEnum = {
    "data.metadata": "data.metadata",
    metadata: "metadata"
} as const;

export type SetInvoiceCleanupChangedEventFieldsEnumKey = (typeof setInvoiceCleanupChangedEventFieldsEnum)[keyof typeof setInvoiceCleanupChangedEventFieldsEnum];

export type SetInvoiceCleanupChangedEvent = {
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    type: string;
    /**
     * @type array
    */
    fields: SetInvoiceCleanupChangedEventFieldsEnumKey[];
};

export type SetInvoiceCleanupOutputDto = {
    /**
     * @type array
    */
    changedEvents: SetInvoiceCleanupChangedEvent[];
    /**
     * @type boolean
    */
    rebuilt: boolean;
};

export type IssueInvoicesInputBody = {
    /**
     * @type array
    */
    invoiceIds: string[];
};

export type IssueInvoicesOutput = object;

export type DeleteInvoicesInputQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the invoice ids to retrieve
     * @type array
    */
    ids: string[];
};

export type DeleteInvoicesOutput = object;

export type RequestValidationFailedDetailsDto = {
    /**
     * @type array
    */
    errors: string[];
};

export const requestValidationFailedErrorDtoCodeEnum = {
    REQUEST_VALIDATION_FAILED: "REQUEST_VALIDATION_FAILED"
} as const;

export type RequestValidationFailedErrorDtoCodeEnumKey = (typeof requestValidationFailedErrorDtoCodeEnum)[keyof typeof requestValidationFailedErrorDtoCodeEnum];

export type RequestValidationFailedErrorDto = {
    /**
     * @type string
    */
    code: RequestValidationFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RequestValidationFailedDetailsDto;
};

export type EditBranchInputBody = {
    /**
     * @description Name of the MTA project
     * @type string
    */
    name: string;
};

export type EditBranchOutput = object;

export type InvalidBranchTypeDetailsDto = {
    branchType: BranchType;
};

export const invalidBranchTypeErrorDtoCodeEnum = {
    INVALID_BRANCH_TYPE: "INVALID_BRANCH_TYPE"
} as const;

export type InvalidBranchTypeErrorDtoCodeEnumKey = (typeof invalidBranchTypeErrorDtoCodeEnum)[keyof typeof invalidBranchTypeErrorDtoCodeEnum];

export type InvalidBranchTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidBranchTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBranchTypeDetailsDto;
};

export const maxBranchTypeOpenedConflictDetailsDtoBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type MaxBranchTypeOpenedConflictDetailsDtoBranchTypeEnumKey = (typeof maxBranchTypeOpenedConflictDetailsDtoBranchTypeEnum)[keyof typeof maxBranchTypeOpenedConflictDetailsDtoBranchTypeEnum];

export type MaxBranchTypeOpenedConflictDetailsDto = {
    /**
     * @type number
    */
    openedBranchLimit: number;
    /**
     * @type string
    */
    branchType: MaxBranchTypeOpenedConflictDetailsDtoBranchTypeEnumKey;
};

export const maxBranchTypeOpenedErrorDtoCodeEnum = {
    MAX_BRANCH_TYPE_OPENED: "MAX_BRANCH_TYPE_OPENED"
} as const;

export type MaxBranchTypeOpenedErrorDtoCodeEnumKey = (typeof maxBranchTypeOpenedErrorDtoCodeEnum)[keyof typeof maxBranchTypeOpenedErrorDtoCodeEnum];

export type MaxBranchTypeOpenedErrorDto = {
    /**
     * @type string
    */
    code: MaxBranchTypeOpenedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MaxBranchTypeOpenedConflictDetailsDto;
};

export const branchSubTypeEnum = {
    CREATE_ADDITIONAL_COMPONENTS: "CREATE_ADDITIONAL_COMPONENTS",
    DRIVEQUANT: "DRIVEQUANT"
} as const;

export type BranchSubTypeEnumKey = (typeof branchSubTypeEnum)[keyof typeof branchSubTypeEnum];

/**
 * @description Branch sub type
*/
export type BranchSubType = BranchSubTypeEnumKey;

export const createBranchInputBodyBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type CreateBranchInputBodyBranchTypeEnumKey = (typeof createBranchInputBodyBranchTypeEnum)[keyof typeof createBranchInputBodyBranchTypeEnum];

export type CreateBranchInputBody = {
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Branch type
     * @type string
    */
    branchType: CreateBranchInputBodyBranchTypeEnumKey;
    /**
     * @description Branch sub type
    */
    branchSubType?: BranchSubType;
};

export type CreateBranchOutput = {
    /**
     * @description Type of the created object
     * @type string
    */
    type: string;
    /**
     * @description Unique identifier for the created object
     * @type string
    */
    id: string;
};

export type GetBranchEffectiveDateOutput = {
    /**
     * @description Date at which the branch changes take effect (policy start for new business, earliest asset start/stop change for an MTA, next renewal date for a renewal). Absent when no date can be derived.
     * @type string | undefined
    */
    effectiveAt?: string;
};

export const forkBranchInputBodyBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type ForkBranchInputBodyBranchTypeEnumKey = (typeof forkBranchInputBodyBranchTypeEnum)[keyof typeof forkBranchInputBodyBranchTypeEnum];

export type ForkBranchInputBody = {
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type boolean | undefined
    */
    closeOriginalBranch?: boolean;
    /**
     * @description Branch type
     * @type string | undefined
    */
    branchType?: ForkBranchInputBodyBranchTypeEnumKey;
    /**
     * @description Branch sub type
    */
    branchSubType?: BranchSubType;
    /**
     * @description Include all events from the original branch
     * @type boolean | undefined
    */
    includeAllEvents?: boolean;
};

export type ForkBranchOutput = {
    /**
     * @description Type of the created object
     * @type string
    */
    type: string;
    /**
     * @description Unique identifier for the created object
     * @type string
    */
    id: string;
};

export const branchCloseReasonsEnum = {
    BROKER_REQUEST: "BROKER_REQUEST",
    CUSTOMER_REQUEST: "CUSTOMER_REQUEST",
    FORKED: "FORKED",
    ASSET_START_PASSED: "ASSET_START_PASSED",
    CONCURRENT_BRANCH_MERGED: "CONCURRENT_BRANCH_MERGED",
    QUOTE_INVALIDATED: "QUOTE_INVALIDATED",
    PARTITION_DROPPED: "PARTITION_DROPPED",
    RENEWAL_REFUSED: "RENEWAL_REFUSED",
    CRM_ABOVE_LIMIT: "CRM_ABOVE_LIMIT",
    TELEMATICS_SCORE_MISSING: "TELEMATICS_SCORE_MISSING",
    SIGNATURE_CANCELLED: "SIGNATURE_CANCELLED",
    DEROGATION_DENIED: "DEROGATION_DENIED"
} as const;

export type BranchCloseReasonsEnumKey = (typeof branchCloseReasonsEnum)[keyof typeof branchCloseReasonsEnum];

export type BranchCloseReasons = BranchCloseReasonsEnumKey;

export type InvalidateBranchInputBody = {
    reason: BranchCloseReasons;
    /**
     * @description Free-text note on why this branch is being invalidated — a draft abandoned, a scheduled stop called off. Audited, never interpreted.
     * @type string | undefined
    */
    comment?: string;
};

export type InvalidateBranchOutput = object;

export type BrokerAtMeOutput = {
    /**
     * @description User id
     * @type string
    */
    userId: string;
    /**
     * @description First name
     * @type string
    */
    firstName: string;
    /**
     * @description Last name
     * @type string
    */
    lastName: string;
    /**
     * @description Email
     * @type string | undefined
    */
    email?: string;
    /**
     * @description User brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Product ids
     * @type array
    */
    productIds: string[];
    /**
     * @description Broker role
     * @type string | undefined
    */
    brokerRole?: string;
};

export type UserNotFoundDetailsDto = {
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    source: string;
};

export const userNotFoundErrorDtoCodeEnum = {
    USER_NOT_FOUND: "USER_NOT_FOUND"
} as const;

export type UserNotFoundErrorDtoCodeEnumKey = (typeof userNotFoundErrorDtoCodeEnum)[keyof typeof userNotFoundErrorDtoCodeEnum];

export type UserNotFoundErrorDto = {
    /**
     * @type string
    */
    code: UserNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UserNotFoundDetailsDto;
};

export type BrokerageFirmNotFoundDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string | undefined
    */
    source?: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
};

export const brokerageFirmNotFoundErrorDtoCodeEnum = {
    BROKERAGE_FIRM_NOT_FOUND: "BROKERAGE_FIRM_NOT_FOUND"
} as const;

export type BrokerageFirmNotFoundErrorDtoCodeEnumKey = (typeof brokerageFirmNotFoundErrorDtoCodeEnum)[keyof typeof brokerageFirmNotFoundErrorDtoCodeEnum];

export type BrokerageFirmNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmNotFoundDetailsDto;
};

export type CreateBrokerInputBody = {
    /**
     * @description First name
     * @type string
    */
    firstName: string;
    /**
     * @description Last name
     * @type string
    */
    lastName: string;
    /**
     * @type string | undefined
    */
    brokerRole?: string;
    /**
     * @description User id
     * @type string
    */
    brokerUserId: string;
};

export type CreateBrokerOutput = object;

export type UpdateBrokerInputBody = {
    /**
     * @description First name
     * @type string | undefined
    */
    firstName?: string;
    /**
     * @description Last name
     * @type string | undefined
    */
    lastName?: string;
    /**
     * @type string | undefined
    */
    brokerRole?: string;
};

export type UpdateBrokerOutput = object;

export type BrokerDto = {
    /**
     * @description First name
     * @type string
    */
    firstName: string;
    /**
     * @description Last name
     * @type string
    */
    lastName: string;
    /**
     * @description User id
     * @type string
    */
    userId: string;
    /**
     * @type string | undefined
    */
    email?: string;
    /**
     * @type string | undefined
    */
    brokerRole?: string;
};

export type ListBrokersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: BrokerDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type DescendantBrokerDto = {
    /**
     * @description First name
     * @type string
    */
    firstName: string;
    /**
     * @description Last name
     * @type string
    */
    lastName: string;
    /**
     * @description User id
     * @type string
    */
    userId: string;
    /**
     * @type string | undefined
    */
    email?: string;
    /**
     * @type string | undefined
    */
    brokerRole?: string;
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    brokerageFirmName: string;
};

export type ListDescendantBrokersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DescendantBrokerDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type BrokerNotFoundDetailsDto = {
    /**
     * @type string
    */
    brokerUserId: string;
};

export const brokerNotFoundErrorDtoCodeEnum = {
    BROKER_NOT_FOUND: "BROKER_NOT_FOUND"
} as const;

export type BrokerNotFoundErrorDtoCodeEnumKey = (typeof brokerNotFoundErrorDtoCodeEnum)[keyof typeof brokerNotFoundErrorDtoCodeEnum];

export type BrokerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BrokerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerNotFoundDetailsDto;
};

export type GetBrokerOutput = {
    /**
     * @description First name
     * @type string
    */
    firstName: string;
    /**
     * @description Last name
     * @type string
    */
    lastName: string;
    /**
     * @description User id
     * @type string
    */
    userId: string;
    /**
     * @type string | undefined
    */
    email?: string;
    /**
     * @type string | undefined
    */
    brokerRole?: string;
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Product ids
     * @type array
    */
    productIds: string[];
};

export type DeleteBrokerOutput = object;

export const emailAccountDtoStatusEnum = {
    connecting: "connecting",
    connected: "connected",
    error: "error",
    disconnected: "disconnected",
    paused: "paused"
} as const;

export type EmailAccountDtoStatusEnumKey = (typeof emailAccountDtoStatusEnum)[keyof typeof emailAccountDtoStatusEnum];

export type EmailAccountDto = {
    /**
     * @description Email account id
     * @type string
    */
    id: string;
    /**
     * @description Primary email address of the connected account
     * @type string
    */
    primaryEmailAddress: string;
    /**
     * @description Display name of the connected account
     * @type string
    */
    name: string;
    /**
     * @description Name of the broker who last connected this account
     * @type string
    */
    connectedBy: string;
    /**
     * @description Email provider type (e.g. gmail, outlook)
     * @type string
    */
    emailProviderType: string;
    /**
     * @description Connection status of the account
     * @type string
    */
    status: EmailAccountDtoStatusEnumKey;
    /**
     * @description Whether the account is shared across the brokerage firm
     * @type boolean
    */
    isShared: boolean;
    /**
     * @description Whether the account is active
     * @type boolean
    */
    isActive: boolean;
    /**
     * @description Whether the account belongs to the logged-in broker
     * @type boolean
    */
    isOwn: boolean;
    /**
     * @description ISO date since which the account has been in error
     * @type string | undefined
    */
    erroredSince?: string;
};

export type ListMyEmailAccountsOutput = {
    /**
     * @type array
    */
    accounts: EmailAccountDto[];
    /**
     * @description Whether the broker may connect and manage shared firm accounts
     * @type boolean
    */
    canManageSharedAccounts: boolean;
};

export const connectEmailAccountBodyProviderEnum = {
    gmail: "gmail",
    outlook: "outlook"
} as const;

export type ConnectEmailAccountBodyProviderEnumKey = (typeof connectEmailAccountBodyProviderEnum)[keyof typeof connectEmailAccountBodyProviderEnum];

export type ConnectEmailAccountBody = {
    /**
     * @description Email provider to connect
     * @type string
    */
    provider: ConnectEmailAccountBodyProviderEnumKey;
    /**
     * @description Frontend URL to return to once the consent flow completes
     * @type string
    */
    returnUrl: string;
    /**
     * @description Whether the mailbox is shared with the whole brokerage firm
     * @type boolean
    */
    isShared: boolean;
    /**
     * @description Microsoft 365 shared mailbox to connect through the signing-in user, who must have full access to it. Outlook only; independent of isShared.
     * @type string | undefined
    */
    delegatedMailboxAddress?: string;
};

export type InitiateEmailAccountConnectionOutput = {
    /**
     * @description Single-use hosted consent URL to redirect the browser to
     * @type string
    */
    url: string;
};

export type ReconnectEmailAccountBody = {
    /**
     * @description Frontend URL to return to once the consent flow completes
     * @type string
    */
    returnUrl: string;
};

export type DisconnectEmailAccountOutput = object;

export type AttachEmailPoliciesBody = {
    /**
     * @description Policies to attach to this individual email
     * @type array
    */
    policyIds: string[];
};

export type EmailPolicyLinkOutput = object;

export type DetachEmailsPoliciesBody = {
    /**
     * @description Emails to detach
     * @type array
    */
    emailIds: string[];
    /**
     * @description Policies to detach from every email
     * @type array
    */
    policyIds: string[];
};

export type MoveEmailPolicyBody = {
    /**
     * @description Currently linked policy to detach
     * @type string
    */
    sourcePolicyId: string;
    /**
     * @description Different policy to attach
     * @type string
    */
    targetPolicyId: string;
};

export type GetEmailAttachmentDownloadUrlOutput = {
    /**
     * @description Short-lived presigned URL downloading the attachment
     * @type string
    */
    url: string;
    /**
     * @description ISO date after which the URL no longer works
     * @type string
    */
    expiresAt: string;
};

export type EmailAddressDto = {
    /**
     * @description Display name, when the header carries one
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Mailbox address
     * @type string | undefined
    */
    address?: string;
};

export const emailDetailAttachmentDtoStatusEnum = {
    pending: "pending",
    stored: "stored",
    failed: "failed",
    skipped: "skipped"
} as const;

export type EmailDetailAttachmentDtoStatusEnumKey = (typeof emailDetailAttachmentDtoStatusEnum)[keyof typeof emailDetailAttachmentDtoStatusEnum];

export type EmailDetailAttachmentDto = {
    /**
     * @description Email attachment id
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    filename?: string | null;
    /**
     * @type string
    */
    contentType: string;
    /**
     * @description Encoded size announced by the provider, in bytes
     * @type number
    */
    encodedSize: number;
    /**
     * @description Referenced from the body through a cid: URL
     * @type boolean
    */
    isInline: boolean;
    /**
     * @description Content-ID header without angle brackets, for cid: matching
     * @type string
    */
    contentId?: string | null;
    /**
     * @type string
    */
    status: EmailDetailAttachmentDtoStatusEnumKey;
    /**
     * @description Machine-readable reason (EmailAttachmentFailureReason) or the last error message
     * @type string
    */
    failureReason?: string | null;
    /**
     * @description Short-lived inline URL, only for stored inline attachments (cid: replacement)
     * @type string | undefined
    */
    inlineUrl?: string;
};

export const generalInboxEmailAccountDtoStatusEnum = {
    connecting: "connecting",
    connected: "connected",
    error: "error",
    disconnected: "disconnected",
    paused: "paused"
} as const;

export type GeneralInboxEmailAccountDtoStatusEnumKey = (typeof generalInboxEmailAccountDtoStatusEnum)[keyof typeof generalInboxEmailAccountDtoStatusEnum];

export type GeneralInboxEmailAccountDto = {
    /**
     * @description Email account id
     * @type string
    */
    id: string;
    /**
     * @description Address of the mailbox that received or sent the email
     * @type string
    */
    primaryEmailAddress: string;
    /**
     * @description Connection status of the account
     * @type string
    */
    status: GeneralInboxEmailAccountDtoStatusEnumKey;
    /**
     * @description Whether the account is shared across the brokerage firm
     * @type boolean
    */
    isShared: boolean;
};

export const getEmailOutputDirectionEnum = {
    inbound: "inbound",
    outbound: "outbound"
} as const;

export type GetEmailOutputDirectionEnumKey = (typeof getEmailOutputDirectionEnum)[keyof typeof getEmailOutputDirectionEnum];

export const getEmailOutputBodyStatusEnum = {
    pending: "pending",
    stored: "stored",
    failed: "failed",
    unavailable: "unavailable"
} as const;

export type GetEmailOutputBodyStatusEnumKey = (typeof getEmailOutputBodyStatusEnum)[keyof typeof getEmailOutputBodyStatusEnum];

export type GetEmailOutput = {
    /**
     * @description Email id
     * @type string
    */
    id: string;
    /**
     * @description Subject, possibly empty
     * @type string
    */
    subject: string;
    /**
     * @type string
    */
    preview?: string | null;
    /**
     * @type string, date-time
    */
    date: string;
    /**
     * @type string
    */
    direction: GetEmailOutputDirectionEnumKey;
    /**
     * @description Mirror of the mailbox Seen flag
     * @type boolean
    */
    isRead: boolean;
    /**
     * @type array
    */
    fromAddresses: EmailAddressDto[];
    /**
     * @type object
    */
    senderAddress?: EmailAddressDto | null;
    /**
     * @type array
    */
    toAddresses: EmailAddressDto[];
    /**
     * @type array
    */
    ccAddresses: EmailAddressDto[];
    /**
     * @description Only known on outbound messages
     * @type array
    */
    bccAddresses: EmailAddressDto[];
    /**
     * @type array
    */
    replyToAddresses: EmailAddressDto[];
    /**
     * @type string
    */
    bodyStatus: GetEmailOutputBodyStatusEnumKey;
    /**
     * @description Web-safe HTML from the provider; empty string is a genuinely empty body
     * @type string
    */
    bodyHtml?: string | null;
    /**
     * @description Last body retrieval error
     * @type string
    */
    bodyError?: string | null;
    /**
     * @type array
    */
    attachments: EmailDetailAttachmentDto[];
    /**
     * @type object
    */
    account: GeneralInboxEmailAccountDto;
};

export const emailThreadLinkedPolicyDtoStatusEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type EmailThreadLinkedPolicyDtoStatusEnumKey = (typeof emailThreadLinkedPolicyDtoStatusEnum)[keyof typeof emailThreadLinkedPolicyDtoStatusEnum];

export type EmailThreadLinkedPolicyDto = {
    /**
     * @description Policy id
     * @type string
    */
    id: string;
    /**
     * @description Policy number shown to brokers; null when the policy has none
     * @type string
    */
    externalId?: string | null;
    /**
     * @description Product of the policy; null when its projection is missing
     * @type string
    */
    productId?: string | null;
    /**
     * @description Status on the current branch; null when its projection is missing
     * @type string
    */
    status?: EmailThreadLinkedPolicyDtoStatusEnumKey | null;
    /**
     * @description Company name of the first customer, else its first and last names; null when none
     * @type string
    */
    customerName?: string | null;
    /**
     * @description Creation date of the policy; null when its projection is missing
     * @type string, date-time
    */
    createdAt?: string | null;
};

export const policyThreadEmailDtoDirectionEnum = {
    inbound: "inbound",
    outbound: "outbound"
} as const;

export type PolicyThreadEmailDtoDirectionEnumKey = (typeof policyThreadEmailDtoDirectionEnum)[keyof typeof policyThreadEmailDtoDirectionEnum];

export type PolicyThreadEmailDto = {
    /**
     * @description Email id
     * @type string
    */
    id: string;
    /**
     * @description Subject, possibly empty
     * @type string
    */
    subject: string;
    /**
     * @type string
    */
    preview?: string | null;
    /**
     * @type string, date-time
    */
    date: string;
    /**
     * @type string
    */
    direction: PolicyThreadEmailDtoDirectionEnumKey;
    /**
     * @description Mirror of the mailbox Seen flag
     * @type boolean
    */
    isRead: boolean;
    /**
     * @type array
    */
    fromAddresses: EmailAddressDto[];
    /**
     * @type array
    */
    toAddresses: EmailAddressDto[];
    /**
     * @type object
    */
    account: GeneralInboxEmailAccountDto;
    /**
     * @description Whether this email carries attachments, stored or not
     * @type boolean
    */
    hasAttachments: boolean;
    /**
     * @description Whether the email is archived
     * @type boolean
    */
    isArchived: boolean;
    /**
     * @description Readable policies linked to this email
     * @type array
    */
    linkedPolicies: EmailThreadLinkedPolicyDto[];
};

export const emailThreadDtoDirectionEnum = {
    inbound: "inbound",
    outbound: "outbound"
} as const;

export type EmailThreadDtoDirectionEnumKey = (typeof emailThreadDtoDirectionEnum)[keyof typeof emailThreadDtoDirectionEnum];

export type EmailThreadDto = {
    /**
     * @description Only with policyId: every email of the thread, oldest first. No read state is changed
     * @type array | undefined
    */
    emails?: PolicyThreadEmailDto[];
    /**
     * @description Opaque thread id, stable for the life of the thread: its account and provider thread key
     * @type string
    */
    id: string;
    /**
     * @description Subject of the latest email, possibly empty
     * @type string
    */
    subject: string;
    /**
     * @description Provider snippet of the latest email; null when the provider gave none
     * @type string
    */
    preview?: string | null;
    /**
     * @description Date of the latest email
     * @type string, date-time
    */
    date: string;
    /**
     * @description Direction of the latest email
     * @type string
    */
    direction: EmailThreadDtoDirectionEnumKey;
    /**
     * @description Whether the latest email carries attachments, stored or not
     * @type boolean
    */
    hasAttachments: boolean;
    /**
     * @type array
    */
    fromAddresses: EmailAddressDto[];
    /**
     * @type array
    */
    toAddresses: EmailAddressDto[];
    /**
     * @description Whether at least one non-archived email of the thread is unread
     * @type boolean
    */
    isUnread: boolean;
    /**
     * @description Emails of the thread, archived included
     * @type integer
    */
    emailCount: number;
    /**
     * @description Emails of the thread to process: not archived and without an active link
     * @type integer
    */
    toProcessCount: number;
    /**
     * @description Whether every email of the thread is archived
     * @type boolean
    */
    isArchived: boolean;
    /**
     * @description Whether a requested thread analysis is unacknowledged and has retries remaining
     * @type boolean
    */
    analysisPending: boolean;
    /**
     * @description Policies linked to at least one email of the thread
     * @type array
    */
    linkedPolicies: EmailThreadLinkedPolicyDto[];
    /**
     * @type object
    */
    account: GeneralInboxEmailAccountDto;
};

export type ListEmailThreadsOutput = {
    /**
     * @type array
    */
    threads: EmailThreadDto[];
    /**
     * @description Cursor for the next page; null when this is the last page
     * @type string
    */
    nextCursor?: string | null;
};

export const emailThreadEmailDtoDirectionEnum = {
    inbound: "inbound",
    outbound: "outbound"
} as const;

export type EmailThreadEmailDtoDirectionEnumKey = (typeof emailThreadEmailDtoDirectionEnum)[keyof typeof emailThreadEmailDtoDirectionEnum];

export type EmailThreadEmailDto = {
    /**
     * @description Subject of this email, possibly empty
     * @type string
    */
    subject: string;
    /**
     * @description Provider snippet of this email; null when the provider gave none
     * @type string
    */
    preview?: string | null;
    /**
     * @description Date of this email
     * @type string, date-time
    */
    date: string;
    /**
     * @description Direction of this email
     * @type string
    */
    direction: EmailThreadEmailDtoDirectionEnumKey;
    /**
     * @description Whether this email carries attachments, stored or not
     * @type boolean
    */
    hasAttachments: boolean;
    /**
     * @type array
    */
    fromAddresses: EmailAddressDto[];
    /**
     * @type array
    */
    toAddresses: EmailAddressDto[];
    /**
     * @description Email id
     * @type string
    */
    id: string;
    /**
     * @description Whether the email is archived
     * @type boolean
    */
    isArchived: boolean;
    /**
     * @description Whether the email is to process: not archived and without an active link
     * @type boolean
    */
    isToProcess: boolean;
    /**
     * @description Readable policies linked to this email
     * @type array
    */
    linkedPolicies: EmailThreadLinkedPolicyDto[];
};

export type GetEmailThreadOutput = {
    /**
     * @description Opaque thread id
     * @type string
    */
    id: string;
    /**
     * @description Every email of the thread, oldest first
     * @type array
    */
    emails: EmailThreadEmailDto[];
    /**
     * @description Whether a requested thread analysis is unacknowledged and has retries remaining
     * @type boolean
    */
    analysisPending: boolean;
    /**
     * @type object
    */
    account: GeneralInboxEmailAccountDto;
};

export type SetEmailThreadArchivedBody = {
    /**
     * @description Opaque thread ids returned by the thread list
     * @type array
    */
    threadIds: string[];
    /**
     * @description true archives, false unarchives
     * @type boolean
    */
    archived: boolean;
    /**
     * @description Only these emails of the threads; omitted, every email. Ids outside them are ignored
     * @type array | undefined
    */
    emailIds?: string[];
};

export type SetEmailThreadArchivedOutput = {
    /**
     * @description Emails whose archive state changed; an undo sends them back with the opposite value
     * @type array
    */
    emailIds: string[];
};

export type AttachEmailThreadsPoliciesBody = {
    /**
     * @description Opaque thread ids returned by the thread list
     * @type array
    */
    threadIds: string[];
    /**
     * @description Policies to attach to every email of the threads still to attach
     * @type array
    */
    policyIds: string[];
};

export type AttachEmailThreadsPoliciesOutput = {
    /**
     * @description Emails now linked; an undo detaches the policies from them in batches of at most 1000
     * @type array
    */
    emailIds: string[];
};

export type GeneralInboxAccountUnreadCountDto = {
    /**
     * @description Email account id
     * @type string
    */
    accountId: string;
    /**
     * @description Threads to process with at least one unread, non-archived email in this mailbox
     * @type integer
    */
    unreadThreadCount: number;
};

export type GeneralInboxSummaryOutput = {
    /**
     * @description Threads to process with at least one unread, non-archived email, across every listable mailbox
     * @type integer
    */
    unreadThreadCount: number;
    /**
     * @description Breakdown of `unreadThreadCount` per mailbox, omitting mailboxes at zero
     * @type array
    */
    unreadThreadCountByAccount: GeneralInboxAccountUnreadCountDto[];
};

export type InvalidTenantDetailsDto = {
    /**
     * @type string
    */
    tenant: string;
};

export const invalidTenantErrorDtoCodeEnum = {
    INVALID_TENANT: "INVALID_TENANT"
} as const;

export type InvalidTenantErrorDtoCodeEnumKey = (typeof invalidTenantErrorDtoCodeEnum)[keyof typeof invalidTenantErrorDtoCodeEnum];

export type InvalidTenantErrorDto = {
    /**
     * @type string
    */
    code: InvalidTenantErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidTenantDetailsDto;
};

export type ClaimManagementCustomerNotFoundDetailsDto = {
    /**
     * @type string
    */
    bin: string;
};

export const claimManagementCustomerNotFoundErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_CUSTOMER_NOT_FOUND: "CLAIM_MANAGEMENT_CUSTOMER_NOT_FOUND"
} as const;

export type ClaimManagementCustomerNotFoundErrorDtoCodeEnumKey = (typeof claimManagementCustomerNotFoundErrorDtoCodeEnum)[keyof typeof claimManagementCustomerNotFoundErrorDtoCodeEnum];

export type ClaimManagementCustomerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementCustomerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementCustomerNotFoundDetailsDto;
};

export type LookupCustomerInputBody = {
    /**
     * @description Product id — selects the right ClaimsIntegration via tenant config.
     * @type string
    */
    productId: string;
    /**
     * @description Opaque customer identifier (BIN, PAN, client number, ...). Treat as sensitive — sent in body, not URL.
     * @type string
    */
    bin: string;
    /**
     * @description Optional secondary identifier (e.g. CB: IDENT_2 file/contract reference). Treat as sensitive — sent in body, not URL.
     * @type string | undefined
    */
    reference?: string;
};

export type CircumstanceNodeDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    label: string;
    /**
     * @type array
    */
    children: CircumstanceNodeDto[];
    /**
     * @type string | undefined
    */
    dateLabel?: string;
    /**
     * @type string | undefined
    */
    factGeneratorCode?: string;
    /**
     * @type string | undefined
    */
    factGeneratorLabel?: string;
};

export type CircumstanceTreeDto = {
    /**
     * @type array
    */
    nodes: CircumstanceNodeDto[];
};

export type LookupCustomerOutput = {
    /**
     * @description Partner-system customer id.
     * @type string
    */
    externalCustomerId: string;
    /**
     * @description Display name shown back to the claimant for confirmation.
     * @type string
    */
    customerDisplayName: string;
    /**
     * @type object
    */
    circumstanceTree: CircumstanceTreeDto;
};

export type ClaimManagementOnBehalfUnavailableDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    productId: string;
};

export const claimManagementOnBehalfUnavailableErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_ON_BEHALF_UNAVAILABLE: "CLAIM_MANAGEMENT_ON_BEHALF_UNAVAILABLE"
} as const;

export type ClaimManagementOnBehalfUnavailableErrorDtoCodeEnumKey = (typeof claimManagementOnBehalfUnavailableErrorDtoCodeEnum)[keyof typeof claimManagementOnBehalfUnavailableErrorDtoCodeEnum];

export type ClaimManagementOnBehalfUnavailableErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementOnBehalfUnavailableErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementOnBehalfUnavailableDetailsDto;
};

export type CheckCoverageInputBody = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @description Partner-resolved customer id from FNOL screen 1. Omitted under `claimantIdentity.mode: \'customer\'`, where the caller\'s own customer relations are resolved server-side from their session instead.
     * @type string | undefined
    */
    externalCustomerId?: string;
    /**
     * @type string
    */
    claimTypeId: string;
    /**
     * @description ISO-8601 date of the incident.
     * @type string
    */
    occurrenceDate: string;
    /**
     * @description Policy the claim is filed against. A broker allowed to file on behalf of the policy\'s policyholder gets coverage for that policy only.
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @description Optional secondary identifier captured on FNOL screen 1 (e.g. CB: IDENT_2 file/contract reference). Forwarded to partner systems that accept it on the coverage call. Treat as sensitive — sent in body, not URL.
     * @type string | undefined
    */
    reference?: string;
};

export type EligibleContractDto = {
    /**
     * @description Korint policy id (which is also the partner-system contract id for partner-driven funnels). Fed back into BootstrapClaimInputBody.policyId.
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    label: string;
    /**
     * @description Partner-specific sub-policy id when the partner returned multiple subscriptions under the same contract. Forwarded back at submit (CB: NU_SOUS_CLIENT).
     * @type string | undefined
    */
    subClientNumber?: string;
};

export type CheckCoverageOutput = {
    /**
     * @type array
    */
    eligibleContracts: EligibleContractDto[];
    /**
     * @description Partner-supplied human-readable explanation when coverage cannot be resolved (e.g. invalid occurrence date). When set, `eligibleContracts` is empty and the FE shows this message in place of the contract picker.
     * @type string | undefined
    */
    errorMessage?: string;
};

export type ClaimDocumentTooLargeDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type number
    */
    fileSizeBytes: number;
    /**
     * @type number
    */
    maxSizeBytes: number;
};

export const claimDocumentTooLargeErrorDtoCodeEnum = {
    CLAIM_DOCUMENT_TOO_LARGE: "CLAIM_DOCUMENT_TOO_LARGE"
} as const;

export type ClaimDocumentTooLargeErrorDtoCodeEnumKey = (typeof claimDocumentTooLargeErrorDtoCodeEnum)[keyof typeof claimDocumentTooLargeErrorDtoCodeEnum];

export type ClaimDocumentTooLargeErrorDto = {
    /**
     * @type string
    */
    code: ClaimDocumentTooLargeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimDocumentTooLargeDetailsDto;
};

export type GenerateFnolUploadUrlInputBody = {
    /**
     * @description Original filename — used for the resulting S3 object key.
     * @type string
    */
    filename: string;
    /**
     * @description Document type (matches one of the claim’s requiredDocuments).
     * @type string
    */
    type: string;
    /**
     * @description Content-Type of the upload (passed to the presigned PUT).
     * @type string
    */
    contentType: string;
    /**
     * @description Claim aggregate id this upload will be attached to. Used to resolve productId for AI classification context.
     * @type string
    */
    claimId: string;
    /**
     * @description Size of the file about to be uploaded, in bytes. Checked against the product\'s document size limit before signing, so an oversized file is refused before it is uploaded. Client-declared: the attach step re-checks the stored object.
     * @type number
    */
    sizeBytes: number;
};

export type GenerateFnolUploadUrlOutput = {
    /**
     * @description documentId to feed into POST /claim-management/claims/:id/documents.
     * @type string
    */
    documentId: string;
    /**
     * @description Presigned PUT URL — single-use, short-lived.
     * @type string
    */
    uploadUrl: string;
    /**
     * @description Content-Type baked into the presigned URL signature. The FE must echo it as the `Content-Type` header on the PUT or the signature will not match.
     * @type string
    */
    contentType: string;
    /**
     * @description Content-Disposition baked into the presigned URL signature. The FE must echo it as the `Content-Disposition` header on the PUT or the signature will not match.
     * @type string
    */
    contentDisposition: string;
};

export type BootstrapClaimInputBody = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted onto the aggregate so reads can show a readable type (join the array) instead of the opaque `claimType` id.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @description Partner-system identifier resolved by `lookupCustomer` for funnel tenants (e.g. Carrefour Banque). Absent for tenants without external customer lookup.
     * @type string | undefined
    */
    externalCustomerId?: string;
    /**
     * @description Partner-system contract id picked on the funnel’s contract-selection screen. Absent for tenants without coverage checks.
     * @type string | undefined
    */
    contractId?: string;
    /**
     * @description ISO date of the incident, captured early in the funnel before the aggregate is created. Lands on the aggregate’s `incident.occurredAt`.
     * @type string | undefined
    */
    occurrenceDate?: string;
    /**
     * @description Partner-specific sub-policy id matched to `policyId` (CB: NU_SOUS_CLIENT). Snapshotted onto the aggregate so the create call can forward it back at submit.
     * @type string | undefined
    */
    subClientNumber?: string;
    /**
     * @description Partner-specific generative-fact code from the picked circumstance leaf (CB: CD_FAIT_GEN). Required by CB to fetch the right list of expected pieces at bootstrap.
     * @type string | undefined
    */
    factGeneratorCode?: string;
    /**
     * @description Free-text description of the claim captured on the circumstances step (before the aggregate exists). Seeds the first-class `incident.description` at creation. Length-bounded so direct/M2M callers can’t seed an out-of-range value.
     * @type string | undefined
    */
    description?: string;
    /**
     * @description Optional secondary identifier captured on FNOL screen 1 (e.g. CB: IDENT_2 file/contract reference). Snapshotted onto the aggregate so the create call can forward it back at submit. Treat as sensitive — sent in body, not URL.
     * @type string | undefined
    */
    reference?: string;
};

export type BootstrapClaimOutput = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @description Stream version after the write (bigint serialized as string).
     * @type string
    */
    version: string;
};

export type ClaimManagementIncidentDto = {
    /**
     * @description ISO-8601 timestamp of when the incident happened.
     * @type string | undefined
    */
    occurredAt?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string | undefined
    */
    location?: string;
    /**
     * @type string | undefined
    */
    circumstances?: string;
};

export type ClaimManagementDocumentRefDto = {
    /**
     * @description Partner-specific code (e.g. P_9999 for CB) or generic type key.
     * @type string
    */
    type: string;
    /**
     * @description Display label shown to the customer.
     * @type string
    */
    libelle: string;
    /**
     * @description Human-readable explanation of what this document is. Partner-sourced (e.g. CB\'s `LI_TYP_PIECE_COURRIER`), captured once at bootstrap/external sync. Absent when the partner didn\'t provide one.
     * @type string | undefined
    */
    description?: string;
    /**
     * @description High-level ClaimDocCategory resolved from `type` via the partner integration\'s code→category registry (e.g. CARREFOUR_BANQUE_DOC_CODE_TO_CATEGORY). Lets the FE match a classifier `result.category` to the right slot.
     * @type string | undefined
    */
    category?: string;
    /**
     * @description Korint document id once the file has been uploaded and attached.
     * @type string | undefined
    */
    documentId?: string;
    /**
     * @description Uploaded filename.
     * @type string | undefined
    */
    filename?: string;
    /**
     * @description ISO-8601 timestamp when the doc was attached.
     * @type string | undefined
    */
    attachedAt?: string;
    /**
     * @description Marks the slot as a Korint-generated document. The customer never uploads it; the FNOL upload step hides generated slots, and the doc-specific custom fields needed to fill it are merged into the claim\'s `fields` list.
     * @type boolean | undefined
    */
    generated?: boolean;
    /**
     * @description When set, names a `configName` to look up in the product config\'s `generatedDocuments[]` for the Carbon templateId + provider that should render this slot. Stamped by the integration that produced the slot. The FNOL \'generate\' step iterates over generated slots that carry one of these and calls the document-generation endpoint per slot.
     * @type string | undefined
    */
    generatorConfigName?: string;
    /**
     * @description documentId of this slot blank fill-by-hand template (ENG-3590). Present only when the slot code pièce has a configured template; stamped per-request on the GET_CLAIM response. The FNOL upload step downloads it through the standard documents signed-URL flow and renders the \"Télécharger le modèle vierge\" link.
     * @type string | undefined
    */
    templateDocumentId?: string;
};

export type ClaimManagementNoteDto = {
    /**
     * @type string
    */
    content: string;
    /**
     * @type string
    */
    authorId: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
};

export type ClaimAwaitingDocumentsDto = {
    /**
     * @description Partner piece type codes flagged as needing a fresh upload.
     * @type array
    */
    requiredCodes: string[];
    /**
     * @description ISO-8601 timestamp (Korint server clock) when the pieces were flagged.
     * @type string
    */
    flaggedAt: string;
};

export type ClaimUnderReviewDto = {
    /**
     * @description Partner piece type codes resubmitted and awaiting the partner re-verdict.
     * @type array
    */
    codes: string[];
    /**
     * @description ISO-8601 timestamp (Korint server clock) when the pieces were resubmitted.
     * @type string
    */
    since: string;
};

export type ClaimPartnerPieceStatusesDto = {
    /**
     * @description Map of partner piece type code (`CD_TYP_PIECE`) → status (`VALIDATED` | `AWAITING_REVIEW` | `REJECTED`).
     * @type object
    */
    statuses: object;
    /**
     * @description ISO-8601 timestamp (Korint server clock) of the last status sync.
     * @type string
    */
    syncedAt: string;
};

export type ClaimManagementFieldEnumOptionDto = {
    /**
     * @description Value stored on the claim.
     * @type string
    */
    value: string;
    /**
     * @description Human-readable label for the value.
     * @type string
    */
    label: string;
};

export type ConfigClaimFieldVisibleWhenDto = {
    /**
     * @description Key of the sibling field this one depends on.
     * @type string
    */
    field: string;
    /**
     * @description Value the sibling must hold for this field to show.
     * @type object
    */
    equals: object;
};

export type ConfigClaimFieldValidationDto = {
    /**
     * @type number | undefined
    */
    min?: number;
    /**
     * @type number | undefined
    */
    max?: number;
    /**
     * @type number | undefined
    */
    minLength?: number;
    /**
     * @type number | undefined
    */
    maxLength?: number;
    /**
     * @type string | undefined
    */
    pattern?: string;
    /**
     * @description Exact value required to pass — powers acknowledgements.
     * @type object | undefined
    */
    equals?: object;
};

export const claimManagementFieldDtoTypeEnum = {
    string: "string",
    number: "number",
    price: "price",
    boolean: "boolean",
    date: "date",
    datetime: "datetime",
    enum: "enum",
    multiselect: "multiselect",
    text: "text",
    country: "country",
    phone: "phone",
    address: "address",
    postcode: "postcode",
    city: "city"
} as const;

export type ClaimManagementFieldDtoTypeEnumKey = (typeof claimManagementFieldDtoTypeEnum)[keyof typeof claimManagementFieldDtoTypeEnum];

export type ClaimManagementFieldDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    label: string;
    /**
     * @description Field input type driving the FNOL renderer (string, number, boolean, date, enum, multiselect, text, country, phone, address, postcode, city).
     * @type string
    */
    type: ClaimManagementFieldDtoTypeEnumKey;
    /**
     * @type boolean
    */
    required: boolean;
    /**
     * @description Value supplied by the claimant through the FNOL funnel. Polymorphic: a scalar for simple fields, `string[]` for multiselect, or `Array<Record<string, unknown>>` for repeatable groups (carried on the group’s first field). Absent until filled.
     * @type object | undefined
    */
    value?: object;
    /**
     * @description Funnel section the field belongs to (e.g. `claimant`, `insured`, `incident`). Absent for unsectioned fields.
     * @type string | undefined
    */
    section?: string;
    /**
     * @type array | undefined
    */
    enumValues?: string[];
    /**
     * @description Labels for `enum` / `multiselect` values. Absent when the integration ships none: show the raw value.
     * @type array | undefined
    */
    enumOptions?: ClaimManagementFieldEnumOptionDto[];
    /**
     * @type object | undefined
    */
    visibleWhen?: ConfigClaimFieldVisibleWhenDto;
    /**
     * @type object | undefined
    */
    validation?: ConfigClaimFieldValidationDto;
    /**
     * @description Repeatable-group id. When set, the field belongs to a collection the user can add multiple instances of; the group’s value lives on the first field with this id.
     * @type string | undefined
    */
    group?: string;
};

export const claimFraudSummaryDtoGlobalStatusEnum = {
    pending: "pending",
    clean: "clean",
    review_needed: "review_needed",
    fraud: "fraud",
    unchecked: "unchecked",
    error: "error"
} as const;

export type ClaimFraudSummaryDtoGlobalStatusEnumKey = (typeof claimFraudSummaryDtoGlobalStatusEnum)[keyof typeof claimFraudSummaryDtoGlobalStatusEnum];

export type ClaimFraudSummaryDto = {
    /**
     * @description Worst fraud-check status among the documents.
     * @type string
    */
    globalStatus: ClaimFraudSummaryDtoGlobalStatusEnumKey;
    /**
     * @description Highest per-document 0..100 score (higher = more suspicious); null when no document carries a numeric score.
     * @type number
    */
    globalScore?: number | null;
};

export type ClaimManagementStateDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type ClaimFraudVerdictCountsDto = {
    /**
     * @type number
    */
    total: number;
    /**
     * @type number
    */
    fraud: number;
    /**
     * @type number
    */
    review_needed: number;
    /**
     * @type number
    */
    clean: number;
};

export type ListClaimsManagementOutput = {
    /**
     * @type array
    */
    data: ClaimManagementStateDto[];
    /**
     * @description Total claims matching the filters, ignoring pagination. Equals `data.length` when no `limit` is sent.
     * @type number
    */
    total: number;
    /**
     * @description Per-verdict claim counts for the triage pills. Present only on the manager list; absent on the self-service `my-claims` read.
    */
    fraudCounts?: ClaimFraudVerdictCountsDto;
};

export type ClaimManagementNotFoundDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
};

export const claimManagementNotFoundErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_NOT_FOUND: "CLAIM_MANAGEMENT_NOT_FOUND"
} as const;

export type ClaimManagementNotFoundErrorDtoCodeEnumKey = (typeof claimManagementNotFoundErrorDtoCodeEnum)[keyof typeof claimManagementNotFoundErrorDtoCodeEnum];

export type ClaimManagementNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementNotFoundDetailsDto;
};

export type ClaimManagementInvalidTransitionDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string
    */
    event: string;
};

export const claimManagementInvalidTransitionErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_INVALID_TRANSITION: "CLAIM_MANAGEMENT_INVALID_TRANSITION"
} as const;

export type ClaimManagementInvalidTransitionErrorDtoCodeEnumKey = (typeof claimManagementInvalidTransitionErrorDtoCodeEnum)[keyof typeof claimManagementInvalidTransitionErrorDtoCodeEnum];

export type ClaimManagementInvalidTransitionErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementInvalidTransitionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementInvalidTransitionDetailsDto;
};

export type UpdateClaimDraftInputBody = {
    /**
     * @type object | undefined
    */
    incident?: ClaimManagementIncidentDto;
    /**
     * @description Pass `null` to clear, omit to leave untouched.
     * @type object
    */
    assetId?: object | null;
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @description Step 6 toggle — `true` when insuree files for themselves. SUBMIT requires this to be set (true or false). `undefined` leaves the existing value untouched.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
};

export type UpdateClaimDraftOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type ClaimManagementInvalidCustomFieldDetailsDto = {
    /**
     * @type string | undefined
    */
    claimId?: string;
    /**
     * @type array
    */
    issues: string[];
};

export const claimManagementInvalidCustomFieldErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_INVALID_CUSTOM_FIELD: "CLAIM_MANAGEMENT_INVALID_CUSTOM_FIELD"
} as const;

export type ClaimManagementInvalidCustomFieldErrorDtoCodeEnumKey = (typeof claimManagementInvalidCustomFieldErrorDtoCodeEnum)[keyof typeof claimManagementInvalidCustomFieldErrorDtoCodeEnum];

export type ClaimManagementInvalidCustomFieldErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementInvalidCustomFieldErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementInvalidCustomFieldDetailsDto;
};

export type UpdateClaimDraftCustomFieldsInputBody = {
    /**
     * @description Patch: merged into the existing customFields map before validation + persist.
     * @type object
    */
    customFields: object;
};

export type UpdateClaimDraftCustomFieldsOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export const attachClaimDocumentInputBodyClassificationSourceEnum = {
    human: "human"
} as const;

export type AttachClaimDocumentInputBodyClassificationSourceEnumKey = (typeof attachClaimDocumentInputBodyClassificationSourceEnum)[keyof typeof attachClaimDocumentInputBodyClassificationSourceEnum];

export type AttachClaimDocumentInputBody = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    filename: string;
    /**
     * @description Set to human when manually identifying or reclassifying a document. Omit for uploads and automatic filing. Emits classification feedback after the document is attached.
     * @type string | undefined
    */
    classificationSource?: AttachClaimDocumentInputBodyClassificationSourceEnumKey;
};

export type AttachClaimDocumentOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type DocumentConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    name: string;
};

export const documentConfigNotFoundErrorDtoCodeEnum = {
    DOCUMENT_CONFIG_NOT_FOUND: "DOCUMENT_CONFIG_NOT_FOUND"
} as const;

export type DocumentConfigNotFoundErrorDtoCodeEnumKey = (typeof documentConfigNotFoundErrorDtoCodeEnum)[keyof typeof documentConfigNotFoundErrorDtoCodeEnum];

export type DocumentConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DocumentConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConfigNotFoundDetailsDto;
};

export type GenerateClaimDocumentInputBody = {
    /**
     * @description Partner-specific doc code identifying the generated slot to render (e.g. `P_075` for Carrefour Banque). Must match a generated slot on the claim that hasn\'t been attached yet.
     * @type string
    */
    slotType: string;
};

export type GenerateClaimDocumentOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type GetClaimDocumentGenerationPayloadInputBody = {
    /**
     * @description Claim semantic id (`claim_*`).
     * @type string
    */
    claimId: string;
    /**
     * @description Partner-specific doc code identifying the generated slot (e.g. `P_075` for Carrefour Banque). Must match a `generated` slot on the claim.
     * @type string
    */
    slotType: string;
};

export type GetClaimDocumentGenerationPayloadOutput = {
    /**
     * @description Exact payload object the Carbone template would receive at render time.
     * @type object
    */
    payload: object;
};

export type DetachClaimDocumentOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type TransitionClaimInputBody = {
    /**
     * @description Machine transition id, e.g. `SUBMIT`.
     * @type string
    */
    transition: string;
    /**
     * @description Optional human-readable audit context.
     * @type string | undefined
    */
    reason?: string;
    /**
     * @description FLAG_PIECES only — partner piece type codes (`CD_TYP_PIECE`) to flag for re-upload.
     * @type array | undefined
    */
    flaggedPieceCodes?: string[];
};

export type TransitionClaimOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export const retryClaimForwardOutputStatusEnum = {
    dispatched: "dispatched",
    "already-forwarded": "already-forwarded",
    "not-forwardable": "not-forwardable"
} as const;

export type RetryClaimForwardOutputStatusEnumKey = (typeof retryClaimForwardOutputStatusEnum)[keyof typeof retryClaimForwardOutputStatusEnum];

export type RetryClaimForwardOutput = {
    /**
     * @type string
    */
    status: RetryClaimForwardOutputStatusEnumKey;
    /**
     * @type string
    */
    externalClaimId?: string | null;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export type AddClaimNoteInputBody = {
    /**
     * @type string
    */
    content: string;
};

export type AddClaimNoteOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type MissingTenantDetailsDto = object;

export const missingTenantErrorDtoCodeEnum = {
    MISSING_TENANT: "MISSING_TENANT"
} as const;

export type MissingTenantErrorDtoCodeEnumKey = (typeof missingTenantErrorDtoCodeEnum)[keyof typeof missingTenantErrorDtoCodeEnum];

export type MissingTenantErrorDto = {
    /**
     * @type string
    */
    code: MissingTenantErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingTenantDetailsDto;
};

export type StartClaimsExportOutput = {
    /**
     * @description Id of the job building the CSV. Poll `GET /claim-management/claims/export/{jobId}` until it leaves CREATED/RUNNING.
     * @type string
    */
    jobId: string;
};

export const jobStatusEnum = {
    CREATED: "CREATED",
    RUNNING: "RUNNING",
    SUCCEEDED: "SUCCEEDED",
    CANCELLED: "CANCELLED",
    ERROR: "ERROR"
} as const;

export type JobStatusEnumKey = (typeof jobStatusEnum)[keyof typeof jobStatusEnum];

/**
 * @description Terminal states are SUCCEEDED, ERROR and CANCELLED.
*/
export type JobStatus = JobStatusEnumKey;

export type ClaimsExportStatusOutput = {
    /**
     * @description Terminal states are SUCCEEDED, ERROR and CANCELLED.
    */
    status: JobStatus;
    /**
     * @description Presigned CSV URL, present only once the job has SUCCEEDED. Expires after an hour.
     * @type string | undefined
    */
    downloadUrl?: string;
};

export type GetClaimManagementOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    version: number;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Korint Claimant semantic id (`claimant_*`) owning the claim (resolved at the legacy service from the caller’s Cognito sub via `ClaimantIdentityService`). Distinct from a policy `Customer` and from the actor on event metadata.
     * @type string
    */
    claimantId: string;
    /**
     * @type string | undefined
    */
    assetId?: string;
    /**
     * @type string
    */
    claimType: string;
    /**
     * @description Human-readable labels of every node on the picked circumstance path (root → leaf; e.g. CB `LI_CIRC_EXT` per level). Snapshotted at bootstrap so reads can show a readable type (join the array) rather than the opaque `claimType` id. Absent for claims created before the label was captured.
     * @type array | undefined
    */
    claimTypeLabel?: string[];
    /**
     * @type object
    */
    incident: ClaimManagementIncidentDto;
    /**
     * @description Step 6 toggle — `true` when the insuree is also the claimant. Unset until the user answers on the parties screen; SUBMIT is gated on this being defined.
     * @type boolean | undefined
    */
    insureeIsClaimant?: boolean;
    /**
     * @description Main lifecycle status — one of the five fixed values: DRAFT, INSTRUCTION, SETTLEMENT, CLOSED, DISCARDED.
     * @type string
    */
    status: string;
    /**
     * @description Per-module sub-state map (module key → state), e.g. `{ documents: \"AWAITING_DOCUMENTS\" }` or `{ externalIntake: \"PENDING_EXTERNAL_DATA\" }`. The documents module uses AWAITING_DOCUMENTS / UNDER_REVIEW; externalIntake uses PENDING_EXTERNAL_DATA / AWAITING_CLAIMANT_SUBMISSION. Empty/absent = neutral main status (every module idle).
     * @type object | undefined
    */
    subStatuses?: {
        [key: string]: string;
    };
    /**
     * @type array
    */
    documents: ClaimManagementDocumentRefDto[];
    /**
     * @type array
    */
    notes: ClaimManagementNoteDto[];
    /**
     * @description Present only while `status === AWAITING_DOCUMENTS`: the pieces the partner flagged for re-upload and when. Cleared when the claim returns to CREATED.
    */
    awaitingDocuments?: ClaimAwaitingDocumentsDto;
    /**
     * @description Present only while `status === UNDER_REVIEW`: the pieces the claimant resubmitted that are awaiting the partner’s re-verdict. Cleared when the claim returns to CREATED or is re-flagged.
    */
    underReview?: ClaimUnderReviewDto;
    /**
     * @description Per-piece partner status map from the last Marsh \"Infos sinistres\" sync (ENG-3616). Present once synced; persists across CREATED / AWAITING_DOCUMENTS / UNDER_REVIEW. Drives the read-only \"Documents validés\" display.
    */
    partnerPieceStatuses?: ClaimPartnerPieceStatusesDto;
    /**
     * @description Form fields the claim must collect, schema + value fused in a single ordered list. Bootstrapped from the tenant’s `fetchClaimRequirements`; each entry’s `value` is filled in by the customer through the FNOL funnel. Repeatable-section instances live on the first field of each group.
     * @type array
    */
    fields: ClaimManagementFieldDto[];
    /**
     * @type object
    */
    metadata: object;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    createdAt: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string
    */
    updatedAt: string;
    /**
     * @description Partner-system claim reference returned when the claim was forwarded (e.g. CB `NU_SIN_GEST`). Set on submit; absent on drafts. Surfaced as the human-facing claim number.
     * @type string | undefined
    */
    externalClaimId?: string;
    /**
     * @description Claim-level fraud verdict (worst document status / highest document score), populated only on the manager LIST read (ENG-3638). Null when the claim has no scored documents; absent on single-claim reads.
     * @type object
    */
    fraudSummary?: ClaimFraudSummaryDto | null;
    /**
     * @description Contract number (external id) of the claim’s policy, populated on list reads only. Absent when the policy has none.
     * @type string | undefined
    */
    policyNumber?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    submittedAt?: string;
    /**
     * @description ISO-8601 timestamp.
     * @type string | undefined
    */
    discardedAt?: string;
    /**
     * @type string | undefined
    */
    discardReason?: string;
};

export type GetAvailableTransitionsOutput = {
    /**
     * @description Event types that pass all guards from the current machine state.
     * @type array
    */
    availableEvents: string[];
};

export const getDocumentExtractionOutputStatusEnum = {
    PENDING: "PENDING",
    DONE: "DONE",
    FAILED: "FAILED",
    SKIPPED: "SKIPPED"
} as const;

export type GetDocumentExtractionOutputStatusEnumKey = (typeof getDocumentExtractionOutputStatusEnum)[keyof typeof getDocumentExtractionOutputStatusEnum];

export type GetDocumentExtractionOutput = {
    /**
     * @description Document ID
     * @type string
    */
    documentId: string;
    /**
     * @description Extraction status
     * @type string
    */
    status: GetDocumentExtractionOutputStatusEnumKey;
    /**
     * @description Extracted fields
     * @type object | undefined
    */
    fields?: object;
    /**
     * @description AI operation ID
     * @type string | undefined
    */
    aiOperationId?: string;
    /**
     * @description Error message if extraction failed
     * @type string | undefined
    */
    errorMessage?: string;
    /**
     * @description Extraction context metadata
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @description Creation timestamp
     * @type string
    */
    createdAt: string;
    /**
     * @description Last update timestamp
     * @type string
    */
    updatedAt: string;
};

export type GetClaimExtractionsOutput = {
    /**
     * @description List of document extractions for the claim
     * @type array
    */
    extractions: GetDocumentExtractionOutput[];
};

export const claimStatusHistoryEntryDtoKindEnum = {
    created: "created",
    submitted: "submitted",
    awaiting_documents: "awaiting_documents",
    under_review: "under_review",
    returned: "returned",
    discarded: "discarded",
    settlement: "settlement",
    closed: "closed",
    reopened: "reopened"
} as const;

export type ClaimStatusHistoryEntryDtoKindEnumKey = (typeof claimStatusHistoryEntryDtoKindEnum)[keyof typeof claimStatusHistoryEntryDtoKindEnum];

export type ClaimStatusHistoryEntryDto = {
    /**
     * @type string
    */
    kind: ClaimStatusHistoryEntryDtoKindEnumKey;
    /**
     * @description ISO-8601 timestamp of the transition.
     * @type string
    */
    date: string;
    /**
     * @description Main status the claim landed in.
     * @type string | undefined
    */
    status?: string;
    /**
     * @description Sub-module owning the change (e.g. `documents`), when module-scoped.
     * @type string | undefined
    */
    module?: string;
    /**
     * @description Module state the claim landed in; absent when the module ended.
     * @type string | undefined
    */
    subStatus?: string;
};

export type GetClaimStatusHistoryOutput = {
    /**
     * @type array
    */
    entries: ClaimStatusHistoryEntryDto[];
};

export type DocumentFraudScoreSignalRegionDto = {
    /**
     * @description Left edge as a 0..1 fraction of the image width.
     * @type number
    */
    x: number;
    /**
     * @description Top edge as a 0..1 fraction of the image height.
     * @type number
    */
    y: number;
    /**
     * @description Width as a 0..1 fraction of the image width.
     * @type number
    */
    width: number;
    /**
     * @description Height as a 0..1 fraction of the image height.
     * @type number
    */
    height: number;
};

export const documentFraudScoreSignalDtoSeverityEnum = {
    info: "info",
    warning: "warning",
    critical: "critical"
} as const;

export type DocumentFraudScoreSignalDtoSeverityEnumKey = (typeof documentFraudScoreSignalDtoSeverityEnum)[keyof typeof documentFraudScoreSignalDtoSeverityEnum];

export type DocumentFraudScoreSignalDto = {
    /**
     * @description Stable signal code, provider-namespaced (e.g. `inhouse:tamper.suspect`).
     * @type string
    */
    code: string;
    /**
     * @description Human-readable detail (FR by default for Marsh).
     * @type string | undefined
    */
    message?: string;
    /**
     * @type string | undefined
    */
    severity?: DocumentFraudScoreSignalDtoSeverityEnumKey;
    /**
     * @description Where on the document the evidence sits (normalised 0..1 rect); absent when unknown or whole-document.
    */
    region?: DocumentFraudScoreSignalRegionDto;
    /**
     * @description How many same-code findings this signal stands for, when repeats of a region-scoped check were collapsed into one (ENG-4673). Absent on a signal that stands alone.
     * @type number | undefined
    */
    occurrences?: number;
    /**
     * @description Every location the collapsed findings covered, so the page overlay still draws one box per finding. Absent unless `occurrences` is set; `region` holds the first.
     * @type array | undefined
    */
    regions?: DocumentFraudScoreSignalRegionDto[];
};

export const documentFraudScoreDtoStatusEnum = {
    pending: "pending",
    clean: "clean",
    review_needed: "review_needed",
    fraud: "fraud",
    unchecked: "unchecked",
    error: "error"
} as const;

export type DocumentFraudScoreDtoStatusEnumKey = (typeof documentFraudScoreDtoStatusEnum)[keyof typeof documentFraudScoreDtoStatusEnum];

export const documentFraudScoreDtoFieldExtractionStatusEnum = {
    available: "available",
    empty: "empty"
} as const;

export type DocumentFraudScoreDtoFieldExtractionStatusEnumKey = (typeof documentFraudScoreDtoFieldExtractionStatusEnum)[keyof typeof documentFraudScoreDtoFieldExtractionStatusEnum];

export const documentFraudScoreDtoManagerVerdictEnum = {
    clean: "clean",
    review_needed: "review_needed",
    fraud: "fraud"
} as const;

export type DocumentFraudScoreDtoManagerVerdictEnumKey = (typeof documentFraudScoreDtoManagerVerdictEnum)[keyof typeof documentFraudScoreDtoManagerVerdictEnum];

export type DocumentFraudScoreDto = {
    /**
     * @description Korint document id the score belongs to.
     * @type string
    */
    documentId: string;
    /**
     * @description Scoring provider key (e.g. `inhouse`).
     * @type string
    */
    providerKey: string;
    /**
     * @description Fraud-check status. `pending` = async in-flight; others are terminal.
     * @type string
    */
    status: DocumentFraudScoreDtoStatusEnumKey;
    /**
     * @description Normalised 0..100 score (higher = more suspicious); null on unchecked/error.
     * @type number
    */
    fraudScore?: number | null;
    /**
     * @type array
    */
    signals: DocumentFraudScoreSignalDto[];
    /**
     * @description Checker keys that ran on this document, regardless of whether they fired a signal (ENG-3845). Empty for providers that do not report applied checkers.
     * @type array
    */
    appliedCheckers: string[];
    /**
     * @description Whether successful shared extraction supplied fraud fields. Empty means field checks were not performed; the result covers file checks only. Absent when the provider does not report extraction coverage.
     * @type string | undefined
    */
    fieldExtractionStatus?: DocumentFraudScoreDtoFieldExtractionStatusEnumKey;
    /**
     * @description ClaimDocCategory if known.
     * @type string
    */
    docCategory?: string | null;
    /**
     * @description Manager-corrected verdict, when a claims manager reviewed the document; overrides `status` for display (ENG-3658). Null when never corrected.
     * @type string
    */
    managerVerdict?: DocumentFraudScoreDtoManagerVerdictEnumKey | null;
    /**
     * @description ISO timestamp of the manager correction; null when never corrected.
     * @type string
    */
    managerReviewedAt?: string | null;
    /**
     * @description Free-text notes the manager left with the correction; null when none.
     * @type string
    */
    managerReviewNotes?: string | null;
    /**
     * @description Email of the user who corrected the verdict; absent when never corrected.
     * @type string | undefined
    */
    managerReviewedByEmail?: string;
    /**
     * @description ISO time the stored result last changed; send it back as `expectedUpdatedAt` to correct it.
     * @type string
    */
    updatedAt: string;
};

export type GetClaimDocumentFraudScoresOutput = {
    /**
     * @type array
    */
    scores: DocumentFraudScoreDto[];
    /**
     * @description Claim-level aggregate; null when the claim has no scored documents.
     * @type object
    */
    summary?: ClaimFraudSummaryDto | null;
};

export const claimFraudNarrativeItemDtoSeverityEnum = {
    info: "info",
    warning: "warning",
    critical: "critical"
} as const;

export type ClaimFraudNarrativeItemDtoSeverityEnumKey = (typeof claimFraudNarrativeItemDtoSeverityEnum)[keyof typeof claimFraudNarrativeItemDtoSeverityEnum];

export type ClaimFraudNarrativeItemDto = {
    /**
     * @description Short French restatement of one finding (≤ ~12 words).
     * @type string
    */
    text: string;
    /**
     * @type string
    */
    severity: ClaimFraudNarrativeItemDtoSeverityEnumKey;
    /**
     * @description Korint document ids the bullet refers to, for linking back to each document; empty/absent for cross-document or \"all clean\" bullets.
     * @type array | undefined
    */
    documentIds?: string[];
};

export type GetClaimFraudNarrativeOutput = {
    /**
     * @description AI-generated bullets summarizing the per-document fraud findings, most severe first; null when the claim has no verdicts yet or generation is unavailable.
     * @type array
    */
    items?: ClaimFraudNarrativeItemDto[] | null;
};

export const correctClaimDocumentFraudVerdictInputBodyVerdictEnum = {
    clean: "clean",
    review_needed: "review_needed",
    fraud: "fraud"
} as const;

export type CorrectClaimDocumentFraudVerdictInputBodyVerdictEnumKey = (typeof correctClaimDocumentFraudVerdictInputBodyVerdictEnum)[keyof typeof correctClaimDocumentFraudVerdictInputBodyVerdictEnum];

export type CorrectClaimDocumentFraudVerdictInputBody = {
    /**
     * @description The verdict the manager believes is correct.
     * @type string
    */
    verdict: CorrectClaimDocumentFraudVerdictInputBodyVerdictEnumKey;
    /**
     * @description Optional notes explaining the correction.
     * @type string | undefined
    */
    notes?: string;
};

export type CorrectClaimDocumentFraudVerdictOutput = {
    /**
     * @description The updated per-document score.
    */
    score: DocumentFraudScoreDto;
};

export type ClaimManagementTimelineEntryDto = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type object
    */
    data: object;
    /**
     * @type object
    */
    metadata: object;
};

export type GetClaimManagementTimelineOutput = {
    /**
     * @type array
    */
    events: ClaimManagementTimelineEntryDto[];
};

export type CreateExternalClaimInputBody = {
    /**
     * @type string
    */
    externalClaimId: string;
    /**
     * @type string
    */
    email: string;
};

export type InvalidClaimCategoryDto = {
    /**
     * @type string
    */
    category: string;
    /**
     * @type array
    */
    availableCategories: any[][];
};

export const invalidClaimCategoryErrorDtoCodeEnum = {
    INVALID_CLAIM_CATEGORY: "INVALID_CLAIM_CATEGORY"
} as const;

export type InvalidClaimCategoryErrorDtoCodeEnumKey = (typeof invalidClaimCategoryErrorDtoCodeEnum)[keyof typeof invalidClaimCategoryErrorDtoCodeEnum];

export type InvalidClaimCategoryErrorDto = {
    /**
     * @type string
    */
    code: InvalidClaimCategoryErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidClaimCategoryDto;
};

export type CreateClaimInputBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string | undefined, date-time
    */
    occurredAt?: string;
    /**
     * @type string | undefined, date-time
    */
    createdAt?: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
    /**
     * @type string
    */
    externalId: string;
};

export type CreateClaimOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string, date-time
    */
    occurredAt: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    externalId: string;
};

export type ClaimNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const claimNotFoundErrorDtoCodeEnum = {
    CLAIM_NOT_FOUND: "CLAIM_NOT_FOUND"
} as const;

export type ClaimNotFoundErrorDtoCodeEnumKey = (typeof claimNotFoundErrorDtoCodeEnum)[keyof typeof claimNotFoundErrorDtoCodeEnum];

export type ClaimNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ClaimNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimNotFoundDetailsDto;
};

export type UpdateClaimInputBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string | undefined, date-time
    */
    occurredAt?: string;
    /**
     * @type string | undefined, date-time
    */
    createdAt?: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
};

export type UpdateClaimOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string, date-time
    */
    occurredAt: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    externalId: string;
};

export type DeleteClaimOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string, date-time
    */
    occurredAt: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    externalId: string;
};

export type GetClaimOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string, date-time
    */
    occurredAt: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    externalId: string;
};

export type ClaimDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    description?: string;
    /**
     * @type string, date-time
    */
    occurredAt: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined
    */
    responsibility?: string;
    /**
     * @description the amount of money that an insurance company sets aside to cover
     * @type string | undefined
    */
    category?: string;
    /**
     * @type number | undefined
    */
    reserve?: number;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    externalId: string;
};

export type ListClaimsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ClaimDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ListTenantsOutput = {
    /**
     * @description Every tenant id the running backend has a config for.
     * @type array
    */
    tenants: string[];
};

export const durationUnitEnum = {
    YEAR: "YEAR",
    MONTH: "MONTH",
    WEEK: "WEEK",
    DAY: "DAY",
    HOUR: "HOUR",
    MINUTE: "MINUTE",
    SECOND: "SECOND"
} as const;

export type DurationUnitEnumKey = (typeof durationUnitEnum)[keyof typeof durationUnitEnum];

export type Duration = {
    /**
     * @type number
    */
    amount: number;
    /**
     * @type string
    */
    unit: DurationUnitEnumKey;
};

export const renewalCancellationTriggerEnum = {
    RENEWAL_REFUSED: "RENEWAL_REFUSED",
    CRM_ABOVE_LIMIT: "CRM_ABOVE_LIMIT"
} as const;

export type RenewalCancellationTriggerEnumKey = (typeof renewalCancellationTriggerEnum)[keyof typeof renewalCancellationTriggerEnum];

export type RenewalCancellationTrigger = RenewalCancellationTriggerEnumKey;

export type ConfigEnabledRenewalCancellationConfig = {
    trigger: RenewalCancellationTrigger;
    closeBranchReason: BranchCloseReasons;
    /**
     * @type string
    */
    policyStopReason: string;
    /**
     * @type array
    */
    policyStopDetails: CustomFieldDto[];
};

export const configRenewalCrmParametersUsageEnum = {
    TOURING_OR_ALL_PURPOSE: "TOURING_OR_ALL_PURPOSE",
    OTHER: "OTHER"
} as const;

export type ConfigRenewalCrmParametersUsageEnumKey = (typeof configRenewalCrmParametersUsageEnum)[keyof typeof configRenewalCrmParametersUsageEnum];

export type ConfigRenewalCrmParameters = {
    /**
     * @type string
    */
    usage: ConfigRenewalCrmParametersUsageEnumKey;
    /**
     * @type number
    */
    crmLimit: number;
};

export type ConfigRenewalFeeConditionDto = {
    /**
     * @description Tier this fee applies to. If not specified, applies to all tiers
     * @type string | undefined
    */
    tier?: string;
    /**
     * @description Excess this fee applies to. If not specified, applies to all excesses
     * @type string | undefined
    */
    excess?: string;
    /**
     * @description Perils this fee applies to. If not specified, applies to all perils
     * @type array | undefined
    */
    perils?: string[];
};

export type ConfigRenewalFeesDto = {
    /**
     * @description Unique identifier for this renewal fee rule
     * @type string
    */
    id: string;
    /**
     * @description Conditions that must be met for this fee to apply
    */
    condition?: ConfigRenewalFeeConditionDto;
    /**
     * @description Fee component to apply on renewal
    */
    component: QuoteComponentDto;
    /**
     * @description Whether to apply this fee on every renewal or only first one
     * @default true
     * @type boolean
    */
    applyOnEveryRenewal: boolean;
};

export const configRenewalEnabledTypeEnum = {
    ConfigRenewalEnabled: "ConfigRenewalEnabled"
} as const;

export type ConfigRenewalEnabledTypeEnumKey = (typeof configRenewalEnabledTypeEnum)[keyof typeof configRenewalEnabledTypeEnum];

export type ConfigRenewalEnabled = {
    /**
     * @type string
    */
    __type: ConfigRenewalEnabledTypeEnumKey;
    /**
     * @description How long before the term the POLICY_STOP_NOTICE email trigger fires.
    */
    stopNoticePeriod?: Duration;
    /**
     * @type boolean
    */
    enabled: boolean;
    /**
     * @type object
    */
    renewalPeriod: Duration;
    /**
     * @description By default this will be false, meaning that if you don\'t explicitly accept a renewal, the policy will be stopped.
     * @type boolean | undefined
    */
    tacitRenewal?: boolean;
    /**
     * @type boolean | undefined
    */
    quoteAtRenewal?: boolean;
    /**
     * @type boolean | undefined
    */
    editableAtRenewal?: boolean;
    /**
     * @description Cancellation configurations for renewal triggers
     * @type array
    */
    cancellationConfigs: ConfigEnabledRenewalCancellationConfig[];
    /**
     * @description CRM parameters for renewal
    */
    crmParameters?: ConfigRenewalCrmParameters;
    /**
     * @description Optional fees to apply on renewal based on tier, excess, and perils
     * @type array | undefined
    */
    renewalFees?: ConfigRenewalFeesDto[];
};

export type ConfigDisabledRenewalCancellationConfig = {
    /**
     * @type string
    */
    policyStopReason: string;
    /**
     * @type array
    */
    policyStopDetails: CustomFieldDto[];
};

export const configRenewalDisabledTypeEnum = {
    ConfigRenewalDisabled: "ConfigRenewalDisabled"
} as const;

export type ConfigRenewalDisabledTypeEnumKey = (typeof configRenewalDisabledTypeEnum)[keyof typeof configRenewalDisabledTypeEnum];

export type ConfigRenewalDisabled = {
    /**
     * @type string
    */
    __type: ConfigRenewalDisabledTypeEnumKey;
    /**
     * @description How long before the term the POLICY_STOP_NOTICE email trigger fires.
    */
    stopNoticePeriod?: Duration;
    /**
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Whether policies are automatically stopped once they reach the end of their period.
     * @type boolean | undefined
    */
    stopAtTerm?: boolean;
    /**
     * @type object
    */
    stopConfig: ConfigDisabledRenewalCancellationConfig;
};

export const operatorEnum = {
    equals: "equals",
    exists: "exists",
    is_undefined: "is_undefined",
    greater_than: "greater_than",
    less_than: "less_than",
    greater_than_or_equal: "greater_than_or_equal",
    less_than_or_equal: "less_than_or_equal",
    contains: "contains",
    in: "in",
    not_equals: "not_equals",
    array_min_length: "array_min_length",
    years_less_than: "years_less_than",
    years_greater_than_or_equal: "years_greater_than_or_equal",
    months_less_than: "months_less_than",
    months_greater_than_or_equal: "months_greater_than_or_equal"
} as const;

export type OperatorEnumKey = (typeof operatorEnum)[keyof typeof operatorEnum];

export type Operator = OperatorEnumKey;

export type FilterDto = {
    /**
     * @type string
    */
    path: string;
    operator: Operator;
    value?: (string | number | boolean | string[]);
};

export const configGeneratedDocumentCarboneDtoShadowProviderEnum = {
    CraftMyPdf: "CraftMyPdf",
    Carbone: "Carbone",
    ReactPdf: "ReactPdf",
    Static: "Static"
} as const;

export type ConfigGeneratedDocumentCarboneDtoShadowProviderEnumKey = (typeof configGeneratedDocumentCarboneDtoShadowProviderEnum)[keyof typeof configGeneratedDocumentCarboneDtoShadowProviderEnum];

export const configGeneratedDocumentCarboneDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type ConfigGeneratedDocumentCarboneDtoInsurerEnumKey = (typeof configGeneratedDocumentCarboneDtoInsurerEnum)[keyof typeof configGeneratedDocumentCarboneDtoInsurerEnum];

export const configGeneratedDocumentCarboneDtoProviderEnum = {
    Carbone: "Carbone",
    CraftMyPdf: "CraftMyPdf",
    ReactPdf: "ReactPdf"
} as const;

export type ConfigGeneratedDocumentCarboneDtoProviderEnumKey = (typeof configGeneratedDocumentCarboneDtoProviderEnum)[keyof typeof configGeneratedDocumentCarboneDtoProviderEnum];

export type ConfigGeneratedDocumentCarboneDto = {
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string | undefined
    */
    documentType?: string;
    /**
     * @type array
    */
    trigger: string[];
    /**
     * @type array | undefined
    */
    filters?: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilters?: FilterDto[];
    /**
     * @type string
    */
    target: string;
    /**
     * @type array
    */
    businessObjects: string[];
    /**
     * @description Whether this document can be generated on demand from the frontend
     * @type boolean | undefined
    */
    generateOnDemand?: boolean;
    /**
     * @description Whether the policyholder can generate this on-demand document from their client space. Narrows generateOnDemand, which stays required.
     * @type boolean | undefined
    */
    generateOnDemandByPolicyholder?: boolean;
    /**
     * @description Whether to resolve per-asset external quotes into the payload (defaults to true). Set false for templates that do not render franchise-grid data on large fleets.
     * @type boolean | undefined
    */
    resolveExternalQuotes?: boolean;
    /**
     * @description Shadow-mode provider: generate this document a second time with this provider/template, for comparison against the primary provider. Never affects the primary document returned to the caller. Must be set together with shadowTemplateId.
     * @type string | undefined
    */
    shadowProvider?: ConfigGeneratedDocumentCarboneDtoShadowProviderEnumKey;
    /**
     * @description templateId to use for the shadow-mode generation. Must be set together with shadowProvider.
     * @type string | undefined
    */
    shadowTemplateId?: string;
    /**
     * @description Insurer this document is issued for, stamped on its metadata so readers can tell per-insurer copies apart
     * @type string | undefined
    */
    insurer?: ConfigGeneratedDocumentCarboneDtoInsurerEnumKey;
    /**
     * @description Document generation provider
     * @type string
    */
    provider: ConfigGeneratedDocumentCarboneDtoProviderEnumKey;
    /**
     * @type string
    */
    templateId: string;
    /**
     * @description Carbone enum definitions for convEnum formatter
     * @type object | undefined
    */
    enum?: {
        [key: string]: any;
    };
};

export const configGeneratedDocumentStaticDtoShadowProviderEnum = {
    CraftMyPdf: "CraftMyPdf",
    Carbone: "Carbone",
    ReactPdf: "ReactPdf",
    Static: "Static"
} as const;

export type ConfigGeneratedDocumentStaticDtoShadowProviderEnumKey = (typeof configGeneratedDocumentStaticDtoShadowProviderEnum)[keyof typeof configGeneratedDocumentStaticDtoShadowProviderEnum];

export const configGeneratedDocumentStaticDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type ConfigGeneratedDocumentStaticDtoInsurerEnumKey = (typeof configGeneratedDocumentStaticDtoInsurerEnum)[keyof typeof configGeneratedDocumentStaticDtoInsurerEnum];

export const configGeneratedDocumentStaticDtoProviderEnum = {
    Static: "Static"
} as const;

export type ConfigGeneratedDocumentStaticDtoProviderEnumKey = (typeof configGeneratedDocumentStaticDtoProviderEnum)[keyof typeof configGeneratedDocumentStaticDtoProviderEnum];

export type ConfigGeneratedDocumentStaticDto = {
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string | undefined
    */
    documentType?: string;
    /**
     * @type array
    */
    trigger: string[];
    /**
     * @type array | undefined
    */
    filters?: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilters?: FilterDto[];
    /**
     * @type string
    */
    target: string;
    /**
     * @type array
    */
    businessObjects: string[];
    /**
     * @description Whether this document can be generated on demand from the frontend
     * @type boolean | undefined
    */
    generateOnDemand?: boolean;
    /**
     * @description Whether the policyholder can generate this on-demand document from their client space. Narrows generateOnDemand, which stays required.
     * @type boolean | undefined
    */
    generateOnDemandByPolicyholder?: boolean;
    /**
     * @description Whether to resolve per-asset external quotes into the payload (defaults to true). Set false for templates that do not render franchise-grid data on large fleets.
     * @type boolean | undefined
    */
    resolveExternalQuotes?: boolean;
    /**
     * @description Shadow-mode provider: generate this document a second time with this provider/template, for comparison against the primary provider. Never affects the primary document returned to the caller. Must be set together with shadowTemplateId.
     * @type string | undefined
    */
    shadowProvider?: ConfigGeneratedDocumentStaticDtoShadowProviderEnumKey;
    /**
     * @description templateId to use for the shadow-mode generation. Must be set together with shadowProvider.
     * @type string | undefined
    */
    shadowTemplateId?: string;
    /**
     * @description Insurer this document is issued for, stamped on its metadata so readers can tell per-insurer copies apart
     * @type string | undefined
    */
    insurer?: ConfigGeneratedDocumentStaticDtoInsurerEnumKey;
    /**
     * @description Document generation provider
     * @type string
    */
    provider: ConfigGeneratedDocumentStaticDtoProviderEnumKey;
};

export type ConfigPolicyStop = {
    /**
     * @description Delay between a stop request and its execution, during which the request can still be cancelled. The stop executes at max(requested stop date, request time + this window); its effective date stays the requested one. Defaults to 2 hours.
    */
    minimumUndoWindow?: Duration;
};

export const speechToTextConfigProviderEnum = {
    "aws-transcribe": "aws-transcribe",
    elevenlabs: "elevenlabs"
} as const;

export type SpeechToTextConfigProviderEnumKey = (typeof speechToTextConfigProviderEnum)[keyof typeof speechToTextConfigProviderEnum];

export type SpeechToTextConfig = {
    /**
     * @description Speech-to-text provider for this tenant. Presence enables dictation.
     * @type string
    */
    provider: SpeechToTextConfigProviderEnumKey;
};

export type TenantExternalLinkDto = {
    /**
     * @description Stable identifier the tenant frontend uses to look up a translated label (e.g. `insurance_certificate`). Falls back to `label` when unset or unknown.
     * @type string | undefined
    */
    id?: string;
    /**
     * @description Display label for the external link
     * @type string
    */
    label: string;
    /**
     * @description Absolute URL the link points to
     * @type string
    */
    url: string;
};

export type ClaimsPortalContactDto = {
    /**
     * @description Phone number of the claims-management platform, in the display form end users should see, spacing included. The frontend derives the `tel:` link from it.
     * @type string | undefined
    */
    phone?: string;
    /**
     * @description Contact email address of the claims-management platform
     * @type string | undefined
    */
    email?: string;
    /**
     * @description Postal address of the claims-management platform, as a single display line
     * @type string | undefined
    */
    postalAddress?: string;
};

export type ClaimsPortalConfigDto = {
    /**
     * @description URL of the legacy claims platform. When set, the tenant frontend surfaces an alert pointing users to it for claims filed before migration.
     * @type string | undefined
    */
    previousPlatformUrl?: string;
    /**
     * @description Show the WhatsApp claim-declaration entry point. Requires the conversation relay to be wired for this tenant server-side — the call carries no product, hence a tenant-level flag.
     * @type boolean | undefined
    */
    whatsappEntryPoint?: boolean;
    /**
     * @description Contact details of the claims-management platform. Presence enables the \"contact the platform\" call to action on a claim; each detail renders only when set.
    */
    contact?: ClaimsPortalContactDto;
    /**
     * @description Product names this tenant sells, as marketed. When set, the claims-portal home subtitle names them instead of reading generically; proper nouns only, the surrounding sentence stays translated frontend-side.
     * @type array | undefined
    */
    homeProductNames?: string[];
};

export const configAnnualCommissionDocumentDtoProviderEnum = {
    Carbone: "Carbone",
    CraftMyPdf: "CraftMyPdf",
    ReactPdf: "ReactPdf"
} as const;

export type ConfigAnnualCommissionDocumentDtoProviderEnumKey = (typeof configAnnualCommissionDocumentDtoProviderEnum)[keyof typeof configAnnualCommissionDocumentDtoProviderEnum];

export type ConfigAnnualCommissionDocumentDto = {
    /**
     * @description Document generation provider
     * @type string
    */
    provider: ConfigAnnualCommissionDocumentDtoProviderEnumKey;
    /**
     * @type string
    */
    templateId: string;
};

export type EmailsConfig = {
    /**
     * @description All transactional emails will be CC to these emails
     * @type array | undefined
    */
    bccEmail?: string[];
    /**
     * @description Default From address for this scope, overridable per trigger
     * @type string | undefined
    */
    fromAddress?: string;
    /**
     * @description Default Reply-To for this scope, overridable per trigger. Transports only.
     * @type string | undefined
    */
    replyTo?: string;
};

export type SendToDto = {
    /**
     * @type string | undefined
    */
    recipient?: string;
    /**
     * @type array | undefined
    */
    roles?: string[];
    /**
     * @type string | undefined
    */
    email?: string;
};

export type ConfigEmailAttachmentDto = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type boolean | undefined
    */
    signed?: boolean;
};

export type DocumentGenerationConfig = {
    /**
     * @type string | undefined
    */
    target?: string;
    /**
     * @type array
    */
    businessObjects: string[];
};

export type EmailMessageData = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    path: string;
    /**
     * @type object | undefined
    */
    mapping?: object;
    /**
     * @type string | undefined
    */
    format?: string;
    /**
     * @type string | undefined
    */
    dateFormat?: string;
};

export const configEmailDtoProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type ConfigEmailDtoProviderEnumKey = (typeof configEmailDtoProviderEnum)[keyof typeof configEmailDtoProviderEnum];

export type ConfigEmailDto = {
    /**
     * @type string
    */
    trigger: string;
    /**
     * @type array | undefined
    */
    filters?: FilterDto[];
    /**
     * @type string
    */
    templateId: string;
    /**
     * @type string | undefined
    */
    provider?: ConfigEmailDtoProviderEnumKey;
    /**
     * @type string | undefined
    */
    fromAddress?: string;
    /**
     * @type string | undefined
    */
    replyTo?: string;
    /**
     * @type array
    */
    sendTo: SendToDto[];
    /**
     * @type array | undefined
    */
    bccTo?: SendToDto[];
    /**
     * @type array | undefined
    */
    attachments?: ConfigEmailAttachmentDto[];
    /**
     * @type object | undefined
    */
    payload?: DocumentGenerationConfig;
    /**
     * @type array | undefined
    */
    calculate?: string[];
    /**
     * @type array | undefined
    */
    messageData?: EmailMessageData[];
};

export type YouSignConfig = {
    /**
     * @description The YouSign workspace ID
     * @type string | undefined
    */
    workspaceId?: string;
};

export const rolesProductConfigRoleEnum = {
    TENANT_ACCOUNTING_SUMMARY: "TENANT_ACCOUNTING_SUMMARY",
    POLICY_ADMIN: "POLICY_ADMIN",
    POLICY_EDITOR: "POLICY_EDITOR",
    POLICY_VIEWER: "POLICY_VIEWER",
    PORTFOLIO_VIEWER: "PORTFOLIO_VIEWER",
    POLICY_QUOTER: "POLICY_QUOTER",
    POLICY_SIGNER: "POLICY_SIGNER",
    POLICY_STOPPER: "POLICY_STOPPER",
    POLICY_SUSPENDER: "POLICY_SUSPENDER",
    POLICY_NON_DELEGATED: "POLICY_NON_DELEGATED",
    POLICY_DEROGATION_ADMIN: "POLICY_DEROGATION_ADMIN",
    POLICY_MTA_EDITOR: "POLICY_MTA_EDITOR",
    BRANCH_EDITOR: "BRANCH_EDITOR",
    ASSET_ADMIN: "ASSET_ADMIN",
    ASSET_EDITOR: "ASSET_EDITOR",
    ASSET_VIEWER: "ASSET_VIEWER",
    CUSTOMER_INITIALIZER: "CUSTOMER_INITIALIZER",
    CUSTOMER_ADMIN: "CUSTOMER_ADMIN",
    CUSTOMER_EDITOR: "CUSTOMER_EDITOR",
    CUSTOMER_VIEWER: "CUSTOMER_VIEWER",
    CUSTOMER_INVITE: "CUSTOMER_INVITE",
    INTERNAL_NOTE_ADMIN: "INTERNAL_NOTE_ADMIN",
    PAYMENTS_ADMIN: "PAYMENTS_ADMIN",
    PAYMENTS_EDITOR: "PAYMENTS_EDITOR",
    PAYMENTS_VIEWER: "PAYMENTS_VIEWER",
    PAYMENTS_RETRY_EDITOR: "PAYMENTS_RETRY_EDITOR",
    PAYMENTS_MODE_EDITOR: "PAYMENTS_MODE_EDITOR",
    PAYMENTS_OFFLINE_EDITOR: "PAYMENTS_OFFLINE_EDITOR",
    BROKER_ADMIN: "BROKER_ADMIN",
    BROKER_EDITOR: "BROKER_EDITOR",
    BROKER_VIEWER: "BROKER_VIEWER",
    BROKER_CONFIG_VIEWER: "BROKER_CONFIG_VIEWER",
    EMAIL_ACCOUNT_SHARED_ADMIN: "EMAIL_ACCOUNT_SHARED_ADMIN",
    DISTRIBUTION_REQUEST_VIEWER: "DISTRIBUTION_REQUEST_VIEWER",
    DISTRIBUTION_REQUEST_CREATOR: "DISTRIBUTION_REQUEST_CREATOR",
    DISTRIBUTION_REQUEST_HANDLER: "DISTRIBUTION_REQUEST_HANDLER",
    BROKERAGE_FEE_ADMIN: "BROKERAGE_FEE_ADMIN",
    BROKERAGE_FEE_EDITOR: "BROKERAGE_FEE_EDITOR",
    BROKERAGE_FEE_VIEWER: "BROKERAGE_FEE_VIEWER",
    CLAIMS_ADMIN: "CLAIMS_ADMIN",
    CLAIMS_EDITOR: "CLAIMS_EDITOR",
    CLAIMS_VIEWER: "CLAIMS_VIEWER",
    CLAIMS_MANAGER: "CLAIMS_MANAGER",
    NOTIFICATIONS_ADMIN: "NOTIFICATIONS_ADMIN",
    NOTIFICATIONS_EDITOR: "NOTIFICATIONS_EDITOR",
    NOTIFICATIONS_VIEWER: "NOTIFICATIONS_VIEWER",
    REPORTS_ADMIN: "REPORTS_ADMIN",
    REPORTS_VIEWER: "REPORTS_VIEWER",
    DOCUMENT_GENERATOR: "DOCUMENT_GENERATOR",
    POLICYHOLDER_DOCUMENT_GENERATOR: "POLICYHOLDER_DOCUMENT_GENERATOR",
    METABASE_VIEWER: "METABASE_VIEWER",
    COMPLIANCE_VIEWER: "COMPLIANCE_VIEWER",
    COMPLIANCE_EDITOR: "COMPLIANCE_EDITOR",
    BROKERAGE_FIRM_COMPLIANCE_OVERRIDER: "BROKERAGE_FIRM_COMPLIANCE_OVERRIDER",
    PRODUCT_VIEWER: "PRODUCT_VIEWER",
    HISCOX: "HISCOX",
    SRA: "SRA",
    SIV: "SIV",
    SIREN: "SIREN",
    ADDRESS: "ADDRESS",
    SYDIA: "SYDIA",
    WAKAM: "WAKAM",
    YEET_BROKER: "YEET_BROKER",
    YEET_DRIVEQUANT_AVERAGE: "YEET_DRIVEQUANT_AVERAGE",
    AXECE_BROKER: "AXECE_BROKER",
    AXECE_DRIVEQUANT_AVERAGE: "AXECE_DRIVEQUANT_AVERAGE",
    BIKE_EMPLOYEE_PORTFOLIO: "BIKE_EMPLOYEE_PORTFOLIO",
    CONVERSATION_USER: "CONVERSATION_USER",
    SELF_CLAIMANT: "SELF_CLAIMANT",
    CLAIMS_DECLARANT: "CLAIMS_DECLARANT",
    SPEECH_TO_TEXT_USER: "SPEECH_TO_TEXT_USER"
} as const;

export type RolesProductConfigRoleEnumKey = (typeof rolesProductConfigRoleEnum)[keyof typeof rolesProductConfigRoleEnum];

export type RolesProductConfig = {
    /**
     * @type array
    */
    role: RolesProductConfigRoleEnumKey[];
    /**
     * @type array | undefined
    */
    productIds?: string[];
};

export type BusinessRole = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type array
    */
    roles: RolesProductConfig[];
    /**
     * @type array | undefined
    */
    forbiddenRoles?: RolesProductConfig[];
    customerRole?: (boolean | string[]);
    customerDefault?: (boolean | string[]);
};

export type ValidationRuleDto = {
    /**
     * @type string
    */
    option: string;
    value: (string | number | boolean | string[]);
};

export type DocumentAutoFillDto = {
    /**
     * @description Whether auto-fill is enabled for this field
     * @type boolean
    */
    enabled: boolean;
};

export const brokerageFirmCustomFieldConfigDtoTypeEnum = {
    BOOLEAN: "BOOLEAN",
    STRING: "STRING",
    NUMBER: "NUMBER",
    INTEGER: "INTEGER",
    ENUM: "ENUM",
    DATE: "DATE",
    DATETIME: "DATETIME",
    PHONE_NUMBER: "PHONE_NUMBER",
    EMAIL: "EMAIL",
    REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
    SIRET: "SIRET",
    POSTCODE: "POSTCODE",
    URL: "URL",
    IBAN: "IBAN",
    BIC: "BIC",
    ARRAY: "ARRAY"
} as const;

export type BrokerageFirmCustomFieldConfigDtoTypeEnumKey = (typeof brokerageFirmCustomFieldConfigDtoTypeEnum)[keyof typeof brokerageFirmCustomFieldConfigDtoTypeEnum];

export type BrokerageFirmCustomFieldConfigDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    type: BrokerageFirmCustomFieldConfigDtoTypeEnumKey;
    /**
     * @type array | undefined
    */
    validationRules?: ValidationRuleDto[];
    /**
     * @description The field is filled from an external source — a company registry, a vehicle registry, a telematics profile — and a value you send for it is replaced by the integration\'s.
     * @type string | undefined
    */
    integrationKey?: string;
    /**
     * @description Extraction source categories that map to this field
     * @type array | undefined
    */
    extractionSources?: string[];
    /**
     * @description Field key used in extraction prompt output
     * @type string | undefined
    */
    extractionFieldKey?: string;
    /**
     * @description Auto-fill configuration for this field
    */
    autoFill?: DocumentAutoFillDto;
};

export type ConfigCommonDocumentDto = {
    /**
     * @type string
    */
    type: string;
};

export const signatureRequestReminderSettingsDelayEnum = {
    "1": 1,
    "2": 2,
    "7": 7,
    "14": 14
} as const;

export type SignatureRequestReminderSettingsDelayEnumKey = (typeof signatureRequestReminderSettingsDelayEnum)[keyof typeof signatureRequestReminderSettingsDelayEnum];

export type SignatureRequestReminderSettings = {
    /**
     * @description the delay between reminders, in days
     * @type number
    */
    delay: SignatureRequestReminderSettingsDelayEnumKey;
    /**
     * @description the maximum number of reminders
     * @minLength 1
     * @maxLength 10
     * @type number
    */
    maxAttempts: number;
};

export type ConfigSignedDocumentAnchorDto = {
    /**
     * @type object
    */
    page: object;
    /**
     * @type number
    */
    x: number;
    /**
     * @type number
    */
    y: number;
    /**
     * @type number
    */
    height: number;
    /**
     * @type number
    */
    width: number;
};

export type ConfigSignedDocumentMentionDto = {
    /**
     * @type object
    */
    page: object;
    /**
     * @type number
    */
    x: number;
    /**
     * @type number
    */
    y: number;
    /**
     * @type number | undefined
    */
    width?: number;
    /**
     * @type string
    */
    mention: string;
};

export type ConfigSignedDocumentTextDto = {
    /**
     * @type object
    */
    page: object;
    /**
     * @type number
    */
    x: number;
    /**
     * @type number
    */
    y: number;
    /**
     * @type number
    */
    width: number;
    /**
     * @type number | undefined
    */
    height?: number;
    /**
     * @type number
    */
    maxLength: number;
    /**
     * @type string
    */
    question: string;
    /**
     * @type string | undefined
    */
    instruction?: string;
    /**
     * @type boolean | undefined
    */
    optional?: boolean;
};

export type ConfigSignedDocumentCheckboxDto = {
    /**
     * @type object
    */
    page: object;
    /**
     * @type number
    */
    x: number;
    /**
     * @type number
    */
    y: number;
    /**
     * @type number
    */
    size: number;
    /**
     * @type string
    */
    name: string;
    /**
     * @type boolean | undefined
    */
    optional?: boolean;
    /**
     * @type boolean | undefined
    */
    checked?: boolean;
};

export const signerConfigItemDtoRecipientEnum = {
    BROKER: "BROKER",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    WHOLESALE_BROKER: "WHOLESALE_BROKER",
    USER: "USER",
    AUTHOR: "AUTHOR",
    INVOICE_PAYER: "INVOICE_PAYER",
    EMAIL: "EMAIL"
} as const;

export type SignerConfigItemDtoRecipientEnumKey = (typeof signerConfigItemDtoRecipientEnum)[keyof typeof signerConfigItemDtoRecipientEnum];

export const signerConfigItemDtoDisplayAsEnum = {
    BROKER: "BROKER",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    WHOLESALE_BROKER: "WHOLESALE_BROKER",
    USER: "USER",
    AUTHOR: "AUTHOR",
    INVOICE_PAYER: "INVOICE_PAYER",
    EMAIL: "EMAIL"
} as const;

export type SignerConfigItemDtoDisplayAsEnumKey = (typeof signerConfigItemDtoDisplayAsEnum)[keyof typeof signerConfigItemDtoDisplayAsEnum];

export type SignerConfigItemDto = {
    /**
     * @type string
    */
    recipient: SignerConfigItemDtoRecipientEnumKey;
    /**
     * @type string | undefined
    */
    displayAs?: SignerConfigItemDtoDisplayAsEnumKey;
    /**
     * @type string | undefined
    */
    role?: string;
    /**
     * @type object | undefined
    */
    anchor?: ConfigSignedDocumentAnchorDto;
    /**
     * @type array | undefined
    */
    mentions?: ConfigSignedDocumentMentionDto[];
    /**
     * @type array | undefined
    */
    texts?: ConfigSignedDocumentTextDto[];
    /**
     * @type array | undefined
    */
    checkboxes?: ConfigSignedDocumentCheckboxDto[];
};

export type SepaMandateSignatureConfig = {
    /**
     * @description When set, this entry targets only the generated document whose configName matches. Allows different signature positions for multiple generated documents sharing the same documentType.
     * @type string | undefined
    */
    configName?: string;
    /**
     * @type array | undefined
    */
    signers?: SignerConfigItemDto[];
    /**
     * @type object | undefined
    */
    anchor?: ConfigSignedDocumentAnchorDto;
    /**
     * @type array | undefined
    */
    mentions?: ConfigSignedDocumentMentionDto[];
    /**
     * @type array | undefined
    */
    texts?: ConfigSignedDocumentTextDto[];
    /**
     * @type array | undefined
    */
    checkboxes?: ConfigSignedDocumentCheckboxDto[];
};

export type PaymentMethodConfigDto = {
    /**
     * @type object | undefined
    */
    mandateDocument?: ConfigGeneratedDocumentCarboneDto;
    /**
     * @type object | undefined
    */
    reminders?: SignatureRequestReminderSettings;
    /**
     * @type object | undefined
    */
    mandateSignature?: SepaMandateSignatureConfig;
};

export const configSignedDocumentDtoSignatureEnum = {
    VIEW: "VIEW",
    SIGN: "SIGN"
} as const;

export type ConfigSignedDocumentDtoSignatureEnumKey = (typeof configSignedDocumentDtoSignatureEnum)[keyof typeof configSignedDocumentDtoSignatureEnum];

export type ConfigSignedDocumentDto = {
    /**
     * @type string
    */
    signature: ConfigSignedDocumentDtoSignatureEnumKey;
    /**
     * @description When set, this entry targets only the generated document whose configName matches. Allows different signature positions for multiple generated documents sharing the same documentType.
     * @type string | undefined
    */
    configName?: string;
    /**
     * @type array | undefined
    */
    signers?: SignerConfigItemDto[];
    /**
     * @type object | undefined
    */
    anchor?: ConfigSignedDocumentAnchorDto;
    /**
     * @type array | undefined
    */
    mentions?: ConfigSignedDocumentMentionDto[];
    /**
     * @type array | undefined
    */
    texts?: ConfigSignedDocumentTextDto[];
    /**
     * @type array | undefined
    */
    checkboxes?: ConfigSignedDocumentCheckboxDto[];
    /**
     * @type string
    */
    type: string;
};

export type BrokerageFirmSignatureConfigDto = {
    /**
     * @type object | undefined
    */
    reminders?: SignatureRequestReminderSettings;
    /**
     * @type array | undefined
    */
    signedDocuments?: ConfigSignedDocumentDto[];
};

export const distributionRequestContractConfigDtoProviderEnum = {
    CraftMyPdf: "CraftMyPdf",
    Carbone: "Carbone",
    ReactPdf: "ReactPdf",
    Static: "Static"
} as const;

export type DistributionRequestContractConfigDtoProviderEnumKey = (typeof distributionRequestContractConfigDtoProviderEnum)[keyof typeof distributionRequestContractConfigDtoProviderEnum];

export type DistributionRequestContractConfigDto = {
    /**
     * @type string
    */
    templateId: string;
    /**
     * @type object
    */
    signature: ConfigSignedDocumentDto;
    /**
     * @description Document generation provider to use for this distribution contract
     * @type string
    */
    provider: DistributionRequestContractConfigDtoProviderEnumKey;
};

export type DistributionRequestConfigDto = {
    /**
     * @type boolean
    */
    approveOnSignature: boolean;
    /**
     * @type object | undefined
    */
    contractConfig?: DistributionRequestContractConfigDto;
};

export type ExtractionFieldConfigDto = {
    /**
     * @description Field key to extract
     * @type string
    */
    key: string;
    /**
     * @description Field type (e.g. STRING, DATE, NUMBER, string[])
     * @type string
    */
    type: string;
    /**
     * @description Instructions for reading this field from the document
     * @type string | undefined
    */
    description?: string;
    /**
     * @description Require this output key, returning an empty string or array when absent
     * @type boolean | undefined
    */
    required?: boolean;
    /**
     * @description Which sides of a document this field appears on
     * @type array | undefined
    */
    sides?: string[];
};

export const fieldValidationReferenceDtoRefEnum = {
    NOW: "NOW",
    FIELD: "FIELD",
    LITERAL: "LITERAL"
} as const;

export type FieldValidationReferenceDtoRefEnumKey = (typeof fieldValidationReferenceDtoRefEnum)[keyof typeof fieldValidationReferenceDtoRefEnum];

export type FieldValidationReferenceDto = {
    /**
     * @description Reference type
     * @type string
    */
    ref: FieldValidationReferenceDtoRefEnumKey;
    /**
     * @description Field key when ref is FIELD
     * @type string | undefined
    */
    fieldKey?: string;
    /**
     * @description Literal value when ref is LITERAL (e.g. ISO date string)
     * @type string | undefined
    */
    value?: string;
};

export const fieldValidationDurationDtoUnitEnum = {
    MONTH: "MONTH",
    DAY: "DAY",
    YEAR: "YEAR"
} as const;

export type FieldValidationDurationDtoUnitEnumKey = (typeof fieldValidationDurationDtoUnitEnum)[keyof typeof fieldValidationDurationDtoUnitEnum];

export type FieldValidationDurationDto = {
    /**
     * @description Duration amount
     * @type number
    */
    amount: number;
    /**
     * @description Duration unit
     * @type string
    */
    unit: FieldValidationDurationDtoUnitEnumKey;
};

export const fieldValidationRuleConfigOperatorEnum = {
    DATE_IS_AFTER: "DATE_IS_AFTER",
    DATE_IS_BEFORE: "DATE_IS_BEFORE",
    DATE_IS_NOT_OLDER_THAN: "DATE_IS_NOT_OLDER_THAN",
    DATE_IS_NOT_NEWER_THAN: "DATE_IS_NOT_NEWER_THAN",
    STRING_MATCHES: "STRING_MATCHES",
    STRING_EQUALS: "STRING_EQUALS",
    STRING_NOT_EMPTY: "STRING_NOT_EMPTY",
    NUMBER_GT: "NUMBER_GT",
    NUMBER_LT: "NUMBER_LT",
    NUMBER_BETWEEN: "NUMBER_BETWEEN"
} as const;

export type FieldValidationRuleConfigOperatorEnumKey = (typeof fieldValidationRuleConfigOperatorEnum)[keyof typeof fieldValidationRuleConfigOperatorEnum];

export type FieldValidationRuleConfig = {
    /**
     * @description Extracted field key to validate
     * @type string
    */
    fieldKey: string;
    /**
     * @description Validation operator
     * @type string
    */
    operator: FieldValidationRuleConfigOperatorEnumKey;
    /**
     * @description Reference for date comparison
    */
    reference?: FieldValidationReferenceDto;
    /**
     * @description Duration for relative date operators
    */
    duration?: FieldValidationDurationDto;
    /**
     * @description Regex pattern for STRING_MATCHES
     * @type string | undefined
    */
    pattern?: string;
    /**
     * @description Expected value for STRING_EQUALS (case insensitive)
     * @type string | undefined
    */
    expectedValue?: string;
    /**
     * @description Numeric value for NUMBER_GT / NUMBER_LT
     * @type number | undefined
    */
    numericValue?: number;
    /**
     * @description Min value for NUMBER_BETWEEN
     * @type number | undefined
    */
    numericMin?: number;
    /**
     * @description Max value for NUMBER_BETWEEN
     * @type number | undefined
    */
    numericMax?: number;
    /**
     * @description Human-readable failure message
     * @type string | undefined
    */
    errorMessage?: string;
};

export const documentValidityRuleDtoTypeEnum = {
    READABLE: "READABLE",
    REQUIRED_FIELDS: "REQUIRED_FIELDS",
    PROMPT: "PROMPT",
    FIELD_VALIDATION: "FIELD_VALIDATION"
} as const;

export type DocumentValidityRuleDtoTypeEnumKey = (typeof documentValidityRuleDtoTypeEnum)[keyof typeof documentValidityRuleDtoTypeEnum];

export type DocumentValidityRuleDto = {
    /**
     * @description Validity rule type
     * @type string
    */
    type: DocumentValidityRuleDtoTypeEnumKey;
    /**
     * @description Prompt slug for PROMPT rule type
     * @type string | undefined
    */
    promptSlug?: string;
    /**
     * @description Required field keys for REQUIRED_FIELDS rule type
     * @type array | undefined
    */
    requiredFields?: any[][];
    /**
     * @description Validation rules for FIELD_VALIDATION rule type
     * @type array | undefined
    */
    validations?: FieldValidationRuleConfig[];
};

export type ConfigBrokerageFirmDocumentDto = {
    /**
     * @type string
    */
    category: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
    /**
     * @description Human-readable name for this document category, shown to the brokerage firm. Falls back to the raw category code when absent.
     * @type string | undefined
    */
    label?: string;
    /**
     * @type boolean | undefined
    */
    allowMultiple?: boolean;
    /**
     * @description Fields to extract from this document category
     * @type array | undefined
    */
    extractionFields?: ExtractionFieldConfigDto[];
    /**
     * @description Validity rules for this document category
     * @type array | undefined
    */
    validity?: DocumentValidityRuleDto[];
    /**
     * @type array | undefined
    */
    filters?: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilters?: FilterDto[];
};

export type BrokerageFirmDocumentsConfigDto = {
    /**
     * @type array
    */
    brokerageFirmDocumentsList: ConfigBrokerageFirmDocumentDto[];
    /**
     * @type array | undefined
    */
    signatureDocumentsList?: ConfigBrokerageFirmDocumentDto[];
};

export const documentPrefillConfigDtoPolicyholderDefaultChoiceEnum = {
    upload: "upload",
    later: "later"
} as const;

export type DocumentPrefillConfigDtoPolicyholderDefaultChoiceEnumKey = (typeof documentPrefillConfigDtoPolicyholderDefaultChoiceEnum)[keyof typeof documentPrefillConfigDtoPolicyholderDefaultChoiceEnum];

export const documentPrefillConfigDtoBrokerageFirmDefaultChoiceEnum = {
    upload: "upload",
    later: "later"
} as const;

export type DocumentPrefillConfigDtoBrokerageFirmDefaultChoiceEnumKey = (typeof documentPrefillConfigDtoBrokerageFirmDefaultChoiceEnum)[keyof typeof documentPrefillConfigDtoBrokerageFirmDefaultChoiceEnum];

export type DocumentPrefillConfigDto = {
    /**
     * @description Default choice on the policyholder discovery funnel
     * @type string | undefined
    */
    policyholderDefaultChoice?: DocumentPrefillConfigDtoPolicyholderDefaultChoiceEnumKey;
    /**
     * @description Default choice on the brokerage firm signup funnel
     * @type string | undefined
    */
    brokerageFirmDefaultChoice?: DocumentPrefillConfigDtoBrokerageFirmDefaultChoiceEnumKey;
};

export type PolicyDocumentFraudDetectionConfigDto = {
    /**
     * @description Scan policy supporting documents for fraud (in-house provider).
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Products whose policy documents are never scanned.
     * @type array | undefined
    */
    excludedProductIds?: string[];
    /**
     * @description Policyholder document categories that are never scanned.
     * @type array | undefined
    */
    excludedDocumentCategories?: string[];
};

export type BrokerageFirmDocumentFraudDetectionConfigDto = {
    /**
     * @description Scan brokerage firm onboarding documents for fraud (in-house provider).
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Brokerage firm document categories that are never scanned.
     * @type array | undefined
    */
    excludedDocumentCategories?: string[];
};

export const reportConfigDtoTypeEnum = {
    WORKFLOWS: "WORKFLOWS",
    POLICY_EXPORT: "POLICY_EXPORT",
    INVOICE_EXPORT: "INVOICE_EXPORT",
    BROKERAGE_FIRM_EXPORT: "BROKERAGE_FIRM_EXPORT",
    CLAIMS_EXPORT: "CLAIMS_EXPORT",
    COMMISSION_TRANSFER: "COMMISSION_TRANSFER",
    COMMISSION_TRANSFER_DETAIL: "COMMISSION_TRANSFER_DETAIL",
    YEET_VTC_IMA_ASSISTANCE: "YEET_VTC_IMA_ASSISTANCE",
    YEET_VTC_CASH_STATEMENT: "YEET_VTC_CASH_STATEMENT",
    YEET_VTC_POLICIES_V2: "YEET_VTC_POLICIES_V2",
    YEET_VTC_POLICY_PARTY: "YEET_VTC_POLICY_PARTY",
    YEET_VTC_KPI: "YEET_VTC_KPI",
    YEET_VTC_POLICY_INVOICE: "YEET_VTC_POLICY_INVOICE",
    YEET_VTC_POLICY_INVOICE_WAKAM: "YEET_VTC_POLICY_INVOICE_WAKAM",
    YEET_FVA_EXPORT: "YEET_FVA_EXPORT",
    YEET_STARTED_UNPAID_POLICIES: "YEET_STARTED_UNPAID_POLICIES",
    GARANTIE_PLUS_SALES_REPORT: "GARANTIE_PLUS_SALES_REPORT",
    GARANTIE_PLUS_SALES_RECAP_BY_GARAGE: "GARANTIE_PLUS_SALES_RECAP_BY_GARAGE",
    GARANTIE_PLUS_CAREA_CASH_STATEMENT: "GARANTIE_PLUS_CAREA_CASH_STATEMENT",
    GARANTIE_PLUS_CAAREA_DAILY_REPORT: "GARANTIE_PLUS_CAAREA_DAILY_REPORT",
    AXECE_POLICY: "AXECE_POLICY",
    AXECE_POLICY_INVOICE: "AXECE_POLICY_INVOICE",
    AXECE_POLICY_PARTY: "AXECE_POLICY_PARTY",
    AXECE_KPI: "AXECE_KPI",
    AXECE_MRPRO_KPI: "AXECE_MRPRO_KPI",
    AXECE_POLICY_INVOICE_WAKAM: "AXECE_POLICY_INVOICE_WAKAM",
    AXECE_VTC_IMA_ASSISTANCE: "AXECE_VTC_IMA_ASSISTANCE",
    AXECE_COMMISSION: "AXECE_COMMISSION",
    AXECE_BROKERAGE_FIRM_POLICIES: "AXECE_BROKERAGE_FIRM_POLICIES",
    AXECE_CASH_STATEMENT: "AXECE_CASH_STATEMENT",
    AXECE_MRPRO_POLICY: "AXECE_MRPRO_POLICY",
    AXECE_FVA_EXPORT: "AXECE_FVA_EXPORT",
    AXECE_STARTED_UNPAID_POLICIES: "AXECE_STARTED_UNPAID_POLICIES",
    ACCELERANT_VTC_IMA_ASSISTANCE: "ACCELERANT_VTC_IMA_ASSISTANCE",
    TUTASSUR_MILA_PNO_ASSUREUR_EXPORT: "TUTASSUR_MILA_PNO_ASSUREUR_EXPORT",
    TUTASSUR_MILA_MRH_ASSUREUR_EXPORT: "TUTASSUR_MILA_MRH_ASSUREUR_EXPORT",
    TUTASSUR_AXA_PORTFOLIO_EXPORT: "TUTASSUR_AXA_PORTFOLIO_EXPORT",
    TUTASSUR_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_COMPANY_STATEMENT: "TUTASSUR_COMPANY_STATEMENT",
    TUTASSUR_BROKER_STATEMENT: "TUTASSUR_BROKER_STATEMENT",
    TUTASSUR_CASH_STATEMENT: "TUTASSUR_CASH_STATEMENT",
    TUTASSUR_HISCOX_COLLECTED_PREMIUMS: "TUTASSUR_HISCOX_COLLECTED_PREMIUMS",
    TUTASSUR_HISCOX_UNPAID_PREMIUMS: "TUTASSUR_HISCOX_UNPAID_PREMIUMS",
    TUTASSUR_HISCOX_BORDEREAU_PRODUCTION: "TUTASSUR_HISCOX_BORDEREAU_PRODUCTION",
    TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_PJPRO_CFDP_MTA_EXPORT: "TUTASSUR_PJPRO_CFDP_MTA_EXPORT",
    TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT: "TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT",
    EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_ACCOUNTING_STATEMENT: "EGA_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT",
    EGA_RCPRO_ACCOUNTING_STATEMENT: "EGA_RCPRO_ACCOUNTING_STATEMENT",
    EGA_RCPRO_MADP_EXPORT: "EGA_RCPRO_MADP_EXPORT",
    EGA_CASH_STATEMENT: "EGA_CASH_STATEMENT",
    EGA_RETAIL_PERFORMANCE: "EGA_RETAIL_PERFORMANCE",
    EGA_TEAM_PERFORMANCE: "EGA_TEAM_PERFORMANCE",
    LUKO_MRH_POLICY: "LUKO_MRH_POLICY",
    LUKO_MRH_POLICY_INVOICE_WAKAM: "LUKO_MRH_POLICY_INVOICE_WAKAM",
    LUKO_MRH_POLICY_PAYMENT_WAKAM: "LUKO_MRH_POLICY_PAYMENT_WAKAM",
    LUKO_MRH_KPI: "LUKO_MRH_KPI",
    LUKO_CASH_STATEMENT: "LUKO_CASH_STATEMENT",
    ASSUREQUINE_CASH_STATEMENT: "ASSUREQUINE_CASH_STATEMENT",
    ASSUREQUINE_PORTFOLIO_STATEMENT: "ASSUREQUINE_PORTFOLIO_STATEMENT",
    ASSUREQUINE_PREMIUM_STATEMENT: "ASSUREQUINE_PREMIUM_STATEMENT",
    ARCHIMEDE_CFDP_MSG002_STOCK: "ARCHIMEDE_CFDP_MSG002_STOCK",
    ARCHIMEDE_CFDP_MSG002_STOCK_CSV: "ARCHIMEDE_CFDP_MSG002_STOCK_CSV",
    PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT: "PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT",
    PLEBAGNAC_CFDP_STATEMENT: "PLEBAGNAC_CFDP_STATEMENT",
    PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT: "PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT",
    PLEBAGNAC_MSC_SCOOTER_STATEMENT: "PLEBAGNAC_MSC_SCOOTER_STATEMENT",
    PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT: "PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT"
} as const;

export type ReportConfigDtoTypeEnumKey = (typeof reportConfigDtoTypeEnum)[keyof typeof reportConfigDtoTypeEnum];

export type ReportConfigDto = {
    /**
     * @type string
    */
    type: ReportConfigDtoTypeEnumKey;
    /**
     * @type array
    */
    columnsMapping: object[];
    /**
     * @description If not set, all products are available
     * @type array | undefined
    */
    availableProductIds?: string[];
    /**
     * @description If not set, no business role can access
     * @type array | undefined
    */
    allowedBusinessRoles?: string[];
    /**
     * @description Only an automation may generate it; listing and download stay open
     * @type boolean | undefined
    */
    automationOnly?: boolean;
    /**
     * @type array | undefined
    */
    automations?: object[];
};

export type MetabaseDashboardTabConfig = {
    /**
     * @description i18n key for the tab name
     * @type string
    */
    name: string;
    /**
     * @description Metabase dashboard ID for this tab
     * @type number
    */
    dashboardId: number;
    /**
     * @description Business role names that can access this tab
     * @type array
    */
    forTypes: string[];
    /**
     * @description Locked parameters to pass to the Metabase static embed JWT
     * @type object | undefined
    */
    params?: {
        [key: string]: any;
    };
    /**
     * @description Locked Metabase parameter receiving the caller brokerage firm ids (own firm + descendants); super users send [] (unfiltered), callers without a firm are denied
     * @type string | undefined
    */
    brokerageFirmParameter?: string;
};

export type AIModelsConfig = {
    /**
     * @description Bedrock model or inference profile id for document classification. Defaults to MODELS.PRIMARY_CLASSIFIER.
     * @minLength 1
     * @type string | undefined
    */
    classifier?: string;
    /**
     * @description Bedrock model or inference profile id for document field extraction. Defaults to MODELS.EXTRACTOR.
     * @minLength 1
     * @type string | undefined
    */
    extractor?: string;
};

export type AIClassificationJudgeConfig = {
    /**
     * @description Judge model identifier (fast or quality)
     * @type string
    */
    model: string;
    /**
     * @description Whether this judge is enabled
     * @type boolean
    */
    enabled: boolean;
};

export type AIClassificationInterfaceConfig = {
    /**
     * @description Whether AI classification is enabled for this interface
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description System prompt template slug
     * @type string
    */
    systemPromptSlug: string;
    /**
     * @description Judge prompt template slug
     * @type string
    */
    judgePromptSlug: string;
    /**
     * @description Judge configurations
     * @type array
    */
    judges: AIClassificationJudgeConfig[];
};

export type AIClassificationInterfacesConfig = {
    /**
     * @type object | undefined
    */
    policyholderDashboard?: AIClassificationInterfaceConfig;
    /**
     * @type object | undefined
    */
    brokerageFirmDocuments?: AIClassificationInterfaceConfig;
    /**
     * @type object | undefined
    */
    nonDelegatedDocuments?: AIClassificationInterfaceConfig;
    /**
     * @type object | undefined
    */
    fnolDocuments?: AIClassificationInterfaceConfig;
};

export type AIClassificationConfig = {
    /**
     * @description Master switch for AI classification
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Per-interface configuration
    */
    interfaces: AIClassificationInterfacesConfig;
};

export type AIExtractionConfig = {
    /**
     * @description Whether AI extraction is enabled
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Extraction prompt template slug
     * @type string | undefined
    */
    promptSlug?: string;
};

export type AIValidityConfig = {
    /**
     * @description Whether AI validity checking is enabled
     * @type boolean
    */
    enabled: boolean;
};

export type AIAutofillConfig = {
    /**
     * @description Whether AI autofill is enabled
     * @type boolean
    */
    enabled: boolean;
};

export type ClaimDocClassifierConfig = {
    /**
     * @description Whether the claim document classifier is enabled for this product. When true and an entityId is supplied with the classify call, the classifier loads the claim\'s ClaimDocumentRef list, runs buildClaimClassificationContext, and invokes classificationPromptSlug with the expected-docs list as an injected variable. The classifier returns the matching insurer code; downstream extraction uses the category-specific slug from CLAIM_DOC_CATEGORY_TO_PROMPT_SLUG. When no entityId is supplied, the classic AIClassificationInterfaceConfig path runs unchanged.
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Prompt slug for the claim doc classifier (resolved from the in-code PromptLibrary). The prompt receives `expected_docs` (list of {code, libelle, category, extractionPromptSlug} for the claim) as an injected variable and returns the code that matches the uploaded document. Example: \'document-classification-<tenant>-claim\'.
     * @type string
    */
    classificationPromptSlug: string;
    /**
     * @description Partner-specific document code → ClaimDocCategory registry. Used by the partner integration at bootstrap to stamp `category` onto each required document slot, and (when present) lets downstream consumers resolve a code without an out-of-band table lookup. Each value must be a ClaimDocCategory enum value.
     * @type object | undefined
    */
    claimDocCodeToCategory?: object;
};

export type ClaimDocExtractorConfig = {
    /**
     * @description Whether claim document extraction for business prefill is enabled for this product.
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Prompt slug for the claim doc extractor (resolved from the in-code PromptLibrary, under prompts/library/document-extraction/). Receives {category, claimType, fields} variables. Example: \'claim-doc-extraction-<tenant>-v1\'.
     * @type string
    */
    promptSlug: string;
};

export const AIConfigDocumentVerdictEnum = {
    manual: "manual",
    automatic: "automatic"
} as const;

export type AIConfigDocumentVerdictEnumKey = (typeof AIConfigDocumentVerdictEnum)[keyof typeof AIConfigDocumentVerdictEnum];

export type AIConfig = {
    /**
     * @description Per-tenant/product model choice for document classification and extraction
    */
    models?: AIModelsConfig;
    /**
     * @description AI classification config
    */
    classification?: AIClassificationConfig;
    /**
     * @description AI extraction config
    */
    extraction?: AIExtractionConfig;
    /**
     * @description AI validity config
    */
    validity?: AIValidityConfig;
    /**
     * @description AI autofill config
    */
    autofill?: AIAutofillConfig;
    /**
     * @description automatic: the system accepts an undecided document whose verdict is CONFORM
     * @type string | undefined
    */
    documentVerdict?: AIConfigDocumentVerdictEnumKey;
    /**
     * @description Code-based claim document classifier config (opt-in per product)
    */
    claimDocClassifier?: ClaimDocClassifierConfig;
    /**
     * @description Claim document field extractor config (opt-in per product)
    */
    claimDocExtractor?: ClaimDocExtractorConfig;
    /**
     * @description System prompt for in-app AI conversation
     * @type string | undefined
    */
    conversationSystemPrompt?: string;
};

export const tenantThemeConfigDtoColorSchemeEnum = {
    light: "light",
    dark: "dark",
    auto: "auto"
} as const;

export type TenantThemeConfigDtoColorSchemeEnumKey = (typeof tenantThemeConfigDtoColorSchemeEnum)[keyof typeof tenantThemeConfigDtoColorSchemeEnum];

export type TenantThemeConfigDto = {
    /**
     * @description Primary brand color. Accepts either a single hex string (expanded to a 10-shade Mantine palette via @mantine/colors-generator, with shade 6 forced to the input hex for exact brand match) or a pre-built 10-shade tuple (lightest to darkest) when manual control is required.
    */
    primaryColor: (string | string[]);
    /**
     * @description Logo URL for light mode
     * @type string
    */
    logo: string;
    /**
     * @description Logo URL for dark mode
     * @type string | undefined
    */
    logoDark?: string;
    /**
     * @description Favicon URL
     * @type string
    */
    favicon: string;
    /**
     * @description Force a color scheme for this tenant
     * @type string | undefined
    */
    colorScheme?: TenantThemeConfigDtoColorSchemeEnumKey;
    /**
     * @description Optional named secondary brand colors. Each value is either a single hex string (auto-expanded) or a 10-shade tuple. Keys become Mantine color names usable via `<Button color=\"key\" />`. Reserved keys `brand` and `gray` are ignored to protect the primary palette and neutral ramp.
     * @type object | undefined
    */
    secondaryColors?: object;
};

export type ExternalScriptConfigDto = {
    /**
     * @description Stable id — used as the script tag id and de-dupe key.
     * @type string
    */
    id: string;
    /**
     * @description Absolute URL of the script to load.
     * @type string
    */
    src: string;
    /**
     * @description Render as <script async>. Defaults to true.
     * @type boolean | undefined
    */
    async?: boolean;
    /**
     * @description Render as <script defer>.
     * @type boolean | undefined
    */
    defer?: boolean;
    /**
     * @description Arbitrary data-* attributes (key without the \"data-\" prefix). Used by vendor loaders — an embed script typically reads data-key, data-domain and data-consent.
     * @type object | undefined
    */
    dataAttributes?: object;
    /**
     * @description When true, the frontend loader mints a fresh RS256 JWT from the Korint widget endpoint (with the user\'s Cognito Bearer) before injecting the script, then stamps the JWT as `data-init-token=<jwt>` on the tag.
     * @type boolean | undefined
    */
    requiresInitToken?: boolean;
};

export type TenantMfaConfigDto = {
    /**
     * @description Whether the authenticator app (TOTP) MFA method is offered.
     * @type boolean | undefined
    */
    authenticator?: boolean;
    /**
     * @description Whether SMS is offered as an MFA method. Set false when the tenant\'s Cognito pool has no working SMS configuration yet.
     * @type boolean | undefined
    */
    sms?: boolean;
};

export type TenantAuthenticationConfigDto = {
    /**
     * @description Cognito User Pool ID
     * @type string
    */
    cognitoUserPoolId: string;
    /**
     * @description Cognito User Pool Web Client ID
     * @type string
    */
    cognitoUserPoolClientId: string;
    /**
     * @description Cognito OAuth domain
     * @type string
    */
    cognitoDomain: string;
    /**
     * @description Which MFA methods this tenant\'s Cognito pool requires. Presence of at least one enabled method turns on the post-login MFA setup/challenge flow; the frontend collects a phone number at sign-up when sms is enabled.
    */
    mfa?: TenantMfaConfigDto;
};

export const externalIdentityProviderEnum = {
    ALPTIS_CONNECT: "ALPTIS_CONNECT"
} as const;

export type ExternalIdentityProviderEnumKey = (typeof externalIdentityProviderEnum)[keyof typeof externalIdentityProviderEnum];

/**
 * @description The identity provider this tenant\'s brokers log in with
*/
export type ExternalIdentityProvider = ExternalIdentityProviderEnumKey;

export type TenantFederationConfigDto = {
    /**
     * @description The identity provider this tenant\'s brokers log in with
    */
    provider: ExternalIdentityProvider;
    /**
     * @description Network the provider must assert; any other value is refused
     * @type string
    */
    network: string;
    /**
     * @description Provider role → business role id; a role absent from this map is refused
     * @type object
    */
    brokerRoles: {
        [key: string]: string;
    };
    /**
     * @description Landing paths a login may target; \'/\' is exact, others match path prefixes
     * @type array
    */
    targets: string[];
    /**
     * @description WHOLESALE brokerage firm that parents the firms provisioned at login
     * @type string
    */
    wholesaleBrokerageFirmId: string;
    /**
     * @description Provider scope → product id it entitles; unmapped scopes entitle nothing
     * @type object
    */
    productScopes: {
        [key: string]: string;
    };
};

export const korintTenantConfigDtoBrokerRolesOnBrokerageFirmCreationEnum = {
    RETAIL: "RETAIL"
} as const;

export type KorintTenantConfigDtoBrokerRolesOnBrokerageFirmCreationEnumKey = (typeof korintTenantConfigDtoBrokerRolesOnBrokerageFirmCreationEnum)[keyof typeof korintTenantConfigDtoBrokerRolesOnBrokerageFirmCreationEnum];

export const korintTenantConfigDtoSignDistributionRequestOnEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type KorintTenantConfigDtoSignDistributionRequestOnEnumKey = (typeof korintTenantConfigDtoSignDistributionRequestOnEnum)[keyof typeof korintTenantConfigDtoSignDistributionRequestOnEnum];

export type KorintTenantConfigDto = {
    /**
     * @description Output language for fraud-detection AI results (ISO 639-1). Defaults to \"fr\" when unset.
     * @type string | undefined
    */
    language?: string;
    /**
     * @description Policy-stop behaviour shared by every product of this tenant.
    */
    stop?: ConfigPolicyStop;
    /**
     * @description Speech-to-text (dictation) config. When set, dictation is enabled for this tenant; when absent, dictation is off. Exposed in the public tenant config so the frontend can gate the mic.
    */
    speechToText?: SpeechToTextConfig;
    /**
     * @description External links (attestations, notices, legal pages, …) rendered in the tenant frontend on the login page, the home page and the sidebar. Exposed in the public tenant config.
     * @type array | undefined
    */
    externalLinks?: TenantExternalLinkDto[];
    /**
     * @description Claims-portal capabilities and content for the tenant frontend (legacy-platform notice, WhatsApp entry point, claims-platform contact details). Exposed in the public tenant config so the frontend gates on capabilities rather than on the tenant id. Whether the self-service claim funnel exists is a property of the claims product, not the tenant — see `isSelfServiceClaimIntakeEnabled` on the public product config.
    */
    claimsPortal?: ClaimsPortalConfigDto;
    /**
     * @description Human-readable tenant name shown to end users in the tenant frontend. Falls back to the technical tenant ID when unset.
     * @type string | undefined
    */
    displayName?: string;
    /**
     * @description Commission statements cover invoice events from this instant onwards, and never earlier. The issuer re-picks any event it has not settled yet, so without this floor the first run would pay the whole history. Unset means the tenant issues no commission statement.
     * @type string | undefined
    */
    commissionStatementsStartedAt?: string;
    /**
     * @description Commission statements pay the retail fees without their VAT: a fee charged without a tax line is deemed to include 20%. Unset pays them as charged.
     * @type boolean | undefined
    */
    commissionStatementsFeesExcludingTaxes?: boolean;
    /**
     * @description Template of the annual tax declaration. Deliberately not a `generatedDocuments` entry: that list is what `listDocuments` derives its categories from, and this document is read from the Commissions view by its own metadata rather than from the documents list. Unset means the tenant issues no declaration.
    */
    annualCommissionDocument?: ConfigAnnualCommissionDocumentDto;
    /**
     * @type array | undefined
    */
    domains?: string[];
    /**
     * @description The Cognito Userpool ID
     * @type string | undefined
    */
    cognitoUserPoolId?: string;
    /**
     * @description Emails specific configuration
    */
    emailsConfig?: EmailsConfig;
    /**
     * @type array | undefined
    */
    emails?: ConfigEmailDto[];
    /**
     * @type string
    */
    stripeAccountId: string;
    /**
     * @type string | undefined
    */
    stripeApiKey?: string;
    /**
     * @type string | undefined
    */
    stripeWebhookSecret?: string;
    /**
     * @type string | undefined
    */
    stripeConnectWebhookSecret?: string;
    /**
     * @description The YouSign workspace ID, you can find this ID in the YouSign dashboard settings.
    */
    yousign?: YouSignConfig;
    /**
     * @type string | undefined
    */
    yousignApiKey?: string;
    /**
     * @type string | undefined
    */
    yousignApiUrl?: string;
    /**
     * @type string | undefined
    */
    yousignWebhookSecret?: string;
    /**
     * @type string | undefined
    */
    sydiaToken?: string;
    /**
     * @type string | undefined
    */
    ellisphereUserId?: string;
    /**
     * @type string | undefined
    */
    ellispherePassword?: string;
    /**
     * @type string | undefined
    */
    ellisphereContractId?: string;
    /**
     * @type string
    */
    stripePaymentWording: string;
    /**
     * @type string
    */
    externalInvoiceIdFormat: string;
    /**
     * @type object
    */
    products: object;
    /**
     * @type string | undefined
    */
    brokerRolesOnBrokerageFirmCreation?: KorintTenantConfigDtoBrokerRolesOnBrokerageFirmCreationEnumKey;
    /**
     * @description Tenant specific mapping between businessRoles and Korint technical roles
     * @type array | undefined
    */
    businessRoles?: BusinessRole[];
    /**
     * @type boolean
    */
    areRetailBrokerageFirmsIndependent: boolean;
    /**
     * @type boolean
    */
    areTeamBrokerageFirmsEnabled: boolean;
    /**
     * @type array
    */
    brokerageFirmCustomFields: BrokerageFirmCustomFieldConfigDto[];
    /**
     * @type string | undefined
    */
    signDistributionRequestOn?: KorintTenantConfigDtoSignDistributionRequestOnEnumKey;
    /**
     * @description Configure whether to create a payment customer on brokerage firm creation
     * @type boolean | undefined
    */
    createPaymentCustomer?: boolean;
    /**
     * @type array | undefined
    */
    generatedDocuments?: (ConfigGeneratedDocumentCarboneDto | ConfigGeneratedDocumentStaticDto)[];
    /**
     * @type array | undefined
    */
    commonDocuments?: ConfigCommonDocumentDto[];
    /**
     * @type object | undefined
    */
    sepaMandate?: PaymentMethodConfigDto;
    /**
     * @type object | undefined
    */
    brokerageFirmSignature?: BrokerageFirmSignatureConfigDto;
    /**
     * @type object | undefined
    */
    migration?: object;
    /**
     * @description CFDP EDI reporting settings. policeMere and codeIA are supplied by CFDP; until then the report emits explicit placeholders.
     * @type object | undefined
    */
    cfdp?: object;
    /**
     * @type object | undefined
    */
    compliance?: object;
    /**
     * @type object | undefined
    */
    solvability?: object;
    /**
     * @type object | undefined
    */
    distributionRequest?: DistributionRequestConfigDto;
    /**
     * @type object | undefined
    */
    brokerageFirmDocuments?: BrokerageFirmDocumentsConfigDto;
    /**
     * @description Controls the default choice (upload now vs. later) on the document prefill funnel step
    */
    documentPrefill?: DocumentPrefillConfigDto;
    /**
     * @type object | undefined
    */
    policyDocumentFraudDetection?: PolicyDocumentFraudDetectionConfigDto;
    /**
     * @type object | undefined
    */
    brokerageFirmDocumentFraudDetection?: BrokerageFirmDocumentFraudDetectionConfigDto;
    /**
     * @type object | undefined
    */
    externalConnectors?: object;
    /**
     * @type array | undefined
    */
    reports?: ReportConfigDto[];
    /**
     * @description Metabase dashboard ID for analytics
     * @type number | undefined
    */
    metabaseDashboardId?: number;
    /**
     * @description Metabase dashboard tabs configuration (takes priority over metabaseDashboardId)
     * @type array | undefined
    */
    metabaseDashboardIds?: MetabaseDashboardTabConfig[];
    /**
     * @description Tenant-level AI configuration (classification, extraction)
    */
    ai?: AIConfig;
    /**
     * @description Visual theming configuration (colors, logos, branding)
    */
    theme: TenantThemeConfigDto;
    /**
     * @description Third-party scripts to inject into the tenant frontend at runtime (e.g. chat widgets). Each entry is rendered as a <script> tag with its data-* attributes by the frontend ExternalScriptsLoader.
     * @type array | undefined
    */
    externalScripts?: ExternalScriptConfigDto[];
    /**
     * @description Cognito web login (user pool, OAuth domain); absent when brokers sign in only through `federation`
    */
    authentication?: TenantAuthenticationConfigDto;
    /**
     * @description Federated login of this tenant\'s brokers through an external identity provider
    */
    federation?: TenantFederationConfigDto;
};

export const insurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type InsurerEnumKey = (typeof insurerEnum)[keyof typeof insurerEnum];

/**
 * @description Insurers of the product. A new business may be quoted on any of them; an MTA or a renewal stays on the insurer of the contract\'s quote.
*/
export type Insurer = InsurerEnumKey;

export type AssetStartedAtLimitDto = {
    /**
     * @type object
    */
    min: object;
    /**
     * @type object | undefined
    */
    max?: object;
};

export type PeriodDurationConfigDto = {
    /**
     * @type object
    */
    defaultConfig: Duration;
    /**
     * @type array
    */
    availableConfigs: Duration[];
};

export type ConfigRenewalDayOfYearDto = {
    /**
     * @minLength 1
     * @maxLength 31
     * @type number
    */
    day: number;
    /**
     * @minLength 1
     * @maxLength 12
     * @type number
    */
    month: number;
};

export type AutoArchiveConfig = {
    /**
     * @type object
    */
    inactivityDuration: Duration;
    /**
     * @description Whether auto-archiving is active for this product
     * @type boolean
    */
    enabled: boolean;
};

export type WorkflowDefinition = object;

export type SpotTaskConfig = {
    /**
     * @type array
    */
    trigger: string[];
    /**
     * @type object
    */
    task: WorkflowDefinition;
};

export type ProductDynamicConfigDto = {
    /**
     * @description Key of the dynamic config provider.
     * @type string
    */
    provider: string;
    /**
     * @type object
    */
    params: {
        [key: string]: any;
    };
};

export type DynamicStepDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    label: string;
    /**
     * @description Order of the step in the funnel.
     * @type number
    */
    position: number;
};

export const configArrayColumnDtoTypeEnum = {
    BOOLEAN: "BOOLEAN",
    STRING: "STRING",
    NUMBER: "NUMBER",
    INTEGER: "INTEGER",
    ENUM: "ENUM",
    DATE: "DATE",
    DATETIME: "DATETIME",
    PHONE_NUMBER: "PHONE_NUMBER",
    EMAIL: "EMAIL",
    REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
    SIRET: "SIRET",
    POSTCODE: "POSTCODE",
    URL: "URL",
    IBAN: "IBAN",
    BIC: "BIC",
    ARRAY: "ARRAY"
} as const;

export type ConfigArrayColumnDtoTypeEnumKey = (typeof configArrayColumnDtoTypeEnum)[keyof typeof configArrayColumnDtoTypeEnum];

export type ConfigArrayColumnDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    type: ConfigArrayColumnDtoTypeEnumKey;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
    /**
     * @type array | undefined
    */
    validationRules?: ValidationRuleDto[];
};

export const displayConditionDtoConditionEnum = {
    equals: "equals",
    in: "in",
    lessThan: "lessThan",
    greaterThanOrEquals: "greaterThanOrEquals"
} as const;

export type DisplayConditionDtoConditionEnumKey = (typeof displayConditionDtoConditionEnum)[keyof typeof displayConditionDtoConditionEnum];

export type DisplayConditionDto = {
    /**
     * @type string
    */
    fieldName: string;
    /**
     * @type string
    */
    condition: DisplayConditionDtoConditionEnumKey;
    value?: (string | number | boolean);
    /**
     * @type array | undefined
    */
    values?: (string | number | boolean)[];
};

export type CustomFieldDisplayDto = {
    /**
     * @description Key of the dynamic step the field is displayed on.
     * @type string
    */
    step: string;
    /**
     * @description Question text, relayed as-is from the external API.
     * @type string
    */
    label: string;
    /**
     * @type object | undefined
    */
    optionLabels?: {
        [key: string]: string;
    };
    /**
     * @type array | undefined
    */
    showWhen?: DisplayConditionDto[];
    /**
     * @type array | undefined
    */
    blockingWhen?: DisplayConditionDto[];
    /**
     * @description Column labels of an ARRAY field, by column key.
     * @type object | undefined
    */
    columnLabels?: {
        [key: string]: string;
    };
};

export const configCustomFieldDtoTypeEnum = {
    BOOLEAN: "BOOLEAN",
    STRING: "STRING",
    NUMBER: "NUMBER",
    INTEGER: "INTEGER",
    ENUM: "ENUM",
    DATE: "DATE",
    DATETIME: "DATETIME",
    PHONE_NUMBER: "PHONE_NUMBER",
    EMAIL: "EMAIL",
    REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
    SIRET: "SIRET",
    POSTCODE: "POSTCODE",
    URL: "URL",
    IBAN: "IBAN",
    BIC: "BIC",
    ARRAY: "ARRAY"
} as const;

export type ConfigCustomFieldDtoTypeEnumKey = (typeof configCustomFieldDtoTypeEnum)[keyof typeof configCustomFieldDtoTypeEnum];

export const configCustomFieldDtoRequiredForEnum = {
    NEVER: "NEVER",
    CREATION: "CREATION",
    QUOTE: "QUOTE",
    CONFIRMATION: "CONFIRMATION",
    SIGNATURE: "SIGNATURE",
    NOTHING: "NOTHING"
} as const;

export type ConfigCustomFieldDtoRequiredForEnumKey = (typeof configCustomFieldDtoRequiredForEnum)[keyof typeof configCustomFieldDtoRequiredForEnum];

export const configCustomFieldDtoRequiresOnChangeEnum = {
    NEVER: "NEVER",
    CREATION: "CREATION",
    QUOTE: "QUOTE",
    CONFIRMATION: "CONFIRMATION",
    SIGNATURE: "SIGNATURE",
    NOTHING: "NOTHING"
} as const;

export type ConfigCustomFieldDtoRequiresOnChangeEnumKey = (typeof configCustomFieldDtoRequiresOnChangeEnum)[keyof typeof configCustomFieldDtoRequiresOnChangeEnum];

export const configCustomFieldDtoMtaModificationEnum = {
    ALLOWED: "ALLOWED",
    FORBIDDEN: "FORBIDDEN"
} as const;

export type ConfigCustomFieldDtoMtaModificationEnumKey = (typeof configCustomFieldDtoMtaModificationEnum)[keyof typeof configCustomFieldDtoMtaModificationEnum];

export const configCustomFieldDtoRenewalModificationEnum = {
    ALLOWED: "ALLOWED",
    FORBIDDEN: "FORBIDDEN"
} as const;

export type ConfigCustomFieldDtoRenewalModificationEnumKey = (typeof configCustomFieldDtoRenewalModificationEnum)[keyof typeof configCustomFieldDtoRenewalModificationEnum];

export type ConfigCustomFieldDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string | undefined
    */
    role?: string;
    /**
     * @type string
    */
    type: ConfigCustomFieldDtoTypeEnumKey;
    /**
     * @description The first business action that cannot proceed without the field. NOTHING and NEVER mean it is never required. Requirements accumulate: confirming a contract also satisfies the creation and quote fields.
     * @type string | undefined
    */
    requiredFor?: ConfigCustomFieldDtoRequiredForEnumKey;
    /**
     * @description What changing the field invalidates back to — a field with QUOTE forces a re-quote after any change.
     * @type string | undefined
    */
    requiresOnChange?: ConfigCustomFieldDtoRequiresOnChangeEnumKey;
    /**
     * @description Whether the field may be changed during a mid-term adjustment.
     * @type string | undefined
    */
    mtaModification?: ConfigCustomFieldDtoMtaModificationEnumKey;
    /**
     * @description Whether the field may be changed at renewal.
     * @type string | undefined
    */
    renewalModification?: ConfigCustomFieldDtoRenewalModificationEnumKey;
    /**
     * @type array | undefined
    */
    validationRules?: ValidationRuleDto[];
    /**
     * @description The field is derived by the platform, typically a pricing output. Sending it is rejected with INVALID_CUSTOM_FIELDS; read it back after quoting instead.
     * @type boolean | undefined
    */
    isCalculated?: boolean;
    /**
     * @description The field is filled from an external source — a company registry, a vehicle registry, a telematics profile — and a value you send for it is replaced by the integration\'s.
     * @type string | undefined
    */
    integrationKey?: string;
    /**
     * @type object | undefined
    */
    defaultValue?: object;
    /**
     * @type array | undefined
    */
    updatesOn?: string[];
    /**
     * @description Extraction source categories that map to this field
     * @type array | undefined
    */
    extractionSources?: string[];
    /**
     * @description Field key used in extraction prompt output
     * @type string | undefined
    */
    extractionFieldKey?: string;
    /**
     * @description Auto-fill configuration for this field
    */
    autoFill?: DocumentAutoFillDto;
    /**
     * @type boolean | undefined
    */
    canBeDeleted?: boolean;
    /**
     * @description Columns of an ARRAY field; its value is an array of rows keyed by column key.
     * @type array | undefined
    */
    columns?: ConfigArrayColumnDto[];
    /**
     * @description Set on fields from a dynamic config; a field without it is not displayed.
    */
    display?: CustomFieldDisplayDto;
};

export type CustomEventsConfigDto = {
    /**
     * @type array
    */
    customer: string[];
    /**
     * @type array
    */
    policy: string[];
    /**
     * @type array
    */
    asset: string[];
};

export const configAggregateFieldDtoRequiredForEnum = {
    NEVER: "NEVER",
    CREATION: "CREATION",
    QUOTE: "QUOTE",
    CONFIRMATION: "CONFIRMATION",
    SIGNATURE: "SIGNATURE",
    NOTHING: "NOTHING"
} as const;

export type ConfigAggregateFieldDtoRequiredForEnumKey = (typeof configAggregateFieldDtoRequiredForEnum)[keyof typeof configAggregateFieldDtoRequiredForEnum];

export const configAggregateFieldDtoRequiresOnChangeEnum = {
    NEVER: "NEVER",
    CREATION: "CREATION",
    QUOTE: "QUOTE",
    CONFIRMATION: "CONFIRMATION",
    SIGNATURE: "SIGNATURE",
    NOTHING: "NOTHING"
} as const;

export type ConfigAggregateFieldDtoRequiresOnChangeEnumKey = (typeof configAggregateFieldDtoRequiresOnChangeEnum)[keyof typeof configAggregateFieldDtoRequiresOnChangeEnum];

export const configAggregateFieldDtoMtaModificationEnum = {
    ALLOWED: "ALLOWED",
    FORBIDDEN: "FORBIDDEN"
} as const;

export type ConfigAggregateFieldDtoMtaModificationEnumKey = (typeof configAggregateFieldDtoMtaModificationEnum)[keyof typeof configAggregateFieldDtoMtaModificationEnum];

export const configAggregateFieldDtoRenewalModificationEnum = {
    ALLOWED: "ALLOWED",
    FORBIDDEN: "FORBIDDEN"
} as const;

export type ConfigAggregateFieldDtoRenewalModificationEnumKey = (typeof configAggregateFieldDtoRenewalModificationEnum)[keyof typeof configAggregateFieldDtoRenewalModificationEnum];

export const configAggregateFieldDtoTypeEnum = {
    BOOLEAN: "BOOLEAN",
    STRING: "STRING",
    NUMBER: "NUMBER",
    INTEGER: "INTEGER",
    ENUM: "ENUM",
    DATE: "DATE",
    DATETIME: "DATETIME",
    PHONE_NUMBER: "PHONE_NUMBER",
    EMAIL: "EMAIL",
    REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
    SIRET: "SIRET",
    POSTCODE: "POSTCODE",
    URL: "URL",
    IBAN: "IBAN",
    BIC: "BIC",
    ARRAY: "ARRAY"
} as const;

export type ConfigAggregateFieldDtoTypeEnumKey = (typeof configAggregateFieldDtoTypeEnum)[keyof typeof configAggregateFieldDtoTypeEnum];

export type ConfigAggregateFieldDto = {
    /**
     * @type string | undefined
    */
    role?: string;
    /**
     * @description The first business action that cannot proceed without the field. NOTHING and NEVER mean it is never required. Requirements accumulate: confirming a contract also satisfies the creation and quote fields.
     * @type string | undefined
    */
    requiredFor?: ConfigAggregateFieldDtoRequiredForEnumKey;
    /**
     * @description What changing the field invalidates back to — a field with QUOTE forces a re-quote after any change.
     * @type string | undefined
    */
    requiresOnChange?: ConfigAggregateFieldDtoRequiresOnChangeEnumKey;
    /**
     * @description Whether the field may be changed during a mid-term adjustment.
     * @type string | undefined
    */
    mtaModification?: ConfigAggregateFieldDtoMtaModificationEnumKey;
    /**
     * @description Whether the field may be changed at renewal.
     * @type string | undefined
    */
    renewalModification?: ConfigAggregateFieldDtoRenewalModificationEnumKey;
    /**
     * @type array | undefined
    */
    validationRules?: ValidationRuleDto[];
    /**
     * @description The field is derived by the platform, typically a pricing output. Sending it is rejected with INVALID_CUSTOM_FIELDS; read it back after quoting instead.
     * @type boolean | undefined
    */
    isCalculated?: boolean;
    /**
     * @description The field is filled from an external source — a company registry, a vehicle registry, a telematics profile — and a value you send for it is replaced by the integration\'s.
     * @type string | undefined
    */
    integrationKey?: string;
    /**
     * @type object | undefined
    */
    defaultValue?: object;
    /**
     * @type array | undefined
    */
    updatesOn?: string[];
    /**
     * @description Extraction source categories that map to this field
     * @type array | undefined
    */
    extractionSources?: string[];
    /**
     * @description Field key used in extraction prompt output
     * @type string | undefined
    */
    extractionFieldKey?: string;
    /**
     * @description Auto-fill configuration for this field
    */
    autoFill?: DocumentAutoFillDto;
    /**
     * @type boolean | undefined
    */
    canBeDeleted?: boolean;
    /**
     * @description Columns of an ARRAY field; its value is an array of rows keyed by column key.
     * @type array | undefined
    */
    columns?: ConfigArrayColumnDto[];
    /**
     * @description Set on fields from a dynamic config; a field without it is not displayed.
    */
    display?: CustomFieldDisplayDto;
    /**
     * @type string
    */
    key: string;
    /**
     * @type string | undefined
    */
    type?: ConfigAggregateFieldDtoTypeEnumKey;
};

export type ConfigQuoteEngineDto = {
    /**
     * @type boolean
    */
    useLastQuoteOnFrequency: boolean;
    /**
     * @type boolean
    */
    shouldProrate: boolean;
    /**
     * @type number | undefined
    */
    splitAt?: number;
};

export const referenceDateTokenEnum = {
    STARTED_AT: "STARTED_AT",
    QUOTED_AT: "QUOTED_AT",
    RENEWAL_DATE: "RENEWAL_DATE"
} as const;

export type ReferenceDateTokenEnumKey = (typeof referenceDateTokenEnum)[keyof typeof referenceDateTokenEnum];

/**
 * @description Reference date for calculating invalidation time
*/
export type ReferenceDateToken = ReferenceDateTokenEnumKey;

export type QuoteInvalidationRuleDto = {
    /**
     * @description Reference date for calculating invalidation time
    */
    referenceDate: ReferenceDateToken;
    /**
     * @description Duration to add to reference date. Can be negative.
    */
    duration: Duration;
};

export type ConfigQuoteDefaultOptionsDto = {
    /**
     * @description The tier selected for this asset, as listed by GET /policies/{policyId}/available-pricing. Tiers are computed per policy, so there is no fixed list.
     * @type string
    */
    tier: string;
    /**
     * @description The excess selected for this asset, from the chosen tier\'s available excesses.
     * @type string
    */
    excess: string;
    /**
     * @description The optional perils selected for this asset. Perils always included in the tier are not listed here.
     * @type array | undefined
    */
    perils?: ConfigQuoteChosenWarrantyDto[];
    /**
     * @description Insurer a new business is quoted on when the quote request names none. Required when the product\'s `insurers` lists several.
    */
    insurer?: Insurer;
};

export type ConfigQuoteShowWhenSingleValueDto = {
    /**
     * @type string
    */
    fieldKey: string;
    /**
     * @type string
    */
    fieldValue: string;
    /**
     * @type string
    */
    condition: string;
    /**
     * @type string
    */
    value: string;
};

export type ConfigQuoteShowWhenMultipleValuesDto = {
    /**
     * @type string
    */
    fieldKey: string;
    /**
     * @type string
    */
    fieldValue: string;
    /**
     * @type string
    */
    condition: string;
    /**
     * @type array
    */
    values: string[];
};

export type ConfigQuoteShowWhenNoValueDto = {
    /**
     * @type string
    */
    fieldKey: string;
    /**
     * @type string
    */
    fieldValue: string;
    /**
     * @type string
    */
    condition: string;
};

export type ConfigQuoteAvailableWarrantyDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
    /**
     * @type array | undefined
    */
    options?: string[];
    showWhen?: (ConfigQuoteShowWhenSingleValueDto | ConfigQuoteShowWhenMultipleValuesDto | ConfigQuoteShowWhenNoValueDto);
};

export type QuoteAvailableOptionsDto = {
    /**
     * @type string
    */
    tier: string;
    /**
     * @type string
    */
    excess: string;
    /**
     * @type array | undefined
    */
    perils?: ConfigQuoteAvailableWarrantyDto[];
};

export type QuotePricingConditionDto = {
    /**
     * @type string
    */
    entity: string;
    /**
     * @type string
    */
    fieldKey: string;
    value: (string | number | boolean | string[] | number[] | boolean[]);
};

export const apiSpreadsheetsQuoteComponentDtoTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type ApiSpreadsheetsQuoteComponentDtoTypeEnumKey = (typeof apiSpreadsheetsQuoteComponentDtoTypeEnum)[keyof typeof apiSpreadsheetsQuoteComponentDtoTypeEnum];

export const apiSpreadsheetsQuoteComponentDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type ApiSpreadsheetsQuoteComponentDtoChargeTypeEnumKey = (typeof apiSpreadsheetsQuoteComponentDtoChargeTypeEnum)[keyof typeof apiSpreadsheetsQuoteComponentDtoChargeTypeEnum];

export type ApiSpreadsheetsQuoteComponentDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: ApiSpreadsheetsQuoteComponentDtoTypeEnumKey;
    /**
     * @type string
    */
    chargeType: ApiSpreadsheetsQuoteComponentDtoChargeTypeEnumKey;
    /**
     * @type object
    */
    premium: object;
};

export const apiSpreadsheetsQuotePricingConfigDtoTypeEnum = {
    EXCEL_API_SPREADSHEET: "EXCEL_API_SPREADSHEET",
    CUSTOM: "CUSTOM",
    MOCK: "MOCK"
} as const;

export type ApiSpreadsheetsQuotePricingConfigDtoTypeEnumKey = (typeof apiSpreadsheetsQuotePricingConfigDtoTypeEnum)[keyof typeof apiSpreadsheetsQuotePricingConfigDtoTypeEnum];

export type ApiSpreadsheetsQuotePricingConfigDto = {
    /**
     * @type string
    */
    type: ApiSpreadsheetsQuotePricingConfigDtoTypeEnumKey;
    /**
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    condition?: QuotePricingConditionDto;
    /**
     * @type string
    */
    fileId: string;
    /**
     * @type array
    */
    inputs: any[][];
    /**
     * @type array | undefined
    */
    outputs?: string[];
    /**
     * @type array
    */
    policyComponents: ApiSpreadsheetsQuoteComponentDto[];
    /**
     * @type array
    */
    assetComponents: any[][];
};

export const customQuotePricingConfigDtoTypeEnum = {
    EXCEL_API_SPREADSHEET: "EXCEL_API_SPREADSHEET",
    CUSTOM: "CUSTOM",
    MOCK: "MOCK"
} as const;

export type CustomQuotePricingConfigDtoTypeEnumKey = (typeof customQuotePricingConfigDtoTypeEnum)[keyof typeof customQuotePricingConfigDtoTypeEnum];

export type CustomQuotePricingConfigDto = {
    /**
     * @type string
    */
    type: CustomQuotePricingConfigDtoTypeEnumKey;
    /**
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    condition?: QuotePricingConditionDto;
};

export const mockQuotePricingConfigDtoTypeEnum = {
    EXCEL_API_SPREADSHEET: "EXCEL_API_SPREADSHEET",
    CUSTOM: "CUSTOM",
    MOCK: "MOCK"
} as const;

export type MockQuotePricingConfigDtoTypeEnumKey = (typeof mockQuotePricingConfigDtoTypeEnum)[keyof typeof mockQuotePricingConfigDtoTypeEnum];

export type MockQuotePricingConfigDto = {
    /**
     * @type string
    */
    type: MockQuotePricingConfigDtoTypeEnumKey;
    /**
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    condition?: QuotePricingConditionDto;
};

export type ConfigQuote = {
    /**
     * @type object
    */
    defaultConfig: ConfigQuoteDefaultOptionsDto;
    /**
     * @type array
    */
    availableConfigs: QuoteAvailableOptionsDto[];
    /**
     * @type array
    */
    pricing: (ApiSpreadsheetsQuotePricingConfigDto | CustomQuotePricingConfigDto | MockQuotePricingConfigDto)[];
};

export type ConfigAllowedTotalCommissionFeeDto = {
    /**
     * @minLength 0
     * @maxLength 100
     * @type number
    */
    min: number;
    /**
     * @minLength 0
     * @maxLength 100
     * @type number
    */
    max: number;
    /**
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    default?: number;
};

export type IndividualPolicyConfigDto = {
    /**
     * @type boolean | undefined
    */
    startOnSignature?: boolean;
    /**
     * @type object
    */
    pricing: ConfigQuoteEngineDto;
    /**
     * @description Quote invalidation rules. Earliest date wins. Empty array = no invalidation.
     * @type array
    */
    quoteInvalidation: QuoteInvalidationRuleDto[];
    /**
     * @type object | undefined
    */
    quote?: ConfigQuote;
    /**
     * @deprecated
    */
    allowedTotalCommissionFee?: ConfigAllowedTotalCommissionFeeDto;
};

export type ClaimsConfigDto = object;

export type FraudDetectionByCategoryEntryDto = {
    /**
     * @description Handler key for the primary fraud check on documents of this category. The primary handler\'s verdict is the one forwarded to the partner (e.g. Marsh SAM via pairDocument).
     * @type string
    */
    primary: string;
    /**
     * @description Optional shadow handler keys run alongside the primary for offline ranking. Persisted with `role = shadow`, never forwarded to the partner.
     * @type array | undefined
    */
    shadows?: string[];
};

export type FraudEvidenceExtractionConfigDto = {
    /**
     * @description Shared document-reading prompt for fraud evidence and business fields
     * @type string
    */
    promptSlug: string;
    /**
     * @description Observed document fields required by fraud checks
     * @type array
    */
    fields: ExtractionFieldConfigDto[];
};

export type FraudCustomCheckConfigDto = {
    /**
     * @description Stable check id. Namespaces the signal codes the in-house `tenant-rules` checker emits (`tenant-rules.<key>`).
     * @type string
    */
    key: string;
    /**
     * @description `ClaimDocCategory` string values the check applies to (e.g. `bank_statement`). Absent or empty = applies to every document.
     * @type array | undefined
    */
    appliesTo?: string[];
    /**
     * @description Partner-specific consistency rules (red flags, expected formats) handed verbatim to the vision model that inspects the document.
     * @type string
    */
    instructions: string;
};

export type FraudDetectionScopesDto = {
    /**
     * @description Run fraud detection on claim documents.
     * @type boolean
    */
    claims: boolean;
    /**
     * @description Run fraud detection on policy documents (Phase 4+).
     * @type boolean
    */
    policy: boolean;
};

export const fraudDetectionConfigDtoExperimentalCheckersEnum = {
    "ocr-glyph-geometry": "ocr-glyph-geometry",
    "noise-residual": "noise-residual",
    "background-continuity": "background-continuity"
} as const;

export type FraudDetectionConfigDtoExperimentalCheckersEnumKey = (typeof fraudDetectionConfigDtoExperimentalCheckersEnum)[keyof typeof fraudDetectionConfigDtoExperimentalCheckersEnum];

export type FraudDetectionConfigDto = {
    /**
     * @type object | undefined
    */
    extraction?: FraudEvidenceExtractionConfigDto;
    /**
     * @description Master toggle. Off → the orchestrator short-circuits without persisting any DocumentFraudScore row. Off everywhere at merge of ENG-3384; enabled per tenant once Phase 1A is signed off.
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Handler key used when an uploaded document\'s category has no `byCategory` override (or category resolution fails). Must be one of the registered `FraudProvider` keys (`mock`, `inhouse`, …) or `skip`.
     * @type string
    */
    defaultHandler: string;
    /**
     * @description Shadow handlers applied to every document that falls back to `defaultHandler`.
     * @type array | undefined
    */
    defaultShadows?: string[];
    /**
     * @description Per-`ClaimDocCategory` handler routing. Key is the `ClaimDocCategory` enum value (e.g. `ID_CARD`). Categories absent from this map use `defaultHandler` + `defaultShadows`.
     * @type object | undefined
    */
    byCategory?: {
        [key: string]: FraudDetectionByCategoryEntryDto;
    };
    /**
     * @description Tenant-specific consistency checks (e.g. the Marsh documentary-fraud rules) run by the in-house `tenant-rules` checker on top of the generic file/content checkers.
     * @type array | undefined
    */
    customChecks?: FraudCustomCheckConfigDto[];
    /**
     * @description In-house checker keys to enable that are off by default — the experimental, heuristic pixel-tampering checks. A checker runs only when its key is listed here; the always-on deterministic checkers ignore this field. Per-tenant opt-in while these are calibrated against the feedback loop (ENG-3389).
     * @type array | undefined
    */
    experimentalCheckers?: FraudDetectionConfigDtoExperimentalCheckersEnumKey[];
    /**
     * @description Probability (0..1) that shadow handlers run for any given document. Lets us cap vendor spend on shadow ranking in prod while keeping primary at 100%. Defaults to 1 (always run shadows).
     * @minLength 0
     * @maxLength 1
     * @type number | undefined
    */
    shadowSamplingRate?: number;
    /**
     * @description Scopes the fraud check applies to. `claims` is the only one wired in Phase 1; `policy` is Phase 4+.
    */
    scopes: FraudDetectionScopesDto;
    /**
     * @description Below this claim amount (EUR), the fraud check is skipped entirely. Mirrors the partner manual-review threshold (€500 for Marsh).
     * @minLength 0
     * @type number | undefined
    */
    minClaimAmountEur?: number;
};

export type BranchSubTypeConfigDto = {
    /**
     * @type array | undefined
    */
    BASE?: string[];
    /**
     * @type array | undefined
    */
    NEW_BUSINESS?: string[];
    /**
     * @type array | undefined
    */
    MTA?: string[];
    /**
     * @type array | undefined
    */
    RENEWAL?: string[];
    /**
     * @type array | undefined
    */
    REPRICING?: string[];
};

export const paymentConfigDtoAllowedPaymentModesEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type PaymentConfigDtoAllowedPaymentModesEnumKey = (typeof paymentConfigDtoAllowedPaymentModesEnum)[keyof typeof paymentConfigDtoAllowedPaymentModesEnum];

export const paymentConfigDtoAllowedPaymentMethodsEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentConfigDtoAllowedPaymentMethodsEnumKey = (typeof paymentConfigDtoAllowedPaymentMethodsEnum)[keyof typeof paymentConfigDtoAllowedPaymentMethodsEnum];

export const paymentConfigDtoPaymentMethodOnEarlyPaymentEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentConfigDtoPaymentMethodOnEarlyPaymentEnumKey = (typeof paymentConfigDtoPaymentMethodOnEarlyPaymentEnum)[keyof typeof paymentConfigDtoPaymentMethodOnEarlyPaymentEnum];

export const paymentConfigDtoPaymentMethodOnRecurringPaymentEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentConfigDtoPaymentMethodOnRecurringPaymentEnumKey = (typeof paymentConfigDtoPaymentMethodOnRecurringPaymentEnum)[keyof typeof paymentConfigDtoPaymentMethodOnRecurringPaymentEnum];

export const paymentConfigDtoPaymentMethodOnBrokenMethodEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentConfigDtoPaymentMethodOnBrokenMethodEnumKey = (typeof paymentConfigDtoPaymentMethodOnBrokenMethodEnum)[keyof typeof paymentConfigDtoPaymentMethodOnBrokenMethodEnum];

export type PaymentConfigDto = {
    /**
     * @type array
    */
    allowedPaymentModes: PaymentConfigDtoAllowedPaymentModesEnumKey[];
    /**
     * @type array
    */
    allowedPaymentMethods: PaymentConfigDtoAllowedPaymentMethodsEnumKey[];
    /**
     * @type object | undefined
    */
    sepaMandate?: PaymentMethodConfigDto;
    /**
     * @type array | undefined
    */
    paymentMethodOnEarlyPayment?: PaymentConfigDtoPaymentMethodOnEarlyPaymentEnumKey[];
    /**
     * @type array | undefined
    */
    paymentMethodOnRecurringPayment?: PaymentConfigDtoPaymentMethodOnRecurringPaymentEnumKey[];
    /**
     * @description Charged only when the early/recurring type has no usable method left, e.g. a dead SEPA mandate. Omit to leave such invoices unpaid.
     * @type array | undefined
    */
    paymentMethodOnBrokenMethod?: PaymentConfigDtoPaymentMethodOnBrokenMethodEnumKey[];
    /**
     * @description Whether the payment method used is saved on the brokerage firm
     * @type boolean | undefined
    */
    paymentMethodIsOnBrokerageFirm?: boolean;
};

export const unpaidEmailActionConfigTypeEnum = {
    SEND_EMAIL: "SEND_EMAIL"
} as const;

export type UnpaidEmailActionConfigTypeEnumKey = (typeof unpaidEmailActionConfigTypeEnum)[keyof typeof unpaidEmailActionConfigTypeEnum];

export type UnpaidEmailActionConfig = {
    /**
     * @type string
    */
    type: UnpaidEmailActionConfigTypeEnumKey;
    /**
     * @description An `emails` trigger of the product or its tenant, which owns the template and the recipients.
     * @type string
    */
    trigger: string;
};

export const unpaidFeeComponentConfigTypeEnum = {
    UNPAID_FEE: "UNPAID_FEE"
} as const;

export type UnpaidFeeComponentConfigTypeEnumKey = (typeof unpaidFeeComponentConfigTypeEnum)[keyof typeof unpaidFeeComponentConfigTypeEnum];

export type UnpaidFeeComponentConfig = {
    /**
     * @type string
    */
    type: UnpaidFeeComponentConfigTypeEnumKey;
    /**
     * @description Fee amount in cents.
     * @minLength 0
     * @type number
    */
    amount: number;
};

export type UnpaidFeesConfig = {
    /**
     * @type array
    */
    components: UnpaidFeeComponentConfig[];
};

export type UnpaidRetryConditionConfig = {
    /**
     * @type array
    */
    reasonIn: string[];
};

export const unpaidRetryConfigMethodEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type UnpaidRetryConfigMethodEnumKey = (typeof unpaidRetryConfigMethodEnum)[keyof typeof unpaidRetryConfigMethodEnum];

export const unpaidRetryConfigFallbackMethodEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type UnpaidRetryConfigFallbackMethodEnumKey = (typeof unpaidRetryConfigFallbackMethodEnum)[keyof typeof unpaidRetryConfigFallbackMethodEnum];

export type UnpaidRetryConfig = {
    /**
     * @description Matches the latest payment failure or decline code. Omit to retry all reasons.
    */
    when?: UnpaidRetryConditionConfig;
    /**
     * @description Maximum automatic retries after the initial attempt. Primary and fallback share one retry.
     * @minLength 1
     * @type number
    */
    repeat: number;
    /**
     * @description Days between payment failure and the next retry.
     * @minLength 1
     * @type number
    */
    delaySinceFailure: number;
    /**
     * @description Omit to use the policy default payment method.
     * @type string | undefined
    */
    method?: UnpaidRetryConfigMethodEnumKey;
    /**
     * @description Fallback payment method within the same retry attempt.
     * @type string | undefined
    */
    fallbackMethod?: UnpaidRetryConfigFallbackMethodEnumKey;
    /**
     * @description Email before retrying a card payment.
    */
    cardRetryPreventionEmail?: UnpaidEmailActionConfig;
};

export type UnpaidReminderConfig = {
    /**
     * @minLength 0
     * @type number
    */
    delaySinceFailure: number;
    /**
     * @type object
    */
    action: UnpaidEmailActionConfig;
};

export const unpaidEscalationActionConfigTypeEnum = {
    SEND_FORMAL_NOTICE: "SEND_FORMAL_NOTICE",
    SUSPEND_POLICY: "SUSPEND_POLICY"
} as const;

export type UnpaidEscalationActionConfigTypeEnumKey = (typeof unpaidEscalationActionConfigTypeEnum)[keyof typeof unpaidEscalationActionConfigTypeEnum];

export type UnpaidEscalationActionConfig = {
    /**
     * @type string
    */
    type: UnpaidEscalationActionConfigTypeEnumKey;
};

export const unpaidCancellationActionConfigTypeEnum = {
    CANCEL_POLICY: "CANCEL_POLICY"
} as const;

export type UnpaidCancellationActionConfigTypeEnumKey = (typeof unpaidCancellationActionConfigTypeEnum)[keyof typeof unpaidCancellationActionConfigTypeEnum];

export type UnpaidCancellationActionConfig = {
    /**
     * @type string
    */
    type: UnpaidCancellationActionConfigTypeEnumKey;
    /**
     * @type string
    */
    stopReason: string;
};

export type UnpaidEscalationConfig = {
    /**
     * @description Days since the earliest currently unpaid invoice issuance date.
     * @minLength 0
     * @type number
    */
    delaySinceFailure: number;
    action: (UnpaidEmailActionConfig | UnpaidEscalationActionConfig | UnpaidCancellationActionConfig);
};

export type UnpaidConfigNotification = {
    /**
     * @type number
    */
    notificationIndex: number;
    /**
     * @type object
    */
    durationSinceFailure: Duration;
    /**
     * @type boolean | undefined
    */
    sendIfPriorUnpaidInvoice?: boolean;
    /**
     * @description The trigger to use for the unpaid invoice notification, should be associated to an email in `emails`
     * @type string
    */
    trigger: string;
};

export type UnpaidConfigDto = {
    /**
     * @description Email for every invoice payment failure. Declarative in the no-op preview.
    */
    paymentFailedEmail?: UnpaidEmailActionConfig;
    /**
     * @description Fees applied once on the first invoice failure. Declarative in the no-op preview.
    */
    unpaidFees?: UnpaidFeesConfig;
    /**
     * @type object | undefined
    */
    retries?: UnpaidRetryConfig;
    /**
     * @description Email actions scheduled from the earliest currently unpaid invoice issuance date, sent only while no retry can recover the debt. One per policy, not per invoice.
     * @type array | undefined
    */
    reminderEmails?: UnpaidReminderConfig[];
    /**
     * @description Actions scheduled by full unpaid duration, independently of retries and reminders. `SEND_FORMAL_NOTICE` requires `ere.formalNotice.enabled`; rungs already reached are skipped.
     * @type array | undefined
    */
    escalation?: UnpaidEscalationConfig[];
    /**
     * @description Collection fee in cents added to a replacement invoice when a payment fails. A single number applies to every billing frequency; an object keyed by invoice frequency charges a distinct fee per frequency, and a frequency absent from the object is rejected. Omit to replace the invoice without adding any fee.
    */
    unpaidAmount?: (number | {
        [key: string]: number;
    });
    /**
     * @type array | undefined
    */
    notifications?: UnpaidConfigNotification[];
    /**
     * @description Stripe error codes that justify a collection fee. Replaces DEFAULT_CHARGEABLE_FAILURE_CODES when set; omit to use it.
     * @type array | undefined
    */
    chargeableFailureCodes?: string[];
    /**
     * @description Stripe decline codes that justify a collection fee. Replaces DEFAULT_CHARGEABLE_DECLINE_CODES when set; omit to use it.
     * @type array | undefined
    */
    chargeableDeclineCodes?: string[];
};

export const invoiceFrequencyEnum = {
    YEARLY: "YEARLY",
    HALF_YEARLY: "HALF_YEARLY",
    QUARTERLY: "QUARTERLY",
    MONTHLY: "MONTHLY",
    BIENNIAL: "BIENNIAL",
    WEEKLY: "WEEKLY"
} as const;

export type InvoiceFrequencyEnumKey = (typeof invoiceFrequencyEnum)[keyof typeof invoiceFrequencyEnum];

export type InvoiceFrequency = InvoiceFrequencyEnumKey;

export const invoiceTimingEnum = {
    IN_ADVANCE: "IN_ADVANCE",
    IN_ARREAR: "IN_ARREAR"
} as const;

export type InvoiceTimingEnumKey = (typeof invoiceTimingEnum)[keyof typeof invoiceTimingEnum];

export type InvoiceTiming = InvoiceTimingEnumKey;

export const firstPaymentEnum = {
    NONE: "NONE",
    EARLY_PAYMENT_AT_SIGNATURE: "EARLY_PAYMENT_AT_SIGNATURE",
    FULL_AT_SIGNATURE: "FULL_AT_SIGNATURE",
    EARLY_PAYMENT_AT_START_DATE: "EARLY_PAYMENT_AT_START_DATE",
    FULL_AT_START_DATE: "FULL_AT_START_DATE"
} as const;

export type FirstPaymentEnumKey = (typeof firstPaymentEnum)[keyof typeof firstPaymentEnum];

export type FirstPayment = FirstPaymentEnumKey;

export type InvoicingConfigDto = {
    frequency: InvoiceFrequency;
    timing: InvoiceTiming;
    firstPayment: FirstPayment;
    /**
     * @type object | undefined
    */
    earlyPayment?: Duration;
};

export type ConfigBillingAssignmentComponentOverrideDto = {
    /**
     * @type string
    */
    componentId: string;
    /**
     * @description Business role ID (customerRole) that pays for this component
     * @type string
    */
    payerRole: string;
};

export type ConfigBillingAssignmentDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @description Default payer role — required, no fallback to customerIds[0]
     * @type string
    */
    defaultPayerRole: string;
    /**
     * @type array | undefined
    */
    componentOverrides?: ConfigBillingAssignmentComponentOverrideDto[];
    /**
     * @type array | undefined
    */
    filter?: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilter?: FilterDto[];
};

export type ConfigBillingAssignmentConfig = {
    /**
     * @type object
    */
    defaultConfig: ConfigBillingAssignmentDto;
    /**
     * @type array
    */
    availableConfigs: ConfigBillingAssignmentDto[];
};

export type ConfigBilling = {
    /**
     * @description determines whether the billing should take into account failed payments when reimbursing customers
     * @type boolean | undefined
    */
    reconcileFailedPayments?: boolean;
    /**
     * @type object
    */
    defaultConfig: InvoicingConfigDto;
    /**
     * @type array
    */
    availableConfigs: InvoicingConfigDto[];
    /**
     * @type object
    */
    billingAssignment: ConfigBillingAssignmentConfig;
};

export type ConfigRepricing = {
    /**
     * @type object
    */
    repricingPeriod: Duration;
    /**
     * @type object
    */
    drivequantScoreOptions: CustomFieldDto;
};

export type ConfigPolicyholderDocumentDto = {
    /**
     * @type string
    */
    category: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
    /**
     * @description Human-readable name for this document category, shown to the policyholder. Falls back to the raw category code when absent.
     * @type string | undefined
    */
    label?: string;
    /**
     * @description Fields to extract from this document category
     * @type array | undefined
    */
    extractionFields?: ExtractionFieldConfigDto[];
    /**
     * @description Validity rules for this document category
     * @type array | undefined
    */
    validity?: DocumentValidityRuleDto[];
    /**
     * @type array | undefined
    */
    filters?: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilters?: FilterDto[];
};

export type DocumentCollectionReminderDto = {
    /**
     * @description Explicit rung index, matching `UnpaidConfigNotification.notificationIndex` — not positional.
     * @type number
    */
    reminderIndex: number;
    /**
     * @description Offset from the anchor at which this rung wakes.
    */
    offset: Duration;
    /**
     * @description Event trigger for this rung\'s email, should be associated to an email in `emails`. Falls back to `DOCUMENT_COLLECTION_REMINDER_DUE` when absent.
     * @type string | undefined
    */
    trigger?: string;
};

export type DocumentCollectionConfigDto = {
    /**
     * @description Master toggle: absent or false means no detection, no query.
     * @type boolean
    */
    enabled: boolean;
    /**
     * @description Policy event types that (re)open the reminder ladder. Must be a subset of the reminder starter subscriber\'s routing-key binding.
     * @type array
    */
    startEvents: string[];
    /**
     * @description The collection window, measured from the anchor (the policy\'s NB-signature timestamp).
    */
    window: Duration;
    /**
     * @description The reminder ladder rungs, consumed by the reminder workflow. Absent or empty starts no reminders.
     * @type array | undefined
    */
    reminders?: DocumentCollectionReminderDto[];
    /**
     * @description The single-rung reminder workflow definition. Required once `reminders` is non-empty.
    */
    task?: WorkflowDefinition;
};

export type ConfigClaimDocumentDto = {
    /**
     * @description High-level ClaimDocCategory code (e.g. ID_CARD, BOOKING_VOUCHER) — must match a value the claim-doc classifier can output.
     * @type string
    */
    category: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
    /**
     * @description Fields to extract from this claim doc category. The `key` of each entry must match a key in the claim aggregate\'s `requiredFields[]` so the prefill step can write it back via ClaimDraftCustomFieldsUpdated.
     * @type array | undefined
    */
    extractionFields?: ExtractionFieldConfigDto[];
    /**
     * @description Validity rules for this claim doc category
     * @type array | undefined
    */
    validity?: DocumentValidityRuleDto[];
};

export const configSignedDocumentDtoWithSignPolicySignatureEnum = {
    VIEW: "VIEW",
    SIGN: "SIGN"
} as const;

export type ConfigSignedDocumentDtoWithSignPolicySignatureEnumKey = (typeof configSignedDocumentDtoWithSignPolicySignatureEnum)[keyof typeof configSignedDocumentDtoWithSignPolicySignatureEnum];

export const configSignedDocumentDtoWithSignPolicyBranchTypesEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type ConfigSignedDocumentDtoWithSignPolicyBranchTypesEnumKey = (typeof configSignedDocumentDtoWithSignPolicyBranchTypesEnum)[keyof typeof configSignedDocumentDtoWithSignPolicyBranchTypesEnum];

export type ConfigSignedDocumentDtoWithSignPolicy = {
    /**
     * @type string
    */
    signature: ConfigSignedDocumentDtoWithSignPolicySignatureEnumKey;
    /**
     * @description When set, this entry targets only the generated document whose configName matches. Allows different signature positions for multiple generated documents sharing the same documentType.
     * @type string | undefined
    */
    configName?: string;
    /**
     * @type array | undefined
    */
    signers?: SignerConfigItemDto[];
    /**
     * @type object | undefined
    */
    anchor?: ConfigSignedDocumentAnchorDto;
    /**
     * @type array | undefined
    */
    mentions?: ConfigSignedDocumentMentionDto[];
    /**
     * @type array | undefined
    */
    texts?: ConfigSignedDocumentTextDto[];
    /**
     * @type array | undefined
    */
    checkboxes?: ConfigSignedDocumentCheckboxDto[];
    /**
     * @type string
    */
    type: string;
    /**
     * @description Whether the policy should be signed when all those documents are needed for merge. It signs all those documents at the same time.
     * @type boolean
    */
    neededForPolicySigned: boolean;
    /**
     * @type array | undefined
    */
    branchTypes?: ConfigSignedDocumentDtoWithSignPolicyBranchTypesEnumKey[];
};

export type SignatureConfigDto = {
    /**
     * @type boolean | undefined
    */
    requirePaymentMethodForNewBusiness?: boolean;
    /**
     * @type object | undefined
    */
    reminders?: SignatureRequestReminderSettings;
    /**
     * @type array
    */
    signedDocuments: ConfigSignedDocumentDtoWithSignPolicy[];
};

export const configEreLetterRecipientStatusEnum = {
    particulier: "particulier",
    professionnel: "professionnel"
} as const;

export type ConfigEreLetterRecipientStatusEnumKey = (typeof configEreLetterRecipientStatusEnum)[keyof typeof configEreLetterRecipientStatusEnum];

export type ConfigEreLetter = {
    /**
     * @type string
    */
    ar24User: string;
    /**
     * @default "professionnel"
     * @type string | undefined
    */
    recipientStatus?: ConfigEreLetterRecipientStatusEnumKey;
    /**
     * @type string
    */
    content: string;
    /**
     * @type string | undefined
    */
    fileName?: string;
};

export type ConfigPriorContractCancellation = {
    /**
     * @description When true, the policyholder can declare a prior contract to cancel, and the broker sends its insurer a registered cancellation letter once documents are validated.
     * @type boolean
    */
    enabled: boolean;
    /**
     * @type object
    */
    cancellationLetter: ConfigEreLetter;
};

export const stopDateNoticePeriodReferenceDateEnum = {
    NOW: "NOW",
    SUSPENSION_STARTED: "SUSPENSION_STARTED"
} as const;

export type StopDateNoticePeriodReferenceDateEnumKey = (typeof stopDateNoticePeriodReferenceDateEnum)[keyof typeof stopDateNoticePeriodReferenceDateEnum];

export type StopDateNoticePeriodReferenceDate = StopDateNoticePeriodReferenceDateEnumKey;

export type ConfigNoticePeriodBound = {
    referenceDate: StopDateNoticePeriodReferenceDate;
    /**
     * @description Duration to add to reference date. Can be negative.
    */
    duration: Duration;
};

export type ConfigStopDateNoticePeriod = {
    /**
     * @description Earliest allowed stop date = referenceDate + duration. A positive duration enforces a forward notice period (e.g. amount: 5, unit: DAY — earliest allowed date is in 5 days) or, with amount: 1, forbids same-day and retroactive dates entirely (earliest allowed is tomorrow). A negative duration instead permits limited backdating, up to that many days in the past.
    */
    min?: ConfigNoticePeriodBound;
    /**
     * @description Latest allowed stop date = referenceDate + duration. Independent of appliedInFutureAllowed, which gates future dates entirely when unset — this instead caps how far in the future a date can be.
    */
    max?: ConfigNoticePeriodBound;
};

export const requestNoticePeriodReferenceDateEnum = {
    NEXT_ANNIVERSARY: "NEXT_ANNIVERSARY"
} as const;

export type RequestNoticePeriodReferenceDateEnumKey = (typeof requestNoticePeriodReferenceDateEnum)[keyof typeof requestNoticePeriodReferenceDateEnum];

/**
 * @description Gates whether the reason is usable at all: the request must be made before the policy\'s next renewal date + duration (pass a negative duration for a deadline before the anniversary). When the reason has no appliedAtDate (no client-submitted stop date), the effective stop date is the anniversary itself.
*/
export type RequestNoticePeriodReferenceDate = RequestNoticePeriodReferenceDateEnumKey;

export type ConfigRequestNoticePeriod = {
    /**
     * @description Gates whether the reason is usable at all: the request must be made before the policy\'s next renewal date + duration (pass a negative duration for a deadline before the anniversary). When the reason has no appliedAtDate (no client-submitted stop date), the effective stop date is the anniversary itself.
    */
    referenceDate: RequestNoticePeriodReferenceDate;
    /**
     * @description Duration to add to reference date. Can be negative.
    */
    duration: Duration;
};

export type ConfigPolicyStopReasonDto = {
    /**
     * @type string
    */
    reason: string;
    /**
     * @type array | undefined
    */
    details?: string[];
    /**
     * @type string | undefined
    */
    appliedAtDate?: string;
    /**
     * @type boolean | undefined
    */
    appliedInFutureAllowed?: boolean;
    /**
     * @type string | undefined
    */
    refundType?: string;
    /**
     * @type object | undefined
    */
    validForDuration?: Duration;
    /**
     * @description Whether to refund unpaid fees
     * @type boolean | undefined
    */
    billUnpaidFees?: boolean;
    /**
     * @description Business role IDs allowed to use this stop reason. When omitted, all roles can use it.
     * @type array | undefined
    */
    allowedTo?: string[];
    /**
     * @description Only the platform applies this reason (e.g. renewal.stopConfig at term): no user may request it.
     * @type boolean | undefined
    */
    automaticOnly?: boolean;
    /**
     * @type object | undefined
    */
    stopDateNoticePeriod?: ConfigStopDateNoticePeriod;
    /**
     * @type object | undefined
    */
    requestNoticePeriod?: ConfigRequestNoticePeriod;
    /**
     * @description policyholderDocuments categories this reason needs as proof. A reason that declares any cannot be scheduled until all of them sit on the stop branch, and its request goes to the derogation queue for a manager to validate document by document.
     * @type array | undefined
    */
    requiredDocuments?: string[];
};

export type CommissionRange = {
    /**
     * @description Min commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommission?: number;
    /**
     * @description Max commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommission?: number;
    /**
     * @description Default commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    defaultCommission?: number;
    /**
     * @description Min commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommissionLimit?: number;
    /**
     * @description Max commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommissionLimit?: number;
    /**
     * @description Min total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minTotalCommission?: number;
    /**
     * @description Max total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxTotalCommission?: number;
    /**
     * @description Min management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    minManagementFee?: number;
    /**
     * @description Max management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    maxManagementFee?: number;
};

export type DefaultBrokerFeesDto = {
    /**
     * @type object | undefined
    */
    retail?: CommissionRange;
    /**
     * @type object | undefined
    */
    wholesale?: CommissionRange;
};

export const brokerFeesDtoCompensateWithEnum = {
    WHOLESALE_FEE: "WHOLESALE_FEE",
    RETAIL_FEE: "RETAIL_FEE",
    NONE: "NONE"
} as const;

export type BrokerFeesDtoCompensateWithEnumKey = (typeof brokerFeesDtoCompensateWithEnum)[keyof typeof brokerFeesDtoCompensateWithEnum];

export type BrokerFeesDto = {
    /**
     * @type string | undefined
    */
    compensateWith?: BrokerFeesDtoCompensateWithEnumKey;
    /**
     * @type object | undefined
    */
    defaults?: DefaultBrokerFeesDto;
};

export type MigrationConfigDto = {
    /**
     * @type array | undefined
    */
    quoteComponents?: string[];
    /**
     * @description Enable migration of policy internal IDs
     * @type boolean | undefined
    */
    policyInternalIdMigrationEnabled?: boolean;
};

export type InputKeyDto = {
    /**
     * @type string
    */
    inputKey: string;
    /**
     * @type string
    */
    customField: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
};

export type OutputKeyDto = {
    /**
     * @type string
    */
    outputKey: string;
    /**
     * @type string
    */
    customField: string;
};

export const integrationDtoEntityTypeEnum = {
    ASSET: "ASSET",
    CUSTOMER: "CUSTOMER",
    POLICY: "POLICY"
} as const;

export type IntegrationDtoEntityTypeEnumKey = (typeof integrationDtoEntityTypeEnum)[keyof typeof integrationDtoEntityTypeEnum];

export type IntegrationDto = {
    /**
     * @type boolean
    */
    enabled: boolean;
    /**
     * @type string
    */
    target: string;
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    provider: string;
    /**
     * @type string
    */
    entityType: IntegrationDtoEntityTypeEnumKey;
    /**
     * @type array
    */
    inputKeys: InputKeyDto[];
    /**
     * @type array
    */
    outputKeys: OutputKeyDto[];
    /**
     * @type array | undefined
    */
    disabledOnBranchTypes?: string[];
};

export const nonDelegatedQuoteConfigDtoBranchTypesEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type NonDelegatedQuoteConfigDtoBranchTypesEnumKey = (typeof nonDelegatedQuoteConfigDtoBranchTypesEnum)[keyof typeof nonDelegatedQuoteConfigDtoBranchTypesEnum];

export type NonDelegatedQuoteConfigDto = {
    /**
     * @type array
    */
    filter: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilter?: FilterDto[];
    /**
     * @type array | undefined
    */
    branchTypes?: NonDelegatedQuoteConfigDtoBranchTypesEnumKey[];
};

export type NonDelegatedDocumentConfigDto = {
    /**
     * @type array
    */
    documentTypes: string[];
};

export type NonDelegatedConfigDto = {
    /**
     * @type object | undefined
    */
    quote?: NonDelegatedQuoteConfigDto;
    /**
     * @type object | undefined
    */
    documents?: NonDelegatedDocumentConfigDto;
};

export const derogationActionEnum = {
    QUOTE: "QUOTE",
    CONFIRM: "CONFIRM",
    SIGN: "SIGN",
    STOP: "STOP"
} as const;

export type DerogationActionEnumKey = (typeof derogationActionEnum)[keyof typeof derogationActionEnum];

export type DerogationAction = DerogationActionEnumKey;

export type DerogationActionsConfigDto = {
    action: DerogationAction;
    /**
     * @type array
    */
    filter: FilterDto[];
    /**
     * @type array | undefined
    */
    orFilter?: FilterDto[];
};

export type DerogationConfigDto = {
    branchType: BranchType;
    /**
     * @type array
    */
    actions: DerogationActionsConfigDto[];
};

export type ProductQuoteConfig = object;

export const manualComponentConfigDtoComponentTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type ManualComponentConfigDtoComponentTypeEnumKey = (typeof manualComponentConfigDtoComponentTypeEnum)[keyof typeof manualComponentConfigDtoComponentTypeEnum];

export const manualComponentConfigDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type ManualComponentConfigDtoChargeTypeEnumKey = (typeof manualComponentConfigDtoChargeTypeEnum)[keyof typeof manualComponentConfigDtoChargeTypeEnum];

export const manualComponentConfigDtoTargetEnum = {
    POLICY: "POLICY",
    ASSET: "ASSET"
} as const;

export type ManualComponentConfigDtoTargetEnumKey = (typeof manualComponentConfigDtoTargetEnum)[keyof typeof manualComponentConfigDtoTargetEnum];

export const manualComponentConfigDtoValueTypeEnum = {
    ABSOLUTE: "ABSOLUTE",
    PERCENTAGE: "PERCENTAGE"
} as const;

export type ManualComponentConfigDtoValueTypeEnumKey = (typeof manualComponentConfigDtoValueTypeEnum)[keyof typeof manualComponentConfigDtoValueTypeEnum];

export const manualComponentConfigDtoEditableForEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type ManualComponentConfigDtoEditableForEnumKey = (typeof manualComponentConfigDtoEditableForEnum)[keyof typeof manualComponentConfigDtoEditableForEnum];

export const manualComponentConfigDtoIntegrationKeyEnum = {
    RETAIL_MANAGEMENT_FEE: "RETAIL_MANAGEMENT_FEE",
    RETAIL_COMMISSION: "RETAIL_COMMISSION"
} as const;

export type ManualComponentConfigDtoIntegrationKeyEnumKey = (typeof manualComponentConfigDtoIntegrationKeyEnum)[keyof typeof manualComponentConfigDtoIntegrationKeyEnum];

export type ManualComponentConfigDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    componentType: ManualComponentConfigDtoComponentTypeEnumKey;
    /**
     * @type string
    */
    chargeType: ManualComponentConfigDtoChargeTypeEnumKey;
    /**
     * @type string
    */
    target: ManualComponentConfigDtoTargetEnumKey;
    /**
     * @type string
    */
    valueType: ManualComponentConfigDtoValueTypeEnumKey;
    /**
     * @type array | undefined
    */
    editableFor?: ManualComponentConfigDtoEditableForEnumKey[];
    /**
     * @type boolean
    */
    required: boolean;
    /**
     * @type string | undefined
    */
    integrationKey?: ManualComponentConfigDtoIntegrationKeyEnumKey;
    /**
     * @type array | undefined
    */
    referenceComponentIds?: string[];
    /**
     * @type array | undefined
    */
    referenceAmountFields?: string[];
};

export type PublicTierConfig = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type array | undefined
    */
    manualComponents?: ManualComponentConfigDto[];
};

export type PublicQuoteConfig = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    defaultTier: string;
    /**
     * @type array
    */
    tiers: PublicTierConfig[];
};

export const korintProductConfigWithProductNameDtoTypeEnum = {
    INDIVIDUAL: "INDIVIDUAL"
} as const;

export type KorintProductConfigWithProductNameDtoTypeEnumKey = (typeof korintProductConfigWithProductNameDtoTypeEnum)[keyof typeof korintProductConfigWithProductNameDtoTypeEnum];

export const korintProductConfigWithProductNameDtoLinkedServicesEnum = {
    DRIVEQUANT: "DRIVEQUANT",
    SYDIA: "SYDIA"
} as const;

export type KorintProductConfigWithProductNameDtoLinkedServicesEnumKey = (typeof korintProductConfigWithProductNameDtoLinkedServicesEnum)[keyof typeof korintProductConfigWithProductNameDtoLinkedServicesEnum];

export const korintProductConfigWithProductNameDtoGenerateExternalPolicyIdTriggerEnum = {
    NEVER: "NEVER",
    CREATION: "CREATION",
    QUOTE: "QUOTE",
    CONFIRMATION: "CONFIRMATION",
    SIGNATURE: "SIGNATURE",
    NOTHING: "NOTHING"
} as const;

export type KorintProductConfigWithProductNameDtoGenerateExternalPolicyIdTriggerEnumKey = (typeof korintProductConfigWithProductNameDtoGenerateExternalPolicyIdTriggerEnum)[keyof typeof korintProductConfigWithProductNameDtoGenerateExternalPolicyIdTriggerEnum];

export const korintProductConfigWithProductNameDtoListOfIntegrationsEnum = {
    Siv: "Siv",
    Sra: "Sra",
    Compliance: "Compliance",
    Sydia: "Sydia",
    Solvability: "Solvability",
    ExcelApiDatabase: "ExcelApiDatabase"
} as const;

export type KorintProductConfigWithProductNameDtoListOfIntegrationsEnumKey = (typeof korintProductConfigWithProductNameDtoListOfIntegrationsEnum)[keyof typeof korintProductConfigWithProductNameDtoListOfIntegrationsEnum];

export type KorintProductConfigWithProductNameDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string | undefined
    */
    parentProductId?: string;
    /**
     * @type string | undefined
    */
    childProductId?: string;
    /**
     * @type string
    */
    type: KorintProductConfigWithProductNameDtoTypeEnumKey;
    /**
     * @type boolean | undefined
    */
    featureFlag?: boolean;
    /**
     * @description Services to link to the customers
     * @type array | undefined
    */
    linkedServices?: KorintProductConfigWithProductNameDtoLinkedServicesEnumKey[];
    /**
     * @type string | undefined
    */
    externalProductId?: string;
    /**
     * @type string
    */
    generateExternalPolicyIdTrigger: KorintProductConfigWithProductNameDtoGenerateExternalPolicyIdTriggerEnumKey;
    /**
     * @type string
    */
    externalPolicyIdFormat: string;
    /**
     * @type object | undefined
    */
    stopBillingPeriod?: Duration;
    /**
     * @type boolean
    */
    enableMta: boolean;
    /**
     * @description When true, a signed contract only comes into force once the first premium has been collected, in addition to reaching its start date. When false or absent, the start date alone brings it into force.
     * @type boolean | undefined
    */
    requireFirstPaymentToActivate?: boolean;
    /**
     * @description Insurers of the product. A new business may be quoted on any of them; an MTA or a renewal stays on the insurer of the contract\'s quote.
     * @type array | undefined
    */
    insurers?: Insurer[];
    /**
     * @type boolean
    */
    allowDirectSale: boolean;
    /**
     * @type boolean
    */
    allowBrokerSale: boolean;
    /**
     * @type object | undefined
    */
    assetStartedAtLimit?: AssetStartedAtLimitDto;
    /**
     * @type object | undefined
    */
    engagementDuration?: Duration;
    /**
     * @type object | undefined
    */
    periodDuration?: PeriodDurationConfigDto;
    /**
     * @description Échéance principale: every term ends on this day and month instead of the start-date anniversary. Requires renewal disabled and a periodDuration in whole years.
    */
    renewalDayOfYear?: ConfigRenewalDayOfYearDto;
    /**
     * @type array | undefined
    */
    listOfIntegrations?: KorintProductConfigWithProductNameDtoListOfIntegrationsEnumKey[];
    /**
     * @type object | undefined
    */
    autoArchive?: AutoArchiveConfig;
    /**
     * @type array | undefined
    */
    spotTasks?: SpotTaskConfig[];
    /**
     * @description External API the product loads part of its custom fields from.
    */
    dynamicConfig?: ProductDynamicConfigDto;
    /**
     * @description Funnel pages of the dynamic config, filled when it is loaded.
     * @type array | undefined
    */
    steps?: DynamicStepDto[];
    /**
     * @type array
    */
    customerFields: ConfigCustomFieldDto[];
    /**
     * @type array
    */
    policyFields: ConfigCustomFieldDto[];
    /**
     * @type array
    */
    assetFields: ConfigCustomFieldDto[];
    /**
     * @type array
    */
    claimFields: ConfigCustomFieldDto[];
    /**
     * @type object | undefined
    */
    customEvents?: CustomEventsConfigDto;
    /**
     * @type array | undefined
    */
    createUserOn?: string[];
    /**
     * @type array
    */
    policyAggregateFields: ConfigAggregateFieldDto[];
    /**
     * @type array
    */
    customerAggregateFields: ConfigAggregateFieldDto[];
    /**
     * @type array
    */
    assetAggregateFields: ConfigAggregateFieldDto[];
    /**
     * @type object | undefined
    */
    individualPolicyConfig?: IndividualPolicyConfigDto;
    /**
     * @type object | undefined
    */
    claims?: ClaimsConfigDto;
    /**
     * @description Document fraud detection config (Phase 1: vendor fan-out per docCategory). `enabled = false` (or absent) is the no-op default.
    */
    fraudDetection?: FraudDetectionConfigDto;
    /**
     * @type object | undefined
    */
    branchSubTypes?: BranchSubTypeConfigDto;
    /**
     * @type object
    */
    payment: PaymentConfigDto;
    /**
     * @type object | undefined
    */
    unpaid?: UnpaidConfigDto;
    /**
     * @type object
    */
    billing: ConfigBilling;
    /**
     * @type array | undefined
    */
    nonRefundableComponents?: string[];
    renewal?: (ConfigRenewalEnabled | ConfigRenewalDisabled);
    /**
     * @type object | undefined
    */
    repricing?: ConfigRepricing;
    /**
     * @type array
    */
    commonDocuments: ConfigCommonDocumentDto[];
    /**
     * @type array
    */
    generatedDocuments: (ConfigGeneratedDocumentCarboneDto | ConfigGeneratedDocumentStaticDto)[];
    /**
     * @type array
    */
    policyholderDocuments: ConfigPolicyholderDocumentDto[];
    /**
     * @description Governs the completeness reminder ladder only; document accept/reject is unconditional.
    */
    documentCollection?: DocumentCollectionConfigDto;
    /**
     * @type array | undefined
    */
    claimDocuments?: ConfigClaimDocumentDto[];
    /**
     * @type object
    */
    signature: SignatureConfigDto;
    /**
     * @description Emails specific configuration
    */
    emailsConfig?: EmailsConfig;
    /**
     * @type array | undefined
    */
    emails?: ConfigEmailDto[];
    /**
     * @type object | undefined
    */
    priorContractCancellation?: ConfigPriorContractCancellation;
    /**
     * @type array | undefined
    */
    policyStopReasons?: ConfigPolicyStopReasonDto[];
    /**
     * @type object | undefined
    */
    fees?: BrokerFeesDto;
    /**
     * @type object | undefined
    */
    migration?: MigrationConfigDto;
    /**
     * @type array | undefined
    */
    integrations?: IntegrationDto[];
    /**
     * @type object | undefined
    */
    nonDelegatedConfig?: NonDelegatedConfigDto;
    /**
     * @description Maximum number of assets allowed per policy
     * @minLength 1
     * @type number | undefined
    */
    maxAssets?: number;
    /**
     * @type array | undefined
    */
    derogation?: DerogationConfigDto[];
    /**
     * @description AI configuration (classification, extraction)
    */
    ai?: AIConfig;
    /**
     * @description Declarative display line formulas for price breakdown rendering.
    */
    priceBreakdown?: ProductQuoteConfig;
    /**
     * @description Configuration-driven quote system. When defined, replaces legacy per-product quote engines.
    */
    quoteConfig?: ProductQuoteConfig;
    /**
     * @type string
    */
    tenantName: string;
    /**
     * @type string
    */
    productName: string;
    /**
     * @type object | undefined
    */
    publicQuoteConfig?: PublicQuoteConfig;
};

export type GetPublicTenantConfigByDomainOutput = {
    /**
     * @description Speech-to-text (dictation) config. When set, dictation is enabled for this tenant; when absent, dictation is off. Exposed in the public tenant config so the frontend can gate the mic.
    */
    speechToText?: SpeechToTextConfig;
    /**
     * @description External links (attestations, notices, legal pages, …) rendered in the tenant frontend on the login page, the home page and the sidebar. Exposed in the public tenant config.
     * @type array | undefined
    */
    externalLinks?: TenantExternalLinkDto[];
    /**
     * @description Claims-portal capabilities and content for the tenant frontend (legacy-platform notice, WhatsApp entry point, claims-platform contact details). Exposed in the public tenant config so the frontend gates on capabilities rather than on the tenant id. Whether the self-service claim funnel exists is a property of the claims product, not the tenant — see `isSelfServiceClaimIntakeEnabled` on the public product config.
    */
    claimsPortal?: ClaimsPortalConfigDto;
    /**
     * @description Human-readable tenant name shown to end users in the tenant frontend. Falls back to the technical tenant ID when unset.
     * @type string | undefined
    */
    displayName?: string;
    /**
     * @type array
    */
    brokerageFirmCustomFields: BrokerageFirmCustomFieldConfigDto[];
    /**
     * @type object | undefined
    */
    distributionRequest?: DistributionRequestConfigDto;
    /**
     * @type object | undefined
    */
    brokerageFirmDocuments?: BrokerageFirmDocumentsConfigDto;
    /**
     * @description Controls the default choice (upload now vs. later) on the document prefill funnel step
    */
    documentPrefill?: DocumentPrefillConfigDto;
    /**
     * @type array | undefined
    */
    reports?: ReportConfigDto[];
    /**
     * @description Metabase dashboard tabs configuration (takes priority over metabaseDashboardId)
     * @type array | undefined
    */
    metabaseDashboardIds?: MetabaseDashboardTabConfig[];
    /**
     * @description Tenant-level AI configuration (classification, extraction)
    */
    ai?: AIConfig;
    /**
     * @description Visual theming configuration (colors, logos, branding)
    */
    theme: TenantThemeConfigDto;
    /**
     * @description Third-party scripts to inject into the tenant frontend at runtime (e.g. chat widgets). Each entry is rendered as a <script> tag with its data-* attributes by the frontend ExternalScriptsLoader.
     * @type array | undefined
    */
    externalScripts?: ExternalScriptConfigDto[];
    /**
     * @description Cognito web login (user pool, OAuth domain); absent when brokers sign in only through `federation`
    */
    authentication?: TenantAuthenticationConfigDto;
    /**
     * @type string
    */
    tenantName: string;
    /**
     * @description Product ids active (feature-flag-enabled) for this tenant in this environment.
     * @type array
    */
    availableProductIds: string[];
    /**
     * @description Resolved tenant ID for the requested domain
     * @type string
    */
    tenantId: string;
};

export type PerilConfig = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type array | undefined
    */
    options?: string[];
    /**
     * @type array | undefined
    */
    customFields?: string[];
};

export type QuoteConfig = {
    /**
     * @type array
    */
    availableTiers: string[];
    /**
     * @type array
    */
    availableExcesses: string[];
    /**
     * @type array
    */
    availablePerils: PerilConfig[];
    /**
     * @type object
    */
    defaultConfig: ConfigQuoteDefaultOptionsDto;
    /**
     * @type array
    */
    availableConfigs: QuoteAvailableOptionsDto[];
};

export type PublicClaimTypeDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    label: string;
};

export const getPublicProductConfigOutputTypeEnum = {
    INDIVIDUAL: "INDIVIDUAL"
} as const;

export type GetPublicProductConfigOutputTypeEnumKey = (typeof getPublicProductConfigOutputTypeEnum)[keyof typeof getPublicProductConfigOutputTypeEnum];

export const getPublicProductConfigOutputLinkedServicesEnum = {
    DRIVEQUANT: "DRIVEQUANT",
    SYDIA: "SYDIA"
} as const;

export type GetPublicProductConfigOutputLinkedServicesEnumKey = (typeof getPublicProductConfigOutputLinkedServicesEnum)[keyof typeof getPublicProductConfigOutputLinkedServicesEnum];

export const getPublicProductConfigOutputGenerateExternalPolicyIdTriggerEnum = {
    NEVER: "NEVER",
    CREATION: "CREATION",
    QUOTE: "QUOTE",
    CONFIRMATION: "CONFIRMATION",
    SIGNATURE: "SIGNATURE",
    NOTHING: "NOTHING"
} as const;

export type GetPublicProductConfigOutputGenerateExternalPolicyIdTriggerEnumKey = (typeof getPublicProductConfigOutputGenerateExternalPolicyIdTriggerEnum)[keyof typeof getPublicProductConfigOutputGenerateExternalPolicyIdTriggerEnum];

export const getPublicProductConfigOutputListOfIntegrationsEnum = {
    Siv: "Siv",
    Sra: "Sra",
    Compliance: "Compliance",
    Sydia: "Sydia",
    Solvability: "Solvability",
    ExcelApiDatabase: "ExcelApiDatabase"
} as const;

export type GetPublicProductConfigOutputListOfIntegrationsEnumKey = (typeof getPublicProductConfigOutputListOfIntegrationsEnum)[keyof typeof getPublicProductConfigOutputListOfIntegrationsEnum];

export const getPublicProductConfigOutputClaimLookupModeEnum = {
    none: "none",
    partner: "partner",
    "policy-reference": "policy-reference"
} as const;

export type GetPublicProductConfigOutputClaimLookupModeEnumKey = (typeof getPublicProductConfigOutputClaimLookupModeEnum)[keyof typeof getPublicProductConfigOutputClaimLookupModeEnum];

export type GetPublicProductConfigOutput = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    type: GetPublicProductConfigOutputTypeEnumKey;
    /**
     * @description Services to link to the customers
     * @type array | undefined
    */
    linkedServices?: GetPublicProductConfigOutputLinkedServicesEnumKey[];
    /**
     * @type string | undefined
    */
    externalProductId?: string;
    /**
     * @type string
    */
    generateExternalPolicyIdTrigger: GetPublicProductConfigOutputGenerateExternalPolicyIdTriggerEnumKey;
    /**
     * @type string
    */
    externalPolicyIdFormat: string;
    /**
     * @type boolean
    */
    enableMta: boolean;
    /**
     * @description When true, a signed contract only comes into force once the first premium has been collected, in addition to reaching its start date. When false or absent, the start date alone brings it into force.
     * @type boolean | undefined
    */
    requireFirstPaymentToActivate?: boolean;
    /**
     * @description Insurers of the product. A new business may be quoted on any of them; an MTA or a renewal stays on the insurer of the contract\'s quote.
     * @type array | undefined
    */
    insurers?: Insurer[];
    /**
     * @type boolean
    */
    allowDirectSale: boolean;
    /**
     * @type boolean
    */
    allowBrokerSale: boolean;
    /**
     * @type object | undefined
    */
    assetStartedAtLimit?: AssetStartedAtLimitDto;
    /**
     * @type object | undefined
    */
    engagementDuration?: Duration;
    /**
     * @type array | undefined
    */
    listOfIntegrations?: GetPublicProductConfigOutputListOfIntegrationsEnumKey[];
    /**
     * @description Funnel pages of the dynamic config, filled when it is loaded.
     * @type array | undefined
    */
    steps?: DynamicStepDto[];
    /**
     * @type array
    */
    customerFields: ConfigCustomFieldDto[];
    /**
     * @type array
    */
    policyFields: ConfigCustomFieldDto[];
    /**
     * @type array
    */
    assetFields: ConfigCustomFieldDto[];
    /**
     * @type object | undefined
    */
    customEvents?: CustomEventsConfigDto;
    /**
     * @type array
    */
    policyAggregateFields: ConfigAggregateFieldDto[];
    /**
     * @type array
    */
    customerAggregateFields: ConfigAggregateFieldDto[];
    /**
     * @type array
    */
    assetAggregateFields: ConfigAggregateFieldDto[];
    /**
     * @type object | undefined
    */
    claims?: ClaimsConfigDto;
    /**
     * @type object
    */
    payment: PaymentConfigDto;
    /**
     * @type object
    */
    billing: ConfigBilling;
    /**
     * @type array | undefined
    */
    nonRefundableComponents?: string[];
    renewal?: (ConfigRenewalEnabled | ConfigRenewalDisabled);
    /**
     * @type array
    */
    commonDocuments: ConfigCommonDocumentDto[];
    /**
     * @type array
    */
    generatedDocuments: (ConfigGeneratedDocumentCarboneDto | ConfigGeneratedDocumentStaticDto)[];
    /**
     * @type array
    */
    policyholderDocuments: ConfigPolicyholderDocumentDto[];
    /**
     * @description Governs the completeness reminder ladder only; document accept/reject is unconditional.
    */
    documentCollection?: DocumentCollectionConfigDto;
    /**
     * @type array | undefined
    */
    claimDocuments?: ConfigClaimDocumentDto[];
    /**
     * @type object
    */
    signature: SignatureConfigDto;
    /**
     * @type array | undefined
    */
    policyStopReasons?: ConfigPolicyStopReasonDto[];
    /**
     * @type object | undefined
    */
    nonDelegatedConfig?: NonDelegatedConfigDto;
    /**
     * @description AI configuration (classification, extraction)
    */
    ai?: AIConfig;
    /**
     * @type string
    */
    productName: string;
    /**
     * @type object | undefined
    */
    publicQuoteConfig?: PublicQuoteConfig;
    /**
     * @type object | undefined
    */
    quote?: QuoteConfig;
    /**
     * @description True when the product uses the new quoteConfig format (tier-based perils). False/absent for legacy individualPolicyConfig.quote products.
     * @type boolean | undefined
    */
    usesQuoteConfig?: boolean;
    /**
     * @description Whether AR24 formal notice (mise en demeure) is enabled for this product.
     * @type boolean
    */
    isFormalNoticeEnabled: boolean;
    /**
     * @description Whether the policyholder can ask the broker to cancel their prior contract with another insurer (Loi Hamon), declared on the policy as `priorContract`.
     * @type boolean
    */
    isPriorContractCancellationEnabled: boolean;
    /**
     * @description Whether the AR24 non-renewal letter can be sent to policyholders of this product.
     * @type boolean
    */
    isNonRenewalEnabled: boolean;
    /**
     * @description Whether claimants can declare a claim on this product themselves, through the self-service funnel. Read it across every id in `availableProductIds` to find which product backs the funnel.
     * @type boolean
    */
    isSelfServiceClaimIntakeEnabled: boolean;
    /**
     * @description Which identifier the self-service funnel\'s first screen asks for. `none` — there is no first screen: the claimant is the signed-in user, resolved from their existing customer relations. `partner` — an identifier only an external claims partner can resolve, such as a card number. `policy-reference` — the policy\'s external id, resolved against Korint\'s own data. Lets the frontend pick its copy from a capability instead of branching on a tenant id.
     * @type string
    */
    claimLookupMode: GetPublicProductConfigOutputClaimLookupModeEnumKey;
    /**
     * @description Claim types the funnel\'s picker offers. Present only when `claimLookupMode` is `none` — every other mode receives the catalogue from its lookup step instead.
     * @type array | undefined
    */
    claimTypes?: PublicClaimTypeDto[];
    /**
     * @description Largest single supporting document the claimant may upload on a claim, in bytes. Absent when the product sets no limit. The funnel refuses a bigger file at pick time rather than letting the partner drop it after upload.
     * @type number | undefined
    */
    claimDocumentMaxSizeBytes?: number;
};

export type KorintPublicTenantConfigDto = {
    /**
     * @description Speech-to-text (dictation) config. When set, dictation is enabled for this tenant; when absent, dictation is off. Exposed in the public tenant config so the frontend can gate the mic.
    */
    speechToText?: SpeechToTextConfig;
    /**
     * @description External links (attestations, notices, legal pages, …) rendered in the tenant frontend on the login page, the home page and the sidebar. Exposed in the public tenant config.
     * @type array | undefined
    */
    externalLinks?: TenantExternalLinkDto[];
    /**
     * @description Claims-portal capabilities and content for the tenant frontend (legacy-platform notice, WhatsApp entry point, claims-platform contact details). Exposed in the public tenant config so the frontend gates on capabilities rather than on the tenant id. Whether the self-service claim funnel exists is a property of the claims product, not the tenant — see `isSelfServiceClaimIntakeEnabled` on the public product config.
    */
    claimsPortal?: ClaimsPortalConfigDto;
    /**
     * @description Human-readable tenant name shown to end users in the tenant frontend. Falls back to the technical tenant ID when unset.
     * @type string | undefined
    */
    displayName?: string;
    /**
     * @type array
    */
    brokerageFirmCustomFields: BrokerageFirmCustomFieldConfigDto[];
    /**
     * @type object | undefined
    */
    distributionRequest?: DistributionRequestConfigDto;
    /**
     * @type object | undefined
    */
    brokerageFirmDocuments?: BrokerageFirmDocumentsConfigDto;
    /**
     * @description Controls the default choice (upload now vs. later) on the document prefill funnel step
    */
    documentPrefill?: DocumentPrefillConfigDto;
    /**
     * @type array | undefined
    */
    reports?: ReportConfigDto[];
    /**
     * @description Metabase dashboard tabs configuration (takes priority over metabaseDashboardId)
     * @type array | undefined
    */
    metabaseDashboardIds?: MetabaseDashboardTabConfig[];
    /**
     * @description Tenant-level AI configuration (classification, extraction)
    */
    ai?: AIConfig;
    /**
     * @description Visual theming configuration (colors, logos, branding)
    */
    theme: TenantThemeConfigDto;
    /**
     * @description Third-party scripts to inject into the tenant frontend at runtime (e.g. chat widgets). Each entry is rendered as a <script> tag with its data-* attributes by the frontend ExternalScriptsLoader.
     * @type array | undefined
    */
    externalScripts?: ExternalScriptConfigDto[];
    /**
     * @description Cognito web login (user pool, OAuth domain); absent when brokers sign in only through `federation`
    */
    authentication?: TenantAuthenticationConfigDto;
    /**
     * @type string
    */
    tenantName: string;
    /**
     * @description Product ids active (feature-flag-enabled) for this tenant in this environment.
     * @type array
    */
    availableProductIds: string[];
};

export type ProductDto = {
    /**
     * @type string
    */
    id: string;
};

export type GetProductsForTenantOutput = {
    /**
     * @type array
    */
    products: ProductDto[];
};

export type InvalidBusinessRoleDto = {
    /**
     * @type string
    */
    businessRoleId: string;
    /**
     * @type array
    */
    existingBusinessRoles: string[];
};

export const invalidBusinessRoleErrorDtoCodeEnum = {
    INVALID_BUSINESS_ROLE: "INVALID_BUSINESS_ROLE"
} as const;

export type InvalidBusinessRoleErrorDtoCodeEnumKey = (typeof invalidBusinessRoleErrorDtoCodeEnum)[keyof typeof invalidBusinessRoleErrorDtoCodeEnum];

export type InvalidBusinessRoleErrorDto = {
    /**
     * @type string
    */
    code: InvalidBusinessRoleErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBusinessRoleDto;
};

export const actionsEnum = {
    LIST: "LIST",
    GET_ACCOUNTING_SUMMARY: "GET_ACCOUNTING_SUMMARY",
    SEARCH: "SEARCH",
    COUNT: "COUNT",
    SUGGEST: "SUGGEST",
    VALIDATE_DOCUMENT_UPLOAD: "VALIDATE_DOCUMENT_UPLOAD",
    SET_DOCUMENT_CATEGORY: "SET_DOCUMENT_CATEGORY",
    GET_PRODUCT_CONFIGURATION: "GET_PRODUCT_CONFIGURATION",
    MANAGE_SHARED_EMAIL_ACCOUNT: "MANAGE_SHARED_EMAIL_ACCOUNT",
    GET_SPEECH_TO_TEXT_CREDENTIALS: "GET_SPEECH_TO_TEXT_CREDENTIALS",
    EDIT_CUSTOMER: "EDIT_CUSTOMER",
    GET_CUSTOMER: "GET_CUSTOMER",
    GET_INVOICING_SCHEDULE: "GET_INVOICING_SCHEDULE",
    INITIALIZE_CUSTOMER: "INITIALIZE_CUSTOMER",
    DELETE_CUSTOMER_FROM_POLICY: "DELETE_CUSTOMER_FROM_POLICY",
    CREATE_CUSTOMER_FOR_POLICY: "CREATE_CUSTOMER_FOR_POLICY",
    LIST_ALL_INVOICES_FROM_CUSTOMER: "LIST_ALL_INVOICES_FROM_CUSTOMER",
    PUSH_CUSTOMER_EVENT: "PUSH_CUSTOMER_EVENT",
    LIST_CUSTOMER_RELATIONS: "LIST_CUSTOMER_RELATIONS",
    DELETE_RELATION: "DELETE_RELATION",
    RETRY_CHARGE: "RETRY_CHARGE",
    GENERATE_MANDATE_SIGNATURE_REQUEST: "GENERATE_MANDATE_SIGNATURE_REQUEST",
    GET_BANK_TRANSFER_ACCOUNT: "GET_BANK_TRANSFER_ACCOUNT",
    GET_CUSTOMER_PAYMENT_METHODS: "GET_CUSTOMER_PAYMENT_METHODS",
    LIST_ALL_PAYMENTS_FROM_CUSTOMER: "LIST_ALL_PAYMENTS_FROM_CUSTOMER",
    GET_PAYMENT_METHOD_SETUP_SECRET: "GET_PAYMENT_METHOD_SETUP_SECRET",
    UPDATE_PAYMENT_MODE: "UPDATE_PAYMENT_MODE",
    UPDATE_PREFERRED_PAYMENT_METHOD: "UPDATE_PREFERRED_PAYMENT_METHOD",
    GET_CUSTOMER_BALANCE: "GET_CUSTOMER_BALANCE",
    DELETE_PAYMENT_METHOD: "DELETE_PAYMENT_METHOD",
    MANUALLY_MARK_INVOICE: "MANUALLY_MARK_INVOICE",
    CALCULATE_POLICY_QUOTE: "CALCULATE_POLICY_QUOTE",
    CONFIRM_POLICY: "CONFIRM_POLICY",
    CREATE_COMPLIANCE_CHECK: "CREATE_COMPLIANCE_CHECK",
    LIST_COMPLIANCE_CHECKS: "LIST_COMPLIANCE_CHECKS",
    CREATE_COMPLIANCE_ALERT: "CREATE_COMPLIANCE_ALERT",
    LIST_COMPLIANCE_ALERTS: "LIST_COMPLIANCE_ALERTS",
    ACKNOWLEDGE_COMPLIANCE_ALERT: "ACKNOWLEDGE_COMPLIANCE_ALERT",
    DELETE_POLICY_DOCUMENTS: "DELETE_POLICY_DOCUMENTS",
    OVERRIDE_DOCUMENT_VALIDITY: "OVERRIDE_DOCUMENT_VALIDITY",
    EDIT_POLICY: "EDIT_POLICY",
    EDIT_POLICY_EXTERNAL_ID: "EDIT_POLICY_EXTERNAL_ID",
    GENERATE_POLICY_SIGNATURE_REQUEST: "GENERATE_POLICY_SIGNATURE_REQUEST",
    GENERATE_UPLOAD_DOCUMENT_URL: "GENERATE_UPLOAD_DOCUMENT_URL",
    GET_POLICY: "GET_POLICY",
    GET_POLICY_DOCUMENT_FRAUD: "GET_POLICY_DOCUMENT_FRAUD",
    GET_PREMIUM_SCHEDULE: "GET_PREMIUM_SCHEDULE",
    LIST_ALL_ASSETS_FROM_POLICY: "LIST_ALL_ASSETS_FROM_POLICY",
    LIST_ALL_CUSTOMERS_FROM_POLICY: "LIST_ALL_CUSTOMERS_FROM_POLICY",
    LIST_BRANCHES: "LIST_BRANCHES",
    LIST_POLICY_DOCUMENTS: "LIST_POLICY_DOCUMENTS",
    REVIEW_POLICY_DOCUMENT: "REVIEW_POLICY_DOCUMENT",
    REVIEW_POLICY_DOCUMENT_FRAUD: "REVIEW_POLICY_DOCUMENT_FRAUD",
    LIST_POLICY_EVENTS: "LIST_POLICY_EVENTS",
    PLAN_POLICY_TASKS: "PLAN_POLICY_TASKS",
    PUSH_POLICY_EVENT: "PUSH_POLICY_EVENT",
    QUOTE_POLICY: "QUOTE_POLICY",
    STOP_POLICY: "STOP_POLICY",
    FINALIZE_RENEWAL: "FINALIZE_RENEWAL",
    INVITE: "INVITE",
    SUSPEND_POLICY: "SUSPEND_POLICY",
    ACTIVATE_POLICY: "ACTIVATE_POLICY",
    GET_POLICY_EXTERNAL_QUOTE: "GET_POLICY_EXTERNAL_QUOTE",
    SET_POLICY_FEES: "SET_POLICY_FEES",
    MANUAL_QUOTE_POLICY: "MANUAL_QUOTE_POLICY",
    NON_DELEGATED_GENERATE_DOCUMENT: "NON_DELEGATED_GENERATE_DOCUMENT",
    UPDATE_POLICY_QUOTE: "UPDATE_POLICY_QUOTE",
    GET_AVAILABLE_PRICING: "GET_AVAILABLE_PRICING",
    COMPUTE_PRICING: "COMPUTE_PRICING",
    GET_PRICE: "GET_PRICE",
    SAVE_PRICING_SELECTION: "SAVE_PRICING_SELECTION",
    CREATE_BRANCH: "CREATE_BRANCH",
    FORK_BRANCH: "FORK_BRANCH",
    INVALIDATE_BRANCH: "INVALIDATE_BRANCH",
    EDIT_BRANCH: "EDIT_BRANCH",
    CHOOSE_ASSET_OPTIONS: "CHOOSE_ASSET_OPTIONS",
    CREATE_ASSET: "CREATE_ASSET",
    EDIT_ASSET: "EDIT_ASSET",
    GET_ASSET: "GET_ASSET",
    GET_ASSET_EXTERNAL_QUOTE: "GET_ASSET_EXTERNAL_QUOTE",
    PUSH_ASSET_EVENT: "PUSH_ASSET_EVENT",
    REMOVE_ASSET: "REMOVE_ASSET",
    REPLACE_ASSET: "REPLACE_ASSET",
    CREATE_DEROGATION: "CREATE_DEROGATION",
    APPROVE_DEROGATION: "APPROVE_DEROGATION",
    DENY_DEROGATION: "DENY_DEROGATION",
    CHECK_DEROGATION_REQUIREMENT: "CHECK_DEROGATION_REQUIREMENT",
    CREATE_CLAIM: "CREATE_CLAIM",
    DELETE_CLAIM: "DELETE_CLAIM",
    GET_CLAIM: "GET_CLAIM",
    EDIT_CLAIM: "EDIT_CLAIM",
    LIST_CLAIMS: "LIST_CLAIMS",
    LIST_CLAIMS_MANAGEMENT: "LIST_CLAIMS_MANAGEMENT",
    MANAGE_OWN_CLAIM: "MANAGE_OWN_CLAIM",
    LIST_OWN_CLAIMS: "LIST_OWN_CLAIMS",
    FILE_CLAIM: "FILE_CLAIM",
    FILE_CLAIM_ON_BEHALF: "FILE_CLAIM_ON_BEHALF",
    MANAGE_CLAIM_ON_BEHALF: "MANAGE_CLAIM_ON_BEHALF",
    CORRECT_DOCUMENT_FRAUD_VERDICT: "CORRECT_DOCUMENT_FRAUD_VERDICT",
    TRANSITION_CLAIM: "TRANSITION_CLAIM",
    CREATE_COMMENT: "CREATE_COMMENT",
    UPDATE_COMMENT: "UPDATE_COMMENT",
    DELETE_COMMENT: "DELETE_COMMENT",
    GET_COMMENT: "GET_COMMENT",
    LIST_COMMENTS: "LIST_COMMENTS",
    LIST_INTERNAL_NOTES: "LIST_INTERNAL_NOTES",
    GET_INTERNAL_NOTE: "GET_INTERNAL_NOTE",
    CREATE_INTERNAL_NOTE: "CREATE_INTERNAL_NOTE",
    UPDATE_INTERNAL_NOTE: "UPDATE_INTERNAL_NOTE",
    DELETE_INTERNAL_NOTE: "DELETE_INTERNAL_NOTE",
    CREATE_CONVERSATION: "CREATE_CONVERSATION",
    LIST_CONVERSATIONS: "LIST_CONVERSATIONS",
    GET_CONVERSATION: "GET_CONVERSATION",
    GET_CONVERSATION_MESSAGES: "GET_CONVERSATION_MESSAGES",
    SEND_CONVERSATION_MESSAGE: "SEND_CONVERSATION_MESSAGE",
    DELETE_CONVERSATION: "DELETE_CONVERSATION",
    SEND_CONVERSATION_FEEDBACK: "SEND_CONVERSATION_FEEDBACK",
    CREATE_NOTIFICATION: "CREATE_NOTIFICATION",
    DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
    GET_NOTIFICATION: "GET_NOTIFICATION",
    UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
    LIST_NOTIFICATIONS: "LIST_NOTIFICATIONS",
    CREATE_REPORT: "CREATE_REPORT",
    GET_REPORT: "GET_REPORT",
    GENERATE_ON_DEMAND_DOCUMENT: "GENERATE_ON_DEMAND_DOCUMENT",
    GENERATE_ON_DEMAND_POLICYHOLDER_DOCUMENT: "GENERATE_ON_DEMAND_POLICYHOLDER_DOCUMENT",
    BROKER_AT_ME: "BROKER_AT_ME",
    CREATE_BROKER: "CREATE_BROKER",
    EDIT_BROKER: "EDIT_BROKER",
    DELETE_BROKER: "DELETE_BROKER",
    GET_BROKER: "GET_BROKER",
    LIST_BROKERS: "LIST_BROKERS",
    LIST_BROKER_INVITES: "LIST_BROKER_INVITES",
    DELETE_BROKER_INVITE: "DELETE_BROKER_INVITE",
    GET_PLATFORM_CONFIG: "GET_PLATFORM_CONFIG",
    UPDATE_PLATFORM_CONFIG: "UPDATE_PLATFORM_CONFIG",
    GET_BROKERAGE_FIRM: "GET_BROKERAGE_FIRM",
    EDIT_BROKERAGE_FIRM: "EDIT_BROKERAGE_FIRM",
    LIST_BROKERAGE_FIRM_DOCUMENTS: "LIST_BROKERAGE_FIRM_DOCUMENTS",
    GENERATE_BROKERAGE_FIRM_DOCUMENT_UPLOAD_URL: "GENERATE_BROKERAGE_FIRM_DOCUMENT_UPLOAD_URL",
    DELETE_BROKERAGE_FIRM_DOCUMENT: "DELETE_BROKERAGE_FIRM_DOCUMENT",
    REVIEW_BROKERAGE_FIRM_DOCUMENT: "REVIEW_BROKERAGE_FIRM_DOCUMENT",
    GET_BROKERAGE_FIRM_DOCUMENT_FRAUD: "GET_BROKERAGE_FIRM_DOCUMENT_FRAUD",
    REVIEW_BROKERAGE_FIRM_DOCUMENT_FRAUD: "REVIEW_BROKERAGE_FIRM_DOCUMENT_FRAUD",
    LIST_ALL_POLICIES_FROM_BROKERAGE_FIRM: "LIST_ALL_POLICIES_FROM_BROKERAGE_FIRM",
    LIST_LIVE_POLICIES_FROM_BROKERAGE_FIRM: "LIST_LIVE_POLICIES_FROM_BROKERAGE_FIRM",
    LIST_BROKERAGE_FIRM_DEROGATIONS: "LIST_BROKERAGE_FIRM_DEROGATIONS",
    GET_ACCOUNTING_SUMMARY_FOR_BROKERAGE_FIRM: "GET_ACCOUNTING_SUMMARY_FOR_BROKERAGE_FIRM",
    INVITE_BROKER: "INVITE_BROKER",
    LIST_CHILD_BROKERAGE_FIRMS: "LIST_CHILD_BROKERAGE_FIRMS",
    GENERATE_BROKERAGE_FIRM_SIGNATURE_REQUEST: "GENERATE_BROKERAGE_FIRM_SIGNATURE_REQUEST",
    GENERATE_BROKERAGE_FIRM_MANDATE_SIGNATURE_REQUEST: "GENERATE_BROKERAGE_FIRM_MANDATE_SIGNATURE_REQUEST",
    GET_PAYMENT_METHODS: "GET_PAYMENT_METHODS",
    CREATE_DISTRIBUTION_REQUEST: "CREATE_DISTRIBUTION_REQUEST",
    GET_DISTRIBUTION_REQUEST: "GET_DISTRIBUTION_REQUEST",
    LIST_DISTRIBUTION_REQUESTS: "LIST_DISTRIBUTION_REQUESTS",
    DELETE_DISTRIBUTION_REQUEST: "DELETE_DISTRIBUTION_REQUEST",
    APPROVE_DISTRIBUTION_REQUEST: "APPROVE_DISTRIBUTION_REQUEST",
    DENY_DISTRIBUTION_REQUEST: "DENY_DISTRIBUTION_REQUEST",
    REVOKE_DISTRIBUTION_REQUEST: "REVOKE_DISTRIBUTION_REQUEST",
    WAITING_FOR_SIGNATURE_DISTRIBUTION_REQUEST: "WAITING_FOR_SIGNATURE_DISTRIBUTION_REQUEST",
    EDIT_BROKERAGE_FEE: "EDIT_BROKERAGE_FEE",
    LIST_BROKERAGE_FEES: "LIST_BROKERAGE_FEES",
    DELETE_BROKERAGE_FEE: "DELETE_BROKERAGE_FEE",
    CREATE_BROKERAGE_FEE: "CREATE_BROKERAGE_FEE",
    HISCOX_GET_ACTIVITIES_BY_SECTOR: "HISCOX_GET_ACTIVITIES_BY_SECTOR",
    SRA_GET_FACETS: "SRA_GET_FACETS",
    SRA_GET_DETAILS: "SRA_GET_DETAILS",
    SRA_GET_VERSIONS: "SRA_GET_VERSIONS",
    SIV_SEARCH: "SIV_SEARCH",
    SIREN_SEARCH: "SIREN_SEARCH",
    ADDRESS_AUTOCOMPLETE: "ADDRESS_AUTOCOMPLETE",
    BIKE_EMPLOYEE_GET_PORTFOLIO: "BIKE_EMPLOYEE_GET_PORTFOLIO",
    YEET_SURCHARGE: "YEET_SURCHARGE",
    YEET_GET_DRIVEQUANT_AVERAGE: "YEET_GET_DRIVEQUANT_AVERAGE",
    YEET_LIST_POSSIBLE_DRIVEQUANT_USERS: "YEET_LIST_POSSIBLE_DRIVEQUANT_USERS",
    YEET_ATTACH_DRIVEQUANT_USER_ID_TO_CUSTOMER: "YEET_ATTACH_DRIVEQUANT_USER_ID_TO_CUSTOMER",
    AXECE_SURCHARGE: "AXECE_SURCHARGE",
    AXECE_GET_DRIVEQUANT_AVERAGE: "AXECE_GET_DRIVEQUANT_AVERAGE",
    AXECE_LIST_POSSIBLE_DRIVEQUANT_USERS: "AXECE_LIST_POSSIBLE_DRIVEQUANT_USERS",
    AXECE_ATTACH_DRIVEQUANT_USER_ID_TO_CUSTOMER: "AXECE_ATTACH_DRIVEQUANT_USER_ID_TO_CUSTOMER",
    GENERATE_FORMAL_NOTICE: "GENERATE_FORMAL_NOTICE",
    LIST_PRODUCT_DOCUMENTS: "LIST_PRODUCT_DOCUMENTS",
    GET_METABASE_TOKEN: "GET_METABASE_TOKEN"
} as const;

export type ActionsEnumKey = (typeof actionsEnum)[keyof typeof actionsEnum];

export type Actions = ActionsEnumKey;

export const subjectTypeEnum = {
    CUSTOMER: "CUSTOMER",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    CLAIM: "CLAIM",
    NOTE: "NOTE",
    NONE: "NONE"
} as const;

export type SubjectTypeEnumKey = (typeof subjectTypeEnum)[keyof typeof subjectTypeEnum];

export type SubjectType = SubjectTypeEnumKey;

export type ProductPermissionDto = {
    action: Actions;
    subject: SubjectType;
    /**
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @type object | undefined
    */
    conditions?: object;
};

export type GetBusinessRolePermissionsOutput = {
    /**
     * @type array
    */
    allowedPermissions: ProductPermissionDto[];
    /**
     * @type array
    */
    forbiddenPermissions: ProductPermissionDto[];
};

export type EvaluateFeatureFlagOutput = {
    /**
     * @type boolean
    */
    enabled: boolean;
};

export const flagOverrideDtoContextKeyEnum = {
    tenantId: "tenantId",
    productId: "productId",
    userId: "userId",
    userEmail: "userEmail"
} as const;

export type FlagOverrideDtoContextKeyEnumKey = (typeof flagOverrideDtoContextKeyEnum)[keyof typeof flagOverrideDtoContextKeyEnum];

export type FlagOverrideDto = {
    /**
     * @type string
    */
    contextKey: FlagOverrideDtoContextKeyEnumKey;
    /**
     * @type string
    */
    equals: string;
    /**
     * @type boolean
    */
    enabled: boolean;
};

export const featureFlagDtoKeyEnum = {
    perm_ai_classification: "perm_ai_classification",
    perm_ai_extraction: "perm_ai_extraction",
    perm_ai_validity: "perm_ai_validity",
    perm_ai_autofill: "perm_ai_autofill",
    perm_ai_claim_doc_classifier: "perm_ai_claim_doc_classifier",
    perm_ai_claim_doc_extractor: "perm_ai_claim_doc_extractor",
    ops_product_feature_flag: "ops_product_feature_flag",
    ops_marsh_replay_logging: "ops_marsh_replay_logging",
    ops_shadow_document_generation: "ops_shadow_document_generation",
    ops_policy_stop_branch: "ops_policy_stop_branch",
    ops_ai_coherence: "ops_ai_coherence",
    ops_ai_document_models: "ops_ai_document_models",
    ops_yeet_vtc_assistance_suspended: "ops_yeet_vtc_assistance_suspended",
    ops_axece_vtc_assistance_suspended: "ops_axece_vtc_assistance_suspended",
    ops_alptis_connect: "ops_alptis_connect",
    feat_automatic_unpaid_retry: "feat_automatic_unpaid_retry",
    feat_automatic_unpaid_recovery_execution: "feat_automatic_unpaid_recovery_execution",
    feat_commission_statements: "feat_commission_statements",
    feat_anonymous_funnel_links: "feat_anonymous_funnel_links",
    feat_connected_email_accounts: "feat_connected_email_accounts",
    feat_document_conformity: "feat_document_conformity",
    feat_notifications_v2: "feat_notifications_v2",
    feat_finalize_new_business_buttons: "feat_finalize_new_business_buttons",
    feat_accelerant_vtc_pricing: "feat_accelerant_vtc_pricing",
    feat_local_spreadsheet_engine: "feat_local_spreadsheet_engine",
    feat_policy_fraud_detection: "feat_policy_fraud_detection",
    feat_document_review: "feat_document_review",
    feat_claims_management: "feat_claims_management",
    test_static: "test_static",
    test_dynamic: "test_dynamic"
} as const;

export type FeatureFlagDtoKeyEnumKey = (typeof featureFlagDtoKeyEnum)[keyof typeof featureFlagDtoKeyEnum];

export const featureFlagDtoTypeEnum = {
    STATIC: "STATIC",
    DYNAMIC: "DYNAMIC"
} as const;

export type FeatureFlagDtoTypeEnumKey = (typeof featureFlagDtoTypeEnum)[keyof typeof featureFlagDtoTypeEnum];

export type FeatureFlagDto = {
    /**
     * @type string
    */
    key: FeatureFlagDtoKeyEnumKey;
    /**
     * @type string
    */
    type: FeatureFlagDtoTypeEnumKey;
    /**
     * @type string
    */
    description: string;
    /**
     * @description Dynamic: stored/default global value. Static: baseline evaluation.
     * @type boolean
    */
    enabled: boolean;
    /**
     * @type array
    */
    overrides: FlagOverrideDto[];
    /**
     * @description Optional: date the dynamic flag state was last saved. Absent for static.
     * @type string | undefined
    */
    updatedAt?: string;
};

export type ListFeatureFlagsOutput = {
    /**
     * @type array
    */
    flags: FeatureFlagDto[];
};

export type UpdateFeatureFlagInput = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type boolean
    */
    enabled: boolean;
    /**
     * @type array
    */
    overrides: FlagOverrideDto[];
};

export type UpdateFeatureFlagOutput = object;

export type CustomerNotFoundDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type string | undefined
    */
    simulatedAt?: string;
};

export const customerNotFoundErrorDtoCodeEnum = {
    CUSTOMER_NOT_FOUND: "CUSTOMER_NOT_FOUND"
} as const;

export type CustomerNotFoundErrorDtoCodeEnumKey = (typeof customerNotFoundErrorDtoCodeEnum)[keyof typeof customerNotFoundErrorDtoCodeEnum];

export type CustomerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CustomerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CustomerNotFoundDetailsDto;
};

export const customerDtoStatusEnum = {
    CUSTOMER_CREATED: "CUSTOMER_CREATED",
    CUSTOMER_CONFIRMED: "CUSTOMER_CONFIRMED"
} as const;

export type CustomerDtoStatusEnumKey = (typeof customerDtoStatusEnum)[keyof typeof customerDtoStatusEnum];

export const customerDtoPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type CustomerDtoPaymentModeEnumKey = (typeof customerDtoPaymentModeEnum)[keyof typeof customerDtoPaymentModeEnum];

export type CustomerDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Type of the customer
     * @type string
    */
    type: string;
    /**
     * @description Unique identifier for the customer
     * @type string
    */
    id: string;
    /**
     * @description Date and time when the customer was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the customer was last modified
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Status of the customer
     * @type string
    */
    status: CustomerDtoStatusEnumKey;
    /**
     * @description Policies associated with the customer
     * @type array
    */
    policies: string[];
    /**
     * @description Customer business role
     * @type string
    */
    role: string;
    /**
     * @description Optional: Preferred payment method of the customer
     * @type string | undefined
    */
    preferredPaymentMethodId?: string;
    /**
     * @type string
    */
    paymentMode: CustomerDtoPaymentModeEnumKey;
};

export type BillingAddress = {
    /**
     * @description the city of the billing address
     * @type string
    */
    city: string;
    /**
     * @description the country of the billing address
     * @type string
    */
    country: string;
    /**
     * @description the line1 of the billing address
     * @type string
    */
    line1: string;
    /**
     * @description the line2 of the billing address
     * @type string
    */
    line2: string;
    /**
     * @description the postal code of the billing address
     * @type string
    */
    postalCode: string;
    /**
     * @description the state of the billing address
     * @type string
    */
    state: string;
};

export type BillingDetails = {
    /**
     * @description the name of the billing details
     * @type string
    */
    name: string;
    /**
     * @description the email of the billing details
     * @type string
    */
    email: string;
    /**
     * @description the phone of the billing details
     * @type string
    */
    phone: string;
    /**
     * @description the address of the billing details
    */
    address: BillingAddress;
};

export const paymentMethodDtoWithIsPreferredPaymentMethodTypeEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentMethodDtoWithIsPreferredPaymentMethodTypeEnumKey = (typeof paymentMethodDtoWithIsPreferredPaymentMethodTypeEnum)[keyof typeof paymentMethodDtoWithIsPreferredPaymentMethodTypeEnum];

export type PaymentMethodDtoWithIsPreferred = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @description the id of the payment method
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    status: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description set when the payment method has been soft-deleted
     * @type string | undefined, date-time
    */
    deletedAt?: string;
    /**
     * @description the type of the payment method
     * @type string
    */
    paymentMethodType: PaymentMethodDtoWithIsPreferredPaymentMethodTypeEnumKey;
    /**
     * @description the document id of the mandate, if applicable
     * @type string | undefined
    */
    mandateDocumentId?: string;
    /**
     * @description the last 4 digits of the payment method, if applicable
     * @type string | undefined
    */
    last4?: string;
    /**
     * @description the expiration month of payment method, if applicable
     * @type number | undefined
    */
    expirationMonth?: number;
    /**
     * @description the expiration year of payment method, if applicable
     * @type number | undefined
    */
    expirationYear?: number;
    /**
     * @description the billing details of payment method, if applicable
    */
    billingDetails?: BillingDetails;
    /**
     * @description Is the preferred payment method
     * @type boolean
    */
    isPreferred: boolean;
};

export type GetCustomerPaymentMethodsOutput = {
    /**
     * @description Optional: Total number of payment methods
     * @type number | undefined
    */
    total?: number;
    /**
     * @description Optional: Number of payment methods the array has to star after
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description Optional: Number of payment methods in the array
     * @type number | undefined
    */
    limit?: number;
    /**
     * @description Array of payment methods
     * @type array
    */
    data: PaymentMethodDtoWithIsPreferred[];
};

export type PaymentCustomerNotFoundDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
};

export const paymentCustomerNotFoundErrorDtoCodeEnum = {
    PAYMENT_CUSTOMER_NOT_FOUND: "PAYMENT_CUSTOMER_NOT_FOUND"
} as const;

export type PaymentCustomerNotFoundErrorDtoCodeEnumKey = (typeof paymentCustomerNotFoundErrorDtoCodeEnum)[keyof typeof paymentCustomerNotFoundErrorDtoCodeEnum];

export type PaymentCustomerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PaymentCustomerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PaymentCustomerNotFoundDetailsDto;
};

export type GetPaymentMethodSetupSecretOutput = {
    /**
     * @description Client secret to setup a payment method
     * @type string
    */
    clientSecret: string;
};

export type ListCustomersOutput = {
    /**
     * @description Total number of customers
     * @type number
    */
    total: number;
    /**
     * @description Offset used for pagination
     * @type number
    */
    offset: number;
    /**
     * @description Page size used for pagination
     * @type number
    */
    limit: number;
    /**
     * @description List of customers
     * @type array
    */
    data: CustomerDto[];
};

export type InvalidBrokerageFirmDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const invalidBrokerageFirmErrorDtoCodeEnum = {
    INVALID_BROKERAGE_FIRM: "INVALID_BROKERAGE_FIRM"
} as const;

export type InvalidBrokerageFirmErrorDtoCodeEnumKey = (typeof invalidBrokerageFirmErrorDtoCodeEnum)[keyof typeof invalidBrokerageFirmErrorDtoCodeEnum];

export type InvalidBrokerageFirmErrorDto = {
    /**
     * @type string
    */
    code: InvalidBrokerageFirmErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBrokerageFirmDetailsDto;
};

export type BrokerageFirmFeesNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const brokerageFirmFeesNotFoundErrorDtoCodeEnum = {
    BROKERAGE_FIRM_FEES_NOT_FOUND: "BROKERAGE_FIRM_FEES_NOT_FOUND"
} as const;

export type BrokerageFirmFeesNotFoundErrorDtoCodeEnumKey = (typeof brokerageFirmFeesNotFoundErrorDtoCodeEnum)[keyof typeof brokerageFirmFeesNotFoundErrorDtoCodeEnum];

export type BrokerageFirmFeesNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmFeesNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmFeesNotFoundDetailsDto;
};

export type ConflictingPolicyTypeDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    policyType: string;
    requirement: OperationRequirement;
    action: Action;
};

export const conflictingPolicyTypeErrorDtoCodeEnum = {
    CONFLICTING_POLICY_TYPE: "CONFLICTING_POLICY_TYPE"
} as const;

export type ConflictingPolicyTypeErrorDtoCodeEnumKey = (typeof conflictingPolicyTypeErrorDtoCodeEnum)[keyof typeof conflictingPolicyTypeErrorDtoCodeEnum];

export type ConflictingPolicyTypeErrorDto = {
    /**
     * @type string
    */
    code: ConflictingPolicyTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingPolicyTypeDetailsDto;
};

export type InitializeCustomerInputBody = {
    /**
     * @description Brokerage firm id to associate with the customer (used in anonymous funnels)
     * @type string | undefined
    */
    brokerageFirmId?: string;
};

export type InitializedWithDto = {
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    policy: string;
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branch: string;
};

export type InitializeCustomerOutput = {
    /**
     * @description Type of the customer
     * @type string
    */
    type: string;
    /**
     * @description Unique identifier for the customer
     * @type string
    */
    id: string;
    /**
     * @description Policy and branch id created with the customer
    */
    initializedWith: InitializedWithDto;
};

export type CompanyNotFoundDetailsDto = {
    /**
     * @type string
    */
    siret: string;
};

export const companyNotFoundErrorDtoCodeEnum = {
    COMPANY_NOT_FOUND: "COMPANY_NOT_FOUND"
} as const;

export type CompanyNotFoundErrorDtoCodeEnumKey = (typeof companyNotFoundErrorDtoCodeEnum)[keyof typeof companyNotFoundErrorDtoCodeEnum];

export type CompanyNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CompanyNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CompanyNotFoundDetailsDto;
};

export type EditCustomerInputBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Optional: Customer business role
     * @type string | undefined
    */
    role?: string;
    /**
     * @description Optional: Siret number
     * @type string | undefined
    */
    siret?: string;
};

export type EditCustomerOutput = object;

export type PushCustomerEventInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
    /**
     * @description The event type. Must be one of the custom customer events declared for the product; read them from `GET /config/{productId}`.
     * @type string
    */
    eventType: string;
};

export type PushCustomerEventOutput = object;

export type InvoiceDetails = {
    /**
     * @description invoice issuance date
     * @type string
    */
    issuedAt: string;
    /**
     * @type object
    */
    period: Period;
    /**
     * @type array
    */
    components: BillingComponentDto[];
    /**
     * @type array
    */
    lines: InvoiceLineDto[];
    /**
     * @type object
    */
    total: AmountDto;
    /**
     * @description Invoice ids that have been reconciled
     * @type array | undefined
    */
    reconciledInvoiceIds?: any[][];
};

export type CustomerGetInvoicingScheduleOutput = {
    /**
     * @description Optional: Total number of invoice details
     * @type number | undefined
    */
    total?: number;
    /**
     * @description Optional: Number of invoice details the array has to star after
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description Optional: Number of invoice details in the array
     * @type number | undefined
    */
    limit?: number;
    /**
     * @description Array invoice details
     * @type array
    */
    data: InvoiceDetails[];
};

export type MissingCustomerContactFieldsDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type array
    */
    missingFields: string[];
};

export const missingCustomerContactFieldsErrorDtoCodeEnum = {
    MISSING_CUSTOMER_CONTACT_FIELDS: "MISSING_CUSTOMER_CONTACT_FIELDS"
} as const;

export type MissingCustomerContactFieldsErrorDtoCodeEnumKey = (typeof missingCustomerContactFieldsErrorDtoCodeEnum)[keyof typeof missingCustomerContactFieldsErrorDtoCodeEnum];

export type MissingCustomerContactFieldsErrorDto = {
    /**
     * @type string
    */
    code: MissingCustomerContactFieldsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingCustomerContactFieldsDetailsDto;
};

export type PaymentMethodNotFoundDetailsDto = {
    /**
     * @type string
    */
    paymentMethodId: string;
};

export const paymentMethodNotFoundErrorDtoCodeEnum = {
    PAYMENT_METHOD_NOT_FOUND: "PAYMENT_METHOD_NOT_FOUND"
} as const;

export type PaymentMethodNotFoundErrorDtoCodeEnumKey = (typeof paymentMethodNotFoundErrorDtoCodeEnum)[keyof typeof paymentMethodNotFoundErrorDtoCodeEnum];

export type PaymentMethodNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PaymentMethodNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PaymentMethodNotFoundDetailsDto;
};

export type ConflictingPaymentMethodStatusDetailsDto = {
    /**
     * @type string
    */
    paymentMethodStatus: string;
    /**
     * @type string
    */
    paymentMethodId: string;
    requirement: OperationRequirement;
    action: Action;
    /**
     * @type object | undefined
    */
    additionalData?: {
        [key: string]: any;
    };
};

export const conflictingPaymentMethodStatusErrorDtoCodeEnum = {
    CONFLICTING_PAYMENT_METHOD_STATUS: "CONFLICTING_PAYMENT_METHOD_STATUS"
} as const;

export type ConflictingPaymentMethodStatusErrorDtoCodeEnumKey = (typeof conflictingPaymentMethodStatusErrorDtoCodeEnum)[keyof typeof conflictingPaymentMethodStatusErrorDtoCodeEnum];

export type ConflictingPaymentMethodStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingPaymentMethodStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingPaymentMethodStatusDetailsDto;
};

export type NoUniqueDocumentReadyTypeToBeSignedDetailsDto = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type number
    */
    documentNumber: number;
    /**
     * @description Ids of the conflicting documents of this type (populated when more than one).
     * @type array | undefined
    */
    documentIds?: string[];
    /**
     * @description Names of the conflicting documents of this type, for support diagnosis.
     * @type array | undefined
    */
    documentNames?: string[];
};

export const noUniqueDocumentTypeReadyToBeSignedErrorDtoCodeEnum = {
    NO_UNIQUE_DOCUMENT_TYPE_READY_TO_BE_SIGNED: "NO_UNIQUE_DOCUMENT_TYPE_READY_TO_BE_SIGNED"
} as const;

export type NoUniqueDocumentTypeReadyToBeSignedErrorDtoCodeEnumKey = (typeof noUniqueDocumentTypeReadyToBeSignedErrorDtoCodeEnum)[keyof typeof noUniqueDocumentTypeReadyToBeSignedErrorDtoCodeEnum];

export type NoUniqueDocumentTypeReadyToBeSignedErrorDto = {
    /**
     * @type string
    */
    code: NoUniqueDocumentTypeReadyToBeSignedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoUniqueDocumentReadyTypeToBeSignedDetailsDto;
};

export const generateMandateSignatureRequestInputBodyDeliveryModeEnum = {
    EMAIL: "EMAIL",
    URL: "URL"
} as const;

export type GenerateMandateSignatureRequestInputBodyDeliveryModeEnumKey = (typeof generateMandateSignatureRequestInputBodyDeliveryModeEnum)[keyof typeof generateMandateSignatureRequestInputBodyDeliveryModeEnum];

export type GenerateMandateSignatureRequestInputBody = {
    /**
     * @description the delivery mode
     * @type string
    */
    deliveryMode: GenerateMandateSignatureRequestInputBodyDeliveryModeEnumKey;
    /**
     * @description Force test mode to skip Yousign. Defaults to isTestId(customerId).
     * @type boolean | undefined
    */
    test?: boolean;
};

export type SignerDto = {
    /**
     * @description Customer Id
     * @type string
    */
    customerId: string;
    /**
     * @description Signature url
     * @type string
    */
    url: string;
};

export type GenerateMandateSignatureRequestOutput = {
    /**
     * @description the signature id
     * @type string
    */
    id: string;
    /**
     * @description the signers
     * @type array
    */
    signers: SignerDto[];
};

export const invalidPaymentMethodDetailsDtoPaymentMethodEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type InvalidPaymentMethodDetailsDtoPaymentMethodEnumKey = (typeof invalidPaymentMethodDetailsDtoPaymentMethodEnum)[keyof typeof invalidPaymentMethodDetailsDtoPaymentMethodEnum];

export const invalidPaymentMethodDetailsDtoAllowedPaymentMethodsEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type InvalidPaymentMethodDetailsDtoAllowedPaymentMethodsEnumKey = (typeof invalidPaymentMethodDetailsDtoAllowedPaymentMethodsEnum)[keyof typeof invalidPaymentMethodDetailsDtoAllowedPaymentMethodsEnum];

export type InvalidPaymentMethodDetailsDto = {
    /**
     * @type string
    */
    paymentMethod: InvalidPaymentMethodDetailsDtoPaymentMethodEnumKey;
    /**
     * @type array
    */
    allowedPaymentMethods: InvalidPaymentMethodDetailsDtoAllowedPaymentMethodsEnumKey[];
};

export const invalidPaymentMethodErrorDtoCodeEnum = {
    INVALID_PAYMENT_METHOD: "INVALID_PAYMENT_METHOD"
} as const;

export type InvalidPaymentMethodErrorDtoCodeEnumKey = (typeof invalidPaymentMethodErrorDtoCodeEnum)[keyof typeof invalidPaymentMethodErrorDtoCodeEnum];

export type InvalidPaymentMethodErrorDto = {
    /**
     * @type string
    */
    code: InvalidPaymentMethodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPaymentMethodDetailsDto;
};

export type UpdatePreferredPaymentMethodOutput = object;

export type CannotDeleteLastPaymentMethodDetailsDto = {
    /**
     * @type string
    */
    paymentMethodId: string;
};

export const cannotDeleteLastPaymentMethodErrorDtoCodeEnum = {
    CANNOT_DELETE_LAST_PAYMENT_METHOD: "CANNOT_DELETE_LAST_PAYMENT_METHOD"
} as const;

export type CannotDeleteLastPaymentMethodErrorDtoCodeEnumKey = (typeof cannotDeleteLastPaymentMethodErrorDtoCodeEnum)[keyof typeof cannotDeleteLastPaymentMethodErrorDtoCodeEnum];

export type CannotDeleteLastPaymentMethodErrorDto = {
    /**
     * @type string
    */
    code: CannotDeleteLastPaymentMethodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotDeleteLastPaymentMethodDetailsDto;
};

export type DeleteCustomerPaymentMethodOutput = object;

export const paymentMethodRequiredDetailsDtoPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type PaymentMethodRequiredDetailsDtoPaymentModeEnumKey = (typeof paymentMethodRequiredDetailsDtoPaymentModeEnum)[keyof typeof paymentMethodRequiredDetailsDtoPaymentModeEnum];

export type PaymentMethodRequiredDetailsDto = {
    /**
     * @type string | undefined
    */
    paymentMode?: PaymentMethodRequiredDetailsDtoPaymentModeEnumKey;
};

export const paymentMethodRequiredErrorDtoCodeEnum = {
    PAYMENT_METHOD_REQUIRED: "PAYMENT_METHOD_REQUIRED"
} as const;

export type PaymentMethodRequiredErrorDtoCodeEnumKey = (typeof paymentMethodRequiredErrorDtoCodeEnum)[keyof typeof paymentMethodRequiredErrorDtoCodeEnum];

export type PaymentMethodRequiredErrorDto = {
    /**
     * @type string
    */
    code: PaymentMethodRequiredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PaymentMethodRequiredDetailsDto;
};

export const invalidPaymentModeDetailsDtoPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type InvalidPaymentModeDetailsDtoPaymentModeEnumKey = (typeof invalidPaymentModeDetailsDtoPaymentModeEnum)[keyof typeof invalidPaymentModeDetailsDtoPaymentModeEnum];

export const invalidPaymentModeDetailsDtoAllowedPaymentModesEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type InvalidPaymentModeDetailsDtoAllowedPaymentModesEnumKey = (typeof invalidPaymentModeDetailsDtoAllowedPaymentModesEnum)[keyof typeof invalidPaymentModeDetailsDtoAllowedPaymentModesEnum];

export type InvalidPaymentModeDetailsDto = {
    /**
     * @type string
    */
    paymentMode: InvalidPaymentModeDetailsDtoPaymentModeEnumKey;
    /**
     * @type array
    */
    allowedPaymentModes: InvalidPaymentModeDetailsDtoAllowedPaymentModesEnumKey[];
};

export const invalidPaymentModeErrorDtoCodeEnum = {
    INVALID_PAYMENT_MODE: "INVALID_PAYMENT_MODE"
} as const;

export type InvalidPaymentModeErrorDtoCodeEnumKey = (typeof invalidPaymentModeErrorDtoCodeEnum)[keyof typeof invalidPaymentModeErrorDtoCodeEnum];

export type InvalidPaymentModeErrorDto = {
    /**
     * @type string
    */
    code: InvalidPaymentModeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPaymentModeDetailsDto;
};

export const updatePaymentModeInputBodyPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type UpdatePaymentModeInputBodyPaymentModeEnumKey = (typeof updatePaymentModeInputBodyPaymentModeEnum)[keyof typeof updatePaymentModeInputBodyPaymentModeEnum];

export type UpdatePaymentModeInputBody = {
    /**
     * @description the customer payment mode
     * @type string
    */
    paymentMode: UpdatePaymentModeInputBodyPaymentModeEnumKey;
};

export type UpdatePaymentModeOutput = object;

export type GetCustomerBankTransferAccountOutput = {
    /**
     * @description The IBAN the customer needs to pay to
     * @type string
    */
    iban: string;
    /**
     * @description The BIC for this IBAN
     * @type string
    */
    bic: string;
    /**
     * @description The two-letter country code of the bank account to transfer to
     * @type string
    */
    countryCode: string;
    /**
     * @description The name of the person or business that owns the bank account
     * @type string
    */
    accountHolderName: string;
};

export type RetryChargeInputBody = {
    /**
     * @description the invoice id to retry a charge on
     * @type string
    */
    invoiceId: string;
    /**
     * @description Payment method to use. If not provided, the default payment method will be used.
     * @type string | undefined
    */
    paymentMethodId?: string;
};

export type RetryChargeOutput = object;

export type InvoiceDoesNotBelongToCustomerDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    invoiceCustomerId: string;
};

export const invoiceDoesNotBelongToCustomerErrorDtoCodeEnum = {
    INVOICE_DOES_NOT_BELONG_TO_CUSTOMER: "INVOICE_DOES_NOT_BELONG_TO_CUSTOMER"
} as const;

export type InvoiceDoesNotBelongToCustomerErrorDtoCodeEnumKey = (typeof invoiceDoesNotBelongToCustomerErrorDtoCodeEnum)[keyof typeof invoiceDoesNotBelongToCustomerErrorDtoCodeEnum];

export type InvoiceDoesNotBelongToCustomerErrorDto = {
    /**
     * @type string
    */
    code: InvoiceDoesNotBelongToCustomerErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceDoesNotBelongToCustomerDetailsDto;
};

export type InvalidChargeAttemptDetailsDto = {
    /**
     * @type string
    */
    reason: string;
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @type array
    */
    paymentIds: string[];
};

export const invalidChargeAttemptErrorDtoCodeEnum = {
    INVALID_CHARGE_ATTEMPT: "INVALID_CHARGE_ATTEMPT"
} as const;

export type InvalidChargeAttemptErrorDtoCodeEnumKey = (typeof invalidChargeAttemptErrorDtoCodeEnum)[keyof typeof invalidChargeAttemptErrorDtoCodeEnum];

export type InvalidChargeAttemptErrorDto = {
    /**
     * @type string
    */
    code: InvalidChargeAttemptErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidChargeAttemptDetailsDto;
};

export type InvalidInvoiceStatusDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @type string
    */
    currentStatus: string;
    /**
     * @type array
    */
    requiredStatus: string[];
};

export const invalidInvoiceStatusErrorDtoCodeEnum = {
    INVALID_INVOICE_STATUS: "INVALID_INVOICE_STATUS"
} as const;

export type InvalidInvoiceStatusErrorDtoCodeEnumKey = (typeof invalidInvoiceStatusErrorDtoCodeEnum)[keyof typeof invalidInvoiceStatusErrorDtoCodeEnum];

export type InvalidInvoiceStatusErrorDto = {
    /**
     * @type string
    */
    code: InvalidInvoiceStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidInvoiceStatusDetailsDto;
};

export const manuallyMarkInvoiceInputBodyManualPaymentMethodEnum = {
    check: "check",
    wire_transfer: "wire_transfer",
    cash: "cash"
} as const;

export type ManuallyMarkInvoiceInputBodyManualPaymentMethodEnumKey = (typeof manuallyMarkInvoiceInputBodyManualPaymentMethodEnum)[keyof typeof manuallyMarkInvoiceInputBodyManualPaymentMethodEnum];

export type ManuallyMarkInvoiceInputBody = {
    /**
     * @description the invoice to mark as settled outside the platform
     * @type string
    */
    invoiceId: string;
    /**
     * @description how the payment was settled outside the platform
     * @type string
    */
    manualPaymentMethod: ManuallyMarkInvoiceInputBodyManualPaymentMethodEnumKey;
    /**
     * @description accounting application date of the settlement — drives paidAt / finalizedAt, cannot be in the future
     * @type string
    */
    appliedAt: string;
};

export type ManuallyMarkInvoiceOutput = object;

export type GetCustomerBalanceOutput = {
    /**
     * @description The customer balance
     * @type number
    */
    balance: number | null;
};

export const migratedBillingTakeoverDtoSourceEnum = {
    COMPUTED: "COMPUTED",
    MANUAL: "MANUAL",
    CONFIG_FALLBACK: "CONFIG_FALLBACK"
} as const;

export type MigratedBillingTakeoverDtoSourceEnumKey = (typeof migratedBillingTakeoverDtoSourceEnum)[keyof typeof migratedBillingTakeoverDtoSourceEnum];

export type MigratedBillingTakeoverDto = {
    /**
     * @description The policy this takeover date bills
     * @type string
    */
    policyId: string;
    /**
     * @description Instant the platform takes over billing this policy — everything before it belongs to the previous insurer. Null is a gap, not \"no takeover\": billing rederives the date on demand rather than trusting a stored null.
     * @type string, date-time
    */
    takeoverAt: string | null;
    /**
     * @description Where the date came from: derived from the imported invoice coverage, hand-set, or — on rows frozen before the product-config dates were removed — the config date.
     * @type string
    */
    source: MigratedBillingTakeoverDtoSourceEnumKey;
    /**
     * @description Frozen against every writer, the recomputing projection included
     * @type boolean
    */
    isLocked: boolean;
    /**
     * @description Why the date was frozen
     * @type string | undefined
    */
    lockReason?: string;
    /**
     * @description When the date was last derived
     * @type string | undefined
    */
    computedAt?: string;
    /**
     * @description IANA zone the takeover instant is anchored in. Billing days run in the policy time zone, so rendering the date in any other zone can show the previous day.
     * @type string
    */
    timeZone: string;
    /**
     * @type string
    */
    updatedAt: string;
};

export type GetMigratedBillingTakeoverOutput = {
    /**
     * @description Whether the customer comes from an imported portfolio
     * @type boolean
    */
    migrated: boolean;
    /**
     * @description One entry per policy this customer pays for
     * @type array
    */
    data: MigratedBillingTakeoverDto[];
};

export type SetMigratedBillingTakeoverBody = {
    /**
     * @description Calendar day the platform should take over, as `YYYY-MM-DD`. Anchored server-side to midnight in the policy time zone, which is where billing days run — a caller cannot compute that instant without knowing the zone. Required: a row with no date reads downstream as \"never migrated\" and bills the whole history.
     * @type string, date
    */
    takeoverDate: string;
    /**
     * @description Why the date is being overridden — kept on the row as the audit trail
     * @type string
    */
    lockReason: string;
};

export type SetMigratedBillingTakeoverOutput = {
    /**
     * @description Whether the customer comes from an imported portfolio
     * @type boolean
    */
    migrated: boolean;
    /**
     * @description One entry per policy this customer pays for
     * @type array
    */
    data: MigratedBillingTakeoverDto[];
};

export type UnlockMigratedBillingTakeoverOutput = {
    /**
     * @description Whether the customer comes from an imported portfolio
     * @type boolean
    */
    migrated: boolean;
    /**
     * @description One entry per policy this customer pays for
     * @type array
    */
    data: MigratedBillingTakeoverDto[];
};

export type CreateCustomerForPolicyInputBody = {
    /**
     * @description The role of the customer on the policy
     * @type string
    */
    role: string;
    /**
     * @description Custom fields for the customer
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
};

export type CreateCustomerForPolicyOutput = {
    /**
     * @description The created customer id
     * @type string
    */
    customerId: string;
};

export type CannotDeleteLastCustomerDetailsDto = {
    /**
     * @description Policy ID
     * @type string
    */
    policyId: string;
    /**
     * @description Customer ID
     * @type string
    */
    customerId: string;
};

export const cannotDeleteLastCustomerErrorDtoCodeEnum = {
    CANNOT_DELETE_LAST_CUSTOMER: "CANNOT_DELETE_LAST_CUSTOMER"
} as const;

export type CannotDeleteLastCustomerErrorDtoCodeEnumKey = (typeof cannotDeleteLastCustomerErrorDtoCodeEnum)[keyof typeof cannotDeleteLastCustomerErrorDtoCodeEnum];

export type CannotDeleteLastCustomerErrorDto = {
    /**
     * @type string
    */
    code: CannotDeleteLastCustomerErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotDeleteLastCustomerDetailsDto;
};

export type DeleteCustomerFromPolicyOutput = {
    /**
     * @description The deleted customer id
     * @type string
    */
    customerId: string;
    /**
     * @description The policy id
     * @type string
    */
    policyId: string;
};

export type ClearLegacyTestDataOutputDto = object;

export type ClearLegacyProjectionsDataOutputDto = object;

export type ClearLegacyCacheOutputDto = object;

export type GetProjectionsOutput = {
    /**
     * @type array
    */
    projections: object[];
};

export type CountCoreEventsOutput = {
    /**
     * @type number
    */
    count: number;
};

export type ToggleIgnoreCoreEventsInputBody = {
    /**
     * @type string
    */
    rootId: string;
    /**
     * @type number
    */
    version: number;
};

export type ToggleIgnoreCoreEventsOutput = object;

export type BillCustomerInputQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type boolean | undefined
    */
    bypass?: boolean;
    /**
     * @description If true, the invoice will not be replaced even if it is unpaid
     * @type boolean | undefined
    */
    shouldNotReplace?: boolean;
};

export type BillCustomerOutput = {
    /**
     * @type string
    */
    id: string;
};

export type BatchBillCustomersInputQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type boolean | undefined
    */
    bypass?: boolean;
    /**
     * @description If true, the invoice will not be replaced even if it is unpaid
     * @type boolean | undefined
    */
    shouldNotReplace?: boolean;
};

export type BatchBillCustomersInputBody = {
    /**
     * @description List of customer IDs to bill
     * @type array
    */
    customerIds: string[];
};

export type BatchBillCustomersOutputItem = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    workflowId: string;
};

export type BatchBillCustomersOutput = {
    /**
     * @description List of billing results for each customer
     * @type array
    */
    results: BatchBillCustomersOutputItem[];
};

export type DebugRetryChargeInputBody = {
    /**
     * @description Invoices to attempt a charge on
     * @type array
    */
    invoiceIds: string[];
};

export const debugRetryChargeOutputItemStatusEnum = {
    QUEUED: "QUEUED",
    SKIPPED: "SKIPPED",
    NOT_FOUND: "NOT_FOUND",
    FAILED: "FAILED"
} as const;

export type DebugRetryChargeOutputItemStatusEnumKey = (typeof debugRetryChargeOutputItemStatusEnum)[keyof typeof debugRetryChargeOutputItemStatusEnum];

export type DebugRetryChargeOutputItem = {
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @description `SKIPPED` is not an error: the charge was refused on a business rule, such as a payment already in flight or a customer settling offline.
     * @type string
    */
    status: DebugRetryChargeOutputItemStatusEnumKey;
    /**
     * @description Why the charge was skipped or failed
     * @type string | undefined
    */
    error?: string;
};

export type DebugRetryChargeOutput = {
    /**
     * @type array
    */
    results: DebugRetryChargeOutputItem[];
};

export type CreateDistributionRequestsAndFeesDefaultFeesDto = {
    /**
     * @type number | undefined
    */
    minCommission?: number;
    /**
     * @type number | undefined
    */
    maxCommission?: number;
    /**
     * @type number | undefined
    */
    defaultCommission?: number;
    /**
     * @type number | undefined
    */
    minCommissionLimit?: number;
    /**
     * @type number | undefined
    */
    maxCommissionLimit?: number;
    /**
     * @type number | undefined
    */
    minTotalCommission?: number;
    /**
     * @type number | undefined
    */
    maxTotalCommission?: number;
    /**
     * @type number | undefined
    */
    minManagementFee?: number;
    /**
     * @type number | undefined
    */
    maxManagementFee?: number;
};

export type CreateDistributionRequestsAndFeesBody = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @type object
    */
    defaultFees: CreateDistributionRequestsAndFeesDefaultFeesDto;
    /**
     * @description If true, will override existing brokerage fees. If false or not provided, will only create fees for brokerage firms that do not have fees yet.
     * @default false
     * @type boolean | undefined
    */
    overrideExistingFees?: boolean;
};

export type CreateDistributionRequestsAndFeesOutput = {
    /**
     * @type number
    */
    totalBrokerageFirms: number;
    /**
     * @type number
    */
    distributionRequestsCreated: number;
    /**
     * @type number
    */
    distributionRequestsUpdated: number;
    /**
     * @type number
    */
    distributionRequestsSkipped: number;
    /**
     * @type number
    */
    brokerageFeesCreated: number;
    /**
     * @type number
    */
    brokerageFeesUpdated: number;
    /**
     * @type number
    */
    brokerageFeesSkipped: number;
    /**
     * @type number
    */
    errors: number;
};

export type CreatePaymentFromStripeInputBody = {
    /**
     * @description Stripe PaymentIntent ID to sync from
     * @type string
    */
    stripePaymentIntentId: string;
    /**
     * @description Korint customer ID
     * @type string
    */
    customerId: string;
    /**
     * @description Korint invoice ID
     * @type string
    */
    invoiceId: string;
    /**
     * @description Product ID for metadata
     * @type string | undefined
    */
    productId?: string;
    /**
     * @description Skip the Stripe API call and use the provided overrides (amount, customer, method). Use for off-Stripe payments (cheque, bank transfer).
     * @type boolean | undefined
    */
    skipStripeFetch?: boolean;
    /**
     * @description Tag the created payment as a test entity (prefixes the ID with `_test_`).
     * @type boolean | undefined
    */
    test?: boolean;
    /**
     * @description Amount in euro cents (required if skipStripeFetch)
     * @type number | undefined
    */
    amountInEuroCents?: number;
    /**
     * @description Stripe customer ID (from PI if not skipStripeFetch)
     * @type string | undefined
    */
    stripeCustomerId?: string;
    /**
     * @description Stripe payment method ID (from PI if not skipStripeFetch)
     * @type string | undefined
    */
    stripePaymentMethodId?: string;
};

export type CreatePaymentFromStripeOutput = {
    /**
     * @description Created Korint payment ID
     * @type string
    */
    paymentId: string;
};

export const updatePaymentStatusInputBodyStatusEnum = {
    SUCCESSFUL: "SUCCESSFUL",
    FAILED: "FAILED"
} as const;

export type UpdatePaymentStatusInputBodyStatusEnumKey = (typeof updatePaymentStatusInputBodyStatusEnum)[keyof typeof updatePaymentStatusInputBodyStatusEnum];

export type UpdatePaymentStatusInputBody = {
    /**
     * @description Korint payment ID
     * @type string
    */
    paymentId: string;
    /**
     * @description Korint customer ID
     * @type string
    */
    customerId: string;
    /**
     * @description Stripe PaymentIntent ID (for retrieving real PI data)
     * @type string
    */
    stripePaymentIntentId: string;
    /**
     * @description Target payment status
     * @type string
    */
    status: UpdatePaymentStatusInputBodyStatusEnumKey;
    /**
     * @description Skip the Stripe API call and construct the status event from inputs. Use for off-Stripe payments.
     * @type boolean | undefined
    */
    skipStripeFetch?: boolean;
    /**
     * @description Tag the payment as a test entity in downstream handlers. Has no effect on the payment ID (already minted at creation).
     * @type boolean | undefined
    */
    test?: boolean;
    /**
     * @description Failure reason (only for FAILED status)
     * @type string | undefined
    */
    reason?: string;
};

export type UpdatePaymentStatusOutput = {
    /**
     * @description Updated payment ID
     * @type string
    */
    paymentId: string;
    /**
     * @description New payment status
     * @type string
    */
    status: string;
};

export type RefreshInvoiceStatusInputBody = {
    /**
     * @description Korint invoice ID
     * @type string
    */
    invoiceId: string;
};

export type RefreshInvoiceStatusOutput = object;

export type BatchGenerateDocumentsInputBody = {
    /**
     * @description List of policy IDs to generate documents for
     * @type array
    */
    policyIds: string[];
    /**
     * @description List of document type config names to generate
     * @type array
    */
    documentTypes: string[];
};

export type BatchGenerateDocumentsSuccessDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    configName: string;
};

export type BatchGenerateDocumentsErrorDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string
    */
    error: string;
};

export type BatchGenerateDocumentsOutput = {
    /**
     * @type array
    */
    successes: BatchGenerateDocumentsSuccessDto[];
    /**
     * @type array
    */
    errors: BatchGenerateDocumentsErrorDto[];
};

export type BatchCreateUserRelationsInputBody = {
    /**
     * @type string | undefined
    */
    role?: string;
    /**
     * @type string | undefined
    */
    email?: string;
};

export type BatchCreateUserRelationsError = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    error: string;
};

export type BatchCreateUserRelationsOutput = {
    /**
     * @type number
    */
    processed: number;
    /**
     * @type number
    */
    created: number;
    /**
     * @type number
    */
    skipped: number;
    /**
     * @type array
    */
    errors: BatchCreateUserRelationsError[];
};

export const checkAllDocumentsInputChecksEnum = {
    RENEWAL_DOCUMENTS: "RENEWAL_DOCUMENTS",
    MULTIPLE_ACTIVE_INFORMATION_REPORTS: "MULTIPLE_ACTIVE_INFORMATION_REPORTS"
} as const;

export type CheckAllDocumentsInputChecksEnumKey = (typeof checkAllDocumentsInputChecksEnum)[keyof typeof checkAllDocumentsInputChecksEnum];

export const checkAllDocumentsInputBranchStatusEnum = {
    OPEN: "OPEN",
    MERGED: "MERGED"
} as const;

export type CheckAllDocumentsInputBranchStatusEnumKey = (typeof checkAllDocumentsInputBranchStatusEnum)[keyof typeof checkAllDocumentsInputBranchStatusEnum];

export type CheckAllDocumentsInput = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @description Limit to specific policyIds
     * @type array | undefined
    */
    policyIds?: string[];
    /**
     * @description Only check branches created/merged after this date (ISO)
     * @type string | undefined
    */
    since?: string;
    /**
     * @description If true, generate missing documents, archive duplicates, and apply fixes
     * @type boolean | undefined
    */
    fix?: boolean;
    /**
     * @description Which document verifications to run. Defaults to all: RENEWAL_DOCUMENTS, MULTIPLE_ACTIVE_INFORMATION_REPORTS
     * @type array | undefined
    */
    checks?: CheckAllDocumentsInputChecksEnumKey[];
    /**
     * @description For RENEWAL_DOCUMENTS check: limit to OPEN or MERGED branches. Defaults to both.
     * @type string | undefined
    */
    branchStatus?: CheckAllDocumentsInputBranchStatusEnumKey;
};

export const documentCheckerIssueIssueEnum = {
    MISSING: "MISSING",
    DUPLICATE: "DUPLICATE"
} as const;

export type DocumentCheckerIssueIssueEnumKey = (typeof documentCheckerIssueIssueEnum)[keyof typeof documentCheckerIssueIssueEnum];

export type DocumentCheckerIssue = {
    /**
     * @type string
    */
    issue: DocumentCheckerIssueIssueEnumKey;
    /**
     * @type string
    */
    docType: string;
    /**
     * @type number
    */
    docCount: number;
    /**
     * @type array
    */
    documentIds: string[];
};

export type DocumentCheckerPolicyResult = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    branchId: string;
    /**
     * @type array
    */
    customerIds: string[];
    /**
     * @type string
    */
    branchCreatedAt: string;
    /**
     * @type array
    */
    issues: DocumentCheckerIssue[];
    /**
     * @type array | undefined
    */
    generatedDocTypes?: string[];
    /**
     * @type array | undefined
    */
    archivedDocumentIds?: string[];
};

export type DocumentCheckResult = {
    /**
     * @type string
    */
    check: string;
    /**
     * @type number
    */
    branchesChecked: number;
    /**
     * @type number
    */
    policiesWithIssues: number;
    /**
     * @type array
    */
    policies: DocumentCheckerPolicyResult[];
};

export type CheckAllDocumentsOutput = {
    /**
     * @type array
    */
    results: DocumentCheckResult[];
};

export type RetriggerClaimDocumentFraudCheckInputBody = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type RetriggerClaimDocumentFraudCheckOutput = {
    /**
     * @description False when the product has fraud detection disabled/out of scope for claims, or the document is not on the claim
     * @type boolean
    */
    enqueued: boolean;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export type SuperDeletePoliciesOutputDto = {
    /**
     * @type string | undefined
    */
    jobId?: string;
};

export const generateDocumentUploadUrlInputBodyTypeEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated"
} as const;

export type GenerateDocumentUploadUrlInputBodyTypeEnumKey = (typeof generateDocumentUploadUrlInputBodyTypeEnum)[keyof typeof generateDocumentUploadUrlInputBodyTypeEnum];

export type GenerateDocumentUploadUrlInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the name of the document
     * @type string
    */
    name: string;
    /**
     * @description is it a test customer
     * @type boolean | undefined
    */
    test?: boolean;
    /**
     * @description the document\'s classification role. Only client-declarable values are accepted; \'generated\' is server-only. When omitted the server derives it from the upload context.
     * @type string | undefined
    */
    type?: GenerateDocumentUploadUrlInputBodyTypeEnumKey;
    /**
     * @description The document category. Omit while awaiting classification.
     * @type string | undefined
    */
    category?: string;
    /**
     * @description Allowed MIME types for the uploaded file. When omitted, no MIME validation is performed.
     * @type array | undefined
    */
    allowedMimeTypes?: string[];
};

export type GenerateDocumentUploadUrlOutput = {
    /**
     * @description the signed url to upload the document
     * @type string
    */
    url: string;
    /**
     * @description the id of the document
     * @type string
    */
    id: string;
    /**
     * @description the Content-Type header that was signed into the presigned URL
     * @type string | undefined
    */
    contentType?: string;
    /**
     * @description the Content-Disposition header that was signed into the presigned URL
     * @type string | undefined
    */
    contentDisposition?: string;
};

export type DeleteDocumentsOutput = object;

export type DocumentNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
};

export const documentNotFoundErrorDtoCodeEnum = {
    DOCUMENT_NOT_FOUND: "DOCUMENT_NOT_FOUND"
} as const;

export type DocumentNotFoundErrorDtoCodeEnumKey = (typeof documentNotFoundErrorDtoCodeEnum)[keyof typeof documentNotFoundErrorDtoCodeEnum];

export type DocumentNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DocumentNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentNotFoundDetailsDto;
};

export type ArchiveDocumentsInputBody = {
    /**
     * @description the document ids to archive
     * @type array
    */
    ids: string[];
};

export type ArchiveDocumentsOutput = object;

export type RestoreDocumentsInputBody = {
    /**
     * @description the document ids to archive
     * @type array
    */
    ids: string[];
};

export type RestoreDocumentsOutput = object;

export type DuplicateNonDelegatedDocumentTypeDetailsDto = {
    /**
     * @type string
    */
    documentType: string;
};

export const duplicateNonDelegatedDocumentTypeErrorDtoCodeEnum = {
    DUPLICATE_NON_DELEGATED_DOCUMENT_TYPE: "DUPLICATE_NON_DELEGATED_DOCUMENT_TYPE"
} as const;

export type DuplicateNonDelegatedDocumentTypeErrorDtoCodeEnumKey = (typeof duplicateNonDelegatedDocumentTypeErrorDtoCodeEnum)[keyof typeof duplicateNonDelegatedDocumentTypeErrorDtoCodeEnum];

export type DuplicateNonDelegatedDocumentTypeErrorDto = {
    /**
     * @type string
    */
    code: DuplicateNonDelegatedDocumentTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DuplicateNonDelegatedDocumentTypeDetailsDto;
};

export type AIClassificationCorrectionDto = {
    /**
     * @description Legacy Braintrust trace ID; unused since the Dash0 migration (feedback is keyed on the aiclassification metadata aiOperationId server-side)
     * @type string | undefined
    */
    traceId?: string;
    /**
     * @description Original AI-suggested category before user override
     * @type string
    */
    originalCategory: string;
};

export type SetDocumentCategoryInputBody = {
    /**
     * @description category of the document
     * @type string
    */
    category: string;
    /**
     * @description AI classification correction context, provided when overriding an AI suggestion
    */
    aiCorrection?: AIClassificationCorrectionDto;
    /**
     * @description Why the user corrected the platform result
     * @type string | undefined
    */
    reason?: string;
};

export type SetDocumentCategoryOutput = object;

export const listDocumentsWithPresignedUrlInputBodyTypesEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated",
    generated: "generated"
} as const;

export type ListDocumentsWithPresignedUrlInputBodyTypesEnumKey = (typeof listDocumentsWithPresignedUrlInputBodyTypesEnum)[keyof typeof listDocumentsWithPresignedUrlInputBodyTypesEnum];

export type ListDocumentsWithPresignedUrlInputBody = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type array | undefined
    */
    types?: ListDocumentsWithPresignedUrlInputBodyTypesEnumKey[];
    /**
     * @type array | undefined
    */
    extensions?: string[];
    /**
     * @type array | undefined
    */
    categories?: string[];
};

export type ListDocumentsWithPresignedUrlOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DocumentWithSignedUrl[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const generateDocumentPdfInputBodyProviderEnum = {
    CraftMyPdf: "CraftMyPdf",
    Carbone: "Carbone",
    ReactPdf: "ReactPdf",
    Static: "Static"
} as const;

export type GenerateDocumentPdfInputBodyProviderEnumKey = (typeof generateDocumentPdfInputBodyProviderEnum)[keyof typeof generateDocumentPdfInputBodyProviderEnum];

export type GenerateDocumentPdfInputBody = {
    /**
     * @type string
    */
    provider: GenerateDocumentPdfInputBodyProviderEnumKey;
    /**
     * @type string
    */
    templateId: string;
    /**
     * @type object
    */
    payload: object;
    /**
     * @description Metadata to attach to uploaded document
     * @type array
    */
    metadata: Metadata[];
};

export type GenerateDocumentPdfOutput = {
    /**
     * @description the id of the document
     * @type string
    */
    id: string;
};

export type ScheduleHandleMalwareProtectionScanResultInputBody = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    status: string;
};

export type InvalidEmailDetailsDto = {
    /**
     * @type string
    */
    email: string;
};

export const invalidEmailErrorDtoCodeEnum = {
    INVALID_EMAIL: "INVALID_EMAIL"
} as const;

export type InvalidEmailErrorDtoCodeEnumKey = (typeof invalidEmailErrorDtoCodeEnum)[keyof typeof invalidEmailErrorDtoCodeEnum];

export type InvalidEmailErrorDto = {
    /**
     * @type string
    */
    code: InvalidEmailErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEmailDetailsDto;
};

export type InviteInputBody = {
    /**
     * @description Policy id
     * @type string
    */
    policyId: string;
    /**
     * @description Customer id
     * @type string
    */
    customerId: string;
    /**
     * @description Branch id
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Email address
     * @type string | undefined
    */
    email?: string;
    /**
     * @description Role for the invitation
     * @type string
    */
    role: string;
};

export type InviteOutput = object;

export type BrokerInviteBody = {
    /**
     * @description Email address to invite
     * @type string
    */
    email: string;
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description First name
     * @type string
    */
    firstName: string;
    /**
     * @description Last name
     * @type string
    */
    lastName: string;
    /**
     * @description Broker role
     * @type string | undefined
    */
    brokerRole?: string;
};

export type CreateAnonymousSessionOutput = {
    /**
     * @description The session Id
     * @type string
    */
    sessionId: string;
    /**
     * @description The access token
     * @type string
    */
    accessToken: string;
};

export type HandoffAnonymousSessionBody = {
    /**
     * @description Anonymous session id to transfer
     * @type string
    */
    sessionId: string;
};

export type HandoffAnonymousSessionOutput = {
    /**
     * @description Number of relations transferred
     * @type number
    */
    transferredCount: number;
};

export type AnonymousSessionPolicy = {
    /**
     * @description Customer id
     * @type string
    */
    customerId: string;
    /**
     * @description Policy id
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @description Branch id
     * @type string | undefined
    */
    branchId?: string;
};

export type ResolveAnonymousSessionEntitiesOutput = {
    /**
     * @description All policies tied to the session
     * @type array
    */
    policies: AnonymousSessionPolicy[];
};

export type GetJobSchedulersBullMqOutput = {
    /**
     * @type array
    */
    jobSchedulers: string[];
};

export type ListJobSchedulersInput = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type string | undefined
    */
    queueName?: string;
};

export type JobSchedulerDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    pattern: string;
    /**
     * @type string
    */
    queueName: string;
    /**
     * @type object
    */
    jobTemplate: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
};

export type ListJobSchedulersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: JobSchedulerDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type JobSchedulerNotFoundDto = {
    /**
     * @type string
    */
    id: string;
};

export const jobSchedulerNotFoundErrorDtoCodeEnum = {
    JOB_SCHEDULER_NOT_FOUND: "JOB_SCHEDULER_NOT_FOUND"
} as const;

export type JobSchedulerNotFoundErrorDtoCodeEnumKey = (typeof jobSchedulerNotFoundErrorDtoCodeEnum)[keyof typeof jobSchedulerNotFoundErrorDtoCodeEnum];

export type JobSchedulerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: JobSchedulerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: JobSchedulerNotFoundDto;
};

export type GetJobSchedulerOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    pattern: string;
    /**
     * @type string
    */
    queueName: string;
    /**
     * @type object
    */
    jobTemplate: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
};

export type UpsertJobSchedulerBody = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    pattern: string;
    /**
     * @type object
    */
    jobTemplate: object;
};

export type UpsertJobSchedulerOutput = object;

export type UpdateJobSchedulerBody = {
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
    /**
     * @type string | undefined
    */
    pattern?: string;
    /**
     * @type object | undefined
    */
    jobTemplate?: object;
};

export type UpdateJobSchedulerOutput = object;

export type DeleteJobSchedulerOutput = object;

export const jobPriorityEnum = {
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6
} as const;

export type JobPriorityEnumKey = (typeof jobPriorityEnum)[keyof typeof jobPriorityEnum];

/**
 * @description The priority of the job, the lower the number, the higher the priority
*/
export type JobPriority = JobPriorityEnumKey;

export const servicesEnum = {
    LEGACY: "LEGACY"
} as const;

export type ServicesEnumKey = (typeof servicesEnum)[keyof typeof servicesEnum];

export type Services = ServicesEnumKey;

export const jobDataCommandEnum = {
    "legacy_event_store.push_projection": "legacy_event_store.push_projection",
    "legacy_event_store.rebuild_projections": "legacy_event_store.rebuild_projections",
    "legacy_event_store.dispatch_rebuild_projections": "legacy_event_store.dispatch_rebuild_projections",
    "legacy_event_store.rebuild_core_aggregate_projections": "legacy_event_store.rebuild_core_aggregate_projections",
    "billing_event_store.rebuild_projections": "billing_event_store.rebuild_projections",
    "billing_event_store.dispatch_rebuild_projections": "billing_event_store.dispatch_rebuild_projections",
    "payments_event_store.rebuild_projections": "payments_event_store.rebuild_projections",
    "payment_event_store.rebuild_projections": "payment_event_store.rebuild_projections",
    "payment_event_store.build_projections": "payment_event_store.build_projections",
    "search.index_collection": "search.index_collection",
    "search.reindex_collection": "search.reindex_collection",
    "legacy.attach_policy_document": "legacy.attach_policy_document",
    "legacy.attach_common_documents": "legacy.attach_common_documents",
    "legacy.generate_document": "legacy.generate_document",
    "legacy.archive_old_documents": "legacy.archive_old_documents",
    "claim-management.get-document-generation-payload": "claim-management.get-document-generation-payload",
    "documents.handle_malware_protection_scan_result": "documents.handle_malware_protection_scan_result",
    "notification.send_email_from_fanout_trigger": "notification.send_email_from_fanout_trigger",
    "payments.handle_payment_method_attached": "payments.handle_payment_method_attached",
    "payments.handle_payment_method_updated": "payments.handle_payment_method_updated",
    "payments.handle_payment_method_detached": "payments.handle_payment_method_detached",
    "payments.handle_payment_succeeded": "payments.handle_payment_succeeded",
    "payments.handle_payment_failed": "payments.handle_payment_failed",
    "payments.handle_payment_canceled": "payments.handle_payment_canceled",
    "payments.handle_payment_created": "payments.handle_payment_created",
    "payments.handle_payment_disputed": "payments.handle_payment_disputed",
    "payments.handle_payment_creation_failed": "payments.handle_payment_creation_failed",
    "payments.handle_setup_intent_succeeded": "payments.handle_setup_intent_succeeded",
    "payments.handle_payment_refund_succeeded": "payments.handle_payment_refund_succeeded",
    "payments.handle_payment_refund_updated": "payments.handle_payment_refund_updated",
    "payments.handle_payment_refund_failed": "payments.handle_payment_refund_failed",
    "email_account.handle_sync_webhook_event": "email_account.handle_sync_webhook_event",
    "email.fetch_body": "email.fetch_body",
    "email.analyze_thread": "email.analyze_thread",
    "email.recover_thread_analyses": "email.recover_thread_analyses",
    "email.fetch_attachment": "email.fetch_attachment",
    "branch.invalidate_branch": "branch.invalidate_branch",
    "relations.create_user_and_relation": "relations.create_user_and_relation",
    "jobs.cleanup_jobs_db": "jobs.cleanup_jobs_db",
    "legacy.apply_migration": "legacy.apply_migration",
    "address_autocomplete.suggest": "address_autocomplete.suggest",
    "asset.apply_start_asset": "asset.apply_start_asset",
    "asset.apply_stop_asset": "asset.apply_stop_asset",
    "axece.create_drivequant_user_id": "axece.create_drivequant_user_id",
    "axece.edit_policy_crm": "axece.edit_policy_crm",
    "yeet.create_drivequant_user_id": "yeet.create_drivequant_user_id",
    "yeet.edit_policy_crm": "yeet.edit_policy_crm",
    "fva.retrieve_report_outcome": "fva.retrieve_report_outcome",
    "billing.handle_payment_creation": "billing.handle_payment_creation",
    "billing.handle_payment_disputed": "billing.handle_payment_disputed",
    "billing.handle_payment_failure": "billing.handle_payment_failure",
    "billing.handle_payment_succeeded": "billing.handle_payment_succeeded",
    "branch.auto_archive_one_product_inactive_branches": "branch.auto_archive_one_product_inactive_branches",
    "branch.fork_branch": "branch.fork_branch",
    "branch.edit_branch": "branch.edit_branch",
    "branch.merge_branch": "branch.merge_branch",
    "branch.auto_archive_all_products_inactive_branches": "branch.auto_archive_all_products_inactive_branches",
    "brokerage-firm.create_payment_customer": "brokerage-firm.create_payment_customer",
    "brokerage-firm.score_document_fraud": "brokerage-firm.score_document_fraud",
    "commission-statements.get_document": "commission-statements.get_document",
    "commission-statements.list_for_brokerage_firm": "commission-statements.list_for_brokerage_firm",
    "customer.bill": "customer.bill",
    "customer.charge_customer": "customer.charge_customer",
    "payments.cancel_payment": "payments.cancel_payment",
    "documents.upload_reports_to_connector": "documents.upload_reports_to_connector",
    "documents.check_wakam_validation": "documents.check_wakam_validation",
    "debug.super_delete_policies": "debug.super_delete_policies",
    "notification.send_email": "notification.send_email",
    "notification.send_test_email": "notification.send_test_email",
    "policy.apply_activate_policy": "policy.apply_activate_policy",
    "policy.apply_start_policy": "policy.apply_start_policy",
    "policy.apply_stop_policy": "policy.apply_stop_policy",
    "policy.sign_policy": "policy.sign_policy",
    "policy.dispatch_tasks": "policy.dispatch_tasks",
    "policy.plan_tasks": "policy.plan_tasks",
    "policy.run_tasks": "policy.run_tasks",
    "policy.get_unpaid_duration": "policy.get_unpaid_duration",
    "policy.score_document_fraud": "policy.score_document_fraud",
    "renewal.handle_renewal_branch_on_claim_creation": "renewal.handle_renewal_branch_on_claim_creation",
    "renewal.dispatch_renewal_creation_for_policy": "renewal.dispatch_renewal_creation_for_policy",
    "renewal.dispatch_renewal_merge_for_policy": "renewal.dispatch_renewal_merge_for_policy",
    "renewal.publish_stop_notice": "renewal.publish_stop_notice",
    "reporting.generate_report": "reporting.generate_report",
    "monitoring.run_daily_checks": "monitoring.run_daily_checks",
    "monitoring.list_checks": "monitoring.list_checks",
    "signature.update_signer_status": "signature.update_signer_status",
    "signature.update_signature_signed_status": "signature.update_signature_signed_status",
    "signature.update_signature_cancelled_status": "signature.update_signature_cancelled_status",
    "ar24.create_user": "ar24.create_user",
    "ar24.get_user": "ar24.get_user",
    "ar24.list_users": "ar24.list_users",
    "ar24.request_user_access": "ar24.request_user_access",
    "ar24.request_user_eula": "ar24.request_user_eula",
    "ar24.resend_user_confirmation": "ar24.resend_user_confirmation",
    "ar24.send_ere": "ar24.send_ere",
    "ar24.send_formal_notice": "ar24.send_formal_notice",
    "ar24.update_user": "ar24.update_user",
    "asset.batch_create_assets": "asset.batch_create_assets",
    "asset.batch_edit_assets": "asset.batch_edit_assets",
    "asset.batch_remove_assets": "asset.batch_remove_assets",
    "asset.create_asset": "asset.create_asset",
    "asset.edit_asset": "asset.edit_asset",
    "asset.get_asset": "asset.get_asset",
    "asset.list_assets": "asset.list_assets",
    "asset.push_custom_event": "asset.push_custom_event",
    "asset.remove_asset": "asset.remove_asset",
    "asset.replace_asset": "asset.replace_asset",
    "auth.check_email": "auth.check_email",
    "axece.attach_drivequant_user_id_to_customer": "axece.attach_drivequant_user_id_to_customer",
    "axece.edit_drivequant_score_range": "axece.edit_drivequant_score_range",
    "axece.edit_drivequant_surcharge_rate": "axece.edit_drivequant_surcharge_rate",
    "axece.edit_policy_drivequant_repricing": "axece.edit_policy_drivequant_repricing",
    "axece.list_drivequant_average_scores": "axece.list_drivequant_average_scores",
    "axece.list_drivequant_historical_users": "axece.list_drivequant_historical_users",
    "axece.list_possible_drivequant_users": "axece.list_possible_drivequant_users",
    "axece.surchargePolicy": "axece.surchargePolicy",
    "billing.cancel_invoices": "billing.cancel_invoices",
    "billing.delete_invoices": "billing.delete_invoices",
    "billing.draft_credit_invoice": "billing.draft_credit_invoice",
    "billing.draft_next_invoice": "billing.draft_next_invoice",
    "billing.finalize_invoice": "billing.finalize_invoice",
    "billing.get_invoices": "billing.get_invoices",
    "billing.handle_charge_customer_failure_without_payment_creation": "billing.handle_charge_customer_failure_without_payment_creation",
    "billing.handle_refund_not_handled": "billing.handle_refund_not_handled",
    "billing.issue_invoices": "billing.issue_invoices",
    "billing.list": "billing.list",
    "billing.list_invoice_events": "billing.list_invoice_events",
    "billing.list_invoice_flows": "billing.list_invoice_flows",
    "billing.reconcile_invoices": "billing.reconcile_invoices",
    "billing.replace_invoice": "billing.replace_invoice",
    "billing.replace_unpaid_invoice_checks": "billing.replace_unpaid_invoice_checks",
    "billing.write_off_invoice": "billing.write_off_invoice",
    "branch.apply_close_branch": "branch.apply_close_branch",
    "branch.create_branch": "branch.create_branch",
    "branch.create_or_reuse_branch": "branch.create_or_reuse_branch",
    "branch.get_effective_date": "branch.get_effective_date",
    "broker.at_me": "broker.at_me",
    "broker.batch_get_brokers": "broker.batch_get_brokers",
    "broker.create_broker": "broker.create_broker",
    "broker.delete_broker": "broker.delete_broker",
    "broker.get_broker": "broker.get_broker",
    "broker.list_brokers": "broker.list_brokers",
    "broker.list_descendant_brokers": "broker.list_descendant_brokers",
    "broker.update_broker": "broker.update_broker",
    "brokerage-fee.create": "brokerage-fee.create",
    "brokerage-fee.delete": "brokerage-fee.delete",
    "brokerage-fee.get_computed_fees_for_brokerage_firm": "brokerage-fee.get_computed_fees_for_brokerage_firm",
    "brokerage-fee.get_fees_for_brokerage_firm": "brokerage-fee.get_fees_for_brokerage_firm",
    "brokerage-fee.update": "brokerage-fee.update",
    "brokerage-firm.correct_document_fraud_verdict": "brokerage-firm.correct_document_fraud_verdict",
    "brokerage-firm.create_brokerage_firm": "brokerage-firm.create_brokerage_firm",
    "brokerage-firm.delete_documents": "brokerage-firm.delete_documents",
    "brokerage-firm.generate_document_upload_url": "brokerage-firm.generate_document_upload_url",
    "brokerage-firm.generate_documents_for_signature": "brokerage-firm.generate_documents_for_signature",
    "brokerage-firm.generate_mandate_signature_request": "brokerage-firm.generate_mandate_signature_request",
    "brokerage-firm.generate_report": "brokerage-firm.generate_report",
    "brokerage-firm.generate_signature_request": "brokerage-firm.generate_signature_request",
    "brokerage-firm.get_brokerage_firm": "brokerage-firm.get_brokerage_firm",
    "brokerage-firm.get_document_fraud": "brokerage-firm.get_document_fraud",
    "brokerage-firm.get_payment_methods": "brokerage-firm.get_payment_methods",
    "brokerage-firm.get_payment_setup_secret": "brokerage-firm.get_payment_setup_secret",
    "brokerage-firm.get_report_config": "brokerage-firm.get_report_config",
    "brokerage-firm.list_brokerage_firms": "brokerage-firm.list_brokerage_firms",
    "brokerage-firm.list_documents": "brokerage-firm.list_documents",
    "brokerage-firm.list_reports": "brokerage-firm.list_reports",
    "brokerage-firm.transfer_policies": "brokerage-firm.transfer_policies",
    "brokerage-firm.update_brokerage_firm": "brokerage-firm.update_brokerage_firm",
    "brokerage-firm.update_preferred_payment_method": "brokerage-firm.update_preferred_payment_method",
    "claim-management.score-document-fraud": "claim-management.score-document-fraud",
    "claims.create": "claims.create",
    "claims.delete": "claims.delete",
    "claims.get": "claims.get",
    "claims.list": "claims.list",
    "claims.update": "claims.update",
    "comments.create_comment": "comments.create_comment",
    "comments.delete_comment": "comments.delete_comment",
    "comments.get_comment": "comments.get_comment",
    "comments.list_comments": "comments.list_comments",
    "comments.update_comment": "comments.update_comment",
    "internal_notes.create": "internal_notes.create",
    "internal_notes.list": "internal_notes.list",
    "internal_notes.get": "internal_notes.get",
    "internal_notes.update": "internal_notes.update",
    "internal_notes.soft_delete": "internal_notes.soft_delete",
    "internal_notes.hard_delete": "internal_notes.hard_delete",
    "whatsapp_consent.record": "whatsapp_consent.record",
    "compliance.acknowledge_alerts_by_check_ids": "compliance.acknowledge_alerts_by_check_ids",
    "compliance.acknowledge_alerts_by_entity": "compliance.acknowledge_alerts_by_entity",
    "compliance.batch_check_compliance": "compliance.batch_check_compliance",
    "compliance.create_alert": "compliance.create_alert",
    "compliance.create_compliance_check": "compliance.create_compliance_check",
    "compliance.delete_alert": "compliance.delete_alert",
    "compliance.delete_compliance_check": "compliance.delete_compliance_check",
    "compliance.get_alert": "compliance.get_alert",
    "compliance.get_compliance_check": "compliance.get_compliance_check",
    "compliance.list_alerts": "compliance.list_alerts",
    "compliance.list_compliance_checks": "compliance.list_compliance_checks",
    "compliance.synchronize_new_alerts": "compliance.synchronize_new_alerts",
    "compliance.update_alert": "compliance.update_alert",
    "compliance.update_compliance_check": "compliance.update_compliance_check",
    "config.GET_PRODUCT_CONFIG": "config.GET_PRODUCT_CONFIG",
    "config.GET_PUBLIC_PRODUCT_CONFIG": "config.GET_PUBLIC_PRODUCT_CONFIG",
    "config.GET_PUBLIC_TENANT_CONFIG": "config.GET_PUBLIC_TENANT_CONFIG",
    "config.GET_TENANT_CONFIG": "config.GET_TENANT_CONFIG",
    "config.get_business_role_permissions": "config.get_business_role_permissions",
    "config.get_products_for_tenant": "config.get_products_for_tenant",
    "config.get_public_tenant_config_by_domain": "config.get_public_tenant_config_by_domain",
    "core_aggregate.get_product_config": "core_aggregate.get_product_config",
    "customer.batch_get_customers": "customer.batch_get_customers",
    "customer.create_customer_for_policy": "customer.create_customer_for_policy",
    "customer.create_payment_customer": "customer.create_payment_customer",
    "customer.delete_customer_from_policy": "customer.delete_customer_from_policy",
    "customer.draft_checker": "customer.draft_checker",
    "customer.draft_next_invoice": "customer.draft_next_invoice",
    "customer.draft_replacement_invoice": "customer.draft_replacement_invoice",
    "customer.edit_customer": "customer.edit_customer",
    "customer.generate_mandates_signature_request": "customer.generate_mandates_signature_request",
    "customer.get_bank_transfer_account": "customer.get_bank_transfer_account",
    "customer.get_customer": "customer.get_customer",
    "customer.get_customer_balance": "customer.get_customer_balance",
    "customer.get_customer_payment_methods": "customer.get_customer_payment_methods",
    "customer.get_invoicing_schedule": "customer.get_invoicing_schedule",
    "customer.get_migrated_billing_takeover": "customer.get_migrated_billing_takeover",
    "customer.get_payment_method_setup_secret": "customer.get_payment_method_setup_secret",
    "customer.initialize_customer": "customer.initialize_customer",
    "customer.invoice_drafted_checker": "customer.invoice_drafted_checker",
    "customer.list_customers": "customer.list_customers",
    "customer.lock_customer_billing": "customer.lock_customer_billing",
    "customer.manually_mark_invoice": "customer.manually_mark_invoice",
    "customer.push_custom_event": "customer.push_custom_event",
    "customer.replace_invoice": "customer.replace_invoice",
    "customer.retry_charge": "customer.retry_charge",
    "customer.set_migrated_billing_takeover": "customer.set_migrated_billing_takeover",
    "customer.unlock_customer_billing": "customer.unlock_customer_billing",
    "customer.unlock_migrated_billing_takeover": "customer.unlock_migrated_billing_takeover",
    "customer.update_customer_payment_mode": "customer.update_customer_payment_mode",
    "customer.update_customer_preferred_payment_method": "customer.update_customer_preferred_payment_method",
    "debug.add_new_product_to_distribution-requests": "debug.add_new_product_to_distribution-requests",
    "debug.batch_bill_customers": "debug.batch_bill_customers",
    "debug.batch_create_user_relations": "debug.batch_create_user_relations",
    "debug.batch_generate_documents": "debug.batch_generate_documents",
    "debug.cancel_invoices_one_time": "debug.cancel_invoices_one_time",
    "debug.check_all_documents": "debug.check_all_documents",
    "debug.check_documents": "debug.check_documents",
    "debug.clear_core_cache": "debug.clear_core_cache",
    "debug.clear_core_projections_data": "debug.clear_core_projections_data",
    "debug.clear_core_test_data": "debug.clear_core_test_data",
    "debug.clear_jobs_data": "debug.clear_jobs_data",
    "debug.clear_signature_test_data": "debug.clear_signature_test_data",
    "debug.clear_workflows_data": "debug.clear_workflows_data",
    "debug.count_core_events": "debug.count_core_events",
    "debug.create_manual_invoice": "debug.create_manual_invoice",
    "debug.create_payment_from_stripe": "debug.create_payment_from_stripe",
    "debug.dispatch_invoice_replacement": "debug.dispatch_invoice_replacement",
    "debug.dispatch_unpaid_invoice_replacement": "debug.dispatch_unpaid_invoice_replacement",
    "debug.draft_checker_checks": "debug.draft_checker_checks",
    "debug.get_projections": "debug.get_projections",
    "debug.migrate_yeet_policies_contract_number": "debug.migrate_yeet_policies_contract_number",
    "debug.migrate_luko_yearly_billing": "debug.migrate_luko_yearly_billing",
    "debug.backfill_document_correctness": "debug.backfill_document_correctness",
    "debug.refresh_invoice_status": "debug.refresh_invoice_status",
    "debug.retrigger_claim_document_fraud_check": "debug.retrigger_claim_document_fraud_check",
    "debug.retry_charge": "debug.retry_charge",
    "debug.rotate_claims_pii_key": "debug.rotate_claims_pii_key",
    "debug.seed_policies": "debug.seed_policies",
    "debug.set_invoice_cleanup": "debug.set_invoice_cleanup",
    "debug.send_emails_fix_171125": "debug.send_emails_fix_171125",
    "debug.start_daily_staging_cleanup": "debug.start_daily_staging_cleanup",
    "debug.toggle_ignore_core_events": "debug.toggle_ignore_core_events",
    "debug.update_payment_status": "debug.update_payment_status",
    "debug.yousign_security_check": "debug.yousign_security_check",
    "derogation.approve_derogation": "derogation.approve_derogation",
    "derogation.check_derogation_requirement": "derogation.check_derogation_requirement",
    "derogation.create_derogation": "derogation.create_derogation",
    "derogation.deny_derogation": "derogation.deny_derogation",
    "distribution_request.approve": "distribution_request.approve",
    "distribution_request.create_many": "distribution_request.create_many",
    "distribution_request.delete": "distribution_request.delete",
    "distribution_request.deny": "distribution_request.deny",
    "distribution_request.get": "distribution_request.get",
    "distribution_request.list": "distribution_request.list",
    "distribution_request.revoke": "distribution_request.revoke",
    "distribution_request.waiting_for_signature": "distribution_request.waiting_for_signature",
    "documents.archive_documents": "documents.archive_documents",
    "documents.classify_document": "documents.classify_document",
    "documents.create_document_upload_url": "documents.create_document_upload_url",
    "documents.delete_documents": "documents.delete_documents",
    "documents.generate_and_upload_document": "documents.generate_and_upload_document",
    "documents.generate_document": "documents.generate_document",
    "documents.get_documents": "documents.get_documents",
    "documents.get_template": "documents.get_template",
    "documents.handle_document_uploaded": "documents.handle_document_uploaded",
    "documents.health": "documents.health",
    "documents.list": "documents.list",
    "documents.list_all": "documents.list_all",
    "documents.list_all_with_presigned_urls": "documents.list_all_with_presigned_urls",
    "documents.list_with_presigned_urls": "documents.list_with_presigned_urls",
    "documents.restore_documents": "documents.restore_documents",
    "documents.update_documents": "documents.update_documents",
    "efficiale.check_compliance": "efficiale.check_compliance",
    "efficiale.get_alerts": "efficiale.get_alerts",
    "ellisphere.online_order": "ellisphere.online_order",
    "email_account.list_mine": "email_account.list_mine",
    "email_account.initiate_connection": "email_account.initiate_connection",
    "email_account.complete_connection": "email_account.complete_connection",
    "email_account.disconnect": "email_account.disconnect",
    "email_account.reconnect": "email_account.reconnect",
    "email.get_attachment_download_url": "email.get_attachment_download_url",
    "email.get": "email.get",
    "email.mark_as_seen": "email.mark_as_seen",
    "email.list_threads": "email.list_threads",
    "email.get_thread": "email.get_thread",
    "email.set_thread_archived": "email.set_thread_archived",
    "email.attach_policies": "email.attach_policies",
    "email.attach_threads_policies": "email.attach_threads_policies",
    "email.detach_policies": "email.detach_policies",
    "email.detach_policy": "email.detach_policy",
    "email.move_policy": "email.move_policy",
    "general_inbox.get_summary": "general_inbox.get_summary",
    "failed_payments.get_entities_from_invoice": "failed_payments.get_entities_from_invoice",
    "failed_payments.get_failed_payments_workflow_parameters": "failed_payments.get_failed_payments_workflow_parameters",
    "failed_payments.publish_unpaid_invoice_event": "failed_payments.publish_unpaid_invoice_event",
    "failed_payments.start_failed_payment_workflow": "failed_payments.start_failed_payment_workflow",
    "formal_notice.execute_formal_notice_workflow": "formal_notice.execute_formal_notice_workflow",
    "fva.upload_file": "fva.upload_file",
    "hiscox.get_activities_by_sector": "hiscox.get_activities_by_sector",
    "federated_session.start": "federated_session.start",
    "federated_session.get": "federated_session.get",
    "federated_session.revoke": "federated_session.revoke",
    "federated_session.revoke_by_provider_logout": "federated_session.revoke_by_provider_logout",
    "federated_provisioning.provision": "federated_provisioning.provision",
    "impersonation.create_session": "impersonation.create_session",
    "impersonation.get_session": "impersonation.get_session",
    "impersonation.list_sessions": "impersonation.list_sessions",
    "impersonation.revoke_session": "impersonation.revoke_session",
    "invitation.admin_invite": "invitation.admin_invite",
    "invitation.broker_invite": "invitation.broker_invite",
    "invitation.create_anonymous_session": "invitation.create_anonymous_session",
    "invitation.handoff_anonymous_session": "invitation.handoff_anonymous_session",
    "invitation.invite": "invitation.invite",
    "invitation.resolve_session_entities": "invitation.resolve_session_entities",
    "job_schedulers.delete": "job_schedulers.delete",
    "job_schedulers.get": "job_schedulers.get",
    "job_schedulers.get_bull_mq": "job_schedulers.get_bull_mq",
    "job_schedulers.list": "job_schedulers.list",
    "job_schedulers.update": "job_schedulers.update",
    "job_schedulers.upsert": "job_schedulers.upsert",
    "jobs.cancel_job": "jobs.cancel_job",
    "jobs.cancel_jobs": "jobs.cancel_jobs",
    "jobs.count_jobs": "jobs.count_jobs",
    "jobs.create_job": "jobs.create_job",
    "jobs.create_jobs": "jobs.create_jobs",
    "jobs.debounce_job": "jobs.debounce_job",
    "jobs.drain_jobs": "jobs.drain_jobs",
    "jobs.get_job": "jobs.get_job",
    "jobs.list_jobs": "jobs.list_jobs",
    "jobs.retry_jobs": "jobs.retry_jobs",
    "jobs.update_job": "jobs.update_job",
    "legacy.admin_get_conversation_messages": "legacy.admin_get_conversation_messages",
    "legacy.admin_list_conversations": "legacy.admin_list_conversations",
    "legacy.ai_classify_document": "legacy.ai_classify_document",
    "legacy.ai_document_classify": "legacy.ai_document_classify",
    "legacy.ai_document_log_correction": "legacy.ai_document_log_correction",
    "legacy.create_conversation": "legacy.create_conversation",
    "legacy.delete_conversation": "legacy.delete_conversation",
    "legacy.document_extraction.extract_document": "legacy.document_extraction.extract_document",
    "legacy.document_extraction.get_brokerage_firm_extractions": "legacy.document_extraction.get_brokerage_firm_extractions",
    "legacy.document_extraction.get_claim_extractions": "legacy.document_extraction.get_claim_extractions",
    "legacy.document_extraction.get_document_extraction": "legacy.document_extraction.get_document_extraction",
    "legacy.document_extraction.get_extraction_feedback": "legacy.document_extraction.get_extraction_feedback",
    "legacy.document_extraction.get_policy_extractions": "legacy.document_extraction.get_policy_extractions",
    "legacy.document_extraction.submit_extraction_feedback": "legacy.document_extraction.submit_extraction_feedback",
    "legacy.document_prefill.prefill": "legacy.document_prefill.prefill",
    "legacy.document_prefill.record_outcome": "legacy.document_prefill.record_outcome",
    "legacy.document_validity.check_document_validity": "legacy.document_validity.check_document_validity",
    "legacy.document_validity.get_brokerage_firm_validity": "legacy.document_validity.get_brokerage_firm_validity",
    "legacy.document_validity.get_document_validity": "legacy.document_validity.get_document_validity",
    "legacy.document_validity.get_policy_validity": "legacy.document_validity.get_policy_validity",
    "legacy.document_validity.override_document_validity": "legacy.document_validity.override_document_validity",
    "legacy.document_coherence.get_document_coherence": "legacy.document_coherence.get_document_coherence",
    "legacy.document_conformity.accept_document": "legacy.document_conformity.accept_document",
    "legacy.document_conformity.reject_document": "legacy.document_conformity.reject_document",
    "legacy.document_conformity.accept_all_documents": "legacy.document_conformity.accept_all_documents",
    "legacy.document_conformity.cancel_document_conformity": "legacy.document_conformity.cancel_document_conformity",
    "legacy.document_conformity.get_policy_document_conformity": "legacy.document_conformity.get_policy_document_conformity",
    "legacy.document_conformity.get_policy_document_verdicts": "legacy.document_conformity.get_policy_document_verdicts",
    "legacy.document_conformity.apply_automatic_verdict": "legacy.document_conformity.apply_automatic_verdict",
    "legacy.document_conformity.accept_brokerage_firm_document": "legacy.document_conformity.accept_brokerage_firm_document",
    "legacy.document_conformity.reject_brokerage_firm_document": "legacy.document_conformity.reject_brokerage_firm_document",
    "legacy.document_conformity.accept_all_brokerage_firm_documents": "legacy.document_conformity.accept_all_brokerage_firm_documents",
    "legacy.document_conformity.cancel_brokerage_firm_document_conformity": "legacy.document_conformity.cancel_brokerage_firm_document_conformity",
    "legacy.document_conformity.get_brokerage_firm_document_conformity": "legacy.document_conformity.get_brokerage_firm_document_conformity",
    "legacy.document_collection.get_state": "legacy.document_collection.get_state",
    "legacy.document_collection.get_reminder_date": "legacy.document_collection.get_reminder_date",
    "legacy.document_collection.get_reminder_parameters": "legacy.document_collection.get_reminder_parameters",
    "legacy.document_collection.publish_reminder_event": "legacy.document_collection.publish_reminder_event",
    "legacy.get_conversation": "legacy.get_conversation",
    "legacy.get_conversation_messages": "legacy.get_conversation_messages",
    "legacy.get_feature_flags": "legacy.get_feature_flags",
    "legacy.list_feature_flags": "legacy.list_feature_flags",
    "legacy.update_feature_flag": "legacy.update_feature_flag",
    "legacy.get_expected_generated_documents": "legacy.get_expected_generated_documents",
    "legacy.get_expected_uploaded_documents": "legacy.get_expected_uploaded_documents",
    "legacy.get_generation_payload": "legacy.get_generation_payload",
    "legacy.get_on_demand_documents": "legacy.get_on_demand_documents",
    "legacy.get_payload_from_target": "legacy.get_payload_from_target",
    "legacy.health": "legacy.health",
    "legacy.list_conversations": "legacy.list_conversations",
    "legacy_migration.cleanup_dry_run": "legacy_migration.cleanup_dry_run",
    "legacy_migration.migrate_portfolio": "legacy_migration.migrate_portfolio",
    "legacy.regenerate_document": "legacy.regenerate_document",
    "legacy.schedule_handle_malware_protection_scan_result": "legacy.schedule_handle_malware_protection_scan_result",
    "legacy.send_conversation_feedback": "legacy.send_conversation_feedback",
    "legacy.send_conversation_message": "legacy.send_conversation_message",
    "legacy.set_document_category": "legacy.set_document_category",
    "lock.batch_create_locks": "lock.batch_create_locks",
    "lock.batch_delete_locks": "lock.batch_delete_locks",
    "lock.batch_get_locks": "lock.batch_get_locks",
    "lock.create_lock": "lock.create_lock",
    "lock.delete_lock": "lock.delete_lock",
    "lock.get_lock": "lock.get_lock",
    "lock.list_locks": "lock.list_locks",
    "mcp.handle_request": "mcp.handle_request",
    "metabase.get_metabase_iframe_url": "metabase.get_metabase_iframe_url",
    "migration.cleanup_dry_run": "migration.cleanup_dry_run",
    "migration.extract_and_transform_client_data": "migration.extract_and_transform_client_data",
    "migration.load": "migration.load",
    "migration.reupload_corrupted_documents": "migration.reupload_corrupted_documents",
    "migration.run_planned_job": "migration.run_planned_job",
    "migration.start_workflow_api": "migration.start_workflow_api",
    "migration.transform": "migration.transform",
    "migration.update_task_success": "migration.update_task_success",
    "migration.validate": "migration.validate",
    "notification.create": "notification.create",
    "notification.delete": "notification.delete",
    "notification.get": "notification.get",
    "notification.list": "notification.list",
    "notification.list_email_templates": "notification.list_email_templates",
    "notification.patch": "notification.patch",
    "notification.patch-by-metadata-id": "notification.patch-by-metadata-id",
    "notification.render_email_template": "notification.render_email_template",
    "notification.send": "notification.send",
    "payment_methods_migration.load_payment_methods_and_mandates": "payment_methods_migration.load_payment_methods_and_mandates",
    "payment_methods_migration.start_workflow_api": "payment_methods_migration.start_workflow_api",
    "payments.create_customer": "payments.create_customer",
    "payments.create_payment": "payments.create_payment",
    "payments.create_payment_from_stripe": "payments.create_payment_from_stripe",
    "payments.soft_delete_payment_method": "payments.soft_delete_payment_method",
    "customer.delete_payment_method": "customer.delete_payment_method",
    "brokerage_firm.delete_payment_method": "brokerage_firm.delete_payment_method",
    "payments_event_store.dispatch_rebuild_projections": "payments_event_store.dispatch_rebuild_projections",
    "payments.get_bank_transfer_account": "payments.get_bank_transfer_account",
    "payments.get_customer_payment_methods": "payments.get_customer_payment_methods",
    "payments.get_customer_payments": "payments.get_customer_payments",
    "payments.get_payment_methods": "payments.get_payment_methods",
    "payments.get_payments": "payments.get_payments",
    "payments.list_all_payments": "payments.list_all_payments",
    "payments.list_customers": "payments.list_customers",
    "payments.list_payments": "payments.list_payments",
    "payments.refund_payment": "payments.refund_payment",
    "payments.setup_intent": "payments.setup_intent",
    "payments.update_payment_status": "payments.update_payment_status",
    "permissions.authorize_request": "permissions.authorize_request",
    "permissions.define_casl_user": "permissions.define_casl_user",
    "permissions.define_subject": "permissions.define_subject",
    "policy.activate_policy": "policy.activate_policy",
    "policy.batch_get_policies": "policy.batch_get_policies",
    "policy.calculate_policy_quote": "policy.calculate_policy_quote",
    "policy.confirm_policy": "policy.confirm_policy",
    "policy.correct_document_fraud_verdict": "policy.correct_document_fraud_verdict",
    "policy.create_additional_components": "policy.create_additional_components",
    "policy.delete_policy_documents": "policy.delete_policy_documents",
    "policy.edit_policy": "policy.edit_policy",
    "policy.edit_policy_external_id": "policy.edit_policy_external_id",
    "policy.generate_document_upload_url": "policy.generate_document_upload_url",
    "policy.generate_incremental_id": "policy.generate_incremental_id",
    "policy.generate_signature_request": "policy.generate_signature_request",
    "policy.get_aggregate": "policy.get_aggregate",
    "policy.get_document_fraud": "policy.get_document_fraud",
    "policy.get_policy": "policy.get_policy",
    "policy.get_premium_schedule": "policy.get_premium_schedule",
    "policy.list_active_policies": "policy.list_active_policies",
    "policy.list_branches": "policy.list_branches",
    "policy.list_policy_documents": "policy.list_policy_documents",
    "policy.list_policy_events": "policy.list_policy_events",
    "policy.manual_quote_policy": "policy.manual_quote_policy",
    "policy.push_custom_event": "policy.push_custom_event",
    "policy.quote_policy": "policy.quote_policy",
    "policy.register_additional_quote_components": "policy.register_additional_quote_components",
    "policy.set_fees": "policy.set_fees",
    "policy.stop_policy": "policy.stop_policy",
    "policy.suspend_policy": "policy.suspend_policy",
    "policy.transfer_brokerage_firm": "policy.transfer_brokerage_firm",
    "policy.update_policy_quote": "policy.update_policy_quote",
    "pricing.compute_pricing": "pricing.compute_pricing",
    "pricing.get_available_pricing": "pricing.get_available_pricing",
    "pricing.get_price": "pricing.get_price",
    "pricing.save_pricing_selection": "pricing.save_pricing_selection",
    "queue_management.pause": "queue_management.pause",
    "queue_management.pause_single": "queue_management.pause_single",
    "queue_management.resume": "queue_management.resume",
    "queue_management.resume_single": "queue_management.resume_single",
    "queue_management.status": "queue_management.status",
    "quote.get_asset_external_quote": "quote.get_asset_external_quote",
    "quote.get_external_quote": "quote.get_external_quote",
    "quote.get_quote": "quote.get_quote",
    "relations.create": "relations.create",
    "relations.delete": "relations.delete",
    "relations.get_permission_relations_for_user": "relations.get_permission_relations_for_user",
    "relations.list": "relations.list",
    "relations.list_tenant_users": "relations.list_tenant_users",
    "renewal.archive_renewal_document": "renewal.archive_renewal_document",
    "renewal.edit_renewal": "renewal.edit_renewal",
    "renewal.finalize_renewal_branch": "renewal.finalize_renewal_branch",
    "renewal.renewal_creation_checks": "renewal.renewal_creation_checks",
    "renewal.renewal_merge_checks": "renewal.renewal_merge_checks",
    "reporting.get_report_config": "reporting.get_report_config",
    "reporting.get_reports": "reporting.get_reports",
    "reporting.generate_custom_report": "reporting.generate_custom_report",
    "repricing.dispatch": "repricing.dispatch",
    "repricing.merge_branch": "repricing.merge_branch",
    "repricing.quote_policy": "repricing.quote_policy",
    "repricing.start_checks": "repricing.start_checks",
    "search.configurable_search": "search.configurable_search",
    "search.configurable_search_swagger": "search.configurable_search_swagger",
    "search.count": "search.count",
    "search.reindex_all": "search.reindex_all",
    "search.reindex_all_collections": "search.reindex_all_collections",
    "search.search": "search.search",
    "search.suggest": "search.suggest",
    "signature.cancel_signature_request": "signature.cancel_signature_request",
    "signature.cancel_signatures_for_archived_documents": "signature.cancel_signatures_for_archived_documents",
    "signature.cleanup_dry_run": "signature.cleanup_dry_run",
    "signature.create_signature_entries": "signature.create_signature_entries",
    "signature.generate_signature_request": "signature.generate_signature_request",
    "signature.get_signature_requests_by_external_id": "signature.get_signature_requests_by_external_id",
    "signature.get_signature_requests_signed_between": "signature.get_signature_requests_signed_between",
    "signature.get_signature_requests_signed_by_external_ids": "signature.get_signature_requests_signed_by_external_ids",
    "signature.get_signer_link": "signature.get_signer_link",
    "signature.initiate_signature": "signature.initiate_signature",
    "signature.portfolio_migration": "signature.portfolio_migration",
    "signature.resend_signature_reminder": "signature.resend_signature_reminder",
    "siren.search_siren": "siren.search_siren",
    "siv.search_siv": "siv.search_siv",
    "solvability.get_score": "solvability.get_score",
    "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL": "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL",
    "sra.get_facet": "sra.get_facet",
    "sra.get_vehicle_details": "sra.get_vehicle_details",
    "sydia.add_claim": "sydia.add_claim",
    "sydia.aikan_batch_get_assets": "sydia.aikan_batch_get_assets",
    "sydia.get_claim": "sydia.get_claim",
    "sydia.get_claims": "sydia.get_claims",
    "sydia.get_customer": "sydia.get_customer",
    "sydia.get_customers": "sydia.get_customers",
    "sydia.get_policy": "sydia.get_policy",
    "sydia.upsert_policy_claim": "sydia.upsert_policy_claim",
    "telematics.list_average_scores": "telematics.list_average_scores",
    "telematics.list_scores": "telematics.list_scores",
    "telematics.upsert_external_service_user_id": "telematics.upsert_external_service_user_id",
    "tenant_onboarding.create_account": "tenant_onboarding.create_account",
    "tenant_onboarding.create_account_link": "tenant_onboarding.create_account_link",
    "user.get_service_user_data": "user.get_service_user_data",
    "users.legacy_at_me": "users.legacy_at_me",
    "view_specific.accounting_summary": "view_specific.accounting_summary",
    "view_specific.acknowledge_compliance_alert": "view_specific.acknowledge_compliance_alert",
    "view_specific.create_active_team": "view_specific.create_active_team",
    "view_specific.get_available_pricing": "view_specific.get_available_pricing",
    "view_specific.list_brokerage_firm_derogations": "view_specific.list_brokerage_firm_derogations",
    "view_specific.list_brokerage_firm_distribution_requests": "view_specific.list_brokerage_firm_distribution_requests",
    "view_specific.list_brokerage_firm_payment_methods": "view_specific.list_brokerage_firm_payment_methods",
    "view_specific.list_brokerage_firm_policies": "view_specific.list_brokerage_firm_policies",
    "view_specific.list_child_brokerage_firms": "view_specific.list_child_brokerage_firms",
    "view_specific.list_customer_invoices": "view_specific.list_customer_invoices",
    "view_specific.list_customer_payment_methods": "view_specific.list_customer_payment_methods",
    "view_specific.list_customer_payments": "view_specific.list_customer_payments",
    "view_specific.list_customer_relations": "view_specific.list_customer_relations",
    "view_specific.list_distribution_requests_to_brokerage_firm": "view_specific.list_distribution_requests_to_brokerage_firm",
    "view_specific.list_policy_assets": "view_specific.list_policy_assets",
    "view_specific.list_policy_compliance_alerts": "view_specific.list_policy_compliance_alerts",
    "view_specific.list_policy_compliance_checks": "view_specific.list_policy_compliance_checks",
    "view_specific.list_policy_customers": "view_specific.list_policy_customers",
    "view_specific.list_product_common_documents": "view_specific.list_product_common_documents",
    "validation.list_tickets": "validation.list_tickets",
    "validation.generate_test_plan": "validation.generate_test_plan",
    "validation.start_run": "validation.start_run",
    "validation.get_run": "validation.get_run",
    "validation.confirm_run": "validation.confirm_run",
    "validation.list_assets": "validation.list_assets",
    "validation.append_run_event": "validation.append_run_event",
    "validation.list_runs": "validation.list_runs",
    "workflows.cancel_workflow_runs": "workflows.cancel_workflow_runs",
    "workflows.debug_add": "workflows.debug_add",
    "workflows.debug_add_2": "workflows.debug_add_2",
    "workflows.get_workflow_run": "workflows.get_workflow_run",
    "workflows.list_workflow_run_nodes": "workflows.list_workflow_run_nodes",
    "workflows.list_workflow_runs": "workflows.list_workflow_runs",
    "workflows.retry_workflow_run": "workflows.retry_workflow_run",
    "workflows.start_workflow": "workflows.start_workflow",
    "yeet.attach_drivequant_user_id_to_customer": "yeet.attach_drivequant_user_id_to_customer",
    "yeet.edit_drivequant_score_range": "yeet.edit_drivequant_score_range",
    "yeet.edit_drivequant_surcharge_rate": "yeet.edit_drivequant_surcharge_rate",
    "yeet.edit_policy_drivequant_repricing": "yeet.edit_policy_drivequant_repricing",
    "yeet.list_drivequant_average_scores": "yeet.list_drivequant_average_scores",
    "yeet.list_drivequant_historical_users": "yeet.list_drivequant_historical_users",
    "yeet.list_possible_drivequant_users": "yeet.list_possible_drivequant_users",
    "yeet.surchargePolicy": "yeet.surchargePolicy",
    "tutassur.upload_signed_docs_to_cfdp": "tutassur.upload_signed_docs_to_cfdp"
} as const;

export type JobDataCommandEnumKey = (typeof jobDataCommandEnum)[keyof typeof jobDataCommandEnum];

export type JobData = {
    service: Services;
    /**
     * @type string
    */
    command: JobDataCommandEnumKey;
    /**
     * @type object
    */
    payload: object;
    /**
     * @description The timeout of the job
     * @type number | undefined
    */
    timeout?: number;
};

export type CreateJobInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description The time to schedule the job for
     * @type string | undefined, date-time
    */
    runAt?: string;
    /**
     * @description The maximum number of attempts to run the job
     * @type number | undefined
    */
    maxAttempts?: number;
    /**
     * @description The priority of the job, the lower the number, the higher the priority
    */
    priority?: JobPriority;
    /**
     * @type string | undefined
    */
    id?: string;
    /**
     * @type object
    */
    data: JobData;
    /**
     * @type string | undefined
    */
    jobSchedulerRunId?: string;
};

export const createJobOutputTypeEnum = {
    JOB: "JOB"
} as const;

export type CreateJobOutputTypeEnumKey = (typeof createJobOutputTypeEnum)[keyof typeof createJobOutputTypeEnum];

export type CreateJobOutput = {
    /**
     * @type string
    */
    type: CreateJobOutputTypeEnumKey;
    /**
     * @type string
    */
    id: string;
};

export const createJobsInputCommandEnum = {
    "legacy_event_store.push_projection": "legacy_event_store.push_projection",
    "legacy_event_store.rebuild_projections": "legacy_event_store.rebuild_projections",
    "legacy_event_store.dispatch_rebuild_projections": "legacy_event_store.dispatch_rebuild_projections",
    "legacy_event_store.rebuild_core_aggregate_projections": "legacy_event_store.rebuild_core_aggregate_projections",
    "billing_event_store.rebuild_projections": "billing_event_store.rebuild_projections",
    "billing_event_store.dispatch_rebuild_projections": "billing_event_store.dispatch_rebuild_projections",
    "payments_event_store.rebuild_projections": "payments_event_store.rebuild_projections",
    "payment_event_store.rebuild_projections": "payment_event_store.rebuild_projections",
    "payment_event_store.build_projections": "payment_event_store.build_projections",
    "search.index_collection": "search.index_collection",
    "search.reindex_collection": "search.reindex_collection",
    "legacy.attach_policy_document": "legacy.attach_policy_document",
    "legacy.attach_common_documents": "legacy.attach_common_documents",
    "legacy.generate_document": "legacy.generate_document",
    "legacy.archive_old_documents": "legacy.archive_old_documents",
    "claim-management.get-document-generation-payload": "claim-management.get-document-generation-payload",
    "documents.handle_malware_protection_scan_result": "documents.handle_malware_protection_scan_result",
    "notification.send_email_from_fanout_trigger": "notification.send_email_from_fanout_trigger",
    "payments.handle_payment_method_attached": "payments.handle_payment_method_attached",
    "payments.handle_payment_method_updated": "payments.handle_payment_method_updated",
    "payments.handle_payment_method_detached": "payments.handle_payment_method_detached",
    "payments.handle_payment_succeeded": "payments.handle_payment_succeeded",
    "payments.handle_payment_failed": "payments.handle_payment_failed",
    "payments.handle_payment_canceled": "payments.handle_payment_canceled",
    "payments.handle_payment_created": "payments.handle_payment_created",
    "payments.handle_payment_disputed": "payments.handle_payment_disputed",
    "payments.handle_payment_creation_failed": "payments.handle_payment_creation_failed",
    "payments.handle_setup_intent_succeeded": "payments.handle_setup_intent_succeeded",
    "payments.handle_payment_refund_succeeded": "payments.handle_payment_refund_succeeded",
    "payments.handle_payment_refund_updated": "payments.handle_payment_refund_updated",
    "payments.handle_payment_refund_failed": "payments.handle_payment_refund_failed",
    "email_account.handle_sync_webhook_event": "email_account.handle_sync_webhook_event",
    "email.fetch_body": "email.fetch_body",
    "email.analyze_thread": "email.analyze_thread",
    "email.recover_thread_analyses": "email.recover_thread_analyses",
    "email.fetch_attachment": "email.fetch_attachment",
    "branch.invalidate_branch": "branch.invalidate_branch",
    "relations.create_user_and_relation": "relations.create_user_and_relation",
    "jobs.cleanup_jobs_db": "jobs.cleanup_jobs_db",
    "legacy.apply_migration": "legacy.apply_migration",
    "address_autocomplete.suggest": "address_autocomplete.suggest",
    "asset.apply_start_asset": "asset.apply_start_asset",
    "asset.apply_stop_asset": "asset.apply_stop_asset",
    "axece.create_drivequant_user_id": "axece.create_drivequant_user_id",
    "axece.edit_policy_crm": "axece.edit_policy_crm",
    "yeet.create_drivequant_user_id": "yeet.create_drivequant_user_id",
    "yeet.edit_policy_crm": "yeet.edit_policy_crm",
    "fva.retrieve_report_outcome": "fva.retrieve_report_outcome",
    "billing.handle_payment_creation": "billing.handle_payment_creation",
    "billing.handle_payment_disputed": "billing.handle_payment_disputed",
    "billing.handle_payment_failure": "billing.handle_payment_failure",
    "billing.handle_payment_succeeded": "billing.handle_payment_succeeded",
    "branch.auto_archive_one_product_inactive_branches": "branch.auto_archive_one_product_inactive_branches",
    "branch.fork_branch": "branch.fork_branch",
    "branch.edit_branch": "branch.edit_branch",
    "branch.merge_branch": "branch.merge_branch",
    "branch.auto_archive_all_products_inactive_branches": "branch.auto_archive_all_products_inactive_branches",
    "brokerage-firm.create_payment_customer": "brokerage-firm.create_payment_customer",
    "brokerage-firm.score_document_fraud": "brokerage-firm.score_document_fraud",
    "commission-statements.get_document": "commission-statements.get_document",
    "commission-statements.list_for_brokerage_firm": "commission-statements.list_for_brokerage_firm",
    "customer.bill": "customer.bill",
    "customer.charge_customer": "customer.charge_customer",
    "payments.cancel_payment": "payments.cancel_payment",
    "documents.upload_reports_to_connector": "documents.upload_reports_to_connector",
    "documents.check_wakam_validation": "documents.check_wakam_validation",
    "debug.super_delete_policies": "debug.super_delete_policies",
    "notification.send_email": "notification.send_email",
    "notification.send_test_email": "notification.send_test_email",
    "policy.apply_activate_policy": "policy.apply_activate_policy",
    "policy.apply_start_policy": "policy.apply_start_policy",
    "policy.apply_stop_policy": "policy.apply_stop_policy",
    "policy.sign_policy": "policy.sign_policy",
    "policy.dispatch_tasks": "policy.dispatch_tasks",
    "policy.plan_tasks": "policy.plan_tasks",
    "policy.run_tasks": "policy.run_tasks",
    "policy.get_unpaid_duration": "policy.get_unpaid_duration",
    "policy.score_document_fraud": "policy.score_document_fraud",
    "renewal.handle_renewal_branch_on_claim_creation": "renewal.handle_renewal_branch_on_claim_creation",
    "renewal.dispatch_renewal_creation_for_policy": "renewal.dispatch_renewal_creation_for_policy",
    "renewal.dispatch_renewal_merge_for_policy": "renewal.dispatch_renewal_merge_for_policy",
    "renewal.publish_stop_notice": "renewal.publish_stop_notice",
    "reporting.generate_report": "reporting.generate_report",
    "monitoring.run_daily_checks": "monitoring.run_daily_checks",
    "monitoring.list_checks": "monitoring.list_checks",
    "signature.update_signer_status": "signature.update_signer_status",
    "signature.update_signature_signed_status": "signature.update_signature_signed_status",
    "signature.update_signature_cancelled_status": "signature.update_signature_cancelled_status",
    "ar24.create_user": "ar24.create_user",
    "ar24.get_user": "ar24.get_user",
    "ar24.list_users": "ar24.list_users",
    "ar24.request_user_access": "ar24.request_user_access",
    "ar24.request_user_eula": "ar24.request_user_eula",
    "ar24.resend_user_confirmation": "ar24.resend_user_confirmation",
    "ar24.send_ere": "ar24.send_ere",
    "ar24.send_formal_notice": "ar24.send_formal_notice",
    "ar24.update_user": "ar24.update_user",
    "asset.batch_create_assets": "asset.batch_create_assets",
    "asset.batch_edit_assets": "asset.batch_edit_assets",
    "asset.batch_remove_assets": "asset.batch_remove_assets",
    "asset.create_asset": "asset.create_asset",
    "asset.edit_asset": "asset.edit_asset",
    "asset.get_asset": "asset.get_asset",
    "asset.list_assets": "asset.list_assets",
    "asset.push_custom_event": "asset.push_custom_event",
    "asset.remove_asset": "asset.remove_asset",
    "asset.replace_asset": "asset.replace_asset",
    "auth.check_email": "auth.check_email",
    "axece.attach_drivequant_user_id_to_customer": "axece.attach_drivequant_user_id_to_customer",
    "axece.edit_drivequant_score_range": "axece.edit_drivequant_score_range",
    "axece.edit_drivequant_surcharge_rate": "axece.edit_drivequant_surcharge_rate",
    "axece.edit_policy_drivequant_repricing": "axece.edit_policy_drivequant_repricing",
    "axece.list_drivequant_average_scores": "axece.list_drivequant_average_scores",
    "axece.list_drivequant_historical_users": "axece.list_drivequant_historical_users",
    "axece.list_possible_drivequant_users": "axece.list_possible_drivequant_users",
    "axece.surchargePolicy": "axece.surchargePolicy",
    "billing.cancel_invoices": "billing.cancel_invoices",
    "billing.delete_invoices": "billing.delete_invoices",
    "billing.draft_credit_invoice": "billing.draft_credit_invoice",
    "billing.draft_next_invoice": "billing.draft_next_invoice",
    "billing.finalize_invoice": "billing.finalize_invoice",
    "billing.get_invoices": "billing.get_invoices",
    "billing.handle_charge_customer_failure_without_payment_creation": "billing.handle_charge_customer_failure_without_payment_creation",
    "billing.handle_refund_not_handled": "billing.handle_refund_not_handled",
    "billing.issue_invoices": "billing.issue_invoices",
    "billing.list": "billing.list",
    "billing.list_invoice_events": "billing.list_invoice_events",
    "billing.list_invoice_flows": "billing.list_invoice_flows",
    "billing.reconcile_invoices": "billing.reconcile_invoices",
    "billing.replace_invoice": "billing.replace_invoice",
    "billing.replace_unpaid_invoice_checks": "billing.replace_unpaid_invoice_checks",
    "billing.write_off_invoice": "billing.write_off_invoice",
    "branch.apply_close_branch": "branch.apply_close_branch",
    "branch.create_branch": "branch.create_branch",
    "branch.create_or_reuse_branch": "branch.create_or_reuse_branch",
    "branch.get_effective_date": "branch.get_effective_date",
    "broker.at_me": "broker.at_me",
    "broker.batch_get_brokers": "broker.batch_get_brokers",
    "broker.create_broker": "broker.create_broker",
    "broker.delete_broker": "broker.delete_broker",
    "broker.get_broker": "broker.get_broker",
    "broker.list_brokers": "broker.list_brokers",
    "broker.list_descendant_brokers": "broker.list_descendant_brokers",
    "broker.update_broker": "broker.update_broker",
    "brokerage-fee.create": "brokerage-fee.create",
    "brokerage-fee.delete": "brokerage-fee.delete",
    "brokerage-fee.get_computed_fees_for_brokerage_firm": "brokerage-fee.get_computed_fees_for_brokerage_firm",
    "brokerage-fee.get_fees_for_brokerage_firm": "brokerage-fee.get_fees_for_brokerage_firm",
    "brokerage-fee.update": "brokerage-fee.update",
    "brokerage-firm.correct_document_fraud_verdict": "brokerage-firm.correct_document_fraud_verdict",
    "brokerage-firm.create_brokerage_firm": "brokerage-firm.create_brokerage_firm",
    "brokerage-firm.delete_documents": "brokerage-firm.delete_documents",
    "brokerage-firm.generate_document_upload_url": "brokerage-firm.generate_document_upload_url",
    "brokerage-firm.generate_documents_for_signature": "brokerage-firm.generate_documents_for_signature",
    "brokerage-firm.generate_mandate_signature_request": "brokerage-firm.generate_mandate_signature_request",
    "brokerage-firm.generate_report": "brokerage-firm.generate_report",
    "brokerage-firm.generate_signature_request": "brokerage-firm.generate_signature_request",
    "brokerage-firm.get_brokerage_firm": "brokerage-firm.get_brokerage_firm",
    "brokerage-firm.get_document_fraud": "brokerage-firm.get_document_fraud",
    "brokerage-firm.get_payment_methods": "brokerage-firm.get_payment_methods",
    "brokerage-firm.get_payment_setup_secret": "brokerage-firm.get_payment_setup_secret",
    "brokerage-firm.get_report_config": "brokerage-firm.get_report_config",
    "brokerage-firm.list_brokerage_firms": "brokerage-firm.list_brokerage_firms",
    "brokerage-firm.list_documents": "brokerage-firm.list_documents",
    "brokerage-firm.list_reports": "brokerage-firm.list_reports",
    "brokerage-firm.transfer_policies": "brokerage-firm.transfer_policies",
    "brokerage-firm.update_brokerage_firm": "brokerage-firm.update_brokerage_firm",
    "brokerage-firm.update_preferred_payment_method": "brokerage-firm.update_preferred_payment_method",
    "claim-management.score-document-fraud": "claim-management.score-document-fraud",
    "claims.create": "claims.create",
    "claims.delete": "claims.delete",
    "claims.get": "claims.get",
    "claims.list": "claims.list",
    "claims.update": "claims.update",
    "comments.create_comment": "comments.create_comment",
    "comments.delete_comment": "comments.delete_comment",
    "comments.get_comment": "comments.get_comment",
    "comments.list_comments": "comments.list_comments",
    "comments.update_comment": "comments.update_comment",
    "internal_notes.create": "internal_notes.create",
    "internal_notes.list": "internal_notes.list",
    "internal_notes.get": "internal_notes.get",
    "internal_notes.update": "internal_notes.update",
    "internal_notes.soft_delete": "internal_notes.soft_delete",
    "internal_notes.hard_delete": "internal_notes.hard_delete",
    "whatsapp_consent.record": "whatsapp_consent.record",
    "compliance.acknowledge_alerts_by_check_ids": "compliance.acknowledge_alerts_by_check_ids",
    "compliance.acknowledge_alerts_by_entity": "compliance.acknowledge_alerts_by_entity",
    "compliance.batch_check_compliance": "compliance.batch_check_compliance",
    "compliance.create_alert": "compliance.create_alert",
    "compliance.create_compliance_check": "compliance.create_compliance_check",
    "compliance.delete_alert": "compliance.delete_alert",
    "compliance.delete_compliance_check": "compliance.delete_compliance_check",
    "compliance.get_alert": "compliance.get_alert",
    "compliance.get_compliance_check": "compliance.get_compliance_check",
    "compliance.list_alerts": "compliance.list_alerts",
    "compliance.list_compliance_checks": "compliance.list_compliance_checks",
    "compliance.synchronize_new_alerts": "compliance.synchronize_new_alerts",
    "compliance.update_alert": "compliance.update_alert",
    "compliance.update_compliance_check": "compliance.update_compliance_check",
    "config.GET_PRODUCT_CONFIG": "config.GET_PRODUCT_CONFIG",
    "config.GET_PUBLIC_PRODUCT_CONFIG": "config.GET_PUBLIC_PRODUCT_CONFIG",
    "config.GET_PUBLIC_TENANT_CONFIG": "config.GET_PUBLIC_TENANT_CONFIG",
    "config.GET_TENANT_CONFIG": "config.GET_TENANT_CONFIG",
    "config.get_business_role_permissions": "config.get_business_role_permissions",
    "config.get_products_for_tenant": "config.get_products_for_tenant",
    "config.get_public_tenant_config_by_domain": "config.get_public_tenant_config_by_domain",
    "core_aggregate.get_product_config": "core_aggregate.get_product_config",
    "customer.batch_get_customers": "customer.batch_get_customers",
    "customer.create_customer_for_policy": "customer.create_customer_for_policy",
    "customer.create_payment_customer": "customer.create_payment_customer",
    "customer.delete_customer_from_policy": "customer.delete_customer_from_policy",
    "customer.draft_checker": "customer.draft_checker",
    "customer.draft_next_invoice": "customer.draft_next_invoice",
    "customer.draft_replacement_invoice": "customer.draft_replacement_invoice",
    "customer.edit_customer": "customer.edit_customer",
    "customer.generate_mandates_signature_request": "customer.generate_mandates_signature_request",
    "customer.get_bank_transfer_account": "customer.get_bank_transfer_account",
    "customer.get_customer": "customer.get_customer",
    "customer.get_customer_balance": "customer.get_customer_balance",
    "customer.get_customer_payment_methods": "customer.get_customer_payment_methods",
    "customer.get_invoicing_schedule": "customer.get_invoicing_schedule",
    "customer.get_migrated_billing_takeover": "customer.get_migrated_billing_takeover",
    "customer.get_payment_method_setup_secret": "customer.get_payment_method_setup_secret",
    "customer.initialize_customer": "customer.initialize_customer",
    "customer.invoice_drafted_checker": "customer.invoice_drafted_checker",
    "customer.list_customers": "customer.list_customers",
    "customer.lock_customer_billing": "customer.lock_customer_billing",
    "customer.manually_mark_invoice": "customer.manually_mark_invoice",
    "customer.push_custom_event": "customer.push_custom_event",
    "customer.replace_invoice": "customer.replace_invoice",
    "customer.retry_charge": "customer.retry_charge",
    "customer.set_migrated_billing_takeover": "customer.set_migrated_billing_takeover",
    "customer.unlock_customer_billing": "customer.unlock_customer_billing",
    "customer.unlock_migrated_billing_takeover": "customer.unlock_migrated_billing_takeover",
    "customer.update_customer_payment_mode": "customer.update_customer_payment_mode",
    "customer.update_customer_preferred_payment_method": "customer.update_customer_preferred_payment_method",
    "debug.add_new_product_to_distribution-requests": "debug.add_new_product_to_distribution-requests",
    "debug.batch_bill_customers": "debug.batch_bill_customers",
    "debug.batch_create_user_relations": "debug.batch_create_user_relations",
    "debug.batch_generate_documents": "debug.batch_generate_documents",
    "debug.cancel_invoices_one_time": "debug.cancel_invoices_one_time",
    "debug.check_all_documents": "debug.check_all_documents",
    "debug.check_documents": "debug.check_documents",
    "debug.clear_core_cache": "debug.clear_core_cache",
    "debug.clear_core_projections_data": "debug.clear_core_projections_data",
    "debug.clear_core_test_data": "debug.clear_core_test_data",
    "debug.clear_jobs_data": "debug.clear_jobs_data",
    "debug.clear_signature_test_data": "debug.clear_signature_test_data",
    "debug.clear_workflows_data": "debug.clear_workflows_data",
    "debug.count_core_events": "debug.count_core_events",
    "debug.create_manual_invoice": "debug.create_manual_invoice",
    "debug.create_payment_from_stripe": "debug.create_payment_from_stripe",
    "debug.dispatch_invoice_replacement": "debug.dispatch_invoice_replacement",
    "debug.dispatch_unpaid_invoice_replacement": "debug.dispatch_unpaid_invoice_replacement",
    "debug.draft_checker_checks": "debug.draft_checker_checks",
    "debug.get_projections": "debug.get_projections",
    "debug.migrate_yeet_policies_contract_number": "debug.migrate_yeet_policies_contract_number",
    "debug.migrate_luko_yearly_billing": "debug.migrate_luko_yearly_billing",
    "debug.backfill_document_correctness": "debug.backfill_document_correctness",
    "debug.refresh_invoice_status": "debug.refresh_invoice_status",
    "debug.retrigger_claim_document_fraud_check": "debug.retrigger_claim_document_fraud_check",
    "debug.retry_charge": "debug.retry_charge",
    "debug.rotate_claims_pii_key": "debug.rotate_claims_pii_key",
    "debug.seed_policies": "debug.seed_policies",
    "debug.set_invoice_cleanup": "debug.set_invoice_cleanup",
    "debug.send_emails_fix_171125": "debug.send_emails_fix_171125",
    "debug.start_daily_staging_cleanup": "debug.start_daily_staging_cleanup",
    "debug.toggle_ignore_core_events": "debug.toggle_ignore_core_events",
    "debug.update_payment_status": "debug.update_payment_status",
    "debug.yousign_security_check": "debug.yousign_security_check",
    "derogation.approve_derogation": "derogation.approve_derogation",
    "derogation.check_derogation_requirement": "derogation.check_derogation_requirement",
    "derogation.create_derogation": "derogation.create_derogation",
    "derogation.deny_derogation": "derogation.deny_derogation",
    "distribution_request.approve": "distribution_request.approve",
    "distribution_request.create_many": "distribution_request.create_many",
    "distribution_request.delete": "distribution_request.delete",
    "distribution_request.deny": "distribution_request.deny",
    "distribution_request.get": "distribution_request.get",
    "distribution_request.list": "distribution_request.list",
    "distribution_request.revoke": "distribution_request.revoke",
    "distribution_request.waiting_for_signature": "distribution_request.waiting_for_signature",
    "documents.archive_documents": "documents.archive_documents",
    "documents.classify_document": "documents.classify_document",
    "documents.create_document_upload_url": "documents.create_document_upload_url",
    "documents.delete_documents": "documents.delete_documents",
    "documents.generate_and_upload_document": "documents.generate_and_upload_document",
    "documents.generate_document": "documents.generate_document",
    "documents.get_documents": "documents.get_documents",
    "documents.get_template": "documents.get_template",
    "documents.handle_document_uploaded": "documents.handle_document_uploaded",
    "documents.health": "documents.health",
    "documents.list": "documents.list",
    "documents.list_all": "documents.list_all",
    "documents.list_all_with_presigned_urls": "documents.list_all_with_presigned_urls",
    "documents.list_with_presigned_urls": "documents.list_with_presigned_urls",
    "documents.restore_documents": "documents.restore_documents",
    "documents.update_documents": "documents.update_documents",
    "efficiale.check_compliance": "efficiale.check_compliance",
    "efficiale.get_alerts": "efficiale.get_alerts",
    "ellisphere.online_order": "ellisphere.online_order",
    "email_account.list_mine": "email_account.list_mine",
    "email_account.initiate_connection": "email_account.initiate_connection",
    "email_account.complete_connection": "email_account.complete_connection",
    "email_account.disconnect": "email_account.disconnect",
    "email_account.reconnect": "email_account.reconnect",
    "email.get_attachment_download_url": "email.get_attachment_download_url",
    "email.get": "email.get",
    "email.mark_as_seen": "email.mark_as_seen",
    "email.list_threads": "email.list_threads",
    "email.get_thread": "email.get_thread",
    "email.set_thread_archived": "email.set_thread_archived",
    "email.attach_policies": "email.attach_policies",
    "email.attach_threads_policies": "email.attach_threads_policies",
    "email.detach_policies": "email.detach_policies",
    "email.detach_policy": "email.detach_policy",
    "email.move_policy": "email.move_policy",
    "general_inbox.get_summary": "general_inbox.get_summary",
    "failed_payments.get_entities_from_invoice": "failed_payments.get_entities_from_invoice",
    "failed_payments.get_failed_payments_workflow_parameters": "failed_payments.get_failed_payments_workflow_parameters",
    "failed_payments.publish_unpaid_invoice_event": "failed_payments.publish_unpaid_invoice_event",
    "failed_payments.start_failed_payment_workflow": "failed_payments.start_failed_payment_workflow",
    "formal_notice.execute_formal_notice_workflow": "formal_notice.execute_formal_notice_workflow",
    "fva.upload_file": "fva.upload_file",
    "hiscox.get_activities_by_sector": "hiscox.get_activities_by_sector",
    "federated_session.start": "federated_session.start",
    "federated_session.get": "federated_session.get",
    "federated_session.revoke": "federated_session.revoke",
    "federated_session.revoke_by_provider_logout": "federated_session.revoke_by_provider_logout",
    "federated_provisioning.provision": "federated_provisioning.provision",
    "impersonation.create_session": "impersonation.create_session",
    "impersonation.get_session": "impersonation.get_session",
    "impersonation.list_sessions": "impersonation.list_sessions",
    "impersonation.revoke_session": "impersonation.revoke_session",
    "invitation.admin_invite": "invitation.admin_invite",
    "invitation.broker_invite": "invitation.broker_invite",
    "invitation.create_anonymous_session": "invitation.create_anonymous_session",
    "invitation.handoff_anonymous_session": "invitation.handoff_anonymous_session",
    "invitation.invite": "invitation.invite",
    "invitation.resolve_session_entities": "invitation.resolve_session_entities",
    "job_schedulers.delete": "job_schedulers.delete",
    "job_schedulers.get": "job_schedulers.get",
    "job_schedulers.get_bull_mq": "job_schedulers.get_bull_mq",
    "job_schedulers.list": "job_schedulers.list",
    "job_schedulers.update": "job_schedulers.update",
    "job_schedulers.upsert": "job_schedulers.upsert",
    "jobs.cancel_job": "jobs.cancel_job",
    "jobs.cancel_jobs": "jobs.cancel_jobs",
    "jobs.count_jobs": "jobs.count_jobs",
    "jobs.create_job": "jobs.create_job",
    "jobs.create_jobs": "jobs.create_jobs",
    "jobs.debounce_job": "jobs.debounce_job",
    "jobs.drain_jobs": "jobs.drain_jobs",
    "jobs.get_job": "jobs.get_job",
    "jobs.list_jobs": "jobs.list_jobs",
    "jobs.retry_jobs": "jobs.retry_jobs",
    "jobs.update_job": "jobs.update_job",
    "legacy.admin_get_conversation_messages": "legacy.admin_get_conversation_messages",
    "legacy.admin_list_conversations": "legacy.admin_list_conversations",
    "legacy.ai_classify_document": "legacy.ai_classify_document",
    "legacy.ai_document_classify": "legacy.ai_document_classify",
    "legacy.ai_document_log_correction": "legacy.ai_document_log_correction",
    "legacy.create_conversation": "legacy.create_conversation",
    "legacy.delete_conversation": "legacy.delete_conversation",
    "legacy.document_extraction.extract_document": "legacy.document_extraction.extract_document",
    "legacy.document_extraction.get_brokerage_firm_extractions": "legacy.document_extraction.get_brokerage_firm_extractions",
    "legacy.document_extraction.get_claim_extractions": "legacy.document_extraction.get_claim_extractions",
    "legacy.document_extraction.get_document_extraction": "legacy.document_extraction.get_document_extraction",
    "legacy.document_extraction.get_extraction_feedback": "legacy.document_extraction.get_extraction_feedback",
    "legacy.document_extraction.get_policy_extractions": "legacy.document_extraction.get_policy_extractions",
    "legacy.document_extraction.submit_extraction_feedback": "legacy.document_extraction.submit_extraction_feedback",
    "legacy.document_prefill.prefill": "legacy.document_prefill.prefill",
    "legacy.document_prefill.record_outcome": "legacy.document_prefill.record_outcome",
    "legacy.document_validity.check_document_validity": "legacy.document_validity.check_document_validity",
    "legacy.document_validity.get_brokerage_firm_validity": "legacy.document_validity.get_brokerage_firm_validity",
    "legacy.document_validity.get_document_validity": "legacy.document_validity.get_document_validity",
    "legacy.document_validity.get_policy_validity": "legacy.document_validity.get_policy_validity",
    "legacy.document_validity.override_document_validity": "legacy.document_validity.override_document_validity",
    "legacy.document_coherence.get_document_coherence": "legacy.document_coherence.get_document_coherence",
    "legacy.document_conformity.accept_document": "legacy.document_conformity.accept_document",
    "legacy.document_conformity.reject_document": "legacy.document_conformity.reject_document",
    "legacy.document_conformity.accept_all_documents": "legacy.document_conformity.accept_all_documents",
    "legacy.document_conformity.cancel_document_conformity": "legacy.document_conformity.cancel_document_conformity",
    "legacy.document_conformity.get_policy_document_conformity": "legacy.document_conformity.get_policy_document_conformity",
    "legacy.document_conformity.get_policy_document_verdicts": "legacy.document_conformity.get_policy_document_verdicts",
    "legacy.document_conformity.apply_automatic_verdict": "legacy.document_conformity.apply_automatic_verdict",
    "legacy.document_conformity.accept_brokerage_firm_document": "legacy.document_conformity.accept_brokerage_firm_document",
    "legacy.document_conformity.reject_brokerage_firm_document": "legacy.document_conformity.reject_brokerage_firm_document",
    "legacy.document_conformity.accept_all_brokerage_firm_documents": "legacy.document_conformity.accept_all_brokerage_firm_documents",
    "legacy.document_conformity.cancel_brokerage_firm_document_conformity": "legacy.document_conformity.cancel_brokerage_firm_document_conformity",
    "legacy.document_conformity.get_brokerage_firm_document_conformity": "legacy.document_conformity.get_brokerage_firm_document_conformity",
    "legacy.document_collection.get_state": "legacy.document_collection.get_state",
    "legacy.document_collection.get_reminder_date": "legacy.document_collection.get_reminder_date",
    "legacy.document_collection.get_reminder_parameters": "legacy.document_collection.get_reminder_parameters",
    "legacy.document_collection.publish_reminder_event": "legacy.document_collection.publish_reminder_event",
    "legacy.get_conversation": "legacy.get_conversation",
    "legacy.get_conversation_messages": "legacy.get_conversation_messages",
    "legacy.get_feature_flags": "legacy.get_feature_flags",
    "legacy.list_feature_flags": "legacy.list_feature_flags",
    "legacy.update_feature_flag": "legacy.update_feature_flag",
    "legacy.get_expected_generated_documents": "legacy.get_expected_generated_documents",
    "legacy.get_expected_uploaded_documents": "legacy.get_expected_uploaded_documents",
    "legacy.get_generation_payload": "legacy.get_generation_payload",
    "legacy.get_on_demand_documents": "legacy.get_on_demand_documents",
    "legacy.get_payload_from_target": "legacy.get_payload_from_target",
    "legacy.health": "legacy.health",
    "legacy.list_conversations": "legacy.list_conversations",
    "legacy_migration.cleanup_dry_run": "legacy_migration.cleanup_dry_run",
    "legacy_migration.migrate_portfolio": "legacy_migration.migrate_portfolio",
    "legacy.regenerate_document": "legacy.regenerate_document",
    "legacy.schedule_handle_malware_protection_scan_result": "legacy.schedule_handle_malware_protection_scan_result",
    "legacy.send_conversation_feedback": "legacy.send_conversation_feedback",
    "legacy.send_conversation_message": "legacy.send_conversation_message",
    "legacy.set_document_category": "legacy.set_document_category",
    "lock.batch_create_locks": "lock.batch_create_locks",
    "lock.batch_delete_locks": "lock.batch_delete_locks",
    "lock.batch_get_locks": "lock.batch_get_locks",
    "lock.create_lock": "lock.create_lock",
    "lock.delete_lock": "lock.delete_lock",
    "lock.get_lock": "lock.get_lock",
    "lock.list_locks": "lock.list_locks",
    "mcp.handle_request": "mcp.handle_request",
    "metabase.get_metabase_iframe_url": "metabase.get_metabase_iframe_url",
    "migration.cleanup_dry_run": "migration.cleanup_dry_run",
    "migration.extract_and_transform_client_data": "migration.extract_and_transform_client_data",
    "migration.load": "migration.load",
    "migration.reupload_corrupted_documents": "migration.reupload_corrupted_documents",
    "migration.run_planned_job": "migration.run_planned_job",
    "migration.start_workflow_api": "migration.start_workflow_api",
    "migration.transform": "migration.transform",
    "migration.update_task_success": "migration.update_task_success",
    "migration.validate": "migration.validate",
    "notification.create": "notification.create",
    "notification.delete": "notification.delete",
    "notification.get": "notification.get",
    "notification.list": "notification.list",
    "notification.list_email_templates": "notification.list_email_templates",
    "notification.patch": "notification.patch",
    "notification.patch-by-metadata-id": "notification.patch-by-metadata-id",
    "notification.render_email_template": "notification.render_email_template",
    "notification.send": "notification.send",
    "payment_methods_migration.load_payment_methods_and_mandates": "payment_methods_migration.load_payment_methods_and_mandates",
    "payment_methods_migration.start_workflow_api": "payment_methods_migration.start_workflow_api",
    "payments.create_customer": "payments.create_customer",
    "payments.create_payment": "payments.create_payment",
    "payments.create_payment_from_stripe": "payments.create_payment_from_stripe",
    "payments.soft_delete_payment_method": "payments.soft_delete_payment_method",
    "customer.delete_payment_method": "customer.delete_payment_method",
    "brokerage_firm.delete_payment_method": "brokerage_firm.delete_payment_method",
    "payments_event_store.dispatch_rebuild_projections": "payments_event_store.dispatch_rebuild_projections",
    "payments.get_bank_transfer_account": "payments.get_bank_transfer_account",
    "payments.get_customer_payment_methods": "payments.get_customer_payment_methods",
    "payments.get_customer_payments": "payments.get_customer_payments",
    "payments.get_payment_methods": "payments.get_payment_methods",
    "payments.get_payments": "payments.get_payments",
    "payments.list_all_payments": "payments.list_all_payments",
    "payments.list_customers": "payments.list_customers",
    "payments.list_payments": "payments.list_payments",
    "payments.refund_payment": "payments.refund_payment",
    "payments.setup_intent": "payments.setup_intent",
    "payments.update_payment_status": "payments.update_payment_status",
    "permissions.authorize_request": "permissions.authorize_request",
    "permissions.define_casl_user": "permissions.define_casl_user",
    "permissions.define_subject": "permissions.define_subject",
    "policy.activate_policy": "policy.activate_policy",
    "policy.batch_get_policies": "policy.batch_get_policies",
    "policy.calculate_policy_quote": "policy.calculate_policy_quote",
    "policy.confirm_policy": "policy.confirm_policy",
    "policy.correct_document_fraud_verdict": "policy.correct_document_fraud_verdict",
    "policy.create_additional_components": "policy.create_additional_components",
    "policy.delete_policy_documents": "policy.delete_policy_documents",
    "policy.edit_policy": "policy.edit_policy",
    "policy.edit_policy_external_id": "policy.edit_policy_external_id",
    "policy.generate_document_upload_url": "policy.generate_document_upload_url",
    "policy.generate_incremental_id": "policy.generate_incremental_id",
    "policy.generate_signature_request": "policy.generate_signature_request",
    "policy.get_aggregate": "policy.get_aggregate",
    "policy.get_document_fraud": "policy.get_document_fraud",
    "policy.get_policy": "policy.get_policy",
    "policy.get_premium_schedule": "policy.get_premium_schedule",
    "policy.list_active_policies": "policy.list_active_policies",
    "policy.list_branches": "policy.list_branches",
    "policy.list_policy_documents": "policy.list_policy_documents",
    "policy.list_policy_events": "policy.list_policy_events",
    "policy.manual_quote_policy": "policy.manual_quote_policy",
    "policy.push_custom_event": "policy.push_custom_event",
    "policy.quote_policy": "policy.quote_policy",
    "policy.register_additional_quote_components": "policy.register_additional_quote_components",
    "policy.set_fees": "policy.set_fees",
    "policy.stop_policy": "policy.stop_policy",
    "policy.suspend_policy": "policy.suspend_policy",
    "policy.transfer_brokerage_firm": "policy.transfer_brokerage_firm",
    "policy.update_policy_quote": "policy.update_policy_quote",
    "pricing.compute_pricing": "pricing.compute_pricing",
    "pricing.get_available_pricing": "pricing.get_available_pricing",
    "pricing.get_price": "pricing.get_price",
    "pricing.save_pricing_selection": "pricing.save_pricing_selection",
    "queue_management.pause": "queue_management.pause",
    "queue_management.pause_single": "queue_management.pause_single",
    "queue_management.resume": "queue_management.resume",
    "queue_management.resume_single": "queue_management.resume_single",
    "queue_management.status": "queue_management.status",
    "quote.get_asset_external_quote": "quote.get_asset_external_quote",
    "quote.get_external_quote": "quote.get_external_quote",
    "quote.get_quote": "quote.get_quote",
    "relations.create": "relations.create",
    "relations.delete": "relations.delete",
    "relations.get_permission_relations_for_user": "relations.get_permission_relations_for_user",
    "relations.list": "relations.list",
    "relations.list_tenant_users": "relations.list_tenant_users",
    "renewal.archive_renewal_document": "renewal.archive_renewal_document",
    "renewal.edit_renewal": "renewal.edit_renewal",
    "renewal.finalize_renewal_branch": "renewal.finalize_renewal_branch",
    "renewal.renewal_creation_checks": "renewal.renewal_creation_checks",
    "renewal.renewal_merge_checks": "renewal.renewal_merge_checks",
    "reporting.get_report_config": "reporting.get_report_config",
    "reporting.get_reports": "reporting.get_reports",
    "reporting.generate_custom_report": "reporting.generate_custom_report",
    "repricing.dispatch": "repricing.dispatch",
    "repricing.merge_branch": "repricing.merge_branch",
    "repricing.quote_policy": "repricing.quote_policy",
    "repricing.start_checks": "repricing.start_checks",
    "search.configurable_search": "search.configurable_search",
    "search.configurable_search_swagger": "search.configurable_search_swagger",
    "search.count": "search.count",
    "search.reindex_all": "search.reindex_all",
    "search.reindex_all_collections": "search.reindex_all_collections",
    "search.search": "search.search",
    "search.suggest": "search.suggest",
    "signature.cancel_signature_request": "signature.cancel_signature_request",
    "signature.cancel_signatures_for_archived_documents": "signature.cancel_signatures_for_archived_documents",
    "signature.cleanup_dry_run": "signature.cleanup_dry_run",
    "signature.create_signature_entries": "signature.create_signature_entries",
    "signature.generate_signature_request": "signature.generate_signature_request",
    "signature.get_signature_requests_by_external_id": "signature.get_signature_requests_by_external_id",
    "signature.get_signature_requests_signed_between": "signature.get_signature_requests_signed_between",
    "signature.get_signature_requests_signed_by_external_ids": "signature.get_signature_requests_signed_by_external_ids",
    "signature.get_signer_link": "signature.get_signer_link",
    "signature.initiate_signature": "signature.initiate_signature",
    "signature.portfolio_migration": "signature.portfolio_migration",
    "signature.resend_signature_reminder": "signature.resend_signature_reminder",
    "siren.search_siren": "siren.search_siren",
    "siv.search_siv": "siv.search_siv",
    "solvability.get_score": "solvability.get_score",
    "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL": "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL",
    "sra.get_facet": "sra.get_facet",
    "sra.get_vehicle_details": "sra.get_vehicle_details",
    "sydia.add_claim": "sydia.add_claim",
    "sydia.aikan_batch_get_assets": "sydia.aikan_batch_get_assets",
    "sydia.get_claim": "sydia.get_claim",
    "sydia.get_claims": "sydia.get_claims",
    "sydia.get_customer": "sydia.get_customer",
    "sydia.get_customers": "sydia.get_customers",
    "sydia.get_policy": "sydia.get_policy",
    "sydia.upsert_policy_claim": "sydia.upsert_policy_claim",
    "telematics.list_average_scores": "telematics.list_average_scores",
    "telematics.list_scores": "telematics.list_scores",
    "telematics.upsert_external_service_user_id": "telematics.upsert_external_service_user_id",
    "tenant_onboarding.create_account": "tenant_onboarding.create_account",
    "tenant_onboarding.create_account_link": "tenant_onboarding.create_account_link",
    "user.get_service_user_data": "user.get_service_user_data",
    "users.legacy_at_me": "users.legacy_at_me",
    "view_specific.accounting_summary": "view_specific.accounting_summary",
    "view_specific.acknowledge_compliance_alert": "view_specific.acknowledge_compliance_alert",
    "view_specific.create_active_team": "view_specific.create_active_team",
    "view_specific.get_available_pricing": "view_specific.get_available_pricing",
    "view_specific.list_brokerage_firm_derogations": "view_specific.list_brokerage_firm_derogations",
    "view_specific.list_brokerage_firm_distribution_requests": "view_specific.list_brokerage_firm_distribution_requests",
    "view_specific.list_brokerage_firm_payment_methods": "view_specific.list_brokerage_firm_payment_methods",
    "view_specific.list_brokerage_firm_policies": "view_specific.list_brokerage_firm_policies",
    "view_specific.list_child_brokerage_firms": "view_specific.list_child_brokerage_firms",
    "view_specific.list_customer_invoices": "view_specific.list_customer_invoices",
    "view_specific.list_customer_payment_methods": "view_specific.list_customer_payment_methods",
    "view_specific.list_customer_payments": "view_specific.list_customer_payments",
    "view_specific.list_customer_relations": "view_specific.list_customer_relations",
    "view_specific.list_distribution_requests_to_brokerage_firm": "view_specific.list_distribution_requests_to_brokerage_firm",
    "view_specific.list_policy_assets": "view_specific.list_policy_assets",
    "view_specific.list_policy_compliance_alerts": "view_specific.list_policy_compliance_alerts",
    "view_specific.list_policy_compliance_checks": "view_specific.list_policy_compliance_checks",
    "view_specific.list_policy_customers": "view_specific.list_policy_customers",
    "view_specific.list_product_common_documents": "view_specific.list_product_common_documents",
    "validation.list_tickets": "validation.list_tickets",
    "validation.generate_test_plan": "validation.generate_test_plan",
    "validation.start_run": "validation.start_run",
    "validation.get_run": "validation.get_run",
    "validation.confirm_run": "validation.confirm_run",
    "validation.list_assets": "validation.list_assets",
    "validation.append_run_event": "validation.append_run_event",
    "validation.list_runs": "validation.list_runs",
    "workflows.cancel_workflow_runs": "workflows.cancel_workflow_runs",
    "workflows.debug_add": "workflows.debug_add",
    "workflows.debug_add_2": "workflows.debug_add_2",
    "workflows.get_workflow_run": "workflows.get_workflow_run",
    "workflows.list_workflow_run_nodes": "workflows.list_workflow_run_nodes",
    "workflows.list_workflow_runs": "workflows.list_workflow_runs",
    "workflows.retry_workflow_run": "workflows.retry_workflow_run",
    "workflows.start_workflow": "workflows.start_workflow",
    "yeet.attach_drivequant_user_id_to_customer": "yeet.attach_drivequant_user_id_to_customer",
    "yeet.edit_drivequant_score_range": "yeet.edit_drivequant_score_range",
    "yeet.edit_drivequant_surcharge_rate": "yeet.edit_drivequant_surcharge_rate",
    "yeet.edit_policy_drivequant_repricing": "yeet.edit_policy_drivequant_repricing",
    "yeet.list_drivequant_average_scores": "yeet.list_drivequant_average_scores",
    "yeet.list_drivequant_historical_users": "yeet.list_drivequant_historical_users",
    "yeet.list_possible_drivequant_users": "yeet.list_possible_drivequant_users",
    "yeet.surchargePolicy": "yeet.surchargePolicy",
    "tutassur.upload_signed_docs_to_cfdp": "tutassur.upload_signed_docs_to_cfdp"
} as const;

export type CreateJobsInputCommandEnumKey = (typeof createJobsInputCommandEnum)[keyof typeof createJobsInputCommandEnum];

export type CreateJobsInput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    service: Services;
    /**
     * @type string
    */
    command: CreateJobsInputCommandEnumKey;
    /**
     * @description The time to schedule the job for
     * @type string | undefined, date-time
    */
    runAt?: string;
    /**
     * @description The maximum number of attempts to run the job
     * @type number | undefined
    */
    maxAttempts?: number;
    /**
     * @description The priority of the job, the lower the number, the higher the priority
    */
    priority?: JobPriority;
    /**
     * @description Optional timeout shared by every job in the batch
     * @type number | undefined
    */
    timeout?: number;
    /**
     * @description S3 key (the `id` returned by POST /documents) of a JSON file containing the payloads array. PUT the JSON to the presigned URL before calling this endpoint. The backend deletes the object after parsing.
     * @type string
    */
    payloadsS3Key: string;
};

export type CreateJobsOutput = {
    /**
     * @type string
    */
    batchId: string;
    /**
     * @description Number of jobs created in this batch
     * @type number
    */
    createdCount: number;
};

export type UpdateJobInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
    /**
     * @description The time to schedule the job for
     * @type string | undefined, date-time
    */
    runAt?: string;
    /**
     * @description The priority of the job, the lower the number, the higher the priority
    */
    priority?: JobPriority;
    /**
     * @type string | undefined
    */
    id?: string;
    /**
     * @type object | undefined
    */
    data?: JobData;
    /**
     * @type string | undefined
    */
    jobSchedulerRunId?: string;
};

export type UpdateJobOutput = object;

export const getJobOutputTypeEnum = {
    JOB: "JOB"
} as const;

export type GetJobOutputTypeEnumKey = (typeof getJobOutputTypeEnum)[keyof typeof getJobOutputTypeEnum];

export const getJobOutputCommandEnum = {
    "legacy_event_store.push_projection": "legacy_event_store.push_projection",
    "legacy_event_store.rebuild_projections": "legacy_event_store.rebuild_projections",
    "legacy_event_store.dispatch_rebuild_projections": "legacy_event_store.dispatch_rebuild_projections",
    "legacy_event_store.rebuild_core_aggregate_projections": "legacy_event_store.rebuild_core_aggregate_projections",
    "billing_event_store.rebuild_projections": "billing_event_store.rebuild_projections",
    "billing_event_store.dispatch_rebuild_projections": "billing_event_store.dispatch_rebuild_projections",
    "payments_event_store.rebuild_projections": "payments_event_store.rebuild_projections",
    "payment_event_store.rebuild_projections": "payment_event_store.rebuild_projections",
    "payment_event_store.build_projections": "payment_event_store.build_projections",
    "search.index_collection": "search.index_collection",
    "search.reindex_collection": "search.reindex_collection",
    "legacy.attach_policy_document": "legacy.attach_policy_document",
    "legacy.attach_common_documents": "legacy.attach_common_documents",
    "legacy.generate_document": "legacy.generate_document",
    "legacy.archive_old_documents": "legacy.archive_old_documents",
    "claim-management.get-document-generation-payload": "claim-management.get-document-generation-payload",
    "documents.handle_malware_protection_scan_result": "documents.handle_malware_protection_scan_result",
    "notification.send_email_from_fanout_trigger": "notification.send_email_from_fanout_trigger",
    "payments.handle_payment_method_attached": "payments.handle_payment_method_attached",
    "payments.handle_payment_method_updated": "payments.handle_payment_method_updated",
    "payments.handle_payment_method_detached": "payments.handle_payment_method_detached",
    "payments.handle_payment_succeeded": "payments.handle_payment_succeeded",
    "payments.handle_payment_failed": "payments.handle_payment_failed",
    "payments.handle_payment_canceled": "payments.handle_payment_canceled",
    "payments.handle_payment_created": "payments.handle_payment_created",
    "payments.handle_payment_disputed": "payments.handle_payment_disputed",
    "payments.handle_payment_creation_failed": "payments.handle_payment_creation_failed",
    "payments.handle_setup_intent_succeeded": "payments.handle_setup_intent_succeeded",
    "payments.handle_payment_refund_succeeded": "payments.handle_payment_refund_succeeded",
    "payments.handle_payment_refund_updated": "payments.handle_payment_refund_updated",
    "payments.handle_payment_refund_failed": "payments.handle_payment_refund_failed",
    "email_account.handle_sync_webhook_event": "email_account.handle_sync_webhook_event",
    "email.fetch_body": "email.fetch_body",
    "email.analyze_thread": "email.analyze_thread",
    "email.recover_thread_analyses": "email.recover_thread_analyses",
    "email.fetch_attachment": "email.fetch_attachment",
    "branch.invalidate_branch": "branch.invalidate_branch",
    "relations.create_user_and_relation": "relations.create_user_and_relation",
    "jobs.cleanup_jobs_db": "jobs.cleanup_jobs_db",
    "legacy.apply_migration": "legacy.apply_migration",
    "address_autocomplete.suggest": "address_autocomplete.suggest",
    "asset.apply_start_asset": "asset.apply_start_asset",
    "asset.apply_stop_asset": "asset.apply_stop_asset",
    "axece.create_drivequant_user_id": "axece.create_drivequant_user_id",
    "axece.edit_policy_crm": "axece.edit_policy_crm",
    "yeet.create_drivequant_user_id": "yeet.create_drivequant_user_id",
    "yeet.edit_policy_crm": "yeet.edit_policy_crm",
    "fva.retrieve_report_outcome": "fva.retrieve_report_outcome",
    "billing.handle_payment_creation": "billing.handle_payment_creation",
    "billing.handle_payment_disputed": "billing.handle_payment_disputed",
    "billing.handle_payment_failure": "billing.handle_payment_failure",
    "billing.handle_payment_succeeded": "billing.handle_payment_succeeded",
    "branch.auto_archive_one_product_inactive_branches": "branch.auto_archive_one_product_inactive_branches",
    "branch.fork_branch": "branch.fork_branch",
    "branch.edit_branch": "branch.edit_branch",
    "branch.merge_branch": "branch.merge_branch",
    "branch.auto_archive_all_products_inactive_branches": "branch.auto_archive_all_products_inactive_branches",
    "brokerage-firm.create_payment_customer": "brokerage-firm.create_payment_customer",
    "brokerage-firm.score_document_fraud": "brokerage-firm.score_document_fraud",
    "commission-statements.get_document": "commission-statements.get_document",
    "commission-statements.list_for_brokerage_firm": "commission-statements.list_for_brokerage_firm",
    "customer.bill": "customer.bill",
    "customer.charge_customer": "customer.charge_customer",
    "payments.cancel_payment": "payments.cancel_payment",
    "documents.upload_reports_to_connector": "documents.upload_reports_to_connector",
    "documents.check_wakam_validation": "documents.check_wakam_validation",
    "debug.super_delete_policies": "debug.super_delete_policies",
    "notification.send_email": "notification.send_email",
    "notification.send_test_email": "notification.send_test_email",
    "policy.apply_activate_policy": "policy.apply_activate_policy",
    "policy.apply_start_policy": "policy.apply_start_policy",
    "policy.apply_stop_policy": "policy.apply_stop_policy",
    "policy.sign_policy": "policy.sign_policy",
    "policy.dispatch_tasks": "policy.dispatch_tasks",
    "policy.plan_tasks": "policy.plan_tasks",
    "policy.run_tasks": "policy.run_tasks",
    "policy.get_unpaid_duration": "policy.get_unpaid_duration",
    "policy.score_document_fraud": "policy.score_document_fraud",
    "renewal.handle_renewal_branch_on_claim_creation": "renewal.handle_renewal_branch_on_claim_creation",
    "renewal.dispatch_renewal_creation_for_policy": "renewal.dispatch_renewal_creation_for_policy",
    "renewal.dispatch_renewal_merge_for_policy": "renewal.dispatch_renewal_merge_for_policy",
    "renewal.publish_stop_notice": "renewal.publish_stop_notice",
    "reporting.generate_report": "reporting.generate_report",
    "monitoring.run_daily_checks": "monitoring.run_daily_checks",
    "monitoring.list_checks": "monitoring.list_checks",
    "signature.update_signer_status": "signature.update_signer_status",
    "signature.update_signature_signed_status": "signature.update_signature_signed_status",
    "signature.update_signature_cancelled_status": "signature.update_signature_cancelled_status",
    "ar24.create_user": "ar24.create_user",
    "ar24.get_user": "ar24.get_user",
    "ar24.list_users": "ar24.list_users",
    "ar24.request_user_access": "ar24.request_user_access",
    "ar24.request_user_eula": "ar24.request_user_eula",
    "ar24.resend_user_confirmation": "ar24.resend_user_confirmation",
    "ar24.send_ere": "ar24.send_ere",
    "ar24.send_formal_notice": "ar24.send_formal_notice",
    "ar24.update_user": "ar24.update_user",
    "asset.batch_create_assets": "asset.batch_create_assets",
    "asset.batch_edit_assets": "asset.batch_edit_assets",
    "asset.batch_remove_assets": "asset.batch_remove_assets",
    "asset.create_asset": "asset.create_asset",
    "asset.edit_asset": "asset.edit_asset",
    "asset.get_asset": "asset.get_asset",
    "asset.list_assets": "asset.list_assets",
    "asset.push_custom_event": "asset.push_custom_event",
    "asset.remove_asset": "asset.remove_asset",
    "asset.replace_asset": "asset.replace_asset",
    "auth.check_email": "auth.check_email",
    "axece.attach_drivequant_user_id_to_customer": "axece.attach_drivequant_user_id_to_customer",
    "axece.edit_drivequant_score_range": "axece.edit_drivequant_score_range",
    "axece.edit_drivequant_surcharge_rate": "axece.edit_drivequant_surcharge_rate",
    "axece.edit_policy_drivequant_repricing": "axece.edit_policy_drivequant_repricing",
    "axece.list_drivequant_average_scores": "axece.list_drivequant_average_scores",
    "axece.list_drivequant_historical_users": "axece.list_drivequant_historical_users",
    "axece.list_possible_drivequant_users": "axece.list_possible_drivequant_users",
    "axece.surchargePolicy": "axece.surchargePolicy",
    "billing.cancel_invoices": "billing.cancel_invoices",
    "billing.delete_invoices": "billing.delete_invoices",
    "billing.draft_credit_invoice": "billing.draft_credit_invoice",
    "billing.draft_next_invoice": "billing.draft_next_invoice",
    "billing.finalize_invoice": "billing.finalize_invoice",
    "billing.get_invoices": "billing.get_invoices",
    "billing.handle_charge_customer_failure_without_payment_creation": "billing.handle_charge_customer_failure_without_payment_creation",
    "billing.handle_refund_not_handled": "billing.handle_refund_not_handled",
    "billing.issue_invoices": "billing.issue_invoices",
    "billing.list": "billing.list",
    "billing.list_invoice_events": "billing.list_invoice_events",
    "billing.list_invoice_flows": "billing.list_invoice_flows",
    "billing.reconcile_invoices": "billing.reconcile_invoices",
    "billing.replace_invoice": "billing.replace_invoice",
    "billing.replace_unpaid_invoice_checks": "billing.replace_unpaid_invoice_checks",
    "billing.write_off_invoice": "billing.write_off_invoice",
    "branch.apply_close_branch": "branch.apply_close_branch",
    "branch.create_branch": "branch.create_branch",
    "branch.create_or_reuse_branch": "branch.create_or_reuse_branch",
    "branch.get_effective_date": "branch.get_effective_date",
    "broker.at_me": "broker.at_me",
    "broker.batch_get_brokers": "broker.batch_get_brokers",
    "broker.create_broker": "broker.create_broker",
    "broker.delete_broker": "broker.delete_broker",
    "broker.get_broker": "broker.get_broker",
    "broker.list_brokers": "broker.list_brokers",
    "broker.list_descendant_brokers": "broker.list_descendant_brokers",
    "broker.update_broker": "broker.update_broker",
    "brokerage-fee.create": "brokerage-fee.create",
    "brokerage-fee.delete": "brokerage-fee.delete",
    "brokerage-fee.get_computed_fees_for_brokerage_firm": "brokerage-fee.get_computed_fees_for_brokerage_firm",
    "brokerage-fee.get_fees_for_brokerage_firm": "brokerage-fee.get_fees_for_brokerage_firm",
    "brokerage-fee.update": "brokerage-fee.update",
    "brokerage-firm.correct_document_fraud_verdict": "brokerage-firm.correct_document_fraud_verdict",
    "brokerage-firm.create_brokerage_firm": "brokerage-firm.create_brokerage_firm",
    "brokerage-firm.delete_documents": "brokerage-firm.delete_documents",
    "brokerage-firm.generate_document_upload_url": "brokerage-firm.generate_document_upload_url",
    "brokerage-firm.generate_documents_for_signature": "brokerage-firm.generate_documents_for_signature",
    "brokerage-firm.generate_mandate_signature_request": "brokerage-firm.generate_mandate_signature_request",
    "brokerage-firm.generate_report": "brokerage-firm.generate_report",
    "brokerage-firm.generate_signature_request": "brokerage-firm.generate_signature_request",
    "brokerage-firm.get_brokerage_firm": "brokerage-firm.get_brokerage_firm",
    "brokerage-firm.get_document_fraud": "brokerage-firm.get_document_fraud",
    "brokerage-firm.get_payment_methods": "brokerage-firm.get_payment_methods",
    "brokerage-firm.get_payment_setup_secret": "brokerage-firm.get_payment_setup_secret",
    "brokerage-firm.get_report_config": "brokerage-firm.get_report_config",
    "brokerage-firm.list_brokerage_firms": "brokerage-firm.list_brokerage_firms",
    "brokerage-firm.list_documents": "brokerage-firm.list_documents",
    "brokerage-firm.list_reports": "brokerage-firm.list_reports",
    "brokerage-firm.transfer_policies": "brokerage-firm.transfer_policies",
    "brokerage-firm.update_brokerage_firm": "brokerage-firm.update_brokerage_firm",
    "brokerage-firm.update_preferred_payment_method": "brokerage-firm.update_preferred_payment_method",
    "claim-management.score-document-fraud": "claim-management.score-document-fraud",
    "claims.create": "claims.create",
    "claims.delete": "claims.delete",
    "claims.get": "claims.get",
    "claims.list": "claims.list",
    "claims.update": "claims.update",
    "comments.create_comment": "comments.create_comment",
    "comments.delete_comment": "comments.delete_comment",
    "comments.get_comment": "comments.get_comment",
    "comments.list_comments": "comments.list_comments",
    "comments.update_comment": "comments.update_comment",
    "internal_notes.create": "internal_notes.create",
    "internal_notes.list": "internal_notes.list",
    "internal_notes.get": "internal_notes.get",
    "internal_notes.update": "internal_notes.update",
    "internal_notes.soft_delete": "internal_notes.soft_delete",
    "internal_notes.hard_delete": "internal_notes.hard_delete",
    "whatsapp_consent.record": "whatsapp_consent.record",
    "compliance.acknowledge_alerts_by_check_ids": "compliance.acknowledge_alerts_by_check_ids",
    "compliance.acknowledge_alerts_by_entity": "compliance.acknowledge_alerts_by_entity",
    "compliance.batch_check_compliance": "compliance.batch_check_compliance",
    "compliance.create_alert": "compliance.create_alert",
    "compliance.create_compliance_check": "compliance.create_compliance_check",
    "compliance.delete_alert": "compliance.delete_alert",
    "compliance.delete_compliance_check": "compliance.delete_compliance_check",
    "compliance.get_alert": "compliance.get_alert",
    "compliance.get_compliance_check": "compliance.get_compliance_check",
    "compliance.list_alerts": "compliance.list_alerts",
    "compliance.list_compliance_checks": "compliance.list_compliance_checks",
    "compliance.synchronize_new_alerts": "compliance.synchronize_new_alerts",
    "compliance.update_alert": "compliance.update_alert",
    "compliance.update_compliance_check": "compliance.update_compliance_check",
    "config.GET_PRODUCT_CONFIG": "config.GET_PRODUCT_CONFIG",
    "config.GET_PUBLIC_PRODUCT_CONFIG": "config.GET_PUBLIC_PRODUCT_CONFIG",
    "config.GET_PUBLIC_TENANT_CONFIG": "config.GET_PUBLIC_TENANT_CONFIG",
    "config.GET_TENANT_CONFIG": "config.GET_TENANT_CONFIG",
    "config.get_business_role_permissions": "config.get_business_role_permissions",
    "config.get_products_for_tenant": "config.get_products_for_tenant",
    "config.get_public_tenant_config_by_domain": "config.get_public_tenant_config_by_domain",
    "core_aggregate.get_product_config": "core_aggregate.get_product_config",
    "customer.batch_get_customers": "customer.batch_get_customers",
    "customer.create_customer_for_policy": "customer.create_customer_for_policy",
    "customer.create_payment_customer": "customer.create_payment_customer",
    "customer.delete_customer_from_policy": "customer.delete_customer_from_policy",
    "customer.draft_checker": "customer.draft_checker",
    "customer.draft_next_invoice": "customer.draft_next_invoice",
    "customer.draft_replacement_invoice": "customer.draft_replacement_invoice",
    "customer.edit_customer": "customer.edit_customer",
    "customer.generate_mandates_signature_request": "customer.generate_mandates_signature_request",
    "customer.get_bank_transfer_account": "customer.get_bank_transfer_account",
    "customer.get_customer": "customer.get_customer",
    "customer.get_customer_balance": "customer.get_customer_balance",
    "customer.get_customer_payment_methods": "customer.get_customer_payment_methods",
    "customer.get_invoicing_schedule": "customer.get_invoicing_schedule",
    "customer.get_migrated_billing_takeover": "customer.get_migrated_billing_takeover",
    "customer.get_payment_method_setup_secret": "customer.get_payment_method_setup_secret",
    "customer.initialize_customer": "customer.initialize_customer",
    "customer.invoice_drafted_checker": "customer.invoice_drafted_checker",
    "customer.list_customers": "customer.list_customers",
    "customer.lock_customer_billing": "customer.lock_customer_billing",
    "customer.manually_mark_invoice": "customer.manually_mark_invoice",
    "customer.push_custom_event": "customer.push_custom_event",
    "customer.replace_invoice": "customer.replace_invoice",
    "customer.retry_charge": "customer.retry_charge",
    "customer.set_migrated_billing_takeover": "customer.set_migrated_billing_takeover",
    "customer.unlock_customer_billing": "customer.unlock_customer_billing",
    "customer.unlock_migrated_billing_takeover": "customer.unlock_migrated_billing_takeover",
    "customer.update_customer_payment_mode": "customer.update_customer_payment_mode",
    "customer.update_customer_preferred_payment_method": "customer.update_customer_preferred_payment_method",
    "debug.add_new_product_to_distribution-requests": "debug.add_new_product_to_distribution-requests",
    "debug.batch_bill_customers": "debug.batch_bill_customers",
    "debug.batch_create_user_relations": "debug.batch_create_user_relations",
    "debug.batch_generate_documents": "debug.batch_generate_documents",
    "debug.cancel_invoices_one_time": "debug.cancel_invoices_one_time",
    "debug.check_all_documents": "debug.check_all_documents",
    "debug.check_documents": "debug.check_documents",
    "debug.clear_core_cache": "debug.clear_core_cache",
    "debug.clear_core_projections_data": "debug.clear_core_projections_data",
    "debug.clear_core_test_data": "debug.clear_core_test_data",
    "debug.clear_jobs_data": "debug.clear_jobs_data",
    "debug.clear_signature_test_data": "debug.clear_signature_test_data",
    "debug.clear_workflows_data": "debug.clear_workflows_data",
    "debug.count_core_events": "debug.count_core_events",
    "debug.create_manual_invoice": "debug.create_manual_invoice",
    "debug.create_payment_from_stripe": "debug.create_payment_from_stripe",
    "debug.dispatch_invoice_replacement": "debug.dispatch_invoice_replacement",
    "debug.dispatch_unpaid_invoice_replacement": "debug.dispatch_unpaid_invoice_replacement",
    "debug.draft_checker_checks": "debug.draft_checker_checks",
    "debug.get_projections": "debug.get_projections",
    "debug.migrate_yeet_policies_contract_number": "debug.migrate_yeet_policies_contract_number",
    "debug.migrate_luko_yearly_billing": "debug.migrate_luko_yearly_billing",
    "debug.backfill_document_correctness": "debug.backfill_document_correctness",
    "debug.refresh_invoice_status": "debug.refresh_invoice_status",
    "debug.retrigger_claim_document_fraud_check": "debug.retrigger_claim_document_fraud_check",
    "debug.retry_charge": "debug.retry_charge",
    "debug.rotate_claims_pii_key": "debug.rotate_claims_pii_key",
    "debug.seed_policies": "debug.seed_policies",
    "debug.set_invoice_cleanup": "debug.set_invoice_cleanup",
    "debug.send_emails_fix_171125": "debug.send_emails_fix_171125",
    "debug.start_daily_staging_cleanup": "debug.start_daily_staging_cleanup",
    "debug.toggle_ignore_core_events": "debug.toggle_ignore_core_events",
    "debug.update_payment_status": "debug.update_payment_status",
    "debug.yousign_security_check": "debug.yousign_security_check",
    "derogation.approve_derogation": "derogation.approve_derogation",
    "derogation.check_derogation_requirement": "derogation.check_derogation_requirement",
    "derogation.create_derogation": "derogation.create_derogation",
    "derogation.deny_derogation": "derogation.deny_derogation",
    "distribution_request.approve": "distribution_request.approve",
    "distribution_request.create_many": "distribution_request.create_many",
    "distribution_request.delete": "distribution_request.delete",
    "distribution_request.deny": "distribution_request.deny",
    "distribution_request.get": "distribution_request.get",
    "distribution_request.list": "distribution_request.list",
    "distribution_request.revoke": "distribution_request.revoke",
    "distribution_request.waiting_for_signature": "distribution_request.waiting_for_signature",
    "documents.archive_documents": "documents.archive_documents",
    "documents.classify_document": "documents.classify_document",
    "documents.create_document_upload_url": "documents.create_document_upload_url",
    "documents.delete_documents": "documents.delete_documents",
    "documents.generate_and_upload_document": "documents.generate_and_upload_document",
    "documents.generate_document": "documents.generate_document",
    "documents.get_documents": "documents.get_documents",
    "documents.get_template": "documents.get_template",
    "documents.handle_document_uploaded": "documents.handle_document_uploaded",
    "documents.health": "documents.health",
    "documents.list": "documents.list",
    "documents.list_all": "documents.list_all",
    "documents.list_all_with_presigned_urls": "documents.list_all_with_presigned_urls",
    "documents.list_with_presigned_urls": "documents.list_with_presigned_urls",
    "documents.restore_documents": "documents.restore_documents",
    "documents.update_documents": "documents.update_documents",
    "efficiale.check_compliance": "efficiale.check_compliance",
    "efficiale.get_alerts": "efficiale.get_alerts",
    "ellisphere.online_order": "ellisphere.online_order",
    "email_account.list_mine": "email_account.list_mine",
    "email_account.initiate_connection": "email_account.initiate_connection",
    "email_account.complete_connection": "email_account.complete_connection",
    "email_account.disconnect": "email_account.disconnect",
    "email_account.reconnect": "email_account.reconnect",
    "email.get_attachment_download_url": "email.get_attachment_download_url",
    "email.get": "email.get",
    "email.mark_as_seen": "email.mark_as_seen",
    "email.list_threads": "email.list_threads",
    "email.get_thread": "email.get_thread",
    "email.set_thread_archived": "email.set_thread_archived",
    "email.attach_policies": "email.attach_policies",
    "email.attach_threads_policies": "email.attach_threads_policies",
    "email.detach_policies": "email.detach_policies",
    "email.detach_policy": "email.detach_policy",
    "email.move_policy": "email.move_policy",
    "general_inbox.get_summary": "general_inbox.get_summary",
    "failed_payments.get_entities_from_invoice": "failed_payments.get_entities_from_invoice",
    "failed_payments.get_failed_payments_workflow_parameters": "failed_payments.get_failed_payments_workflow_parameters",
    "failed_payments.publish_unpaid_invoice_event": "failed_payments.publish_unpaid_invoice_event",
    "failed_payments.start_failed_payment_workflow": "failed_payments.start_failed_payment_workflow",
    "formal_notice.execute_formal_notice_workflow": "formal_notice.execute_formal_notice_workflow",
    "fva.upload_file": "fva.upload_file",
    "hiscox.get_activities_by_sector": "hiscox.get_activities_by_sector",
    "federated_session.start": "federated_session.start",
    "federated_session.get": "federated_session.get",
    "federated_session.revoke": "federated_session.revoke",
    "federated_session.revoke_by_provider_logout": "federated_session.revoke_by_provider_logout",
    "federated_provisioning.provision": "federated_provisioning.provision",
    "impersonation.create_session": "impersonation.create_session",
    "impersonation.get_session": "impersonation.get_session",
    "impersonation.list_sessions": "impersonation.list_sessions",
    "impersonation.revoke_session": "impersonation.revoke_session",
    "invitation.admin_invite": "invitation.admin_invite",
    "invitation.broker_invite": "invitation.broker_invite",
    "invitation.create_anonymous_session": "invitation.create_anonymous_session",
    "invitation.handoff_anonymous_session": "invitation.handoff_anonymous_session",
    "invitation.invite": "invitation.invite",
    "invitation.resolve_session_entities": "invitation.resolve_session_entities",
    "job_schedulers.delete": "job_schedulers.delete",
    "job_schedulers.get": "job_schedulers.get",
    "job_schedulers.get_bull_mq": "job_schedulers.get_bull_mq",
    "job_schedulers.list": "job_schedulers.list",
    "job_schedulers.update": "job_schedulers.update",
    "job_schedulers.upsert": "job_schedulers.upsert",
    "jobs.cancel_job": "jobs.cancel_job",
    "jobs.cancel_jobs": "jobs.cancel_jobs",
    "jobs.count_jobs": "jobs.count_jobs",
    "jobs.create_job": "jobs.create_job",
    "jobs.create_jobs": "jobs.create_jobs",
    "jobs.debounce_job": "jobs.debounce_job",
    "jobs.drain_jobs": "jobs.drain_jobs",
    "jobs.get_job": "jobs.get_job",
    "jobs.list_jobs": "jobs.list_jobs",
    "jobs.retry_jobs": "jobs.retry_jobs",
    "jobs.update_job": "jobs.update_job",
    "legacy.admin_get_conversation_messages": "legacy.admin_get_conversation_messages",
    "legacy.admin_list_conversations": "legacy.admin_list_conversations",
    "legacy.ai_classify_document": "legacy.ai_classify_document",
    "legacy.ai_document_classify": "legacy.ai_document_classify",
    "legacy.ai_document_log_correction": "legacy.ai_document_log_correction",
    "legacy.create_conversation": "legacy.create_conversation",
    "legacy.delete_conversation": "legacy.delete_conversation",
    "legacy.document_extraction.extract_document": "legacy.document_extraction.extract_document",
    "legacy.document_extraction.get_brokerage_firm_extractions": "legacy.document_extraction.get_brokerage_firm_extractions",
    "legacy.document_extraction.get_claim_extractions": "legacy.document_extraction.get_claim_extractions",
    "legacy.document_extraction.get_document_extraction": "legacy.document_extraction.get_document_extraction",
    "legacy.document_extraction.get_extraction_feedback": "legacy.document_extraction.get_extraction_feedback",
    "legacy.document_extraction.get_policy_extractions": "legacy.document_extraction.get_policy_extractions",
    "legacy.document_extraction.submit_extraction_feedback": "legacy.document_extraction.submit_extraction_feedback",
    "legacy.document_prefill.prefill": "legacy.document_prefill.prefill",
    "legacy.document_prefill.record_outcome": "legacy.document_prefill.record_outcome",
    "legacy.document_validity.check_document_validity": "legacy.document_validity.check_document_validity",
    "legacy.document_validity.get_brokerage_firm_validity": "legacy.document_validity.get_brokerage_firm_validity",
    "legacy.document_validity.get_document_validity": "legacy.document_validity.get_document_validity",
    "legacy.document_validity.get_policy_validity": "legacy.document_validity.get_policy_validity",
    "legacy.document_validity.override_document_validity": "legacy.document_validity.override_document_validity",
    "legacy.document_coherence.get_document_coherence": "legacy.document_coherence.get_document_coherence",
    "legacy.document_conformity.accept_document": "legacy.document_conformity.accept_document",
    "legacy.document_conformity.reject_document": "legacy.document_conformity.reject_document",
    "legacy.document_conformity.accept_all_documents": "legacy.document_conformity.accept_all_documents",
    "legacy.document_conformity.cancel_document_conformity": "legacy.document_conformity.cancel_document_conformity",
    "legacy.document_conformity.get_policy_document_conformity": "legacy.document_conformity.get_policy_document_conformity",
    "legacy.document_conformity.get_policy_document_verdicts": "legacy.document_conformity.get_policy_document_verdicts",
    "legacy.document_conformity.apply_automatic_verdict": "legacy.document_conformity.apply_automatic_verdict",
    "legacy.document_conformity.accept_brokerage_firm_document": "legacy.document_conformity.accept_brokerage_firm_document",
    "legacy.document_conformity.reject_brokerage_firm_document": "legacy.document_conformity.reject_brokerage_firm_document",
    "legacy.document_conformity.accept_all_brokerage_firm_documents": "legacy.document_conformity.accept_all_brokerage_firm_documents",
    "legacy.document_conformity.cancel_brokerage_firm_document_conformity": "legacy.document_conformity.cancel_brokerage_firm_document_conformity",
    "legacy.document_conformity.get_brokerage_firm_document_conformity": "legacy.document_conformity.get_brokerage_firm_document_conformity",
    "legacy.document_collection.get_state": "legacy.document_collection.get_state",
    "legacy.document_collection.get_reminder_date": "legacy.document_collection.get_reminder_date",
    "legacy.document_collection.get_reminder_parameters": "legacy.document_collection.get_reminder_parameters",
    "legacy.document_collection.publish_reminder_event": "legacy.document_collection.publish_reminder_event",
    "legacy.get_conversation": "legacy.get_conversation",
    "legacy.get_conversation_messages": "legacy.get_conversation_messages",
    "legacy.get_feature_flags": "legacy.get_feature_flags",
    "legacy.list_feature_flags": "legacy.list_feature_flags",
    "legacy.update_feature_flag": "legacy.update_feature_flag",
    "legacy.get_expected_generated_documents": "legacy.get_expected_generated_documents",
    "legacy.get_expected_uploaded_documents": "legacy.get_expected_uploaded_documents",
    "legacy.get_generation_payload": "legacy.get_generation_payload",
    "legacy.get_on_demand_documents": "legacy.get_on_demand_documents",
    "legacy.get_payload_from_target": "legacy.get_payload_from_target",
    "legacy.health": "legacy.health",
    "legacy.list_conversations": "legacy.list_conversations",
    "legacy_migration.cleanup_dry_run": "legacy_migration.cleanup_dry_run",
    "legacy_migration.migrate_portfolio": "legacy_migration.migrate_portfolio",
    "legacy.regenerate_document": "legacy.regenerate_document",
    "legacy.schedule_handle_malware_protection_scan_result": "legacy.schedule_handle_malware_protection_scan_result",
    "legacy.send_conversation_feedback": "legacy.send_conversation_feedback",
    "legacy.send_conversation_message": "legacy.send_conversation_message",
    "legacy.set_document_category": "legacy.set_document_category",
    "lock.batch_create_locks": "lock.batch_create_locks",
    "lock.batch_delete_locks": "lock.batch_delete_locks",
    "lock.batch_get_locks": "lock.batch_get_locks",
    "lock.create_lock": "lock.create_lock",
    "lock.delete_lock": "lock.delete_lock",
    "lock.get_lock": "lock.get_lock",
    "lock.list_locks": "lock.list_locks",
    "mcp.handle_request": "mcp.handle_request",
    "metabase.get_metabase_iframe_url": "metabase.get_metabase_iframe_url",
    "migration.cleanup_dry_run": "migration.cleanup_dry_run",
    "migration.extract_and_transform_client_data": "migration.extract_and_transform_client_data",
    "migration.load": "migration.load",
    "migration.reupload_corrupted_documents": "migration.reupload_corrupted_documents",
    "migration.run_planned_job": "migration.run_planned_job",
    "migration.start_workflow_api": "migration.start_workflow_api",
    "migration.transform": "migration.transform",
    "migration.update_task_success": "migration.update_task_success",
    "migration.validate": "migration.validate",
    "notification.create": "notification.create",
    "notification.delete": "notification.delete",
    "notification.get": "notification.get",
    "notification.list": "notification.list",
    "notification.list_email_templates": "notification.list_email_templates",
    "notification.patch": "notification.patch",
    "notification.patch-by-metadata-id": "notification.patch-by-metadata-id",
    "notification.render_email_template": "notification.render_email_template",
    "notification.send": "notification.send",
    "payment_methods_migration.load_payment_methods_and_mandates": "payment_methods_migration.load_payment_methods_and_mandates",
    "payment_methods_migration.start_workflow_api": "payment_methods_migration.start_workflow_api",
    "payments.create_customer": "payments.create_customer",
    "payments.create_payment": "payments.create_payment",
    "payments.create_payment_from_stripe": "payments.create_payment_from_stripe",
    "payments.soft_delete_payment_method": "payments.soft_delete_payment_method",
    "customer.delete_payment_method": "customer.delete_payment_method",
    "brokerage_firm.delete_payment_method": "brokerage_firm.delete_payment_method",
    "payments_event_store.dispatch_rebuild_projections": "payments_event_store.dispatch_rebuild_projections",
    "payments.get_bank_transfer_account": "payments.get_bank_transfer_account",
    "payments.get_customer_payment_methods": "payments.get_customer_payment_methods",
    "payments.get_customer_payments": "payments.get_customer_payments",
    "payments.get_payment_methods": "payments.get_payment_methods",
    "payments.get_payments": "payments.get_payments",
    "payments.list_all_payments": "payments.list_all_payments",
    "payments.list_customers": "payments.list_customers",
    "payments.list_payments": "payments.list_payments",
    "payments.refund_payment": "payments.refund_payment",
    "payments.setup_intent": "payments.setup_intent",
    "payments.update_payment_status": "payments.update_payment_status",
    "permissions.authorize_request": "permissions.authorize_request",
    "permissions.define_casl_user": "permissions.define_casl_user",
    "permissions.define_subject": "permissions.define_subject",
    "policy.activate_policy": "policy.activate_policy",
    "policy.batch_get_policies": "policy.batch_get_policies",
    "policy.calculate_policy_quote": "policy.calculate_policy_quote",
    "policy.confirm_policy": "policy.confirm_policy",
    "policy.correct_document_fraud_verdict": "policy.correct_document_fraud_verdict",
    "policy.create_additional_components": "policy.create_additional_components",
    "policy.delete_policy_documents": "policy.delete_policy_documents",
    "policy.edit_policy": "policy.edit_policy",
    "policy.edit_policy_external_id": "policy.edit_policy_external_id",
    "policy.generate_document_upload_url": "policy.generate_document_upload_url",
    "policy.generate_incremental_id": "policy.generate_incremental_id",
    "policy.generate_signature_request": "policy.generate_signature_request",
    "policy.get_aggregate": "policy.get_aggregate",
    "policy.get_document_fraud": "policy.get_document_fraud",
    "policy.get_policy": "policy.get_policy",
    "policy.get_premium_schedule": "policy.get_premium_schedule",
    "policy.list_active_policies": "policy.list_active_policies",
    "policy.list_branches": "policy.list_branches",
    "policy.list_policy_documents": "policy.list_policy_documents",
    "policy.list_policy_events": "policy.list_policy_events",
    "policy.manual_quote_policy": "policy.manual_quote_policy",
    "policy.push_custom_event": "policy.push_custom_event",
    "policy.quote_policy": "policy.quote_policy",
    "policy.register_additional_quote_components": "policy.register_additional_quote_components",
    "policy.set_fees": "policy.set_fees",
    "policy.stop_policy": "policy.stop_policy",
    "policy.suspend_policy": "policy.suspend_policy",
    "policy.transfer_brokerage_firm": "policy.transfer_brokerage_firm",
    "policy.update_policy_quote": "policy.update_policy_quote",
    "pricing.compute_pricing": "pricing.compute_pricing",
    "pricing.get_available_pricing": "pricing.get_available_pricing",
    "pricing.get_price": "pricing.get_price",
    "pricing.save_pricing_selection": "pricing.save_pricing_selection",
    "queue_management.pause": "queue_management.pause",
    "queue_management.pause_single": "queue_management.pause_single",
    "queue_management.resume": "queue_management.resume",
    "queue_management.resume_single": "queue_management.resume_single",
    "queue_management.status": "queue_management.status",
    "quote.get_asset_external_quote": "quote.get_asset_external_quote",
    "quote.get_external_quote": "quote.get_external_quote",
    "quote.get_quote": "quote.get_quote",
    "relations.create": "relations.create",
    "relations.delete": "relations.delete",
    "relations.get_permission_relations_for_user": "relations.get_permission_relations_for_user",
    "relations.list": "relations.list",
    "relations.list_tenant_users": "relations.list_tenant_users",
    "renewal.archive_renewal_document": "renewal.archive_renewal_document",
    "renewal.edit_renewal": "renewal.edit_renewal",
    "renewal.finalize_renewal_branch": "renewal.finalize_renewal_branch",
    "renewal.renewal_creation_checks": "renewal.renewal_creation_checks",
    "renewal.renewal_merge_checks": "renewal.renewal_merge_checks",
    "reporting.get_report_config": "reporting.get_report_config",
    "reporting.get_reports": "reporting.get_reports",
    "reporting.generate_custom_report": "reporting.generate_custom_report",
    "repricing.dispatch": "repricing.dispatch",
    "repricing.merge_branch": "repricing.merge_branch",
    "repricing.quote_policy": "repricing.quote_policy",
    "repricing.start_checks": "repricing.start_checks",
    "search.configurable_search": "search.configurable_search",
    "search.configurable_search_swagger": "search.configurable_search_swagger",
    "search.count": "search.count",
    "search.reindex_all": "search.reindex_all",
    "search.reindex_all_collections": "search.reindex_all_collections",
    "search.search": "search.search",
    "search.suggest": "search.suggest",
    "signature.cancel_signature_request": "signature.cancel_signature_request",
    "signature.cancel_signatures_for_archived_documents": "signature.cancel_signatures_for_archived_documents",
    "signature.cleanup_dry_run": "signature.cleanup_dry_run",
    "signature.create_signature_entries": "signature.create_signature_entries",
    "signature.generate_signature_request": "signature.generate_signature_request",
    "signature.get_signature_requests_by_external_id": "signature.get_signature_requests_by_external_id",
    "signature.get_signature_requests_signed_between": "signature.get_signature_requests_signed_between",
    "signature.get_signature_requests_signed_by_external_ids": "signature.get_signature_requests_signed_by_external_ids",
    "signature.get_signer_link": "signature.get_signer_link",
    "signature.initiate_signature": "signature.initiate_signature",
    "signature.portfolio_migration": "signature.portfolio_migration",
    "signature.resend_signature_reminder": "signature.resend_signature_reminder",
    "siren.search_siren": "siren.search_siren",
    "siv.search_siv": "siv.search_siv",
    "solvability.get_score": "solvability.get_score",
    "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL": "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL",
    "sra.get_facet": "sra.get_facet",
    "sra.get_vehicle_details": "sra.get_vehicle_details",
    "sydia.add_claim": "sydia.add_claim",
    "sydia.aikan_batch_get_assets": "sydia.aikan_batch_get_assets",
    "sydia.get_claim": "sydia.get_claim",
    "sydia.get_claims": "sydia.get_claims",
    "sydia.get_customer": "sydia.get_customer",
    "sydia.get_customers": "sydia.get_customers",
    "sydia.get_policy": "sydia.get_policy",
    "sydia.upsert_policy_claim": "sydia.upsert_policy_claim",
    "telematics.list_average_scores": "telematics.list_average_scores",
    "telematics.list_scores": "telematics.list_scores",
    "telematics.upsert_external_service_user_id": "telematics.upsert_external_service_user_id",
    "tenant_onboarding.create_account": "tenant_onboarding.create_account",
    "tenant_onboarding.create_account_link": "tenant_onboarding.create_account_link",
    "user.get_service_user_data": "user.get_service_user_data",
    "users.legacy_at_me": "users.legacy_at_me",
    "view_specific.accounting_summary": "view_specific.accounting_summary",
    "view_specific.acknowledge_compliance_alert": "view_specific.acknowledge_compliance_alert",
    "view_specific.create_active_team": "view_specific.create_active_team",
    "view_specific.get_available_pricing": "view_specific.get_available_pricing",
    "view_specific.list_brokerage_firm_derogations": "view_specific.list_brokerage_firm_derogations",
    "view_specific.list_brokerage_firm_distribution_requests": "view_specific.list_brokerage_firm_distribution_requests",
    "view_specific.list_brokerage_firm_payment_methods": "view_specific.list_brokerage_firm_payment_methods",
    "view_specific.list_brokerage_firm_policies": "view_specific.list_brokerage_firm_policies",
    "view_specific.list_child_brokerage_firms": "view_specific.list_child_brokerage_firms",
    "view_specific.list_customer_invoices": "view_specific.list_customer_invoices",
    "view_specific.list_customer_payment_methods": "view_specific.list_customer_payment_methods",
    "view_specific.list_customer_payments": "view_specific.list_customer_payments",
    "view_specific.list_customer_relations": "view_specific.list_customer_relations",
    "view_specific.list_distribution_requests_to_brokerage_firm": "view_specific.list_distribution_requests_to_brokerage_firm",
    "view_specific.list_policy_assets": "view_specific.list_policy_assets",
    "view_specific.list_policy_compliance_alerts": "view_specific.list_policy_compliance_alerts",
    "view_specific.list_policy_compliance_checks": "view_specific.list_policy_compliance_checks",
    "view_specific.list_policy_customers": "view_specific.list_policy_customers",
    "view_specific.list_product_common_documents": "view_specific.list_product_common_documents",
    "validation.list_tickets": "validation.list_tickets",
    "validation.generate_test_plan": "validation.generate_test_plan",
    "validation.start_run": "validation.start_run",
    "validation.get_run": "validation.get_run",
    "validation.confirm_run": "validation.confirm_run",
    "validation.list_assets": "validation.list_assets",
    "validation.append_run_event": "validation.append_run_event",
    "validation.list_runs": "validation.list_runs",
    "workflows.cancel_workflow_runs": "workflows.cancel_workflow_runs",
    "workflows.debug_add": "workflows.debug_add",
    "workflows.debug_add_2": "workflows.debug_add_2",
    "workflows.get_workflow_run": "workflows.get_workflow_run",
    "workflows.list_workflow_run_nodes": "workflows.list_workflow_run_nodes",
    "workflows.list_workflow_runs": "workflows.list_workflow_runs",
    "workflows.retry_workflow_run": "workflows.retry_workflow_run",
    "workflows.start_workflow": "workflows.start_workflow",
    "yeet.attach_drivequant_user_id_to_customer": "yeet.attach_drivequant_user_id_to_customer",
    "yeet.edit_drivequant_score_range": "yeet.edit_drivequant_score_range",
    "yeet.edit_drivequant_surcharge_rate": "yeet.edit_drivequant_surcharge_rate",
    "yeet.edit_policy_drivequant_repricing": "yeet.edit_policy_drivequant_repricing",
    "yeet.list_drivequant_average_scores": "yeet.list_drivequant_average_scores",
    "yeet.list_drivequant_historical_users": "yeet.list_drivequant_historical_users",
    "yeet.list_possible_drivequant_users": "yeet.list_possible_drivequant_users",
    "yeet.surchargePolicy": "yeet.surchargePolicy",
    "tutassur.upload_signed_docs_to_cfdp": "tutassur.upload_signed_docs_to_cfdp"
} as const;

export type GetJobOutputCommandEnumKey = (typeof getJobOutputCommandEnum)[keyof typeof getJobOutputCommandEnum];

export type GetJobOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: GetJobOutputTypeEnumKey;
    /**
     * @type string
    */
    id: string;
    status: JobStatus;
    service: Services;
    /**
     * @type string
    */
    command: GetJobOutputCommandEnumKey;
    /**
     * @type object
    */
    payload: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description The time to schedule the job for
     * @type string | undefined, date-time
    */
    runAt?: string;
    /**
     * @description The effective number of attempts to run the job
     * @type number
    */
    attempts: number;
    /**
     * @description The maximum number of attempts to run the job
     * @type number | undefined
    */
    maxAttempts?: number;
    /**
     * @description The timeout of the job
     * @type number | undefined
    */
    timeout?: number;
    /**
     * @description The priority of the job, the lower the number, the higher the priority
    */
    priority?: JobPriority;
    /**
     * @description The response of the job
     * @type object | undefined
    */
    response?: object;
    /**
     * @type array | undefined
    */
    errors?: string[];
};

export type CancelJobsInput = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type array | undefined
    */
    ids?: string[];
};

export type CancelJobsOutput = object;

export type CancelJobOutput = object;

export type RetryJobsInput = {
    /**
     * @type array
    */
    ids: string[];
};

export type RetryJobsOutput = {
    /**
     * @type array
    */
    retriedJobs: string[];
    /**
     * @type array
    */
    notFoundJobs: string[];
    /**
     * @type array
    */
    failedJobs: string[];
};

export const listJobsInputStatusesEnum = {
    CREATED: "CREATED",
    RUNNING: "RUNNING",
    SUCCEEDED: "SUCCEEDED",
    CANCELLED: "CANCELLED",
    ERROR: "ERROR"
} as const;

export type ListJobsInputStatusesEnumKey = (typeof listJobsInputStatusesEnum)[keyof typeof listJobsInputStatusesEnum];

export type ListJobsInput = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @type string | undefined
    */
    command?: string;
    /**
     * @type array | undefined
    */
    statuses?: ListJobsInputStatusesEnumKey[];
    /**
     * @type string | undefined, date-time
    */
    createdAtFrom?: string;
    /**
     * @type string | undefined, date-time
    */
    createdAtTo?: string;
    /**
     * @type string | undefined, date-time
    */
    runAtFrom?: string;
    /**
     * @type string | undefined, date-time
    */
    runAtTo?: string;
};

export const jobDtoTypeEnum = {
    JOB: "JOB"
} as const;

export type JobDtoTypeEnumKey = (typeof jobDtoTypeEnum)[keyof typeof jobDtoTypeEnum];

export const jobDtoCommandEnum = {
    "legacy_event_store.push_projection": "legacy_event_store.push_projection",
    "legacy_event_store.rebuild_projections": "legacy_event_store.rebuild_projections",
    "legacy_event_store.dispatch_rebuild_projections": "legacy_event_store.dispatch_rebuild_projections",
    "legacy_event_store.rebuild_core_aggregate_projections": "legacy_event_store.rebuild_core_aggregate_projections",
    "billing_event_store.rebuild_projections": "billing_event_store.rebuild_projections",
    "billing_event_store.dispatch_rebuild_projections": "billing_event_store.dispatch_rebuild_projections",
    "payments_event_store.rebuild_projections": "payments_event_store.rebuild_projections",
    "payment_event_store.rebuild_projections": "payment_event_store.rebuild_projections",
    "payment_event_store.build_projections": "payment_event_store.build_projections",
    "search.index_collection": "search.index_collection",
    "search.reindex_collection": "search.reindex_collection",
    "legacy.attach_policy_document": "legacy.attach_policy_document",
    "legacy.attach_common_documents": "legacy.attach_common_documents",
    "legacy.generate_document": "legacy.generate_document",
    "legacy.archive_old_documents": "legacy.archive_old_documents",
    "claim-management.get-document-generation-payload": "claim-management.get-document-generation-payload",
    "documents.handle_malware_protection_scan_result": "documents.handle_malware_protection_scan_result",
    "notification.send_email_from_fanout_trigger": "notification.send_email_from_fanout_trigger",
    "payments.handle_payment_method_attached": "payments.handle_payment_method_attached",
    "payments.handle_payment_method_updated": "payments.handle_payment_method_updated",
    "payments.handle_payment_method_detached": "payments.handle_payment_method_detached",
    "payments.handle_payment_succeeded": "payments.handle_payment_succeeded",
    "payments.handle_payment_failed": "payments.handle_payment_failed",
    "payments.handle_payment_canceled": "payments.handle_payment_canceled",
    "payments.handle_payment_created": "payments.handle_payment_created",
    "payments.handle_payment_disputed": "payments.handle_payment_disputed",
    "payments.handle_payment_creation_failed": "payments.handle_payment_creation_failed",
    "payments.handle_setup_intent_succeeded": "payments.handle_setup_intent_succeeded",
    "payments.handle_payment_refund_succeeded": "payments.handle_payment_refund_succeeded",
    "payments.handle_payment_refund_updated": "payments.handle_payment_refund_updated",
    "payments.handle_payment_refund_failed": "payments.handle_payment_refund_failed",
    "email_account.handle_sync_webhook_event": "email_account.handle_sync_webhook_event",
    "email.fetch_body": "email.fetch_body",
    "email.analyze_thread": "email.analyze_thread",
    "email.recover_thread_analyses": "email.recover_thread_analyses",
    "email.fetch_attachment": "email.fetch_attachment",
    "branch.invalidate_branch": "branch.invalidate_branch",
    "relations.create_user_and_relation": "relations.create_user_and_relation",
    "jobs.cleanup_jobs_db": "jobs.cleanup_jobs_db",
    "legacy.apply_migration": "legacy.apply_migration",
    "address_autocomplete.suggest": "address_autocomplete.suggest",
    "asset.apply_start_asset": "asset.apply_start_asset",
    "asset.apply_stop_asset": "asset.apply_stop_asset",
    "axece.create_drivequant_user_id": "axece.create_drivequant_user_id",
    "axece.edit_policy_crm": "axece.edit_policy_crm",
    "yeet.create_drivequant_user_id": "yeet.create_drivequant_user_id",
    "yeet.edit_policy_crm": "yeet.edit_policy_crm",
    "fva.retrieve_report_outcome": "fva.retrieve_report_outcome",
    "billing.handle_payment_creation": "billing.handle_payment_creation",
    "billing.handle_payment_disputed": "billing.handle_payment_disputed",
    "billing.handle_payment_failure": "billing.handle_payment_failure",
    "billing.handle_payment_succeeded": "billing.handle_payment_succeeded",
    "branch.auto_archive_one_product_inactive_branches": "branch.auto_archive_one_product_inactive_branches",
    "branch.fork_branch": "branch.fork_branch",
    "branch.edit_branch": "branch.edit_branch",
    "branch.merge_branch": "branch.merge_branch",
    "branch.auto_archive_all_products_inactive_branches": "branch.auto_archive_all_products_inactive_branches",
    "brokerage-firm.create_payment_customer": "brokerage-firm.create_payment_customer",
    "brokerage-firm.score_document_fraud": "brokerage-firm.score_document_fraud",
    "commission-statements.get_document": "commission-statements.get_document",
    "commission-statements.list_for_brokerage_firm": "commission-statements.list_for_brokerage_firm",
    "customer.bill": "customer.bill",
    "customer.charge_customer": "customer.charge_customer",
    "payments.cancel_payment": "payments.cancel_payment",
    "documents.upload_reports_to_connector": "documents.upload_reports_to_connector",
    "documents.check_wakam_validation": "documents.check_wakam_validation",
    "debug.super_delete_policies": "debug.super_delete_policies",
    "notification.send_email": "notification.send_email",
    "notification.send_test_email": "notification.send_test_email",
    "policy.apply_activate_policy": "policy.apply_activate_policy",
    "policy.apply_start_policy": "policy.apply_start_policy",
    "policy.apply_stop_policy": "policy.apply_stop_policy",
    "policy.sign_policy": "policy.sign_policy",
    "policy.dispatch_tasks": "policy.dispatch_tasks",
    "policy.plan_tasks": "policy.plan_tasks",
    "policy.run_tasks": "policy.run_tasks",
    "policy.get_unpaid_duration": "policy.get_unpaid_duration",
    "policy.score_document_fraud": "policy.score_document_fraud",
    "renewal.handle_renewal_branch_on_claim_creation": "renewal.handle_renewal_branch_on_claim_creation",
    "renewal.dispatch_renewal_creation_for_policy": "renewal.dispatch_renewal_creation_for_policy",
    "renewal.dispatch_renewal_merge_for_policy": "renewal.dispatch_renewal_merge_for_policy",
    "renewal.publish_stop_notice": "renewal.publish_stop_notice",
    "reporting.generate_report": "reporting.generate_report",
    "monitoring.run_daily_checks": "monitoring.run_daily_checks",
    "monitoring.list_checks": "monitoring.list_checks",
    "signature.update_signer_status": "signature.update_signer_status",
    "signature.update_signature_signed_status": "signature.update_signature_signed_status",
    "signature.update_signature_cancelled_status": "signature.update_signature_cancelled_status",
    "ar24.create_user": "ar24.create_user",
    "ar24.get_user": "ar24.get_user",
    "ar24.list_users": "ar24.list_users",
    "ar24.request_user_access": "ar24.request_user_access",
    "ar24.request_user_eula": "ar24.request_user_eula",
    "ar24.resend_user_confirmation": "ar24.resend_user_confirmation",
    "ar24.send_ere": "ar24.send_ere",
    "ar24.send_formal_notice": "ar24.send_formal_notice",
    "ar24.update_user": "ar24.update_user",
    "asset.batch_create_assets": "asset.batch_create_assets",
    "asset.batch_edit_assets": "asset.batch_edit_assets",
    "asset.batch_remove_assets": "asset.batch_remove_assets",
    "asset.create_asset": "asset.create_asset",
    "asset.edit_asset": "asset.edit_asset",
    "asset.get_asset": "asset.get_asset",
    "asset.list_assets": "asset.list_assets",
    "asset.push_custom_event": "asset.push_custom_event",
    "asset.remove_asset": "asset.remove_asset",
    "asset.replace_asset": "asset.replace_asset",
    "auth.check_email": "auth.check_email",
    "axece.attach_drivequant_user_id_to_customer": "axece.attach_drivequant_user_id_to_customer",
    "axece.edit_drivequant_score_range": "axece.edit_drivequant_score_range",
    "axece.edit_drivequant_surcharge_rate": "axece.edit_drivequant_surcharge_rate",
    "axece.edit_policy_drivequant_repricing": "axece.edit_policy_drivequant_repricing",
    "axece.list_drivequant_average_scores": "axece.list_drivequant_average_scores",
    "axece.list_drivequant_historical_users": "axece.list_drivequant_historical_users",
    "axece.list_possible_drivequant_users": "axece.list_possible_drivequant_users",
    "axece.surchargePolicy": "axece.surchargePolicy",
    "billing.cancel_invoices": "billing.cancel_invoices",
    "billing.delete_invoices": "billing.delete_invoices",
    "billing.draft_credit_invoice": "billing.draft_credit_invoice",
    "billing.draft_next_invoice": "billing.draft_next_invoice",
    "billing.finalize_invoice": "billing.finalize_invoice",
    "billing.get_invoices": "billing.get_invoices",
    "billing.handle_charge_customer_failure_without_payment_creation": "billing.handle_charge_customer_failure_without_payment_creation",
    "billing.handle_refund_not_handled": "billing.handle_refund_not_handled",
    "billing.issue_invoices": "billing.issue_invoices",
    "billing.list": "billing.list",
    "billing.list_invoice_events": "billing.list_invoice_events",
    "billing.list_invoice_flows": "billing.list_invoice_flows",
    "billing.reconcile_invoices": "billing.reconcile_invoices",
    "billing.replace_invoice": "billing.replace_invoice",
    "billing.replace_unpaid_invoice_checks": "billing.replace_unpaid_invoice_checks",
    "billing.write_off_invoice": "billing.write_off_invoice",
    "branch.apply_close_branch": "branch.apply_close_branch",
    "branch.create_branch": "branch.create_branch",
    "branch.create_or_reuse_branch": "branch.create_or_reuse_branch",
    "branch.get_effective_date": "branch.get_effective_date",
    "broker.at_me": "broker.at_me",
    "broker.batch_get_brokers": "broker.batch_get_brokers",
    "broker.create_broker": "broker.create_broker",
    "broker.delete_broker": "broker.delete_broker",
    "broker.get_broker": "broker.get_broker",
    "broker.list_brokers": "broker.list_brokers",
    "broker.list_descendant_brokers": "broker.list_descendant_brokers",
    "broker.update_broker": "broker.update_broker",
    "brokerage-fee.create": "brokerage-fee.create",
    "brokerage-fee.delete": "brokerage-fee.delete",
    "brokerage-fee.get_computed_fees_for_brokerage_firm": "brokerage-fee.get_computed_fees_for_brokerage_firm",
    "brokerage-fee.get_fees_for_brokerage_firm": "brokerage-fee.get_fees_for_brokerage_firm",
    "brokerage-fee.update": "brokerage-fee.update",
    "brokerage-firm.correct_document_fraud_verdict": "brokerage-firm.correct_document_fraud_verdict",
    "brokerage-firm.create_brokerage_firm": "brokerage-firm.create_brokerage_firm",
    "brokerage-firm.delete_documents": "brokerage-firm.delete_documents",
    "brokerage-firm.generate_document_upload_url": "brokerage-firm.generate_document_upload_url",
    "brokerage-firm.generate_documents_for_signature": "brokerage-firm.generate_documents_for_signature",
    "brokerage-firm.generate_mandate_signature_request": "brokerage-firm.generate_mandate_signature_request",
    "brokerage-firm.generate_report": "brokerage-firm.generate_report",
    "brokerage-firm.generate_signature_request": "brokerage-firm.generate_signature_request",
    "brokerage-firm.get_brokerage_firm": "brokerage-firm.get_brokerage_firm",
    "brokerage-firm.get_document_fraud": "brokerage-firm.get_document_fraud",
    "brokerage-firm.get_payment_methods": "brokerage-firm.get_payment_methods",
    "brokerage-firm.get_payment_setup_secret": "brokerage-firm.get_payment_setup_secret",
    "brokerage-firm.get_report_config": "brokerage-firm.get_report_config",
    "brokerage-firm.list_brokerage_firms": "brokerage-firm.list_brokerage_firms",
    "brokerage-firm.list_documents": "brokerage-firm.list_documents",
    "brokerage-firm.list_reports": "brokerage-firm.list_reports",
    "brokerage-firm.transfer_policies": "brokerage-firm.transfer_policies",
    "brokerage-firm.update_brokerage_firm": "brokerage-firm.update_brokerage_firm",
    "brokerage-firm.update_preferred_payment_method": "brokerage-firm.update_preferred_payment_method",
    "claim-management.score-document-fraud": "claim-management.score-document-fraud",
    "claims.create": "claims.create",
    "claims.delete": "claims.delete",
    "claims.get": "claims.get",
    "claims.list": "claims.list",
    "claims.update": "claims.update",
    "comments.create_comment": "comments.create_comment",
    "comments.delete_comment": "comments.delete_comment",
    "comments.get_comment": "comments.get_comment",
    "comments.list_comments": "comments.list_comments",
    "comments.update_comment": "comments.update_comment",
    "internal_notes.create": "internal_notes.create",
    "internal_notes.list": "internal_notes.list",
    "internal_notes.get": "internal_notes.get",
    "internal_notes.update": "internal_notes.update",
    "internal_notes.soft_delete": "internal_notes.soft_delete",
    "internal_notes.hard_delete": "internal_notes.hard_delete",
    "whatsapp_consent.record": "whatsapp_consent.record",
    "compliance.acknowledge_alerts_by_check_ids": "compliance.acknowledge_alerts_by_check_ids",
    "compliance.acknowledge_alerts_by_entity": "compliance.acknowledge_alerts_by_entity",
    "compliance.batch_check_compliance": "compliance.batch_check_compliance",
    "compliance.create_alert": "compliance.create_alert",
    "compliance.create_compliance_check": "compliance.create_compliance_check",
    "compliance.delete_alert": "compliance.delete_alert",
    "compliance.delete_compliance_check": "compliance.delete_compliance_check",
    "compliance.get_alert": "compliance.get_alert",
    "compliance.get_compliance_check": "compliance.get_compliance_check",
    "compliance.list_alerts": "compliance.list_alerts",
    "compliance.list_compliance_checks": "compliance.list_compliance_checks",
    "compliance.synchronize_new_alerts": "compliance.synchronize_new_alerts",
    "compliance.update_alert": "compliance.update_alert",
    "compliance.update_compliance_check": "compliance.update_compliance_check",
    "config.GET_PRODUCT_CONFIG": "config.GET_PRODUCT_CONFIG",
    "config.GET_PUBLIC_PRODUCT_CONFIG": "config.GET_PUBLIC_PRODUCT_CONFIG",
    "config.GET_PUBLIC_TENANT_CONFIG": "config.GET_PUBLIC_TENANT_CONFIG",
    "config.GET_TENANT_CONFIG": "config.GET_TENANT_CONFIG",
    "config.get_business_role_permissions": "config.get_business_role_permissions",
    "config.get_products_for_tenant": "config.get_products_for_tenant",
    "config.get_public_tenant_config_by_domain": "config.get_public_tenant_config_by_domain",
    "core_aggregate.get_product_config": "core_aggregate.get_product_config",
    "customer.batch_get_customers": "customer.batch_get_customers",
    "customer.create_customer_for_policy": "customer.create_customer_for_policy",
    "customer.create_payment_customer": "customer.create_payment_customer",
    "customer.delete_customer_from_policy": "customer.delete_customer_from_policy",
    "customer.draft_checker": "customer.draft_checker",
    "customer.draft_next_invoice": "customer.draft_next_invoice",
    "customer.draft_replacement_invoice": "customer.draft_replacement_invoice",
    "customer.edit_customer": "customer.edit_customer",
    "customer.generate_mandates_signature_request": "customer.generate_mandates_signature_request",
    "customer.get_bank_transfer_account": "customer.get_bank_transfer_account",
    "customer.get_customer": "customer.get_customer",
    "customer.get_customer_balance": "customer.get_customer_balance",
    "customer.get_customer_payment_methods": "customer.get_customer_payment_methods",
    "customer.get_invoicing_schedule": "customer.get_invoicing_schedule",
    "customer.get_migrated_billing_takeover": "customer.get_migrated_billing_takeover",
    "customer.get_payment_method_setup_secret": "customer.get_payment_method_setup_secret",
    "customer.initialize_customer": "customer.initialize_customer",
    "customer.invoice_drafted_checker": "customer.invoice_drafted_checker",
    "customer.list_customers": "customer.list_customers",
    "customer.lock_customer_billing": "customer.lock_customer_billing",
    "customer.manually_mark_invoice": "customer.manually_mark_invoice",
    "customer.push_custom_event": "customer.push_custom_event",
    "customer.replace_invoice": "customer.replace_invoice",
    "customer.retry_charge": "customer.retry_charge",
    "customer.set_migrated_billing_takeover": "customer.set_migrated_billing_takeover",
    "customer.unlock_customer_billing": "customer.unlock_customer_billing",
    "customer.unlock_migrated_billing_takeover": "customer.unlock_migrated_billing_takeover",
    "customer.update_customer_payment_mode": "customer.update_customer_payment_mode",
    "customer.update_customer_preferred_payment_method": "customer.update_customer_preferred_payment_method",
    "debug.add_new_product_to_distribution-requests": "debug.add_new_product_to_distribution-requests",
    "debug.batch_bill_customers": "debug.batch_bill_customers",
    "debug.batch_create_user_relations": "debug.batch_create_user_relations",
    "debug.batch_generate_documents": "debug.batch_generate_documents",
    "debug.cancel_invoices_one_time": "debug.cancel_invoices_one_time",
    "debug.check_all_documents": "debug.check_all_documents",
    "debug.check_documents": "debug.check_documents",
    "debug.clear_core_cache": "debug.clear_core_cache",
    "debug.clear_core_projections_data": "debug.clear_core_projections_data",
    "debug.clear_core_test_data": "debug.clear_core_test_data",
    "debug.clear_jobs_data": "debug.clear_jobs_data",
    "debug.clear_signature_test_data": "debug.clear_signature_test_data",
    "debug.clear_workflows_data": "debug.clear_workflows_data",
    "debug.count_core_events": "debug.count_core_events",
    "debug.create_manual_invoice": "debug.create_manual_invoice",
    "debug.create_payment_from_stripe": "debug.create_payment_from_stripe",
    "debug.dispatch_invoice_replacement": "debug.dispatch_invoice_replacement",
    "debug.dispatch_unpaid_invoice_replacement": "debug.dispatch_unpaid_invoice_replacement",
    "debug.draft_checker_checks": "debug.draft_checker_checks",
    "debug.get_projections": "debug.get_projections",
    "debug.migrate_yeet_policies_contract_number": "debug.migrate_yeet_policies_contract_number",
    "debug.migrate_luko_yearly_billing": "debug.migrate_luko_yearly_billing",
    "debug.backfill_document_correctness": "debug.backfill_document_correctness",
    "debug.refresh_invoice_status": "debug.refresh_invoice_status",
    "debug.retrigger_claim_document_fraud_check": "debug.retrigger_claim_document_fraud_check",
    "debug.retry_charge": "debug.retry_charge",
    "debug.rotate_claims_pii_key": "debug.rotate_claims_pii_key",
    "debug.seed_policies": "debug.seed_policies",
    "debug.set_invoice_cleanup": "debug.set_invoice_cleanup",
    "debug.send_emails_fix_171125": "debug.send_emails_fix_171125",
    "debug.start_daily_staging_cleanup": "debug.start_daily_staging_cleanup",
    "debug.toggle_ignore_core_events": "debug.toggle_ignore_core_events",
    "debug.update_payment_status": "debug.update_payment_status",
    "debug.yousign_security_check": "debug.yousign_security_check",
    "derogation.approve_derogation": "derogation.approve_derogation",
    "derogation.check_derogation_requirement": "derogation.check_derogation_requirement",
    "derogation.create_derogation": "derogation.create_derogation",
    "derogation.deny_derogation": "derogation.deny_derogation",
    "distribution_request.approve": "distribution_request.approve",
    "distribution_request.create_many": "distribution_request.create_many",
    "distribution_request.delete": "distribution_request.delete",
    "distribution_request.deny": "distribution_request.deny",
    "distribution_request.get": "distribution_request.get",
    "distribution_request.list": "distribution_request.list",
    "distribution_request.revoke": "distribution_request.revoke",
    "distribution_request.waiting_for_signature": "distribution_request.waiting_for_signature",
    "documents.archive_documents": "documents.archive_documents",
    "documents.classify_document": "documents.classify_document",
    "documents.create_document_upload_url": "documents.create_document_upload_url",
    "documents.delete_documents": "documents.delete_documents",
    "documents.generate_and_upload_document": "documents.generate_and_upload_document",
    "documents.generate_document": "documents.generate_document",
    "documents.get_documents": "documents.get_documents",
    "documents.get_template": "documents.get_template",
    "documents.handle_document_uploaded": "documents.handle_document_uploaded",
    "documents.health": "documents.health",
    "documents.list": "documents.list",
    "documents.list_all": "documents.list_all",
    "documents.list_all_with_presigned_urls": "documents.list_all_with_presigned_urls",
    "documents.list_with_presigned_urls": "documents.list_with_presigned_urls",
    "documents.restore_documents": "documents.restore_documents",
    "documents.update_documents": "documents.update_documents",
    "efficiale.check_compliance": "efficiale.check_compliance",
    "efficiale.get_alerts": "efficiale.get_alerts",
    "ellisphere.online_order": "ellisphere.online_order",
    "email_account.list_mine": "email_account.list_mine",
    "email_account.initiate_connection": "email_account.initiate_connection",
    "email_account.complete_connection": "email_account.complete_connection",
    "email_account.disconnect": "email_account.disconnect",
    "email_account.reconnect": "email_account.reconnect",
    "email.get_attachment_download_url": "email.get_attachment_download_url",
    "email.get": "email.get",
    "email.mark_as_seen": "email.mark_as_seen",
    "email.list_threads": "email.list_threads",
    "email.get_thread": "email.get_thread",
    "email.set_thread_archived": "email.set_thread_archived",
    "email.attach_policies": "email.attach_policies",
    "email.attach_threads_policies": "email.attach_threads_policies",
    "email.detach_policies": "email.detach_policies",
    "email.detach_policy": "email.detach_policy",
    "email.move_policy": "email.move_policy",
    "general_inbox.get_summary": "general_inbox.get_summary",
    "failed_payments.get_entities_from_invoice": "failed_payments.get_entities_from_invoice",
    "failed_payments.get_failed_payments_workflow_parameters": "failed_payments.get_failed_payments_workflow_parameters",
    "failed_payments.publish_unpaid_invoice_event": "failed_payments.publish_unpaid_invoice_event",
    "failed_payments.start_failed_payment_workflow": "failed_payments.start_failed_payment_workflow",
    "formal_notice.execute_formal_notice_workflow": "formal_notice.execute_formal_notice_workflow",
    "fva.upload_file": "fva.upload_file",
    "hiscox.get_activities_by_sector": "hiscox.get_activities_by_sector",
    "federated_session.start": "federated_session.start",
    "federated_session.get": "federated_session.get",
    "federated_session.revoke": "federated_session.revoke",
    "federated_session.revoke_by_provider_logout": "federated_session.revoke_by_provider_logout",
    "federated_provisioning.provision": "federated_provisioning.provision",
    "impersonation.create_session": "impersonation.create_session",
    "impersonation.get_session": "impersonation.get_session",
    "impersonation.list_sessions": "impersonation.list_sessions",
    "impersonation.revoke_session": "impersonation.revoke_session",
    "invitation.admin_invite": "invitation.admin_invite",
    "invitation.broker_invite": "invitation.broker_invite",
    "invitation.create_anonymous_session": "invitation.create_anonymous_session",
    "invitation.handoff_anonymous_session": "invitation.handoff_anonymous_session",
    "invitation.invite": "invitation.invite",
    "invitation.resolve_session_entities": "invitation.resolve_session_entities",
    "job_schedulers.delete": "job_schedulers.delete",
    "job_schedulers.get": "job_schedulers.get",
    "job_schedulers.get_bull_mq": "job_schedulers.get_bull_mq",
    "job_schedulers.list": "job_schedulers.list",
    "job_schedulers.update": "job_schedulers.update",
    "job_schedulers.upsert": "job_schedulers.upsert",
    "jobs.cancel_job": "jobs.cancel_job",
    "jobs.cancel_jobs": "jobs.cancel_jobs",
    "jobs.count_jobs": "jobs.count_jobs",
    "jobs.create_job": "jobs.create_job",
    "jobs.create_jobs": "jobs.create_jobs",
    "jobs.debounce_job": "jobs.debounce_job",
    "jobs.drain_jobs": "jobs.drain_jobs",
    "jobs.get_job": "jobs.get_job",
    "jobs.list_jobs": "jobs.list_jobs",
    "jobs.retry_jobs": "jobs.retry_jobs",
    "jobs.update_job": "jobs.update_job",
    "legacy.admin_get_conversation_messages": "legacy.admin_get_conversation_messages",
    "legacy.admin_list_conversations": "legacy.admin_list_conversations",
    "legacy.ai_classify_document": "legacy.ai_classify_document",
    "legacy.ai_document_classify": "legacy.ai_document_classify",
    "legacy.ai_document_log_correction": "legacy.ai_document_log_correction",
    "legacy.create_conversation": "legacy.create_conversation",
    "legacy.delete_conversation": "legacy.delete_conversation",
    "legacy.document_extraction.extract_document": "legacy.document_extraction.extract_document",
    "legacy.document_extraction.get_brokerage_firm_extractions": "legacy.document_extraction.get_brokerage_firm_extractions",
    "legacy.document_extraction.get_claim_extractions": "legacy.document_extraction.get_claim_extractions",
    "legacy.document_extraction.get_document_extraction": "legacy.document_extraction.get_document_extraction",
    "legacy.document_extraction.get_extraction_feedback": "legacy.document_extraction.get_extraction_feedback",
    "legacy.document_extraction.get_policy_extractions": "legacy.document_extraction.get_policy_extractions",
    "legacy.document_extraction.submit_extraction_feedback": "legacy.document_extraction.submit_extraction_feedback",
    "legacy.document_prefill.prefill": "legacy.document_prefill.prefill",
    "legacy.document_prefill.record_outcome": "legacy.document_prefill.record_outcome",
    "legacy.document_validity.check_document_validity": "legacy.document_validity.check_document_validity",
    "legacy.document_validity.get_brokerage_firm_validity": "legacy.document_validity.get_brokerage_firm_validity",
    "legacy.document_validity.get_document_validity": "legacy.document_validity.get_document_validity",
    "legacy.document_validity.get_policy_validity": "legacy.document_validity.get_policy_validity",
    "legacy.document_validity.override_document_validity": "legacy.document_validity.override_document_validity",
    "legacy.document_coherence.get_document_coherence": "legacy.document_coherence.get_document_coherence",
    "legacy.document_conformity.accept_document": "legacy.document_conformity.accept_document",
    "legacy.document_conformity.reject_document": "legacy.document_conformity.reject_document",
    "legacy.document_conformity.accept_all_documents": "legacy.document_conformity.accept_all_documents",
    "legacy.document_conformity.cancel_document_conformity": "legacy.document_conformity.cancel_document_conformity",
    "legacy.document_conformity.get_policy_document_conformity": "legacy.document_conformity.get_policy_document_conformity",
    "legacy.document_conformity.get_policy_document_verdicts": "legacy.document_conformity.get_policy_document_verdicts",
    "legacy.document_conformity.apply_automatic_verdict": "legacy.document_conformity.apply_automatic_verdict",
    "legacy.document_conformity.accept_brokerage_firm_document": "legacy.document_conformity.accept_brokerage_firm_document",
    "legacy.document_conformity.reject_brokerage_firm_document": "legacy.document_conformity.reject_brokerage_firm_document",
    "legacy.document_conformity.accept_all_brokerage_firm_documents": "legacy.document_conformity.accept_all_brokerage_firm_documents",
    "legacy.document_conformity.cancel_brokerage_firm_document_conformity": "legacy.document_conformity.cancel_brokerage_firm_document_conformity",
    "legacy.document_conformity.get_brokerage_firm_document_conformity": "legacy.document_conformity.get_brokerage_firm_document_conformity",
    "legacy.document_collection.get_state": "legacy.document_collection.get_state",
    "legacy.document_collection.get_reminder_date": "legacy.document_collection.get_reminder_date",
    "legacy.document_collection.get_reminder_parameters": "legacy.document_collection.get_reminder_parameters",
    "legacy.document_collection.publish_reminder_event": "legacy.document_collection.publish_reminder_event",
    "legacy.get_conversation": "legacy.get_conversation",
    "legacy.get_conversation_messages": "legacy.get_conversation_messages",
    "legacy.get_feature_flags": "legacy.get_feature_flags",
    "legacy.list_feature_flags": "legacy.list_feature_flags",
    "legacy.update_feature_flag": "legacy.update_feature_flag",
    "legacy.get_expected_generated_documents": "legacy.get_expected_generated_documents",
    "legacy.get_expected_uploaded_documents": "legacy.get_expected_uploaded_documents",
    "legacy.get_generation_payload": "legacy.get_generation_payload",
    "legacy.get_on_demand_documents": "legacy.get_on_demand_documents",
    "legacy.get_payload_from_target": "legacy.get_payload_from_target",
    "legacy.health": "legacy.health",
    "legacy.list_conversations": "legacy.list_conversations",
    "legacy_migration.cleanup_dry_run": "legacy_migration.cleanup_dry_run",
    "legacy_migration.migrate_portfolio": "legacy_migration.migrate_portfolio",
    "legacy.regenerate_document": "legacy.regenerate_document",
    "legacy.schedule_handle_malware_protection_scan_result": "legacy.schedule_handle_malware_protection_scan_result",
    "legacy.send_conversation_feedback": "legacy.send_conversation_feedback",
    "legacy.send_conversation_message": "legacy.send_conversation_message",
    "legacy.set_document_category": "legacy.set_document_category",
    "lock.batch_create_locks": "lock.batch_create_locks",
    "lock.batch_delete_locks": "lock.batch_delete_locks",
    "lock.batch_get_locks": "lock.batch_get_locks",
    "lock.create_lock": "lock.create_lock",
    "lock.delete_lock": "lock.delete_lock",
    "lock.get_lock": "lock.get_lock",
    "lock.list_locks": "lock.list_locks",
    "mcp.handle_request": "mcp.handle_request",
    "metabase.get_metabase_iframe_url": "metabase.get_metabase_iframe_url",
    "migration.cleanup_dry_run": "migration.cleanup_dry_run",
    "migration.extract_and_transform_client_data": "migration.extract_and_transform_client_data",
    "migration.load": "migration.load",
    "migration.reupload_corrupted_documents": "migration.reupload_corrupted_documents",
    "migration.run_planned_job": "migration.run_planned_job",
    "migration.start_workflow_api": "migration.start_workflow_api",
    "migration.transform": "migration.transform",
    "migration.update_task_success": "migration.update_task_success",
    "migration.validate": "migration.validate",
    "notification.create": "notification.create",
    "notification.delete": "notification.delete",
    "notification.get": "notification.get",
    "notification.list": "notification.list",
    "notification.list_email_templates": "notification.list_email_templates",
    "notification.patch": "notification.patch",
    "notification.patch-by-metadata-id": "notification.patch-by-metadata-id",
    "notification.render_email_template": "notification.render_email_template",
    "notification.send": "notification.send",
    "payment_methods_migration.load_payment_methods_and_mandates": "payment_methods_migration.load_payment_methods_and_mandates",
    "payment_methods_migration.start_workflow_api": "payment_methods_migration.start_workflow_api",
    "payments.create_customer": "payments.create_customer",
    "payments.create_payment": "payments.create_payment",
    "payments.create_payment_from_stripe": "payments.create_payment_from_stripe",
    "payments.soft_delete_payment_method": "payments.soft_delete_payment_method",
    "customer.delete_payment_method": "customer.delete_payment_method",
    "brokerage_firm.delete_payment_method": "brokerage_firm.delete_payment_method",
    "payments_event_store.dispatch_rebuild_projections": "payments_event_store.dispatch_rebuild_projections",
    "payments.get_bank_transfer_account": "payments.get_bank_transfer_account",
    "payments.get_customer_payment_methods": "payments.get_customer_payment_methods",
    "payments.get_customer_payments": "payments.get_customer_payments",
    "payments.get_payment_methods": "payments.get_payment_methods",
    "payments.get_payments": "payments.get_payments",
    "payments.list_all_payments": "payments.list_all_payments",
    "payments.list_customers": "payments.list_customers",
    "payments.list_payments": "payments.list_payments",
    "payments.refund_payment": "payments.refund_payment",
    "payments.setup_intent": "payments.setup_intent",
    "payments.update_payment_status": "payments.update_payment_status",
    "permissions.authorize_request": "permissions.authorize_request",
    "permissions.define_casl_user": "permissions.define_casl_user",
    "permissions.define_subject": "permissions.define_subject",
    "policy.activate_policy": "policy.activate_policy",
    "policy.batch_get_policies": "policy.batch_get_policies",
    "policy.calculate_policy_quote": "policy.calculate_policy_quote",
    "policy.confirm_policy": "policy.confirm_policy",
    "policy.correct_document_fraud_verdict": "policy.correct_document_fraud_verdict",
    "policy.create_additional_components": "policy.create_additional_components",
    "policy.delete_policy_documents": "policy.delete_policy_documents",
    "policy.edit_policy": "policy.edit_policy",
    "policy.edit_policy_external_id": "policy.edit_policy_external_id",
    "policy.generate_document_upload_url": "policy.generate_document_upload_url",
    "policy.generate_incremental_id": "policy.generate_incremental_id",
    "policy.generate_signature_request": "policy.generate_signature_request",
    "policy.get_aggregate": "policy.get_aggregate",
    "policy.get_document_fraud": "policy.get_document_fraud",
    "policy.get_policy": "policy.get_policy",
    "policy.get_premium_schedule": "policy.get_premium_schedule",
    "policy.list_active_policies": "policy.list_active_policies",
    "policy.list_branches": "policy.list_branches",
    "policy.list_policy_documents": "policy.list_policy_documents",
    "policy.list_policy_events": "policy.list_policy_events",
    "policy.manual_quote_policy": "policy.manual_quote_policy",
    "policy.push_custom_event": "policy.push_custom_event",
    "policy.quote_policy": "policy.quote_policy",
    "policy.register_additional_quote_components": "policy.register_additional_quote_components",
    "policy.set_fees": "policy.set_fees",
    "policy.stop_policy": "policy.stop_policy",
    "policy.suspend_policy": "policy.suspend_policy",
    "policy.transfer_brokerage_firm": "policy.transfer_brokerage_firm",
    "policy.update_policy_quote": "policy.update_policy_quote",
    "pricing.compute_pricing": "pricing.compute_pricing",
    "pricing.get_available_pricing": "pricing.get_available_pricing",
    "pricing.get_price": "pricing.get_price",
    "pricing.save_pricing_selection": "pricing.save_pricing_selection",
    "queue_management.pause": "queue_management.pause",
    "queue_management.pause_single": "queue_management.pause_single",
    "queue_management.resume": "queue_management.resume",
    "queue_management.resume_single": "queue_management.resume_single",
    "queue_management.status": "queue_management.status",
    "quote.get_asset_external_quote": "quote.get_asset_external_quote",
    "quote.get_external_quote": "quote.get_external_quote",
    "quote.get_quote": "quote.get_quote",
    "relations.create": "relations.create",
    "relations.delete": "relations.delete",
    "relations.get_permission_relations_for_user": "relations.get_permission_relations_for_user",
    "relations.list": "relations.list",
    "relations.list_tenant_users": "relations.list_tenant_users",
    "renewal.archive_renewal_document": "renewal.archive_renewal_document",
    "renewal.edit_renewal": "renewal.edit_renewal",
    "renewal.finalize_renewal_branch": "renewal.finalize_renewal_branch",
    "renewal.renewal_creation_checks": "renewal.renewal_creation_checks",
    "renewal.renewal_merge_checks": "renewal.renewal_merge_checks",
    "reporting.get_report_config": "reporting.get_report_config",
    "reporting.get_reports": "reporting.get_reports",
    "reporting.generate_custom_report": "reporting.generate_custom_report",
    "repricing.dispatch": "repricing.dispatch",
    "repricing.merge_branch": "repricing.merge_branch",
    "repricing.quote_policy": "repricing.quote_policy",
    "repricing.start_checks": "repricing.start_checks",
    "search.configurable_search": "search.configurable_search",
    "search.configurable_search_swagger": "search.configurable_search_swagger",
    "search.count": "search.count",
    "search.reindex_all": "search.reindex_all",
    "search.reindex_all_collections": "search.reindex_all_collections",
    "search.search": "search.search",
    "search.suggest": "search.suggest",
    "signature.cancel_signature_request": "signature.cancel_signature_request",
    "signature.cancel_signatures_for_archived_documents": "signature.cancel_signatures_for_archived_documents",
    "signature.cleanup_dry_run": "signature.cleanup_dry_run",
    "signature.create_signature_entries": "signature.create_signature_entries",
    "signature.generate_signature_request": "signature.generate_signature_request",
    "signature.get_signature_requests_by_external_id": "signature.get_signature_requests_by_external_id",
    "signature.get_signature_requests_signed_between": "signature.get_signature_requests_signed_between",
    "signature.get_signature_requests_signed_by_external_ids": "signature.get_signature_requests_signed_by_external_ids",
    "signature.get_signer_link": "signature.get_signer_link",
    "signature.initiate_signature": "signature.initiate_signature",
    "signature.portfolio_migration": "signature.portfolio_migration",
    "signature.resend_signature_reminder": "signature.resend_signature_reminder",
    "siren.search_siren": "siren.search_siren",
    "siv.search_siv": "siv.search_siv",
    "solvability.get_score": "solvability.get_score",
    "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL": "sra.GET_VERSION_INFORMATION_FROM_BRAND_AND_MODEL",
    "sra.get_facet": "sra.get_facet",
    "sra.get_vehicle_details": "sra.get_vehicle_details",
    "sydia.add_claim": "sydia.add_claim",
    "sydia.aikan_batch_get_assets": "sydia.aikan_batch_get_assets",
    "sydia.get_claim": "sydia.get_claim",
    "sydia.get_claims": "sydia.get_claims",
    "sydia.get_customer": "sydia.get_customer",
    "sydia.get_customers": "sydia.get_customers",
    "sydia.get_policy": "sydia.get_policy",
    "sydia.upsert_policy_claim": "sydia.upsert_policy_claim",
    "telematics.list_average_scores": "telematics.list_average_scores",
    "telematics.list_scores": "telematics.list_scores",
    "telematics.upsert_external_service_user_id": "telematics.upsert_external_service_user_id",
    "tenant_onboarding.create_account": "tenant_onboarding.create_account",
    "tenant_onboarding.create_account_link": "tenant_onboarding.create_account_link",
    "user.get_service_user_data": "user.get_service_user_data",
    "users.legacy_at_me": "users.legacy_at_me",
    "view_specific.accounting_summary": "view_specific.accounting_summary",
    "view_specific.acknowledge_compliance_alert": "view_specific.acknowledge_compliance_alert",
    "view_specific.create_active_team": "view_specific.create_active_team",
    "view_specific.get_available_pricing": "view_specific.get_available_pricing",
    "view_specific.list_brokerage_firm_derogations": "view_specific.list_brokerage_firm_derogations",
    "view_specific.list_brokerage_firm_distribution_requests": "view_specific.list_brokerage_firm_distribution_requests",
    "view_specific.list_brokerage_firm_payment_methods": "view_specific.list_brokerage_firm_payment_methods",
    "view_specific.list_brokerage_firm_policies": "view_specific.list_brokerage_firm_policies",
    "view_specific.list_child_brokerage_firms": "view_specific.list_child_brokerage_firms",
    "view_specific.list_customer_invoices": "view_specific.list_customer_invoices",
    "view_specific.list_customer_payment_methods": "view_specific.list_customer_payment_methods",
    "view_specific.list_customer_payments": "view_specific.list_customer_payments",
    "view_specific.list_customer_relations": "view_specific.list_customer_relations",
    "view_specific.list_distribution_requests_to_brokerage_firm": "view_specific.list_distribution_requests_to_brokerage_firm",
    "view_specific.list_policy_assets": "view_specific.list_policy_assets",
    "view_specific.list_policy_compliance_alerts": "view_specific.list_policy_compliance_alerts",
    "view_specific.list_policy_compliance_checks": "view_specific.list_policy_compliance_checks",
    "view_specific.list_policy_customers": "view_specific.list_policy_customers",
    "view_specific.list_product_common_documents": "view_specific.list_product_common_documents",
    "validation.list_tickets": "validation.list_tickets",
    "validation.generate_test_plan": "validation.generate_test_plan",
    "validation.start_run": "validation.start_run",
    "validation.get_run": "validation.get_run",
    "validation.confirm_run": "validation.confirm_run",
    "validation.list_assets": "validation.list_assets",
    "validation.append_run_event": "validation.append_run_event",
    "validation.list_runs": "validation.list_runs",
    "workflows.cancel_workflow_runs": "workflows.cancel_workflow_runs",
    "workflows.debug_add": "workflows.debug_add",
    "workflows.debug_add_2": "workflows.debug_add_2",
    "workflows.get_workflow_run": "workflows.get_workflow_run",
    "workflows.list_workflow_run_nodes": "workflows.list_workflow_run_nodes",
    "workflows.list_workflow_runs": "workflows.list_workflow_runs",
    "workflows.retry_workflow_run": "workflows.retry_workflow_run",
    "workflows.start_workflow": "workflows.start_workflow",
    "yeet.attach_drivequant_user_id_to_customer": "yeet.attach_drivequant_user_id_to_customer",
    "yeet.edit_drivequant_score_range": "yeet.edit_drivequant_score_range",
    "yeet.edit_drivequant_surcharge_rate": "yeet.edit_drivequant_surcharge_rate",
    "yeet.edit_policy_drivequant_repricing": "yeet.edit_policy_drivequant_repricing",
    "yeet.list_drivequant_average_scores": "yeet.list_drivequant_average_scores",
    "yeet.list_drivequant_historical_users": "yeet.list_drivequant_historical_users",
    "yeet.list_possible_drivequant_users": "yeet.list_possible_drivequant_users",
    "yeet.surchargePolicy": "yeet.surchargePolicy",
    "tutassur.upload_signed_docs_to_cfdp": "tutassur.upload_signed_docs_to_cfdp"
} as const;

export type JobDtoCommandEnumKey = (typeof jobDtoCommandEnum)[keyof typeof jobDtoCommandEnum];

export type JobDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: JobDtoTypeEnumKey;
    /**
     * @type string
    */
    id: string;
    status: JobStatus;
    service: Services;
    /**
     * @type string
    */
    command: JobDtoCommandEnumKey;
    /**
     * @type object
    */
    payload: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description The time to schedule the job for
     * @type string | undefined, date-time
    */
    runAt?: string;
    /**
     * @description The effective number of attempts to run the job
     * @type number
    */
    attempts: number;
    /**
     * @description The maximum number of attempts to run the job
     * @type number | undefined
    */
    maxAttempts?: number;
    /**
     * @description The timeout of the job
     * @type number | undefined
    */
    timeout?: number;
    /**
     * @description The priority of the job, the lower the number, the higher the priority
    */
    priority?: JobPriority;
    /**
     * @description The response of the job
     * @type object | undefined
    */
    response?: object;
    /**
     * @type array | undefined
    */
    errors?: string[];
};

export type ListJobsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: JobDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const countJobsInputStatusesEnum = {
    CREATED: "CREATED",
    RUNNING: "RUNNING",
    SUCCEEDED: "SUCCEEDED",
    CANCELLED: "CANCELLED",
    ERROR: "ERROR"
} as const;

export type CountJobsInputStatusesEnumKey = (typeof countJobsInputStatusesEnum)[keyof typeof countJobsInputStatusesEnum];

export type CountJobsInput = {
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @type string | undefined
    */
    command?: string;
    /**
     * @type array | undefined
    */
    statuses?: CountJobsInputStatusesEnumKey[];
    /**
     * @type string | undefined, date-time
    */
    createdAtFrom?: string;
    /**
     * @type string | undefined, date-time
    */
    createdAtTo?: string;
    /**
     * @type string | undefined, date-time
    */
    runAtFrom?: string;
    /**
     * @type string | undefined, date-time
    */
    runAtTo?: string;
};

export type JobStatusCountDto = {
    status: JobStatus;
    /**
     * @type number
    */
    count: number;
};

export type CountJobsOutput = {
    /**
     * @description Total number of jobs matching the filters
     * @type number
    */
    total: number;
    /**
     * @description Counts grouped by status (only statuses with at least one match are present)
     * @type array
    */
    byStatus: JobStatusCountDto[];
};

export type QueuePauseOutput = object;

export type QueueResumeOutput = object;

export type QueueJobCounts = {
    /**
     * @type number
    */
    waiting: number;
    /**
     * @type number
    */
    active: number;
    /**
     * @type number
    */
    delayed: number;
    /**
     * @type number
    */
    failed: number;
    /**
     * @type number
    */
    completed: number;
};

export const queueStatusItemStatusEnum = {
    paused: "paused",
    running: "running"
} as const;

export type QueueStatusItemStatusEnumKey = (typeof queueStatusItemStatusEnum)[keyof typeof queueStatusItemStatusEnum];

export type QueueStatusItem = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    status: QueueStatusItemStatusEnumKey;
    /**
     * @type object
    */
    jobCounts: QueueJobCounts;
};

export type QueueStatusOutput = {
    /**
     * @type array
    */
    queues: QueueStatusItem[];
};

export type SingleQueuePauseOutput = object;

export type SingleQueueResumeOutput = object;

export type LegacyGenerateDocumentInputBody = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string
    */
    targetId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type array | undefined
    */
    metadata?: string[];
};

export type LegacyGenerateDocumentOutput = {
    /**
     * @type string | undefined
    */
    attachmentId?: string;
};

export type OnDemandDocumentDto = {
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string | undefined
    */
    documentType?: string;
};

export type GetOnDemandDocumentsOutput = {
    /**
     * @type array
    */
    documents: OnDemandDocumentDto[];
};

export type GetExpectedGeneratedDocumentsOutput = {
    /**
     * @type array
    */
    documentTypes: string[];
};

export type TargetNotImplementedDetailsDto = {
    /**
     * @type string
    */
    target: string;
};

export const targetNotImplementedErrorDtoCodeEnum = {
    TARGET_NOT_IMPLEMENTED: "TARGET_NOT_IMPLEMENTED"
} as const;

export type TargetNotImplementedErrorDtoCodeEnumKey = (typeof targetNotImplementedErrorDtoCodeEnum)[keyof typeof targetNotImplementedErrorDtoCodeEnum];

export type TargetNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: TargetNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TargetNotImplementedDetailsDto;
};

export type ExpectedUploadedDocumentDto = {
    /**
     * @type string
    */
    category: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
};

export type GetExpectedUploadedDocumentsOutput = {
    /**
     * @type array
    */
    documents: ExpectedUploadedDocumentDto[];
};

export type GetGenerationPayloadOutputIds = {
    /**
     * @type string | undefined
    */
    parent_customer?: string;
    /**
     * @type string | undefined
    */
    parent_policy?: string;
    /**
     * @type string | undefined
    */
    customer?: string;
    /**
     * @type string | undefined
    */
    policy?: string;
    /**
     * @type string | undefined
    */
    branch?: string;
    /**
     * @type array | undefined
    */
    policies?: string[];
    /**
     * @type string | undefined
    */
    asset?: string;
    /**
     * @type array | undefined
    */
    assets?: string[];
    /**
     * @type array | undefined
    */
    ongoing_assets?: string[];
    /**
     * @type string | undefined
    */
    invoice?: string;
    /**
     * @type string | undefined
    */
    payment_method?: string;
    /**
     * @type array | undefined
    */
    payment_methods?: string[];
    /**
     * @type string | undefined
    */
    brokerage_firm?: string;
    /**
     * @type string | undefined
    */
    parent_brokerage_firm?: string;
    /**
     * @type array | undefined
    */
    customers?: string[];
    /**
     * @type array | undefined
    */
    claims?: string[];
    /**
     * @type array | undefined
    */
    brokerage_firms?: string[];
};

export type PolicyBrokerageFirmContactDto = {
    /**
     * @description Brokerage firm name displayed to the policyholder
     * @type string
    */
    name: string;
    /**
     * @description Brokerage firm phone number displayed to the policyholder
     * @type string
    */
    phoneNumber: string;
};

export type PolicyQuoteDto = {
    /**
     * @description Quote id
     * @type string
    */
    id: string;
    /**
     * @description Entity the quote is for
     * @type string
    */
    entityId: string;
    /**
     * @type object
    */
    provider: QuoteProviderDto;
    /**
     * @type integer | undefined
    */
    basePrice?: number;
    /**
     * @type array
    */
    rates: RateDto[];
    /**
     * @type object
    */
    totalPremium: AmountDto;
    /**
     * @description components of the quote
     * @type array
    */
    components: QuoteComponentDto[];
};

export type StopRequesterDto = {
    /**
     * @description User who requested the stop
     * @type string | undefined
    */
    userId?: string;
    /**
     * @description Business role the requesting user acted under
     * @type string | undefined
    */
    businessRoleId?: string;
    /**
     * @description Requesting user\'s full name, else their email. Absent when the requester is not a broker.
     * @type string | undefined
    */
    name?: string;
};

export type StopDto = {
    /**
     * @description Stop reason. The accepted values are defined per product; read them from `stopReasons` in `GET /config/{productId}`. An unlisted value fails with INVALID_STOP_REASON.
     * @type string
    */
    reason: string;
    /**
     * @description Stop details
     * @type array | undefined
    */
    details?: CustomFieldDto[];
    /**
     * @description Date and time when the stop was created
     * @type string | undefined
    */
    createdAt?: string;
    /**
     * @description Requested effective date, present while the stop is scheduled but not yet executed. Once it executes the date is on the policy as `stoppedAt` and coverage has ended.
     * @type string | undefined
    */
    stopDate?: string;
    /**
     * @description When the scheduled stop actually executes — the later of `stopDate` and the end of the undo window. Until then the stop can be cancelled and the policy keeps running.
     * @type string | undefined
    */
    executesAt?: string;
    /**
     * @description Who requested the stop
    */
    requestedBy?: StopRequesterDto;
};

export type BillingAssignmentComponentOverrideDto = {
    /**
     * @description Component ID
     * @type string
    */
    componentId: string;
    /**
     * @description Payer customer ID
     * @type string
    */
    payerCustomerId: string;
};

export type BillingAssignmentDto = {
    /**
     * @description ID of the billing assignment config to apply
     * @type string
    */
    configId: string;
    /**
     * @description Default payer ID
     * @type string
    */
    defaultPayerId: string;
    /**
     * @type array | undefined
    */
    componentOverrides?: BillingAssignmentComponentOverrideDto[];
};

export type PriorInsurerDto = {
    /**
     * @description the prior insurer\'s name
     * @type string
    */
    name: string;
    /**
     * @description where the registered cancellation letter is sent
     * @type string
    */
    email: string;
    /**
     * @description the prior insurer\'s postal address, printed on the letter
     * @type string
    */
    postalAddress: string;
};

export type PriorContractDto = {
    /**
     * @description whether the policyholder asks the broker to cancel their prior contract
     * @type boolean
    */
    cancellationRequested: boolean;
    /**
     * @description required when requested
    */
    insurer?: PriorInsurerDto;
    /**
     * @description the prior contract\'s number at its insurer, required when requested
     * @type string | undefined
    */
    contractNumber?: string;
    /**
     * @description the prior contract\'s start date (ISO 8601), required when requested
     * @type string | undefined
    */
    contractStartDate?: string;
};

export const policyDtoStatusEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type PolicyDtoStatusEnumKey = (typeof policyDtoStatusEnum)[keyof typeof policyDtoStatusEnum];

export const policyDtoBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type PolicyDtoBranchTypeEnumKey = (typeof policyDtoBranchTypeEnum)[keyof typeof policyDtoBranchTypeEnum];

export type PolicyDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    id: string;
    /**
     * @description Unique identifier for the parent policy
     * @type string | undefined
    */
    parent?: string;
    /**
     * @description Unique identifier for the brokerage firm
     * @type string | undefined
    */
    brokerageFirm?: string;
    /**
     * @description Contact details for the policy\'s brokerage firm, resolved from tenant-configured firm data. Omitted unless both the firm name and phone number are available.
    */
    brokerageFirmContact?: PolicyBrokerageFirmContactDto;
    /**
     * @description Product ID
     * @type string
    */
    productId: string;
    /**
     * @description Incremental policy id
     * @type number | undefined
    */
    incrementalId?: number;
    /**
     * @description External policy id
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @description Date and time when the policy was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the policy was last modified
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Status of the policy
     * @type string
    */
    status: PolicyDtoStatusEnumKey;
    /**
     * @description Type of branch associated with the policy
     * @type string | undefined
    */
    branchType?: PolicyDtoBranchTypeEnumKey;
    /**
     * @description Author of the policy
    */
    author?: BrokerDto;
    /**
     * @description Date and time when the policy was signed
     * @type string | undefined
    */
    signedAt?: string;
    /**
     * @description Date and time when the policy started. Stored exactly as sent: pass the zone-local midnight of the intended first day of cover (22:00:00Z the previous day in Paris summer time, 23:00:00Z in winter), not UTC midnight — endedAt is snapped to a zone-local day boundary, so a UTC midnight start yields a period two hours short of the premium\'s.
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description Derived: signed but not yet active because the product gates activation on first payment and that payment is still outstanding (status CONFIRMED, signed, start date passed).
     * @type boolean | undefined
    */
    isAwaitingFirstPayment?: boolean;
    /**
     * @description Insurer of the returned branch\'s quote; on the main branch, the insurer of the last merged quote. Set on GET /policies/{policyId}, the portfolio list and document payloads; absent when the product has no insurer mapping or the quote provider is unmapped.
    */
    insurer?: Insurer;
    /**
     * @description Derived: a stop has been requested on a reason that needs proof, and a manager has not decided it yet. Cover continues meanwhile; the stop will not execute until the derogation is approved.
     * @type boolean | undefined
    */
    isStopAwaitingValidation?: boolean;
    /**
     * @description Date and time when the policy will end. Read-only and derived: startedAt plus the period duration, snapped to the start of the policy timezone\'s day. Not settable.
     * @type string | undefined
    */
    endedAt?: string;
    /**
     * @description Next renewal anniversary date, even for stopped policies
     * @type string | undefined
    */
    nextRenewalAt?: string;
    /**
     * @description Date and time when the policy stopped
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @description Date and time when the policy  was suspended
     * @type string | undefined
    */
    suspendedAt?: string;
    /**
     * @description Date and time when the policy was reactivated after suspension
     * @type string | undefined
    */
    reactivatedAt?: string;
    /**
     * @description Array of asset identifiers associated with the policy
     * @type array
    */
    assets: string[];
    /**
     * @description Identifiers of the customers associated with the policy
     * @type array
    */
    customers: string[];
    /**
     * @description Policy period duration
    */
    periodDuration: Duration;
    /**
     * @description IANA timezone the policy dates are read in, e.g. `Europe/Paris`
     * @type string
    */
    timeZone: string;
    /**
     * @description Nested DTO for invoicing configuration
    */
    invoicingConfig: InvoicingConfigDto;
    /**
     * @type object | undefined
    */
    additionalQuoteComponents?: QuoteComponentDto;
    /**
     * @description policy quote
    */
    quote?: PolicyQuoteDto;
    /**
     * @description Prorated policy quote based on the invoicing frequency of the policy
    */
    proratedQuote?: PolicyQuoteDto;
    /**
     * @description Selected pricing tier with perils and breakdown
     * @type object | undefined
    */
    selectedTier?: object;
    /**
     * @description stop reason, details and createdAt
    */
    stop?: StopDto;
    /**
     * @description Brokerage fees
     * @type array | undefined
    */
    brokerageFees?: BrokerageFeeOnPolicy[];
    /**
     * @description Billing assignment for multi-payer policies
    */
    billingAssignment?: BillingAssignmentDto;
    /**
     * @type object | undefined
    */
    priorContract?: PriorContractDto;
};

export const paymentMethodDtoPaymentMethodTypeEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentMethodDtoPaymentMethodTypeEnumKey = (typeof paymentMethodDtoPaymentMethodTypeEnum)[keyof typeof paymentMethodDtoPaymentMethodTypeEnum];

export type PaymentMethodDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @description the id of the payment method
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    status: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description set when the payment method has been soft-deleted
     * @type string | undefined, date-time
    */
    deletedAt?: string;
    /**
     * @description the type of the payment method
     * @type string
    */
    paymentMethodType: PaymentMethodDtoPaymentMethodTypeEnumKey;
    /**
     * @description the document id of the mandate, if applicable
     * @type string | undefined
    */
    mandateDocumentId?: string;
    /**
     * @description the last 4 digits of the payment method, if applicable
     * @type string | undefined
    */
    last4?: string;
    /**
     * @description the expiration month of payment method, if applicable
     * @type number | undefined
    */
    expirationMonth?: number;
    /**
     * @description the expiration year of payment method, if applicable
     * @type number | undefined
    */
    expirationYear?: number;
    /**
     * @description the billing details of payment method, if applicable
    */
    billingDetails?: BillingDetails;
};

export type BankAccountDto = {
    /**
     * @description The IBAN the customer needs to pay to
     * @type string
    */
    iban: string;
    /**
     * @description The BIC for this IBAN
     * @type string
    */
    bic: string;
    /**
     * @description The two-letter country code of the bank account to transfer to
     * @type string
    */
    countryCode: string;
    /**
     * @description The name of the person or business that owns the bank account
     * @type string
    */
    accountHolderName: string;
};

export type BreakdownAmounts = {
    /**
     * @description Premium before fees and taxes
     * @type integer
    */
    premiumPreFeesAndTaxes: number;
    /**
     * @description Fees
     * @type integer
    */
    fees: number;
    /**
     * @description Premium + fees before taxes
     * @type integer
    */
    withFeesPreTaxes: number;
    /**
     * @description Taxes
     * @type integer
    */
    taxes: number;
    /**
     * @description Premium + fees + taxes
     * @type integer
    */
    withFeesAndTaxes: number;
};

export const displayLineSubLineOutputDtoTypeEnum = {
    price: "price",
    percentage: "percentage"
} as const;

export type DisplayLineSubLineOutputDtoTypeEnumKey = (typeof displayLineSubLineOutputDtoTypeEnum)[keyof typeof displayLineSubLineOutputDtoTypeEnum];

export type DisplayLineSubLineOutputDto = {
    /**
     * @description Line key identifier
     * @type string
    */
    key: string;
    /**
     * @description Computed amount in euro cents (face/annual value)
     * @type integer
    */
    amount: number;
    /**
     * @description Frequency-adjusted amount in euro cents (pro-rated per billing period)
     * @type integer
    */
    adjustedAmount: number;
    /**
     * @description Business role types this line is visible to
     * @type array
    */
    forTypes: string[];
    /**
     * @description Display type
     * @type string | undefined
    */
    type?: DisplayLineSubLineOutputDtoTypeEnumKey;
};

export const priceBreakdownLineOutputDtoTypeEnum = {
    price: "price",
    percentage: "percentage"
} as const;

export type PriceBreakdownLineOutputDtoTypeEnumKey = (typeof priceBreakdownLineOutputDtoTypeEnum)[keyof typeof priceBreakdownLineOutputDtoTypeEnum];

export type PriceBreakdownLineOutputDto = {
    /**
     * @description Line key identifier
     * @type string
    */
    key: string;
    /**
     * @description Computed amount in euro cents (face/annual value)
     * @type integer
    */
    amount: number;
    /**
     * @description Frequency-adjusted amount in euro cents (pro-rated per billing period)
     * @type integer
    */
    adjustedAmount: number;
    /**
     * @description Business role types this line is visible to
     * @type array
    */
    forTypes: string[];
    /**
     * @description Display type
     * @type string | undefined
    */
    type?: PriceBreakdownLineOutputDtoTypeEnumKey;
    /**
     * @description Nested sub-lines
     * @type array | undefined
    */
    subLines?: DisplayLineSubLineOutputDto[];
};

export type PriceBreakdownTotalOutputDto = {
    /**
     * @description Total line key identifier
     * @type string
    */
    key: string;
    /**
     * @description Computed total amount in euro cents (face/annual value)
     * @type integer
    */
    amount: number;
    /**
     * @description Frequency-adjusted total amount in euro cents (pro-rated per billing period)
     * @type integer
    */
    adjustedAmount: number;
};

export const getPriceOutputFrequencyEnum = {
    YEARLY: "YEARLY",
    HALF_YEARLY: "HALF_YEARLY",
    QUARTERLY: "QUARTERLY",
    MONTHLY: "MONTHLY",
    BIENNIAL: "BIENNIAL",
    WEEKLY: "WEEKLY"
} as const;

export type GetPriceOutputFrequencyEnumKey = (typeof getPriceOutputFrequencyEnum)[keyof typeof getPriceOutputFrequencyEnum];

export type GetPriceOutput = {
    /**
     * @description Billing frequency from policy config
     * @type string
    */
    frequency: GetPriceOutputFrequencyEnumKey;
    /**
     * @description Full contract amounts (face value)
    */
    total: BreakdownAmounts;
    /**
     * @description Recurring amounts divided by frequency
    */
    recurring: BreakdownAmounts;
    /**
     * @description One-time amounts at face value
    */
    oneTime: BreakdownAmounts;
    /**
     * @description Configurable display lines computed from product priceBreakdownConfig
     * @type array | undefined
    */
    lines?: PriceBreakdownLineOutputDto[];
    /**
     * @description Configurable total display line
    */
    totalLine?: PriceBreakdownTotalOutputDto;
    /**
     * @description First invoice total display line
    */
    firstInvoiceTotal?: PriceBreakdownTotalOutputDto;
    /**
     * @description Renewal total display line
    */
    renewalTotal?: PriceBreakdownTotalOutputDto;
    /**
     * @description Date the price was computed at (whenAt, branch effective date, or now)
     * @type string | undefined
    */
    effectiveAt?: string;
};

export type GenerationPayloadExternalQuote = {
    /**
     * @type string
    */
    externalQuoteId: string;
    /**
     * @type object
    */
    data: object;
};

export type ComplianceDataItem = {
    /**
     * @type array
    */
    lists: string[];
    /**
     * @type string | undefined
    */
    comment?: string;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type array | undefined
    */
    rawdata?: object[];
};

export type ComplianceAlertDto = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type boolean
    */
    acknowledged: boolean;
    /**
     * @type string | undefined, date-time
    */
    acknowledgedAt?: string;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type ComplianceCheckDto = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @type string
    */
    provider: string;
    /**
     * @type string
    */
    searchKey: string;
    /**
     * @description Array of alert IDs associated with this check
     * @type array | undefined
    */
    alertIds?: string[];
};

export const commentDtoKindEnum = {
    GENERIC: "GENERIC",
    NOTE: "NOTE"
} as const;

export type CommentDtoKindEnumKey = (typeof commentDtoKindEnum)[keyof typeof commentDtoKindEnum];

export type CommentDto = {
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description Id of the comment
     * @type string
    */
    id: string;
    /**
     * @description Id of the entity (policy, customer, branch, ...)
     * @type string
    */
    entityId: string;
    /**
     * @description Id of the branch
     * @type string
    */
    branchId: string;
    /**
     * @description Comment content
     * @maxLength 10000
     * @type string
    */
    comment: string;
    /**
     * @description Date and time when the comment was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the comment was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the comment was soft-deleted
     * @type object
    */
    deletedAt?: object | null;
    /**
     * @description Kind of comment (defaults to GENERIC)
     * @type string | undefined
    */
    kind?: CommentDtoKindEnumKey;
    /**
     * @description Cognito sub of the comment author (NOTE kind only)
     * @type object
    */
    authorUserId?: object | null;
};

export type GetGenerationPayloadOutputPayload = {
    /**
     * @type object | undefined
    */
    parent_customer?: CustomerDto;
    /**
     * @type object | undefined
    */
    parent_policy?: PolicyDto;
    /**
     * @type object | undefined
    */
    branch?: object;
    /**
     * @type object | undefined
    */
    customer?: CustomerDto;
    /**
     * @type object | undefined
    */
    policy?: PolicyDto;
    /**
     * @type array | undefined
    */
    policies?: PolicyDto[];
    /**
     * @type object | undefined
    */
    asset?: AssetDto;
    /**
     * @type array | undefined
    */
    assets?: AssetDto[];
    /**
     * @type array | undefined
    */
    ongoing_assets?: AssetDto[];
    /**
     * @type object | undefined
    */
    invoice?: InvoiceDto;
    /**
     * @type array | undefined
    */
    invoice_schedule_on_base?: InvoiceDetails[];
    /**
     * @type array | undefined
    */
    invoice_schedule_on_branch?: InvoiceDetails[];
    /**
     * @type object | undefined
    */
    payment_method?: PaymentMethodDto;
    /**
     * @type array | undefined
    */
    payment_methods?: PaymentMethodDto[];
    /**
     * @type object | undefined
    */
    brokerage_firm?: object;
    /**
     * @type object | undefined
    */
    parent_brokerage_firm?: object;
    /**
     * @type array | undefined
    */
    brokerage_firms?: string[];
    /**
     * @type object | undefined
    */
    bank_transfer_account?: BankAccountDto;
    /**
     * @type object | undefined
    */
    pricing?: GetPriceOutput;
    /**
     * @type array | undefined
    */
    externalQuotes?: GenerationPayloadExternalQuote[];
    /**
     * @type array | undefined
    */
    customers?: CustomerDto[];
    /**
     * @type array | undefined
    */
    claims?: ClaimDto[];
    /**
     * @type object | undefined
    */
    claim?: object;
    /**
     * @type array | undefined
    */
    invoices?: InvoiceDto[];
    /**
     * @type object | undefined
    */
    alert?: ComplianceAlertDto;
    /**
     * @type object | undefined
    */
    compliance_check?: ComplianceCheckDto;
    /**
     * @type array | undefined
    */
    comments?: CommentDto[];
    /**
     * @type object | undefined
    */
    annual_commission_statement?: object;
};

export type GetGenerationPayloadOutput = {
    /**
     * @description ids of the targets
    */
    ids: GetGenerationPayloadOutputIds;
    /**
     * @description payload of the targets
    */
    payload: GetGenerationPayloadOutputPayload;
};

export type FailedToGeneratePdfDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    templateId?: string;
};

export const failedToGeneratePdfErrorDtoCodeEnum = {
    FAILED_TO_GENERATE_PDF: "FAILED_TO_GENERATE_PDF"
} as const;

export type FailedToGeneratePdfErrorDtoCodeEnumKey = (typeof failedToGeneratePdfErrorDtoCodeEnum)[keyof typeof failedToGeneratePdfErrorDtoCodeEnum];

export type FailedToGeneratePdfErrorDto = {
    /**
     * @type string
    */
    code: FailedToGeneratePdfErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGeneratePdfDetailsDto;
};

export type RegenerateDocumentInputBody = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type RegenerateDocumentOutput = {
    /**
     * @type string | undefined
    */
    attachmentId?: string;
    /**
     * @type boolean | undefined
    */
    requiresSignature?: boolean;
};

export type LockListItem = {
    /**
     * @type string
    */
    id: string;
    /**
     * @description Why the lock is held: an operator states it when taking the lock, and the platform records the service that took it.
     * @type string | undefined
    */
    lockedBy?: string;
    /**
     * @description When the lock was taken
     * @type string
    */
    createdAt: string;
    /**
     * @description When the lock was last updated
     * @type string
    */
    updatedAt: string;
};

export type ListLocksOutputType = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: LockListItem[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type LockModel = {
    /**
     * @type string
    */
    id: string;
    /**
     * @description Why the lock is held: an operator states it when taking the lock, and the platform records the service that took it.
     * @type string | undefined
    */
    lockedBy?: string;
    /**
     * @description When the lock was taken
     * @type string
    */
    createdAt: string;
};

export type GetLockOutputType = {
    /**
     * @type object
    */
    lock: LockModel;
};

export type DeleteLockOutputType = object;

export type BatchCreateLocksBody = {
    /**
     * @description Lock ids to take, each `<entityId>:BILLING` or `<entityId>:PAYMENT`
     * @type array
    */
    ids: string[];
    /**
     * @description Why these are being held, recorded on every lock taken
     * @type string
    */
    lockedBy: string;
};

export const batchCreateLocksOutputItemStatusEnum = {
    LOCKED: "LOCKED",
    ALREADY_LOCKED: "ALREADY_LOCKED",
    FAILED: "FAILED"
} as const;

export type BatchCreateLocksOutputItemStatusEnumKey = (typeof batchCreateLocksOutputItemStatusEnum)[keyof typeof batchCreateLocksOutputItemStatusEnum];

export type BatchCreateLocksOutputItem = {
    /**
     * @type string
    */
    id: string;
    /**
     * @description `ALREADY_LOCKED` is not an error: it was already held, and this call left the existing lock untouched.
     * @type string
    */
    status: BatchCreateLocksOutputItemStatusEnumKey;
    /**
     * @description Why the lock could not be taken
     * @type string | undefined
    */
    error?: string;
};

export type BatchCreateLocksOutputType = {
    /**
     * @type array
    */
    results: BatchCreateLocksOutputItem[];
};

export type BatchGetLocksBody = {
    /**
     * @description Lock ids to read, each `<entityId>:BILLING` or `<entityId>:PAYMENT`
     * @type array
    */
    ids: string[];
};

export type BatchGetLocksOutputType = {
    /**
     * @description Only the ids currently held; anything absent from this list is not locked.
     * @type array
    */
    locks: LockModel[];
};

export type BatchDeleteLockItem = {
    /**
     * @description Lock id, `<entityId>:BILLING` or `<entityId>:PAYMENT`
     * @type string
    */
    id: string;
    /**
     * @description When the hold being released was taken, as the preceding batch-get reported it. A row whose creation instant no longer matches was released and retaken since, so it is a different hold than the one the caller reviewed and comes back `STALE` instead of being deleted.
     * @type string
    */
    takenAt: string;
};

export type BatchDeleteLocksBody = {
    /**
     * @type array
    */
    locks: BatchDeleteLockItem[];
};

export const batchDeleteLocksOutputItemStatusEnum = {
    UNLOCKED: "UNLOCKED",
    NOT_LOCKED: "NOT_LOCKED",
    STALE: "STALE",
    FAILED: "FAILED"
} as const;

export type BatchDeleteLocksOutputItemStatusEnumKey = (typeof batchDeleteLocksOutputItemStatusEnum)[keyof typeof batchDeleteLocksOutputItemStatusEnum];

export type BatchDeleteLocksOutputItem = {
    /**
     * @type string
    */
    id: string;
    /**
     * @description `NOT_LOCKED` is not an error: nothing was holding that id, which is the state the caller wanted. `STALE` means the id is held by a different hold than the reviewed one, and was left alone.
     * @type string
    */
    status: BatchDeleteLocksOutputItemStatusEnumKey;
    /**
     * @description Why the lock could not be released
     * @type string | undefined
    */
    error?: string;
};

export type BatchDeleteLocksOutputType = {
    /**
     * @type array
    */
    results: BatchDeleteLocksOutputItem[];
};

export type CreateLockBody = {
    /**
     * @description Why the lock is being taken
     * @type string | undefined
    */
    lockedBy?: string;
};

export type CreateLockOutputType = object;

export type Receiver = {
    /**
     * @type string
    */
    email: string;
    /**
     * @type string
    */
    identifier: string;
};

export type EmailAttachment = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    data: string;
};

export type EmailData = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    value: string;
};

export const sendEmailInputProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type SendEmailInputProviderEnumKey = (typeof sendEmailInputProviderEnum)[keyof typeof sendEmailInputProviderEnum];

export type SendEmailInput = {
    /**
     * @type string
    */
    templateId: string;
    /**
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @type array
    */
    receivers: Receiver[];
    /**
     * @type string | undefined
    */
    bccEmail?: string;
    /**
     * @type string | undefined
    */
    provider?: SendEmailInputProviderEnumKey;
    /**
     * @type string | undefined
    */
    fromAddress?: string;
    /**
     * @type string | undefined
    */
    replyTo?: string;
    /**
     * @type array
    */
    attachments: EmailAttachment[];
    /**
     * @type array
    */
    messageData: EmailData[];
};

export type EmailTemplateDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @description Subject rendered from `sampleData`
     * @type string
    */
    subject: string;
    /**
     * @description Default variables the template renders with (a flat string bag, like runtime)
     * @type object
    */
    sampleData: {
        [key: string]: string;
    };
};

export type ListEmailTemplatesOutput = {
    /**
     * @type array
    */
    templates: EmailTemplateDto[];
};

export type EmailTemplateNotFoundDetailsDto = {
    /**
     * @type string
    */
    key: string;
};

export const emailTemplateNotFoundErrorDtoCodeEnum = {
    EMAIL_TEMPLATE_NOT_FOUND: "EMAIL_TEMPLATE_NOT_FOUND"
} as const;

export type EmailTemplateNotFoundErrorDtoCodeEnumKey = (typeof emailTemplateNotFoundErrorDtoCodeEnum)[keyof typeof emailTemplateNotFoundErrorDtoCodeEnum];

export type EmailTemplateNotFoundErrorDto = {
    /**
     * @type string
    */
    code: EmailTemplateNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EmailTemplateNotFoundDetailsDto;
};

export type RenderEmailTemplateBodyDto = {
    /**
     * @type object
    */
    data: {
        [key: string]: string;
    };
};

export type RenderEmailTemplateOutput = {
    /**
     * @type string
    */
    subject: string;
    /**
     * @type string
    */
    html: string;
};

export type UserEmailNotFoundDetailsDto = {
    /**
     * @type string
    */
    userId: string;
};

export const userEmailNotFoundErrorDtoCodeEnum = {
    USER_EMAIL_NOT_FOUND: "USER_EMAIL_NOT_FOUND"
} as const;

export type UserEmailNotFoundErrorDtoCodeEnumKey = (typeof userEmailNotFoundErrorDtoCodeEnum)[keyof typeof userEmailNotFoundErrorDtoCodeEnum];

export type UserEmailNotFoundErrorDto = {
    /**
     * @type string
    */
    code: UserEmailNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UserEmailNotFoundDetailsDto;
};

export const sendTestEmailBodyDtoProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type SendTestEmailBodyDtoProviderEnumKey = (typeof sendTestEmailBodyDtoProviderEnum)[keyof typeof sendTestEmailBodyDtoProviderEnum];

export type SendTestEmailBodyDto = {
    /**
     * @type object
    */
    data: {
        [key: string]: string;
    };
    /**
     * @description Sender for this send. RFC 5322 display-name form accepted; must be verified with the resolved provider. Outside production its domain is rewritten to the environment SES identity.
     * @type string
    */
    fromAddress: string;
    /**
     * @description Transport to send with, defaulting to `SES`. `CUSTOMER_IO` is rejected: it renders remotely from its own template and would ignore the in-repo one being previewed.
     * @type string | undefined
    */
    provider?: SendTestEmailBodyDtoProviderEnumKey;
};

export type SendTestEmailOutput = {
    /**
     * @description Address the test was sent to
     * @type string
    */
    recipient: string;
};

export const notificationDtoTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type NotificationDtoTypeEnumKey = (typeof notificationDtoTypeEnum)[keyof typeof notificationDtoTypeEnum];

export const notificationDtoStatusEnum = {
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    BOUNCED: "BOUNCED",
    COMPLAINED: "COMPLAINED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    NEGLECTED: "NEGLECTED"
} as const;

export type NotificationDtoStatusEnumKey = (typeof notificationDtoStatusEnum)[keyof typeof notificationDtoStatusEnum];

export const notificationDtoProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type NotificationDtoProviderEnumKey = (typeof notificationDtoProviderEnum)[keyof typeof notificationDtoProviderEnum];

export type NotificationDto = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: NotificationDtoTypeEnumKey;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type string
    */
    status: NotificationDtoStatusEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type string | undefined
    */
    recipientEmail?: string;
    /**
     * @type string | undefined
    */
    recipientFirstName?: string;
    /**
     * @type string | undefined
    */
    recipientLastName?: string;
    /**
     * @type string | undefined
    */
    recipientCompany?: string;
    /**
     * @type string
    */
    provider: NotificationDtoProviderEnumKey;
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined, date-time
    */
    updatedAt?: string;
};

export type ListNotificationsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: NotificationDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type NotificationNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const notificationNotFoundErrorDtoCodeEnum = {
    NOTIFICATION_NOT_FOUND: "NOTIFICATION_NOT_FOUND"
} as const;

export type NotificationNotFoundErrorDtoCodeEnumKey = (typeof notificationNotFoundErrorDtoCodeEnum)[keyof typeof notificationNotFoundErrorDtoCodeEnum];

export type NotificationNotFoundErrorDto = {
    /**
     * @type string
    */
    code: NotificationNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NotificationNotFoundDetailsDto;
};

export const getNotificationOutputTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type GetNotificationOutputTypeEnumKey = (typeof getNotificationOutputTypeEnum)[keyof typeof getNotificationOutputTypeEnum];

export const getNotificationOutputStatusEnum = {
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    BOUNCED: "BOUNCED",
    COMPLAINED: "COMPLAINED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    NEGLECTED: "NEGLECTED"
} as const;

export type GetNotificationOutputStatusEnumKey = (typeof getNotificationOutputStatusEnum)[keyof typeof getNotificationOutputStatusEnum];

export const getNotificationOutputProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type GetNotificationOutputProviderEnumKey = (typeof getNotificationOutputProviderEnum)[keyof typeof getNotificationOutputProviderEnum];

export type GetNotificationOutput = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: GetNotificationOutputTypeEnumKey;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type string
    */
    status: GetNotificationOutputStatusEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type string | undefined
    */
    recipientEmail?: string;
    /**
     * @type string | undefined
    */
    recipientFirstName?: string;
    /**
     * @type string | undefined
    */
    recipientLastName?: string;
    /**
     * @type string | undefined
    */
    recipientCompany?: string;
    /**
     * @type string
    */
    provider: GetNotificationOutputProviderEnumKey;
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined, date-time
    */
    updatedAt?: string;
};

export type EreReasonNotSupportedDetailsDto = {
    /**
     * @type string
    */
    reason: string;
};

export const ereReasonNotSupportedErrorDtoCodeEnum = {
    ERE_REASON_NOT_SUPPORTED: "ERE_REASON_NOT_SUPPORTED"
} as const;

export type EreReasonNotSupportedErrorDtoCodeEnumKey = (typeof ereReasonNotSupportedErrorDtoCodeEnum)[keyof typeof ereReasonNotSupportedErrorDtoCodeEnum];

export type EreReasonNotSupportedErrorDto = {
    /**
     * @type string
    */
    code: EreReasonNotSupportedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EreReasonNotSupportedDetailsDto;
};

export type FormalNoticeNotEnabledDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const formalNoticeNotEnabledErrorDtoCodeEnum = {
    FORMAL_NOTICE_NOT_ENABLED: "FORMAL_NOTICE_NOT_ENABLED"
} as const;

export type FormalNoticeNotEnabledErrorDtoCodeEnumKey = (typeof formalNoticeNotEnabledErrorDtoCodeEnum)[keyof typeof formalNoticeNotEnabledErrorDtoCodeEnum];

export type FormalNoticeNotEnabledErrorDto = {
    /**
     * @type string
    */
    code: FormalNoticeNotEnabledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FormalNoticeNotEnabledDetailsDto;
};

export type NonRenewalNotEnabledDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const nonRenewalNotEnabledErrorDtoCodeEnum = {
    NON_RENEWAL_NOT_ENABLED: "NON_RENEWAL_NOT_ENABLED"
} as const;

export type NonRenewalNotEnabledErrorDtoCodeEnumKey = (typeof nonRenewalNotEnabledErrorDtoCodeEnum)[keyof typeof nonRenewalNotEnabledErrorDtoCodeEnum];

export type NonRenewalNotEnabledErrorDto = {
    /**
     * @type string
    */
    code: NonRenewalNotEnabledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NonRenewalNotEnabledDetailsDto;
};

export const sendableNotificationTypeEnum = {
    ERE: "ERE"
} as const;

export type SendableNotificationTypeEnumKey = (typeof sendableNotificationTypeEnum)[keyof typeof sendableNotificationTypeEnum];

export type SendableNotificationType = SendableNotificationTypeEnumKey;

export const notificationReasonEnum = {
    FORMAL_NOTICE: "FORMAL_NOTICE",
    PRIOR_CONTRACT_CANCELLATION: "PRIOR_CONTRACT_CANCELLATION",
    NON_RENEWAL: "NON_RENEWAL"
} as const;

export type NotificationReasonEnumKey = (typeof notificationReasonEnum)[keyof typeof notificationReasonEnum];

export type NotificationReason = NotificationReasonEnumKey;

export type EreRecipientDto = {
    /**
     * @description required without a company
     * @type string | undefined
    */
    firstName?: string;
    /**
     * @description required without a company
     * @type string | undefined
    */
    lastName?: string;
    /**
     * @type string
    */
    email: string;
    /**
     * @type string | undefined
    */
    company?: string;
};

export type SendNotificationBody = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    type: SendableNotificationType;
    /**
     * @description The policy the notification is about
     * @type string
    */
    policyId: string;
    reason: NotificationReason;
    /**
     * @description Who to send it to; defaults to the policy\'s customer
    */
    recipient?: EreRecipientDto;
};

export type SendNotificationOutput = {
    /**
     * @description The workflow run sending it; the notification is recorded once sent
     * @type string
    */
    workflowRunId: string;
};

export const createNotificationBodyDtoTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type CreateNotificationBodyDtoTypeEnumKey = (typeof createNotificationBodyDtoTypeEnum)[keyof typeof createNotificationBodyDtoTypeEnum];

export type CreateNotificationBodyDto = {
    /**
     * @type string
    */
    externalId: string;
    /**
     * @type string
    */
    type: CreateNotificationBodyDtoTypeEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type object | undefined
    */
    metadata?: object;
};

export const createNotificationOutputTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type CreateNotificationOutputTypeEnumKey = (typeof createNotificationOutputTypeEnum)[keyof typeof createNotificationOutputTypeEnum];

export const createNotificationOutputStatusEnum = {
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    BOUNCED: "BOUNCED",
    COMPLAINED: "COMPLAINED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    NEGLECTED: "NEGLECTED"
} as const;

export type CreateNotificationOutputStatusEnumKey = (typeof createNotificationOutputStatusEnum)[keyof typeof createNotificationOutputStatusEnum];

export const createNotificationOutputProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type CreateNotificationOutputProviderEnumKey = (typeof createNotificationOutputProviderEnum)[keyof typeof createNotificationOutputProviderEnum];

export type CreateNotificationOutput = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: CreateNotificationOutputTypeEnumKey;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type string
    */
    status: CreateNotificationOutputStatusEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type string | undefined
    */
    recipientEmail?: string;
    /**
     * @type string | undefined
    */
    recipientFirstName?: string;
    /**
     * @type string | undefined
    */
    recipientLastName?: string;
    /**
     * @type string | undefined
    */
    recipientCompany?: string;
    /**
     * @type string
    */
    provider: CreateNotificationOutputProviderEnumKey;
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined, date-time
    */
    updatedAt?: string;
};

export const patchNotificationBodyDtoStatusEnum = {
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    BOUNCED: "BOUNCED",
    COMPLAINED: "COMPLAINED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    NEGLECTED: "NEGLECTED"
} as const;

export type PatchNotificationBodyDtoStatusEnumKey = (typeof patchNotificationBodyDtoStatusEnum)[keyof typeof patchNotificationBodyDtoStatusEnum];

export const patchNotificationBodyDtoTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type PatchNotificationBodyDtoTypeEnumKey = (typeof patchNotificationBodyDtoTypeEnum)[keyof typeof patchNotificationBodyDtoTypeEnum];

export type PatchNotificationBodyDto = {
    /**
     * @type string | undefined
    */
    status?: PatchNotificationBodyDtoStatusEnumKey;
    /**
     * @type string | undefined
    */
    type?: PatchNotificationBodyDtoTypeEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type object | undefined
    */
    metadata?: object;
};

export const patchNotificationOutputTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type PatchNotificationOutputTypeEnumKey = (typeof patchNotificationOutputTypeEnum)[keyof typeof patchNotificationOutputTypeEnum];

export const patchNotificationOutputStatusEnum = {
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    BOUNCED: "BOUNCED",
    COMPLAINED: "COMPLAINED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    NEGLECTED: "NEGLECTED"
} as const;

export type PatchNotificationOutputStatusEnumKey = (typeof patchNotificationOutputStatusEnum)[keyof typeof patchNotificationOutputStatusEnum];

export const patchNotificationOutputProviderEnum = {
    AR24: "AR24",
    CUSTOMER_IO: "CUSTOMER_IO",
    SES: "SES"
} as const;

export type PatchNotificationOutputProviderEnumKey = (typeof patchNotificationOutputProviderEnum)[keyof typeof patchNotificationOutputProviderEnum];

export type PatchNotificationOutput = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: PatchNotificationOutputTypeEnumKey;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type string
    */
    status: PatchNotificationOutputStatusEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type string | undefined
    */
    recipientEmail?: string;
    /**
     * @type string | undefined
    */
    recipientFirstName?: string;
    /**
     * @type string | undefined
    */
    recipientLastName?: string;
    /**
     * @type string | undefined
    */
    recipientCompany?: string;
    /**
     * @type string
    */
    provider: PatchNotificationOutputProviderEnumKey;
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string | undefined, date-time
    */
    updatedAt?: string;
};

export type DeleteNotificationOutput = object;

export type CreateCustomerInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the name of the customer
     * @type string
    */
    name: string;
    /**
     * @description is it a test customer
     * @type boolean
    */
    test: boolean;
};

export type CreateCustomerOutput = {
    /**
     * @description the id of the stripe customer
     * @type string
    */
    id: string;
};

export type ListPaymentCustomersInputBody = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
};

export type StripeCustomer = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the id of the stripe customer
     * @type string
    */
    id: string;
    /**
     * @description the name of the customer
     * @type string
    */
    name: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    createdAt: string;
};

export type ListPaymentCustomersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: StripeCustomer[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const createPaymentInputBodyPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type CreatePaymentInputBodyPaymentModeEnumKey = (typeof createPaymentInputBodyPaymentModeEnum)[keyof typeof createPaymentInputBodyPaymentModeEnum];

export type CreatePaymentInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the amount to charge in cents of euro
     * @type number
    */
    amountInEuroCents: number;
    /**
     * @description the id of the stripe customer
     * @type string
    */
    stripeCustomerId: string;
    /**
     * @description the payment mode
     * @type string
    */
    paymentMode: CreatePaymentInputBodyPaymentModeEnumKey;
    /**
     * @description the id of the payment method
     * @type string | undefined
    */
    paymentMethodId?: string;
};

export type CreatePaymentOutput = {
    /**
     * @description the id of the payment
     * @type string
    */
    id: string;
};

export type StripeCustomerNotFoundDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
};

export const stripeCustomerNotFoundErrorDtoCodeEnum = {
    STRIPE_CUSTOMER_NOT_FOUND: "STRIPE_CUSTOMER_NOT_FOUND"
} as const;

export type StripeCustomerNotFoundErrorDtoCodeEnumKey = (typeof stripeCustomerNotFoundErrorDtoCodeEnum)[keyof typeof stripeCustomerNotFoundErrorDtoCodeEnum];

export type StripeCustomerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: StripeCustomerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: StripeCustomerNotFoundDetailsDto;
};

export type SetupIntentInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the id of the customer
     * @type string
    */
    stripeCustomerId: string;
    /**
     * @description the allowed payment methods
     * @type array
    */
    allowedPaymentMethods: string[];
};

export type SetupIntentOutput = {
    /**
     * @description the created intent client secret
     * @type string
    */
    clientSecret: string;
    /**
     * @description the id of the intent
     * @type string
    */
    id: string;
};

export type GetCustomersPaymentMethodsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentMethodDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const paymentRefundDtoStatusEnum = {
    CREATED: "CREATED",
    SUCCEEDED: "SUCCEEDED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type PaymentRefundDtoStatusEnumKey = (typeof paymentRefundDtoStatusEnum)[keyof typeof paymentRefundDtoStatusEnum];

export type PaymentRefundDto = {
    /**
     * @description the id of the refund
     * @type string
    */
    refundId: string;
    /**
     * @description the id of the invoice leading to the refund
     * @type string
    */
    refundInvoiceId: string;
    /**
     * @description amount refunded for the refundInvoiceId
     * @type number
    */
    amountInEuroCents: number;
    /**
     * @description refund status
     * @type string
    */
    status: PaymentRefundDtoStatusEnumKey;
};

export const paymentDtoStatusEnum = {
    CREATED: "CREATED",
    SUCCESSFUL: "SUCCESSFUL",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED",
    DISPUTED: "DISPUTED"
} as const;

export type PaymentDtoStatusEnumKey = (typeof paymentDtoStatusEnum)[keyof typeof paymentDtoStatusEnum];

export const paymentDtoPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type PaymentDtoPaymentModeEnumKey = (typeof paymentDtoPaymentModeEnum)[keyof typeof paymentDtoPaymentModeEnum];

export type PaymentDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @description the id of the payment
     * @type string
    */
    id: string;
    /**
     * @description the status of the payment
     * @type string
    */
    status: PaymentDtoStatusEnumKey;
    /**
     * @description the payment mode
     * @type string
    */
    paymentMode: PaymentDtoPaymentModeEnumKey;
    /**
     * @description the id of the payment
     * @type string
    */
    paymentMethodId: string;
    /**
     * @description the amount to charge in cents of euro
     * @type number
    */
    amountInEuroCents: number;
    /**
     * @description the refundable amount in cents of euro
     * @type number
    */
    refundableAmount: number;
    /**
     * @description the refunded amount in cents of euro
     * @type number
    */
    amountRefunded: number;
    /**
     * @description the amount waiting for refund to be processed, in cents of euro
     * @type number
    */
    amountToRefund: number;
    /**
     * @description the date of creation of the payment
     * @type string
    */
    createdAt: string;
    /**
     * @description the reason of the cancellation
     * @type string
    */
    cancellationReason: string;
    /**
     * @description the reason of the failure
     * @type string
    */
    failureReason: string;
    /**
     * @description the Stripe error code of the failure, e.g. `card_declined`
     * @type string | undefined
    */
    failureCode?: string;
    /**
     * @description the Stripe decline code underlying `failureCode`, when the code alone carries no motive
     * @type string | undefined
    */
    failureDeclineCode?: string;
    /**
     * @description the refunds of the payment
     * @type array
    */
    refunds: PaymentRefundDto[];
    /**
     * @description the date of the payment failure
     * @type string | undefined
    */
    failedAt?: string;
};

export type GetPaymentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type GetCustomerPaymentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const cancelPaymentInputBodyReasonEnum = {
    fraudulent: "fraudulent",
    requested_by_customer: "requested_by_customer",
    abandoned: "abandoned",
    duplicate: "duplicate"
} as const;

export type CancelPaymentInputBodyReasonEnumKey = (typeof cancelPaymentInputBodyReasonEnum)[keyof typeof cancelPaymentInputBodyReasonEnum];

export type CancelPaymentInputBody = {
    /**
     * @description the reason of the cancellation
     * @type string
    */
    reason: CancelPaymentInputBodyReasonEnumKey;
};

export type CancelPaymentOutput = object;

export type SoftDeletePaymentMethodOutput = {
    /**
     * @description whether the payment method was soft-deleted
     * @type boolean
    */
    deleted: boolean;
};

export type GenerateIncrementalPolicyIdOutput = {
    /**
     * @description Incremental policy id
     * @type number
    */
    incrementalId: number;
    /**
     * @description External policy id
     * @type string | undefined
    */
    externalPolicyId?: string;
};

export type InvalidNonDelegatedDocumentTypeDetailsDto = {
    /**
     * @type string
    */
    documentType: string;
    /**
     * @type string
    */
    productId: string;
};

export const invalidNonDelegatedDocumentTypeErrorDtoCodeEnum = {
    INVALID_NON_DELEGATED_DOCUMENT_TYPE: "INVALID_NON_DELEGATED_DOCUMENT_TYPE"
} as const;

export type InvalidNonDelegatedDocumentTypeErrorDtoCodeEnumKey = (typeof invalidNonDelegatedDocumentTypeErrorDtoCodeEnum)[keyof typeof invalidNonDelegatedDocumentTypeErrorDtoCodeEnum];

export type InvalidNonDelegatedDocumentTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidNonDelegatedDocumentTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidNonDelegatedDocumentTypeDetailsDto;
};

export type NonDelegatedDocumentsConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const nonDelegatedDocumentsConfigNotFoundErrorDtoCodeEnum = {
    NON_DELEGATED_DOCUMENTS_CONFIG_NOT_FOUND: "NON_DELEGATED_DOCUMENTS_CONFIG_NOT_FOUND"
} as const;

export type NonDelegatedDocumentsConfigNotFoundErrorDtoCodeEnumKey = (typeof nonDelegatedDocumentsConfigNotFoundErrorDtoCodeEnum)[keyof typeof nonDelegatedDocumentsConfigNotFoundErrorDtoCodeEnum];

export type NonDelegatedDocumentsConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: NonDelegatedDocumentsConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NonDelegatedDocumentsConfigNotFoundDetailsDto;
};

export const policyGenerateDocumentUploadUrlInputBodyTypeEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated"
} as const;

export type PolicyGenerateDocumentUploadUrlInputBodyTypeEnumKey = (typeof policyGenerateDocumentUploadUrlInputBodyTypeEnum)[keyof typeof policyGenerateDocumentUploadUrlInputBodyTypeEnum];

export type PolicyGenerateDocumentUploadUrlInputBody = {
    /**
     * @type string | undefined
    */
    type?: PolicyGenerateDocumentUploadUrlInputBodyTypeEnumKey;
    /**
     * @description The document category. Omit while awaiting classification.
     * @type string | undefined
    */
    category?: string;
    /**
     * @description name
     * @type string
    */
    name: string;
    /**
     * @description metadata of the policy
     * @type array | undefined
    */
    metadata?: Metadata[];
};

export type InvalidInvoicingConfigDetailsDto = {
    /**
     * @type array
    */
    availableConfigs: InvoicingConfigDto[];
};

export const invalidInvoicingConfigErrorDtoCodeEnum = {
    INVALID_INVOICING_CONFIG: "INVALID_INVOICING_CONFIG"
} as const;

export type InvalidInvoicingConfigErrorDtoCodeEnumKey = (typeof invalidInvoicingConfigErrorDtoCodeEnum)[keyof typeof invalidInvoicingConfigErrorDtoCodeEnum];

export type InvalidInvoicingConfigErrorDto = {
    /**
     * @type string
    */
    code: InvalidInvoicingConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidInvoicingConfigDetailsDto;
};

export type EditBillingAssignmentInputDto = {
    /**
     * @description ID of the billing assignment config to apply
     * @type string
    */
    configId: string;
};

export type EditPolicyInputBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: NullableCustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description the policy\'s invoicing configuration
    */
    invoicingConfig?: InvoicingConfigDto;
    /**
     * @description the policy\'s period duration
    */
    periodDuration?: Duration;
    /**
     * @type object | undefined
    */
    billingAssignment?: EditBillingAssignmentInputDto;
    /**
     * @description the prior contract the policyholder asks to cancel; frozen once the letter is sent. Only accepted when the product enables prior contract cancellation.
    */
    priorContract?: PriorContractDto;
};

export type EditPolicyOutput = object;

export type ExternalIdAlreadyInUseDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const externalIdAlreadyInUseErrorDtoCodeEnum = {
    EXTERNAL_ID_ALREADY_IN_USE: "EXTERNAL_ID_ALREADY_IN_USE"
} as const;

export type ExternalIdAlreadyInUseErrorDtoCodeEnumKey = (typeof externalIdAlreadyInUseErrorDtoCodeEnum)[keyof typeof externalIdAlreadyInUseErrorDtoCodeEnum];

export type ExternalIdAlreadyInUseErrorDto = {
    /**
     * @type string
    */
    code: ExternalIdAlreadyInUseErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ExternalIdAlreadyInUseDetailsDto;
};

export type EditPolicyExternalIdInputBody = {
    /**
     * @type string
    */
    externalId: string;
};

export type EditPolicyExternalIdOutput = object;

export type InvalidConfirmationDateDetailsDto = {
    /**
     * @type string, date-time
    */
    startedAt: string;
    /**
     * @type string, date-time
    */
    whenAt: string;
};

export const invalidConfirmationDateErrorDtoCodeEnum = {
    INVALID_CONFIRMATION_DATE: "INVALID_CONFIRMATION_DATE"
} as const;

export type InvalidConfirmationDateErrorDtoCodeEnumKey = (typeof invalidConfirmationDateErrorDtoCodeEnum)[keyof typeof invalidConfirmationDateErrorDtoCodeEnum];

export type InvalidConfirmationDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidConfirmationDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidConfirmationDateDetailsDto;
};

export type InvoicingConfigNotSetDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    action: Action;
};

export const invoicingConfigNotSetErrorDtoCodeEnum = {
    INVOICING_CONFIG_NOT_SET: "INVOICING_CONFIG_NOT_SET"
} as const;

export type InvoicingConfigNotSetErrorDtoCodeEnumKey = (typeof invoicingConfigNotSetErrorDtoCodeEnum)[keyof typeof invoicingConfigNotSetErrorDtoCodeEnum];

export type InvoicingConfigNotSetErrorDto = {
    /**
     * @type string
    */
    code: InvoicingConfigNotSetErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoicingConfigNotSetDetailsDto;
};

export type NoChangesToSignConflictDetailsDto = object;

export const noChangesToSignErrorDtoCodeEnum = {
    NO_CHANGES_TO_SIGN: "NO_CHANGES_TO_SIGN"
} as const;

export type NoChangesToSignErrorDtoCodeEnumKey = (typeof noChangesToSignErrorDtoCodeEnum)[keyof typeof noChangesToSignErrorDtoCodeEnum];

export type NoChangesToSignErrorDto = {
    /**
     * @type string
    */
    code: NoChangesToSignErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoChangesToSignConflictDetailsDto;
};

export type ConfirmPolicyOutput = object;

export type NoSignedDocumentsOnProductDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const noSignedDocumentsOnProductErrorDtoCodeEnum = {
    NO_SIGNED_DOCUMENTS_ON_PRODUCT: "NO_SIGNED_DOCUMENTS_ON_PRODUCT"
} as const;

export type NoSignedDocumentsOnProductErrorDtoCodeEnumKey = (typeof noSignedDocumentsOnProductErrorDtoCodeEnum)[keyof typeof noSignedDocumentsOnProductErrorDtoCodeEnum];

export type NoSignedDocumentsOnProductErrorDto = {
    /**
     * @type string
    */
    code: NoSignedDocumentsOnProductErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoSignedDocumentsOnProductDetailsDto;
};

export type NoValidPaymentMethodsConflictDto = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type boolean
    */
    requiresEarlyPaymentMethod: boolean;
    /**
     * @type boolean
    */
    missingValidPaymentMethod: boolean;
    /**
     * @type boolean
    */
    missingEarlyPaymentMethod: boolean;
};

export const noValidPaymentMethodsErrorDtoCodeEnum = {
    NO_VALID_PAYMENT_METHODS: "NO_VALID_PAYMENT_METHODS"
} as const;

export type NoValidPaymentMethodsErrorDtoCodeEnumKey = (typeof noValidPaymentMethodsErrorDtoCodeEnum)[keyof typeof noValidPaymentMethodsErrorDtoCodeEnum];

export type NoValidPaymentMethodsErrorDto = {
    /**
     * @type string
    */
    code: NoValidPaymentMethodsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoValidPaymentMethodsConflictDto;
};

export type NoDocumentReadyToBeSignedDetailsDto = object;

export const noDocumentReadyToBeSignedErrorDtoCodeEnum = {
    NO_DOCUMENT_READY_TO_BE_SIGNED: "NO_DOCUMENT_READY_TO_BE_SIGNED"
} as const;

export type NoDocumentReadyToBeSignedErrorDtoCodeEnumKey = (typeof noDocumentReadyToBeSignedErrorDtoCodeEnum)[keyof typeof noDocumentReadyToBeSignedErrorDtoCodeEnum];

export type NoDocumentReadyToBeSignedErrorDto = {
    /**
     * @type string
    */
    code: NoDocumentReadyToBeSignedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoDocumentReadyToBeSignedDetailsDto;
};

export const generatePolicySignatureRequestInputBodyDeliveryModeEnum = {
    EMAIL: "EMAIL",
    URL: "URL"
} as const;

export type GeneratePolicySignatureRequestInputBodyDeliveryModeEnumKey = (typeof generatePolicySignatureRequestInputBodyDeliveryModeEnum)[keyof typeof generatePolicySignatureRequestInputBodyDeliveryModeEnum];

export type GeneratePolicySignatureRequestInputBody = {
    /**
     * @description the delivery mode
     * @type string
    */
    deliveryMode: GeneratePolicySignatureRequestInputBodyDeliveryModeEnumKey;
    /**
     * @description Do we want to sign the documents needed for the policy to be signed? If yes, it signs all those documents at the same time.
     * @default true
     * @type boolean | undefined
    */
    neededForPolicySigned?: boolean;
    /**
     * @description if the signature request is an otp one or not
     * @type boolean | undefined
    */
    isOtp?: boolean;
    /**
     * @description the phone number
     * @type string | undefined
    */
    phoneNumber?: string;
};

export type SignatureRequestOutput = {
    /**
     * @description the signature id
     * @type string
    */
    id: string;
    /**
     * @description the signers
     * @type array
    */
    signers: SignerDto[];
};

export type GeneratePolicySignatureRequestOutput = {
    /**
     * @description the signature requests
     * @type array
    */
    signatures: SignatureRequestOutput[];
};

export const derogationStatusEnum = {
    CREATED: "CREATED",
    APPROVED: "APPROVED",
    DENIED: "DENIED"
} as const;

export type DerogationStatusEnumKey = (typeof derogationStatusEnum)[keyof typeof derogationStatusEnum];

/**
 * @description Status of the derogation
*/
export type DerogationStatus = DerogationStatusEnumKey;

export type DerogationDto = {
    /**
     * @description Unique identifier for the derogation
     * @type string
    */
    derogationId: string;
    /**
     * @description Action for the derogation
    */
    action: DerogationAction;
    /**
     * @description Status of the derogation
    */
    status: DerogationStatus;
    /**
     * @description Derogation creation date
     * @type string
    */
    createdAt: string;
};

export const branchDtoTypeEnum = {
    BRANCH: "BRANCH"
} as const;

export type BranchDtoTypeEnumKey = (typeof branchDtoTypeEnum)[keyof typeof branchDtoTypeEnum];

export const branchDtoStatusEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type BranchDtoStatusEnumKey = (typeof branchDtoStatusEnum)[keyof typeof branchDtoStatusEnum];

export const branchDtoRenewalStatusEnum = {
    RENEWAL_ACCEPTED: "RENEWAL_ACCEPTED",
    RENEWAL_REFUSED: "RENEWAL_REFUSED"
} as const;

export type BranchDtoRenewalStatusEnumKey = (typeof branchDtoRenewalStatusEnum)[keyof typeof branchDtoRenewalStatusEnum];

export const branchDtoBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type BranchDtoBranchTypeEnumKey = (typeof branchDtoBranchTypeEnum)[keyof typeof branchDtoBranchTypeEnum];

export const branchDtoBranchStatusEnum = {
    BRANCH_OPEN: "BRANCH_OPEN",
    BRANCH_MERGED: "BRANCH_MERGED",
    BRANCH_CLOSED: "BRANCH_CLOSED"
} as const;

export type BranchDtoBranchStatusEnumKey = (typeof branchDtoBranchStatusEnum)[keyof typeof branchDtoBranchStatusEnum];

export const branchDtoCloseReasonEnum = {
    BROKER_REQUEST: "BROKER_REQUEST",
    CUSTOMER_REQUEST: "CUSTOMER_REQUEST",
    FORKED: "FORKED",
    ASSET_START_PASSED: "ASSET_START_PASSED",
    CONCURRENT_BRANCH_MERGED: "CONCURRENT_BRANCH_MERGED",
    QUOTE_INVALIDATED: "QUOTE_INVALIDATED",
    PARTITION_DROPPED: "PARTITION_DROPPED",
    RENEWAL_REFUSED: "RENEWAL_REFUSED",
    CRM_ABOVE_LIMIT: "CRM_ABOVE_LIMIT",
    TELEMATICS_SCORE_MISSING: "TELEMATICS_SCORE_MISSING",
    SIGNATURE_CANCELLED: "SIGNATURE_CANCELLED",
    DEROGATION_DENIED: "DEROGATION_DENIED"
} as const;

export type BranchDtoCloseReasonEnumKey = (typeof branchDtoCloseReasonEnum)[keyof typeof branchDtoCloseReasonEnum];

export type BranchDto = {
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    id: string;
    /**
     * @description Type of object
     * @type string
    */
    type: BranchDtoTypeEnumKey;
    /**
     * @description Creation date of the branch
     * @type string
    */
    createdAt: string;
    /**
     * @description Last modification date of the branch
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Optional: Policy status
     * @type string | undefined
    */
    status?: BranchDtoStatusEnumKey;
    /**
     * @description Optional: Branch renewal status
     * @type string | undefined
    */
    renewalStatus?: BranchDtoRenewalStatusEnumKey;
    /**
     * @description Optional: Branch type
     * @type string | undefined
    */
    branchType?: BranchDtoBranchTypeEnumKey;
    /**
     * @description Optional: Branch sub type
    */
    branchSubType?: BranchSubType;
    /**
     * @description Optional: Branch status
     * @type string | undefined
    */
    branchStatus?: BranchDtoBranchStatusEnumKey;
    /**
     * @description Optional: Branch close reason
     * @type string | undefined
    */
    closeReason?: BranchDtoCloseReasonEnumKey;
    /**
     * @description Comment given when the branch was closed
     * @type string | undefined
    */
    closeComment?: string;
    /**
     * @description Close date of the branch
     * @type string | undefined
    */
    closedAt?: string;
    /**
     * @description Merge date of the branch
     * @type string | undefined
    */
    mergedAt?: string;
    /**
     * @description Optional: Branch this branch was forked from
     * @type string | undefined
    */
    parentBranchId?: string;
    /**
     * @description Optional: Branch derogations
     * @type array | undefined
    */
    derogations?: DerogationDto[];
};

export type ListBranchesOutput = {
    /**
     * @description Total number of policies
     * @type number
    */
    total: number;
    /**
     * @description Offset used for pagination
     * @type number
    */
    offset: number;
    /**
     * @description Page size used for pagination
     * @type number
    */
    limit: number;
    /**
     * @description List of policies
     * @type array
    */
    data: BranchDto[];
};

export const componentDtoTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type ComponentDtoTypeEnumKey = (typeof componentDtoTypeEnum)[keyof typeof componentDtoTypeEnum];

export const componentDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type ComponentDtoInsurerEnumKey = (typeof componentDtoInsurerEnum)[keyof typeof componentDtoInsurerEnum];

export type ComponentDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: ComponentDtoTypeEnumKey;
    /**
     * @description insurer of the quote that priced it
     * @type string | undefined
    */
    insurer?: ComponentDtoInsurerEnumKey;
    /**
     * @type object
    */
    premium: AmountDto;
};

export type PremiumOnIntervalDto = {
    /**
     * @type string, date-time
    */
    startAt: string;
    /**
     * @type string, date-time
    */
    endAt: string;
    /**
     * @type array | undefined
    */
    components?: ComponentDto[];
    /**
     * @description insurer of the policy quote in force on the interval
    */
    insurer?: Insurer;
    /**
     * @type object
    */
    premium: AmountDto;
};

export type GetPremiumScheduleOutput = {
    /**
     * @description Total number of policies
     * @type number
    */
    total: number;
    /**
     * @description Offset used for pagination
     * @type number
    */
    offset: number;
    /**
     * @description Page size used for pagination
     * @type number
    */
    limit: number;
    /**
     * @description PremiumSchedule
     * @type array
    */
    data: PremiumOnIntervalDto[];
};

export const policyDocumentsDtoTypeEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated",
    generated: "generated"
} as const;

export type PolicyDocumentsDtoTypeEnumKey = (typeof policyDocumentsDtoTypeEnum)[keyof typeof policyDocumentsDtoTypeEnum];

export type PolicyDocumentsDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description The stored document role.
     * @type string
    */
    type: PolicyDocumentsDtoTypeEnumKey | null;
    /**
     * @description The stored document category, or null while unclassified.
     * @type string
    */
    category: string | null;
    /**
     * @description the id of the document
     * @type string
    */
    id: string;
    /**
     * @description the name of the document
     * @type string
    */
    name: string;
    /**
     * @description the path of the document on the Korint CDN
     * @type string
    */
    path: string;
    /**
     * @description the date of creation of the document
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description the signed url to download the document
     * @type string
    */
    signedUrl: string;
    /**
     * @description Is the document signed ?
     * @type boolean | undefined
    */
    isSigned?: boolean;
};

export type ListPolicyDocumentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PolicyDocumentsDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type DeletePolicyDocumentsOutput = object;

export type EventMetadataDto = {
    /**
     * @description The root aggregate id (policy id)
     * @type string
    */
    rootId: string;
    /**
     * @description The branch id
     * @type string
    */
    branchId: string;
    /**
     * @description The tenant id
     * @type string
    */
    tenantId: string;
    /**
     * @description The product id
     * @type string | undefined
    */
    productId?: string;
    /**
     * @description The user id
     * @type string | undefined
    */
    userId?: string;
    /**
     * @description Is the event simulated
     * @type boolean | undefined
    */
    isSimulated?: boolean;
    /**
     * @description Is this a custom event
     * @type boolean | undefined
    */
    isCustomEvent?: boolean;
    /**
     * @description The event creation date
     * @type string
    */
    createdAt: string;
    /**
     * @description The date the event was applied
     * @type string | undefined
    */
    appliedAt?: string;
    /**
     * @description Is this event migrated
     * @type boolean | undefined
    */
    migrated?: boolean;
    /**
     * @description The migration id, if migrated
     * @type string | undefined
    */
    migrationId?: string;
};

export const policyEventDtoAggregateTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT",
    BRANCH: "BRANCH",
    ROOT: "ROOT",
    JOB: "JOB",
    ROLE: "ROLE",
    SESSION: "SESSION",
    WORKFLOW_RUN: "WORKFLOW_RUN",
    WORKFLOW_RUN_NODE: "WORKFLOW_RUN_NODE",
    JOB_SCHEDULER: "JOB_SCHEDULER",
    JOB_SCHEDULER_RUN: "JOB_SCHEDULER_RUN",
    RELATION: "RELATION",
    MIGRATION_TASK: "MIGRATION_TASK",
    AI_OPERATION: "AI_OPERATION",
    AI_FEEDBACK: "AI_FEEDBACK",
    IMPERSONATION_SESSION: "IMPERSONATION_SESSION",
    FEDERATED_SESSION: "FEDERATED_SESSION"
} as const;

export type PolicyEventDtoAggregateTypeEnumKey = (typeof policyEventDtoAggregateTypeEnum)[keyof typeof policyEventDtoAggregateTypeEnum];

export type PolicyEventDto = {
    /**
     * @description policy event aggregate id
     * @type string
    */
    aggregateId: string;
    /**
     * @description policy event aggregate type
     * @type string
    */
    aggregateType: PolicyEventDtoAggregateTypeEnumKey;
    /**
     * @description policy event version
     * @type number
    */
    version: number;
    /**
     * @description policy event createdAt
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description policy event updatedAt
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description policy event type
     * @type string
    */
    type: string;
    /**
     * @description policy event data
     * @type object
    */
    data: object;
    /**
     * @description policy event metadata
    */
    metadata: EventMetadataDto;
};

export type ListPolicyEventsOutput = {
    /**
     * @description Total number of policies
     * @type number | undefined
    */
    total?: number;
    /**
     * @description Offset used for pagination
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description Page size used for pagination
     * @type number | undefined
    */
    limit?: number;
    /**
     * @description Array of policy events
     * @type array
    */
    data: PolicyEventDto[];
};

export type SuccessNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
};

export type NodeInputMappingDefinitionDto = {
    /**
     * @type string
    */
    inputPath: string;
    statePath?: (string | string[]);
    value?: (string | number | boolean);
};

export type NodeResultMappingDefinitionDto = {
    /**
     * @type string
    */
    statePath: string;
    /**
     * @type string
    */
    resultPath: string;
};

export type RpcCallNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    service: string;
    /**
     * @type string
    */
    command: string;
    /**
     * @type number | undefined
    */
    timeout?: number;
    /**
     * @type number
    */
    maxAttempts: number;
    /**
     * @type array
    */
    inputMapping: NodeInputMappingDefinitionDto[];
    /**
     * @type array | undefined
    */
    resultMapping?: NodeResultMappingDefinitionDto[];
    /**
     * @type string
    */
    next: string;
    /**
     * @type string | undefined
    */
    onError?: string;
};

export type ConditionNodePathDefinitionDto = {
    /**
     * @type array | undefined
    */
    and?: FilterDto[];
    /**
     * @type array | undefined
    */
    or?: FilterDto[];
    /**
     * @type string
    */
    next: string;
};

export type ConditionNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type array
    */
    paths: ConditionNodePathDefinitionDto[];
    /**
     * @type string | undefined
    */
    defaultPath?: string;
};

export type NodeDurationDto = {
    /**
     * @type number | undefined
    */
    years?: number;
    /**
     * @type number | undefined
    */
    year?: number;
    /**
     * @type number | undefined
    */
    quarters?: number;
    /**
     * @type number | undefined
    */
    quarter?: number;
    /**
     * @type number | undefined
    */
    months?: number;
    /**
     * @type number | undefined
    */
    month?: number;
    /**
     * @type number | undefined
    */
    weeks?: number;
    /**
     * @type number | undefined
    */
    week?: number;
    /**
     * @type number | undefined
    */
    days?: number;
    /**
     * @type number | undefined
    */
    day?: number;
    /**
     * @type number | undefined
    */
    hours?: number;
    /**
     * @type number | undefined
    */
    hour?: number;
    /**
     * @type number | undefined
    */
    minutes?: number;
    /**
     * @type number | undefined
    */
    minute?: number;
    /**
     * @type number | undefined
    */
    seconds?: number;
    /**
     * @type number | undefined
    */
    second?: number;
    /**
     * @type number | undefined
    */
    milliseconds?: number;
    /**
     * @type number | undefined
    */
    millisecond?: number;
};

export type WaitNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type object
    */
    waitFor: NodeDurationDto;
    /**
     * @type string
    */
    next: string;
};

export type WaitUntilNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type string | undefined, date-time
    */
    waitUntil?: string;
    /**
     * @type string | undefined
    */
    path?: string;
    /**
     * @type string
    */
    next: string;
};

export type ErrorNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
};

export type ChildWorkflowNodeDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    type: string;
    /**
     * @type array
    */
    inputMapping: NodeInputMappingDefinitionDto[];
    /**
     * @type array | undefined
    */
    resultMapping?: NodeResultMappingDefinitionDto[];
    /**
     * @type object
    */
    definition: WorkflowDefinition;
    /**
     * @type array
    */
    metadata: NodeInputMappingDefinitionDto[];
    /**
     * @type string
    */
    next: string;
};

export type WorkflowDefinitionDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    firstNodeName: string;
    /**
     * @type number | undefined
    */
    maxAttempts?: number;
    /**
     * @type array
    */
    nodes: (SuccessNodeDefinitionDto | RpcCallNodeDefinitionDto | ConditionNodeDefinitionDto | WaitNodeDefinitionDto | WaitUntilNodeDefinitionDto | ErrorNodeDefinitionDto | ChildWorkflowNodeDefinitionDto)[];
};

export const plannedTaskDtoTaskEnum = {
    billing: "billing",
    "renewal-creation": "renewal-creation",
    "renewal-disabled-stop": "renewal-disabled-stop",
    "renewal-disabled-stop-notice": "renewal-disabled-stop-notice",
    "renewal-merge": "renewal-merge",
    repricing: "repricing",
    upsertSydiaClaims: "upsertSydiaClaims",
    "unpaid-retry": "unpaid-retry",
    "unpaid-reminder": "unpaid-reminder",
    "unpaid-escalation": "unpaid-escalation"
} as const;

export type PlannedTaskDtoTaskEnumKey = (typeof plannedTaskDtoTaskEnum)[keyof typeof plannedTaskDtoTaskEnum];

export type PlannedTaskDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    task: PlannedTaskDtoTaskEnumKey;
    /**
     * @type object
    */
    payload: {
        [key: string]: any;
    };
    /**
     * @type object
    */
    workflow: WorkflowDefinitionDto;
};

export type PolicyPlanDto = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    whenAt: string;
    /**
     * @type array
    */
    tasks: PlannedTaskDto[];
};

export type PlanFailureDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    reason: string;
};

export type PlanTasksOutput = {
    /**
     * @type array
    */
    plans: PolicyPlanDto[];
    /**
     * @type array
    */
    failures: PlanFailureDto[];
};

export type PushEventInputBody = {
    /**
     * @description metadata assigned to the object
     * @type array | undefined
    */
    metadata?: Metadata[];
    /**
     * @description The event type. Must be one of the custom policy events declared for the product; read them from `GET /config/{productId}`.
     * @type string
    */
    eventType: string;
    /**
     * @description The event data
     * @type object | undefined
    */
    data?: object;
};

export type PushEventOutput = object;

export type MissingAssetOptionsDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
};

export const missingAssetOptionsErrorDtoCodeEnum = {
    MISSING_ASSET_OPTIONS: "MISSING_ASSET_OPTIONS"
} as const;

export type MissingAssetOptionsErrorDtoCodeEnumKey = (typeof missingAssetOptionsErrorDtoCodeEnum)[keyof typeof missingAssetOptionsErrorDtoCodeEnum];

export type MissingAssetOptionsErrorDto = {
    /**
     * @type string
    */
    code: MissingAssetOptionsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAssetOptionsDetailsDto;
};

export type InvalidPricingDetailsErrorsDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type array
    */
    errorDetails: string[];
    /**
     * @type object | undefined
    */
    value?: object;
};

export type InvalidPricingDetailsDetailsDto = {
    /**
     * @type string
    */
    product: string;
    businessEntity: BusinessEntity;
    /**
     * @type array
    */
    errors: InvalidPricingDetailsErrorsDto[];
};

export const invalidPricingDetailsErrorDtoCodeEnum = {
    INVALID_PRICING_DETAILS: "INVALID_PRICING_DETAILS"
} as const;

export type InvalidPricingDetailsErrorDtoCodeEnumKey = (typeof invalidPricingDetailsErrorDtoCodeEnum)[keyof typeof invalidPricingDetailsErrorDtoCodeEnum];

export type InvalidPricingDetailsErrorDto = {
    /**
     * @type string
    */
    code: InvalidPricingDetailsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPricingDetailsDetailsDto;
};

export type InvalidQuoteOptionsInvalidPerilOptionDetailsDto = object;

export const invalidQuoteOptionsInvalidPerilOptionErrorDtoCodeEnum = {
    INVALID_QUOTE_OPTIONS_INVALID_PERIL_OPTION: "INVALID_QUOTE_OPTIONS_INVALID_PERIL_OPTION"
} as const;

export type InvalidQuoteOptionsInvalidPerilOptionErrorDtoCodeEnumKey = (typeof invalidQuoteOptionsInvalidPerilOptionErrorDtoCodeEnum)[keyof typeof invalidQuoteOptionsInvalidPerilOptionErrorDtoCodeEnum];

export type InvalidQuoteOptionsInvalidPerilOptionErrorDto = {
    /**
     * @type string
    */
    code: InvalidQuoteOptionsInvalidPerilOptionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidQuoteOptionsInvalidPerilOptionDetailsDto;
};

export type InvalidQuoteOptionsMissingPerilsDetailsDto = object;

export const invalidQuoteOptionsMissingRequiredPerilsErrorDtoCodeEnum = {
    INVALID_QUOTE_OPTIONS_MISSING_REQUIRED_PERILS: "INVALID_QUOTE_OPTIONS_MISSING_REQUIRED_PERILS"
} as const;

export type InvalidQuoteOptionsMissingRequiredPerilsErrorDtoCodeEnumKey = (typeof invalidQuoteOptionsMissingRequiredPerilsErrorDtoCodeEnum)[keyof typeof invalidQuoteOptionsMissingRequiredPerilsErrorDtoCodeEnum];

export type InvalidQuoteOptionsMissingRequiredPerilsErrorDto = {
    /**
     * @type string
    */
    code: InvalidQuoteOptionsMissingRequiredPerilsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidQuoteOptionsMissingPerilsDetailsDto;
};

export type InvalidQuoteOptionsTierAndExcessDetailsDto = object;

export const invalidQuoteOptionsTierAndExcessErrorDtoCodeEnum = {
    INVALID_QUOTE_OPTIONS_TIER_AND_EXCESS: "INVALID_QUOTE_OPTIONS_TIER_AND_EXCESS"
} as const;

export type InvalidQuoteOptionsTierAndExcessErrorDtoCodeEnumKey = (typeof invalidQuoteOptionsTierAndExcessErrorDtoCodeEnum)[keyof typeof invalidQuoteOptionsTierAndExcessErrorDtoCodeEnum];

export type InvalidQuoteOptionsTierAndExcessErrorDto = {
    /**
     * @type string
    */
    code: InvalidQuoteOptionsTierAndExcessErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidQuoteOptionsTierAndExcessDetailsDto;
};

export const quoteFailedDetailsDtoFailedReasonEnum = {
    CRM_ABOVE_LIMIT: "CRM_ABOVE_LIMIT",
    NEGATIVE_PREMIUM: "NEGATIVE_PREMIUM",
    SHORT_INSURANCE_HISTORY_OUTSIDE_EXPERIENCE_RANGE: "SHORT_INSURANCE_HISTORY_OUTSIDE_EXPERIENCE_RANGE",
    SRA_GROUP_ABOVE_LIMIT: "SRA_GROUP_ABOVE_LIMIT",
    LICENSE_OBTAINED_TOO_YOUNG: "LICENSE_OBTAINED_TOO_YOUNG",
    LICENSE_TOO_RECENT: "LICENSE_TOO_RECENT",
    DRIVER_TOO_YOUNG: "DRIVER_TOO_YOUNG",
    LOW_EXPERIENCE_WITH_HIGH_CRM: "LOW_EXPERIENCE_WITH_HIGH_CRM",
    NO_EXPERIENCE_WITH_SHORT_HISTORY_OR_HIGH_CRM: "NO_EXPERIENCE_WITH_SHORT_HISTORY_OR_HIGH_CRM",
    TOO_MANY_CLAIMS: "TOO_MANY_CLAIMS",
    TOO_MANY_MATERIAL_DAMAGE_CLAIMS: "TOO_MANY_MATERIAL_DAMAGE_CLAIMS",
    TOO_MANY_GLASS_BREAKAGE_CLAIMS: "TOO_MANY_GLASS_BREAKAGE_CLAIMS",
    TOO_MANY_BODILY_INJURY_CLAIMS: "TOO_MANY_BODILY_INJURY_CLAIMS",
    TOO_MANY_THEFT_AND_FIRE_CLAIMS: "TOO_MANY_THEFT_AND_FIRE_CLAIMS",
    TOO_MANY_PARKING_CLAIMS: "TOO_MANY_PARKING_CLAIMS",
    TERMINATED_FOR_NON_PAYMENT_WITH_INSTALMENTS: "TERMINATED_FOR_NON_PAYMENT_WITH_INSTALMENTS",
    VEHICLE_VALUE_ABOVE_LIMIT: "VEHICLE_VALUE_ABOVE_LIMIT",
    PRICING_UNAVAILABLE: "PRICING_UNAVAILABLE",
    TOO_MANY_SEATS: "TOO_MANY_SEATS",
    MARKET_VALUE_REQUIRED: "MARKET_VALUE_REQUIRED",
    VEHICLE_GROUP_AND_CLASS_REQUIRED: "VEHICLE_GROUP_AND_CLASS_REQUIRED"
} as const;

export type QuoteFailedDetailsDtoFailedReasonEnumKey = (typeof quoteFailedDetailsDtoFailedReasonEnum)[keyof typeof quoteFailedDetailsDtoFailedReasonEnum];

export type QuoteFailedDetailsDto = {
    /**
     * @type string | undefined
    */
    failedReason?: QuoteFailedDetailsDtoFailedReasonEnumKey;
};

export const quoteFailedErrorDtoCodeEnum = {
    QUOTE_FAILED: "QUOTE_FAILED"
} as const;

export type QuoteFailedErrorDtoCodeEnumKey = (typeof quoteFailedErrorDtoCodeEnum)[keyof typeof quoteFailedErrorDtoCodeEnum];

export type QuoteFailedErrorDto = {
    /**
     * @type string
    */
    code: QuoteFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: QuoteFailedDetailsDto;
};

export type CfdpPricingEngineChangedDetailsDto = object;

export const cfdpPricingEngineChangedErrorDtoCodeEnum = {
    CFDP_PRICING_ENGINE_CHANGED: "CFDP_PRICING_ENGINE_CHANGED"
} as const;

export type CfdpPricingEngineChangedErrorDtoCodeEnumKey = (typeof cfdpPricingEngineChangedErrorDtoCodeEnum)[keyof typeof cfdpPricingEngineChangedErrorDtoCodeEnum];

export type CfdpPricingEngineChangedErrorDto = {
    /**
     * @type string
    */
    code: CfdpPricingEngineChangedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CfdpPricingEngineChangedDetailsDto;
};

export type NoChangesToQuoteConflictDetailsDto = object;

export const noChangesToQuoteErrorDtoCodeEnum = {
    NO_CHANGES_TO_QUOTE: "NO_CHANGES_TO_QUOTE"
} as const;

export type NoChangesToQuoteErrorDtoCodeEnumKey = (typeof noChangesToQuoteErrorDtoCodeEnum)[keyof typeof noChangesToQuoteErrorDtoCodeEnum];

export type NoChangesToQuoteErrorDto = {
    /**
     * @type string
    */
    code: NoChangesToQuoteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoChangesToQuoteConflictDetailsDto;
};

export type PolicyQuoteBodyInputOptions = {
    /**
     * @description The tier selected for this asset, as listed by GET /policies/{policyId}/available-pricing. Tiers are computed per policy, so there is no fixed list.
     * @type string
    */
    tier: string;
    /**
     * @description The excess selected for this asset, from the chosen tier\'s available excesses.
     * @type string
    */
    excess: string;
    /**
     * @description The optional perils selected for this asset. Perils always included in the tier are not listed here.
     * @type array | undefined
    */
    perils?: ConfigQuoteChosenWarrantyDto[];
    /**
     * @type string
    */
    assetId: string;
};

export type ManualQuotePolicyInputComponentPremiumDto = {
    /**
     * @type integer
    */
    amountPreFeesAndTaxes: number;
    /**
     * @type integer
    */
    totalFees: number;
    /**
     * @type integer
    */
    totalTaxes: number;
};

export const manualQuoteComponentDtoTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type ManualQuoteComponentDtoTypeEnumKey = (typeof manualQuoteComponentDtoTypeEnum)[keyof typeof manualQuoteComponentDtoTypeEnum];

export const manualQuoteComponentDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type ManualQuoteComponentDtoInsurerEnumKey = (typeof manualQuoteComponentDtoInsurerEnum)[keyof typeof manualQuoteComponentDtoInsurerEnum];

export const manualQuoteComponentDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type ManualQuoteComponentDtoChargeTypeEnumKey = (typeof manualQuoteComponentDtoChargeTypeEnum)[keyof typeof manualQuoteComponentDtoChargeTypeEnum];

export type ManualQuoteComponentDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: ManualQuoteComponentDtoTypeEnumKey;
    /**
     * @description insurer of the quote that priced it
     * @type string | undefined
    */
    insurer?: ManualQuoteComponentDtoInsurerEnumKey;
    /**
     * @description Charge type of component
     * @type string
    */
    chargeType: ManualQuoteComponentDtoChargeTypeEnumKey;
    /**
     * @type boolean | undefined
    */
    calculatePremiumBrokerFees?: boolean;
    /**
     * @type object
    */
    premium: ManualQuotePolicyInputComponentPremiumDto;
};

export const manualQuotePercentageAmountPropertyEnum = {
    amountPreFeesAndTaxes: "amountPreFeesAndTaxes",
    totalFees: "totalFees",
    totalTaxes: "totalTaxes"
} as const;

export type ManualQuotePercentageAmountPropertyEnumKey = (typeof manualQuotePercentageAmountPropertyEnum)[keyof typeof manualQuotePercentageAmountPropertyEnum];

/**
 * @description Amount properties to calculate the percentage from
*/
export type ManualQuotePercentageAmountProperty = ManualQuotePercentageAmountPropertyEnumKey;

export const manualQuotePercentageDtoTypeEnum = {
    PREMIUM: "PREMIUM",
    PERIL: "PERIL",
    FEE: "FEE",
    TAX: "TAX",
    SPECIAL: "SPECIAL"
} as const;

export type ManualQuotePercentageDtoTypeEnumKey = (typeof manualQuotePercentageDtoTypeEnum)[keyof typeof manualQuotePercentageDtoTypeEnum];

export const manualQuotePercentageDtoInsurerEnum = {
    WAKAM: "WAKAM",
    ACCELERANT: "ACCELERANT"
} as const;

export type ManualQuotePercentageDtoInsurerEnumKey = (typeof manualQuotePercentageDtoInsurerEnum)[keyof typeof manualQuotePercentageDtoInsurerEnum];

export const manualQuotePercentageDtoChargeTypeEnum = {
    ONE_TIME: "ONE_TIME",
    SPOT: "SPOT",
    RECURRING: "RECURRING"
} as const;

export type ManualQuotePercentageDtoChargeTypeEnumKey = (typeof manualQuotePercentageDtoChargeTypeEnum)[keyof typeof manualQuotePercentageDtoChargeTypeEnum];

export type ManualQuotePercentageDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    type: ManualQuotePercentageDtoTypeEnumKey;
    /**
     * @description insurer of the quote that priced it
     * @type string | undefined
    */
    insurer?: ManualQuotePercentageDtoInsurerEnumKey;
    /**
     * @description Charge type of component
     * @type string
    */
    chargeType: ManualQuotePercentageDtoChargeTypeEnumKey;
    /**
     * @description Component identifiers from who the percentage is calculated
     * @type array
    */
    componentIds: string[];
    /**
     * @description Amount properties to calculate the percentage from
     * @type array
    */
    amountPropertiesFrom: ManualQuotePercentageAmountProperty[];
    /**
     * @description Percentage
     * @minLength 0
     * @maxLength 100
     * @type number
    */
    percentage: number;
};

export type ManualQuoteComponentsAndPercentagesDto = {
    /**
     * @type array
    */
    components: ManualQuoteComponentDto[];
    /**
     * @type array
    */
    percentages: ManualQuotePercentageDto[];
};

export type ManualComponentValuesDto = {
    /**
     * @description Map of manual componentId -> value. Each value is EITHER a single number (euro cents for ABSOLUTE components, or a 0-100 percentage for PERCENTAGE components) OR a breakdown object { amountPreFeesAndTaxes, totalFees, totalTaxes } for ABSOLUTE components that need an explicit fees/taxes split. PERCENTAGE components must always be a number. The backend resolves which shape applies from the tier config (see TierConfig.manualComponents).
     * @type object
    */
    values: {
        [key: string]: (number | {
            /**
             * @type integer
            */
            amountPreFeesAndTaxes: number;
            /**
             * @type integer
            */
            totalFees: number;
            /**
             * @type integer
            */
            totalTaxes: number;
        });
    };
};

export type PolicyQuoteBodyInput = {
    /**
     * @type array | undefined
    */
    options?: PolicyQuoteBodyInputOptions[];
    /**
     * @description Additional quote components and percentages
    */
    additionalQuoteComponentsAndPercentages?: ManualQuoteComponentsAndPercentagesDto;
    /**
     * @description Manual component values as a flat { componentId: value } map for config-driven manual components.
    */
    manualComponentValues?: ManualComponentValuesDto;
    /**
     * @description Debug: force a quote to happen even if there are no changes to quote
     * @type boolean | undefined
    */
    skipValidation?: boolean;
    /**
     * @description Insurer to quote a new business on, among the product\'s new-business insurers. Defaults to the insurer the branch is already quoted on.
    */
    insurer?: Insurer;
};

export type PolicyQuoteOutput = object;

export const policyAggregateDtoStatusEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type PolicyAggregateDtoStatusEnumKey = (typeof policyAggregateDtoStatusEnum)[keyof typeof policyAggregateDtoStatusEnum];

export type PolicyAggregateDto = {
    /**
     * @type string
    */
    aggregateId: string;
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @type string | undefined
    */
    parentPolicyId?: string;
    /**
     * @type array
    */
    customerIds: string[];
    /**
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @type string
    */
    contractType: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string | undefined
    */
    authorId?: string;
    /**
     * @type string
    */
    status: PolicyAggregateDtoStatusEnumKey;
    /**
     * @type object
    */
    stateByBranchId: object;
    /**
     * @type object | undefined
    */
    quote?: object;
    /**
     * @type array | undefined
    */
    brokerageFees?: string[];
    /**
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @type object | undefined
    */
    stop?: object;
    /**
     * @type string | undefined
    */
    suspendedAt?: string;
    /**
     * @type string | undefined
    */
    reactivatedAt?: string;
    /**
     * @type array
    */
    assets: string[];
    /**
     * @type array
    */
    customFields: string[];
    /**
     * @type object
    */
    invoicingConfig: object;
    /**
     * @type object
    */
    periodDuration: object;
    /**
     * @type string
    */
    timeZone: string;
    /**
     * @type array
    */
    documents: string[];
    /**
     * @type array | undefined
    */
    additionalQuoteComponents?: string[];
};

export const assetAggregateDtoStatusEnum = {
    ASSET_CREATED: "ASSET_CREATED",
    ASSET_REMOVED: "ASSET_REMOVED",
    ASSET_QUOTED: "ASSET_QUOTED",
    ASSET_CONFIRMED: "ASSET_CONFIRMED",
    ASSET_STARTED: "ASSET_STARTED",
    ASSET_STOPPED: "ASSET_STOPPED",
    ASSET_CANCELLED: "ASSET_CANCELLED"
} as const;

export type AssetAggregateDtoStatusEnumKey = (typeof assetAggregateDtoStatusEnum)[keyof typeof assetAggregateDtoStatusEnum];

export type AssetAggregateDto = {
    /**
     * @type string
    */
    aggregateId: string;
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @type string
    */
    status: AssetAggregateDtoStatusEnumKey;
    /**
     * @type object
    */
    stateByBranchId: object;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type array
    */
    customFields: string[];
    /**
     * @type boolean
    */
    isReplacement: boolean;
    /**
     * @type string | undefined
    */
    originAssetId?: string;
    /**
     * @type object | undefined
    */
    quote?: object;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    externalAssetId?: string;
    /**
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @type string | undefined
    */
    cancelledAt?: string;
};

export const customerAggregateDtoStatusEnum = {
    CUSTOMER_CREATED: "CUSTOMER_CREATED",
    CUSTOMER_CONFIRMED: "CUSTOMER_CONFIRMED"
} as const;

export type CustomerAggregateDtoStatusEnumKey = (typeof customerAggregateDtoStatusEnum)[keyof typeof customerAggregateDtoStatusEnum];

export type CustomerAggregateDto = {
    /**
     * @type string
    */
    aggregateId: string;
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type boolean | undefined
    */
    migrated?: boolean;
    /**
     * @type string
    */
    status: CustomerAggregateDtoStatusEnumKey;
    /**
     * @type object
    */
    stateByBranchId: object;
    /**
     * @type array
    */
    policies: string[];
    /**
     * @type string
    */
    paymentMode: string;
    /**
     * @type string | undefined
    */
    preferredPaymentMethodId?: string;
    /**
     * @type array
    */
    customFields: string[];
    /**
     * @type string | undefined
    */
    name?: string;
};

export const getAggregateOutputAggregateTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT",
    BRANCH: "BRANCH",
    ROOT: "ROOT",
    JOB: "JOB",
    ROLE: "ROLE",
    SESSION: "SESSION",
    WORKFLOW_RUN: "WORKFLOW_RUN",
    WORKFLOW_RUN_NODE: "WORKFLOW_RUN_NODE",
    JOB_SCHEDULER: "JOB_SCHEDULER",
    JOB_SCHEDULER_RUN: "JOB_SCHEDULER_RUN",
    RELATION: "RELATION",
    MIGRATION_TASK: "MIGRATION_TASK",
    AI_OPERATION: "AI_OPERATION",
    AI_FEEDBACK: "AI_FEEDBACK",
    IMPERSONATION_SESSION: "IMPERSONATION_SESSION",
    FEDERATED_SESSION: "FEDERATED_SESSION"
} as const;

export type GetAggregateOutputAggregateTypeEnumKey = (typeof getAggregateOutputAggregateTypeEnum)[keyof typeof getAggregateOutputAggregateTypeEnum];

export type GetAggregateOutput = {
    /**
     * @description The type of the aggregate
     * @type string
    */
    aggregateType: GetAggregateOutputAggregateTypeEnumKey;
    /**
     * @description Aggregate data
    */
    aggregate: (PolicyAggregateDto | AssetAggregateDto | CustomerAggregateDto);
};

export type CalculatePolicyQuoteInputBody = {
    /**
     * @type array | undefined
    */
    options?: PolicyQuoteBodyInputOptions[];
    /**
     * @description Additional quote components and percentages
    */
    additionalQuoteComponentsAndPercentages?: ManualQuoteComponentsAndPercentagesDto;
    /**
     * @description Manual component values as a flat { componentId: value } map for config-driven manual components.
    */
    manualComponentValues?: ManualComponentValuesDto;
    /**
     * @description Debug: force a quote to happen even if there are no changes to quote
     * @type boolean | undefined
    */
    skipValidation?: boolean;
    /**
     * @description Insurer to quote a new business on, among the product\'s new-business insurers. Defaults to the insurer the branch is already quoted on.
    */
    insurer?: Insurer;
    /**
     * @description Brokerage fees to calculate quote with
     * @type array | undefined
    */
    brokerageFeesOverride?: BrokerageFeeOnPolicy[];
    /**
     * @description Policy period duration value to calculate quote with
    */
    periodDurationOverride?: Duration;
    /**
     * @description Custom fields you want to calculate quote with
     * @type array | undefined
    */
    customFieldsToOverride?: CustomFieldDto[];
    /**
     * @description The assets ids to quote
     * @type array | undefined
    */
    assetIds?: string[];
    /**
     * @description Decide if the quote should be prorated according to the invoicing frequency
     * @type boolean | undefined
    */
    prorated?: boolean;
};

export const priceBreakdownOutputDtoFrequencyEnum = {
    YEARLY: "YEARLY",
    HALF_YEARLY: "HALF_YEARLY",
    QUARTERLY: "QUARTERLY",
    MONTHLY: "MONTHLY",
    BIENNIAL: "BIENNIAL",
    WEEKLY: "WEEKLY"
} as const;

export type PriceBreakdownOutputDtoFrequencyEnumKey = (typeof priceBreakdownOutputDtoFrequencyEnum)[keyof typeof priceBreakdownOutputDtoFrequencyEnum];

export type PriceBreakdownOutputDto = {
    /**
     * @description Billing frequency from policy config
     * @type string
    */
    frequency: PriceBreakdownOutputDtoFrequencyEnumKey;
    /**
     * @description Full contract amounts (face value)
    */
    total: BreakdownAmounts;
    /**
     * @description Recurring amounts divided by frequency
    */
    recurring: BreakdownAmounts;
    /**
     * @description One-time amounts at face value
    */
    oneTime: BreakdownAmounts;
    /**
     * @description Configurable display lines computed from product priceBreakdownConfig
     * @type array | undefined
    */
    lines?: PriceBreakdownLineOutputDto[];
    /**
     * @description Configurable total display line
    */
    totalLine?: PriceBreakdownTotalOutputDto;
    /**
     * @description First invoice total display line
    */
    firstInvoiceTotal?: PriceBreakdownTotalOutputDto;
    /**
     * @description Renewal total display line
    */
    renewalTotal?: PriceBreakdownTotalOutputDto;
};

export type CalculatePolicyQuoteOutput = {
    /**
     * @type object | undefined
    */
    policy?: PolicyQuoteDto;
    /**
     * @type array | undefined
    */
    assets?: AssetQuoteDto[];
    /**
     * @description Custom fields computed by the pricing engine (e.g. Excel outputs)
     * @type object | undefined
    */
    outputCustomFields?: {
        /**
         * @type array | undefined
        */
        policyCustomFields?: CustomFieldDto[];
        /**
         * @type array | undefined
        */
        assetCustomFields?: CustomFieldDto[];
        /**
         * @type array | undefined
        */
        customerCustomFields?: CustomFieldDto[];
    };
    /**
     * @description Price breakdown computed from product priceBreakdown config
    */
    breakdown?: PriceBreakdownOutputDto;
};

export type InvalidStopReasonDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    reason: string;
};

export const invalidStopReasonErrorDtoCodeEnum = {
    INVALID_STOP_REASON: "INVALID_STOP_REASON"
} as const;

export type InvalidStopReasonErrorDtoCodeEnumKey = (typeof invalidStopReasonErrorDtoCodeEnum)[keyof typeof invalidStopReasonErrorDtoCodeEnum];

export type InvalidStopReasonErrorDto = {
    /**
     * @type string
    */
    code: InvalidStopReasonErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidStopReasonDto;
};

export type InvalidStopReasonDetailsDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type array
    */
    errors: InvalidCustomFieldsDetailsErrorsDto[];
};

export const invalidStopReasonDetailsErrorDtoCodeEnum = {
    INVALID_STOP_REASON_DETAILS: "INVALID_STOP_REASON_DETAILS"
} as const;

export type InvalidStopReasonDetailsErrorDtoCodeEnumKey = (typeof invalidStopReasonDetailsErrorDtoCodeEnum)[keyof typeof invalidStopReasonDetailsErrorDtoCodeEnum];

export type InvalidStopReasonDetailsErrorDto = {
    /**
     * @type string
    */
    code: InvalidStopReasonDetailsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidStopReasonDetailsDto;
};

export type FeatureNotImplementedDetailsDto = {
    /**
     * @type string
    */
    feature: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const featureNotImplementedErrorDtoCodeEnum = {
    FEATURE_NOT_IMPLEMENTED: "FEATURE_NOT_IMPLEMENTED"
} as const;

export type FeatureNotImplementedErrorDtoCodeEnumKey = (typeof featureNotImplementedErrorDtoCodeEnum)[keyof typeof featureNotImplementedErrorDtoCodeEnum];

export type FeatureNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: FeatureNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FeatureNotImplementedDetailsDto;
};

export type StopPolicyInputBody = {
    /**
     * @description Stop reason. The accepted values are defined per product; read them from the product configuration in `GET /config/{productId}`. An unlisted value fails with INVALID_STOP_REASON.
     * @type string
    */
    reason: string;
    /**
     * @description Extra fields the reason declares in the product configuration. The stop date goes under the reason\'s `appliedAtDate` key, as ISO 8601 with a UTC offset, e.g. `2026-11-17T00:00:00+01:00` for midnight in Paris; it is stored in UTC and a value without an offset fails with INVALID_STOP_REASON_DETAILS.
     * @type array | undefined
    */
    details?: CustomFieldDto[];
};

export type StopPolicyOutput = object;

export type RegisterAdditionalQuoteComponentsInputBody = {
    /**
     * @description additional quote components
     * @type array
    */
    additionalQuoteComponents: QuoteComponentDto[];
};

export type RegisterAdditionalQuoteComponentsOutput = object;

export type ConflictingAdditionalQuoteComponentDetailsDto = {
    /**
     * @type array
    */
    componentIds: any[][];
};

export const conflictingAdditionalQuoteComponentsErrorDtoCodeEnum = {
    CONFLICTING_ADDITIONAL_QUOTE_COMPONENTS: "CONFLICTING_ADDITIONAL_QUOTE_COMPONENTS"
} as const;

export type ConflictingAdditionalQuoteComponentsErrorDtoCodeEnumKey = (typeof conflictingAdditionalQuoteComponentsErrorDtoCodeEnum)[keyof typeof conflictingAdditionalQuoteComponentsErrorDtoCodeEnum];

export type ConflictingAdditionalQuoteComponentsErrorDto = {
    /**
     * @type string
    */
    code: ConflictingAdditionalQuoteComponentsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingAdditionalQuoteComponentDetailsDto;
};

export type UpdatePolicyQuoteInputBody = {
    /**
     * @type array | undefined
    */
    components?: ManualQuoteComponentDto[];
    /**
     * @type array | undefined
    */
    percentages?: ManualQuotePercentageDto[];
    /**
     * @description Manual component values (flat { componentId: value } map) to layer on top of the existing quote.
    */
    manualComponentValues?: ManualComponentValuesDto;
};

export type UpdatePolicyQuoteOutput = object;

export type SuspendPolicyOutput = object;

export type InvalidActivationDateDetailsDto = {
    /**
     * @type string, date-time
    */
    whenAt: string;
    /**
     * @type string, date-time
    */
    appliedAt: string;
};

export const invalidActivationDateErrorDtoCodeEnum = {
    INVALID_ACTIVATION_DATE: "INVALID_ACTIVATION_DATE"
} as const;

export type InvalidActivationDateErrorDtoCodeEnumKey = (typeof invalidActivationDateErrorDtoCodeEnum)[keyof typeof invalidActivationDateErrorDtoCodeEnum];

export type InvalidActivationDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidActivationDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidActivationDateDetailsDto;
};

export type InvalidDateStringDetailsDto = {
    /**
     * @type string
    */
    field: string;
    /**
     * @type string
    */
    context: string;
};

export const invalidDateStringErrorDtoCodeEnum = {
    INVALID_DATE_STRING: "INVALID_DATE_STRING"
} as const;

export type InvalidDateStringErrorDtoCodeEnumKey = (typeof invalidDateStringErrorDtoCodeEnum)[keyof typeof invalidDateStringErrorDtoCodeEnum];

export type InvalidDateStringErrorDto = {
    /**
     * @type string
    */
    code: InvalidDateStringErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDateStringDetailsDto;
};

export type ActivatePolicyInputBody = {
    /**
     * @description the date and time when the policy will be activated
     * @type string
    */
    appliedAt: string;
};

export type ActivatePolicyOutput = object;

export type InvalidCommissionFeeDetailsDto = {
    /**
     * @type string
    */
    product: string;
    /**
     * @type number
    */
    min: number;
    /**
     * @type number
    */
    max: number;
};

export const invalidCommissionRangeErrorDtoCodeEnum = {
    INVALID_COMMISSION_RANGE: "INVALID_COMMISSION_RANGE"
} as const;

export type InvalidCommissionRangeErrorDtoCodeEnumKey = (typeof invalidCommissionRangeErrorDtoCodeEnum)[keyof typeof invalidCommissionRangeErrorDtoCodeEnum];

export type InvalidCommissionRangeErrorDto = {
    /**
     * @type string
    */
    code: InvalidCommissionRangeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidCommissionFeeDetailsDto;
};

export type InvalidBrokerageFeeDto = {
    /**
     * @type number
    */
    min: number;
    /**
     * @type number
    */
    max: number;
    /**
     * @type number
    */
    attempted: number;
    /**
     * @type string | undefined
    */
    compensatedWith?: string;
};

export const invalidBrokerageFeeErrorDtoCodeEnum = {
    INVALID_BROKERAGE_FEE: "INVALID_BROKERAGE_FEE"
} as const;

export type InvalidBrokerageFeeErrorDtoCodeEnumKey = (typeof invalidBrokerageFeeErrorDtoCodeEnum)[keyof typeof invalidBrokerageFeeErrorDtoCodeEnum];

export type InvalidBrokerageFeeErrorDto = {
    /**
     * @type string
    */
    code: InvalidBrokerageFeeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBrokerageFeeDto;
};

export const invalidTotalBrokerageFeeErrorDtoCodeEnum = {
    INVALID_TOTAL_BROKERAGE_FEE: "INVALID_TOTAL_BROKERAGE_FEE"
} as const;

export type InvalidTotalBrokerageFeeErrorDtoCodeEnumKey = (typeof invalidTotalBrokerageFeeErrorDtoCodeEnum)[keyof typeof invalidTotalBrokerageFeeErrorDtoCodeEnum];

export type InvalidTotalBrokerageFeeErrorDto = {
    /**
     * @type string
    */
    code: InvalidTotalBrokerageFeeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBrokerageFeeDto;
};

export type SetPolicyFeesBody = {
    /**
     * @type array
    */
    fees: BrokerageFeeOnPolicy[];
};

export type SetPolicyFeesOutput = object;

export type ManualQuotePolicyInputBody = {
    /**
     * @type array | undefined
    */
    components?: ManualQuoteComponentDto[];
    /**
     * @type array | undefined
    */
    percentages?: ManualQuotePercentageDto[];
    /**
     * @description New simplified manual component values. Use this instead of components/percentages.
    */
    manualComponentValues?: ManualComponentValuesDto;
};

export type ManualQuotePolicyOutput = object;

export type OutputCustomFieldsDto = {
    /**
     * @description Policy custom fields computed from pricing
     * @type array
    */
    policyCustomFields: CustomFieldDto[];
    /**
     * @description Asset custom fields computed from pricing
     * @type array
    */
    assetCustomFields: CustomFieldDto[];
    /**
     * @description Customer custom fields computed from pricing
     * @type array
    */
    customerCustomFields: CustomFieldDto[];
};

export type ComputePricingOutput = {
    /**
     * @type object
    */
    policy: PolicyQuoteDto;
    /**
     * @type array
    */
    assets: AssetQuoteDto[];
    /**
     * @description Flat price breakdown
    */
    breakdown?: PriceBreakdownOutputDto;
    /**
     * @description Custom fields computed from pricing engine outputs
    */
    outputCustomFields?: OutputCustomFieldsDto;
};

export type SavePricingSelectionInputBody = {
    /**
     * @description Tier ID, as returned in `GET /policies/{policyId}/available-pricing`. Tiers are computed per policy, so there is no fixed list.
     * @type string
    */
    tierId: string;
    /**
     * @description Policy-level custom fields to save
     * @type array | undefined
    */
    policyCustomFields?: CustomFieldDto[];
};

export type SavePricingSelectionOutput = {
    /**
     * @description Whether the selection was saved successfully
     * @type boolean
    */
    saved: boolean;
};

export type GetQuoteInputBody = {
    /**
     * @description Parent customer data
    */
    parentCustomer?: CustomerDto;
    /**
     * @description Parent policy data
    */
    parentPolicy?: PolicyDto;
    /**
     * @description Customer data
    */
    customer: CustomerDto;
    /**
     * @description Policy data
    */
    policy: PolicyDto;
    /**
     * @description Branch data
    */
    branch: BranchDto;
    /**
     * @description Number of renewals
     * @type number
    */
    nbOfRenewals: number;
    /**
     * @description Assets data
     * @type array
    */
    assets: AssetDto[];
    /**
     * @type array
    */
    options: AssetQuoteOptionsDto[];
    /**
     * @description Additional quote components
    */
    additionalQuoteComponentsAndPercentages?: ManualQuoteComponentsAndPercentagesDto;
    /**
     * @description Simplified manual component values as a flat { componentId: value } map. Used by resolveManualComponents for config-driven manual components.
    */
    manualComponentValues?: ManualComponentValuesDto;
    /**
     * @description Whether to store external quote data
     * @type boolean
    */
    storeExternalQuote: boolean;
};

export type GetQuoteOutput = {
    /**
     * @type object
    */
    policy: PolicyQuoteDto;
    /**
     * @type array
    */
    assets: AssetQuoteDto[];
};

export type GetExternalQuoteOutput = {
    /**
     * @type object
    */
    externalQuoteId: object;
    /**
     * @type object
    */
    data: object;
};

export type FinalizeRenewalBranchOutput = object;

export const reportDtoTypeEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated",
    generated: "generated"
} as const;

export type ReportDtoTypeEnumKey = (typeof reportDtoTypeEnum)[keyof typeof reportDtoTypeEnum];

export type ReportDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description The stored document role.
     * @type string
    */
    type: ReportDtoTypeEnumKey | null;
    /**
     * @description The stored document category, or null while unclassified.
     * @type string
    */
    category: string | null;
    /**
     * @description the id of the document
     * @type string
    */
    id: string;
    /**
     * @description the name of the document
     * @type string
    */
    name: string;
    /**
     * @description the path of the document on the Korint CDN
     * @type string
    */
    path: string;
    /**
     * @description the date of creation of the document
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description the signed url to download the document
     * @type string
    */
    signedUrl: string;
};

export type GetReportsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ReportDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const checkDescriptorDtoTagEnum = {
    error: "error",
    warn: "warn",
    "wip-active": "wip-active",
    "wip-inactive": "wip-inactive"
} as const;

export type CheckDescriptorDtoTagEnumKey = (typeof checkDescriptorDtoTagEnum)[keyof typeof checkDescriptorDtoTagEnum];

export type CheckDescriptorDto = {
    /**
     * @description The check id, e.g. policy.started-expired
     * @type string
    */
    id: string;
    /**
     * @description The check domain, e.g. policy
     * @type string
    */
    domain: string;
    /**
     * @description The scan scope this check runs in, e.g. billing. Entity filters apply across scopes through related policies and customers.
     * @type string
    */
    scope: string;
    /**
     * @description Display tag of the check: error, warn, wip-active or wip-inactive
     * @type string
    */
    tag: CheckDescriptorDtoTagEnumKey;
    /**
     * @description Human-readable explanation of what the check flags
     * @type string
    */
    description: string;
};

export type ListChecksOutput = {
    /**
     * @type array
    */
    checks: CheckDescriptorDto[];
};

export type InvalidReportParamsDetailsDto = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type array
    */
    errors: InvalidCustomFieldsDetailsErrorsDto[];
};

export const invalidReportParamsErrorDtoCodeEnum = {
    INVALID_REPORT_PARAMS: "INVALID_REPORT_PARAMS"
} as const;

export type InvalidReportParamsErrorDtoCodeEnumKey = (typeof invalidReportParamsErrorDtoCodeEnum)[keyof typeof invalidReportParamsErrorDtoCodeEnum];

export type InvalidReportParamsErrorDto = {
    /**
     * @type string
    */
    code: InvalidReportParamsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidReportParamsDetailsDto;
};

export const generateReportInputBodyTypeEnum = {
    WORKFLOWS: "WORKFLOWS",
    POLICY_EXPORT: "POLICY_EXPORT",
    INVOICE_EXPORT: "INVOICE_EXPORT",
    BROKERAGE_FIRM_EXPORT: "BROKERAGE_FIRM_EXPORT",
    CLAIMS_EXPORT: "CLAIMS_EXPORT",
    COMMISSION_TRANSFER: "COMMISSION_TRANSFER",
    COMMISSION_TRANSFER_DETAIL: "COMMISSION_TRANSFER_DETAIL",
    YEET_VTC_IMA_ASSISTANCE: "YEET_VTC_IMA_ASSISTANCE",
    YEET_VTC_CASH_STATEMENT: "YEET_VTC_CASH_STATEMENT",
    YEET_VTC_POLICIES_V2: "YEET_VTC_POLICIES_V2",
    YEET_VTC_POLICY_PARTY: "YEET_VTC_POLICY_PARTY",
    YEET_VTC_KPI: "YEET_VTC_KPI",
    YEET_VTC_POLICY_INVOICE: "YEET_VTC_POLICY_INVOICE",
    YEET_VTC_POLICY_INVOICE_WAKAM: "YEET_VTC_POLICY_INVOICE_WAKAM",
    YEET_FVA_EXPORT: "YEET_FVA_EXPORT",
    YEET_STARTED_UNPAID_POLICIES: "YEET_STARTED_UNPAID_POLICIES",
    GARANTIE_PLUS_SALES_REPORT: "GARANTIE_PLUS_SALES_REPORT",
    GARANTIE_PLUS_SALES_RECAP_BY_GARAGE: "GARANTIE_PLUS_SALES_RECAP_BY_GARAGE",
    GARANTIE_PLUS_CAREA_CASH_STATEMENT: "GARANTIE_PLUS_CAREA_CASH_STATEMENT",
    GARANTIE_PLUS_CAAREA_DAILY_REPORT: "GARANTIE_PLUS_CAAREA_DAILY_REPORT",
    AXECE_POLICY: "AXECE_POLICY",
    AXECE_POLICY_INVOICE: "AXECE_POLICY_INVOICE",
    AXECE_POLICY_PARTY: "AXECE_POLICY_PARTY",
    AXECE_KPI: "AXECE_KPI",
    AXECE_MRPRO_KPI: "AXECE_MRPRO_KPI",
    AXECE_POLICY_INVOICE_WAKAM: "AXECE_POLICY_INVOICE_WAKAM",
    AXECE_VTC_IMA_ASSISTANCE: "AXECE_VTC_IMA_ASSISTANCE",
    AXECE_COMMISSION: "AXECE_COMMISSION",
    AXECE_BROKERAGE_FIRM_POLICIES: "AXECE_BROKERAGE_FIRM_POLICIES",
    AXECE_CASH_STATEMENT: "AXECE_CASH_STATEMENT",
    AXECE_MRPRO_POLICY: "AXECE_MRPRO_POLICY",
    AXECE_FVA_EXPORT: "AXECE_FVA_EXPORT",
    AXECE_STARTED_UNPAID_POLICIES: "AXECE_STARTED_UNPAID_POLICIES",
    ACCELERANT_VTC_IMA_ASSISTANCE: "ACCELERANT_VTC_IMA_ASSISTANCE",
    TUTASSUR_MILA_PNO_ASSUREUR_EXPORT: "TUTASSUR_MILA_PNO_ASSUREUR_EXPORT",
    TUTASSUR_MILA_MRH_ASSUREUR_EXPORT: "TUTASSUR_MILA_MRH_ASSUREUR_EXPORT",
    TUTASSUR_AXA_PORTFOLIO_EXPORT: "TUTASSUR_AXA_PORTFOLIO_EXPORT",
    TUTASSUR_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_COMPANY_STATEMENT: "TUTASSUR_COMPANY_STATEMENT",
    TUTASSUR_BROKER_STATEMENT: "TUTASSUR_BROKER_STATEMENT",
    TUTASSUR_CASH_STATEMENT: "TUTASSUR_CASH_STATEMENT",
    TUTASSUR_HISCOX_COLLECTED_PREMIUMS: "TUTASSUR_HISCOX_COLLECTED_PREMIUMS",
    TUTASSUR_HISCOX_UNPAID_PREMIUMS: "TUTASSUR_HISCOX_UNPAID_PREMIUMS",
    TUTASSUR_HISCOX_BORDEREAU_PRODUCTION: "TUTASSUR_HISCOX_BORDEREAU_PRODUCTION",
    TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_PJPRO_CFDP_MTA_EXPORT: "TUTASSUR_PJPRO_CFDP_MTA_EXPORT",
    TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT: "TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT",
    EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_ACCOUNTING_STATEMENT: "EGA_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT",
    EGA_RCPRO_ACCOUNTING_STATEMENT: "EGA_RCPRO_ACCOUNTING_STATEMENT",
    EGA_RCPRO_MADP_EXPORT: "EGA_RCPRO_MADP_EXPORT",
    EGA_CASH_STATEMENT: "EGA_CASH_STATEMENT",
    EGA_RETAIL_PERFORMANCE: "EGA_RETAIL_PERFORMANCE",
    EGA_TEAM_PERFORMANCE: "EGA_TEAM_PERFORMANCE",
    LUKO_MRH_POLICY: "LUKO_MRH_POLICY",
    LUKO_MRH_POLICY_INVOICE_WAKAM: "LUKO_MRH_POLICY_INVOICE_WAKAM",
    LUKO_MRH_POLICY_PAYMENT_WAKAM: "LUKO_MRH_POLICY_PAYMENT_WAKAM",
    LUKO_MRH_KPI: "LUKO_MRH_KPI",
    LUKO_CASH_STATEMENT: "LUKO_CASH_STATEMENT",
    ASSUREQUINE_CASH_STATEMENT: "ASSUREQUINE_CASH_STATEMENT",
    ASSUREQUINE_PORTFOLIO_STATEMENT: "ASSUREQUINE_PORTFOLIO_STATEMENT",
    ASSUREQUINE_PREMIUM_STATEMENT: "ASSUREQUINE_PREMIUM_STATEMENT",
    ARCHIMEDE_CFDP_MSG002_STOCK: "ARCHIMEDE_CFDP_MSG002_STOCK",
    ARCHIMEDE_CFDP_MSG002_STOCK_CSV: "ARCHIMEDE_CFDP_MSG002_STOCK_CSV",
    PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT: "PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT",
    PLEBAGNAC_CFDP_STATEMENT: "PLEBAGNAC_CFDP_STATEMENT",
    PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT: "PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT",
    PLEBAGNAC_MSC_SCOOTER_STATEMENT: "PLEBAGNAC_MSC_SCOOTER_STATEMENT",
    PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT: "PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT"
} as const;

export type GenerateReportInputBodyTypeEnumKey = (typeof generateReportInputBodyTypeEnum)[keyof typeof generateReportInputBodyTypeEnum];

export type GenerateReportInputBody = {
    /**
     * @description The type of report
     * @type string
    */
    type: GenerateReportInputBodyTypeEnumKey;
    /**
     * @description Report specific parameters
     * @type array
    */
    params: Metadata[];
    /**
     * @description uploadToConnectors
     * @type boolean | undefined
    */
    uploadToConnectors?: boolean;
    /**
     * @description The productIds
     * @type array | undefined
    */
    productIds?: string[];
};

export const generateReportOutputTypeEnum = {
    WORKFLOWS: "WORKFLOWS",
    POLICY_EXPORT: "POLICY_EXPORT",
    INVOICE_EXPORT: "INVOICE_EXPORT",
    BROKERAGE_FIRM_EXPORT: "BROKERAGE_FIRM_EXPORT",
    CLAIMS_EXPORT: "CLAIMS_EXPORT",
    COMMISSION_TRANSFER: "COMMISSION_TRANSFER",
    COMMISSION_TRANSFER_DETAIL: "COMMISSION_TRANSFER_DETAIL",
    YEET_VTC_IMA_ASSISTANCE: "YEET_VTC_IMA_ASSISTANCE",
    YEET_VTC_CASH_STATEMENT: "YEET_VTC_CASH_STATEMENT",
    YEET_VTC_POLICIES_V2: "YEET_VTC_POLICIES_V2",
    YEET_VTC_POLICY_PARTY: "YEET_VTC_POLICY_PARTY",
    YEET_VTC_KPI: "YEET_VTC_KPI",
    YEET_VTC_POLICY_INVOICE: "YEET_VTC_POLICY_INVOICE",
    YEET_VTC_POLICY_INVOICE_WAKAM: "YEET_VTC_POLICY_INVOICE_WAKAM",
    YEET_FVA_EXPORT: "YEET_FVA_EXPORT",
    YEET_STARTED_UNPAID_POLICIES: "YEET_STARTED_UNPAID_POLICIES",
    GARANTIE_PLUS_SALES_REPORT: "GARANTIE_PLUS_SALES_REPORT",
    GARANTIE_PLUS_SALES_RECAP_BY_GARAGE: "GARANTIE_PLUS_SALES_RECAP_BY_GARAGE",
    GARANTIE_PLUS_CAREA_CASH_STATEMENT: "GARANTIE_PLUS_CAREA_CASH_STATEMENT",
    GARANTIE_PLUS_CAAREA_DAILY_REPORT: "GARANTIE_PLUS_CAAREA_DAILY_REPORT",
    AXECE_POLICY: "AXECE_POLICY",
    AXECE_POLICY_INVOICE: "AXECE_POLICY_INVOICE",
    AXECE_POLICY_PARTY: "AXECE_POLICY_PARTY",
    AXECE_KPI: "AXECE_KPI",
    AXECE_MRPRO_KPI: "AXECE_MRPRO_KPI",
    AXECE_POLICY_INVOICE_WAKAM: "AXECE_POLICY_INVOICE_WAKAM",
    AXECE_VTC_IMA_ASSISTANCE: "AXECE_VTC_IMA_ASSISTANCE",
    AXECE_COMMISSION: "AXECE_COMMISSION",
    AXECE_BROKERAGE_FIRM_POLICIES: "AXECE_BROKERAGE_FIRM_POLICIES",
    AXECE_CASH_STATEMENT: "AXECE_CASH_STATEMENT",
    AXECE_MRPRO_POLICY: "AXECE_MRPRO_POLICY",
    AXECE_FVA_EXPORT: "AXECE_FVA_EXPORT",
    AXECE_STARTED_UNPAID_POLICIES: "AXECE_STARTED_UNPAID_POLICIES",
    ACCELERANT_VTC_IMA_ASSISTANCE: "ACCELERANT_VTC_IMA_ASSISTANCE",
    TUTASSUR_MILA_PNO_ASSUREUR_EXPORT: "TUTASSUR_MILA_PNO_ASSUREUR_EXPORT",
    TUTASSUR_MILA_MRH_ASSUREUR_EXPORT: "TUTASSUR_MILA_MRH_ASSUREUR_EXPORT",
    TUTASSUR_AXA_PORTFOLIO_EXPORT: "TUTASSUR_AXA_PORTFOLIO_EXPORT",
    TUTASSUR_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_COMPANY_STATEMENT: "TUTASSUR_COMPANY_STATEMENT",
    TUTASSUR_BROKER_STATEMENT: "TUTASSUR_BROKER_STATEMENT",
    TUTASSUR_CASH_STATEMENT: "TUTASSUR_CASH_STATEMENT",
    TUTASSUR_HISCOX_COLLECTED_PREMIUMS: "TUTASSUR_HISCOX_COLLECTED_PREMIUMS",
    TUTASSUR_HISCOX_UNPAID_PREMIUMS: "TUTASSUR_HISCOX_UNPAID_PREMIUMS",
    TUTASSUR_HISCOX_BORDEREAU_PRODUCTION: "TUTASSUR_HISCOX_BORDEREAU_PRODUCTION",
    TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_PJPRO_CFDP_MTA_EXPORT: "TUTASSUR_PJPRO_CFDP_MTA_EXPORT",
    TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT: "TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT",
    EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_ACCOUNTING_STATEMENT: "EGA_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT",
    EGA_RCPRO_ACCOUNTING_STATEMENT: "EGA_RCPRO_ACCOUNTING_STATEMENT",
    EGA_RCPRO_MADP_EXPORT: "EGA_RCPRO_MADP_EXPORT",
    EGA_CASH_STATEMENT: "EGA_CASH_STATEMENT",
    EGA_RETAIL_PERFORMANCE: "EGA_RETAIL_PERFORMANCE",
    EGA_TEAM_PERFORMANCE: "EGA_TEAM_PERFORMANCE",
    LUKO_MRH_POLICY: "LUKO_MRH_POLICY",
    LUKO_MRH_POLICY_INVOICE_WAKAM: "LUKO_MRH_POLICY_INVOICE_WAKAM",
    LUKO_MRH_POLICY_PAYMENT_WAKAM: "LUKO_MRH_POLICY_PAYMENT_WAKAM",
    LUKO_MRH_KPI: "LUKO_MRH_KPI",
    LUKO_CASH_STATEMENT: "LUKO_CASH_STATEMENT",
    ASSUREQUINE_CASH_STATEMENT: "ASSUREQUINE_CASH_STATEMENT",
    ASSUREQUINE_PORTFOLIO_STATEMENT: "ASSUREQUINE_PORTFOLIO_STATEMENT",
    ASSUREQUINE_PREMIUM_STATEMENT: "ASSUREQUINE_PREMIUM_STATEMENT",
    ARCHIMEDE_CFDP_MSG002_STOCK: "ARCHIMEDE_CFDP_MSG002_STOCK",
    ARCHIMEDE_CFDP_MSG002_STOCK_CSV: "ARCHIMEDE_CFDP_MSG002_STOCK_CSV",
    PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT: "PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT",
    PLEBAGNAC_CFDP_STATEMENT: "PLEBAGNAC_CFDP_STATEMENT",
    PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT: "PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT",
    PLEBAGNAC_MSC_SCOOTER_STATEMENT: "PLEBAGNAC_MSC_SCOOTER_STATEMENT",
    PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT: "PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT"
} as const;

export type GenerateReportOutputTypeEnumKey = (typeof generateReportOutputTypeEnum)[keyof typeof generateReportOutputTypeEnum];

export type GenerateReportOutput = {
    /**
     * @description The type of report
     * @type string
    */
    type: GenerateReportOutputTypeEnumKey;
    /**
     * @type string
    */
    reportId: string;
    /**
     * @type string
    */
    reportName: string;
};

export const reportParamConfigDtoTypeEnum = {
    BOOLEAN: "BOOLEAN",
    STRING: "STRING",
    NUMBER: "NUMBER",
    INTEGER: "INTEGER",
    ENUM: "ENUM",
    DATE: "DATE",
    DATETIME: "DATETIME",
    PHONE_NUMBER: "PHONE_NUMBER",
    EMAIL: "EMAIL",
    REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
    SIRET: "SIRET",
    POSTCODE: "POSTCODE",
    URL: "URL",
    IBAN: "IBAN",
    BIC: "BIC",
    ARRAY: "ARRAY"
} as const;

export type ReportParamConfigDtoTypeEnumKey = (typeof reportParamConfigDtoTypeEnum)[keyof typeof reportParamConfigDtoTypeEnum];

export type ReportParamConfigDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    type: ReportParamConfigDtoTypeEnumKey;
    /**
     * @type array | undefined
    */
    validationRules?: ValidationRuleDto[];
    /**
     * @type string | undefined
    */
    defaultValue?: string;
    /**
     * @type boolean | undefined
    */
    required?: boolean;
};

export type GetReportConfigOutput = {
    /**
     * @type array
    */
    availableProductIds: string[];
    /**
     * @type array
    */
    params: ReportParamConfigDto[];
};

export type GetReportsInputBody = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description the query to search for
    */
    query: MetadataSearch;
    /**
     * @type boolean | undefined
    */
    omitDebugReports?: boolean;
};

export type OpEquals = {
    equals: (string | number | boolean | string);
};

export type OpGt = {
    gt: (string | number | boolean | string);
};

export type OpLt = {
    lt: (string | number | boolean | string);
};

export type OpGte = {
    gte: (string | number | boolean | string);
};

export type OpLte = {
    lte: (string | number | boolean | string);
};

export type OpContains = {
    /**
     * @type string
    */
    contains: string;
};

export type OpStartsWith = {
    /**
     * @type string
    */
    startsWith: string;
};

export type OpEndsWith = {
    /**
     * @type string
    */
    endsWith: string;
};

export type OpIn = {
    /**
     * @type array
    */
    in: (string | number | boolean | string)[];
};

export type PropertyCondition = {
    /**
     * @description Search all branches regardless of their type and status. false = look only at BASE branch
     * @default true
     * @type boolean | undefined
    */
    includeAllBranches?: boolean;
    /**
     * @default false
     * @type boolean | undefined
    */
    excludeBaseBranch?: boolean;
    /**
     * @description This timezone is used in case no offset is specified in date filters values (ex: if 2021-01-01 or 2021-01-01T00:00:00 are provided, the timezone option is used to convert it to a UTC date)
     * @default "UTC"
     * @type string | undefined
    */
    timeZone?: string;
    /**
     * @description [EXPERIMENTAL] The number of relations text search filters are checked against (exponential impact on performances)
     * @minLength 0
     * @maxLength 3
     * @default 0
     * @type number | undefined
    */
    textSearchDepth?: number;
    /**
     * @type string
    */
    property: string;
    value: (OpEquals | OpGt | OpLt | OpGte | OpLte | OpContains | OpStartsWith | OpEndsWith | OpIn);
};

export type RelationCondition = {
    /**
     * @description Search all branches regardless of their type and status. false = look only at BASE branch
     * @default true
     * @type boolean | undefined
    */
    includeAllBranches?: boolean;
    /**
     * @default false
     * @type boolean | undefined
    */
    excludeBaseBranch?: boolean;
    /**
     * @description This timezone is used in case no offset is specified in date filters values (ex: if 2021-01-01 or 2021-01-01T00:00:00 are provided, the timezone option is used to convert it to a UTC date)
     * @default "UTC"
     * @type string | undefined
    */
    timeZone?: string;
    /**
     * @description [EXPERIMENTAL] The number of relations text search filters are checked against (exponential impact on performances)
     * @minLength 0
     * @maxLength 3
     * @default 0
     * @type number | undefined
    */
    textSearchDepth?: number;
    /**
     * @type string
    */
    property: string;
    /**
     * @type object | undefined
    */
    every?: LogicalCondition;
    /**
     * @type object | undefined
    */
    some?: LogicalCondition;
    /**
     * @type object | undefined
    */
    none?: LogicalCondition;
    /**
     * @type string | undefined
    */
    id?: string;
    /**
     * @type array | undefined
    */
    ids?: string[];
};

export const fullTextSearchConditionMatchModeEnum = {
    contains: "contains",
    startsWith: "startsWith"
} as const;

export type FullTextSearchConditionMatchModeEnumKey = (typeof fullTextSearchConditionMatchModeEnum)[keyof typeof fullTextSearchConditionMatchModeEnum];

export type FullTextSearchCondition = {
    /**
     * @description Search all branches regardless of their type and status. false = look only at BASE branch
     * @default true
     * @type boolean | undefined
    */
    includeAllBranches?: boolean;
    /**
     * @default false
     * @type boolean | undefined
    */
    excludeBaseBranch?: boolean;
    /**
     * @description This timezone is used in case no offset is specified in date filters values (ex: if 2021-01-01 or 2021-01-01T00:00:00 are provided, the timezone option is used to convert it to a UTC date)
     * @default "UTC"
     * @type string | undefined
    */
    timeZone?: string;
    /**
     * @description [EXPERIMENTAL] The number of relations text search filters are checked against (exponential impact on performances)
     * @minLength 0
     * @maxLength 3
     * @default 0
     * @type number | undefined
    */
    textSearchDepth?: number;
    /**
     * @type string | undefined
    */
    property?: string;
    /**
     * @type array | undefined
    */
    properties?: string[];
    /**
     * @default "contains"
     * @type string | undefined
    */
    matchMode?: FullTextSearchConditionMatchModeEnumKey;
    /**
     * @type array | undefined
    */
    everyWords?: string[];
    /**
     * @type array | undefined
    */
    someWords?: string[];
    /**
     * @type array | undefined
    */
    noneWords?: string[];
};

export type CorrelatedBranchCondition = {
    /**
     * @type array
    */
    onSameBranch: PropertyCondition[];
};

export type LogicalCondition = {
    /**
     * @type array | undefined
    */
    AND?: (PropertyCondition | RelationCondition | LogicalCondition | FullTextSearchCondition | CorrelatedBranchCondition)[];
    /**
     * @type array | undefined
    */
    OR?: (PropertyCondition | RelationCondition | LogicalCondition | FullTextSearchCondition | CorrelatedBranchCondition)[];
};

export const generateCustomReportInputBodyEntityTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type GenerateCustomReportInputBodyEntityTypeEnumKey = (typeof generateCustomReportInputBodyEntityTypeEnum)[keyof typeof generateCustomReportInputBodyEntityTypeEnum];

export type GenerateCustomReportInputBody = {
    /**
     * @type string
    */
    entityType: GenerateCustomReportInputBodyEntityTypeEnumKey;
    /**
     * @type array | undefined
    */
    fields?: string[];
    /**
     * @type object
    */
    where: LogicalCondition;
    /**
     * @description CSV file name, without the extension
     * @type string | undefined
    */
    name?: string;
};

export type GenerateCustomReportOutput = {
    /**
     * @description Presigned S3 URL that downloads the CSV directly, bypassing the API payload limit. Expires after an hour.
     * @type string
    */
    downloadUrl: string;
};

export type RepricingDispatchOutput = {
    /**
     * @type string
    */
    workflowRunId: string;
};

export const propertySortDirectionEnum = {
    asc: "asc",
    desc: "desc"
} as const;

export type PropertySortDirectionEnumKey = (typeof propertySortDirectionEnum)[keyof typeof propertySortDirectionEnum];

export type PropertySort = {
    /**
     * @type string
    */
    property: string;
    /**
     * @type string | undefined
    */
    direction?: PropertySortDirectionEnumKey;
};

export const searchInputBodyEntityTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type SearchInputBodyEntityTypeEnumKey = (typeof searchInputBodyEntityTypeEnum)[keyof typeof searchInputBodyEntityTypeEnum];

export type SearchInputBody = {
    /**
     * @description Search all branches regardless of their type and status. false = look only at BASE branch
     * @default true
     * @type boolean | undefined
    */
    includeAllBranches?: boolean;
    /**
     * @default false
     * @type boolean | undefined
    */
    excludeBaseBranch?: boolean;
    /**
     * @description This timezone is used in case no offset is specified in date filters values (ex: if 2021-01-01 or 2021-01-01T00:00:00 are provided, the timezone option is used to convert it to a UTC date)
     * @default "UTC"
     * @type string | undefined
    */
    timeZone?: string;
    /**
     * @description [EXPERIMENTAL] The number of relations text search filters are checked against (exponential impact on performances)
     * @minLength 0
     * @maxLength 3
     * @default 0
     * @type number | undefined
    */
    textSearchDepth?: number;
    /**
     * @type string
    */
    entityType: SearchInputBodyEntityTypeEnumKey;
    /**
     * @type object | undefined
    */
    orderBy?: PropertySort;
    /**
     * @type array | undefined
    */
    fields?: string[];
    /**
     * @type object
    */
    where: LogicalCondition;
    /**
     * @description Filter to a single tenant. Super-user only; ignored for regular users.
     * @type string | undefined
    */
    filterTenantId?: string;
};

export type SearchResultProperty = {
    /**
     * @type string
    */
    property: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    value: (string | number | boolean | string);
};

export const searchResultEntityEntityTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type SearchResultEntityEntityTypeEnumKey = (typeof searchResultEntityEntityTypeEnum)[keyof typeof searchResultEntityEntityTypeEnum];

export type SearchResultEntity = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @type string
    */
    entityType: SearchResultEntityEntityTypeEnumKey;
    /**
     * @type array | undefined
    */
    properties?: SearchResultProperty[];
    /**
     * @type array | undefined
    */
    relations?: SearchResultRelation[];
};

export type SearchResultRelation = {
    /**
     * @type string
    */
    property: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type object
    */
    entity: SearchResultEntity;
};

export type SearchOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: SearchResultEntity[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ConfigurableSearchProperty = {
    /**
     * @type string
    */
    property: string;
    /**
     * @type string
    */
    value: string;
};

export type ConfigurableSearchInputBody = {
    /**
     * @type array
    */
    search: ConfigurableSearchProperty[];
};

export type ConfigurableSearchOutput = {
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
    /**
     * @description Array of generic search result objects
     * @type array
    */
    data: object[];
};

export const countInputBodyEntityTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type CountInputBodyEntityTypeEnumKey = (typeof countInputBodyEntityTypeEnum)[keyof typeof countInputBodyEntityTypeEnum];

export type CountInputBody = {
    /**
     * @description Search all branches regardless of their type and status. false = look only at BASE branch
     * @default true
     * @type boolean | undefined
    */
    includeAllBranches?: boolean;
    /**
     * @default false
     * @type boolean | undefined
    */
    excludeBaseBranch?: boolean;
    /**
     * @description This timezone is used in case no offset is specified in date filters values (ex: if 2021-01-01 or 2021-01-01T00:00:00 are provided, the timezone option is used to convert it to a UTC date)
     * @default "UTC"
     * @type string | undefined
    */
    timeZone?: string;
    /**
     * @description [EXPERIMENTAL] The number of relations text search filters are checked against (exponential impact on performances)
     * @minLength 0
     * @maxLength 3
     * @default 0
     * @type number | undefined
    */
    textSearchDepth?: number;
    /**
     * @type string
    */
    entityType: CountInputBodyEntityTypeEnumKey;
    /**
     * @type object
    */
    where: LogicalCondition;
};

export type CountOutput = {
    /**
     * @type number
    */
    count: number;
};

export type SuggestOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: string[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ReindexAllCollectionsInputBody = {
    /**
     * @type boolean | undefined
    */
    test?: boolean;
    /**
     * @type array | undefined
    */
    collections?: string[];
    /**
     * @type array | undefined
    */
    entityIds?: string[];
};

export type ReindexAllCollectionsOutput = object;

export type ReindexAllInputBody = {
    /**
     * @type boolean | undefined
    */
    test?: boolean;
    /**
     * @type array | undefined
    */
    collections?: string[];
    /**
     * @type array | undefined
    */
    entityIds?: string[];
};

export type ReindexAllOutput = object;

export type UpdateSignatureSignedStatusOutput = object;

export type YousignSecurityCheckOutputDto = object;

export type SignatureDocumentAnchor = {
    /**
     * @description the page of the anchor
     * @type object
    */
    page: object;
    /**
     * @description the x position of the anchor
     * @type number
    */
    x: number;
    /**
     * @description the y position of the anchor
     * @type number
    */
    y: number;
    /**
     * @description the height of the anchor
     * @type number
    */
    height: number;
    /**
     * @description the width of the anchor
     * @type number
    */
    width: number;
};

export type SignerDocumentField = {
    /**
     * @description the id of the document these fields apply to
     * @type string
    */
    documentId: string;
    /**
     * @description the anchor configuration
    */
    anchor?: SignatureDocumentAnchor;
    /**
     * @description the mentions to add to the document
     * @type array | undefined
    */
    mentions?: string[];
    /**
     * @description the texts to add to the document
     * @type array | undefined
    */
    texts?: string[];
    /**
     * @description the checkboxes to add to the document
     * @type array | undefined
    */
    checkboxes?: string[];
};

export const signatureSignerStatusEnum = {
    PENDING: "PENDING",
    SIGNED: "SIGNED",
    DECLINED: "DECLINED",
    ERROR: "ERROR"
} as const;

export type SignatureSignerStatusEnumKey = (typeof signatureSignerStatusEnum)[keyof typeof signatureSignerStatusEnum];

export type SignatureSigner = {
    /**
     * @description the id of the signer
     * @type string
    */
    customerId: string;
    /**
     * @description the first name of the signer
     * @type string
    */
    firstName: string;
    /**
     * @description the last name of the signer
     * @type string
    */
    lastName: string;
    /**
     * @description the email of the signer
     * @type string
    */
    email: string;
    /**
     * @description the phone number of the signer
     * @type string
    */
    phoneNumber: string;
    /**
     * @description the id of the signer in yousign
     * @type string | undefined
    */
    yousignId?: string;
    /**
     * @description the signing status of this signer
     * @type string | undefined
    */
    status?: SignatureSignerStatusEnumKey;
    /**
     * @description per-document fields for this signer
     * @type array | undefined
    */
    documentFields?: SignerDocumentField[];
};

export const signatureDocumentTypeEnum = {
    ATTACHMENT: "ATTACHMENT",
    SIGNABLE_DOCUMENT: "SIGNABLE_DOCUMENT"
} as const;

export type SignatureDocumentTypeEnumKey = (typeof signatureDocumentTypeEnum)[keyof typeof signatureDocumentTypeEnum];

export type SignatureDocument = {
    /**
     * @description the id of the document
     * @type string
    */
    id: string;
    /**
     * @description the type of the document
     * @type string
    */
    type: SignatureDocumentTypeEnumKey;
};

export const signatureRequestDeliveryModeEnum = {
    EMAIL: "EMAIL",
    NONE: "NONE"
} as const;

export type SignatureRequestDeliveryModeEnumKey = (typeof signatureRequestDeliveryModeEnum)[keyof typeof signatureRequestDeliveryModeEnum];

export const signatureRequestStatusEnum = {
    PENDING: "PENDING",
    SIGNED: "SIGNED",
    CANCELLED: "CANCELLED"
} as const;

export type SignatureRequestStatusEnumKey = (typeof signatureRequestStatusEnum)[keyof typeof signatureRequestStatusEnum];

export type SignatureRequest = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the id of the signature request
     * @type string
    */
    id: string;
    /**
     * @description the name of the signature request
     * @type string
    */
    name: string;
    /**
     * @description the delivery mode of the signature request
     * @type string
    */
    deliveryMode: SignatureRequestDeliveryModeEnumKey;
    /**
     * @description the external id of the entity linked to this signature request
     * @type string
    */
    externalId: string;
    /**
     * @description the signers info
     * @type array
    */
    signers: SignatureSigner[];
    /**
     * @description the documents to attach on the signature
     * @type array
    */
    documents: SignatureDocument[];
    /**
     * @description the status of the signature request
     * @type string | undefined, date-time
    */
    signedAt?: string;
    /**
     * @description the status of the signature request
     * @type string
    */
    status: SignatureRequestStatusEnumKey;
    /**
     * @description if the signature request is an otp one or not
     * @type boolean | undefined
    */
    isOtp?: boolean;
    /**
     * @type object | undefined
    */
    reminderSettings?: SignatureRequestReminderSettings;
    /**
     * @description the creation date of the signature request
     * @type string | undefined, date-time
    */
    createdAt?: string;
};

export type GetSignatureRequestsByExternalIdOutput = {
    /**
     * @description the signature requests
     * @type array
    */
    signatureRequests: SignatureRequest[];
};

export type GetSignerLinkOutput = {
    /**
     * @description the signature link for the signer
     * @type string
    */
    url: string;
    /**
     * @description the expiration date of the link
     * @type string | undefined
    */
    expiresAt?: string;
};

export type ResendSignatureReminderOutput = {
    /**
     * @description the number of signers who were sent a reminder
     * @type number
    */
    remindedSigners: number;
};

export type InvalidSiretDetailsDto = {
    /**
     * @type string
    */
    siret: string;
};

export const invalidCustomerSiretErrorDtoCodeEnum = {
    INVALID_CUSTOMER_SIRET: "INVALID_CUSTOMER_SIRET"
} as const;

export type InvalidCustomerSiretErrorDtoCodeEnumKey = (typeof invalidCustomerSiretErrorDtoCodeEnum)[keyof typeof invalidCustomerSiretErrorDtoCodeEnum];

export type InvalidCustomerSiretErrorDto = {
    /**
     * @type string
    */
    code: InvalidCustomerSiretErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidSiretDetailsDto;
};

export type InvalidSirenDetailsDto = {
    /**
     * @type string
    */
    siren: string;
};

export const invalidCustomerSirenErrorDtoCodeEnum = {
    INVALID_CUSTOMER_SIREN: "INVALID_CUSTOMER_SIREN"
} as const;

export type InvalidCustomerSirenErrorDtoCodeEnumKey = (typeof invalidCustomerSirenErrorDtoCodeEnum)[keyof typeof invalidCustomerSirenErrorDtoCodeEnum];

export type InvalidCustomerSirenErrorDto = {
    /**
     * @type string
    */
    code: InvalidCustomerSirenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidSirenDetailsDto;
};

export type LocationDto = {
    /**
     * @description Address
     * @type string | undefined
    */
    address?: string;
    /**
     * @description Post code
     * @type string | undefined
    */
    postCode?: string;
    /**
     * @description City
     * @type string
    */
    city: string;
    /**
     * @description Country
     * @type string
    */
    country: string;
};

export type LegalStatusDto = {
    /**
     * @description First legal status
     * @type string
    */
    "1": string;
    /**
     * @description Second legal status
     * @type string
    */
    "2": string;
    /**
     * @description Third legal status
     * @type string
    */
    "3": string;
};

export type FormattedSirenDataDto = {
    /**
     * @description Optional: Siren number
     * @type string | undefined
    */
    siren?: string;
    /**
     * @description Siret number
     * @type string
    */
    siret: string;
    /**
     * @description Optional: Naf code
     * @type string | undefined
    */
    nafCode?: string;
    /**
     * @description Optional: Naf label
     * @type string | undefined
    */
    nafLabel?: string;
    /**
     * @description Optional: Company name
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Optional: Creation date
     * @type string | undefined, date
    */
    creationDate?: string;
    /**
     * @description Optional: Location
    */
    location?: LocationDto;
    /**
     * @description Optional: legal status by level
    */
    legalStatus?: LegalStatusDto;
    /**
     * @description Optional: Number of employees
     * @type string | undefined
    */
    headcount?: string;
    /**
     * @description Optional: legal unit is active (INSEE etatAdministratifUniteLegale: A=active, C=ceased)
     * @type boolean | undefined
    */
    isActive?: boolean;
};

export type SearchSirenOutput = {
    /**
     * @description Total number of results
     * @type number
    */
    total: number;
    /**
     * @description List of formatted company details
     * @type array
    */
    data: FormattedSirenDataDto[];
};

export type AddressSuggestion = {
    /**
     * @description Formatted address, shown in the dropdown
     * @type string
    */
    label: string;
    /**
     * @description Street number + name
     * @type string | undefined
    */
    streetAddress?: string;
    /**
     * @description City / locality
     * @type string | undefined
    */
    locality?: string;
    /**
     * @description Region / state / department
     * @type string | undefined
    */
    administrativeArea?: string;
    /**
     * @description Postal code
     * @type string | undefined
    */
    postalCode?: string;
    /**
     * @description Country name, localized to the requested language
     * @type string | undefined
    */
    country?: string;
    /**
     * @description Country code (ISO 3166-1 alpha-2), locale-independent
     * @type string | undefined
    */
    countryCode?: string;
};

export type AddressAutocompleteSuggestOutput = {
    /**
     * @description Address suggestions
     * @type array
    */
    data: AddressSuggestion[];
};

export type RegistrationNumberNotFoundDetailsDto = {
    /**
     * @type string
    */
    registrationNumber: string;
};

export const registrationNumberNotFoundErrorDtoCodeEnum = {
    REGISTRATION_NUMBER_NOT_FOUND: "REGISTRATION_NUMBER_NOT_FOUND"
} as const;

export type RegistrationNumberNotFoundErrorDtoCodeEnumKey = (typeof registrationNumberNotFoundErrorDtoCodeEnum)[keyof typeof registrationNumberNotFoundErrorDtoCodeEnum];

export type RegistrationNumberNotFoundErrorDto = {
    /**
     * @type string
    */
    code: RegistrationNumberNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RegistrationNumberNotFoundDetailsDto;
};

export type SearchSivOutput = {
    /**
     * @description vehicle information
     * @type string
    */
    registrationNumber: string;
    /**
     * @description vehicle information
     * @type string, date
    */
    firstRegistrationDate: string;
    /**
     * @description vehicle information
     * @type string | undefined
    */
    vinNumber?: string;
    /**
     * @description vehicle information
     * @type string | undefined
    */
    mineType?: string;
    /**
     * @description vehicle information
     * @type string
    */
    brand: string;
    /**
     * @description vehicle information
     * @type string
    */
    model: string;
    /**
     * @description vehicle information
     * @type string
    */
    vehicleType: string;
    /**
     * @description vehicle information
     * @type string
    */
    bodywork: string;
    /**
     * @description vehicle information
     * @type string
    */
    gearbox: string;
    /**
     * @description vehicle information
     * @type string
    */
    energy: string;
    /**
     * @description vehicle information
     * @type number | undefined
    */
    fiscalPower?: number;
    /**
     * @description vehicle information
     * @type number | undefined
    */
    co2?: number;
    /**
     * @description vehicle information
     * @type number | undefined
    */
    numberOfSeats?: number;
    /**
     * @description vehicle information
     * @type number | undefined
    */
    numberOfDoors?: number;
    /**
     * @description vehicle information
     * @type number | undefined
    */
    unladenWeight?: number;
    /**
     * @description vehicle information
     * @type number | undefined
    */
    engineSize?: number;
    /**
     * @description vehicle information
     * @type boolean
    */
    isCollector: boolean;
};

export type NoDerogationToCreateDto = {
    /**
     * @type string
    */
    branchId: string;
    action: DerogationAction;
};

export const noDerogationToCreateErrorDtoCodeEnum = {
    NO_DEROGATION_TO_CREATE: "NO_DEROGATION_TO_CREATE"
} as const;

export type NoDerogationToCreateErrorDtoCodeEnumKey = (typeof noDerogationToCreateErrorDtoCodeEnum)[keyof typeof noDerogationToCreateErrorDtoCodeEnum];

export type NoDerogationToCreateErrorDto = {
    /**
     * @type string
    */
    code: NoDerogationToCreateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoDerogationToCreateDto;
};

export type DerogationAlreadyExistsDto = {
    action: DerogationAction;
    /**
     * @type string
    */
    branchId: string;
};

export const derogationAlreadyExistsErrorDtoCodeEnum = {
    DEROGATION_ALREADY_EXISTS: "DEROGATION_ALREADY_EXISTS"
} as const;

export type DerogationAlreadyExistsErrorDtoCodeEnumKey = (typeof derogationAlreadyExistsErrorDtoCodeEnum)[keyof typeof derogationAlreadyExistsErrorDtoCodeEnum];

export type DerogationAlreadyExistsErrorDto = {
    /**
     * @type string
    */
    code: DerogationAlreadyExistsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DerogationAlreadyExistsDto;
};

export type DerogationCreateOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type DerogationNotFoundDto = {
    /**
     * @type string
    */
    branchId: string;
};

export const derogationNotFoundErrorDtoCodeEnum = {
    DEROGATION_NOT_FOUND: "DEROGATION_NOT_FOUND"
} as const;

export type DerogationNotFoundErrorDtoCodeEnumKey = (typeof derogationNotFoundErrorDtoCodeEnum)[keyof typeof derogationNotFoundErrorDtoCodeEnum];

export type DerogationNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DerogationNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DerogationNotFoundDto;
};

export type DerogationApproveOutput = object;

export type DerogationDenyInputBody = {
    /**
     * @description Comment for the denial
     * @type string | undefined
    */
    comment?: string;
};

export type DerogationDenyOutput = object;

export type CheckDerogationRequirementInputBody = {
    /**
     * @description Custom fields you want to check derogation requirement with
     * @type array | undefined
    */
    customFieldsToOverride?: CustomFieldDto[];
};

export type CheckDerogationRequirementOutput = {
    /**
     * @description Whether a derogation is required for the branch/action
     * @type boolean
    */
    needsDerogation: boolean;
};

export type AdminConversationItem = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string | undefined
    */
    title?: string;
    /**
     * @type number
    */
    messageCount: number;
    /**
     * @type number
    */
    aiOperationCount: number;
    /**
     * @description Messages with a positive user rating (thumbs up).
     * @type number
    */
    positiveFeedbackCount: number;
    /**
     * @description Messages with a negative user rating (thumbs down, incl. legacy unrated).
     * @type number
    */
    negativeFeedbackCount: number;
    /**
     * @type string | undefined
    */
    source?: string;
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    updatedAt: string;
};

export type AdminListConversationsOutput = {
    /**
     * @type array
    */
    items: AdminConversationItem[];
    /**
     * @type number
    */
    total: number;
};

export const toolCallMetadataDtoStateEnum = {
    completed: "completed",
    error: "error"
} as const;

export type ToolCallMetadataDtoStateEnumKey = (typeof toolCallMetadataDtoStateEnum)[keyof typeof toolCallMetadataDtoStateEnum];

export type ToolCallMetadataDto = {
    /**
     * @type string
    */
    toolName: string;
    /**
     * @type string
    */
    state: ToolCallMetadataDtoStateEnumKey;
};

export const conversationMessageDtoRoleEnum = {
    USER: "USER",
    ASSISTANT: "ASSISTANT",
    SYSTEM: "SYSTEM"
} as const;

export type ConversationMessageDtoRoleEnumKey = (typeof conversationMessageDtoRoleEnum)[keyof typeof conversationMessageDtoRoleEnum];

export const conversationMessageDtoFeedbackRatingEnum = {
    "0": 0,
    "1": 1
} as const;

export type ConversationMessageDtoFeedbackRatingEnumKey = (typeof conversationMessageDtoFeedbackRatingEnum)[keyof typeof conversationMessageDtoFeedbackRatingEnum];

export type ConversationMessageDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    conversationId: string;
    /**
     * @type string
    */
    role: ConversationMessageDtoRoleEnumKey;
    /**
     * @type string
    */
    content: string;
    /**
     * @type string | undefined
    */
    aiOperationId?: string;
    /**
     * @type boolean | undefined
    */
    hasFeedback?: boolean;
    /**
     * @description 0 = negative, 1 = positive. Set when hasFeedback is true.
     * @type number | undefined
    */
    feedbackRating?: ConversationMessageDtoFeedbackRatingEnumKey;
    /**
     * @type number | undefined
    */
    inputTokens?: number;
    /**
     * @type number | undefined
    */
    outputTokens?: number;
    /**
     * @type number | undefined
    */
    processingTimeMs?: number;
    /**
     * @type string | undefined
    */
    source?: string;
    /**
     * @type array | undefined
    */
    toolCalls?: ToolCallMetadataDto[];
    /**
     * @type string
    */
    createdAt: string;
};

export type GetConversationMessagesOutput = {
    /**
     * @type array
    */
    messages: ConversationMessageDto[];
};

export type CommentAlreadyExistsDto = {
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    branchId: string;
};

export const commentAlreadyExistsErrorDtoCodeEnum = {
    COMMENT_ALREADY_EXISTS: "COMMENT_ALREADY_EXISTS"
} as const;

export type CommentAlreadyExistsErrorDtoCodeEnumKey = (typeof commentAlreadyExistsErrorDtoCodeEnum)[keyof typeof commentAlreadyExistsErrorDtoCodeEnum];

export type CommentAlreadyExistsErrorDto = {
    /**
     * @type string
    */
    code: CommentAlreadyExistsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CommentAlreadyExistsDto;
};

export type CreateCommentInputBody = {
    /**
     * @description Comment content
     * @maxLength 10000
     * @type string
    */
    comment: string;
};

export type CreateCommentOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type CommentNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const commentNotFoundErrorDtoCodeEnum = {
    COMMENT_NOT_FOUND: "COMMENT_NOT_FOUND"
} as const;

export type CommentNotFoundErrorDtoCodeEnumKey = (typeof commentNotFoundErrorDtoCodeEnum)[keyof typeof commentNotFoundErrorDtoCodeEnum];

export type CommentNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CommentNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CommentNotFoundDetailsDto;
};

export type UpdateCommentInputBody = {
    /**
     * @description Comment content
     * @maxLength 10000
     * @type string
    */
    comment: string;
};

export type UpdateCommentOutput = object;

export type DeleteCommentOutput = object;

export const getCommentOutputKindEnum = {
    GENERIC: "GENERIC",
    NOTE: "NOTE"
} as const;

export type GetCommentOutputKindEnumKey = (typeof getCommentOutputKindEnum)[keyof typeof getCommentOutputKindEnum];

export type GetCommentOutput = {
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description Id of the comment
     * @type string
    */
    id: string;
    /**
     * @description Id of the entity (policy, customer, branch, ...)
     * @type string
    */
    entityId: string;
    /**
     * @description Id of the branch
     * @type string
    */
    branchId: string;
    /**
     * @description Comment content
     * @maxLength 10000
     * @type string
    */
    comment: string;
    /**
     * @description Date and time when the comment was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the comment was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the comment was soft-deleted
     * @type object
    */
    deletedAt?: object | null;
    /**
     * @description Kind of comment (defaults to GENERIC)
     * @type string | undefined
    */
    kind?: GetCommentOutputKindEnumKey;
    /**
     * @description Cognito sub of the comment author (NOTE kind only)
     * @type object
    */
    authorUserId?: object | null;
};

export type ListCommentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: CommentDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type InternalNoteContentEmptyDetailsDto = object;

export const internalNoteContentEmptyErrorDtoCodeEnum = {
    INTERNAL_NOTE_CONTENT_EMPTY: "INTERNAL_NOTE_CONTENT_EMPTY"
} as const;

export type InternalNoteContentEmptyErrorDtoCodeEnumKey = (typeof internalNoteContentEmptyErrorDtoCodeEnum)[keyof typeof internalNoteContentEmptyErrorDtoCodeEnum];

export type InternalNoteContentEmptyErrorDto = {
    /**
     * @type string
    */
    code: InternalNoteContentEmptyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InternalNoteContentEmptyDetailsDto;
};

export type InternalNoteContentTooLongDetailsDto = {
    /**
     * @type number
    */
    maxLength: number;
};

export const internalNoteContentTooLongErrorDtoCodeEnum = {
    INTERNAL_NOTE_CONTENT_TOO_LONG: "INTERNAL_NOTE_CONTENT_TOO_LONG"
} as const;

export type InternalNoteContentTooLongErrorDtoCodeEnumKey = (typeof internalNoteContentTooLongErrorDtoCodeEnum)[keyof typeof internalNoteContentTooLongErrorDtoCodeEnum];

export type InternalNoteContentTooLongErrorDto = {
    /**
     * @type string
    */
    code: InternalNoteContentTooLongErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InternalNoteContentTooLongDetailsDto;
};

export type CreateInternalNoteInputBody = {
    /**
     * @maxLength 5000
     * @type string
    */
    content: string;
};

export type InternalNoteAuthorDto = {
    /**
     * @description Cognito sub of the author
     * @type string
    */
    userId: string;
    /**
     * @description Author display name resolved from the Broker row
     * @type string
    */
    displayName?: string | null;
    /**
     * @description Author business role
     * @type string
    */
    businessRole?: string | null;
};

export type CreateInternalNoteOutput = {
    /**
     * @description Id of the internal note (semantic comment id)
     * @type string
    */
    id: string;
    /**
     * @description Id of the policy the note is attached to
     * @type string
    */
    policyId: string;
    /**
     * @description Note content
     * @maxLength 5000
     * @type string
    */
    content: string;
    /**
     * @type object
    */
    author: InternalNoteAuthorDto;
    /**
     * @description Date and time when the note was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the note was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the note was soft-deleted
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description Whether the calling user authored this note
     * @type boolean
    */
    isOwn: boolean;
};

export type InternalNoteDto = {
    /**
     * @description Id of the internal note (semantic comment id)
     * @type string
    */
    id: string;
    /**
     * @description Id of the policy the note is attached to
     * @type string
    */
    policyId: string;
    /**
     * @description Note content
     * @maxLength 5000
     * @type string
    */
    content: string;
    /**
     * @type object
    */
    author: InternalNoteAuthorDto;
    /**
     * @description Date and time when the note was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the note was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the note was soft-deleted
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description Whether the calling user authored this note
     * @type boolean
    */
    isOwn: boolean;
};

export type ListInternalNotesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: InternalNoteDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type GetInternalNoteOutput = {
    /**
     * @description Id of the internal note (semantic comment id)
     * @type string
    */
    id: string;
    /**
     * @description Id of the policy the note is attached to
     * @type string
    */
    policyId: string;
    /**
     * @description Note content
     * @maxLength 5000
     * @type string
    */
    content: string;
    /**
     * @type object
    */
    author: InternalNoteAuthorDto;
    /**
     * @description Date and time when the note was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the note was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the note was soft-deleted
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description Whether the calling user authored this note
     * @type boolean
    */
    isOwn: boolean;
};

export type InternalNoteNotAuthorDetailsDto = {
    /**
     * @type string
    */
    noteId: string;
    /**
     * @type string
    */
    authorUserId: string;
    /**
     * @type string
    */
    callerUserId: string;
};

export const internalNoteNotAuthorErrorDtoCodeEnum = {
    INTERNAL_NOTE_NOT_AUTHOR: "INTERNAL_NOTE_NOT_AUTHOR"
} as const;

export type InternalNoteNotAuthorErrorDtoCodeEnumKey = (typeof internalNoteNotAuthorErrorDtoCodeEnum)[keyof typeof internalNoteNotAuthorErrorDtoCodeEnum];

export type InternalNoteNotAuthorErrorDto = {
    /**
     * @type string
    */
    code: InternalNoteNotAuthorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InternalNoteNotAuthorDetailsDto;
};

export type UpdateInternalNoteInputBody = {
    /**
     * @maxLength 5000
     * @type string
    */
    content: string;
};

export type UpdateInternalNoteOutput = {
    /**
     * @description Id of the internal note (semantic comment id)
     * @type string
    */
    id: string;
    /**
     * @description Id of the policy the note is attached to
     * @type string
    */
    policyId: string;
    /**
     * @description Note content
     * @maxLength 5000
     * @type string
    */
    content: string;
    /**
     * @type object
    */
    author: InternalNoteAuthorDto;
    /**
     * @description Date and time when the note was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the note was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the note was soft-deleted
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description Whether the calling user authored this note
     * @type boolean
    */
    isOwn: boolean;
};

export type SoftDeleteInternalNoteOutput = object;

export type ClaimInternalNoteOutput = {
    /**
     * @description Id of the internal note (semantic comment id)
     * @type string
    */
    id: string;
    /**
     * @description Note content
     * @maxLength 5000
     * @type string
    */
    content: string;
    /**
     * @type object
    */
    author: InternalNoteAuthorDto;
    /**
     * @description Date and time when the note was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the note was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the note was soft-deleted
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description Whether the calling user authored this note
     * @type boolean
    */
    isOwn: boolean;
    /**
     * @description Id of the claim the note is attached to
     * @type string
    */
    claimId: string;
};

export type ClaimInternalNoteDto = {
    /**
     * @description Id of the internal note (semantic comment id)
     * @type string
    */
    id: string;
    /**
     * @description Note content
     * @maxLength 5000
     * @type string
    */
    content: string;
    /**
     * @type object
    */
    author: InternalNoteAuthorDto;
    /**
     * @description Date and time when the note was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the note was last updated
     * @type string
    */
    updatedAt: string;
    /**
     * @description Date and time when the note was soft-deleted
     * @type string, date-time
    */
    deletedAt?: string | null;
    /**
     * @description Whether the calling user authored this note
     * @type boolean
    */
    isOwn: boolean;
    /**
     * @description Id of the claim the note is attached to
     * @type string
    */
    claimId: string;
};

export type ListClaimInternalNotesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ClaimInternalNoteDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CreateConversationBody = {
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @description User locale (e.g. fr-FR, en-US)
     * @type string | undefined
    */
    locale?: string;
    /**
     * @description User IANA timezone (e.g. Europe/Paris, America/New_York)
     * @type string | undefined
    */
    timezone?: string;
};

export type CreateConversationOutput = {
    /**
     * @type string
    */
    conversationId: string;
};

export type ConversationSummaryDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    title?: string;
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    updatedAt: string;
};

export type ListConversationsOutput = {
    /**
     * @type array
    */
    conversations: ConversationSummaryDto[];
};

export type ConversationNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const conversationNotFoundErrorDtoCodeEnum = {
    CONVERSATION_NOT_FOUND: "CONVERSATION_NOT_FOUND"
} as const;

export type ConversationNotFoundErrorDtoCodeEnumKey = (typeof conversationNotFoundErrorDtoCodeEnum)[keyof typeof conversationNotFoundErrorDtoCodeEnum];

export type ConversationNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ConversationNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConversationNotFoundDetailsDto;
};

export type GetConversationOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string | undefined
    */
    title?: string;
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    updatedAt: string;
};

export type SendMessageBody = {
    /**
     * @type string
    */
    content: string;
    /**
     * @type object | undefined
    */
    metadata?: object;
    /**
     * @description User IANA timezone (e.g. Europe/Paris, America/New_York)
     * @type string | undefined
    */
    timezone?: string;
};

export type SendConversationMessageOutput = {
    /**
     * @type object
    */
    userMessage: ConversationMessageDto;
    /**
     * @type object
    */
    assistantMessage: ConversationMessageDto;
};

export const sendFeedbackBodyRatingEnum = {
    "0": 0,
    "1": 1
} as const;

export type SendFeedbackBodyRatingEnumKey = (typeof sendFeedbackBodyRatingEnum)[keyof typeof sendFeedbackBodyRatingEnum];

export type SendFeedbackBody = {
    /**
     * @type string | undefined
    */
    comment?: string;
    /**
     * @description 0 = negative, 1 = positive. Defaults to 0.
     * @type number | undefined
    */
    rating?: SendFeedbackBodyRatingEnumKey;
};

export type SendConversationFeedbackOutput = {
    /**
     * @type string
    */
    feedbackId: string;
};

export type DeleteConversationOutput = {
    /**
     * @type boolean
    */
    success: boolean;
};

export type GetFacetOutput = {
    /**
     * @type array
    */
    data: string[];
};

export type VehicleInformation = {
    /**
     * @type string
    */
    id: string;
    /**
     * @description Optional: The brand code
     * @type string | undefined
    */
    brand?: string;
    /**
     * @description Optional: The model
     * @type string | undefined
    */
    model?: string;
    /**
     * @description Optional: the version
     * @type string | undefined
    */
    version?: string;
    /**
     * @description Nullable: the administrative power
     * @type number
    */
    fiscalPower: number | null;
    /**
     * @description Nullable: the energy
     * @type string
    */
    energy?: string | null;
    /**
     * @description Nullable: the energy code
     * @type string
    */
    energyCode: string | null;
    /**
     * @description Nullable: the body work
     * @type string
    */
    bodyWork: string | null;
    /**
     * @description Nullable: latest recorded retail price
     * @type number
    */
    latestPriceInEuro: number | null;
    /**
     * @description Nullable: price when new
     * @type number
    */
    originPriceInEuro: number | null;
    /**
     * @description Nullable: transmission
     * @type string
    */
    transmission: string | null;
};

export type GetVehicleDetailsOutput = {
    /**
     * @description List of vehicle sraIds
     * @type array
    */
    data: VehicleInformation[];
};

export type GetVersionInformationFromBrandAndModelData = {
    /**
     * @description The brand
     * @type string
    */
    version: string | null;
    /**
     * @description The fiscal power
     * @type number
    */
    fiscalPower: number | null;
    /**
     * @description The number of seats
     * @type number
    */
    numberOfSeats: number | null;
    /**
     * @description The start of commercialisation
     * @type string, date-time
    */
    commercialisationStartDate: string | null;
};

export type GetVersionInformationFromBrandAndModelOutput = {
    /**
     * @description List of vehicle version main information
     * @type array
    */
    data: GetVersionInformationFromBrandAndModelData[];
};

export type GetHiscoxActivitiesBySectorOutput = {
    /**
     * @type array
    */
    data: string[];
};

export type SydiaListClaimsInput = {
    /**
     * @type string
    */
    tenantId: string;
};

export type SydiaListClaimsOutput = object;

export type SydiaGetClaimInput = {
    /**
     * @type string
    */
    tenantId: string;
};

export type TiersDto = object;

export type IntervenantDto = object;

export type GedDto = object;

export type ReglementDto = object;

export type EvenementGedDto = object;

export type EvenementDto = {
    /**
     * @type array | undefined
    */
    ged?: EvenementGedDto[];
};

export type TacheDto = object;

export type ChecklistDto = object;

export type ProvisionDto = object;

export type RisqueDto = object;

export type SydiaGetClaimOutput = {
    /**
     * @type array | undefined
    */
    tiers?: TiersDto[];
    /**
     * @type array | undefined
    */
    intervenants?: IntervenantDto[];
    /**
     * @type array | undefined
    */
    ged?: GedDto[];
    /**
     * @type array | undefined
    */
    reglements?: ReglementDto[];
    /**
     * @type array | undefined
    */
    evenements?: EvenementDto[];
    /**
     * @type array | undefined
    */
    taches?: TacheDto[];
    /**
     * @type array | undefined
    */
    checklist?: ChecklistDto[];
    /**
     * @type array | undefined
    */
    provisions?: ProvisionDto[];
    /**
     * @type object | undefined
    */
    risque?: RisqueDto;
};

export type SydiaGetCustomerInput = {
    /**
     * @type string
    */
    tenantId: string;
};

export type SydiaGetCustomerOutput = object;

export type SydiaListCustomersInput = {
    /**
     * @type string
    */
    tenantId: string;
};

export type SydiaListCustomersOutput = object;

export type SydiaListPoliciesInput = {
    /**
     * @type string
    */
    tenantId: string;
};

export type SydiaListPoliciesOutput = object;

export type SydiaUpsertClaimInput = object;

export type SydiaUpsertClaimOutput = object;

export type ServiceClientData = {
    /**
     * @description service id
     * @type string
    */
    idClient: string;
};

export type GetServiceUserDataOutput = {
    /**
     * @description user id
     * @type string
    */
    id: string;
    /**
     * @description user firstname
     * @type string | undefined
    */
    firstname?: string;
    /**
     * @description user lastname
     * @type string | undefined
    */
    lastname?: string;
    /**
     * @description user email
     * @type string
    */
    email: string;
    /**
     * @description service info
    */
    clientData?: ServiceClientData;
};

export type StartWorkflowInput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type object
    */
    initialState: object;
    /**
     * @type string | undefined
    */
    currentStep?: string;
    /**
     * @type object
    */
    workflow: WorkflowDefinitionDto;
    /**
     * @type string | undefined, date-time
    */
    runAt?: string;
    /**
     * @type string | undefined
    */
    parentId?: string;
    /**
     * @type string | undefined
    */
    jobSchedulerRunId?: string;
};

export type StartWorkflowOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
};

export const listWorkflowRunsInputStatusesEnum = {
    CREATED: "CREATED",
    RUNNING: "RUNNING",
    SUCCEEDED: "SUCCEEDED",
    CANCELLED: "CANCELLED",
    ERROR: "ERROR"
} as const;

export type ListWorkflowRunsInputStatusesEnumKey = (typeof listWorkflowRunsInputStatusesEnum)[keyof typeof listWorkflowRunsInputStatusesEnum];

export type ListWorkflowRunsInput = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type array | undefined
    */
    statuses?: ListWorkflowRunsInputStatusesEnumKey[];
    /**
     * @type string | undefined, date-time
    */
    createdAtFrom?: string;
    /**
     * @type string | undefined, date-time
    */
    createdAtTo?: string;
    /**
     * @type string | undefined, date-time
    */
    runAtFrom?: string;
    /**
     * @type string | undefined, date-time
    */
    runAtTo?: string;
    /**
     * @type string | undefined
    */
    parentId?: string;
};

export type SuccinctWorkflowRunDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type string, date-time
    */
    runAt: string;
    /**
     * @type string
    */
    status: string;
    /**
     * @type number
    */
    attempts: number;
    /**
     * @type string | undefined, date-time
    */
    startedAt?: string;
    /**
     * @type string | undefined, date-time
    */
    finishedAt?: string;
    /**
     * @type number | undefined
    */
    duration?: number;
    /**
     * @type string | undefined
    */
    currentStep?: string;
    /**
     * @type string | undefined
    */
    parentId?: string;
};

export type ListWorkflowRunsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: SuccinctWorkflowRunDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ErrorDto = {
    /**
     * @type string
    */
    message: string;
    /**
     * @type string | undefined
    */
    stack?: string;
};

export type GetWorkflowRunOutput = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type string, date-time
    */
    runAt: string;
    /**
     * @type string
    */
    status: string;
    /**
     * @type number
    */
    attempts: number;
    /**
     * @type string | undefined, date-time
    */
    startedAt?: string;
    /**
     * @type string | undefined, date-time
    */
    finishedAt?: string;
    /**
     * @type number | undefined
    */
    duration?: number;
    /**
     * @type object
    */
    workflow: WorkflowDefinitionDto;
    /**
     * @type object
    */
    state: object;
    /**
     * @type string | undefined
    */
    currentStep?: string;
    /**
     * @type object | undefined
    */
    error?: ErrorDto;
    /**
     * @type string | undefined
    */
    parentId?: string;
};

export const workflowRunNodeDtoNodeTypeEnum = {
    RPC_CALL: "RPC_CALL",
    CONDITION: "CONDITION",
    WAIT: "WAIT",
    WAIT_UNTIL: "WAIT_UNTIL",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    WORKFLOW: "WORKFLOW"
} as const;

export type WorkflowRunNodeDtoNodeTypeEnumKey = (typeof workflowRunNodeDtoNodeTypeEnum)[keyof typeof workflowRunNodeDtoNodeTypeEnum];

export const workflowRunNodeDtoStatusEnum = {
    CREATED: "CREATED",
    RUNNING: "RUNNING",
    COMPLETED: "COMPLETED",
    ERROR: "ERROR",
    CANCELLED: "CANCELLED"
} as const;

export type WorkflowRunNodeDtoStatusEnumKey = (typeof workflowRunNodeDtoStatusEnum)[keyof typeof workflowRunNodeDtoStatusEnum];

export type WorkflowRunNodeDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type string
    */
    workflowRunId: string;
    /**
     * @type string
    */
    nodeType: WorkflowRunNodeDtoNodeTypeEnumKey;
    /**
     * @type string
    */
    status: WorkflowRunNodeDtoStatusEnumKey;
    /**
     * @type number
    */
    attempts: number;
    /**
     * @type string | undefined, date-time
    */
    startedAt?: string;
    /**
     * @type string | undefined, date-time
    */
    finishedAt?: string;
    /**
     * @type number | undefined
    */
    duration?: number;
    node: (SuccessNodeDefinitionDto | RpcCallNodeDefinitionDto | ConditionNodeDefinitionDto | WaitNodeDefinitionDto | WaitUntilNodeDefinitionDto | ErrorNodeDefinitionDto | ChildWorkflowNodeDefinitionDto);
    /**
     * @type object
    */
    input: object;
    /**
     * @type object | undefined
    */
    result?: object;
    /**
     * @type array | undefined
    */
    errors?: ErrorDto[];
};

export type ListWorkflowRunNodesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: WorkflowRunNodeDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CancelWorkflowRunsInputBody = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type array | undefined
    */
    ids?: string[];
};

export type CancelWorkflowRunsOutput = object;

export type RetryWorkflowRunInputBody = {
    /**
     * @type object | undefined
    */
    initialState?: object;
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type boolean
    */
    retryFromStart: boolean;
};

export type RetryWorkflowRunOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
};

export type YeetListDrivequantAverageScoresOutputScorePeriodDto = {
    /**
     * @description the start date of the period
     * @type string
    */
    startedAt: string;
    /**
     * @description the end date of the period
     * @type string
    */
    endedAt: string;
};

export const yeetDrivequantScoreRangeEnum = {
    "[3;4[": "[3;4[",
    "[4;5[": "[4;5[",
    "[5;6[": "[5;6[",
    "[6;7[": "[6;7[",
    "[7;8[": "[7;8[",
    "[8;8.5[": "[8;8.5[",
    "[8.5;9[": "[8.5;9[",
    "[9;9.5[": "[9;9.5[",
    ">= 9.5": ">= 9.5"
} as const;

export type YeetDrivequantScoreRangeEnumKey = (typeof yeetDrivequantScoreRangeEnum)[keyof typeof yeetDrivequantScoreRangeEnum];

/**
 * @description Drivequant score bracket applied for the period
*/
export type YeetDrivequantScoreRange = YeetDrivequantScoreRangeEnumKey;

export type YeetListDrivequantAverageScoresOutputMonthlyScoreDto = {
    /**
     * @description ISO date of the scored month
     * @type string
    */
    month: string;
    /**
     * @type number
    */
    score: number;
};

export type YeetListDrivequantAverageScoresOutputScoreUserDto = {
    /**
     * @type string
    */
    externalServiceUserId: string;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type string | undefined
    */
    cognitoEmail?: string;
    /**
     * @type array
    */
    datesScored: string[];
    /**
     * @type array
    */
    monthlyScores: YeetListDrivequantAverageScoresOutputMonthlyScoreDto[];
};

export type YeetListDrivequantAverageScoresOutputScoreDto = {
    /**
     * @type object
    */
    period: YeetListDrivequantAverageScoresOutputScorePeriodDto;
    /**
     * @type number
    */
    score?: number | null;
    /**
     * @description Drivequant pricing rate applied for the period (drives the bracket color)
     * @type number
    */
    appliedRate?: number | null;
    /**
     * @description Drivequant score bracket applied for the period
    */
    appliedScoreRange?: YeetDrivequantScoreRange | null;
    /**
     * @type array
    */
    users: YeetListDrivequantAverageScoresOutputScoreUserDto[];
};

export type YeetListDrivequantAverageScoresOutput = {
    /**
     * @type array
    */
    scores: YeetListDrivequantAverageScoresOutputScoreDto[];
};

export const yeetDrivequantSurchargeRateEnum = {
    "1.5": "1.5",
    "1.3": "1.3",
    NONE: "NONE"
} as const;

export type YeetDrivequantSurchargeRateEnumKey = (typeof yeetDrivequantSurchargeRateEnum)[keyof typeof yeetDrivequantSurchargeRateEnum];

/**
 * @description Drivequant surcharge rate
*/
export type YeetDrivequantSurchargeRate = YeetDrivequantSurchargeRateEnumKey;

export type YeetSurchargePolicyInputBody = {
    /**
     * @description Drivequant surcharge rate
    */
    newDrivequantSurchargeRate: YeetDrivequantSurchargeRate;
};

export type YeetSurchargePolicyOutput = object;

export type YeetListPossibleDrivequantUsersOutputData = {
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    email: string;
    /**
     * @description Drivequant externalServiceId, or \'\' if the user has no link
     * @type string
    */
    externalServiceId: string;
    /**
     * @description Account usability flag. True when the externalServiceId corresponds to an active linked Drivequant account (probed via listScores). False when the user has no link, the Drivequant user is not recognized (DRIVEQUANT_USER_NOT_FOUND), or the linked account is otherwise inactive.
     * @type boolean
    */
    enabled: boolean;
};

export type YeetListPossibleDrivequantUsersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: YeetListPossibleDrivequantUsersOutputData[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type YeetListDrivequantHistoricalUsersOutputUserDto = {
    /**
     * @type string
    */
    externalServiceUserId: string;
    /**
     * @description When this user was attached to the customer
     * @type string
    */
    attachedAt: string;
    /**
     * @description When this user was detached, or null if still active
     * @type string
    */
    detachedAt: string | null;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type string | undefined
    */
    cognitoEmail?: string;
};

export type YeetListDrivequantHistoricalUsersOutput = {
    /**
     * @type array
    */
    users: YeetListDrivequantHistoricalUsersOutputUserDto[];
};

export type YeetAttachDrivequantUserIdToCustomerOutput = object;

export type AxeceListDrivequantAverageScoresOutputScorePeriodDto = {
    /**
     * @description the start date of the period
     * @type string
    */
    startedAt: string;
    /**
     * @description the end date of the period
     * @type string
    */
    endedAt: string;
};

export const axeceDrivequantScoreRangeEnum = {
    "[3;4[": "[3;4[",
    "[4;5[": "[4;5[",
    "[5;6[": "[5;6[",
    "[6;7[": "[6;7[",
    "[7;8[": "[7;8[",
    "[8;8.5[": "[8;8.5[",
    "[8.5;9[": "[8.5;9[",
    "[9;9.5[": "[9;9.5[",
    ">= 9.5": ">= 9.5"
} as const;

export type AxeceDrivequantScoreRangeEnumKey = (typeof axeceDrivequantScoreRangeEnum)[keyof typeof axeceDrivequantScoreRangeEnum];

/**
 * @description Drivequant score bracket applied for the period
*/
export type AxeceDrivequantScoreRange = AxeceDrivequantScoreRangeEnumKey;

export type AxeceListDrivequantAverageScoresOutputMonthlyScoreDto = {
    /**
     * @description ISO date of the scored month
     * @type string
    */
    month: string;
    /**
     * @type number
    */
    score: number;
};

export type AxeceListDrivequantAverageScoresOutputScoreUserDto = {
    /**
     * @type string
    */
    externalServiceUserId: string;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type string | undefined
    */
    cognitoEmail?: string;
    /**
     * @type array
    */
    datesScored: string[];
    /**
     * @type array
    */
    monthlyScores: AxeceListDrivequantAverageScoresOutputMonthlyScoreDto[];
};

export type AxeceListDrivequantAverageScoresOutputScoreDto = {
    /**
     * @type object
    */
    period: AxeceListDrivequantAverageScoresOutputScorePeriodDto;
    /**
     * @type number
    */
    score?: number | null;
    /**
     * @description Drivequant pricing rate applied for the period (drives the bracket color)
     * @type number
    */
    appliedRate?: number | null;
    /**
     * @description Drivequant score bracket applied for the period
    */
    appliedScoreRange?: AxeceDrivequantScoreRange | null;
    /**
     * @type array
    */
    users: AxeceListDrivequantAverageScoresOutputScoreUserDto[];
};

export type AxeceListDrivequantAverageScoresOutput = {
    /**
     * @type array
    */
    scores: AxeceListDrivequantAverageScoresOutputScoreDto[];
};

export const axeceDrivequantSurchargeRateEnum = {
    "1.5": "1.5",
    "1.3": "1.3",
    NONE: "NONE"
} as const;

export type AxeceDrivequantSurchargeRateEnumKey = (typeof axeceDrivequantSurchargeRateEnum)[keyof typeof axeceDrivequantSurchargeRateEnum];

/**
 * @description Drivequant surcharge rate
*/
export type AxeceDrivequantSurchargeRate = AxeceDrivequantSurchargeRateEnumKey;

export type AxeceSurchargePolicyInputBody = {
    /**
     * @description Drivequant surcharge rate
    */
    newDrivequantSurchargeRate: AxeceDrivequantSurchargeRate;
};

export type AxeceSurchargePolicyOutput = object;

export type AxeceListPossibleDrivequantUsersOutputData = {
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    email: string;
    /**
     * @description Drivequant externalServiceId, or \'\' if the user has no link
     * @type string
    */
    externalServiceId: string;
    /**
     * @description Account usability flag. True when the externalServiceId corresponds to an active linked Drivequant account (probed via listScores). False when the user has no link, the Drivequant user is not recognized (DRIVEQUANT_USER_NOT_FOUND), or the linked account is otherwise inactive.
     * @type boolean
    */
    enabled: boolean;
};

export type AxeceListPossibleDrivequantUsersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: AxeceListPossibleDrivequantUsersOutputData[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type AxeceListDrivequantHistoricalUsersOutputUserDto = {
    /**
     * @type string
    */
    externalServiceUserId: string;
    /**
     * @description When this user was attached to the customer
     * @type string
    */
    attachedAt: string;
    /**
     * @description When this user was detached, or null if still active
     * @type string
    */
    detachedAt: string | null;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type string | undefined
    */
    cognitoEmail?: string;
};

export type AxeceListDrivequantHistoricalUsersOutput = {
    /**
     * @type array
    */
    users: AxeceListDrivequantHistoricalUsersOutputUserDto[];
};

export type AxeceAttachDrivequantUserIdToCustomerOutput = object;

export const AR24UserStatusEnum = {
    particulier: "particulier",
    professionnel: "professionnel"
} as const;

export type AR24UserStatusEnumKey = (typeof AR24UserStatusEnum)[keyof typeof AR24UserStatusEnum];

export type AR24UserStatus = AR24UserStatusEnumKey;

export const AR24UserGenderEnum = {
    M: "M",
    F: "F"
} as const;

export type AR24UserGenderEnumKey = (typeof AR24UserGenderEnum)[keyof typeof AR24UserGenderEnum];

export type AR24UserGender = AR24UserGenderEnumKey;

export type AR24UserNotificationsDto = {
    /**
     * @description AR24 `notify_dp`: letter deprecated, no longer deliverable
     * @type boolean
    */
    onDeprecated: boolean;
    /**
     * @description AR24 `notify_ev`: letter handed over to the recipient
     * @type boolean
    */
    onHandedOver: boolean;
    /**
     * @description AR24 `notify_ar`: recipient acknowledged receipt
     * @type boolean
    */
    onAcknowledgedReceipt: boolean;
    /**
     * @description AR24 `notify_rf`: recipient refused the letter
     * @type boolean
    */
    onRefused: boolean;
    /**
     * @description AR24 `notify_ng`: recipient left the letter unclaimed
     * @type boolean
    */
    onNegligence: boolean;
    /**
     * @description AR24 `notify_bc`: letter could not be delivered
     * @type boolean
    */
    onNonDelivery: boolean;
    /**
     * @description AR24 `notify_consent`: a consent was collected
     * @type boolean
    */
    onConsent: boolean;
    /**
     * @description AR24 `notify_eidas_to_valid`: an eIDAS letter from the team awaits validation
     * @type boolean
    */
    onEidasToValidate: boolean;
    /**
     * @description AR24 `notify_recipient_update`: a recipient update was created
     * @type boolean
    */
    onRecipientUpdate: boolean;
    /**
     * @description AR24 `notify_waiting_ar_answer`: twice-weekly digest of letters awaiting acknowledgment
     * @type boolean
    */
    onWaitingAcknowledgmentAnswer: boolean;
    /**
     * @description AR24 `notif_billing`: billing notifications
     * @type boolean
    */
    onBilling: boolean;
};

export type AR24UserUsageDto = {
    /**
     * @type string
    */
    tenantName: string;
    /**
     * @description This tenant\'s products whose formal notices are sent from this account
     * @type array
    */
    products: string[];
    /**
     * @description How many of this tenant\'s products can send a registered letter at all
     * @type number
    */
    registeredMailProductCount: number;
    /**
     * @description Hex taken from the tenant theme\'s primary palette
     * @type string
    */
    tenantPrimaryColor: string;
};

export type AR24UserDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    firstName: string;
    /**
     * @type string
    */
    lastName: string;
    /**
     * @type string
    */
    email: string;
    status: AR24UserStatus;
    gender?: AR24UserGender;
    /**
     * @type string | undefined
    */
    company?: string;
    /**
     * @type string | undefined
    */
    companyActivity?: string;
    /**
     * @type string | undefined
    */
    companySiret?: string;
    /**
     * @type string | undefined
    */
    companyVatNumber?: string;
    /**
     * @type string
    */
    address1: string;
    /**
     * @type string | undefined
    */
    address2?: string;
    /**
     * @type string
    */
    city: string;
    /**
     * @type string
    */
    zipCode: string;
    /**
     * @description ISO 3166-1 alpha-2 country code
     * @type string
    */
    country: string;
    /**
     * @type string | undefined
    */
    phone?: string;
    /**
     * @type string | undefined
    */
    mobile?: string;
    /**
     * @type string | undefined
    */
    billingEmail?: string;
    /**
     * @description AR24 `billing_tva`: VAT rate applied to invoices
     * @type string | undefined
    */
    billingVatRate?: string;
    /**
     * @description AR24 `creation`, as AR24 formats it: `yyyy-MM-dd HH:mm:ss`
     * @type string
    */
    createdAt: string;
    /**
     * @description AR24 `cgu`: EULA accepted. No registered letter can be sent until it is
     * @type boolean
    */
    hasAcceptedEula: boolean;
    /**
     * @description AR24 `notif_cgu`: a EULA acceptance request has been sent to this account
     * @type boolean
    */
    hasBeenAskedToAcceptEula: boolean;
    /**
     * @description AR24 `confirmed`: the account confirmed its email address
     * @type boolean
    */
    isEmailConfirmed: boolean;
    /**
     * @description AR24 `payment_active`
     * @type boolean
    */
    isPaymentActive: boolean;
    /**
     * @description AR24 `is_payment_possible`
     * @type boolean
    */
    isPaymentPossible: boolean;
    /**
     * @description AR24 `is_identity_verified`: locks first name and last name
     * @type boolean
    */
    isIdentityVerified: boolean;
    /**
     * @description AR24 `is_legal_entity`: use the company name, not the person, as the letter sender
     * @type boolean
    */
    isLegalEntity: boolean;
    /**
     * @description AR24 `notif_profil_uncomplete`
     * @type boolean
    */
    isProfileIncomplete: boolean;
    /**
     * @type object
    */
    notifications: AR24UserNotificationsDto;
    /**
     * @type array
    */
    usedBy: AR24UserUsageDto[];
};

export type AR24MisconfiguredUsageDto = {
    /**
     * @description The AR24 account id the product config points at
     * @type string
    */
    ar24User: string;
    /**
     * @type string
    */
    tenantName: string;
    /**
     * @type array
    */
    products: string[];
};

export type ListAR24UsersOutput = {
    /**
     * @type array
    */
    users: AR24UserDto[];
    /**
     * @description The AR24 instance these accounts live on — names the environment being read
     * @type string
    */
    apiUrl: string;
    /**
     * @type array
    */
    misconfiguredUsage: AR24MisconfiguredUsageDto[];
};

export type AR24UserNotificationsInputDto = {
    /**
     * @description AR24 `notify_dp`: letter deprecated, no longer deliverable
     * @type boolean | undefined
    */
    onDeprecated?: boolean;
    /**
     * @description AR24 `notify_ev`: letter handed over to the recipient
     * @type boolean | undefined
    */
    onHandedOver?: boolean;
    /**
     * @description AR24 `notify_ar`: recipient acknowledged receipt
     * @type boolean | undefined
    */
    onAcknowledgedReceipt?: boolean;
    /**
     * @description AR24 `notify_rf`: recipient refused the letter
     * @type boolean | undefined
    */
    onRefused?: boolean;
    /**
     * @description AR24 `notify_ng`: recipient left the letter unclaimed
     * @type boolean | undefined
    */
    onNegligence?: boolean;
    /**
     * @description AR24 `notify_bc`: letter could not be delivered
     * @type boolean | undefined
    */
    onNonDelivery?: boolean;
    /**
     * @description AR24 `notify_consent`: a consent was collected
     * @type boolean | undefined
    */
    onConsent?: boolean;
    /**
     * @description AR24 `notify_eidas_to_valid`: an eIDAS letter from the team awaits validation
     * @type boolean | undefined
    */
    onEidasToValidate?: boolean;
    /**
     * @description AR24 `notify_recipient_update`: a recipient update was created
     * @type boolean | undefined
    */
    onRecipientUpdate?: boolean;
    /**
     * @description AR24 `notify_waiting_ar_answer`: twice-weekly digest of letters awaiting acknowledgment
     * @type boolean | undefined
    */
    onWaitingAcknowledgmentAnswer?: boolean;
    /**
     * @description AR24 `notif_billing`: billing notifications
     * @type boolean | undefined
    */
    onBilling?: boolean;
};

export type CreateAR24UserInput = {
    /**
     * @type string
    */
    firstName: string;
    /**
     * @type string
    */
    lastName: string;
    status: AR24UserStatus;
    /**
     * @type string
    */
    address1: string;
    /**
     * @type string
    */
    city: string;
    /**
     * @type string
    */
    zipCode: string;
    /**
     * @description ISO 3166-1 alpha-2 country code
     * @type string
    */
    country: string;
    gender?: AR24UserGender;
    /**
     * @description Required by AR24 when status is `professionnel`
     * @type string | undefined
    */
    company?: string;
    /**
     * @type string | undefined
    */
    companySiret?: string;
    /**
     * @type string | undefined
    */
    companyVatNumber?: string;
    /**
     * @type string | undefined
    */
    address2?: string;
    /**
     * @type string | undefined
    */
    billingEmail?: string;
    /**
     * @description Use the company name, not the person, as the letter sender
     * @type boolean | undefined
    */
    isLegalEntity?: boolean;
    /**
     * @type object | undefined
    */
    notifications?: AR24UserNotificationsInputDto;
    /**
     * @type string
    */
    email: string;
    /**
     * @description Treat the address as already confirmed (AR24 `confirmed=1`) and skip its email
     * @type boolean | undefined
    */
    isEmailAlreadyConfirmed?: boolean;
};

export type CreateAR24UserOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    firstName: string;
    /**
     * @type string
    */
    lastName: string;
    /**
     * @type string
    */
    email: string;
    status: AR24UserStatus;
    gender?: AR24UserGender;
    /**
     * @type string | undefined
    */
    company?: string;
    /**
     * @type string | undefined
    */
    companyActivity?: string;
    /**
     * @type string | undefined
    */
    companySiret?: string;
    /**
     * @type string | undefined
    */
    companyVatNumber?: string;
    /**
     * @type string
    */
    address1: string;
    /**
     * @type string | undefined
    */
    address2?: string;
    /**
     * @type string
    */
    city: string;
    /**
     * @type string
    */
    zipCode: string;
    /**
     * @description ISO 3166-1 alpha-2 country code
     * @type string
    */
    country: string;
    /**
     * @type string | undefined
    */
    phone?: string;
    /**
     * @type string | undefined
    */
    mobile?: string;
    /**
     * @type string | undefined
    */
    billingEmail?: string;
    /**
     * @description AR24 `billing_tva`: VAT rate applied to invoices
     * @type string | undefined
    */
    billingVatRate?: string;
    /**
     * @description AR24 `creation`, as AR24 formats it: `yyyy-MM-dd HH:mm:ss`
     * @type string
    */
    createdAt: string;
    /**
     * @description AR24 `cgu`: EULA accepted. No registered letter can be sent until it is
     * @type boolean
    */
    hasAcceptedEula: boolean;
    /**
     * @description AR24 `notif_cgu`: a EULA acceptance request has been sent to this account
     * @type boolean
    */
    hasBeenAskedToAcceptEula: boolean;
    /**
     * @description AR24 `confirmed`: the account confirmed its email address
     * @type boolean
    */
    isEmailConfirmed: boolean;
    /**
     * @description AR24 `payment_active`
     * @type boolean
    */
    isPaymentActive: boolean;
    /**
     * @description AR24 `is_payment_possible`
     * @type boolean
    */
    isPaymentPossible: boolean;
    /**
     * @description AR24 `is_identity_verified`: locks first name and last name
     * @type boolean
    */
    isIdentityVerified: boolean;
    /**
     * @description AR24 `is_legal_entity`: use the company name, not the person, as the letter sender
     * @type boolean
    */
    isLegalEntity: boolean;
    /**
     * @description AR24 `notif_profil_uncomplete`
     * @type boolean
    */
    isProfileIncomplete: boolean;
    /**
     * @type object
    */
    notifications: AR24UserNotificationsDto;
    /**
     * @type array
    */
    usedBy: AR24UserUsageDto[];
};

export type RequestAR24UserAccessInput = {
    /**
     * @description Address of an existing AR24 account to attach to our API account
     * @type string
    */
    email: string;
};

export type AR24UserRelaunchOutput = {
    /**
     * @description The account id or email the relaunch was sent to
     * @type string
    */
    target: string;
};

export type GetAR24UserOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    firstName: string;
    /**
     * @type string
    */
    lastName: string;
    /**
     * @type string
    */
    email: string;
    status: AR24UserStatus;
    gender?: AR24UserGender;
    /**
     * @type string | undefined
    */
    company?: string;
    /**
     * @type string | undefined
    */
    companyActivity?: string;
    /**
     * @type string | undefined
    */
    companySiret?: string;
    /**
     * @type string | undefined
    */
    companyVatNumber?: string;
    /**
     * @type string
    */
    address1: string;
    /**
     * @type string | undefined
    */
    address2?: string;
    /**
     * @type string
    */
    city: string;
    /**
     * @type string
    */
    zipCode: string;
    /**
     * @description ISO 3166-1 alpha-2 country code
     * @type string
    */
    country: string;
    /**
     * @type string | undefined
    */
    phone?: string;
    /**
     * @type string | undefined
    */
    mobile?: string;
    /**
     * @type string | undefined
    */
    billingEmail?: string;
    /**
     * @description AR24 `billing_tva`: VAT rate applied to invoices
     * @type string | undefined
    */
    billingVatRate?: string;
    /**
     * @description AR24 `creation`, as AR24 formats it: `yyyy-MM-dd HH:mm:ss`
     * @type string
    */
    createdAt: string;
    /**
     * @description AR24 `cgu`: EULA accepted. No registered letter can be sent until it is
     * @type boolean
    */
    hasAcceptedEula: boolean;
    /**
     * @description AR24 `notif_cgu`: a EULA acceptance request has been sent to this account
     * @type boolean
    */
    hasBeenAskedToAcceptEula: boolean;
    /**
     * @description AR24 `confirmed`: the account confirmed its email address
     * @type boolean
    */
    isEmailConfirmed: boolean;
    /**
     * @description AR24 `payment_active`
     * @type boolean
    */
    isPaymentActive: boolean;
    /**
     * @description AR24 `is_payment_possible`
     * @type boolean
    */
    isPaymentPossible: boolean;
    /**
     * @description AR24 `is_identity_verified`: locks first name and last name
     * @type boolean
    */
    isIdentityVerified: boolean;
    /**
     * @description AR24 `is_legal_entity`: use the company name, not the person, as the letter sender
     * @type boolean
    */
    isLegalEntity: boolean;
    /**
     * @description AR24 `notif_profil_uncomplete`
     * @type boolean
    */
    isProfileIncomplete: boolean;
    /**
     * @type object
    */
    notifications: AR24UserNotificationsDto;
    /**
     * @type array
    */
    usedBy: AR24UserUsageDto[];
};

export type UpdateAR24UserBodyDto = {
    /**
     * @type string | undefined
    */
    firstName?: string;
    /**
     * @type string | undefined
    */
    lastName?: string;
    status?: AR24UserStatus;
    /**
     * @type string | undefined
    */
    address1?: string;
    /**
     * @type string | undefined
    */
    city?: string;
    /**
     * @type string | undefined
    */
    zipCode?: string;
    /**
     * @description ISO 3166-1 alpha-2 country code
     * @type string | undefined
    */
    country?: string;
    gender?: AR24UserGender;
    /**
     * @description Required by AR24 when status is `professionnel`
     * @type string | undefined
    */
    company?: string;
    /**
     * @type string | undefined
    */
    companySiret?: string;
    /**
     * @type string | undefined
    */
    companyVatNumber?: string;
    /**
     * @type string | undefined
    */
    address2?: string;
    /**
     * @type string | undefined
    */
    billingEmail?: string;
    /**
     * @description Use the company name, not the person, as the letter sender
     * @type boolean | undefined
    */
    isLegalEntity?: boolean;
    /**
     * @type object | undefined
    */
    notifications?: AR24UserNotificationsInputDto;
};

export type UpdateAR24UserOutput = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    firstName: string;
    /**
     * @type string
    */
    lastName: string;
    /**
     * @type string
    */
    email: string;
    status: AR24UserStatus;
    gender?: AR24UserGender;
    /**
     * @type string | undefined
    */
    company?: string;
    /**
     * @type string | undefined
    */
    companyActivity?: string;
    /**
     * @type string | undefined
    */
    companySiret?: string;
    /**
     * @type string | undefined
    */
    companyVatNumber?: string;
    /**
     * @type string
    */
    address1: string;
    /**
     * @type string | undefined
    */
    address2?: string;
    /**
     * @type string
    */
    city: string;
    /**
     * @type string
    */
    zipCode: string;
    /**
     * @description ISO 3166-1 alpha-2 country code
     * @type string
    */
    country: string;
    /**
     * @type string | undefined
    */
    phone?: string;
    /**
     * @type string | undefined
    */
    mobile?: string;
    /**
     * @type string | undefined
    */
    billingEmail?: string;
    /**
     * @description AR24 `billing_tva`: VAT rate applied to invoices
     * @type string | undefined
    */
    billingVatRate?: string;
    /**
     * @description AR24 `creation`, as AR24 formats it: `yyyy-MM-dd HH:mm:ss`
     * @type string
    */
    createdAt: string;
    /**
     * @description AR24 `cgu`: EULA accepted. No registered letter can be sent until it is
     * @type boolean
    */
    hasAcceptedEula: boolean;
    /**
     * @description AR24 `notif_cgu`: a EULA acceptance request has been sent to this account
     * @type boolean
    */
    hasBeenAskedToAcceptEula: boolean;
    /**
     * @description AR24 `confirmed`: the account confirmed its email address
     * @type boolean
    */
    isEmailConfirmed: boolean;
    /**
     * @description AR24 `payment_active`
     * @type boolean
    */
    isPaymentActive: boolean;
    /**
     * @description AR24 `is_payment_possible`
     * @type boolean
    */
    isPaymentPossible: boolean;
    /**
     * @description AR24 `is_identity_verified`: locks first name and last name
     * @type boolean
    */
    isIdentityVerified: boolean;
    /**
     * @description AR24 `is_legal_entity`: use the company name, not the person, as the letter sender
     * @type boolean
    */
    isLegalEntity: boolean;
    /**
     * @description AR24 `notif_profil_uncomplete`
     * @type boolean
    */
    isProfileIncomplete: boolean;
    /**
     * @type object
    */
    notifications: AR24UserNotificationsDto;
    /**
     * @type array
    */
    usedBy: AR24UserUsageDto[];
};

export type UnpaidRecoveryActionDto = {
    /**
     * @description Recovery workflow name.
     * @type string
    */
    name: string;
    /**
     * @description Planned recovery date if the balance remains unpaid. May be in the past; execution is not checked.
     * @type string
    */
    scheduledAt: string;
};

export type AccountingSummaryOutputEntity = {
    /**
     * @description Parent customer data
    */
    customer: CustomerDto;
    /**
     * @description Policy data
    */
    policy: PolicyDto;
    /**
     * @type number
    */
    numberOfUnpaidInvoices: number;
    /**
     * @type number
    */
    unpaidDurationInDay: number;
    /**
     * @type string
    */
    oldestUnpaidInvoiceIssuedAt: string;
    /**
     * @type string | undefined
    */
    lastFormalNoticeSentAt?: string;
    /**
     * @type object | undefined
    */
    plannedRecoveryAction?: UnpaidRecoveryActionDto;
};

export type AccountingSummaryOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: AccountingSummaryOutputEntity[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ListPolicyComplianceChecksOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ComplianceCheckDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type UpdateAlertOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type boolean
    */
    acknowledged: boolean;
    /**
     * @type string | undefined, date-time
    */
    acknowledgedAt?: string;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type ListPolicyComplianceAlertsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ComplianceAlertDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type BrokerageFirmOrderDto = {
    /**
     * @description the sort key for brokerage firms
     * @type string
    */
    by: string;
    /**
     * @description the sort direction
     * @type string
    */
    direction: string;
};

export const listChildBrokerageFirmsOutputDataFirmTypeEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type ListChildBrokerageFirmsOutputDataFirmTypeEnumKey = (typeof listChildBrokerageFirmsOutputDataFirmTypeEnum)[keyof typeof listChildBrokerageFirmsOutputDataFirmTypeEnum];

export type ListChildBrokerageFirmsOutputData = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description Brokerage firm type
     * @type string
    */
    firmType: ListChildBrokerageFirmsOutputDataFirmTypeEnumKey;
    /**
     * @description Brokerage firm id
     * @type string
    */
    id: string;
    /**
     * @description Brokerage firm id
     * @type string | undefined
    */
    parentBrokerageFirmId?: string;
    /**
     * @description Company info
    */
    companyInfo: FormattedSirenDataDto;
    /**
     * @description Creation date of brokerage firm
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description Tenant id
     * @type string
    */
    tenantId: string;
    /**
     * @type string | undefined
    */
    preferredPaymentMethodId?: string;
    /**
     * @description Product ids with status
     * @type array
    */
    productIdsWithStatus: string[];
};

export type ListChildBrokerageFirmsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ListChildBrokerageFirmsOutputData[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const distributionRequestStatusEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type DistributionRequestStatusEnumKey = (typeof distributionRequestStatusEnum)[keyof typeof distributionRequestStatusEnum];

/**
 * @description Status of the distribution request
*/
export type DistributionRequestStatus = DistributionRequestStatusEnumKey;

export const brokerageFirmDtoFirmTypeEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type BrokerageFirmDtoFirmTypeEnumKey = (typeof brokerageFirmDtoFirmTypeEnum)[keyof typeof brokerageFirmDtoFirmTypeEnum];

export type BrokerageFirmDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description Brokerage firm type
     * @type string
    */
    firmType: BrokerageFirmDtoFirmTypeEnumKey;
    /**
     * @description Brokerage firm id
     * @type string
    */
    id: string;
    /**
     * @description Brokerage firm id
     * @type string | undefined
    */
    parentBrokerageFirmId?: string;
    /**
     * @description Company info
    */
    companyInfo: FormattedSirenDataDto;
    /**
     * @description Creation date of brokerage firm
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description Tenant id
     * @type string
    */
    tenantId: string;
    /**
     * @type string | undefined
    */
    preferredPaymentMethodId?: string;
};

export type DistributionRequestWithBrokerageFirmDto = {
    /**
     * @description Unique identifier for the distribution request
     * @type string
    */
    id: string;
    /**
     * @description entity type
     * @type string
    */
    type: string;
    /**
     * @description Status of the distribution request
    */
    status: DistributionRequestStatus;
    /**
     * @description Brokerage firm the request is attached to
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Product the request is for
     * @type string
    */
    productId: string;
    /**
     * @description Date the request was created
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type object | undefined
    */
    brokerageFirm?: BrokerageFirmDto;
};

export type ListWholesaleBrokerageFirmDistributionRequestsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DistributionRequestWithBrokerageFirmDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ListPolicyAssetsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: AssetDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type PolicyAndAssetsQuoteDto = {
    /**
     * @type object
    */
    policy: PolicyQuoteDto;
    /**
     * @type array
    */
    assets: AssetQuoteDto[];
};

export type AvailablePricingPerilDto = {
    /**
     * @description Peril ID
     * @type string
    */
    id: string;
    /**
     * @description Whether peril is included in this tier pricing
     * @type boolean
    */
    included: boolean;
    /**
     * @description Available option values for this peril
     * @type array | undefined
    */
    options?: string[];
    /**
     * @description Custom field names for this peril
     * @type array | undefined
    */
    customFields?: string[];
    /**
     * @description Default custom field values
     * @type array | undefined
    */
    defaultCustomFieldValues?: CustomFieldDto[];
};

export type AvailablePricingTierDto = {
    /**
     * @description Tier ID, as returned in `GET /policies/{policyId}/available-pricing`. Tiers are computed per policy, so there is no fixed list.
     * @type string
    */
    tierId: string;
    /**
     * @description Pricing for this tier
    */
    pricing: PolicyAndAssetsQuoteDto;
    /**
     * @description Flat price breakdown for this tier
    */
    breakdown?: PriceBreakdownOutputDto;
    /**
     * @description Perils for this tier
     * @type array
    */
    perils: AvailablePricingPerilDto[];
    /**
     * @description Custom fields computed from pricing engine outputs
    */
    outputCustomFields?: OutputCustomFieldsDto;
};

export type GetAvailablePricingOutput = {
    /**
     * @description Available pricing tiers
     * @type array
    */
    tiers: AvailablePricingTierDto[];
    /**
     * @description Default tier ID
     * @type string
    */
    defaultTier: string;
    /**
     * @description The tier the user actually saved; undefined when no selection has been made
     * @type string | undefined
    */
    selectedTier?: string;
    /**
     * @description Legacy mode indicator (true if product not migrated)
     * @type boolean | undefined
    */
    legacyMode?: boolean;
};

export type ListPolicyCustomersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: CustomerDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type InvoiceDocumentDto = {
    /**
     * @description signed url for the document pdf
     * @type string
    */
    signedUrl: string;
    /**
     * @description Insurer the document is issued for, when the invoice has one per insurer
    */
    insurer?: Insurer;
};

export const invoiceWithSignedUrlDtoTypeEnum = {
    INVOICE: "INVOICE"
} as const;

export type InvoiceWithSignedUrlDtoTypeEnumKey = (typeof invoiceWithSignedUrlDtoTypeEnum)[keyof typeof invoiceWithSignedUrlDtoTypeEnum];

export const invoiceWithSignedUrlDtoStatusEnum = {
    DRAFTED: "DRAFTED",
    ISSUED: "ISSUED",
    PAID: "PAID",
    FINALIZED: "FINALIZED",
    PAYMENT_DISPUTED: "PAYMENT_DISPUTED",
    PAYMENT_IN_PROGRESS: "PAYMENT_IN_PROGRESS",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    RECONCILED: "RECONCILED",
    CANCELLED: "CANCELLED",
    REFUND_NOT_HANDLED: "REFUND_NOT_HANDLED",
    PARTIALLY_FINALIZED: "PARTIALLY_FINALIZED",
    REFUND_IN_PROGRESS: "REFUND_IN_PROGRESS",
    WRITTEN_OFF: "WRITTEN_OFF"
} as const;

export type InvoiceWithSignedUrlDtoStatusEnumKey = (typeof invoiceWithSignedUrlDtoStatusEnum)[keyof typeof invoiceWithSignedUrlDtoStatusEnum];

export type InvoiceWithSignedUrlDto = {
    /**
     * @description invoice issuance date
     * @type string
    */
    issuedAt: string;
    /**
     * @type object
    */
    period: Period;
    /**
     * @type array
    */
    components: BillingComponentDto[];
    /**
     * @type array
    */
    lines: InvoiceLineDto[];
    /**
     * @type object
    */
    total: AmountDto;
    /**
     * @description Invoice ids that have been reconciled
     * @type array | undefined
    */
    reconciledInvoiceIds?: any[][];
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @description the invoice id
     * @type string
    */
    id: string;
    /**
     * @description entity type
     * @type string
    */
    type: InvoiceWithSignedUrlDtoTypeEnumKey;
    /**
     * @description invoice status
     * @type string
    */
    status: InvoiceWithSignedUrlDtoStatusEnumKey;
    /**
     * @description invoice creation date
     * @type string
    */
    createdAt: string;
    /**
     * @description has invoice failed at least once
     * @type boolean | undefined
    */
    hasFailedOnce?: boolean;
    /**
     * @description first invoice payment failure date
     * @type string | undefined
    */
    firstFailedAt?: string;
    /**
     * @description Incremental invoice id
     * @type number | undefined
    */
    incrementalId?: number;
    /**
     * @description External invoice id
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @description Invoice payment id, if PAID
     * @type string | undefined
    */
    paymentId?: string;
    /**
     * @description Payment date, if PAID
     * @type string | undefined
    */
    paidAt?: string;
    /**
     * @type string | undefined
    */
    paidEventCreatedAt?: string;
    /**
     * @description Finalization date, if FINALIZED
     * @type string | undefined
    */
    finalizedAt?: string;
    /**
     * @description Offline settlement details, if the invoice was marked manually
    */
    manualPayment?: ManualPaymentDto;
    /**
     * @description Original invoice that we are crediting
     * @type string | undefined
    */
    creditedInvoiceId?: string;
    /**
     * @description Original invoice that we are replacing
     * @type string | undefined
    */
    replacedInvoiceId?: string;
    /**
     * @description Reason for refund not handled
    */
    refundNotHandledReason?: InvoiceRefundNotHandledReason;
    /**
     * @description signed url for the invoice pdf; the first of `documents`
     * @deprecated
     * @type string | undefined
    */
    signedUrl?: string;
    /**
     * @description Every document of the invoice: one per insurer when the invoice has several
     * @type array
    */
    documents: InvoiceDocumentDto[];
};

export type ListCustomerInvoicesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: InvoiceWithSignedUrlDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ListCustomerPaymentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const paymentMethodWithDocumentsDtoPaymentMethodTypeEnum = {
    card: "card",
    sepa_debit: "sepa_debit"
} as const;

export type PaymentMethodWithDocumentsDtoPaymentMethodTypeEnumKey = (typeof paymentMethodWithDocumentsDtoPaymentMethodTypeEnum)[keyof typeof paymentMethodWithDocumentsDtoPaymentMethodTypeEnum];

export type PaymentMethodWithDocumentsDto = {
    /**
     * @description metadata assigned to the object
     * @type array
    */
    metadata: Metadata[];
    /**
     * @type string
    */
    type: string;
    /**
     * @description the id of the payment method
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    status: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description the date of creation of the stripe customer
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description set when the payment method has been soft-deleted
     * @type string | undefined, date-time
    */
    deletedAt?: string;
    /**
     * @description the type of the payment method
     * @type string
    */
    paymentMethodType: PaymentMethodWithDocumentsDtoPaymentMethodTypeEnumKey;
    /**
     * @description the document id of the mandate, if applicable
     * @type string | undefined
    */
    mandateDocumentId?: string;
    /**
     * @description the last 4 digits of the payment method, if applicable
     * @type string | undefined
    */
    last4?: string;
    /**
     * @description the expiration month of payment method, if applicable
     * @type number | undefined
    */
    expirationMonth?: number;
    /**
     * @description the expiration year of payment method, if applicable
     * @type number | undefined
    */
    expirationYear?: number;
    /**
     * @description the billing details of payment method, if applicable
    */
    billingDetails?: BillingDetails;
    /**
     * @description Is the preferred payment method
     * @type boolean
    */
    isPreferred: boolean;
    /**
     * @type array | undefined
    */
    documents?: DocumentWithSignedUrl[];
};

export type ListCustomerPaymentMethodsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentMethodWithDocumentsDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ListBrokerageFirmPaymentMethodsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentMethodWithDocumentsDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type DateRange = {
    /**
     * @description Start date
     * @type string | undefined
    */
    start?: string;
    /**
     * @description End date
     * @type string | undefined
    */
    end?: string;
};

export const listBrokerageFirmPoliciesInputBodyViewTypeEnum = {
    newBusiness: "newBusiness",
    archivedNewBusiness: "archivedNewBusiness",
    derogation: "derogation",
    live: "live"
} as const;

export type ListBrokerageFirmPoliciesInputBodyViewTypeEnumKey = (typeof listBrokerageFirmPoliciesInputBodyViewTypeEnum)[keyof typeof listBrokerageFirmPoliciesInputBodyViewTypeEnum];

export const listBrokerageFirmPoliciesInputBodyStatusesEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type ListBrokerageFirmPoliciesInputBodyStatusesEnumKey = (typeof listBrokerageFirmPoliciesInputBodyStatusesEnum)[keyof typeof listBrokerageFirmPoliciesInputBodyStatusesEnum];

export const listBrokerageFirmPoliciesInputBodyPendingStopStatesEnum = {
    SCHEDULED: "SCHEDULED",
    AWAITING_VALIDATION: "AWAITING_VALIDATION"
} as const;

export type ListBrokerageFirmPoliciesInputBodyPendingStopStatesEnumKey = (typeof listBrokerageFirmPoliciesInputBodyPendingStopStatesEnum)[keyof typeof listBrokerageFirmPoliciesInputBodyPendingStopStatesEnum];

export const listBrokerageFirmPoliciesInputBodyFraudStatusesEnum = {
    fraud: "fraud",
    review_needed: "review_needed",
    clean: "clean"
} as const;

export type ListBrokerageFirmPoliciesInputBodyFraudStatusesEnumKey = (typeof listBrokerageFirmPoliciesInputBodyFraudStatusesEnum)[keyof typeof listBrokerageFirmPoliciesInputBodyFraudStatusesEnum];

export type ListBrokerageFirmPoliciesInputBody = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
    /**
     * @description View type
     * @type string
    */
    viewType: ListBrokerageFirmPoliciesInputBodyViewTypeEnumKey;
    /**
     * @description Statuses to filter by
     * @type array | undefined
    */
    statuses?: ListBrokerageFirmPoliciesInputBodyStatusesEnumKey[];
    /**
     * @description Custom statuses to filter by
     * @type array | undefined
    */
    customStatuses?: string[];
    /**
     * @description Conditions that must be satisfied on the same branch simultaneously
     * @type array | undefined
    */
    onSameBranch?: PropertyCondition[];
    /**
     * @description Business introducers to filter by
     * @type array | undefined
    */
    businessIntroducers?: string[];
    /**
     * @description Started at range
    */
    startedAt?: DateRange;
    /**
     * @description Stopped at range
    */
    stoppedAt?: DateRange;
    /**
     * @description Ended at range (contract end date / due date)
    */
    endedAt?: DateRange;
    /**
     * @description Created at range
    */
    createdAt?: DateRange;
    /**
     * @description Optional: if filled, returns policies with at least one alert which acknowledgement matches this attribute
     * @type boolean | undefined
    */
    hasAcknowledgedAlerts?: boolean;
    /**
     * @description Signed but awaiting first payment: CONFIRMED, signed, start date passed, on a product that gates activation on first payment.
     * @type boolean | undefined
    */
    awaitingFirstPayment?: boolean;
    /**
     * @type boolean | undefined
    */
    expandCustomers?: boolean;
    /**
     * @type boolean | undefined
    */
    expandAssets?: boolean;
    /**
     * @type boolean | undefined
    */
    expandBrokerageFirm?: boolean;
    /**
     * @description Full text search
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description Brokerage firm name
     * @type string | undefined
    */
    brokerageFirmName?: string;
    /**
     * @description List of product ids
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description List of stop reasons to filter by
     * @type array | undefined
    */
    stopReasons?: string[];
    /**
     * @description Filter by assigned broker (policy author) user ids
     * @type array | undefined
    */
    authorUserIds?: string[];
    /**
     * @description Filter by the insurer of the branch\'s quote (on the main branch, the current insurer)
     * @type array | undefined
    */
    insurers?: Insurer[];
    /**
     * @type boolean | undefined
    */
    derogationApproved?: boolean;
    /**
     * @description Policies whose cover continues while a stop waits: SCHEDULED runs on its own date, AWAITING_VALIDATION needs a manager to approve its proof first.
     * @type array | undefined
    */
    pendingStopStates?: ListBrokerageFirmPoliciesInputBodyPendingStopStatesEnumKey[];
    /**
     * @description Keep only policies with a document whose effective fraud verdict (a broker correction wins over the automated one) is in this list, and add a `fraudSummary` to each row. With `viewType: live` only the documents of the contract in force count; with `newBusiness`, only those of the open quote. Replaced, archived and deleted documents never count. Requires the permission to read policy document fraud results, otherwise 403.
     * @type array | undefined
    */
    fraudStatuses?: ListBrokerageFirmPoliciesInputBodyFraudStatusesEnumKey[];
};

export const policyBranchDtoRenewalStatusEnum = {
    RENEWAL_ACCEPTED: "RENEWAL_ACCEPTED",
    RENEWAL_REFUSED: "RENEWAL_REFUSED"
} as const;

export type PolicyBranchDtoRenewalStatusEnumKey = (typeof policyBranchDtoRenewalStatusEnum)[keyof typeof policyBranchDtoRenewalStatusEnum];

export const policyBranchDtoBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type PolicyBranchDtoBranchTypeEnumKey = (typeof policyBranchDtoBranchTypeEnum)[keyof typeof policyBranchDtoBranchTypeEnum];

export const policyBranchDtoAvailabilityEnum = {
    BRANCH_OPEN: "BRANCH_OPEN",
    BRANCH_MERGED: "BRANCH_MERGED",
    BRANCH_CLOSED: "BRANCH_CLOSED"
} as const;

export type PolicyBranchDtoAvailabilityEnumKey = (typeof policyBranchDtoAvailabilityEnum)[keyof typeof policyBranchDtoAvailabilityEnum];

export const policyBranchDtoCloseReasonEnum = {
    BROKER_REQUEST: "BROKER_REQUEST",
    CUSTOMER_REQUEST: "CUSTOMER_REQUEST",
    FORKED: "FORKED",
    ASSET_START_PASSED: "ASSET_START_PASSED",
    CONCURRENT_BRANCH_MERGED: "CONCURRENT_BRANCH_MERGED",
    QUOTE_INVALIDATED: "QUOTE_INVALIDATED",
    PARTITION_DROPPED: "PARTITION_DROPPED",
    RENEWAL_REFUSED: "RENEWAL_REFUSED",
    CRM_ABOVE_LIMIT: "CRM_ABOVE_LIMIT",
    TELEMATICS_SCORE_MISSING: "TELEMATICS_SCORE_MISSING",
    SIGNATURE_CANCELLED: "SIGNATURE_CANCELLED",
    DEROGATION_DENIED: "DEROGATION_DENIED"
} as const;

export type PolicyBranchDtoCloseReasonEnumKey = (typeof policyBranchDtoCloseReasonEnum)[keyof typeof policyBranchDtoCloseReasonEnum];

export type PolicyBranchDto = {
    /**
     * @type string
    */
    branchId: string;
    /**
     * @description Creation date of the branch
     * @type string
    */
    createdAt: string;
    /**
     * @description Optional: Branch renewal status
     * @type string | undefined
    */
    renewalStatus?: PolicyBranchDtoRenewalStatusEnumKey;
    /**
     * @type string
    */
    branchType: PolicyBranchDtoBranchTypeEnumKey;
    /**
     * @description Optional: Branch sub type
    */
    branchSubType?: BranchSubType;
    /**
     * @type string | undefined
    */
    availability?: PolicyBranchDtoAvailabilityEnumKey;
    /**
     * @description Optional: Branch close reason
     * @type string | undefined
    */
    closeReason?: PolicyBranchDtoCloseReasonEnumKey;
    /**
     * @description Optional: Merge date of the branch
     * @type string | undefined
    */
    mergedAt?: string;
    /**
     * @description Optional: Branch derogations
     * @type array | undefined
    */
    derogations?: DerogationDto[];
};

export const simplifiedCustomerDtoStatusEnum = {
    CUSTOMER_CREATED: "CUSTOMER_CREATED",
    CUSTOMER_CONFIRMED: "CUSTOMER_CONFIRMED"
} as const;

export type SimplifiedCustomerDtoStatusEnumKey = (typeof simplifiedCustomerDtoStatusEnum)[keyof typeof simplifiedCustomerDtoStatusEnum];

export const simplifiedCustomerDtoPaymentModeEnum = {
    DIRECT_DEBIT: "DIRECT_DEBIT",
    BANK_TRANSFER: "BANK_TRANSFER",
    OFFLINE: "OFFLINE"
} as const;

export type SimplifiedCustomerDtoPaymentModeEnumKey = (typeof simplifiedCustomerDtoPaymentModeEnum)[keyof typeof simplifiedCustomerDtoPaymentModeEnum];

export type SimplifiedCustomerDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Optional: Name of the entity
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Type of the customer
     * @type string
    */
    type: string;
    /**
     * @description Unique identifier for the customer
     * @type string
    */
    id: string;
    /**
     * @description Date and time when the customer was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the customer was last modified
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Status of the customer
     * @type string
    */
    status: SimplifiedCustomerDtoStatusEnumKey;
    /**
     * @description Customer business role
     * @type string
    */
    role: string;
    /**
     * @type string
    */
    paymentMode: SimplifiedCustomerDtoPaymentModeEnumKey;
};

export type SimplifiedAmountDto = {
    /**
     * @type integer
    */
    amountPreFeesAndTaxes: number;
    /**
     * @type integer
    */
    totalFees: number;
    /**
     * @type integer
    */
    amountWithFeesPreTaxes: number;
    /**
     * @type integer
    */
    totalTaxes: number;
    /**
     * @type integer
    */
    amountWithFeesAndTaxes: number;
};

export const simplifiedPolicyDtoStatusEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type SimplifiedPolicyDtoStatusEnumKey = (typeof simplifiedPolicyDtoStatusEnum)[keyof typeof simplifiedPolicyDtoStatusEnum];

export type SimplifiedPolicyDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    id: string;
    /**
     * @description Product ID
     * @type string
    */
    productId: string;
    /**
     * @description External policy id
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @description Date and time when the policy was created
     * @type string
    */
    createdAt: string;
    /**
     * @description Date and time when the policy was last modified
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Status of the policy
     * @type string
    */
    status: SimplifiedPolicyDtoStatusEnumKey;
    /**
     * @description Author of the policy
    */
    author?: BrokerDto;
    /**
     * @description Date and time when the policy was signed
     * @type string | undefined
    */
    signedAt?: string;
    /**
     * @description Date and time when the policy started. Stored exactly as sent: pass the zone-local midnight of the intended first day of cover (22:00:00Z the previous day in Paris summer time, 23:00:00Z in winter), not UTC midnight — endedAt is snapped to a zone-local day boundary, so a UTC midnight start yields a period two hours short of the premium\'s.
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description Derived: signed but not yet active because the product gates activation on first payment and that payment is still outstanding (status CONFIRMED, signed, start date passed).
     * @type boolean | undefined
    */
    isAwaitingFirstPayment?: boolean;
    /**
     * @description Insurer of the returned branch\'s quote; on the main branch, the insurer of the last merged quote. Set on GET /policies/{policyId}, the portfolio list and document payloads; absent when the product has no insurer mapping or the quote provider is unmapped.
    */
    insurer?: Insurer;
    /**
     * @description Derived: a stop has been requested on a reason that needs proof, and a manager has not decided it yet. Cover continues meanwhile; the stop will not execute until the derogation is approved.
     * @type boolean | undefined
    */
    isStopAwaitingValidation?: boolean;
    /**
     * @description Date and time when the policy will end. Read-only and derived: startedAt plus the period duration, snapped to the start of the policy timezone\'s day. Not settable.
     * @type string | undefined
    */
    endedAt?: string;
    /**
     * @description Date and time when the policy stopped
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @description stop reason, details and createdAt
    */
    stop?: StopDto;
    /**
     * @description Has anyone has a DRIVER relationship with the policy\'s customer
     * @type boolean
    */
    hasOpenedClientAccount: boolean;
    /**
     * @type object | undefined
    */
    totalPremium?: SimplifiedAmountDto;
};

export const simplifiedAssetDtoStatusEnum = {
    ASSET_CREATED: "ASSET_CREATED",
    ASSET_REMOVED: "ASSET_REMOVED",
    ASSET_QUOTED: "ASSET_QUOTED",
    ASSET_CONFIRMED: "ASSET_CONFIRMED",
    ASSET_STARTED: "ASSET_STARTED",
    ASSET_STOPPED: "ASSET_STOPPED",
    ASSET_CANCELLED: "ASSET_CANCELLED"
} as const;

export type SimplifiedAssetDtoStatusEnumKey = (typeof simplifiedAssetDtoStatusEnum)[keyof typeof simplifiedAssetDtoStatusEnum];

export type SimplifiedAssetDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description assetId
     * @type string
    */
    id: string;
    /**
     * @description Last modified date of the asset
     * @type string
    */
    lastModifiedAt: string;
    /**
     * @description Creation date of the asset
     * @type string
    */
    createdAt: string;
    /**
     * @description Status of the asset
     * @type string
    */
    status: SimplifiedAssetDtoStatusEnumKey;
    /**
     * @description Date the asset starts
     * @type string | undefined
    */
    startedAt?: string;
    /**
     * @description Date the asset stops
     * @type string | undefined
    */
    stoppedAt?: string;
    /**
     * @type object | undefined
    */
    totalPremium?: SimplifiedAmountDto;
};

export const simplifiedBrokerageFirmDtoFirmTypeEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type SimplifiedBrokerageFirmDtoFirmTypeEnumKey = (typeof simplifiedBrokerageFirmDtoFirmTypeEnum)[keyof typeof simplifiedBrokerageFirmDtoFirmTypeEnum];

export type SimplifiedBrokerageFirmDto = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Brokerage firm type
     * @type string
    */
    firmType: SimplifiedBrokerageFirmDtoFirmTypeEnumKey;
    /**
     * @description Brokerage firm id
     * @type string
    */
    id: string;
    /**
     * @description Company info
    */
    companyInfo: FormattedSirenDataDto;
};

export const policyFraudSummaryDtoGlobalStatusEnum = {
    pending: "pending",
    clean: "clean",
    review_needed: "review_needed",
    fraud: "fraud",
    unchecked: "unchecked",
    error: "error"
} as const;

export type PolicyFraudSummaryDtoGlobalStatusEnumKey = (typeof policyFraudSummaryDtoGlobalStatusEnum)[keyof typeof policyFraudSummaryDtoGlobalStatusEnum];

export type PolicyFraudSummaryDto = {
    /**
     * @description Worst fraud-check status among the documents.
     * @type string
    */
    globalStatus: PolicyFraudSummaryDtoGlobalStatusEnumKey;
    /**
     * @description Highest per-document 0..100 score (higher = more suspicious); null when no document carries a numeric score.
     * @type number
    */
    globalScore?: number | null;
    /**
     * @description Attached documents whose effective verdict matched the filter.
     * @type number
    */
    flaggedDocumentCount: number;
};

export type PolicyBranchesForBrokerEntity = {
    /**
     * @description Company name of the first customer, else its first and last names; needs expandCustomers
     * @type string
    */
    customerName?: string | null;
    /**
     * @type object | undefined
    */
    branch?: PolicyBranchDto;
    /**
     * @type array | undefined
    */
    customers?: SimplifiedCustomerDto[];
    /**
     * @type object
    */
    policy: SimplifiedPolicyDto;
    /**
     * @type array | undefined
    */
    assets?: SimplifiedAssetDto[];
    /**
     * @type object | undefined
    */
    brokerageFirm?: SimplifiedBrokerageFirmDto;
    /**
     * @type object | undefined
    */
    parentBrokerageFirm?: SimplifiedBrokerageFirmDto;
    /**
     * @description Rollup of the documents that matched `fraudStatuses`: worst verdict, highest score and their count. Set only when `fraudStatuses` is sent.
    */
    fraudSummary?: PolicyFraudSummaryDto;
};

export type PolicyForBrokerEntity = {
    /**
     * @description Customer ids
     * @type array
    */
    customerIds: string[];
    /**
     * @description Policy id
     * @type string
    */
    policyId: string;
    /**
     * @type array
    */
    branches: PolicyBranchesForBrokerEntity[];
};

export type ListBrokerageFirmPoliciesOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PolicyForBrokerEntity[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CustomerRelation = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    resourceId: string;
    /**
     * @type string
    */
    relationType: string;
    /**
     * @type string
    */
    email: string;
};

export type ListCustomerRelationsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: CustomerRelation[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const listBrokerageFirmDerogationsInputBodyStatusesEnum = {
    CREATED: "CREATED",
    APPROVED: "APPROVED",
    DENIED: "DENIED"
} as const;

export type ListBrokerageFirmDerogationsInputBodyStatusesEnumKey = (typeof listBrokerageFirmDerogationsInputBodyStatusesEnum)[keyof typeof listBrokerageFirmDerogationsInputBodyStatusesEnum];

export type ListBrokerageFirmDerogationsInputBody = {
    /**
     * @type array | undefined
    */
    statuses?: ListBrokerageFirmDerogationsInputBodyStatusesEnumKey[];
    /**
     * @description Brokerage firm name
     * @type string | undefined
    */
    brokerageFirmName?: string;
    /**
     * @description Full text search
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description Product ids
     * @type array | undefined
    */
    productIds?: string[];
};

export type DerogationWithPolicyAndCustomerEntity = {
    /**
     * @description Customers
     * @type array
    */
    customers: CustomerDto[];
    /**
     * @description Policy
    */
    policy: PolicyDto;
    /**
     * @type boolean
    */
    hasOpenedClientAccount: boolean;
    /**
     * @type object | undefined
    */
    brokerageFirm?: SimplifiedBrokerageFirmDto;
    /**
     * @type object | undefined
    */
    branch?: PolicyBranchDto;
};

export type ListBrokerageFirmDerogationsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DerogationWithPolicyAndCustomerEntity[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type ListProductCommonDocumentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DocumentWithSignedUrl[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CreateActiveTeamInputBody = {
    /**
     * @description Product IDs to create distribution requests for
     * @type array
    */
    productIds: string[];
    /**
     * @description Custom fields for the brokerage firm
     * @type array | undefined
    */
    customFields?: string[];
};

export type CreateActiveTeamOutput = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type DistributionRequestDto = {
    /**
     * @description Unique identifier for the distribution request
     * @type string
    */
    id: string;
    /**
     * @description entity type
     * @type string
    */
    type: string;
    /**
     * @description Status of the distribution request
    */
    status: DistributionRequestStatus;
    /**
     * @description Brokerage firm the request is attached to
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Product the request is for
     * @type string
    */
    productId: string;
    /**
     * @description Date the request was created
     * @type string, date-time
    */
    createdAt: string;
};

export type ListBrokerageFirmDistributionRequestsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DistributionRequestDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CreateComplianceCheckInputBody = {
    /**
     * @type object
    */
    searchParams: object;
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @description Internal ID of the individual or organization
     * @type string | undefined
    */
    internalId?: string;
    /**
     * @description Tags
     * @type string | undefined
    */
    tags?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type CreateComplianceCheckOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @type string
    */
    provider: string;
    /**
     * @type string
    */
    searchKey: string;
    /**
     * @description Array of alert IDs associated with this check
     * @type array | undefined
    */
    alertIds?: string[];
};

export type CheckNotFoundDto = {
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string | undefined
    */
    alertId?: string;
};

export const checkNotFoundErrorDtoCodeEnum = {
    CHECK_NOT_FOUND: "CHECK_NOT_FOUND"
} as const;

export type CheckNotFoundErrorDtoCodeEnumKey = (typeof checkNotFoundErrorDtoCodeEnum)[keyof typeof checkNotFoundErrorDtoCodeEnum];

export type CheckNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CheckNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CheckNotFoundDto;
};

export type UpdateComplianceCheckInputBody = {
    /**
     * @type object
    */
    searchParams: object;
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @description Internal ID of the individual or organization
     * @type string | undefined
    */
    internalId?: string;
    /**
     * @description Tags
     * @type string | undefined
    */
    tags?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type UpdateComplianceCheckOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @type string
    */
    provider: string;
    /**
     * @type string
    */
    searchKey: string;
    /**
     * @description Array of alert IDs associated with this check
     * @type array | undefined
    */
    alertIds?: string[];
};

export type DeleteComplianceCheckOutput = object;

export type GetComplianceCheckOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string
    */
    entityId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @type string
    */
    provider: string;
    /**
     * @type string
    */
    searchKey: string;
    /**
     * @description Array of alert IDs associated with this check
     * @type array | undefined
    */
    alertIds?: string[];
};

export type ListComplianceChecksOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ComplianceCheckDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CreateAlertInputBody = {
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type boolean
    */
    acknowledged: boolean;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
    /**
     * @type string
    */
    entityId: string;
};

export type CreateAlertOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type boolean
    */
    acknowledged: boolean;
    /**
     * @type string | undefined, date-time
    */
    acknowledgedAt?: string;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type AcknowledgeAlertsByEntityOutput = {
    /**
     * @description Number of alerts acknowledged
     * @type number
    */
    acknowledgedCount: number;
};

export type AcknowledgeAlertsByCheckIdsInputBody = {
    /**
     * @description Entity ID for authorization
     * @type string
    */
    entityId: string;
    /**
     * @description Check IDs to acknowledge alerts for
     * @type array
    */
    checkIds: string[];
};

export type AcknowledgeAlertsByCheckIdsOutput = {
    /**
     * @description Number of alerts acknowledged
     * @type number
    */
    acknowledgedCount: number;
};

export type AlertNotFoundDto = {
    /**
     * @type string
    */
    alertId: string;
};

export const alertNotFoundErrorDtoCodeEnum = {
    ALERT_NOT_FOUND: "ALERT_NOT_FOUND"
} as const;

export type AlertNotFoundErrorDtoCodeEnumKey = (typeof alertNotFoundErrorDtoCodeEnum)[keyof typeof alertNotFoundErrorDtoCodeEnum];

export type AlertNotFoundErrorDto = {
    /**
     * @type string
    */
    code: AlertNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AlertNotFoundDto;
};

export type UpdateAlertInputBody = {
    /**
     * @type boolean | undefined
    */
    acknowledged?: boolean;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type DeleteAlertOutput = object;

export type ListAlertsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ComplianceAlertDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type GetAlertOutput = {
    /**
     * @type string
    */
    type: string;
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type boolean
    */
    acknowledged: boolean;
    /**
     * @type string | undefined, date-time
    */
    acknowledgedAt?: string;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type object | undefined
    */
    data?: ComplianceDataItem;
};

export type CreateRelationInputBody = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    resourceId: string;
    /**
     * @type string
    */
    relationType: string;
};

export type CreateRelationOutput = object;

export type PermissionRelation = {
    /**
     * @type array
    */
    roles: string[];
    /**
     * @type array | undefined
    */
    forbiddenRoles?: string[];
    /**
     * @type array
    */
    resources: string[];
    /**
     * @type string
    */
    type: string;
};

export type GetPermissionRelationsForUserOutput = {
    /**
     * @type array
    */
    relations: PermissionRelation[];
};

export type DeleteRelationOutput = object;

export type TenantUser = {
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @description Cognito email, absent when unresolvable
     * @type string | undefined
    */
    email?: string;
    /**
     * @type array
    */
    relationTypes: string[];
    /**
     * @description when the first relation of that user was created
     * @type string, date-time
    */
    createdAt: string;
};

export type ListTenantUsersOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: TenantUser[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type Relation = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    resourceId: string;
    /**
     * @type string
    */
    relationType: string;
};

export type ListRelationsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: Relation[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type LegacyAtMeOutput = {
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    email: string;
    /**
     * @type boolean
    */
    isSuperUser: boolean;
    /**
     * @description First name
     * @type string | undefined
    */
    firstName?: string;
    /**
     * @description Last name
     * @type string | undefined
    */
    lastName?: string;
    /**
     * @description My brokerage firm
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @description My broker role
     * @type string | undefined
    */
    brokerRole?: string;
    /**
     * @description Products that can be distributed by the user
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @type array
    */
    relations: Relation[];
};

export type MissingProductDetailsDto = object;

export const missingProductErrorDtoCodeEnum = {
    MISSING_PRODUCT: "MISSING_PRODUCT"
} as const;

export type MissingProductErrorDtoCodeEnumKey = (typeof missingProductErrorDtoCodeEnum)[keyof typeof missingProductErrorDtoCodeEnum];

export type MissingProductErrorDto = {
    /**
     * @type string
    */
    code: MissingProductErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingProductDetailsDto;
};

export type InvalidProductTypeDetailsDto = {
    /**
     * @type string
    */
    product: string;
    /**
     * @type string | undefined
    */
    expectedProductType?: string;
};

export const invalidProductTypeErrorDtoCodeEnum = {
    INVALID_PRODUCT_TYPE: "INVALID_PRODUCT_TYPE"
} as const;

export type InvalidProductTypeErrorDtoCodeEnumKey = (typeof invalidProductTypeErrorDtoCodeEnum)[keyof typeof invalidProductTypeErrorDtoCodeEnum];

export type InvalidProductTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidProductTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidProductTypeDetailsDto;
};

export type ImpossibleCommissionFeeDetailsDto = {
    /**
     * @type string
    */
    product: string;
    /**
     * @type number
    */
    currentMin: number;
    /**
     * @type number
    */
    currentMax: number;
    /**
     * @type number | undefined
    */
    currentDefault?: number;
};

export const impossibleCommissionRangeErrorDtoCodeEnum = {
    IMPOSSIBLE_COMMISSION_RANGE: "IMPOSSIBLE_COMMISSION_RANGE"
} as const;

export type ImpossibleCommissionRangeErrorDtoCodeEnumKey = (typeof impossibleCommissionRangeErrorDtoCodeEnum)[keyof typeof impossibleCommissionRangeErrorDtoCodeEnum];

export type ImpossibleCommissionRangeErrorDto = {
    /**
     * @type string
    */
    code: ImpossibleCommissionRangeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ImpossibleCommissionFeeDetailsDto;
};

export type ProductNotFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @type string
    */
    productId: string;
};

export const productNotFoundErrorDtoCodeEnum = {
    PRODUCT_NOT_FOUND: "PRODUCT_NOT_FOUND"
} as const;

export type ProductNotFoundErrorDtoCodeEnumKey = (typeof productNotFoundErrorDtoCodeEnum)[keyof typeof productNotFoundErrorDtoCodeEnum];

export type ProductNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ProductNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ProductNotFoundDetailsDto;
};

export type CompanyInfoLegalStatusPatch = {
    /**
     * @description First legal status
     * @type string | undefined
    */
    "1"?: string;
    /**
     * @description Second legal status
     * @type string | undefined
    */
    "2"?: string;
    /**
     * @description Third legal status
     * @type string | undefined
    */
    "3"?: string;
};

export type CompanyInfoLocationPatch = {
    /**
     * @description Address
     * @type string | undefined
    */
    address?: string;
    /**
     * @description Post code
     * @type string | undefined
    */
    postCode?: string;
    /**
     * @description City
     * @type string | undefined
    */
    city?: string;
    /**
     * @description Country
     * @type string | undefined
    */
    country?: string;
};

export type CompanyInfoPatchDto = {
    /**
     * @description Optional: Siret number
     * @type string | undefined
    */
    siret?: string;
    /**
     * @description Optional: Siren number
     * @type string | undefined
    */
    siren?: string;
    /**
     * @description Optional: Company name
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Optional: Naf code
     * @type string | undefined
    */
    nafCode?: string;
    /**
     * @description Optional: Naf label
     * @type string | undefined
    */
    nafLabel?: string;
    /**
     * @description Optional: Creation date
     * @type string | undefined, date
    */
    creationDate?: string;
    /**
     * @description Optional: Number of employees
     * @type string | undefined
    */
    headcount?: string;
    /**
     * @description Optional: Legal unit is active
     * @type boolean | undefined
    */
    isActive?: boolean;
    /**
     * @description Optional: legal status by level
    */
    legalStatus?: CompanyInfoLegalStatusPatch;
    /**
     * @description Optional: Location partial override
    */
    location?: CompanyInfoLocationPatch;
};

export const createBrokerageFirmInputBodyFirmTypeEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type CreateBrokerageFirmInputBodyFirmTypeEnumKey = (typeof createBrokerageFirmInputBodyFirmTypeEnum)[keyof typeof createBrokerageFirmInputBodyFirmTypeEnum];

export type CreateBrokerageFirmInputBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Brokerage firm type
     * @type string
    */
    firmType: CreateBrokerageFirmInputBodyFirmTypeEnumKey;
    /**
     * @description Brokerage firm id
     * @type string | undefined
    */
    parentBrokerageFirmId?: string;
    /**
     * @description Partial company info supplied directly (used when the user enters company details manually instead of relying on a SIREN lookup).
    */
    companyInfo?: CompanyInfoPatchDto;
};

export type CreateBrokerageFirmOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type DuplicatedProductTypeDetailsDto = {
    /**
     * @type string
    */
    product: string;
};

export const duplicatedProductErrorDtoCodeEnum = {
    DUPLICATED_PRODUCT: "DUPLICATED_PRODUCT"
} as const;

export type DuplicatedProductErrorDtoCodeEnumKey = (typeof duplicatedProductErrorDtoCodeEnum)[keyof typeof duplicatedProductErrorDtoCodeEnum];

export type DuplicatedProductErrorDto = {
    /**
     * @type string
    */
    code: DuplicatedProductErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DuplicatedProductTypeDetailsDto;
};

export type UpdateBrokerageFirmInputBody = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Custom fields to delete
     * @type array | undefined
    */
    customFieldsToDelete?: string[];
    /**
     * @description Partial company info to merge into the existing one (used by wholesale to override retail company info without running a SIREN lookup).
    */
    companyInfo?: CompanyInfoPatchDto;
};

export type UpdateBrokerageFirmOutput = object;

export const getBrokerageFirmOutputFirmTypeEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type GetBrokerageFirmOutputFirmTypeEnumKey = (typeof getBrokerageFirmOutputFirmTypeEnum)[keyof typeof getBrokerageFirmOutputFirmTypeEnum];

export type GetBrokerageFirmOutput = {
    /**
     * @description custom fields per product
     * @type array | undefined
    */
    customFields?: CustomFieldDto[];
    /**
     * @description Entity type
     * @type string
    */
    type: string;
    /**
     * @description Brokerage firm type
     * @type string
    */
    firmType: GetBrokerageFirmOutputFirmTypeEnumKey;
    /**
     * @description Brokerage firm id
     * @type string
    */
    id: string;
    /**
     * @description Brokerage firm id
     * @type string | undefined
    */
    parentBrokerageFirmId?: string;
    /**
     * @description Company info
    */
    companyInfo: FormattedSirenDataDto;
    /**
     * @description Creation date of brokerage firm
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description Tenant id
     * @type string
    */
    tenantId: string;
    /**
     * @type string | undefined
    */
    preferredPaymentMethodId?: string;
    /**
     * @description Active products
     * @type array
    */
    activeProducts: string[];
    /**
     * @description Inactive products
     * @type array
    */
    inactiveProducts: string[];
};

export type ListBrokerageFirmsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: BrokerageFirmDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const brokerageFirmGenerateDocumentUploadUrlInputBodyTypeEnum = {
    supporting_document: "supporting_document",
    non_delegated: "non_delegated"
} as const;

export type BrokerageFirmGenerateDocumentUploadUrlInputBodyTypeEnumKey = (typeof brokerageFirmGenerateDocumentUploadUrlInputBodyTypeEnum)[keyof typeof brokerageFirmGenerateDocumentUploadUrlInputBodyTypeEnum];

export type BrokerageFirmGenerateDocumentUploadUrlInputBody = {
    /**
     * @type string | undefined
    */
    type?: BrokerageFirmGenerateDocumentUploadUrlInputBodyTypeEnumKey;
    /**
     * @description The document category. Omit while awaiting classification.
     * @type string | undefined
    */
    category?: string;
    /**
     * @description name
     * @type string
    */
    name: string;
    /**
     * @description metadata of the policy
     * @type array | undefined
    */
    metadata?: Metadata[];
};

export type BrokerageFirmGenerateDocumentUploadUrlOutput = {
    /**
     * @description type
     * @type string
    */
    type: string;
    /**
     * @description the document\'s id
     * @type string
    */
    id: string;
    /**
     * @description url of the document
     * @type string
    */
    url: string;
    /**
     * @description the Content-Type header that was signed into the presigned URL
     * @type string | undefined
    */
    contentType?: string;
    /**
     * @description the Content-Disposition header that was signed into the presigned URL
     * @type string | undefined
    */
    contentDisposition?: string;
};

export type BrokerageFirmListDocumentsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DocumentWithSignedUrl[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type BrokerageFirmDeleteDocumentsOutput = object;

export type GenerateReportForBrokerageFirmOutput = object;

export type GetReportConfigForBrokerageFirmOutput = {
    /**
     * @type array
    */
    availableProductIds: string[];
    /**
     * @type array
    */
    params: ReportParamConfigDto[];
};

export type ListReportsForBrokerageFirmOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ReportDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const brokerageFirmTypeEnum = {
    WHOLESALE: "WHOLESALE",
    RETAIL: "RETAIL",
    TEAM: "TEAM"
} as const;

export type BrokerageFirmTypeEnumKey = (typeof brokerageFirmTypeEnum)[keyof typeof brokerageFirmTypeEnum];

export type BrokerageFirmType = BrokerageFirmTypeEnumKey;

export type CommissionedFirmsKpiDto = {
    /**
     * @description The latest closed month of the year (yyyy-MM)
     * @type string
    */
    period: string;
    /**
     * @description Retail firms the month transferred money to
     * @type number
    */
    commissionedCount: number;
    /**
     * @description Retail firms the month wrote a statement for
     * @type number
    */
    activeCount: number;
};

export type CommissionStatementsKpisDto = {
    /**
     * @description What the year transferred so far, in cents
     * @type number
    */
    totalCents: number;
    /**
     * @description Number of closed months in the year
     * @type number
    */
    closedMonths: number;
    /**
     * @description Average transferred per closed month, in cents; 0 without any
     * @type number
    */
    monthlyAverageCents: number;
    /**
     * @description What a retail firm is still owed after its latest closed month, any year, in cents; may be negative. Null for a wholesale firm
     * @type number
    */
    outstandingCents: number | null;
    /**
     * @description How many retail firms the latest closed month of the year paid. Null for a retail firm, or a year without a closed month
     * @type object
    */
    commissionedFirms: CommissionedFirmsKpiDto | null;
};

export const commissionStatementFileFormatEnum = {
    CSV: "CSV",
    XML: "XML",
    PDF: "PDF"
} as const;

export type CommissionStatementFileFormatEnumKey = (typeof commissionStatementFileFormatEnum)[keyof typeof commissionStatementFileFormatEnum];

export type CommissionStatementFileFormat = CommissionStatementFileFormatEnumKey;

export type CommissionStatementFileDto = {
    /**
     * @type string
    */
    name: string;
    format: CommissionStatementFileFormat;
    /**
     * @type string
    */
    signedUrl: string;
};

export type CommissionStatementMonthDto = {
    /**
     * @description The calendar month, ISO 8601 `yyyy-MM` in Europe/Paris
     * @type string
    */
    period: string;
    /**
     * @description Whether the month carries statements, i.e. it has been closed
     * @type boolean
    */
    closed: boolean;
    /**
     * @description What was due at the close of the month, carried-over balance included, in cents; 0 while it is open
     * @type number
    */
    amountDueCents: number;
    /**
     * @description What was actually transferred for the month, in cents; 0 while it is open
     * @type number
    */
    amountToTransferCents: number;
    /**
     * @description The monthly report, and for a wholesale firm the pain.001 transfer files
     * @type array
    */
    files: CommissionStatementFileDto[];
};

export type CommissionStatementAnnualDeclarationDto = {
    /**
     * @description The exercise the declaration covers
     * @type number
    */
    year: number;
    /**
     * @description What the exercise transferred to the retail firm, in cents
     * @type number
    */
    totalCents: number;
    /**
     * @description Whether December is closed, so the declaration can be issued
     * @type boolean
    */
    available: boolean;
};

export type ListCommissionStatementsForBrokerageFirmOutput = {
    firmType: BrokerageFirmType;
    /**
     * @description The calendar year the months and KPIs cover, in Europe/Paris
     * @type number
    */
    year: number;
    /**
     * @description Calendar years that can carry statements, from the tenant floor to the current one
     * @type array
    */
    years: number[];
    /**
     * @description Whether the firm carries an IBAN a transfer can be made with
     * @type boolean
    */
    hasValidIban: boolean;
    /**
     * @type object
    */
    kpis: CommissionStatementsKpisDto;
    /**
     * @description The twelve months, January first
     * @type array
    */
    months: CommissionStatementMonthDto[];
    /**
     * @description Annual tax declarations of a retail firm, newest exercise first; empty for a wholesale firm
     * @type array
    */
    annualDeclarations: CommissionStatementAnnualDeclarationDto[];
};

export const commissionStatementDocumentTypeEnum = {
    ANNUAL_DECLARATION: "ANNUAL_DECLARATION"
} as const;

export type CommissionStatementDocumentTypeEnumKey = (typeof commissionStatementDocumentTypeEnum)[keyof typeof commissionStatementDocumentTypeEnum];

export type CommissionStatementDocumentType = CommissionStatementDocumentTypeEnumKey;

export type GetCommissionStatementDocumentInputBody = {
    type: CommissionStatementDocumentType;
    /**
     * @description The period the document covers: `yyyy` for a year, `yyyy-MM` for a month
     * @type string
    */
    period: string;
};

export type GetPaymentMethodSetupSecretForBrokerageFirmOutput = {
    /**
     * @description Client secret to setup a payment method
     * @type string
    */
    clientSecret: string;
};

export type GetBrokerageFirmPaymentMethodsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: PaymentMethodDtoWithIsPreferred[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export const generateDocumentsForSignatureDocumentTypeEnum = {
    SEPA_MANDATE: "SEPA_MANDATE",
    DISTRIBUTION_CONTRACT: "DISTRIBUTION_CONTRACT",
    OTHER: "OTHER"
} as const;

export type GenerateDocumentsForSignatureDocumentTypeEnumKey = (typeof generateDocumentsForSignatureDocumentTypeEnum)[keyof typeof generateDocumentsForSignatureDocumentTypeEnum];

export type GenerateDocumentsForSignatureDocumentType = GenerateDocumentsForSignatureDocumentTypeEnumKey;

export type GenerateDocumentsForSignatureOutput = {
    /**
     * @description List of document ids
     * @type array
    */
    ids: string[];
};

export const generateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnum = {
    EMAIL: "EMAIL",
    URL: "URL"
} as const;

export type GenerateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnumKey = (typeof generateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnum)[keyof typeof generateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnum];

export type GenerateSignatureRequestForBrokerageFirmInputBody = {
    /**
     * @description The delivery mode of the signature request. An email sent to the signer or a URL for an embed signature.
     * @type string
    */
    deliveryMode: GenerateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnumKey;
};

export type GenerateSignatureRequestForBrokerageFirmOutput = {
    /**
     * @description the signature requests
     * @type array
    */
    signatures: SignatureRequestOutput[];
};

export type MissingBrokerageFirmContactFieldsDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type array
    */
    missingFields: string[];
};

export const missingBrokerageFirmContactFieldsErrorDtoCodeEnum = {
    MISSING_BROKERAGE_FIRM_CONTACT_FIELDS: "MISSING_BROKERAGE_FIRM_CONTACT_FIELDS"
} as const;

export type MissingBrokerageFirmContactFieldsErrorDtoCodeEnumKey = (typeof missingBrokerageFirmContactFieldsErrorDtoCodeEnum)[keyof typeof missingBrokerageFirmContactFieldsErrorDtoCodeEnum];

export type MissingBrokerageFirmContactFieldsErrorDto = {
    /**
     * @type string
    */
    code: MissingBrokerageFirmContactFieldsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingBrokerageFirmContactFieldsDetailsDto;
};

export const generateMandateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnum = {
    EMAIL: "EMAIL",
    URL: "URL"
} as const;

export type GenerateMandateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnumKey = (typeof generateMandateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnum)[keyof typeof generateMandateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnum];

export type GenerateMandateSignatureRequestForBrokerageFirmInputBody = {
    /**
     * @description the delivery mode
     * @type string
    */
    deliveryMode: GenerateMandateSignatureRequestForBrokerageFirmInputBodyDeliveryModeEnumKey;
};

export type GenerateMandateSignatureRequestForBrokerageFirmOutput = {
    /**
     * @description the signature requests
     * @type array
    */
    signatures: SignatureRequestOutput[];
};

export type DeleteBrokerageFirmPaymentMethodOutput = object;

export type TransferPoliciesToBrokerageFirmInputBody = {
    /**
     * @description the policy ids to transfer
     * @type array
    */
    policyIds: string[];
};

export type TransferPoliciesToBrokerageFirmOutput = object;

export type DistributionRequestConflictDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    reason: string;
};

export const distributionRequestConflictErrorDtoCodeEnum = {
    DISTRIBUTION_REQUEST_CONFLICT: "DISTRIBUTION_REQUEST_CONFLICT"
} as const;

export type DistributionRequestConflictErrorDtoCodeEnumKey = (typeof distributionRequestConflictErrorDtoCodeEnum)[keyof typeof distributionRequestConflictErrorDtoCodeEnum];

export type DistributionRequestConflictErrorDto = {
    /**
     * @type string
    */
    code: DistributionRequestConflictErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DistributionRequestConflictDto;
};

export type CreateManyDistributionRequestsBody = {
    /**
     * @description Product the request is for
     * @type array
    */
    productIds: string[];
    /**
     * @description Brokerage firm the request is attached to
     * @type string
    */
    brokerageFirmId: string;
};

export type BaseEntityOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type CreateManyDistributionRequestsOutput = {
    /**
     * @description Distribution requests
     * @type array
    */
    results: BaseEntityOutput[];
};

export type DistributionRequestNotFoundDto = {
    /**
     * @type string
    */
    distributionRequestId: string;
};

export const distributionRequestNotFoundErrorDtoCodeEnum = {
    DISTRIBUTION_REQUEST_NOT_FOUND: "DISTRIBUTION_REQUEST_NOT_FOUND"
} as const;

export type DistributionRequestNotFoundErrorDtoCodeEnumKey = (typeof distributionRequestNotFoundErrorDtoCodeEnum)[keyof typeof distributionRequestNotFoundErrorDtoCodeEnum];

export type DistributionRequestNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DistributionRequestNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DistributionRequestNotFoundDto;
};

export type ApproveDistributionRequestOutput = object;

export type WaitingForSignatureDistributionRequestOutput = object;

export type DenyDistributionRequestOutput = object;

export type RevokeDistributionRequestOutput = object;

export type GetDistributionRequestOutput = {
    /**
     * @description Unique identifier for the distribution request
     * @type string
    */
    id: string;
    /**
     * @description entity type
     * @type string
    */
    type: string;
    /**
     * @description Status of the distribution request
    */
    status: DistributionRequestStatus;
    /**
     * @description Brokerage firm the request is attached to
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Product the request is for
     * @type string
    */
    productId: string;
    /**
     * @description Date the request was created
     * @type string, date-time
    */
    createdAt: string;
};

export type DeleteDistributionRequestOutput = object;

export type ListDistributionRequestsBody = {
    /**
     * @description the page info
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
    */
    order?: OrderDto;
};

export type ListDistributionRequestsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: DistributionRequestDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type CreateBrokerageFeeBody = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @description Min commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommission?: number;
    /**
     * @description Max commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommission?: number;
    /**
     * @description Default commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    defaultCommission?: number;
    /**
     * @description Min commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommissionLimit?: number;
    /**
     * @description Max commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommissionLimit?: number;
    /**
     * @description Min total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minTotalCommission?: number;
    /**
     * @description Max total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxTotalCommission?: number;
    /**
     * @description Min management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    minManagementFee?: number;
    /**
     * @description Max management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    maxManagementFee?: number;
};

export type CreateBrokerageFeeOutput = {
    /**
     * @description type of entity
     * @type string
    */
    type: string;
    /**
     * @description id of the entity
     * @type string
    */
    id: string;
};

export type BrokerageFeeNotFoundDto = {
    /**
     * @type string
    */
    id: string;
};

export const brokerageFeeNotFoundErrorDtoCodeEnum = {
    BROKERAGE_FEE_NOT_FOUND: "BROKERAGE_FEE_NOT_FOUND"
} as const;

export type BrokerageFeeNotFoundErrorDtoCodeEnumKey = (typeof brokerageFeeNotFoundErrorDtoCodeEnum)[keyof typeof brokerageFeeNotFoundErrorDtoCodeEnum];

export type BrokerageFeeNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFeeNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFeeNotFoundDto;
};

export type UpdateBrokerageFeeBody = {
    /**
     * @description Min commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommission?: number;
    /**
     * @description Max commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommission?: number;
    /**
     * @description Default commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    defaultCommission?: number;
    /**
     * @description Min commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommissionLimit?: number;
    /**
     * @description Max commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommissionLimit?: number;
    /**
     * @description Min total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minTotalCommission?: number;
    /**
     * @description Max total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxTotalCommission?: number;
    /**
     * @description Min management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    minManagementFee?: number;
    /**
     * @description Max management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    maxManagementFee?: number;
};

export type UpdateBrokerageFeeOutput = object;

export type DeleteBrokerageFeeOutput = object;

export type BrokerageFeeDto = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @description Min commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommission?: number;
    /**
     * @description Max commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommission?: number;
    /**
     * @description Default commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    defaultCommission?: number;
    /**
     * @description Min commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minCommissionLimit?: number;
    /**
     * @description Max commission fee percentage limit
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxCommissionLimit?: number;
    /**
     * @description Min total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    minTotalCommission?: number;
    /**
     * @description Max total commission fee percentage
     * @minLength 0
     * @maxLength 100
     * @type number | undefined
    */
    maxTotalCommission?: number;
    /**
     * @description Min management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    minManagementFee?: number;
    /**
     * @description Max management fee amount in cents
     * @minLength 0
     * @type number | undefined
    */
    maxManagementFee?: number;
    /**
     * @description Brokerage fee id
     * @type string
    */
    id: string;
};

export type GetBrokerageFeesOutput = {
    /**
     * @description Brokerage fees on the brokerage firm
     * @type array
    */
    fees: BrokerageFeeDto[];
};

export type UpsertExternalServiceUserIdInputBody = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    userId: string;
    /**
     * @type string
    */
    externalServiceUserId: string;
};

export type UpsertExternalServiceUserIdOutput = {
    /**
     * @type string
    */
    externalServiceUserId: string;
};

export type CreateAccountInputBody = {
    /**
     * @type string
    */
    email: string;
};

export type CreateAccountOutput = {
    /**
     * @type string
    */
    accountId: string;
};

export type CreateAccountLinkOutput = {
    /**
     * @type string
    */
    url: string;
};

export type StartMigrationWorkflowBody = {
    /**
     * @description Optional migration directory to use for the new migration. If not provided, a new directory will be created.
     * @type string | undefined
    */
    migrationDir?: string;
    /**
     * @description Optional step to start the migration from (extract-and-transform, transform, load)
     * @type string | undefined
    */
    startAt?: string;
    /**
     * @description If true, runs the migration in dry run mode and deletes all data at the end
     * @type boolean | undefined
    */
    testRun?: boolean;
    /**
     * @description The index to start the migration at, optional, can be used to test a specific subset
     * @type number | undefined
    */
    startIndex?: number;
    /**
     * @description The index to end the migration at, can be used to test a specific subset
     * @type number | undefined
    */
    endIndex?: number;
    /**
     * @description Whether to include existing brokerage firms in the migration
     * @type boolean | undefined
    */
    includeExistingFirms?: boolean;
    /**
     * @description Tenant-specific options for the migration orchestrator
     * @type object | undefined
    */
    options?: object;
    /**
     * @description If true, skips rebuilding projections during the load step
     * @type boolean | undefined
    */
    skipRebuildProjections?: boolean;
    /**
     * @description If true, skips reindexing search collections during the load step
     * @type boolean | undefined
    */
    skipReindexSearch?: boolean;
    /**
     * @description If true, skips loading payment methods during the load step. Run the payment-methods-migration workflow separately afterwards.
     * @type boolean | undefined
    */
    skipPaymentMethods?: boolean;
};

export type StartMigrationWorkflowOutput = {
    /**
     * @description The migration task ID for tracking the migration
     * @type string
    */
    taskId: string;
    /**
     * @description The migration directory where files are stored
     * @type string
    */
    migrationDir: string;
    /**
     * @description The workflow run ID for tracking the migration progress
     * @type string
    */
    workflowRunId: string;
};

export type StartPaymentMethodsMigrationBody = {
    /**
     * @description The migration directory with transformed data already present in S3 (payment-methods_payments.json).
     * @type string
    */
    migrationDir: string;
};

export type StartPaymentMethodsMigrationOutput = {
    /**
     * @description The workflow run ID for tracking the payment methods migration progress
     * @type string
    */
    workflowRunId: string;
    /**
     * @description The migration directory used
     * @type string
    */
    migrationDir: string;
};

export type _Object = object;

export const efficialeCheckComplianceOutputControlTypeEnum = {
    individual: "individual",
    organization: "organization"
} as const;

export type EfficialeCheckComplianceOutputControlTypeEnumKey = (typeof efficialeCheckComplianceOutputControlTypeEnum)[keyof typeof efficialeCheckComplianceOutputControlTypeEnum];

export type EfficialeCheckComplianceOutput = {
    /**
     * @description Name of the individual or organization
     * @type string
    */
    name: string;
    /**
     * @description Type of conytrol (individual or organization)
     * @type string
    */
    controlType: EfficialeCheckComplianceOutputControlTypeEnumKey;
    /**
     * @description Control list to check against (gel, ppe_nat, ppe_inter)
     * @type string
    */
    controlList: string;
    /**
     * @description Birth date in Y, Y-m or Y-m-d format
     * @type string | undefined
    */
    birthDate?: string;
    /**
     * @description Internal ID of the individual or organization
     * @type string | undefined
    */
    internalId?: string;
    /**
     * @description Minimum accuracy of the check
     * @type integer
    */
    minAccuracy: number;
    /**
     * @description Total number of alerts found
     * @type integer
    */
    total: number;
    /**
     * @description List of alerts found
     * @type array
    */
    alerts: object[];
};

export type GetAlertsOutput = {
    /**
     * @description Total number of alerts found
     * @type integer
    */
    total: number;
    /**
     * @description List of alerts found
     * @type array
    */
    alerts: object[];
};

export type GetSolvabilityScoreInputBody = {
    /**
     * @description Siret to search
     * @type string
    */
    siret: string;
};

export type EllisphereReportHeader = {
    /**
     * @description Provider information
     * @type object
    */
    provider: object;
    /**
     * @description Report information
     * @type object
    */
    report: object;
    /**
     * @description Order information
     * @type object
    */
    order: object;
};

export type EllisphereIntlReport = {
    /**
     * @description Report version
     * @type string
    */
    "@version": string;
    /**
     * @description Report revision
     * @type string
    */
    "@revision": string;
    /**
     * @description Report header
    */
    header: EllisphereReportHeader;
    /**
     * @description Company identity information
     * @type object | undefined
    */
    companyIdentity?: object;
    /**
     * @description Company details
     * @type object | undefined
    */
    companyDetails?: object;
    /**
     * @description Establishment information
     * @type array | undefined
    */
    establishment?: string[];
    /**
     * @description Establishments breakdown
     * @type object | undefined
    */
    establishmentsBreakDown?: object;
    /**
     * @description Company characteristics
     * @type object | undefined
    */
    characteristics?: object;
    /**
     * @description Company appointments
     * @type object | undefined
    */
    companyAppointments?: object;
    /**
     * @description Company events
     * @type array | undefined
    */
    event?: string[];
    /**
     * @description Assessment data
     * @type object | undefined
    */
    assessmentData?: object;
    /**
     * @description Comments on financials
     * @type object | undefined
    */
    commentsOnFinancials?: object;
};

export type EllisphereOnlineOrderOutput = {
    /**
     * @description International report data
    */
    intlReport: EllisphereIntlReport;
};

export type GetSolvabilityScoreOutput = {
    /**
     * @description Solvability score
     * @type string | undefined
    */
    score?: string;
    /**
     * @description Risk class comment
     * @type string | undefined
    */
    riskClassComment?: string;
    /**
     * @description Detailed score comment
     * @type string | undefined
    */
    scoreComment?: string;
};

export type GetMetabaseIframeUrlOutput = {
    /**
     * @description Iframe URL for Metabase dashboard
     * @type string
    */
    iframeUrl: string;
};

export type FvaUploadFileOutput = {
    /**
     * @type string
    */
    codeStatut: string;
    /**
     * @type string
    */
    libelleStatut: string;
    /**
     * @type string
    */
    refFichierInterne: string;
    /**
     * @type string | undefined
    */
    dateDepot?: string;
    /**
     * @description URL to retrieve the CR
     * @type string
    */
    urlRetour: string;
    /**
     * @description Code to use to retrieve the CR (FVA_CodeOperation)
     * @type string
    */
    refInterneEmetteur: string;
    /**
     * @type string | undefined
    */
    retrieveReportOutcomeJobId?: string;
};

export type FvaRetrieveReportOutcomeOutput = {
    /**
     * @type array
    */
    acceptedRegistrationNumbers: string[];
    /**
     * @type array
    */
    rejections: string[];
};

export const documentValidityRuleResultDtoRuleTypeEnum = {
    READABLE: "READABLE",
    REQUIRED_FIELDS: "REQUIRED_FIELDS",
    PROMPT: "PROMPT",
    FIELD_VALIDATION: "FIELD_VALIDATION"
} as const;

export type DocumentValidityRuleResultDtoRuleTypeEnumKey = (typeof documentValidityRuleResultDtoRuleTypeEnum)[keyof typeof documentValidityRuleResultDtoRuleTypeEnum];

export type DocumentValidityRuleResultDto = {
    /**
     * @description Rule type that was checked
     * @type string
    */
    ruleType: DocumentValidityRuleResultDtoRuleTypeEnumKey;
    /**
     * @description Whether the rule passed
     * @type boolean
    */
    passed: boolean;
    /**
     * @description Failure message if rule did not pass
     * @type string | undefined
    */
    message?: string;
    /**
     * @description Additional metadata about the rule result
     * @type object | undefined
    */
    metadata?: object;
};

export type ValidityOverrideDto = {
    /**
     * @description User ID who performed the override
     * @type string
    */
    overriddenBy: string;
    /**
     * @description ISO timestamp of the override
     * @type string
    */
    overriddenAt: string;
    /**
     * @description Status before the override
     * @type string
    */
    previousStatus: string;
    /**
     * @description Original AI-determined status before any manual override
     * @type string | undefined
    */
    originalStatus?: string;
    /**
     * @description Why the user corrected the platform result
     * @type string | undefined
    */
    reason?: string;
};

export const getDocumentValidityOutputStatusEnum = {
    PENDING: "PENDING",
    VALID: "VALID",
    INVALID: "INVALID",
    FAILED: "FAILED",
    SKIPPED: "SKIPPED"
} as const;

export type GetDocumentValidityOutputStatusEnumKey = (typeof getDocumentValidityOutputStatusEnum)[keyof typeof getDocumentValidityOutputStatusEnum];

export type GetDocumentValidityOutput = {
    /**
     * @description Document ID
     * @type string
    */
    documentId: string;
    /**
     * @description Overall validity status
     * @type string
    */
    status: GetDocumentValidityOutputStatusEnumKey;
    /**
     * @description Results for each validity rule
     * @type array
    */
    results: DocumentValidityRuleResultDto[];
    /**
     * @description AI validity metadata
     * @type object | undefined
    */
    aiMetadata?: object;
    /**
     * @description Last check timestamp
     * @type string | undefined
    */
    checkedAt?: string;
    /**
     * @description Override metadata if validity was manually overridden
    */
    override?: ValidityOverrideDto;
};

export type GetPolicyValidityOutput = {
    /**
     * @description List of document validity results for the policy
     * @type array
    */
    validities: GetDocumentValidityOutput[];
};

export type DocumentValidityFailedDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const documentValidityFailedErrorDtoCodeEnum = {
    DOCUMENT_VALIDITY_FAILED: "DOCUMENT_VALIDITY_FAILED"
} as const;

export type DocumentValidityFailedErrorDtoCodeEnumKey = (typeof documentValidityFailedErrorDtoCodeEnum)[keyof typeof documentValidityFailedErrorDtoCodeEnum];

export type DocumentValidityFailedErrorDto = {
    /**
     * @type string
    */
    code: DocumentValidityFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentValidityFailedDetailsDto;
};

export const overrideValidityBodyStatusEnum = {
    VALID: "VALID",
    INVALID: "INVALID"
} as const;

export type OverrideValidityBodyStatusEnumKey = (typeof overrideValidityBodyStatusEnum)[keyof typeof overrideValidityBodyStatusEnum];

export type OverrideValidityBody = {
    /**
     * @type string
    */
    status: OverrideValidityBodyStatusEnumKey;
    /**
     * @description Why the user corrected the platform result
     * @type string | undefined
    */
    reason?: string;
};

export type GetBrokerageFirmValidityOutput = {
    /**
     * @description List of document validity results for the brokerage firm
     * @type array
    */
    validities: GetDocumentValidityOutput[];
};

export type DocumentCoherenceUnsupportedEntityDetailsDto = {
    /**
     * @type string
    */
    entityId: string;
};

export const documentCoherenceUnsupportedEntityErrorDtoCodeEnum = {
    DOCUMENT_COHERENCE_UNSUPPORTED_ENTITY: "DOCUMENT_COHERENCE_UNSUPPORTED_ENTITY"
} as const;

export type DocumentCoherenceUnsupportedEntityErrorDtoCodeEnumKey = (typeof documentCoherenceUnsupportedEntityErrorDtoCodeEnum)[keyof typeof documentCoherenceUnsupportedEntityErrorDtoCodeEnum];

export type DocumentCoherenceUnsupportedEntityErrorDto = {
    /**
     * @type string
    */
    code: DocumentCoherenceUnsupportedEntityErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentCoherenceUnsupportedEntityDetailsDto;
};

export const documentCoherenceFieldDtoEntityTypeEnum = {
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    BROKERAGE_FIRM: "BROKERAGE_FIRM"
} as const;

export type DocumentCoherenceFieldDtoEntityTypeEnumKey = (typeof documentCoherenceFieldDtoEntityTypeEnum)[keyof typeof documentCoherenceFieldDtoEntityTypeEnum];

export const documentCoherenceFieldDtoFieldTypeEnum = {
    BOOLEAN: "BOOLEAN",
    STRING: "STRING",
    NUMBER: "NUMBER",
    INTEGER: "INTEGER",
    ENUM: "ENUM",
    DATE: "DATE",
    DATETIME: "DATETIME",
    PHONE_NUMBER: "PHONE_NUMBER",
    EMAIL: "EMAIL",
    REGISTRATION_NUMBER: "REGISTRATION_NUMBER",
    SIRET: "SIRET",
    POSTCODE: "POSTCODE",
    URL: "URL",
    IBAN: "IBAN",
    BIC: "BIC",
    ARRAY: "ARRAY"
} as const;

export type DocumentCoherenceFieldDtoFieldTypeEnumKey = (typeof documentCoherenceFieldDtoFieldTypeEnum)[keyof typeof documentCoherenceFieldDtoFieldTypeEnum];

export const documentCoherenceFieldDtoResultEnum = {
    MATCH: "MATCH",
    MISMATCH: "MISMATCH",
    ABSENT: "ABSENT"
} as const;

export type DocumentCoherenceFieldDtoResultEnumKey = (typeof documentCoherenceFieldDtoResultEnum)[keyof typeof documentCoherenceFieldDtoResultEnum];

export type DocumentCoherenceFieldDto = {
    /**
     * @type string
    */
    fieldKey: string;
    /**
     * @type string
    */
    entityType: DocumentCoherenceFieldDtoEntityTypeEnumKey;
    /**
     * @type string
    */
    fieldType: DocumentCoherenceFieldDtoFieldTypeEnumKey;
    /**
     * @description Value typed on the entity, as stored
     * @type string | undefined
    */
    subscriptionValue?: string;
    /**
     * @description Value extracted from the document, as extracted
     * @type string | undefined
    */
    documentValue?: string;
    /**
     * @description ABSENT: a value is missing on one side, which is not a discrepancy
     * @type string
    */
    result: DocumentCoherenceFieldDtoResultEnumKey;
};

export const documentCoherenceDtoStatusEnum = {
    COHERENT: "COHERENT",
    INCOHERENT: "INCOHERENT",
    PENDING: "PENDING"
} as const;

export type DocumentCoherenceDtoStatusEnumKey = (typeof documentCoherenceDtoStatusEnum)[keyof typeof documentCoherenceDtoStatusEnum];

export type DocumentCoherenceDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @description PENDING: extraction not finished yet
     * @type string
    */
    status: DocumentCoherenceDtoStatusEnumKey;
    /**
     * @type array
    */
    fields: DocumentCoherenceFieldDto[];
};

export type GetDocumentCoherenceOutput = {
    /**
     * @description Keyed by documentId; may list documents of the entity that are not on the requested branch
     * @type array
    */
    documents: DocumentCoherenceDto[];
};

export type AcceptDocumentInputBody = {
    /**
     * @type string
    */
    branchId: string;
};

export const documentConformityDtoDecisionEnum = {
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
} as const;

export type DocumentConformityDtoDecisionEnumKey = (typeof documentConformityDtoDecisionEnum)[keyof typeof documentConformityDtoDecisionEnum];

export const documentConformityDtoStatusEnum = {
    ACTIVE: "ACTIVE",
    SUPERSEDED: "SUPERSEDED",
    CANCELLED: "CANCELLED"
} as const;

export type DocumentConformityDtoStatusEnumKey = (typeof documentConformityDtoStatusEnum)[keyof typeof documentConformityDtoStatusEnum];

export type DocumentConformityDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    branchId: string;
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    category: string;
    /**
     * @type string
    */
    decision: DocumentConformityDtoDecisionEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type string
    */
    status: DocumentConformityDtoStatusEnumKey;
    /**
     * @type string
    */
    decidedByUserId: string;
    /**
     * @type string
    */
    decidedAt: string;
};

export type RejectDocumentInputBody = {
    /**
     * @type string
    */
    branchId: string;
    /**
     * @description Required when rejecting a document
     * @type string
    */
    reason: string;
};

export type DocumentConformityUntypedDocumentsDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type array
    */
    documentIds: string[];
};

export const documentConformityUntypedDocumentsErrorDtoCodeEnum = {
    DOCUMENT_CONFORMITY_UNTYPED_DOCUMENTS: "DOCUMENT_CONFORMITY_UNTYPED_DOCUMENTS"
} as const;

export type DocumentConformityUntypedDocumentsErrorDtoCodeEnumKey = (typeof documentConformityUntypedDocumentsErrorDtoCodeEnum)[keyof typeof documentConformityUntypedDocumentsErrorDtoCodeEnum];

export type DocumentConformityUntypedDocumentsErrorDto = {
    /**
     * @type string
    */
    code: DocumentConformityUntypedDocumentsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConformityUntypedDocumentsDetailsDto;
};

export type AcceptAllDocumentsInputBody = {
    /**
     * @type string
    */
    branchId: string;
    /**
     * @description Accept only undecided documents whose AI verdict is CONFORM
     * @type boolean | undefined
    */
    onlyConform?: boolean;
};

export type AcceptAllDocumentsOutput = {
    /**
     * @type array
    */
    conformities: DocumentConformityDto[];
};

export type DocumentConformityNotFoundDetailsDto = {
    /**
     * @type string
    */
    conformityId: string;
    /**
     * @type string
    */
    policyId: string;
};

export const documentConformityNotFoundErrorDtoCodeEnum = {
    DOCUMENT_CONFORMITY_NOT_FOUND: "DOCUMENT_CONFORMITY_NOT_FOUND"
} as const;

export type DocumentConformityNotFoundErrorDtoCodeEnumKey = (typeof documentConformityNotFoundErrorDtoCodeEnum)[keyof typeof documentConformityNotFoundErrorDtoCodeEnum];

export type DocumentConformityNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DocumentConformityNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConformityNotFoundDetailsDto;
};

export type GetPolicyDocumentConformityOutput = {
    /**
     * @type array
    */
    conformities: DocumentConformityDto[];
};

export const documentVerdictChecksDtoClassificationEnum = {
    PASSED: "PASSED",
    FAILED: "FAILED",
    PENDING: "PENDING",
    NOT_RUN: "NOT_RUN"
} as const;

export type DocumentVerdictChecksDtoClassificationEnumKey = (typeof documentVerdictChecksDtoClassificationEnum)[keyof typeof documentVerdictChecksDtoClassificationEnum];

export const documentVerdictChecksDtoValidityEnum = {
    PASSED: "PASSED",
    FAILED: "FAILED",
    PENDING: "PENDING",
    NOT_RUN: "NOT_RUN"
} as const;

export type DocumentVerdictChecksDtoValidityEnumKey = (typeof documentVerdictChecksDtoValidityEnum)[keyof typeof documentVerdictChecksDtoValidityEnum];

export const documentVerdictChecksDtoCoherenceEnum = {
    PASSED: "PASSED",
    FAILED: "FAILED",
    PENDING: "PENDING",
    NOT_RUN: "NOT_RUN"
} as const;

export type DocumentVerdictChecksDtoCoherenceEnumKey = (typeof documentVerdictChecksDtoCoherenceEnum)[keyof typeof documentVerdictChecksDtoCoherenceEnum];

export const documentVerdictChecksDtoFraudEnum = {
    PASSED: "PASSED",
    FAILED: "FAILED",
    PENDING: "PENDING",
    NOT_RUN: "NOT_RUN"
} as const;

export type DocumentVerdictChecksDtoFraudEnumKey = (typeof documentVerdictChecksDtoFraudEnum)[keyof typeof documentVerdictChecksDtoFraudEnum];

export type DocumentVerdictChecksDto = {
    /**
     * @type string
    */
    classification: DocumentVerdictChecksDtoClassificationEnumKey;
    /**
     * @type string
    */
    validity: DocumentVerdictChecksDtoValidityEnumKey;
    /**
     * @type string
    */
    coherence: DocumentVerdictChecksDtoCoherenceEnumKey;
    /**
     * @type string
    */
    fraud: DocumentVerdictChecksDtoFraudEnumKey;
};

export type DocumentCorrectionTraceDto = {
    /**
     * @description ISO timestamp of the correction
     * @type string
    */
    correctedAt: string;
    /**
     * @description Email of the user who made the correction
     * @type string | undefined
    */
    correctedByEmail?: string;
    /**
     * @description Why the user corrected the platform result
     * @type string | undefined
    */
    reason?: string;
};

export type DocumentVerdictCorrectionsDto = {
    /**
     * @type object | undefined
    */
    classification?: DocumentCorrectionTraceDto;
    /**
     * @type object | undefined
    */
    validity?: DocumentCorrectionTraceDto;
};

export const documentVerdictDtoStatusEnum = {
    PROCESSING: "PROCESSING",
    ATTENTION: "ATTENTION",
    CONFORM: "CONFORM"
} as const;

export type DocumentVerdictDtoStatusEnumKey = (typeof documentVerdictDtoStatusEnum)[keyof typeof documentVerdictDtoStatusEnum];

export const documentVerdictDtoReasonsEnum = {
    classification: "classification",
    analysis_failed: "analysis_failed",
    unsafe_document: "unsafe_document",
    validity: "validity",
    validity_unavailable: "validity_unavailable",
    fraud: "fraud",
    coherence: "coherence"
} as const;

export type DocumentVerdictDtoReasonsEnumKey = (typeof documentVerdictDtoReasonsEnum)[keyof typeof documentVerdictDtoReasonsEnum];

export type DocumentVerdictDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    status: DocumentVerdictDtoStatusEnumKey;
    /**
     * @type array
    */
    reasons: DocumentVerdictDtoReasonsEnumKey[];
    /**
     * @type object
    */
    checks: DocumentVerdictChecksDto;
    /**
     * @type object | undefined
    */
    extraction?: GetDocumentExtractionOutput;
    /**
     * @type object | undefined
    */
    validity?: GetDocumentValidityOutput;
    /**
     * @type object | undefined
    */
    fraud?: DocumentFraudScoreDto;
    /**
     * @type object | undefined
    */
    coherence?: DocumentCoherenceDto;
    /**
     * @type object | undefined
    */
    corrections?: DocumentVerdictCorrectionsDto;
};

export const documentCategorySummaryDtoStatusEnum = {
    MISSING: "MISSING",
    TO_REVIEW: "TO_REVIEW",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
} as const;

export type DocumentCategorySummaryDtoStatusEnumKey = (typeof documentCategorySummaryDtoStatusEnum)[keyof typeof documentCategorySummaryDtoStatusEnum];

export type DocumentCategorySummaryDto = {
    /**
     * @type string
    */
    category: string;
    /**
     * @type boolean
    */
    required: boolean;
    /**
     * @type string
    */
    status: DocumentCategorySummaryDtoStatusEnumKey;
};

export type DocumentFileSummaryDto = {
    /**
     * @description Expected categories
     * @type array
    */
    categories: DocumentCategorySummaryDto[];
    /**
     * @description Required categories
     * @type number
    */
    required: number;
    /**
     * @description Required categories with an accepted document
     * @type number
    */
    accepted: number;
    /**
     * @description Required categories with a document the broker has not decided yet
     * @type number
    */
    toReview: number;
    /**
     * @description Required categories with no document
     * @type number
    */
    missing: number;
    /**
     * @description Required categories whose documents were all rejected
     * @type number
    */
    rejected: number;
};

export type GetPolicyDocumentVerdictsOutput = {
    /**
     * @type array
    */
    verdicts: DocumentVerdictDto[];
    /**
     * @type object
    */
    summary: DocumentFileSummaryDto;
    /**
     * @description Undecided documents whose verdict is CONFORM
     * @type number
    */
    conformToAccept: number;
};

export type GetPolicyDocumentFraudOutput = {
    /**
     * @type array
    */
    scores: DocumentFraudScoreDto[];
    /**
     * @description Policy-level aggregate over the attached documents the tenant checks for fraud, an unscored one counting as pending; null when there is none.
     * @type object
    */
    summary?: ClaimFraudSummaryDto | null;
    /**
     * @description Attached documents the tenant checks for fraud that have no fraud result yet.
     * @type array
    */
    unscoredDocumentIds: string[];
};

export type DocumentFraudVerdictConflictDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const documentFraudVerdictConflictErrorDtoCodeEnum = {
    DOCUMENT_FRAUD_VERDICT_CONFLICT: "DOCUMENT_FRAUD_VERDICT_CONFLICT"
} as const;

export type DocumentFraudVerdictConflictErrorDtoCodeEnumKey = (typeof documentFraudVerdictConflictErrorDtoCodeEnum)[keyof typeof documentFraudVerdictConflictErrorDtoCodeEnum];

export type DocumentFraudVerdictConflictErrorDto = {
    /**
     * @type string
    */
    code: DocumentFraudVerdictConflictErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentFraudVerdictConflictDetailsDto;
};

export const correctPolicyDocumentFraudVerdictInputBodyVerdictEnum = {
    clean: "clean",
    review_needed: "review_needed",
    fraud: "fraud"
} as const;

export type CorrectPolicyDocumentFraudVerdictInputBodyVerdictEnumKey = (typeof correctPolicyDocumentFraudVerdictInputBodyVerdictEnum)[keyof typeof correctPolicyDocumentFraudVerdictInputBodyVerdictEnum];

export type CorrectPolicyDocumentFraudVerdictInputBody = {
    /**
     * @description The verdict the manager believes is correct.
     * @type string
    */
    verdict: CorrectPolicyDocumentFraudVerdictInputBodyVerdictEnumKey;
    /**
     * @description Optional notes explaining the correction.
     * @type string | undefined
    */
    notes?: string;
    /**
     * @description The `updatedAt` of the result the broker reviewed; a newer stored result returns 409.
     * @type string
    */
    expectedUpdatedAt: string;
};

export type CorrectPolicyDocumentFraudVerdictOutput = {
    /**
     * @type object
    */
    score: DocumentFraudScoreDto;
};

export const brokerageFirmDocumentConformityDtoDecisionEnum = {
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
} as const;

export type BrokerageFirmDocumentConformityDtoDecisionEnumKey = (typeof brokerageFirmDocumentConformityDtoDecisionEnum)[keyof typeof brokerageFirmDocumentConformityDtoDecisionEnum];

export const brokerageFirmDocumentConformityDtoStatusEnum = {
    ACTIVE: "ACTIVE",
    SUPERSEDED: "SUPERSEDED",
    CANCELLED: "CANCELLED"
} as const;

export type BrokerageFirmDocumentConformityDtoStatusEnumKey = (typeof brokerageFirmDocumentConformityDtoStatusEnum)[keyof typeof brokerageFirmDocumentConformityDtoStatusEnum];

export type BrokerageFirmDocumentConformityDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    category: string;
    /**
     * @type string
    */
    decision: BrokerageFirmDocumentConformityDtoDecisionEnumKey;
    /**
     * @type string | undefined
    */
    reason?: string;
    /**
     * @type string
    */
    status: BrokerageFirmDocumentConformityDtoStatusEnumKey;
    /**
     * @type string
    */
    decidedByUserId: string;
    /**
     * @type string
    */
    decidedAt: string;
};

export type RejectBrokerageFirmDocumentInputBody = {
    /**
     * @description Required when rejecting a document
     * @type string
    */
    reason: string;
};

export type BrokerageFirmDocumentConformityUntypedDocumentsDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type array
    */
    documentIds: string[];
};

export const brokerageFirmDocumentConformityUntypedDocumentsErrorDtoCodeEnum = {
    BROKERAGE_FIRM_DOCUMENT_CONFORMITY_UNTYPED_DOCUMENTS: "BROKERAGE_FIRM_DOCUMENT_CONFORMITY_UNTYPED_DOCUMENTS"
} as const;

export type BrokerageFirmDocumentConformityUntypedDocumentsErrorDtoCodeEnumKey = (typeof brokerageFirmDocumentConformityUntypedDocumentsErrorDtoCodeEnum)[keyof typeof brokerageFirmDocumentConformityUntypedDocumentsErrorDtoCodeEnum];

export type BrokerageFirmDocumentConformityUntypedDocumentsErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmDocumentConformityUntypedDocumentsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmDocumentConformityUntypedDocumentsDetailsDto;
};

export type AcceptAllBrokerageFirmDocumentsOutput = {
    /**
     * @type array
    */
    conformities: BrokerageFirmDocumentConformityDto[];
};

export type BrokerageFirmDocumentConformityNotFoundDetailsDto = {
    /**
     * @type string
    */
    conformityId: string;
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const brokerageFirmDocumentConformityNotFoundErrorDtoCodeEnum = {
    BROKERAGE_FIRM_DOCUMENT_CONFORMITY_NOT_FOUND: "BROKERAGE_FIRM_DOCUMENT_CONFORMITY_NOT_FOUND"
} as const;

export type BrokerageFirmDocumentConformityNotFoundErrorDtoCodeEnumKey = (typeof brokerageFirmDocumentConformityNotFoundErrorDtoCodeEnum)[keyof typeof brokerageFirmDocumentConformityNotFoundErrorDtoCodeEnum];

export type BrokerageFirmDocumentConformityNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmDocumentConformityNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmDocumentConformityNotFoundDetailsDto;
};

export type GetBrokerageFirmDocumentConformityOutput = {
    /**
     * @type array
    */
    conformities: BrokerageFirmDocumentConformityDto[];
};

export type GetBrokerageFirmDocumentFraudOutput = {
    /**
     * @type array
    */
    scores: DocumentFraudScoreDto[];
};

export type CorrectBrokerageFirmDocumentFraudVerdictOutput = {
    /**
     * @type object
    */
    score: DocumentFraudScoreDto;
};

export type GetDocumentCollectionStateOutput = {
    /**
     * @description Whether every required document category has at least one live document.
     * @type boolean
    */
    isComplete: boolean;
    /**
     * @description Required categories with no live document, empty when `isComplete` is true.
     * @type array
    */
    missingCategories: string[];
    /**
     * @description When the collection deadline expires. Null when isComplete, documentCollection is disabled for the product, or the reminder ladder has not started yet.
     * @type string
    */
    windowEndsAt?: string | null;
};

export type GetPolicyExtractionsOutput = {
    /**
     * @description List of document extractions for the policy
     * @type array
    */
    extractions: GetDocumentExtractionOutput[];
};

export type DocumentExtractionNotFoundDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const documentExtractionNotFoundErrorDtoCodeEnum = {
    DOCUMENT_EXTRACTION_NOT_FOUND: "DOCUMENT_EXTRACTION_NOT_FOUND"
} as const;

export type DocumentExtractionNotFoundErrorDtoCodeEnumKey = (typeof documentExtractionNotFoundErrorDtoCodeEnum)[keyof typeof documentExtractionNotFoundErrorDtoCodeEnum];

export type DocumentExtractionNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DocumentExtractionNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentExtractionNotFoundDetailsDto;
};

export const extractDocumentOutputStatusEnum = {
    DONE: "DONE",
    FAILED: "FAILED",
    SKIPPED: "SKIPPED"
} as const;

export type ExtractDocumentOutputStatusEnumKey = (typeof extractDocumentOutputStatusEnum)[keyof typeof extractDocumentOutputStatusEnum];

export type ExtractDocumentOutput = {
    /**
     * @description Extraction status
     * @type string
    */
    status: ExtractDocumentOutputStatusEnumKey;
    /**
     * @description Extracted fields as key-value pairs
     * @type object | undefined
    */
    fields?: object;
    /**
     * @description AI operation ID for tracking
     * @type string | undefined
    */
    aiOperationId?: string;
};

export const submitFeedbackBodyFeedbackTypeEnum = {
    FIELD_CORRECTION: "FIELD_CORRECTION",
    FIELD_VALIDATION: "FIELD_VALIDATION",
    DOCUMENT_REJECTION: "DOCUMENT_REJECTION"
} as const;

export type SubmitFeedbackBodyFeedbackTypeEnumKey = (typeof submitFeedbackBodyFeedbackTypeEnum)[keyof typeof submitFeedbackBodyFeedbackTypeEnum];

export type SubmitFeedbackBody = {
    /**
     * @type string
    */
    feedbackType: SubmitFeedbackBodyFeedbackTypeEnumKey;
    /**
     * @type string | undefined
    */
    fieldKey?: string;
    /**
     * @type string | undefined
    */
    originalValue?: string;
    /**
     * @type string | undefined
    */
    correctedValue?: string;
    /**
     * @type string | undefined
    */
    comment?: string;
};

export type SubmitExtractionFeedbackOutput = {
    /**
     * @description ID of the persisted feedback record
     * @type string
    */
    feedbackId: string;
};

export const extractionFeedbackItemDtoFeedbackTypeEnum = {
    FIELD_CORRECTION: "FIELD_CORRECTION",
    FIELD_VALIDATION: "FIELD_VALIDATION",
    DOCUMENT_REJECTION: "DOCUMENT_REJECTION"
} as const;

export type ExtractionFeedbackItemDtoFeedbackTypeEnumKey = (typeof extractionFeedbackItemDtoFeedbackTypeEnum)[keyof typeof extractionFeedbackItemDtoFeedbackTypeEnum];

export type ExtractionFeedbackItemDto = {
    /**
     * @description Feedback ID
     * @type string
    */
    feedbackId: string;
    /**
     * @description Feedback type
     * @type string
    */
    feedbackType: ExtractionFeedbackItemDtoFeedbackTypeEnumKey;
    /**
     * @description Field key
     * @type string | undefined
    */
    fieldKey?: string;
    /**
     * @description Original value
     * @type string | undefined
    */
    originalValue?: string;
    /**
     * @description Corrected value
     * @type string | undefined
    */
    correctedValue?: string;
    /**
     * @description User comment
     * @type string | undefined
    */
    comment?: string;
    /**
     * @description User ID who provided feedback
     * @type string
    */
    userId: string;
    /**
     * @description Feedback creation timestamp
     * @type string
    */
    createdAt: string;
};

export type GetExtractionFeedbackOutput = {
    /**
     * @description List of feedback items for the document
     * @type array
    */
    feedback: ExtractionFeedbackItemDto[];
};

export type GetBrokerageFirmExtractionsOutput = {
    /**
     * @description List of document extractions for the brokerage firm
     * @type array
    */
    extractions: GetDocumentExtractionOutput[];
};

export const recordPrefillOutcomeBodyEntityTypeEnum = {
    customer: "customer",
    asset: "asset",
    policy: "policy",
    brokerage_firm: "brokerage_firm"
} as const;

export type RecordPrefillOutcomeBodyEntityTypeEnumKey = (typeof recordPrefillOutcomeBodyEntityTypeEnum)[keyof typeof recordPrefillOutcomeBodyEntityTypeEnum];

export type RecordPrefillOutcomeBody = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    customFieldKey: string;
    /**
     * @type string
    */
    extractionFieldKey: string;
    /**
     * @type string | undefined
    */
    documentCategory?: string;
    /**
     * @type string
    */
    entityType: RecordPrefillOutcomeBodyEntityTypeEnumKey;
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @type boolean
    */
    kept: boolean;
    /**
     * @type string
    */
    prefilledValue: string;
    /**
     * @type string | undefined
    */
    finalValue?: string;
    /**
     * @type number
    */
    finalValueLength: number;
    /**
     * @type boolean
    */
    finalValueEmpty: boolean;
};

export type RecordPrefillOutcomeOutput = {
    /**
     * @description Semantic id of the Dash0/OTel prefill operation
     * @type string
    */
    outcomeId: string;
    /**
     * @description Semantic id of the Dash0/OTel prefill operation
     * @type string | undefined
    */
    aiOperationId?: string;
};

export const createImpersonationSessionBodySurfaceEnum = {
    PORTAL: "PORTAL",
    BROKER_APP: "BROKER_APP"
} as const;

export type CreateImpersonationSessionBodySurfaceEnumKey = (typeof createImpersonationSessionBodySurfaceEnum)[keyof typeof createImpersonationSessionBodySurfaceEnum];

export type CreateImpersonationSessionBody = {
    /**
     * @description Tenant owning the impersonated user.
     * @type string
    */
    tenantId: string;
    /**
     * @description Cognito sub of the end user to impersonate.
     * @type string
    */
    userId: string;
    /**
     * @description Frontend to open the session on. Defaults to the tenant\'s customer portal.
     * @default "PORTAL"
     * @type string | undefined
    */
    surface?: CreateImpersonationSessionBodySurfaceEnumKey;
};

export type CreateImpersonationSessionResponse = {
    /**
     * @description Bearer token authenticating as the target user. Hand it to the portal in a URL fragment — never a query string.
     * @type string
    */
    token: string;
    /**
     * @type string
    */
    sessionId: string;
    /**
     * @type string
    */
    expiresAt: string;
    /**
     * @description Origin of the frontend this session is valid for.
     * @type string
    */
    frontendUrl: string;
    /**
     * @description Email of the impersonated user, for the confirmation UI.
     * @type string
    */
    targetEmail: string;
};

export type ImpersonationSessionDto = {
    /**
     * @description Session id — also the minted token’s `jti`.
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @description Cognito sub of the impersonated end user.
     * @type string
    */
    targetUserId: string;
    /**
     * @description Cognito sub of the Korint staff member who started the session.
     * @type string
    */
    actorSub: string;
    /**
     * @type string | undefined
    */
    actorUsername?: string;
    /**
     * @type string | undefined
    */
    sourceIp?: string;
    /**
     * @type string
    */
    expiresAt: string;
    /**
     * @type string | undefined
    */
    revokedAt?: string;
    /**
     * @type string
    */
    createdAt: string;
};

export type ListImpersonationSessionsOutput = {
    /**
     * @description the list of items in the page
     * @type array
    */
    data: ImpersonationSessionDto[];
    /**
     * @description the page info
    */
    pageInfo: ResponsePageInfo;
    /**
     * @description the total number of items
     * @type number
    */
    totalCount: number;
    /**
     * @description the current page
     * @type number
    */
    currentPage: number;
    /**
     * @description the total number of pages
     * @type number
    */
    totalPages: number;
};

export type RevokeImpersonationSessionResponse = {
    /**
     * @type boolean
    */
    revoked: boolean;
};

export type RevokeFederatedSessionResponse = {
    /**
     * @type boolean
    */
    revoked: boolean;
};

export const awsTranscribeCredentialsDtoProviderEnum = {
    "aws-transcribe": "aws-transcribe"
} as const;

export type AwsTranscribeCredentialsDtoProviderEnumKey = (typeof awsTranscribeCredentialsDtoProviderEnum)[keyof typeof awsTranscribeCredentialsDtoProviderEnum];

export type AwsTranscribeCredentialsDto = {
    /**
     * @type string
    */
    provider: AwsTranscribeCredentialsDtoProviderEnumKey;
    /**
     * @type string
    */
    accessKeyId: string;
    /**
     * @type string
    */
    secretAccessKey: string;
    /**
     * @type string
    */
    sessionToken: string;
    /**
     * @type string
    */
    region: string;
    /**
     * @type string
    */
    expiresAt: string;
};

export const elevenLabsCredentialsDtoProviderEnum = {
    elevenlabs: "elevenlabs"
} as const;

export type ElevenLabsCredentialsDtoProviderEnumKey = (typeof elevenLabsCredentialsDtoProviderEnum)[keyof typeof elevenLabsCredentialsDtoProviderEnum];

export type ElevenLabsCredentialsDto = {
    /**
     * @type string
    */
    provider: ElevenLabsCredentialsDtoProviderEnumKey;
    /**
     * @type string
    */
    wsUrl: string;
    /**
     * @type string
    */
    signedToken: string;
    /**
     * @type string
    */
    expiresAt: string;
};

export type SpeechToTextCredentialsRequestDto = {
    /**
     * @description Product semantic id to resolve SPEECH_TO_TEXT provider for
     * @type string | undefined
    */
    productId?: string;
};

export type InitWhatsappConversationInput = {
    /**
     * @description Phone number in E.164 format without the leading \"+\" (e.g. 33612345678).
     * @type string
    */
    phoneNumber: string;
};

export type InitWhatsappConversationOutput = {
    /**
     * @description Status returned by FCB (\"ok\" on success).
     * @type string
    */
    status: string;
};

export type DynamicConfigUnavailableDetailsDto = {
    /**
     * @type string
    */
    product: string;
};

export const dynamicConfigUnavailableErrorDtoCodeEnum = {
    DYNAMIC_CONFIG_UNAVAILABLE: "DYNAMIC_CONFIG_UNAVAILABLE"
} as const;

export type DynamicConfigUnavailableErrorDtoCodeEnumKey = (typeof dynamicConfigUnavailableErrorDtoCodeEnum)[keyof typeof dynamicConfigUnavailableErrorDtoCodeEnum];

export type DynamicConfigUnavailableErrorDto = {
    /**
     * @type string
    */
    code: DynamicConfigUnavailableErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DynamicConfigUnavailableDetailsDto;
};

export type InvalidAssetTierDetailsDto = {
    /**
     * @type string
    */
    asset: string;
    /**
     * @type string
    */
    invalidTier: string;
    /**
     * @type array
    */
    availableTiers: string[];
};

export const invalidAssetTierErrorDtoCodeEnum = {
    INVALID_ASSET_TIER: "INVALID_ASSET_TIER"
} as const;

export type InvalidAssetTierErrorDtoCodeEnumKey = (typeof invalidAssetTierErrorDtoCodeEnum)[keyof typeof invalidAssetTierErrorDtoCodeEnum];

export type InvalidAssetTierErrorDto = {
    /**
     * @type string
    */
    code: InvalidAssetTierErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidAssetTierDetailsDto;
};

export type TokenExpiredDetailsDto = {
    /**
     * @type string
    */
    token: string;
};

export const tokenExpiredErrorDtoCodeEnum = {
    TOKEN_EXPIRED: "TOKEN_EXPIRED"
} as const;

export type TokenExpiredErrorDtoCodeEnumKey = (typeof tokenExpiredErrorDtoCodeEnum)[keyof typeof tokenExpiredErrorDtoCodeEnum];

export type TokenExpiredErrorDto = {
    /**
     * @type string
    */
    code: TokenExpiredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TokenExpiredDetailsDto;
};

export type InvalidBrokerInviteDto = object;

export const invalidBrokerInviteErrorDtoCodeEnum = {
    INVALID_BROKER_INVITE: "INVALID_BROKER_INVITE"
} as const;

export type InvalidBrokerInviteErrorDtoCodeEnumKey = (typeof invalidBrokerInviteErrorDtoCodeEnum)[keyof typeof invalidBrokerInviteErrorDtoCodeEnum];

export type InvalidBrokerInviteErrorDto = {
    /**
     * @type string
    */
    code: InvalidBrokerInviteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBrokerInviteDto;
};

export type InviteNotFoundDto = object;

export const inviteNotFoundErrorDtoCodeEnum = {
    INVITE_NOT_FOUND: "INVITE_NOT_FOUND"
} as const;

export type InviteNotFoundErrorDtoCodeEnumKey = (typeof inviteNotFoundErrorDtoCodeEnum)[keyof typeof inviteNotFoundErrorDtoCodeEnum];

export type InviteNotFoundErrorDto = {
    /**
     * @type string
    */
    code: InviteNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InviteNotFoundDto;
};

export type InvalidPolicyStopDateDetailsDto = {
    /**
     * @type string, date-time
    */
    stoppedAt: string;
    /**
     * @type string, date-time
    */
    minimumStoppedAt: string;
};

export const invalidPolicyStopDateErrorDtoCodeEnum = {
    INVALID_POLICY_STOP_DATE: "INVALID_POLICY_STOP_DATE"
} as const;

export type InvalidPolicyStopDateErrorDtoCodeEnumKey = (typeof invalidPolicyStopDateErrorDtoCodeEnum)[keyof typeof invalidPolicyStopDateErrorDtoCodeEnum];

export type InvalidPolicyStopDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidPolicyStopDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPolicyStopDateDetailsDto;
};

export type InvalidSearchConfigDto = {
    /**
     * @type string
    */
    name: string;
    /**
     * @type array
    */
    product: string[];
};

export const invalidSearchConfigErrorDtoCodeEnum = {
    INVALID_SEARCH_CONFIG: "INVALID_SEARCH_CONFIG"
} as const;

export type InvalidSearchConfigErrorDtoCodeEnumKey = (typeof invalidSearchConfigErrorDtoCodeEnum)[keyof typeof invalidSearchConfigErrorDtoCodeEnum];

export type InvalidSearchConfigErrorDto = {
    /**
     * @type string
    */
    code: InvalidSearchConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidSearchConfigDto;
};

export type NoCommissionRulesDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const noCommissionRulesErrorDtoCodeEnum = {
    NO_COMMISSION_RULES: "NO_COMMISSION_RULES"
} as const;

export type NoCommissionRulesErrorDtoCodeEnumKey = (typeof noCommissionRulesErrorDtoCodeEnum)[keyof typeof noCommissionRulesErrorDtoCodeEnum];

export type NoCommissionRulesErrorDto = {
    /**
     * @type string
    */
    code: NoCommissionRulesErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoCommissionRulesDto;
};

export type InvalidBranchSubTypeDetailsDto = {
    /**
     * @type array
    */
    possibleSubTypes: string[];
};

export const invalidBranchSubTypeErrorDtoCodeEnum = {
    INVALID_BRANCH_SUB_TYPE: "INVALID_BRANCH_SUB_TYPE"
} as const;

export type InvalidBranchSubTypeErrorDtoCodeEnumKey = (typeof invalidBranchSubTypeErrorDtoCodeEnum)[keyof typeof invalidBranchSubTypeErrorDtoCodeEnum];

export type InvalidBranchSubTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidBranchSubTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBranchSubTypeDetailsDto;
};

export type InvalidBrokerageFirmTypeDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type array
    */
    expectedType: string[];
    /**
     * @type string | undefined
    */
    actualType?: string;
};

export const invalidBrokerageFirmTypeErrorDtoCodeEnum = {
    INVALID_BROKERAGE_FIRM_TYPE: "INVALID_BROKERAGE_FIRM_TYPE"
} as const;

export type InvalidBrokerageFirmTypeErrorDtoCodeEnumKey = (typeof invalidBrokerageFirmTypeErrorDtoCodeEnum)[keyof typeof invalidBrokerageFirmTypeErrorDtoCodeEnum];

export type InvalidBrokerageFirmTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidBrokerageFirmTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBrokerageFirmTypeDetailsDto;
};

export type InvalidEmailDomainDetailsDto = {
    /**
     * @type array
    */
    emailDomain: string[];
    /**
     * @type string
    */
    email: string;
};

export const invalidEmailDomainErrorDtoCodeEnum = {
    INVALID_EMAIL_DOMAIN: "INVALID_EMAIL_DOMAIN"
} as const;

export type InvalidEmailDomainErrorDtoCodeEnumKey = (typeof invalidEmailDomainErrorDtoCodeEnum)[keyof typeof invalidEmailDomainErrorDtoCodeEnum];

export type InvalidEmailDomainErrorDto = {
    /**
     * @type string
    */
    code: InvalidEmailDomainErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEmailDomainDetailsDto;
};

export type FreeEmailDomainDetailsDto = {
    /**
     * @type string
    */
    email: string;
};

export const freeEmailDomainErrorDtoCodeEnum = {
    FREE_EMAIL_DOMAIN: "FREE_EMAIL_DOMAIN"
} as const;

export type FreeEmailDomainErrorDtoCodeEnumKey = (typeof freeEmailDomainErrorDtoCodeEnum)[keyof typeof freeEmailDomainErrorDtoCodeEnum];

export type FreeEmailDomainErrorDto = {
    /**
     * @type string
    */
    code: FreeEmailDomainErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FreeEmailDomainDetailsDto;
};

export type InvalidPolicyStartDateDetailsDto = {
    /**
     * @type string, date-time
    */
    startedAt: string;
};

export const invalidPolicyStartDateErrorDtoCodeEnum = {
    INVALID_POLICY_START_DATE: "INVALID_POLICY_START_DATE"
} as const;

export type InvalidPolicyStartDateErrorDtoCodeEnumKey = (typeof invalidPolicyStartDateErrorDtoCodeEnum)[keyof typeof invalidPolicyStartDateErrorDtoCodeEnum];

export type InvalidPolicyStartDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidPolicyStartDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPolicyStartDateDetailsDto;
};

export type InvalidPeriodDurationDetailsDto = {
    /**
     * @type array
    */
    availableConfigs: Duration[];
};

export const invalidPeriodDurationErrorDtoCodeEnum = {
    INVALID_PERIOD_DURATION: "INVALID_PERIOD_DURATION"
} as const;

export type InvalidPeriodDurationErrorDtoCodeEnumKey = (typeof invalidPeriodDurationErrorDtoCodeEnum)[keyof typeof invalidPeriodDurationErrorDtoCodeEnum];

export type InvalidPeriodDurationErrorDto = {
    /**
     * @type string
    */
    code: InvalidPeriodDurationErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPeriodDurationDetailsDto;
};

export type InvalidTokenDetailsDto = {
    /**
     * @type string
    */
    token: string;
};

export const invalidTokenErrorDtoCodeEnum = {
    INVALID_TOKEN: "INVALID_TOKEN"
} as const;

export type InvalidTokenErrorDtoCodeEnumKey = (typeof invalidTokenErrorDtoCodeEnum)[keyof typeof invalidTokenErrorDtoCodeEnum];

export type InvalidTokenErrorDto = {
    /**
     * @type string
    */
    code: InvalidTokenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidTokenDetailsDto;
};

export type InvalidInviteTypeDetailsDto = {
    /**
     * @type string
    */
    inviteType: string;
};

export const invalidInviteTypeErrorDtoCodeEnum = {
    INVALID_INVITE_TYPE: "INVALID_INVITE_TYPE"
} as const;

export type InvalidInviteTypeErrorDtoCodeEnumKey = (typeof invalidInviteTypeErrorDtoCodeEnum)[keyof typeof invalidInviteTypeErrorDtoCodeEnum];

export type InvalidInviteTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidInviteTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidInviteTypeDetailsDto;
};

export type InviteTypeNotAvailableOnProductDetailsDto = {
    /**
     * @type string
    */
    inviteType: string;
    /**
     * @type string
    */
    productId: string;
};

export const inviteTypeAvailableOnProductErrorDtoCodeEnum = {
    INVITE_TYPE_AVAILABLE_ON_PRODUCT: "INVITE_TYPE_AVAILABLE_ON_PRODUCT"
} as const;

export type InviteTypeAvailableOnProductErrorDtoCodeEnumKey = (typeof inviteTypeAvailableOnProductErrorDtoCodeEnum)[keyof typeof inviteTypeAvailableOnProductErrorDtoCodeEnum];

export type InviteTypeAvailableOnProductErrorDto = {
    /**
     * @type string
    */
    code: InviteTypeAvailableOnProductErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InviteTypeNotAvailableOnProductDetailsDto;
};

export type RefundAmountTooHighDetailsDto = {
    /**
     * @type string
    */
    paymentId: string;
    /**
     * @type number
    */
    refundAmount: number;
    /**
     * @type number
    */
    refundableAmount: number;
};

export const refundAmountTooHighErrorDtoCodeEnum = {
    REFUND_AMOUNT_TOO_HIGH: "REFUND_AMOUNT_TOO_HIGH"
} as const;

export type RefundAmountTooHighErrorDtoCodeEnumKey = (typeof refundAmountTooHighErrorDtoCodeEnum)[keyof typeof refundAmountTooHighErrorDtoCodeEnum];

export type RefundAmountTooHighErrorDto = {
    /**
     * @type string
    */
    code: RefundAmountTooHighErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RefundAmountTooHighDetailsDto;
};

export type InvalidCustomFieldOverrideDetailsDto = {
    /**
     * @type string
    */
    customFieldToOverride: string;
};

export const invalidCustomFieldOverrideErrorDtoCodeEnum = {
    INVALID_CUSTOM_FIELD_OVERRIDE: "INVALID_CUSTOM_FIELD_OVERRIDE"
} as const;

export type InvalidCustomFieldOverrideErrorDtoCodeEnumKey = (typeof invalidCustomFieldOverrideErrorDtoCodeEnum)[keyof typeof invalidCustomFieldOverrideErrorDtoCodeEnum];

export type InvalidCustomFieldOverrideErrorDto = {
    /**
     * @type string
    */
    code: InvalidCustomFieldOverrideErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidCustomFieldOverrideDetailsDto;
};

export type PaymentMethodExpiredDetailsDto = {
    /**
     * @type string
    */
    paymentMethodId: string;
};

export const paymentMethodExpiredErrorDtoCodeEnum = {
    PAYMENT_METHOD_EXPIRED: "PAYMENT_METHOD_EXPIRED"
} as const;

export type PaymentMethodExpiredErrorDtoCodeEnumKey = (typeof paymentMethodExpiredErrorDtoCodeEnum)[keyof typeof paymentMethodExpiredErrorDtoCodeEnum];

export type PaymentMethodExpiredErrorDto = {
    /**
     * @type string
    */
    code: PaymentMethodExpiredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PaymentMethodExpiredDetailsDto;
};

export type InvalidDrivequantUserIdDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    typeOfDrivequantUserId: string;
};

export const invalidDrivequantUserIdErrorDtoCodeEnum = {
    INVALID_DRIVEQUANT_USER_ID: "INVALID_DRIVEQUANT_USER_ID"
} as const;

export type InvalidDrivequantUserIdErrorDtoCodeEnumKey = (typeof invalidDrivequantUserIdErrorDtoCodeEnum)[keyof typeof invalidDrivequantUserIdErrorDtoCodeEnum];

export type InvalidDrivequantUserIdErrorDto = {
    /**
     * @type string
    */
    code: InvalidDrivequantUserIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDrivequantUserIdDetailsDto;
};

export type InvalidIntervalDetailsDto = {
    /**
     * @type string | undefined
    */
    start?: string;
    /**
     * @type string | undefined
    */
    end?: string;
    /**
     * @type string
    */
    reason: string;
};

export const invalidIntervalErrorDtoCodeEnum = {
    INVALID_INTERVAL: "INVALID_INTERVAL"
} as const;

export type InvalidIntervalErrorDtoCodeEnumKey = (typeof invalidIntervalErrorDtoCodeEnum)[keyof typeof invalidIntervalErrorDtoCodeEnum];

export type InvalidIntervalErrorDto = {
    /**
     * @type string
    */
    code: InvalidIntervalErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidIntervalDetailsDto;
};

export type InvalidSearchDetailsDto = {
    /**
     * @type string
    */
    msg: string;
};

export const invalidSearchErrorDtoCodeEnum = {
    INVALID_SEARCH: "INVALID_SEARCH"
} as const;

export type InvalidSearchErrorDtoCodeEnumKey = (typeof invalidSearchErrorDtoCodeEnum)[keyof typeof invalidSearchErrorDtoCodeEnum];

export type InvalidSearchErrorDto = {
    /**
     * @type string
    */
    code: InvalidSearchErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidSearchDetailsDto;
};

export type InvalidInputIdDetailsDto = {
    /**
     * @type string
    */
    inputId: string;
};

export const invalidInputIdErrorDtoCodeEnum = {
    INVALID_INPUT_ID: "INVALID_INPUT_ID"
} as const;

export type InvalidInputIdErrorDtoCodeEnumKey = (typeof invalidInputIdErrorDtoCodeEnum)[keyof typeof invalidInputIdErrorDtoCodeEnum];

export type InvalidInputIdErrorDto = {
    /**
     * @type string
    */
    code: InvalidInputIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidInputIdDetailsDto;
};

export type InvalidTypeAssertionDetailsDto = {
    /**
     * @type string
    */
    expectedType: string;
    /**
     * @type string | undefined
    */
    actualValue?: string;
};

export const invalidTypeAssertionErrorDtoCodeEnum = {
    INVALID_TYPE_ASSERTION: "INVALID_TYPE_ASSERTION"
} as const;

export type InvalidTypeAssertionErrorDtoCodeEnumKey = (typeof invalidTypeAssertionErrorDtoCodeEnum)[keyof typeof invalidTypeAssertionErrorDtoCodeEnum];

export type InvalidTypeAssertionErrorDto = {
    /**
     * @type string
    */
    code: InvalidTypeAssertionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidTypeAssertionDetailsDto;
};

export type InvalidEnumValueDetailsDto = {
    /**
     * @type string
    */
    value: string;
    /**
     * @type array
    */
    allowedValues: string[];
};

export const invalidEnumValueErrorDtoCodeEnum = {
    INVALID_ENUM_VALUE: "INVALID_ENUM_VALUE"
} as const;

export type InvalidEnumValueErrorDtoCodeEnumKey = (typeof invalidEnumValueErrorDtoCodeEnum)[keyof typeof invalidEnumValueErrorDtoCodeEnum];

export type InvalidEnumValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidEnumValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEnumValueDetailsDto;
};

export type InvalidDateDetailsDto = {
    /**
     * @type string
    */
    date: string;
    /**
     * @type string
    */
    reason: string;
};

export const invalidDateErrorDtoCodeEnum = {
    INVALID_DATE: "INVALID_DATE"
} as const;

export type InvalidDateErrorDtoCodeEnumKey = (typeof invalidDateErrorDtoCodeEnum)[keyof typeof invalidDateErrorDtoCodeEnum];

export type InvalidDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDateDetailsDto;
};

export type InvalidDurationDetailsDto = {
    /**
     * @type string | undefined
    */
    start?: string;
    /**
     * @type string | undefined
    */
    end?: string;
    /**
     * @type string
    */
    duration: string;
};

export const invalidDurationErrorDtoCodeEnum = {
    INVALID_DURATION: "INVALID_DURATION"
} as const;

export type InvalidDurationErrorDtoCodeEnumKey = (typeof invalidDurationErrorDtoCodeEnum)[keyof typeof invalidDurationErrorDtoCodeEnum];

export type InvalidDurationErrorDto = {
    /**
     * @type string
    */
    code: InvalidDurationErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDurationDetailsDto;
};

export type InvalidDurationAmountDetailsDto = {
    /**
     * @type number
    */
    amount: number;
};

export const invalidDurationAmountErrorDtoCodeEnum = {
    INVALID_DURATION_AMOUNT: "INVALID_DURATION_AMOUNT"
} as const;

export type InvalidDurationAmountErrorDtoCodeEnumKey = (typeof invalidDurationAmountErrorDtoCodeEnum)[keyof typeof invalidDurationAmountErrorDtoCodeEnum];

export type InvalidDurationAmountErrorDto = {
    /**
     * @type string
    */
    code: InvalidDurationAmountErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDurationAmountDetailsDto;
};

export type UnsupportedChunkSizeDetailsDto = {
    /**
     * @type string
    */
    chunkSize: string;
};

export const unsupportedChunkSizeErrorDtoCodeEnum = {
    UNSUPPORTED_CHUNK_SIZE: "UNSUPPORTED_CHUNK_SIZE"
} as const;

export type UnsupportedChunkSizeErrorDtoCodeEnumKey = (typeof unsupportedChunkSizeErrorDtoCodeEnum)[keyof typeof unsupportedChunkSizeErrorDtoCodeEnum];

export type UnsupportedChunkSizeErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedChunkSizeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedChunkSizeDetailsDto;
};

export type MissingOperatorValueDetailsDto = {
    /**
     * @type string
    */
    operator: string;
};

export const missingOperatorValueErrorDtoCodeEnum = {
    MISSING_OPERATOR_VALUE: "MISSING_OPERATOR_VALUE"
} as const;

export type MissingOperatorValueErrorDtoCodeEnumKey = (typeof missingOperatorValueErrorDtoCodeEnum)[keyof typeof missingOperatorValueErrorDtoCodeEnum];

export type MissingOperatorValueErrorDto = {
    /**
     * @type string
    */
    code: MissingOperatorValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingOperatorValueDetailsDto;
};

export type InvalidOperatorValueDetailsDto = {
    /**
     * @type string
    */
    operator: string;
    /**
     * @type string | undefined
    */
    message?: string;
};

export const invalidOperatorValueErrorDtoCodeEnum = {
    INVALID_OPERATOR_VALUE: "INVALID_OPERATOR_VALUE"
} as const;

export type InvalidOperatorValueErrorDtoCodeEnumKey = (typeof invalidOperatorValueErrorDtoCodeEnum)[keyof typeof invalidOperatorValueErrorDtoCodeEnum];

export type InvalidOperatorValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidOperatorValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidOperatorValueDetailsDto;
};

export type InvalidEnvironmentDetailsDto = {
    /**
     * @type string
    */
    environment: string;
};

export const invalidEnvironmentErrorDtoCodeEnum = {
    INVALID_ENVIRONMENT: "INVALID_ENVIRONMENT"
} as const;

export type InvalidEnvironmentErrorDtoCodeEnumKey = (typeof invalidEnvironmentErrorDtoCodeEnum)[keyof typeof invalidEnvironmentErrorDtoCodeEnum];

export type InvalidEnvironmentErrorDto = {
    /**
     * @type string
    */
    code: InvalidEnvironmentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEnvironmentDetailsDto;
};

export type MissingTargetIdDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingTargetIdErrorDtoCodeEnum = {
    MISSING_TARGET_ID: "MISSING_TARGET_ID"
} as const;

export type MissingTargetIdErrorDtoCodeEnumKey = (typeof missingTargetIdErrorDtoCodeEnum)[keyof typeof missingTargetIdErrorDtoCodeEnum];

export type MissingTargetIdErrorDto = {
    /**
     * @type string
    */
    code: MissingTargetIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingTargetIdDetailsDto;
};

export type MissingAssetTierDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
};

export const missingAssetTierErrorDtoCodeEnum = {
    MISSING_ASSET_TIER: "MISSING_ASSET_TIER"
} as const;

export type MissingAssetTierErrorDtoCodeEnumKey = (typeof missingAssetTierErrorDtoCodeEnum)[keyof typeof missingAssetTierErrorDtoCodeEnum];

export type MissingAssetTierErrorDto = {
    /**
     * @type string
    */
    code: MissingAssetTierErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAssetTierDetailsDto;
};

export type MissingAssetExcessDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
};

export const missingAssetExcessErrorDtoCodeEnum = {
    MISSING_ASSET_EXCESS: "MISSING_ASSET_EXCESS"
} as const;

export type MissingAssetExcessErrorDtoCodeEnumKey = (typeof missingAssetExcessErrorDtoCodeEnum)[keyof typeof missingAssetExcessErrorDtoCodeEnum];

export type MissingAssetExcessErrorDto = {
    /**
     * @type string
    */
    code: MissingAssetExcessErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAssetExcessDetailsDto;
};

export type MissingCustomerIdDetailsDto = {
    /**
     * @type string | undefined
    */
    invoiceId?: string;
    /**
     * @type string | undefined
    */
    aggregateId?: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingCustomerIdErrorDtoCodeEnum = {
    MISSING_CUSTOMER_ID: "MISSING_CUSTOMER_ID"
} as const;

export type MissingCustomerIdErrorDtoCodeEnumKey = (typeof missingCustomerIdErrorDtoCodeEnum)[keyof typeof missingCustomerIdErrorDtoCodeEnum];

export type MissingCustomerIdErrorDto = {
    /**
     * @type string
    */
    code: MissingCustomerIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingCustomerIdDetailsDto;
};

export type MissingPolicyIdDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingPolicyIdErrorDtoCodeEnum = {
    MISSING_POLICY_ID: "MISSING_POLICY_ID"
} as const;

export type MissingPolicyIdErrorDtoCodeEnumKey = (typeof missingPolicyIdErrorDtoCodeEnum)[keyof typeof missingPolicyIdErrorDtoCodeEnum];

export type MissingPolicyIdErrorDto = {
    /**
     * @type string
    */
    code: MissingPolicyIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingPolicyIdDetailsDto;
};

export type MissingProductIdDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingProductIdErrorDtoCodeEnum = {
    MISSING_PRODUCT_ID: "MISSING_PRODUCT_ID"
} as const;

export type MissingProductIdErrorDtoCodeEnumKey = (typeof missingProductIdErrorDtoCodeEnum)[keyof typeof missingProductIdErrorDtoCodeEnum];

export type MissingProductIdErrorDto = {
    /**
     * @type string
    */
    code: MissingProductIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingProductIdDetailsDto;
};

export type MissingQuoteConfigDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const missingQuoteConfigErrorDtoCodeEnum = {
    MISSING_QUOTE_CONFIG: "MISSING_QUOTE_CONFIG"
} as const;

export type MissingQuoteConfigErrorDtoCodeEnumKey = (typeof missingQuoteConfigErrorDtoCodeEnum)[keyof typeof missingQuoteConfigErrorDtoCodeEnum];

export type MissingQuoteConfigErrorDto = {
    /**
     * @type string
    */
    code: MissingQuoteConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingQuoteConfigDetailsDto;
};

export type InvalidQuoteConfigurationDetailsDto = {
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const invalidQuoteConfigurationErrorDtoCodeEnum = {
    INVALID_QUOTE_CONFIGURATION: "INVALID_QUOTE_CONFIGURATION"
} as const;

export type InvalidQuoteConfigurationErrorDtoCodeEnumKey = (typeof invalidQuoteConfigurationErrorDtoCodeEnum)[keyof typeof invalidQuoteConfigurationErrorDtoCodeEnum];

export type InvalidQuoteConfigurationErrorDto = {
    /**
     * @type string
    */
    code: InvalidQuoteConfigurationErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidQuoteConfigurationDetailsDto;
};

export type InvalidChosenOptionDetailsDto = {
    /**
     * @type string
    */
    perilName: string;
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string
    */
    chosenOption: string;
};

export const invalidChosenOptionErrorDtoCodeEnum = {
    INVALID_CHOSEN_OPTION: "INVALID_CHOSEN_OPTION"
} as const;

export type InvalidChosenOptionErrorDtoCodeEnumKey = (typeof invalidChosenOptionErrorDtoCodeEnum)[keyof typeof invalidChosenOptionErrorDtoCodeEnum];

export type InvalidChosenOptionErrorDto = {
    /**
     * @type string
    */
    code: InvalidChosenOptionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidChosenOptionDetailsDto;
};

export type InvalidFractionnementDetailsDto = {
    /**
     * @type string
    */
    billingFrequency: string;
};

export const invalidFractionnementErrorDtoCodeEnum = {
    INVALID_FRACTIONNEMENT: "INVALID_FRACTIONNEMENT"
} as const;

export type InvalidFractionnementErrorDtoCodeEnumKey = (typeof invalidFractionnementErrorDtoCodeEnum)[keyof typeof invalidFractionnementErrorDtoCodeEnum];

export type InvalidFractionnementErrorDto = {
    /**
     * @type string
    */
    code: InvalidFractionnementErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidFractionnementDetailsDto;
};

export type InvalidPremiumValueDetailsDto = {
    /**
     * @type number
    */
    value: number;
};

export const invalidPremiumValueErrorDtoCodeEnum = {
    INVALID_PREMIUM_VALUE: "INVALID_PREMIUM_VALUE"
} as const;

export type InvalidPremiumValueErrorDtoCodeEnumKey = (typeof invalidPremiumValueErrorDtoCodeEnum)[keyof typeof invalidPremiumValueErrorDtoCodeEnum];

export type InvalidPremiumValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidPremiumValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPremiumValueDetailsDto;
};

export type MissingDriverMetadataDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
};

export const missingDriverMetadataErrorDtoCodeEnum = {
    MISSING_DRIVER_METADATA: "MISSING_DRIVER_METADATA"
} as const;

export type MissingDriverMetadataErrorDtoCodeEnumKey = (typeof missingDriverMetadataErrorDtoCodeEnum)[keyof typeof missingDriverMetadataErrorDtoCodeEnum];

export type MissingDriverMetadataErrorDto = {
    /**
     * @type string
    */
    code: MissingDriverMetadataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingDriverMetadataDetailsDto;
};

export type InvalidDriverMetadataDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const invalidDriverMetadataErrorDtoCodeEnum = {
    INVALID_DRIVER_METADATA: "INVALID_DRIVER_METADATA"
} as const;

export type InvalidDriverMetadataErrorDtoCodeEnumKey = (typeof invalidDriverMetadataErrorDtoCodeEnum)[keyof typeof invalidDriverMetadataErrorDtoCodeEnum];

export type InvalidDriverMetadataErrorDto = {
    /**
     * @type string
    */
    code: InvalidDriverMetadataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDriverMetadataDetailsDto;
};

export type UnknownTierDetailsDto = {
    /**
     * @type string
    */
    tier: string;
};

export const unknownTierErrorDtoCodeEnum = {
    UNKNOWN_TIER: "UNKNOWN_TIER"
} as const;

export type UnknownTierErrorDtoCodeEnumKey = (typeof unknownTierErrorDtoCodeEnum)[keyof typeof unknownTierErrorDtoCodeEnum];

export type UnknownTierErrorDto = {
    /**
     * @type string
    */
    code: UnknownTierErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownTierDetailsDto;
};

export type InvalidNumberOfRenewalsDetailsDto = {
    /**
     * @type number
    */
    numberOfRenewals: number;
};

export const invalidNumberOfRenewalsErrorDtoCodeEnum = {
    INVALID_NUMBER_OF_RENEWALS: "INVALID_NUMBER_OF_RENEWALS"
} as const;

export type InvalidNumberOfRenewalsErrorDtoCodeEnumKey = (typeof invalidNumberOfRenewalsErrorDtoCodeEnum)[keyof typeof invalidNumberOfRenewalsErrorDtoCodeEnum];

export type InvalidNumberOfRenewalsErrorDto = {
    /**
     * @type string
    */
    code: InvalidNumberOfRenewalsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidNumberOfRenewalsDetailsDto;
};

export type InvalidReportParamDetailsDto = {
    /**
     * @type string
    */
    param: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const invalidReportParamErrorDtoCodeEnum = {
    INVALID_REPORT_PARAM: "INVALID_REPORT_PARAM"
} as const;

export type InvalidReportParamErrorDtoCodeEnumKey = (typeof invalidReportParamErrorDtoCodeEnum)[keyof typeof invalidReportParamErrorDtoCodeEnum];

export type InvalidReportParamErrorDto = {
    /**
     * @type string
    */
    code: InvalidReportParamErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidReportParamDetailsDto;
};

export type InvalidProductIdDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const invalidProductIdErrorDtoCodeEnum = {
    INVALID_PRODUCT_ID: "INVALID_PRODUCT_ID"
} as const;

export type InvalidProductIdErrorDtoCodeEnumKey = (typeof invalidProductIdErrorDtoCodeEnum)[keyof typeof invalidProductIdErrorDtoCodeEnum];

export type InvalidProductIdErrorDto = {
    /**
     * @type string
    */
    code: InvalidProductIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidProductIdDetailsDto;
};

export type AmountFieldNotFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const amountFieldNotFoundErrorDtoCodeEnum = {
    AMOUNT_FIELD_NOT_FOUND: "AMOUNT_FIELD_NOT_FOUND"
} as const;

export type AmountFieldNotFoundErrorDtoCodeEnumKey = (typeof amountFieldNotFoundErrorDtoCodeEnum)[keyof typeof amountFieldNotFoundErrorDtoCodeEnum];

export type AmountFieldNotFoundErrorDto = {
    /**
     * @type string
    */
    code: AmountFieldNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AmountFieldNotFoundDetailsDto;
};

export type InvalidAmountFieldValueDetailsDto = {
    /**
     * @type object
    */
    value: object;
};

export const invalidAmountFieldValueErrorDtoCodeEnum = {
    INVALID_AMOUNT_FIELD_VALUE: "INVALID_AMOUNT_FIELD_VALUE"
} as const;

export type InvalidAmountFieldValueErrorDtoCodeEnumKey = (typeof invalidAmountFieldValueErrorDtoCodeEnum)[keyof typeof invalidAmountFieldValueErrorDtoCodeEnum];

export type InvalidAmountFieldValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidAmountFieldValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidAmountFieldValueDetailsDto;
};

export type BrokerageFirmCreationConflictDto = {
    /**
     * @type string
    */
    conflictReason: string;
};

export const brokerageFirmCreationConflictErrorDtoCodeEnum = {
    BROKERAGE_FIRM_CREATION_CONFLICT: "BROKERAGE_FIRM_CREATION_CONFLICT"
} as const;

export type BrokerageFirmCreationConflictErrorDtoCodeEnumKey = (typeof brokerageFirmCreationConflictErrorDtoCodeEnum)[keyof typeof brokerageFirmCreationConflictErrorDtoCodeEnum];

export type BrokerageFirmCreationConflictErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmCreationConflictErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmCreationConflictDto;
};

export type SimulatedAtCannotBeProvidedInProdDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const simulatedAtCannotBeProvidedInProdErrorDtoCodeEnum = {
    SIMULATED_AT_CANNOT_BE_PROVIDED_IN_PROD: "SIMULATED_AT_CANNOT_BE_PROVIDED_IN_PROD"
} as const;

export type SimulatedAtCannotBeProvidedInProdErrorDtoCodeEnumKey = (typeof simulatedAtCannotBeProvidedInProdErrorDtoCodeEnum)[keyof typeof simulatedAtCannotBeProvidedInProdErrorDtoCodeEnum];

export type SimulatedAtCannotBeProvidedInProdErrorDto = {
    /**
     * @type string
    */
    code: SimulatedAtCannotBeProvidedInProdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SimulatedAtCannotBeProvidedInProdDetailsDto;
};

export type WhenAtCannotBeProvidedInProdDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const whenAtCannotBeProvidedInProdErrorDtoCodeEnum = {
    WHEN_AT_CANNOT_BE_PROVIDED_IN_PROD: "WHEN_AT_CANNOT_BE_PROVIDED_IN_PROD"
} as const;

export type WhenAtCannotBeProvidedInProdErrorDtoCodeEnumKey = (typeof whenAtCannotBeProvidedInProdErrorDtoCodeEnum)[keyof typeof whenAtCannotBeProvidedInProdErrorDtoCodeEnum];

export type WhenAtCannotBeProvidedInProdErrorDto = {
    /**
     * @type string
    */
    code: WhenAtCannotBeProvidedInProdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WhenAtCannotBeProvidedInProdDetailsDto;
};

export type MissingContactOnBrokerageFirmDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    reason: string;
};

export const missingContactOnBrokerageFirmErrorDtoCodeEnum = {
    MISSING_CONTACT_ON_BROKERAGE_FIRM: "MISSING_CONTACT_ON_BROKERAGE_FIRM"
} as const;

export type MissingContactOnBrokerageFirmErrorDtoCodeEnumKey = (typeof missingContactOnBrokerageFirmErrorDtoCodeEnum)[keyof typeof missingContactOnBrokerageFirmErrorDtoCodeEnum];

export type MissingContactOnBrokerageFirmErrorDto = {
    /**
     * @type string
    */
    code: MissingContactOnBrokerageFirmErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingContactOnBrokerageFirmDto;
};

export type InvalidDocumentCategoryDto = {
    /**
     * @type string
    */
    category: string;
    /**
     * @type array
    */
    availableCategories: any[][];
};

export const invalidDocumentCategoryErrorDtoCodeEnum = {
    INVALID_DOCUMENT_CATEGORY: "INVALID_DOCUMENT_CATEGORY"
} as const;

export type InvalidDocumentCategoryErrorDtoCodeEnumKey = (typeof invalidDocumentCategoryErrorDtoCodeEnum)[keyof typeof invalidDocumentCategoryErrorDtoCodeEnum];

export type InvalidDocumentCategoryErrorDto = {
    /**
     * @type string
    */
    code: InvalidDocumentCategoryErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDocumentCategoryDto;
};

export const invalidCertificatePasswordErrorDtoCodeEnum = {
    INVALID_CERTIFICATE_PASSWORD: "INVALID_CERTIFICATE_PASSWORD"
} as const;

export type InvalidCertificatePasswordErrorDtoCodeEnumKey = (typeof invalidCertificatePasswordErrorDtoCodeEnum)[keyof typeof invalidCertificatePasswordErrorDtoCodeEnum];

export type InvalidCertificatePasswordErrorDto = {
    /**
     * @type string
    */
    code: InvalidCertificatePasswordErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: object;
};

export type RejectedQuoteDetailsDto = object;

export const rejectedQuoteErrorDtoCodeEnum = {
    REJECTED_QUOTE: "REJECTED_QUOTE"
} as const;

export type RejectedQuoteErrorDtoCodeEnumKey = (typeof rejectedQuoteErrorDtoCodeEnum)[keyof typeof rejectedQuoteErrorDtoCodeEnum];

export type RejectedQuoteErrorDto = {
    /**
     * @type string
    */
    code: RejectedQuoteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RejectedQuoteDetailsDto;
};

export type InvalidAssetIdsDto = {
    /**
     * @type array
    */
    assetIds: any[][];
};

export const invalidAssetIdsErrorDtoCodeEnum = {
    INVALID_ASSET_IDS: "INVALID_ASSET_IDS"
} as const;

export type InvalidAssetIdsErrorDtoCodeEnumKey = (typeof invalidAssetIdsErrorDtoCodeEnum)[keyof typeof invalidAssetIdsErrorDtoCodeEnum];

export type InvalidAssetIdsErrorDto = {
    /**
     * @type string
    */
    code: InvalidAssetIdsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidAssetIdsDto;
};

export type EmptyAssetIdsDetailsDto = object;

export const emptyAssetIdsErrorDtoCodeEnum = {
    EMPTY_ASSET_IDS: "EMPTY_ASSET_IDS"
} as const;

export type EmptyAssetIdsErrorDtoCodeEnumKey = (typeof emptyAssetIdsErrorDtoCodeEnum)[keyof typeof emptyAssetIdsErrorDtoCodeEnum];

export type EmptyAssetIdsErrorDto = {
    /**
     * @type string
    */
    code: EmptyAssetIdsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EmptyAssetIdsDetailsDto;
};

export type DelegatedMailboxRequiresOutlookDetailsDto = object;

export const delegatedMailboxRequiresOutlookErrorDtoCodeEnum = {
    DELEGATED_MAILBOX_REQUIRES_OUTLOOK: "DELEGATED_MAILBOX_REQUIRES_OUTLOOK"
} as const;

export type DelegatedMailboxRequiresOutlookErrorDtoCodeEnumKey = (typeof delegatedMailboxRequiresOutlookErrorDtoCodeEnum)[keyof typeof delegatedMailboxRequiresOutlookErrorDtoCodeEnum];

export type DelegatedMailboxRequiresOutlookErrorDto = {
    /**
     * @type string
    */
    code: DelegatedMailboxRequiresOutlookErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DelegatedMailboxRequiresOutlookDetailsDto;
};

export type MustBeNonDelegatedQuoteDetailsDto = object;

export const mustBeNonDelegatedQuoteErrorDtoCodeEnum = {
    MUST_BE_NON_DELEGATED_QUOTE: "MUST_BE_NON_DELEGATED_QUOTE"
} as const;

export type MustBeNonDelegatedQuoteErrorDtoCodeEnumKey = (typeof mustBeNonDelegatedQuoteErrorDtoCodeEnum)[keyof typeof mustBeNonDelegatedQuoteErrorDtoCodeEnum];

export type MustBeNonDelegatedQuoteErrorDto = {
    /**
     * @type string
    */
    code: MustBeNonDelegatedQuoteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MustBeNonDelegatedQuoteDetailsDto;
};

export type MustBeDelegatedQuoteDetailsDto = object;

export const mustBeDelegatedQuoteErrorDtoCodeEnum = {
    MUST_BE_DELEGATED_QUOTE: "MUST_BE_DELEGATED_QUOTE"
} as const;

export type MustBeDelegatedQuoteErrorDtoCodeEnumKey = (typeof mustBeDelegatedQuoteErrorDtoCodeEnum)[keyof typeof mustBeDelegatedQuoteErrorDtoCodeEnum];

export type MustBeDelegatedQuoteErrorDto = {
    /**
     * @type string
    */
    code: MustBeDelegatedQuoteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MustBeDelegatedQuoteDetailsDto;
};

export type InvalidQuoteOptionsForbiddenPerilsDetailsDto = object;

export const invalidQuoteOptionsForbiddenPerilsErrorDtoCodeEnum = {
    INVALID_QUOTE_OPTIONS_FORBIDDEN_PERILS: "INVALID_QUOTE_OPTIONS_FORBIDDEN_PERILS"
} as const;

export type InvalidQuoteOptionsForbiddenPerilsErrorDtoCodeEnumKey = (typeof invalidQuoteOptionsForbiddenPerilsErrorDtoCodeEnum)[keyof typeof invalidQuoteOptionsForbiddenPerilsErrorDtoCodeEnum];

export type InvalidQuoteOptionsForbiddenPerilsErrorDto = {
    /**
     * @type string
    */
    code: InvalidQuoteOptionsForbiddenPerilsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidQuoteOptionsForbiddenPerilsDetailsDto;
};

export type InvalidCredentialsDetailsDto = object;

export const invalidCredentialsErrorDtoCodeEnum = {
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS"
} as const;

export type InvalidCredentialsErrorDtoCodeEnumKey = (typeof invalidCredentialsErrorDtoCodeEnum)[keyof typeof invalidCredentialsErrorDtoCodeEnum];

export type InvalidCredentialsErrorDto = {
    /**
     * @type string
    */
    code: InvalidCredentialsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidCredentialsDetailsDto;
};

export type MustBeAuthenticatedDetailsDto = {
    /**
     * @type string
    */
    context: string;
};

export const mustBeAuthenticatedErrorDtoCodeEnum = {
    MUST_BE_AUTHENTICATED: "MUST_BE_AUTHENTICATED"
} as const;

export type MustBeAuthenticatedErrorDtoCodeEnumKey = (typeof mustBeAuthenticatedErrorDtoCodeEnum)[keyof typeof mustBeAuthenticatedErrorDtoCodeEnum];

export type MustBeAuthenticatedErrorDto = {
    /**
     * @type string
    */
    code: MustBeAuthenticatedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MustBeAuthenticatedDetailsDto;
};

export type TestWebhookOnlyNonProdDetailsDto = {
    /**
     * @type string
    */
    environment: string;
};

export const testWebhookOnlyNonProdErrorDtoCodeEnum = {
    TEST_WEBHOOK_ONLY_NON_PROD: "TEST_WEBHOOK_ONLY_NON_PROD"
} as const;

export type TestWebhookOnlyNonProdErrorDtoCodeEnumKey = (typeof testWebhookOnlyNonProdErrorDtoCodeEnum)[keyof typeof testWebhookOnlyNonProdErrorDtoCodeEnum];

export type TestWebhookOnlyNonProdErrorDto = {
    /**
     * @type string
    */
    code: TestWebhookOnlyNonProdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TestWebhookOnlyNonProdDetailsDto;
};

export type TestWebhookOnlyE2EDetailsDto = {
    /**
     * @type string
    */
    eventId: string;
};

export const testWebhookOnlyE2EErrorDtoCodeEnum = {
    TEST_WEBHOOK_ONLY_E2E: "TEST_WEBHOOK_ONLY_E2E"
} as const;

export type TestWebhookOnlyE2EErrorDtoCodeEnumKey = (typeof testWebhookOnlyE2EErrorDtoCodeEnum)[keyof typeof testWebhookOnlyE2EErrorDtoCodeEnum];

export type TestWebhookOnlyE2EErrorDto = {
    /**
     * @type string
    */
    code: TestWebhookOnlyE2EErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TestWebhookOnlyE2EDetailsDto;
};

export type UnauthorizedIpAddressDetailsDto = {
    /**
     * @type string
    */
    ipAddress: string;
};

export const unauthorizedIpAddressErrorDtoCodeEnum = {
    UNAUTHORIZED_IP_ADDRESS: "UNAUTHORIZED_IP_ADDRESS"
} as const;

export type UnauthorizedIpAddressErrorDtoCodeEnumKey = (typeof unauthorizedIpAddressErrorDtoCodeEnum)[keyof typeof unauthorizedIpAddressErrorDtoCodeEnum];

export type UnauthorizedIpAddressErrorDto = {
    /**
     * @type string
    */
    code: UnauthorizedIpAddressErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnauthorizedIpAddressDetailsDto;
};

export type SydiaClaimNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const sydiaClaimNotFoundErrorDtoCodeEnum = {
    SYDIA_CLAIM_NOT_FOUND: "SYDIA_CLAIM_NOT_FOUND"
} as const;

export type SydiaClaimNotFoundErrorDtoCodeEnumKey = (typeof sydiaClaimNotFoundErrorDtoCodeEnum)[keyof typeof sydiaClaimNotFoundErrorDtoCodeEnum];

export type SydiaClaimNotFoundErrorDto = {
    /**
     * @type string
    */
    code: SydiaClaimNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SydiaClaimNotFoundDetailsDto;
};

export type PaymentNotFoundDetailsDto = {
    /**
     * @type string
    */
    paymentId: string;
};

export const paymentNotFoundErrorDtoCodeEnum = {
    PAYMENT_NOT_FOUND: "PAYMENT_NOT_FOUND"
} as const;

export type PaymentNotFoundErrorDtoCodeEnumKey = (typeof paymentNotFoundErrorDtoCodeEnum)[keyof typeof paymentNotFoundErrorDtoCodeEnum];

export type PaymentNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PaymentNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PaymentNotFoundDetailsDto;
};

export type RefundNotFoundDetailsDto = {
    /**
     * @type string
    */
    stripeRefundId: string;
};

export const refundNotFoundErrorDtoCodeEnum = {
    REFUND_NOT_FOUND: "REFUND_NOT_FOUND"
} as const;

export type RefundNotFoundErrorDtoCodeEnumKey = (typeof refundNotFoundErrorDtoCodeEnum)[keyof typeof refundNotFoundErrorDtoCodeEnum];

export type RefundNotFoundErrorDto = {
    /**
     * @type string
    */
    code: RefundNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RefundNotFoundDetailsDto;
};

export type RoleNotFoundDetailsDto = {
    /**
     * @type string
    */
    roleId: string;
    /**
     * @type string | undefined
    */
    productId?: string;
};

export const roleNotFoundErrorDtoCodeEnum = {
    ROLE_NOT_FOUND: "ROLE_NOT_FOUND"
} as const;

export type RoleNotFoundErrorDtoCodeEnumKey = (typeof roleNotFoundErrorDtoCodeEnum)[keyof typeof roleNotFoundErrorDtoCodeEnum];

export type RoleNotFoundErrorDto = {
    /**
     * @type string
    */
    code: RoleNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RoleNotFoundDetailsDto;
};

export type SignatureRequestNotFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const signatureRequestNotFoundErrorDtoCodeEnum = {
    SIGNATURE_REQUEST_NOT_FOUND: "SIGNATURE_REQUEST_NOT_FOUND"
} as const;

export type SignatureRequestNotFoundErrorDtoCodeEnumKey = (typeof signatureRequestNotFoundErrorDtoCodeEnum)[keyof typeof signatureRequestNotFoundErrorDtoCodeEnum];

export type SignatureRequestNotFoundErrorDto = {
    /**
     * @type string
    */
    code: SignatureRequestNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SignatureRequestNotFoundDetailsDto;
};

export type NoProviderSignatureIdFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const noProviderSignatureIdFoundErrorDtoCodeEnum = {
    NO_PROVIDER_SIGNATURE_ID_FOUND: "NO_PROVIDER_SIGNATURE_ID_FOUND"
} as const;

export type NoProviderSignatureIdFoundErrorDtoCodeEnumKey = (typeof noProviderSignatureIdFoundErrorDtoCodeEnum)[keyof typeof noProviderSignatureIdFoundErrorDtoCodeEnum];

export type NoProviderSignatureIdFoundErrorDto = {
    /**
     * @type string
    */
    code: NoProviderSignatureIdFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoProviderSignatureIdFoundDetailsDto;
};

export type DrivequantUserNotFoundDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const drivequantUserNotFoundErrorDtoCodeEnum = {
    DRIVEQUANT_USER_NOT_FOUND: "DRIVEQUANT_USER_NOT_FOUND"
} as const;

export type DrivequantUserNotFoundErrorDtoCodeEnumKey = (typeof drivequantUserNotFoundErrorDtoCodeEnum)[keyof typeof drivequantUserNotFoundErrorDtoCodeEnum];

export type DrivequantUserNotFoundErrorDto = {
    /**
     * @type string
    */
    code: DrivequantUserNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DrivequantUserNotFoundDetailsDto;
};

export type TelematicsScoreNotFoundDetailsDto = object;

export const telematicsScoreNotFoundErrorDtoCodeEnum = {
    TELEMATICS_SCORE_NOT_FOUND: "TELEMATICS_SCORE_NOT_FOUND"
} as const;

export type TelematicsScoreNotFoundErrorDtoCodeEnumKey = (typeof telematicsScoreNotFoundErrorDtoCodeEnum)[keyof typeof telematicsScoreNotFoundErrorDtoCodeEnum];

export type TelematicsScoreNotFoundErrorDto = {
    /**
     * @type string
    */
    code: TelematicsScoreNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TelematicsScoreNotFoundDetailsDto;
};

export type JobNotFoundDto = {
    /**
     * @type string
    */
    id: string;
};

export const jobNotFoundErrorDtoCodeEnum = {
    JOB_NOT_FOUND: "JOB_NOT_FOUND"
} as const;

export type JobNotFoundErrorDtoCodeEnumKey = (typeof jobNotFoundErrorDtoCodeEnum)[keyof typeof jobNotFoundErrorDtoCodeEnum];

export type JobNotFoundErrorDto = {
    /**
     * @type string
    */
    code: JobNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: JobNotFoundDto;
};

export type WorkflowNotFoundDto = {
    /**
     * @type string
    */
    id: string;
};

export const workflowNotFoundErrorDtoCodeEnum = {
    WORKFLOW_NOT_FOUND: "WORKFLOW_NOT_FOUND"
} as const;

export type WorkflowNotFoundErrorDtoCodeEnumKey = (typeof workflowNotFoundErrorDtoCodeEnum)[keyof typeof workflowNotFoundErrorDtoCodeEnum];

export type WorkflowNotFoundErrorDto = {
    /**
     * @type string
    */
    code: WorkflowNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WorkflowNotFoundDto;
};

export type LockNotFoundDto = {
    /**
     * @type string
    */
    id: string;
};

export const lockNotFoundErrorDtoCodeEnum = {
    LOCK_NOT_FOUND: "LOCK_NOT_FOUND"
} as const;

export type LockNotFoundErrorDtoCodeEnumKey = (typeof lockNotFoundErrorDtoCodeEnum)[keyof typeof lockNotFoundErrorDtoCodeEnum];

export type LockNotFoundErrorDto = {
    /**
     * @type string
    */
    code: LockNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: LockNotFoundDto;
};

export type ReserveNotFoundDto = {
    /**
     * @type string
    */
    id: string;
};

export const reserveNotFoundErrorDtoCodeEnum = {
    RESERVE_NOT_FOUND: "RESERVE_NOT_FOUND"
} as const;

export type ReserveNotFoundErrorDtoCodeEnumKey = (typeof reserveNotFoundErrorDtoCodeEnum)[keyof typeof reserveNotFoundErrorDtoCodeEnum];

export type ReserveNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ReserveNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ReserveNotFoundDto;
};

export type SearchNotFoundDetailsDto = {
    /**
     * @type string
    */
    msg: string;
};

export const searchNotFoundErrorDtoCodeEnum = {
    SEARCH_NOT_FOUND: "SEARCH_NOT_FOUND"
} as const;

export type SearchNotFoundErrorDtoCodeEnumKey = (typeof searchNotFoundErrorDtoCodeEnum)[keyof typeof searchNotFoundErrorDtoCodeEnum];

export type SearchNotFoundErrorDto = {
    /**
     * @type string
    */
    code: SearchNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SearchNotFoundDetailsDto;
};

export type CannotDeleteSelfDto = object;

export const cannotDeleteSelfErrorDtoCodeEnum = {
    CANNOT_DELETE_SELF: "CANNOT_DELETE_SELF"
} as const;

export type CannotDeleteSelfErrorDtoCodeEnumKey = (typeof cannotDeleteSelfErrorDtoCodeEnum)[keyof typeof cannotDeleteSelfErrorDtoCodeEnum];

export type CannotDeleteSelfErrorDto = {
    /**
     * @type string
    */
    code: CannotDeleteSelfErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotDeleteSelfDto;
};

export type MaxAlertsReachedDetailsDto = {
    /**
     * @type string
    */
    checkId: string;
};

export const maxAlertsReachedErrorDtoCodeEnum = {
    MAX_ALERTS_REACHED: "MAX_ALERTS_REACHED"
} as const;

export type MaxAlertsReachedErrorDtoCodeEnumKey = (typeof maxAlertsReachedErrorDtoCodeEnum)[keyof typeof maxAlertsReachedErrorDtoCodeEnum];

export type MaxAlertsReachedErrorDto = {
    /**
     * @type string
    */
    code: MaxAlertsReachedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MaxAlertsReachedDetailsDto;
};

export type ConflictingInvoiceStatusDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @type string
    */
    currentStatus: string;
    /**
     * @type array
    */
    expectedStatus: string[];
};

export const conflictingInvoiceStatusErrorDtoCodeEnum = {
    CONFLICTING_INVOICE_STATUS: "CONFLICTING_INVOICE_STATUS"
} as const;

export type ConflictingInvoiceStatusErrorDtoCodeEnumKey = (typeof conflictingInvoiceStatusErrorDtoCodeEnum)[keyof typeof conflictingInvoiceStatusErrorDtoCodeEnum];

export type ConflictingInvoiceStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingInvoiceStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingInvoiceStatusDetailsDto;
};

export type DocumentArchivedDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const documentArchivedErrorDtoCodeEnum = {
    DOCUMENT_ARCHIVED: "DOCUMENT_ARCHIVED"
} as const;

export type DocumentArchivedErrorDtoCodeEnumKey = (typeof documentArchivedErrorDtoCodeEnum)[keyof typeof documentArchivedErrorDtoCodeEnum];

export type DocumentArchivedErrorDto = {
    /**
     * @type string
    */
    code: DocumentArchivedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentArchivedDetailsDto;
};

export type PolicyAlreadyHasIncrementalIdDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const policyAlreadyHasIncrementalIdErrorDtoCodeEnum = {
    POLICY_ALREADY_HAS_INCREMENTAL_ID: "POLICY_ALREADY_HAS_INCREMENTAL_ID"
} as const;

export type PolicyAlreadyHasIncrementalIdErrorDtoCodeEnumKey = (typeof policyAlreadyHasIncrementalIdErrorDtoCodeEnum)[keyof typeof policyAlreadyHasIncrementalIdErrorDtoCodeEnum];

export type PolicyAlreadyHasIncrementalIdErrorDto = {
    /**
     * @type string
    */
    code: PolicyAlreadyHasIncrementalIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyAlreadyHasIncrementalIdDetailsDto;
};

export type ConflictingJobStatusDetailsDto = {
    /**
     * @type string
    */
    jobId: string;
    /**
     * @type string
    */
    currentStatus: string;
    /**
     * @type string
    */
    expectedStatus: string;
    /**
     * @type string | undefined
    */
    action?: string;
};

export const conflictingJobStatusErrorDtoCodeEnum = {
    CONFLICTING_JOB_STATUS: "CONFLICTING_JOB_STATUS"
} as const;

export type ConflictingJobStatusErrorDtoCodeEnumKey = (typeof conflictingJobStatusErrorDtoCodeEnum)[keyof typeof conflictingJobStatusErrorDtoCodeEnum];

export type ConflictingJobStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingJobStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingJobStatusDetailsDto;
};

export type EmailAttachmentNotStoredDetailsDto = {
    /**
     * @type string
    */
    emailAttachmentId: string;
    /**
     * @description Current attachment status: pending, failed or skipped
     * @type string
    */
    status: string;
    /**
     * @type string | undefined
    */
    failureReason?: string;
};

export const emailAttachmentNotStoredErrorDtoCodeEnum = {
    EMAIL_ATTACHMENT_NOT_STORED: "EMAIL_ATTACHMENT_NOT_STORED"
} as const;

export type EmailAttachmentNotStoredErrorDtoCodeEnumKey = (typeof emailAttachmentNotStoredErrorDtoCodeEnum)[keyof typeof emailAttachmentNotStoredErrorDtoCodeEnum];

export type EmailAttachmentNotStoredErrorDto = {
    /**
     * @type string
    */
    code: EmailAttachmentNotStoredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EmailAttachmentNotStoredDetailsDto;
};

export type PriorContractCancellationNotEnabledDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const priorContractCancellationNotEnabledErrorDtoCodeEnum = {
    PRIOR_CONTRACT_CANCELLATION_NOT_ENABLED: "PRIOR_CONTRACT_CANCELLATION_NOT_ENABLED"
} as const;

export type PriorContractCancellationNotEnabledErrorDtoCodeEnumKey = (typeof priorContractCancellationNotEnabledErrorDtoCodeEnum)[keyof typeof priorContractCancellationNotEnabledErrorDtoCodeEnum];

export type PriorContractCancellationNotEnabledErrorDto = {
    /**
     * @type string
    */
    code: PriorContractCancellationNotEnabledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PriorContractCancellationNotEnabledDetailsDto;
};

export type PriorContractCancellationLetterAlreadySentDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const priorContractCancellationLetterAlreadySentErrorDtoCodeEnum = {
    PRIOR_CONTRACT_CANCELLATION_LETTER_ALREADY_SENT: "PRIOR_CONTRACT_CANCELLATION_LETTER_ALREADY_SENT"
} as const;

export type PriorContractCancellationLetterAlreadySentErrorDtoCodeEnumKey = (typeof priorContractCancellationLetterAlreadySentErrorDtoCodeEnum)[keyof typeof priorContractCancellationLetterAlreadySentErrorDtoCodeEnum];

export type PriorContractCancellationLetterAlreadySentErrorDto = {
    /**
     * @type string
    */
    code: PriorContractCancellationLetterAlreadySentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PriorContractCancellationLetterAlreadySentDetailsDto;
};

export type PriorContractNotDeclaredDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const priorContractNotDeclaredErrorDtoCodeEnum = {
    PRIOR_CONTRACT_NOT_DECLARED: "PRIOR_CONTRACT_NOT_DECLARED"
} as const;

export type PriorContractNotDeclaredErrorDtoCodeEnumKey = (typeof priorContractNotDeclaredErrorDtoCodeEnum)[keyof typeof priorContractNotDeclaredErrorDtoCodeEnum];

export type PriorContractNotDeclaredErrorDto = {
    /**
     * @type string
    */
    code: PriorContractNotDeclaredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PriorContractNotDeclaredDetailsDto;
};

export type PolicyholderNameMissingDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const policyholderNameMissingErrorDtoCodeEnum = {
    POLICYHOLDER_NAME_MISSING: "POLICYHOLDER_NAME_MISSING"
} as const;

export type PolicyholderNameMissingErrorDtoCodeEnumKey = (typeof policyholderNameMissingErrorDtoCodeEnum)[keyof typeof policyholderNameMissingErrorDtoCodeEnum];

export type PolicyholderNameMissingErrorDto = {
    /**
     * @type string
    */
    code: PolicyholderNameMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyholderNameMissingDetailsDto;
};

export type ConflictingBranchSubTypeDetailsDto = {
    /**
     * @type string
    */
    branchSubType: string;
    requirement: OperationRequirement;
    action: Action;
};

export const conflictingBranchSubTypeErrorDtoCodeEnum = {
    CONFLICTING_BRANCH_SUB_TYPE: "CONFLICTING_BRANCH_SUB_TYPE"
} as const;

export type ConflictingBranchSubTypeErrorDtoCodeEnumKey = (typeof conflictingBranchSubTypeErrorDtoCodeEnum)[keyof typeof conflictingBranchSubTypeErrorDtoCodeEnum];

export type ConflictingBranchSubTypeErrorDto = {
    /**
     * @type string
    */
    code: ConflictingBranchSubTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingBranchSubTypeDetailsDto;
};

export const customerStatusEnum = {
    CUSTOMER_CREATED: "CUSTOMER_CREATED",
    CUSTOMER_CONFIRMED: "CUSTOMER_CONFIRMED"
} as const;

export type CustomerStatusEnumKey = (typeof customerStatusEnum)[keyof typeof customerStatusEnum];

export type CustomerStatus = CustomerStatusEnumKey;

export type ConflictingCustomerStatusDetailsDto = {
    customerStatus: CustomerStatus;
    requirement: OperationRequirement;
    action: Action;
    /**
     * @type object | undefined
    */
    additionalData?: {
        [key: string]: any;
    };
};

export const conflictingCustomerStatusErrorDtoCodeEnum = {
    CONFLICTING_CUSTOMER_STATUS: "CONFLICTING_CUSTOMER_STATUS"
} as const;

export type ConflictingCustomerStatusErrorDtoCodeEnumKey = (typeof conflictingCustomerStatusErrorDtoCodeEnum)[keyof typeof conflictingCustomerStatusErrorDtoCodeEnum];

export type ConflictingCustomerStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingCustomerStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingCustomerStatusDetailsDto;
};

export type ConflictingSignedAtDetailsDto = {
    /**
     * @type string, date-time
    */
    signedAt: string;
    requirement: OperationRequirement;
    qualifier: FieldQualifier;
    action: Action;
};

export const conflictingSignedAtErrorDtoCodeEnum = {
    CONFLICTING_SIGNED_AT: "CONFLICTING_SIGNED_AT"
} as const;

export type ConflictingSignedAtErrorDtoCodeEnumKey = (typeof conflictingSignedAtErrorDtoCodeEnum)[keyof typeof conflictingSignedAtErrorDtoCodeEnum];

export type ConflictingSignedAtErrorDto = {
    /**
     * @type string
    */
    code: ConflictingSignedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingSignedAtDetailsDto;
};

export type ConflictingDistributionRequestStatusDetailsDto = {
    /**
     * @type string
    */
    distributionRequestId: string;
    status: DistributionRequestStatus;
    requirement: OperationRequirement;
    action: Action;
};

export const conflictingDistributionRequestStatusErrorDtoCodeEnum = {
    CONFLICTING_DISTRIBUTION_REQUEST_STATUS: "CONFLICTING_DISTRIBUTION_REQUEST_STATUS"
} as const;

export type ConflictingDistributionRequestStatusErrorDtoCodeEnumKey = (typeof conflictingDistributionRequestStatusErrorDtoCodeEnum)[keyof typeof conflictingDistributionRequestStatusErrorDtoCodeEnum];

export type ConflictingDistributionRequestStatusErrorDto = {
    /**
     * @type string
    */
    code: ConflictingDistributionRequestStatusErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConflictingDistributionRequestStatusDetailsDto;
};

export type IncompleteAssetDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
};

export const incompleteAssetErrorDtoCodeEnum = {
    INCOMPLETE_ASSET: "INCOMPLETE_ASSET"
} as const;

export type IncompleteAssetErrorDtoCodeEnumKey = (typeof incompleteAssetErrorDtoCodeEnum)[keyof typeof incompleteAssetErrorDtoCodeEnum];

export type IncompleteAssetErrorDto = {
    /**
     * @type string
    */
    code: IncompleteAssetErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: IncompleteAssetDetailsDto;
};

export const branchTypeCurrentlyOpenedConflictDetailsDtoBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type BranchTypeCurrentlyOpenedConflictDetailsDtoBranchTypeEnumKey = (typeof branchTypeCurrentlyOpenedConflictDetailsDtoBranchTypeEnum)[keyof typeof branchTypeCurrentlyOpenedConflictDetailsDtoBranchTypeEnum];

export type BranchTypeCurrentlyOpenedConflictDetailsDto = {
    /**
     * @type string
    */
    branchType: BranchTypeCurrentlyOpenedConflictDetailsDtoBranchTypeEnumKey;
};

export const branchTypeIsCurrentlyOpenedErrorDtoCodeEnum = {
    BRANCH_TYPE_IS_CURRENTLY_OPENED: "BRANCH_TYPE_IS_CURRENTLY_OPENED"
} as const;

export type BranchTypeIsCurrentlyOpenedErrorDtoCodeEnumKey = (typeof branchTypeIsCurrentlyOpenedErrorDtoCodeEnum)[keyof typeof branchTypeIsCurrentlyOpenedErrorDtoCodeEnum];

export type BranchTypeIsCurrentlyOpenedErrorDto = {
    /**
     * @type string
    */
    code: BranchTypeIsCurrentlyOpenedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BranchTypeCurrentlyOpenedConflictDetailsDto;
};

export type FileAlreadyUploadedConflictDetailsDto = {
    /**
     * @type string
    */
    key: string;
};

export const fileAlreadyUploadedErrorDtoCodeEnum = {
    FILE_ALREADY_UPLOADED: "FILE_ALREADY_UPLOADED"
} as const;

export type FileAlreadyUploadedErrorDtoCodeEnumKey = (typeof fileAlreadyUploadedErrorDtoCodeEnum)[keyof typeof fileAlreadyUploadedErrorDtoCodeEnum];

export type FileAlreadyUploadedErrorDto = {
    /**
     * @type string
    */
    code: FileAlreadyUploadedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FileAlreadyUploadedConflictDetailsDto;
};

export type BranchNotOpenDetailsDto = {
    /**
     * @type string
    */
    branchId: string;
    /**
     * @type string
    */
    rootId: string;
};

export const branchNotOpenErrorDtoCodeEnum = {
    BRANCH_NOT_OPEN: "BRANCH_NOT_OPEN"
} as const;

export type BranchNotOpenErrorDtoCodeEnumKey = (typeof branchNotOpenErrorDtoCodeEnum)[keyof typeof branchNotOpenErrorDtoCodeEnum];

export type BranchNotOpenErrorDto = {
    /**
     * @type string
    */
    code: BranchNotOpenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BranchNotOpenDetailsDto;
};

export type NoScheduledStopDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const noScheduledStopErrorDtoCodeEnum = {
    NO_SCHEDULED_STOP: "NO_SCHEDULED_STOP"
} as const;

export type NoScheduledStopErrorDtoCodeEnumKey = (typeof noScheduledStopErrorDtoCodeEnum)[keyof typeof noScheduledStopErrorDtoCodeEnum];

export type NoScheduledStopErrorDto = {
    /**
     * @type string
    */
    code: NoScheduledStopErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoScheduledStopDetailsDto;
};

export type StopDocumentsMissingDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    reason: string;
    /**
     * @type array
    */
    categories: string[];
};

export const stopDocumentsMissingErrorDtoCodeEnum = {
    STOP_DOCUMENTS_MISSING: "STOP_DOCUMENTS_MISSING"
} as const;

export type StopDocumentsMissingErrorDtoCodeEnumKey = (typeof stopDocumentsMissingErrorDtoCodeEnum)[keyof typeof stopDocumentsMissingErrorDtoCodeEnum];

export type StopDocumentsMissingErrorDto = {
    /**
     * @type string
    */
    code: StopDocumentsMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: StopDocumentsMissingDetailsDto;
};

export type InvoiceRefundNotHandledDetailsDto = {
    /**
     * @type string
    */
    refundInvoiceId: string;
};

export const invoiceRefundNotHandledErrorDtoCodeEnum = {
    INVOICE_REFUND_NOT_HANDLED: "INVOICE_REFUND_NOT_HANDLED"
} as const;

export type InvoiceRefundNotHandledErrorDtoCodeEnumKey = (typeof invoiceRefundNotHandledErrorDtoCodeEnum)[keyof typeof invoiceRefundNotHandledErrorDtoCodeEnum];

export type InvoiceRefundNotHandledErrorDto = {
    /**
     * @type string
    */
    code: InvoiceRefundNotHandledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceRefundNotHandledDetailsDto;
};

export type DistributionRequestCreationConflictDto = {
    /**
     * @type string
    */
    reason: string;
};

export const distributionRequestCreationConflictErrorDtoCodeEnum = {
    DISTRIBUTION_REQUEST_CREATION_CONFLICT: "DISTRIBUTION_REQUEST_CREATION_CONFLICT"
} as const;

export type DistributionRequestCreationConflictErrorDtoCodeEnumKey = (typeof distributionRequestCreationConflictErrorDtoCodeEnum)[keyof typeof distributionRequestCreationConflictErrorDtoCodeEnum];

export type DistributionRequestCreationConflictErrorDto = {
    /**
     * @type string
    */
    code: DistributionRequestCreationConflictErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DistributionRequestCreationConflictDto;
};

export type DistributionRequestDeletionForbiddenDto = {
    /**
     * @type string
    */
    id: string;
};

export const distributionRequestDeletionForbiddenErrorDtoCodeEnum = {
    DISTRIBUTION_REQUEST_DELETION_FORBIDDEN: "DISTRIBUTION_REQUEST_DELETION_FORBIDDEN"
} as const;

export type DistributionRequestDeletionForbiddenErrorDtoCodeEnumKey = (typeof distributionRequestDeletionForbiddenErrorDtoCodeEnum)[keyof typeof distributionRequestDeletionForbiddenErrorDtoCodeEnum];

export type DistributionRequestDeletionForbiddenErrorDto = {
    /**
     * @type string
    */
    code: DistributionRequestDeletionForbiddenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DistributionRequestDeletionForbiddenDto;
};

export type BrokerAlreadyExistsDto = {
    /**
     * @type string
    */
    userId: string;
};

export const brokerAlreadyExistsErrorDtoCodeEnum = {
    BROKER_ALREADY_EXISTS: "BROKER_ALREADY_EXISTS"
} as const;

export type BrokerAlreadyExistsErrorDtoCodeEnumKey = (typeof brokerAlreadyExistsErrorDtoCodeEnum)[keyof typeof brokerAlreadyExistsErrorDtoCodeEnum];

export type BrokerAlreadyExistsErrorDto = {
    /**
     * @type string
    */
    code: BrokerAlreadyExistsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerAlreadyExistsDto;
};

export type CheckAlreadyExistsDto = {
    /**
     * @type string
    */
    checkId: string;
    /**
     * @type string
    */
    searchKey: string;
};

export const checkAlreadyExistsErrorDtoCodeEnum = {
    CHECK_ALREADY_EXISTS: "CHECK_ALREADY_EXISTS"
} as const;

export type CheckAlreadyExistsErrorDtoCodeEnumKey = (typeof checkAlreadyExistsErrorDtoCodeEnum)[keyof typeof checkAlreadyExistsErrorDtoCodeEnum];

export type CheckAlreadyExistsErrorDto = {
    /**
     * @type string
    */
    code: CheckAlreadyExistsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CheckAlreadyExistsDto;
};

export type DerogationNotApprovedDto = {
    /**
     * @type string
    */
    branchId: string;
    action: DerogationAction;
};

export const derogationNotApprovedErrorDtoCodeEnum = {
    DEROGATION_NOT_APPROVED: "DEROGATION_NOT_APPROVED"
} as const;

export type DerogationNotApprovedErrorDtoCodeEnumKey = (typeof derogationNotApprovedErrorDtoCodeEnum)[keyof typeof derogationNotApprovedErrorDtoCodeEnum];

export type DerogationNotApprovedErrorDto = {
    /**
     * @type string
    */
    code: DerogationNotApprovedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DerogationNotApprovedDto;
};

export type DerogationQuoteLockedDto = {
    /**
     * @type string
    */
    branchId: string;
    /**
     * @type array
    */
    editedKeys: string[];
};

export const derogationQuoteLockedErrorDtoCodeEnum = {
    DEROGATION_QUOTE_LOCKED: "DEROGATION_QUOTE_LOCKED"
} as const;

export type DerogationQuoteLockedErrorDtoCodeEnumKey = (typeof derogationQuoteLockedErrorDtoCodeEnum)[keyof typeof derogationQuoteLockedErrorDtoCodeEnum];

export type DerogationQuoteLockedErrorDto = {
    /**
     * @type string
    */
    code: DerogationQuoteLockedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DerogationQuoteLockedDto;
};

export type InsurerChangedRequoteRequiredDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    branchId: string;
    quotedInsurer?: Insurer;
    currentInsurer: Insurer;
};

export const insurerChangedRequoteRequiredErrorDtoCodeEnum = {
    INSURER_CHANGED_REQUOTE_REQUIRED: "INSURER_CHANGED_REQUOTE_REQUIRED"
} as const;

export type InsurerChangedRequoteRequiredErrorDtoCodeEnumKey = (typeof insurerChangedRequoteRequiredErrorDtoCodeEnum)[keyof typeof insurerChangedRequoteRequiredErrorDtoCodeEnum];

export type InsurerChangedRequoteRequiredErrorDto = {
    /**
     * @type string
    */
    code: InsurerChangedRequoteRequiredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InsurerChangedRequoteRequiredDto;
};

export type InvalidPolicyStateDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    reason: string;
};

export const invalidPolicyStateErrorDtoCodeEnum = {
    INVALID_POLICY_STATE: "INVALID_POLICY_STATE"
} as const;

export type InvalidPolicyStateErrorDtoCodeEnumKey = (typeof invalidPolicyStateErrorDtoCodeEnum)[keyof typeof invalidPolicyStateErrorDtoCodeEnum];

export type InvalidPolicyStateErrorDto = {
    /**
     * @type string
    */
    code: InvalidPolicyStateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPolicyStateDetailsDto;
};

export type YousignSignatureRequestStatusNotCompatibleDetailsDto = {
    /**
     * @type string
    */
    signatureRequestId: string;
    /**
     * @type string
    */
    status: string;
};

export const yousignSignatureRequestStatusNotCompatibleErrorDtoCodeEnum = {
    YOUSIGN_SIGNATURE_REQUEST_STATUS_NOT_COMPATIBLE: "YOUSIGN_SIGNATURE_REQUEST_STATUS_NOT_COMPATIBLE"
} as const;

export type YousignSignatureRequestStatusNotCompatibleErrorDtoCodeEnumKey = (typeof yousignSignatureRequestStatusNotCompatibleErrorDtoCodeEnum)[keyof typeof yousignSignatureRequestStatusNotCompatibleErrorDtoCodeEnum];

export type YousignSignatureRequestStatusNotCompatibleErrorDto = {
    /**
     * @type string
    */
    code: YousignSignatureRequestStatusNotCompatibleErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: YousignSignatureRequestStatusNotCompatibleDetailsDto;
};

export type YousignSignerStatusNotCompatibleDetailsDto = {
    /**
     * @type string
    */
    signatureRequestId: string;
    /**
     * @type string
    */
    signerId: string;
    /**
     * @type string
    */
    status: string;
};

export const yousignSignerStatusNotCompatibleErrorDtoCodeEnum = {
    YOUSIGN_SIGNER_STATUS_NOT_COMPATIBLE: "YOUSIGN_SIGNER_STATUS_NOT_COMPATIBLE"
} as const;

export type YousignSignerStatusNotCompatibleErrorDtoCodeEnumKey = (typeof yousignSignerStatusNotCompatibleErrorDtoCodeEnum)[keyof typeof yousignSignerStatusNotCompatibleErrorDtoCodeEnum];

export type YousignSignerStatusNotCompatibleErrorDto = {
    /**
     * @type string
    */
    code: YousignSignerStatusNotCompatibleErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: YousignSignerStatusNotCompatibleDetailsDto;
};

export type LockedEventStoreDetailsDto = {
    /**
     * @type array | undefined
    */
    aggregateIds?: string[];
    /**
     * @type number | undefined
    */
    eventCount?: number;
    /**
     * @type string | undefined
    */
    firstEventType?: string;
};

export const lockedEventStoreErrorDtoCodeEnum = {
    LOCKED_EVENT_STORE: "LOCKED_EVENT_STORE"
} as const;

export type LockedEventStoreErrorDtoCodeEnumKey = (typeof lockedEventStoreErrorDtoCodeEnum)[keyof typeof lockedEventStoreErrorDtoCodeEnum];

export type LockedEventStoreErrorDto = {
    /**
     * @type string
    */
    code: LockedEventStoreErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: LockedEventStoreDetailsDto;
};

export type ProjectionLockedDetailsDto = object;

export const lockedProjectionErrorDtoCodeEnum = {
    LOCKED_PROJECTION: "LOCKED_PROJECTION"
} as const;

export type LockedProjectionErrorDtoCodeEnumKey = (typeof lockedProjectionErrorDtoCodeEnum)[keyof typeof lockedProjectionErrorDtoCodeEnum];

export type LockedProjectionErrorDto = {
    /**
     * @type string
    */
    code: LockedProjectionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ProjectionLockedDetailsDto;
};

export type LockActiveDetailsDto = object;

export const lockActiveErrorDtoCodeEnum = {
    LOCK_ACTIVE: "LOCK_ACTIVE"
} as const;

export type LockActiveErrorDtoCodeEnumKey = (typeof lockActiveErrorDtoCodeEnum)[keyof typeof lockActiveErrorDtoCodeEnum];

export type LockActiveErrorDto = {
    /**
     * @type string
    */
    code: LockActiveErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: LockActiveDetailsDto;
};

export type MalwareScanPendingDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const malwareScanPendingErrorDtoCodeEnum = {
    MALWARE_SCAN_PENDING: "MALWARE_SCAN_PENDING"
} as const;

export type MalwareScanPendingErrorDtoCodeEnumKey = (typeof malwareScanPendingErrorDtoCodeEnum)[keyof typeof malwareScanPendingErrorDtoCodeEnum];

export type MalwareScanPendingErrorDto = {
    /**
     * @type string
    */
    code: MalwareScanPendingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MalwareScanPendingDetailsDto;
};

export type DocumentExtractionPendingDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const documentExtractionPendingErrorDtoCodeEnum = {
    DOCUMENT_EXTRACTION_PENDING: "DOCUMENT_EXTRACTION_PENDING"
} as const;

export type DocumentExtractionPendingErrorDtoCodeEnumKey = (typeof documentExtractionPendingErrorDtoCodeEnum)[keyof typeof documentExtractionPendingErrorDtoCodeEnum];

export type DocumentExtractionPendingErrorDto = {
    /**
     * @type string
    */
    code: DocumentExtractionPendingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentExtractionPendingDetailsDto;
};

export type WorkflowErrorDetailsDto = {
    /**
     * @type string
    */
    nodeName: string;
    /**
     * @type string
    */
    workflowRunId: string;
    /**
     * @type string
    */
    workflowType: string;
};

export const workflowErrorErrorDtoCodeEnum = {
    WORKFLOW_ERROR: "WORKFLOW_ERROR"
} as const;

export type WorkflowErrorErrorDtoCodeEnumKey = (typeof workflowErrorErrorDtoCodeEnum)[keyof typeof workflowErrorErrorDtoCodeEnum];

export type WorkflowErrorErrorDto = {
    /**
     * @type string
    */
    code: WorkflowErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WorkflowErrorDetailsDto;
};

export type WorkflowFailedDetailsDto = {
    /**
     * @type string
    */
    message: string;
};

export const workflowFailedErrorDtoCodeEnum = {
    WORKFLOW_FAILED: "WORKFLOW_FAILED"
} as const;

export type WorkflowFailedErrorDtoCodeEnumKey = (typeof workflowFailedErrorDtoCodeEnum)[keyof typeof workflowFailedErrorDtoCodeEnum];

export type WorkflowFailedErrorDto = {
    /**
     * @type string
    */
    code: WorkflowFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WorkflowFailedDetailsDto;
};

export type ApiSpreadsheetsClientErrorDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
    /**
     * @type string
    */
    operation: string;
};

export const apiSpreadsheetsClientErrorErrorDtoCodeEnum = {
    API_SPREADSHEETS_CLIENT_ERROR: "API_SPREADSHEETS_CLIENT_ERROR"
} as const;

export type ApiSpreadsheetsClientErrorErrorDtoCodeEnumKey = (typeof apiSpreadsheetsClientErrorErrorDtoCodeEnum)[keyof typeof apiSpreadsheetsClientErrorErrorDtoCodeEnum];

export type ApiSpreadsheetsClientErrorErrorDto = {
    /**
     * @type string
    */
    code: ApiSpreadsheetsClientErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ApiSpreadsheetsClientErrorDetailsDto;
};

export type UnsupportedEmailEntityTypeDetailsDto = {
    /**
     * @type string
    */
    entityType: string;
    /**
     * @type string
    */
    eventType: string;
};

export const unsupportedEmailEntityTypeErrorDtoCodeEnum = {
    UNSUPPORTED_EMAIL_ENTITY_TYPE: "UNSUPPORTED_EMAIL_ENTITY_TYPE"
} as const;

export type UnsupportedEmailEntityTypeErrorDtoCodeEnumKey = (typeof unsupportedEmailEntityTypeErrorDtoCodeEnum)[keyof typeof unsupportedEmailEntityTypeErrorDtoCodeEnum];

export type UnsupportedEmailEntityTypeErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedEmailEntityTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedEmailEntityTypeDetailsDto;
};

export type MissingScopeConfigDetailsDto = {
    /**
     * @type string | undefined
    */
    route?: string;
};

export const missingScopeConfigErrorDtoCodeEnum = {
    MISSING_SCOPE_CONFIG: "MISSING_SCOPE_CONFIG"
} as const;

export type MissingScopeConfigErrorDtoCodeEnumKey = (typeof missingScopeConfigErrorDtoCodeEnum)[keyof typeof missingScopeConfigErrorDtoCodeEnum];

export type MissingScopeConfigErrorDto = {
    /**
     * @type string
    */
    code: MissingScopeConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingScopeConfigDetailsDto;
};

export type SydiaApiErrorDetailsDto = {
    /**
     * @type string
    */
    endpoint: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const sydiaApiErrorErrorDtoCodeEnum = {
    SYDIA_API_ERROR: "SYDIA_API_ERROR"
} as const;

export type SydiaApiErrorErrorDtoCodeEnumKey = (typeof sydiaApiErrorErrorDtoCodeEnum)[keyof typeof sydiaApiErrorErrorDtoCodeEnum];

export type SydiaApiErrorErrorDto = {
    /**
     * @type string
    */
    code: SydiaApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SydiaApiErrorDetailsDto;
};

export type SydiaConfigurationErrorDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const sydiaConfigurationErrorErrorDtoCodeEnum = {
    SYDIA_CONFIGURATION_ERROR: "SYDIA_CONFIGURATION_ERROR"
} as const;

export type SydiaConfigurationErrorErrorDtoCodeEnumKey = (typeof sydiaConfigurationErrorErrorDtoCodeEnum)[keyof typeof sydiaConfigurationErrorErrorDtoCodeEnum];

export type SydiaConfigurationErrorErrorDto = {
    /**
     * @type string
    */
    code: SydiaConfigurationErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SydiaConfigurationErrorDetailsDto;
};

export type WakamApiErrorDetailsDto = {
    /**
     * @type string
    */
    path: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const wakamApiErrorErrorDtoCodeEnum = {
    WAKAM_API_ERROR: "WAKAM_API_ERROR"
} as const;

export type WakamApiErrorErrorDtoCodeEnumKey = (typeof wakamApiErrorErrorDtoCodeEnum)[keyof typeof wakamApiErrorErrorDtoCodeEnum];

export type WakamApiErrorErrorDto = {
    /**
     * @type string
    */
    code: WakamApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WakamApiErrorDetailsDto;
};

export const wakamApiValidationErrorErrorDtoCodeEnum = {
    WAKAM_API_VALIDATION_ERROR: "WAKAM_API_VALIDATION_ERROR"
} as const;

export type WakamApiValidationErrorErrorDtoCodeEnumKey = (typeof wakamApiValidationErrorErrorDtoCodeEnum)[keyof typeof wakamApiValidationErrorErrorDtoCodeEnum];

export type WakamApiValidationErrorErrorDto = {
    /**
     * @type string
    */
    code: WakamApiValidationErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WakamApiErrorDetailsDto;
};

export type CfdpApiErrorDetailsDto = {
    /**
     * @type string
    */
    path: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const cfdpApiErrorErrorDtoCodeEnum = {
    CFDP_API_ERROR: "CFDP_API_ERROR"
} as const;

export type CfdpApiErrorErrorDtoCodeEnumKey = (typeof cfdpApiErrorErrorDtoCodeEnum)[keyof typeof cfdpApiErrorErrorDtoCodeEnum];

export type CfdpApiErrorErrorDto = {
    /**
     * @type string
    */
    code: CfdpApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CfdpApiErrorDetailsDto;
};

export type SivApiErrorDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const sivApiErrorErrorDtoCodeEnum = {
    SIV_API_ERROR: "SIV_API_ERROR"
} as const;

export type SivApiErrorErrorDtoCodeEnumKey = (typeof sivApiErrorErrorDtoCodeEnum)[keyof typeof sivApiErrorErrorDtoCodeEnum];

export type SivApiErrorErrorDto = {
    /**
     * @type string
    */
    code: SivApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SivApiErrorDetailsDto;
};

export type SirenApiErrorDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const sirenApiErrorErrorDtoCodeEnum = {
    SIREN_API_ERROR: "SIREN_API_ERROR"
} as const;

export type SirenApiErrorErrorDtoCodeEnumKey = (typeof sirenApiErrorErrorDtoCodeEnum)[keyof typeof sirenApiErrorErrorDtoCodeEnum];

export type SirenApiErrorErrorDto = {
    /**
     * @type string
    */
    code: SirenApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SirenApiErrorDetailsDto;
};

export type DrivequantApiErrorDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const drivequantApiErrorErrorDtoCodeEnum = {
    DRIVEQUANT_API_ERROR: "DRIVEQUANT_API_ERROR"
} as const;

export type DrivequantApiErrorErrorDtoCodeEnumKey = (typeof drivequantApiErrorErrorDtoCodeEnum)[keyof typeof drivequantApiErrorErrorDtoCodeEnum];

export type DrivequantApiErrorErrorDto = {
    /**
     * @type string
    */
    code: DrivequantApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DrivequantApiErrorDetailsDto;
};

export type FvaApiErrorDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const fvaApiErrorErrorDtoCodeEnum = {
    FVA_API_ERROR: "FVA_API_ERROR"
} as const;

export type FvaApiErrorErrorDtoCodeEnumKey = (typeof fvaApiErrorErrorDtoCodeEnum)[keyof typeof fvaApiErrorErrorDtoCodeEnum];

export type FvaApiErrorErrorDto = {
    /**
     * @type string
    */
    code: FvaApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FvaApiErrorDetailsDto;
};

export type MtlsCertificateErrorDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const mtlsCertificateErrorErrorDtoCodeEnum = {
    MTLS_CERTIFICATE_ERROR: "MTLS_CERTIFICATE_ERROR"
} as const;

export type MtlsCertificateErrorErrorDtoCodeEnumKey = (typeof mtlsCertificateErrorErrorDtoCodeEnum)[keyof typeof mtlsCertificateErrorErrorDtoCodeEnum];

export type MtlsCertificateErrorErrorDto = {
    /**
     * @type string
    */
    code: MtlsCertificateErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MtlsCertificateErrorDetailsDto;
};

export type RequestTimeoutErrorDetailsDto = {
    /**
     * @type string
    */
    service: string;
    /**
     * @type string | undefined
    */
    endpoint?: string;
};

export const requestTimeoutErrorDtoCodeEnum = {
    REQUEST_TIMEOUT: "REQUEST_TIMEOUT"
} as const;

export type RequestTimeoutErrorDtoCodeEnumKey = (typeof requestTimeoutErrorDtoCodeEnum)[keyof typeof requestTimeoutErrorDtoCodeEnum];

export type RequestTimeoutErrorDto = {
    /**
     * @type string
    */
    code: RequestTimeoutErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RequestTimeoutErrorDetailsDto;
};

export type MissingBrokerageFirmIdDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    customerId?: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingBrokerageFirmIdErrorDtoCodeEnum = {
    MISSING_BROKERAGE_FIRM_ID: "MISSING_BROKERAGE_FIRM_ID"
} as const;

export type MissingBrokerageFirmIdErrorDtoCodeEnumKey = (typeof missingBrokerageFirmIdErrorDtoCodeEnum)[keyof typeof missingBrokerageFirmIdErrorDtoCodeEnum];

export type MissingBrokerageFirmIdErrorDto = {
    /**
     * @type string
    */
    code: MissingBrokerageFirmIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingBrokerageFirmIdDetailsDto;
};

export type MissingAuthorIdDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const missingAuthorIdErrorDtoCodeEnum = {
    MISSING_AUTHOR_ID: "MISSING_AUTHOR_ID"
} as const;

export type MissingAuthorIdErrorDtoCodeEnumKey = (typeof missingAuthorIdErrorDtoCodeEnum)[keyof typeof missingAuthorIdErrorDtoCodeEnum];

export type MissingAuthorIdErrorDto = {
    /**
     * @type string
    */
    code: MissingAuthorIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAuthorIdDetailsDto;
};

export type MissingUserEmailDetailsDto = {
    /**
     * @type string
    */
    userId: string;
};

export const missingUserEmailErrorDtoCodeEnum = {
    MISSING_USER_EMAIL: "MISSING_USER_EMAIL"
} as const;

export type MissingUserEmailErrorDtoCodeEnumKey = (typeof missingUserEmailErrorDtoCodeEnum)[keyof typeof missingUserEmailErrorDtoCodeEnum];

export type MissingUserEmailErrorDto = {
    /**
     * @type string
    */
    code: MissingUserEmailErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingUserEmailDetailsDto;
};

export type MissingPolicyStartedAtDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const missingPolicyStartedAtErrorDtoCodeEnum = {
    MISSING_POLICY_STARTED_AT: "MISSING_POLICY_STARTED_AT"
} as const;

export type MissingPolicyStartedAtErrorDtoCodeEnumKey = (typeof missingPolicyStartedAtErrorDtoCodeEnum)[keyof typeof missingPolicyStartedAtErrorDtoCodeEnum];

export type MissingPolicyStartedAtErrorDto = {
    /**
     * @type string
    */
    code: MissingPolicyStartedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingPolicyStartedAtDetailsDto;
};

export type MissingPolicyEndedAtDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const missingPolicyEndedAtErrorDtoCodeEnum = {
    MISSING_POLICY_ENDED_AT: "MISSING_POLICY_ENDED_AT"
} as const;

export type MissingPolicyEndedAtErrorDtoCodeEnumKey = (typeof missingPolicyEndedAtErrorDtoCodeEnum)[keyof typeof missingPolicyEndedAtErrorDtoCodeEnum];

export type MissingPolicyEndedAtErrorDto = {
    /**
     * @type string
    */
    code: MissingPolicyEndedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingPolicyEndedAtDetailsDto;
};

export type MissingRepricingPeriodDetailsDto = {
    /**
     * @type string | undefined
    */
    productId?: string;
};

export const missingRepricingPeriodErrorDtoCodeEnum = {
    MISSING_REPRICING_PERIOD: "MISSING_REPRICING_PERIOD"
} as const;

export type MissingRepricingPeriodErrorDtoCodeEnumKey = (typeof missingRepricingPeriodErrorDtoCodeEnum)[keyof typeof missingRepricingPeriodErrorDtoCodeEnum];

export type MissingRepricingPeriodErrorDto = {
    /**
     * @type string
    */
    code: MissingRepricingPeriodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingRepricingPeriodDetailsDto;
};

export type MissingDrivequantUserIdKeyDetailsDto = {
    /**
     * @type string | undefined
    */
    productId?: string;
};

export const missingDrivequantUserIdKeyErrorDtoCodeEnum = {
    MISSING_DRIVEQUANT_USER_ID_KEY: "MISSING_DRIVEQUANT_USER_ID_KEY"
} as const;

export type MissingDrivequantUserIdKeyErrorDtoCodeEnumKey = (typeof missingDrivequantUserIdKeyErrorDtoCodeEnum)[keyof typeof missingDrivequantUserIdKeyErrorDtoCodeEnum];

export type MissingDrivequantUserIdKeyErrorDto = {
    /**
     * @type string
    */
    code: MissingDrivequantUserIdKeyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingDrivequantUserIdKeyDetailsDto;
};

export type MissingWorkflowDefinitionDetailsDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    workflowType: string;
};

export const missingWorkflowDefinitionErrorDtoCodeEnum = {
    MISSING_WORKFLOW_DEFINITION: "MISSING_WORKFLOW_DEFINITION"
} as const;

export type MissingWorkflowDefinitionErrorDtoCodeEnumKey = (typeof missingWorkflowDefinitionErrorDtoCodeEnum)[keyof typeof missingWorkflowDefinitionErrorDtoCodeEnum];

export type MissingWorkflowDefinitionErrorDto = {
    /**
     * @type string
    */
    code: MissingWorkflowDefinitionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingWorkflowDefinitionDetailsDto;
};

export type MissingSignerConfigDetailsDto = {
    /**
     * @type object
    */
    signerConfig: object;
};

export const missingSignerConfigErrorDtoCodeEnum = {
    MISSING_SIGNER_CONFIG: "MISSING_SIGNER_CONFIG"
} as const;

export type MissingSignerConfigErrorDtoCodeEnumKey = (typeof missingSignerConfigErrorDtoCodeEnum)[keyof typeof missingSignerConfigErrorDtoCodeEnum];

export type MissingSignerConfigErrorDto = {
    /**
     * @type string
    */
    code: MissingSignerConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingSignerConfigDetailsDto;
};

export type MissingBrokerageFeeDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const missingBrokerageFeeErrorDtoCodeEnum = {
    MISSING_BROKERAGE_FEE: "MISSING_BROKERAGE_FEE"
} as const;

export type MissingBrokerageFeeErrorDtoCodeEnumKey = (typeof missingBrokerageFeeErrorDtoCodeEnum)[keyof typeof missingBrokerageFeeErrorDtoCodeEnum];

export type MissingBrokerageFeeErrorDto = {
    /**
     * @type string
    */
    code: MissingBrokerageFeeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingBrokerageFeeDetailsDto;
};

export type MissingUserIdDetailsDto = object;

export const missingUserIdErrorDtoCodeEnum = {
    MISSING_USER_ID: "MISSING_USER_ID"
} as const;

export type MissingUserIdErrorDtoCodeEnumKey = (typeof missingUserIdErrorDtoCodeEnum)[keyof typeof missingUserIdErrorDtoCodeEnum];

export type MissingUserIdErrorDto = {
    /**
     * @type string
    */
    code: MissingUserIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingUserIdDetailsDto;
};

export type FailedToCalculatePolicyStartedAtDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const failedToCalculatePolicyStartedAtErrorDtoCodeEnum = {
    FAILED_TO_CALCULATE_POLICY_STARTED_AT: "FAILED_TO_CALCULATE_POLICY_STARTED_AT"
} as const;

export type FailedToCalculatePolicyStartedAtErrorDtoCodeEnumKey = (typeof failedToCalculatePolicyStartedAtErrorDtoCodeEnum)[keyof typeof failedToCalculatePolicyStartedAtErrorDtoCodeEnum];

export type FailedToCalculatePolicyStartedAtErrorDto = {
    /**
     * @type string
    */
    code: FailedToCalculatePolicyStartedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToCalculatePolicyStartedAtDetailsDto;
};

export type FailedToGetInvoicingScheduleDetailsDto = object;

export const failedToGetInvoicingScheduleErrorDtoCodeEnum = {
    FAILED_TO_GET_INVOICING_SCHEDULE: "FAILED_TO_GET_INVOICING_SCHEDULE"
} as const;

export type FailedToGetInvoicingScheduleErrorDtoCodeEnumKey = (typeof failedToGetInvoicingScheduleErrorDtoCodeEnum)[keyof typeof failedToGetInvoicingScheduleErrorDtoCodeEnum];

export type FailedToGetInvoicingScheduleErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetInvoicingScheduleErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetInvoicingScheduleDetailsDto;
};

export type FailedToGetDrivequantCustomFieldsDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const failedToGetDrivequantCustomFieldsErrorDtoCodeEnum = {
    FAILED_TO_GET_DRIVEQUANT_CUSTOM_FIELDS: "FAILED_TO_GET_DRIVEQUANT_CUSTOM_FIELDS"
} as const;

export type FailedToGetDrivequantCustomFieldsErrorDtoCodeEnumKey = (typeof failedToGetDrivequantCustomFieldsErrorDtoCodeEnum)[keyof typeof failedToGetDrivequantCustomFieldsErrorDtoCodeEnum];

export type FailedToGetDrivequantCustomFieldsErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetDrivequantCustomFieldsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetDrivequantCustomFieldsDetailsDto;
};

export type FailedToRetrieveDrivequantSurchargeRateDetailsDto = object;

export const failedToRetrieveDrivequantSurchargeRateErrorDtoCodeEnum = {
    FAILED_TO_RETRIEVE_DRIVEQUANT_SURCHARGE_RATE: "FAILED_TO_RETRIEVE_DRIVEQUANT_SURCHARGE_RATE"
} as const;

export type FailedToRetrieveDrivequantSurchargeRateErrorDtoCodeEnumKey = (typeof failedToRetrieveDrivequantSurchargeRateErrorDtoCodeEnum)[keyof typeof failedToRetrieveDrivequantSurchargeRateErrorDtoCodeEnum];

export type FailedToRetrieveDrivequantSurchargeRateErrorDto = {
    /**
     * @type string
    */
    code: FailedToRetrieveDrivequantSurchargeRateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToRetrieveDrivequantSurchargeRateDetailsDto;
};

export type InvalidJobSchedulerCommandDetailsDto = {
    /**
     * @type string
    */
    command: string;
};

export const invalidJobSchedulerCommandErrorDtoCodeEnum = {
    INVALID_JOB_SCHEDULER_COMMAND: "INVALID_JOB_SCHEDULER_COMMAND"
} as const;

export type InvalidJobSchedulerCommandErrorDtoCodeEnumKey = (typeof invalidJobSchedulerCommandErrorDtoCodeEnum)[keyof typeof invalidJobSchedulerCommandErrorDtoCodeEnum];

export type InvalidJobSchedulerCommandErrorDto = {
    /**
     * @type string
    */
    code: InvalidJobSchedulerCommandErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidJobSchedulerCommandDetailsDto;
};

export type InvalidJobSchedulerIdDetailsDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type number
    */
    parts: number;
    /**
     * @type number
    */
    maxParts: number;
};

export const invalidJobSchedulerIdErrorDtoCodeEnum = {
    INVALID_JOB_SCHEDULER_ID: "INVALID_JOB_SCHEDULER_ID"
} as const;

export type InvalidJobSchedulerIdErrorDtoCodeEnumKey = (typeof invalidJobSchedulerIdErrorDtoCodeEnum)[keyof typeof invalidJobSchedulerIdErrorDtoCodeEnum];

export type InvalidJobSchedulerIdErrorDto = {
    /**
     * @type string
    */
    code: InvalidJobSchedulerIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidJobSchedulerIdDetailsDto;
};

export type MissingJobIdDetailsDto = {
    /**
     * @type string
    */
    jobName: string;
    /**
     * @type string | undefined
    */
    jobId?: string;
};

export const missingJobIdErrorDtoCodeEnum = {
    MISSING_JOB_ID: "MISSING_JOB_ID"
} as const;

export type MissingJobIdErrorDtoCodeEnumKey = (typeof missingJobIdErrorDtoCodeEnum)[keyof typeof missingJobIdErrorDtoCodeEnum];

export type MissingJobIdErrorDto = {
    /**
     * @type string
    */
    code: MissingJobIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingJobIdDetailsDto;
};

export type InvalidBatchJobPayloadsBlobDetailsDto = {
    /**
     * @type string
    */
    reason: string;
};

export const invalidBatchJobPayloadsBlobErrorDtoCodeEnum = {
    INVALID_BATCH_JOB_PAYLOADS_BLOB: "INVALID_BATCH_JOB_PAYLOADS_BLOB"
} as const;

export type InvalidBatchJobPayloadsBlobErrorDtoCodeEnumKey = (typeof invalidBatchJobPayloadsBlobErrorDtoCodeEnum)[keyof typeof invalidBatchJobPayloadsBlobErrorDtoCodeEnum];

export type InvalidBatchJobPayloadsBlobErrorDto = {
    /**
     * @type string
    */
    code: InvalidBatchJobPayloadsBlobErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBatchJobPayloadsBlobDetailsDto;
};

export type WorkflowCancellationErrorDetailsDto = {
    /**
     * @type array
    */
    errors: string[];
};

export const workflowCancellationErrorErrorDtoCodeEnum = {
    WORKFLOW_CANCELLATION_ERROR: "WORKFLOW_CANCELLATION_ERROR"
} as const;

export type WorkflowCancellationErrorErrorDtoCodeEnumKey = (typeof workflowCancellationErrorErrorDtoCodeEnum)[keyof typeof workflowCancellationErrorErrorDtoCodeEnum];

export type WorkflowCancellationErrorErrorDto = {
    /**
     * @type string
    */
    code: WorkflowCancellationErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WorkflowCancellationErrorDetailsDto;
};

export type InvalidWorkflowNodeTypeDetailsDto = {
    /**
     * @type string
    */
    nodeType: string;
    /**
     * @type string | undefined
    */
    nodeName?: string;
    /**
     * @type string | undefined
    */
    workflowName?: string;
};

export const invalidWorkflowNodeTypeErrorDtoCodeEnum = {
    INVALID_WORKFLOW_NODE_TYPE: "INVALID_WORKFLOW_NODE_TYPE"
} as const;

export type InvalidWorkflowNodeTypeErrorDtoCodeEnumKey = (typeof invalidWorkflowNodeTypeErrorDtoCodeEnum)[keyof typeof invalidWorkflowNodeTypeErrorDtoCodeEnum];

export type InvalidWorkflowNodeTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidWorkflowNodeTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidWorkflowNodeTypeDetailsDto;
};

export type InvalidWorkflowStateDetailsDto = {
    /**
     * @type string
    */
    message: string;
    /**
     * @type string | undefined
    */
    workflowRunId?: string;
    /**
     * @type string | undefined
    */
    nodeRunId?: string;
};

export const invalidWorkflowStateErrorDtoCodeEnum = {
    INVALID_WORKFLOW_STATE: "INVALID_WORKFLOW_STATE"
} as const;

export type InvalidWorkflowStateErrorDtoCodeEnumKey = (typeof invalidWorkflowStateErrorDtoCodeEnum)[keyof typeof invalidWorkflowStateErrorDtoCodeEnum];

export type InvalidWorkflowStateErrorDto = {
    /**
     * @type string
    */
    code: InvalidWorkflowStateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidWorkflowStateDetailsDto;
};

export type InvalidBillingIntervalDetailsDto = {
    /**
     * @type string
    */
    invalidReason: string;
    /**
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @type number | undefined
    */
    premiumScheduleLength?: number;
    /**
     * @type string | undefined
    */
    earliestStartAt?: string;
    /**
     * @type string | undefined
    */
    latestEndAt?: string;
};

export const invalidBillingIntervalErrorDtoCodeEnum = {
    INVALID_BILLING_INTERVAL: "INVALID_BILLING_INTERVAL"
} as const;

export type InvalidBillingIntervalErrorDtoCodeEnumKey = (typeof invalidBillingIntervalErrorDtoCodeEnum)[keyof typeof invalidBillingIntervalErrorDtoCodeEnum];

export type InvalidBillingIntervalErrorDto = {
    /**
     * @type string
    */
    code: InvalidBillingIntervalErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBillingIntervalDetailsDto;
};

export type InvalidBillingPeriodDetailsDto = {
    /**
     * @type string
    */
    invalidReason: string;
    /**
     * @type string | undefined
    */
    periodStart?: string;
    /**
     * @type string | undefined
    */
    periodEnd?: string;
    /**
     * @type string | undefined
    */
    tenantId?: string;
};

export const invalidBillingPeriodErrorDtoCodeEnum = {
    INVALID_BILLING_PERIOD: "INVALID_BILLING_PERIOD"
} as const;

export type InvalidBillingPeriodErrorDtoCodeEnumKey = (typeof invalidBillingPeriodErrorDtoCodeEnum)[keyof typeof invalidBillingPeriodErrorDtoCodeEnum];

export type InvalidBillingPeriodErrorDto = {
    /**
     * @type string
    */
    code: InvalidBillingPeriodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidBillingPeriodDetailsDto;
};

export type InvalidEventTypeForHandlerDetailsDto = {
    /**
     * @type string
    */
    eventType: string;
};

export const invalidEventTypeForHandlerErrorDtoCodeEnum = {
    INVALID_EVENT_TYPE_FOR_HANDLER: "INVALID_EVENT_TYPE_FOR_HANDLER"
} as const;

export type InvalidEventTypeForHandlerErrorDtoCodeEnumKey = (typeof invalidEventTypeForHandlerErrorDtoCodeEnum)[keyof typeof invalidEventTypeForHandlerErrorDtoCodeEnum];

export type InvalidEventTypeForHandlerErrorDto = {
    /**
     * @type string
    */
    code: InvalidEventTypeForHandlerErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEventTypeForHandlerDetailsDto;
};

export type InvalidMergedPeriodDetailsDto = {
    /**
     * @type string
    */
    invalidReason: string;
    /**
     * @type number | undefined
    */
    invoiceCount?: number;
    /**
     * @type string | undefined
    */
    earliestStartAt?: string;
    /**
     * @type string | undefined
    */
    latestEndAt?: string;
    /**
     * @type array | undefined
    */
    invoiceIds?: string[];
};

export const invalidMergedPeriodErrorDtoCodeEnum = {
    INVALID_MERGED_PERIOD: "INVALID_MERGED_PERIOD"
} as const;

export type InvalidMergedPeriodErrorDtoCodeEnumKey = (typeof invalidMergedPeriodErrorDtoCodeEnum)[keyof typeof invalidMergedPeriodErrorDtoCodeEnum];

export type InvalidMergedPeriodErrorDto = {
    /**
     * @type string
    */
    code: InvalidMergedPeriodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidMergedPeriodDetailsDto;
};

export type InvalidPremiumIntervalDetailsDto = {
    /**
     * @type string
    */
    start: string;
    /**
     * @type string
    */
    end: string;
    /**
     * @type string
    */
    invalidReason: string;
};

export const invalidPremiumIntervalErrorDtoCodeEnum = {
    INVALID_PREMIUM_INTERVAL: "INVALID_PREMIUM_INTERVAL"
} as const;

export type InvalidPremiumIntervalErrorDtoCodeEnumKey = (typeof invalidPremiumIntervalErrorDtoCodeEnum)[keyof typeof invalidPremiumIntervalErrorDtoCodeEnum];

export type InvalidPremiumIntervalErrorDto = {
    /**
     * @type string
    */
    code: InvalidPremiumIntervalErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPremiumIntervalDetailsDto;
};

export type InvoiceAlreadyHasIncrementalIdDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export const invoiceAlreadyHasIncrementalIdErrorDtoCodeEnum = {
    INVOICE_ALREADY_HAS_INCREMENTAL_ID: "INVOICE_ALREADY_HAS_INCREMENTAL_ID"
} as const;

export type InvoiceAlreadyHasIncrementalIdErrorDtoCodeEnumKey = (typeof invoiceAlreadyHasIncrementalIdErrorDtoCodeEnum)[keyof typeof invoiceAlreadyHasIncrementalIdErrorDtoCodeEnum];

export type InvoiceAlreadyHasIncrementalIdErrorDto = {
    /**
     * @type string
    */
    code: InvoiceAlreadyHasIncrementalIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceAlreadyHasIncrementalIdDetailsDto;
};

export type InvoiceAlreadyPaidDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export const invoiceAlreadyPaidErrorDtoCodeEnum = {
    INVOICE_ALREADY_PAID: "INVOICE_ALREADY_PAID"
} as const;

export type InvoiceAlreadyPaidErrorDtoCodeEnumKey = (typeof invoiceAlreadyPaidErrorDtoCodeEnum)[keyof typeof invoiceAlreadyPaidErrorDtoCodeEnum];

export type InvoiceAlreadyPaidErrorDto = {
    /**
     * @type string
    */
    code: InvoiceAlreadyPaidErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceAlreadyPaidDetailsDto;
};

export type InvoiceAlreadyReplacedDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export const invoiceAlreadyReplacedErrorDtoCodeEnum = {
    INVOICE_ALREADY_REPLACED: "INVOICE_ALREADY_REPLACED"
} as const;

export type InvoiceAlreadyReplacedErrorDtoCodeEnumKey = (typeof invoiceAlreadyReplacedErrorDtoCodeEnum)[keyof typeof invoiceAlreadyReplacedErrorDtoCodeEnum];

export type InvoiceAlreadyReplacedErrorDto = {
    /**
     * @type string
    */
    code: InvoiceAlreadyReplacedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceAlreadyReplacedDetailsDto;
};

export type InvoiceNoComponentDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
    /**
     * @type string | undefined
    */
    issuedAt?: string;
};

export const invoiceNoComponentErrorDtoCodeEnum = {
    INVOICE_NO_COMPONENT: "INVOICE_NO_COMPONENT"
} as const;

export type InvoiceNoComponentErrorDtoCodeEnumKey = (typeof invoiceNoComponentErrorDtoCodeEnum)[keyof typeof invoiceNoComponentErrorDtoCodeEnum];

export type InvoiceNoComponentErrorDto = {
    /**
     * @type string
    */
    code: InvoiceNoComponentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceNoComponentDetailsDto;
};

export type UnknownQueueDetailsDto = {
    /**
     * @type string
    */
    queueName: string;
};

export const unknownQueueErrorDtoCodeEnum = {
    UNKNOWN_QUEUE: "UNKNOWN_QUEUE"
} as const;

export type UnknownQueueErrorDtoCodeEnumKey = (typeof unknownQueueErrorDtoCodeEnum)[keyof typeof unknownQueueErrorDtoCodeEnum];

export type UnknownQueueErrorDto = {
    /**
     * @type string
    */
    code: UnknownQueueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownQueueDetailsDto;
};

export type UnsupportedInvoiceTimingDetailsDto = {
    /**
     * @type string
    */
    timing: string;
};

export const unsupportedInvoiceTimingErrorDtoCodeEnum = {
    UNSUPPORTED_INVOICE_TIMING: "UNSUPPORTED_INVOICE_TIMING"
} as const;

export type UnsupportedInvoiceTimingErrorDtoCodeEnumKey = (typeof unsupportedInvoiceTimingErrorDtoCodeEnum)[keyof typeof unsupportedInvoiceTimingErrorDtoCodeEnum];

export type UnsupportedInvoiceTimingErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedInvoiceTimingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedInvoiceTimingDetailsDto;
};

export type EarlyPaymentInvalidIntervalsDetailsDto = object;

export const earlyPaymentInvalidIntervalsErrorDtoCodeEnum = {
    EARLY_PAYMENT_INVALID_INTERVALS: "EARLY_PAYMENT_INVALID_INTERVALS"
} as const;

export type EarlyPaymentInvalidIntervalsErrorDtoCodeEnumKey = (typeof earlyPaymentInvalidIntervalsErrorDtoCodeEnum)[keyof typeof earlyPaymentInvalidIntervalsErrorDtoCodeEnum];

export type EarlyPaymentInvalidIntervalsErrorDto = {
    /**
     * @type string
    */
    code: EarlyPaymentInvalidIntervalsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EarlyPaymentInvalidIntervalsDetailsDto;
};

export type ErrorHandlingPaymentEventDetailsDto = {
    /**
     * @type string
    */
    eventType: string;
    /**
     * @type array
    */
    errors: string[];
    /**
     * @type array | undefined
    */
    failedInvoiceIds?: string[];
    /**
     * @type number | undefined
    */
    errorCount?: number;
    /**
     * @type number | undefined
    */
    totalInvoiceCount?: number;
};

export const errorHandlingPaymentEventErrorDtoCodeEnum = {
    ERROR_HANDLING_PAYMENT_EVENT: "ERROR_HANDLING_PAYMENT_EVENT"
} as const;

export type ErrorHandlingPaymentEventErrorDtoCodeEnumKey = (typeof errorHandlingPaymentEventErrorDtoCodeEnum)[keyof typeof errorHandlingPaymentEventErrorDtoCodeEnum];

export type ErrorHandlingPaymentEventErrorDto = {
    /**
     * @type string
    */
    code: ErrorHandlingPaymentEventErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ErrorHandlingPaymentEventDetailsDto;
};

export type EventsMustHaveSameTenantIdDetailsDto = {
    /**
     * @type array | undefined
    */
    conflictingTenantIds?: string[];
    /**
     * @type number | undefined
    */
    eventCount?: number;
    /**
     * @type string | undefined
    */
    firstAggregateId?: string;
};

export const eventsMustHaveSameTenantIdErrorDtoCodeEnum = {
    EVENTS_MUST_HAVE_SAME_TENANT_ID: "EVENTS_MUST_HAVE_SAME_TENANT_ID"
} as const;

export type EventsMustHaveSameTenantIdErrorDtoCodeEnumKey = (typeof eventsMustHaveSameTenantIdErrorDtoCodeEnum)[keyof typeof eventsMustHaveSameTenantIdErrorDtoCodeEnum];

export type EventsMustHaveSameTenantIdErrorDto = {
    /**
     * @type string
    */
    code: EventsMustHaveSameTenantIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EventsMustHaveSameTenantIdDetailsDto;
};

export type MissingObjectInEventDetailsDto = {
    /**
     * @type string | undefined
    */
    eventType?: string;
    /**
     * @type string | undefined
    */
    aggregateId?: string;
};

export const missingObjectInEventErrorDtoCodeEnum = {
    MISSING_OBJECT_IN_EVENT: "MISSING_OBJECT_IN_EVENT"
} as const;

export type MissingObjectInEventErrorDtoCodeEnumKey = (typeof missingObjectInEventErrorDtoCodeEnum)[keyof typeof missingObjectInEventErrorDtoCodeEnum];

export type MissingObjectInEventErrorDto = {
    /**
     * @type string
    */
    code: MissingObjectInEventErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingObjectInEventDetailsDto;
};

export type MissingTenantInEventMetadataDetailsDto = {
    /**
     * @type string | undefined
    */
    eventType?: string;
    /**
     * @type string | undefined
    */
    aggregateId?: string;
    /**
     * @type number | undefined
    */
    eventCount?: number;
};

export const missingTenantInEventMetadataErrorDtoCodeEnum = {
    MISSING_TENANT_IN_EVENT_METADATA: "MISSING_TENANT_IN_EVENT_METADATA"
} as const;

export type MissingTenantInEventMetadataErrorDtoCodeEnumKey = (typeof missingTenantInEventMetadataErrorDtoCodeEnum)[keyof typeof missingTenantInEventMetadataErrorDtoCodeEnum];

export type MissingTenantInEventMetadataErrorDto = {
    /**
     * @type string
    */
    code: MissingTenantInEventMetadataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingTenantInEventMetadataDetailsDto;
};

export type UnknownTemplateVariableDetailsDto = {
    /**
     * @type string
    */
    key: string;
};

export const unknownTemplateVariableErrorDtoCodeEnum = {
    UNKNOWN_TEMPLATE_VARIABLE: "UNKNOWN_TEMPLATE_VARIABLE"
} as const;

export type UnknownTemplateVariableErrorDtoCodeEnumKey = (typeof unknownTemplateVariableErrorDtoCodeEnum)[keyof typeof unknownTemplateVariableErrorDtoCodeEnum];

export type UnknownTemplateVariableErrorDto = {
    /**
     * @type string
    */
    code: UnknownTemplateVariableErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownTemplateVariableDetailsDto;
};

export type StripeClientSecretNotFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    setupIntentId?: string;
    /**
     * @type string | undefined
    */
    stripeCustomerId?: string;
};

export const stripeClientSecretNotFoundErrorDtoCodeEnum = {
    STRIPE_CLIENT_SECRET_NOT_FOUND: "STRIPE_CLIENT_SECRET_NOT_FOUND"
} as const;

export type StripeClientSecretNotFoundErrorDtoCodeEnumKey = (typeof stripeClientSecretNotFoundErrorDtoCodeEnum)[keyof typeof stripeClientSecretNotFoundErrorDtoCodeEnum];

export type StripeClientSecretNotFoundErrorDto = {
    /**
     * @type string
    */
    code: StripeClientSecretNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: StripeClientSecretNotFoundDetailsDto;
};

export type UnsupportedPaymentModeDetailsDto = {
    /**
     * @type string
    */
    paymentMode: string;
};

export const unsupportedPaymentModeErrorDtoCodeEnum = {
    UNSUPPORTED_PAYMENT_MODE: "UNSUPPORTED_PAYMENT_MODE"
} as const;

export type UnsupportedPaymentModeErrorDtoCodeEnumKey = (typeof unsupportedPaymentModeErrorDtoCodeEnum)[keyof typeof unsupportedPaymentModeErrorDtoCodeEnum];

export type UnsupportedPaymentModeErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedPaymentModeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedPaymentModeDetailsDto;
};

export type UnsupportedPaymentMethodTypeDetailsDto = {
    /**
     * @type string
    */
    paymentMethodType: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export const unsupportedPaymentMethodTypeErrorDtoCodeEnum = {
    UNSUPPORTED_PAYMENT_METHOD_TYPE: "UNSUPPORTED_PAYMENT_METHOD_TYPE"
} as const;

export type UnsupportedPaymentMethodTypeErrorDtoCodeEnumKey = (typeof unsupportedPaymentMethodTypeErrorDtoCodeEnum)[keyof typeof unsupportedPaymentMethodTypeErrorDtoCodeEnum];

export type UnsupportedPaymentMethodTypeErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedPaymentMethodTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedPaymentMethodTypeDetailsDto;
};

export type MissingPaymentMandateDetailsDto = {
    /**
     * @type string
    */
    stripeCustomerId: string;
};

export const missingPaymentMandateErrorDtoCodeEnum = {
    MISSING_PAYMENT_MANDATE: "MISSING_PAYMENT_MANDATE"
} as const;

export type MissingPaymentMandateErrorDtoCodeEnumKey = (typeof missingPaymentMandateErrorDtoCodeEnum)[keyof typeof missingPaymentMandateErrorDtoCodeEnum];

export type MissingPaymentMandateErrorDto = {
    /**
     * @type string
    */
    code: MissingPaymentMandateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingPaymentMandateDetailsDto;
};

export type NoPaymentIntentFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    disputeId?: string;
    /**
     * @type string | undefined
    */
    eventId?: string;
};

export const noPaymentIntentFoundErrorDtoCodeEnum = {
    NO_PAYMENT_INTENT_FOUND: "NO_PAYMENT_INTENT_FOUND"
} as const;

export type NoPaymentIntentFoundErrorDtoCodeEnumKey = (typeof noPaymentIntentFoundErrorDtoCodeEnum)[keyof typeof noPaymentIntentFoundErrorDtoCodeEnum];

export type NoPaymentIntentFoundErrorDto = {
    /**
     * @type string
    */
    code: NoPaymentIntentFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoPaymentIntentFoundDetailsDto;
};

export type FailedToFindBankTransferAccountDetailsDto = {
    /**
     * @type string
    */
    stripeCustomerId: string;
};

export const failedToFindBankTransferAccountErrorDtoCodeEnum = {
    FAILED_TO_FIND_BANK_TRANSFER_ACCOUNT: "FAILED_TO_FIND_BANK_TRANSFER_ACCOUNT"
} as const;

export type FailedToFindBankTransferAccountErrorDtoCodeEnumKey = (typeof failedToFindBankTransferAccountErrorDtoCodeEnum)[keyof typeof failedToFindBankTransferAccountErrorDtoCodeEnum];

export type FailedToFindBankTransferAccountErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindBankTransferAccountErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindBankTransferAccountDetailsDto;
};

export type FailedToFindUniqueFinancialAddressDetailsDto = {
    /**
     * @type string
    */
    stripeCustomerId: string;
    /**
     * @type string
    */
    foundCount: string;
};

export const failedToFindUniqueFinancialAddressErrorDtoCodeEnum = {
    FAILED_TO_FIND_UNIQUE_FINANCIAL_ADDRESS: "FAILED_TO_FIND_UNIQUE_FINANCIAL_ADDRESS"
} as const;

export type FailedToFindUniqueFinancialAddressErrorDtoCodeEnumKey = (typeof failedToFindUniqueFinancialAddressErrorDtoCodeEnum)[keyof typeof failedToFindUniqueFinancialAddressErrorDtoCodeEnum];

export type FailedToFindUniqueFinancialAddressErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindUniqueFinancialAddressErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindUniqueFinancialAddressDetailsDto;
};

export type MissingTenantInSignatureRequestMetadataDetailsDto = {
    /**
     * @type string
    */
    signatureRequestId: string;
};

export const missingTenantInSignatureRequestMetadataErrorDtoCodeEnum = {
    MISSING_TENANT_IN_SIGNATURE_REQUEST_METADATA: "MISSING_TENANT_IN_SIGNATURE_REQUEST_METADATA"
} as const;

export type MissingTenantInSignatureRequestMetadataErrorDtoCodeEnumKey = (typeof missingTenantInSignatureRequestMetadataErrorDtoCodeEnum)[keyof typeof missingTenantInSignatureRequestMetadataErrorDtoCodeEnum];

export type MissingTenantInSignatureRequestMetadataErrorDto = {
    /**
     * @type string
    */
    code: MissingTenantInSignatureRequestMetadataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingTenantInSignatureRequestMetadataDetailsDto;
};

export type SignerNotFoundInYousignRequestDetailsDto = {
    /**
     * @type string
    */
    yousignSignerId: string;
    /**
     * @type string
    */
    signatureRequestId: string;
};

export const signerNotFoundInYousignRequestErrorDtoCodeEnum = {
    SIGNER_NOT_FOUND_IN_YOUSIGN_REQUEST: "SIGNER_NOT_FOUND_IN_YOUSIGN_REQUEST"
} as const;

export type SignerNotFoundInYousignRequestErrorDtoCodeEnumKey = (typeof signerNotFoundInYousignRequestErrorDtoCodeEnum)[keyof typeof signerNotFoundInYousignRequestErrorDtoCodeEnum];

export type SignerNotFoundInYousignRequestErrorDto = {
    /**
     * @type string
    */
    code: SignerNotFoundInYousignRequestErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SignerNotFoundInYousignRequestDetailsDto;
};

export type UnsupportedDeliveryModeDetailsDto = {
    /**
     * @type string
    */
    deliveryMode: string;
};

export const unsupportedDeliveryModeErrorDtoCodeEnum = {
    UNSUPPORTED_DELIVERY_MODE: "UNSUPPORTED_DELIVERY_MODE"
} as const;

export type UnsupportedDeliveryModeErrorDtoCodeEnumKey = (typeof unsupportedDeliveryModeErrorDtoCodeEnum)[keyof typeof unsupportedDeliveryModeErrorDtoCodeEnum];

export type UnsupportedDeliveryModeErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedDeliveryModeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedDeliveryModeDetailsDto;
};

export type UnsupportedDocumentTypeForSignatureDetailsDto = {
    /**
     * @type string
    */
    documentType: string;
};

export const unsupportedDocumentTypeForSignatureErrorDtoCodeEnum = {
    UNSUPPORTED_DOCUMENT_TYPE_FOR_SIGNATURE: "UNSUPPORTED_DOCUMENT_TYPE_FOR_SIGNATURE"
} as const;

export type UnsupportedDocumentTypeForSignatureErrorDtoCodeEnumKey = (typeof unsupportedDocumentTypeForSignatureErrorDtoCodeEnum)[keyof typeof unsupportedDocumentTypeForSignatureErrorDtoCodeEnum];

export type UnsupportedDocumentTypeForSignatureErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedDocumentTypeForSignatureErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedDocumentTypeForSignatureDetailsDto;
};

export type MissingAnchorForSignableDocumentDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const missingAnchorForSignableDocumentErrorDtoCodeEnum = {
    MISSING_ANCHOR_FOR_SIGNABLE_DOCUMENT: "MISSING_ANCHOR_FOR_SIGNABLE_DOCUMENT"
} as const;

export type MissingAnchorForSignableDocumentErrorDtoCodeEnumKey = (typeof missingAnchorForSignableDocumentErrorDtoCodeEnum)[keyof typeof missingAnchorForSignableDocumentErrorDtoCodeEnum];

export type MissingAnchorForSignableDocumentErrorDto = {
    /**
     * @type string
    */
    code: MissingAnchorForSignableDocumentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAnchorForSignableDocumentDetailsDto;
};

export type AnchorPageNotImplementedDetailsDto = {
    /**
     * @type string
    */
    page: string;
};

export const anchorPageNotImplementedErrorDtoCodeEnum = {
    ANCHOR_PAGE_NOT_IMPLEMENTED: "ANCHOR_PAGE_NOT_IMPLEMENTED"
} as const;

export type AnchorPageNotImplementedErrorDtoCodeEnumKey = (typeof anchorPageNotImplementedErrorDtoCodeEnum)[keyof typeof anchorPageNotImplementedErrorDtoCodeEnum];

export type AnchorPageNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: AnchorPageNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AnchorPageNotImplementedDetailsDto;
};

export type MentionPageNotImplementedDetailsDto = {
    /**
     * @type string
    */
    page: string;
};

export const mentionPageNotImplementedErrorDtoCodeEnum = {
    MENTION_PAGE_NOT_IMPLEMENTED: "MENTION_PAGE_NOT_IMPLEMENTED"
} as const;

export type MentionPageNotImplementedErrorDtoCodeEnumKey = (typeof mentionPageNotImplementedErrorDtoCodeEnum)[keyof typeof mentionPageNotImplementedErrorDtoCodeEnum];

export type MentionPageNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: MentionPageNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MentionPageNotImplementedDetailsDto;
};

export type TextPageNotImplementedDetailsDto = {
    /**
     * @type string
    */
    page: string;
};

export const textPageNotImplementedErrorDtoCodeEnum = {
    TEXT_PAGE_NOT_IMPLEMENTED: "TEXT_PAGE_NOT_IMPLEMENTED"
} as const;

export type TextPageNotImplementedErrorDtoCodeEnumKey = (typeof textPageNotImplementedErrorDtoCodeEnum)[keyof typeof textPageNotImplementedErrorDtoCodeEnum];

export type TextPageNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: TextPageNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TextPageNotImplementedDetailsDto;
};

export type CheckboxPageNotImplementedDetailsDto = {
    /**
     * @type string
    */
    page: string;
};

export const checkboxPageNotImplementedErrorDtoCodeEnum = {
    CHECKBOX_PAGE_NOT_IMPLEMENTED: "CHECKBOX_PAGE_NOT_IMPLEMENTED"
} as const;

export type CheckboxPageNotImplementedErrorDtoCodeEnumKey = (typeof checkboxPageNotImplementedErrorDtoCodeEnum)[keyof typeof checkboxPageNotImplementedErrorDtoCodeEnum];

export type CheckboxPageNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: CheckboxPageNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CheckboxPageNotImplementedDetailsDto;
};

export type FailedToUploadDocumentDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    documentId?: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const failedToUploadDocumentErrorDtoCodeEnum = {
    FAILED_TO_UPLOAD_DOCUMENT: "FAILED_TO_UPLOAD_DOCUMENT"
} as const;

export type FailedToUploadDocumentErrorDtoCodeEnumKey = (typeof failedToUploadDocumentErrorDtoCodeEnum)[keyof typeof failedToUploadDocumentErrorDtoCodeEnum];

export type FailedToUploadDocumentErrorDto = {
    /**
     * @type string
    */
    code: FailedToUploadDocumentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToUploadDocumentDetailsDto;
};

export type FailedToAddSignerDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signerEmail?: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const failedToAddSignerErrorDtoCodeEnum = {
    FAILED_TO_ADD_SIGNER: "FAILED_TO_ADD_SIGNER"
} as const;

export type FailedToAddSignerErrorDtoCodeEnumKey = (typeof failedToAddSignerErrorDtoCodeEnum)[keyof typeof failedToAddSignerErrorDtoCodeEnum];

export type FailedToAddSignerErrorDto = {
    /**
     * @type string
    */
    code: FailedToAddSignerErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToAddSignerDetailsDto;
};

export type FailedToDownloadDocumentDetailsDto = {
    /**
     * @type string | undefined
    */
    documentId?: string;
    /**
     * @type string | undefined
    */
    yousignDocumentId?: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const failedToDownloadDocumentErrorDtoCodeEnum = {
    FAILED_TO_DOWNLOAD_DOCUMENT: "FAILED_TO_DOWNLOAD_DOCUMENT"
} as const;

export type FailedToDownloadDocumentErrorDtoCodeEnumKey = (typeof failedToDownloadDocumentErrorDtoCodeEnum)[keyof typeof failedToDownloadDocumentErrorDtoCodeEnum];

export type FailedToDownloadDocumentErrorDto = {
    /**
     * @type string
    */
    code: FailedToDownloadDocumentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToDownloadDocumentDetailsDto;
};

export type FailedToFetchYousignSecurityChecksDetailsDto = {
    /**
     * @type string
    */
    error: string;
};

export const failedToFetchYousignSecurityChecksErrorDtoCodeEnum = {
    FAILED_TO_FETCH_YOUSIGN_SECURITY_CHECKS: "FAILED_TO_FETCH_YOUSIGN_SECURITY_CHECKS"
} as const;

export type FailedToFetchYousignSecurityChecksErrorDtoCodeEnumKey = (typeof failedToFetchYousignSecurityChecksErrorDtoCodeEnum)[keyof typeof failedToFetchYousignSecurityChecksErrorDtoCodeEnum];

export type FailedToFetchYousignSecurityChecksErrorDto = {
    /**
     * @type string
    */
    code: FailedToFetchYousignSecurityChecksErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFetchYousignSecurityChecksDetailsDto;
};

export type FailedToSendSignatureReminderDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
    /**
     * @type string | undefined
    */
    signerId?: string;
};

export const yousignFailedToSendReminderErrorDtoCodeEnum = {
    YOUSIGN_FAILED_TO_SEND_REMINDER: "YOUSIGN_FAILED_TO_SEND_REMINDER"
} as const;

export type YousignFailedToSendReminderErrorDtoCodeEnumKey = (typeof yousignFailedToSendReminderErrorDtoCodeEnum)[keyof typeof yousignFailedToSendReminderErrorDtoCodeEnum];

export type YousignFailedToSendReminderErrorDto = {
    /**
     * @type string
    */
    code: YousignFailedToSendReminderErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToSendSignatureReminderDetailsDto;
};

export type FailedToGetSignatureRequestDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const yousignFailedToGetSignatureRequestErrorDtoCodeEnum = {
    YOUSIGN_FAILED_TO_GET_SIGNATURE_REQUEST: "YOUSIGN_FAILED_TO_GET_SIGNATURE_REQUEST"
} as const;

export type YousignFailedToGetSignatureRequestErrorDtoCodeEnumKey = (typeof yousignFailedToGetSignatureRequestErrorDtoCodeEnum)[keyof typeof yousignFailedToGetSignatureRequestErrorDtoCodeEnum];

export type YousignFailedToGetSignatureRequestErrorDto = {
    /**
     * @type string
    */
    code: YousignFailedToGetSignatureRequestErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetSignatureRequestDetailsDto;
};

export type FailedToListSignatureRequestSignersDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const yousignFailedToListSignersErrorDtoCodeEnum = {
    YOUSIGN_FAILED_TO_LIST_SIGNERS: "YOUSIGN_FAILED_TO_LIST_SIGNERS"
} as const;

export type YousignFailedToListSignersErrorDtoCodeEnumKey = (typeof yousignFailedToListSignersErrorDtoCodeEnum)[keyof typeof yousignFailedToListSignersErrorDtoCodeEnum];

export type YousignFailedToListSignersErrorDto = {
    /**
     * @type string
    */
    code: YousignFailedToListSignersErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToListSignatureRequestSignersDetailsDto;
};

export type FailedToActivateSignatureRequestDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const yousignFailedToActivateSignatureRequestErrorDtoCodeEnum = {
    YOUSIGN_FAILED_TO_ACTIVATE_SIGNATURE_REQUEST: "YOUSIGN_FAILED_TO_ACTIVATE_SIGNATURE_REQUEST"
} as const;

export type YousignFailedToActivateSignatureRequestErrorDtoCodeEnumKey = (typeof yousignFailedToActivateSignatureRequestErrorDtoCodeEnum)[keyof typeof yousignFailedToActivateSignatureRequestErrorDtoCodeEnum];

export type YousignFailedToActivateSignatureRequestErrorDto = {
    /**
     * @type string
    */
    code: YousignFailedToActivateSignatureRequestErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToActivateSignatureRequestDetailsDto;
};

export type FailedToCancelSignatureRequestDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const yousignFailedToCancelSignatureRequestErrorDtoCodeEnum = {
    YOUSIGN_FAILED_TO_CANCEL_SIGNATURE_REQUEST: "YOUSIGN_FAILED_TO_CANCEL_SIGNATURE_REQUEST"
} as const;

export type YousignFailedToCancelSignatureRequestErrorDtoCodeEnumKey = (typeof yousignFailedToCancelSignatureRequestErrorDtoCodeEnum)[keyof typeof yousignFailedToCancelSignatureRequestErrorDtoCodeEnum];

export type YousignFailedToCancelSignatureRequestErrorDto = {
    /**
     * @type string
    */
    code: YousignFailedToCancelSignatureRequestErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToCancelSignatureRequestDetailsDto;
};

export type FailedToReactivateSignatureRequestDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    signatureRequestId?: string;
};

export const yousignFailedToReactivateSignatureRequestErrorDtoCodeEnum = {
    YOUSIGN_FAILED_TO_REACTIVATE_SIGNATURE_REQUEST: "YOUSIGN_FAILED_TO_REACTIVATE_SIGNATURE_REQUEST"
} as const;

export type YousignFailedToReactivateSignatureRequestErrorDtoCodeEnumKey = (typeof yousignFailedToReactivateSignatureRequestErrorDtoCodeEnum)[keyof typeof yousignFailedToReactivateSignatureRequestErrorDtoCodeEnum];

export type YousignFailedToReactivateSignatureRequestErrorDto = {
    /**
     * @type string
    */
    code: YousignFailedToReactivateSignatureRequestErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToReactivateSignatureRequestDetailsDto;
};

export type NoSignaturesProvidedForMigrationDetailsDto = {
    /**
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @type number | undefined
    */
    providedCount?: number;
};

export const noSignaturesProvidedForMigrationErrorDtoCodeEnum = {
    NO_SIGNATURES_PROVIDED_FOR_MIGRATION: "NO_SIGNATURES_PROVIDED_FOR_MIGRATION"
} as const;

export type NoSignaturesProvidedForMigrationErrorDtoCodeEnumKey = (typeof noSignaturesProvidedForMigrationErrorDtoCodeEnum)[keyof typeof noSignaturesProvidedForMigrationErrorDtoCodeEnum];

export type NoSignaturesProvidedForMigrationErrorDto = {
    /**
     * @type string
    */
    code: NoSignaturesProvidedForMigrationErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoSignaturesProvidedForMigrationDetailsDto;
};

export type DocumentNotFoundInS3DetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const documentNotFoundInS3ErrorDtoCodeEnum = {
    DOCUMENT_NOT_FOUND_IN_S3: "DOCUMENT_NOT_FOUND_IN_S3"
} as const;

export type DocumentNotFoundInS3ErrorDtoCodeEnumKey = (typeof documentNotFoundInS3ErrorDtoCodeEnum)[keyof typeof documentNotFoundInS3ErrorDtoCodeEnum];

export type DocumentNotFoundInS3ErrorDto = {
    /**
     * @type string
    */
    code: DocumentNotFoundInS3ErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentNotFoundInS3DetailsDto;
};

export type ConfigurationNotFoundDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
    /**
     * @type string | undefined
    */
    configurationType?: string;
    /**
     * @type string | undefined
    */
    configurationKey?: string;
};

export const configurationNotFoundErrorDtoCodeEnum = {
    CONFIGURATION_NOT_FOUND: "CONFIGURATION_NOT_FOUND"
} as const;

export type ConfigurationNotFoundErrorDtoCodeEnumKey = (typeof configurationNotFoundErrorDtoCodeEnum)[keyof typeof configurationNotFoundErrorDtoCodeEnum];

export type ConfigurationNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ConfigurationNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ConfigurationNotFoundDetailsDto;
};

export type MissingMetadataDetailsDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    documentKey: string;
};

export const missingMetadataErrorDtoCodeEnum = {
    MISSING_METADATA: "MISSING_METADATA"
} as const;

export type MissingMetadataErrorDtoCodeEnumKey = (typeof missingMetadataErrorDtoCodeEnum)[keyof typeof missingMetadataErrorDtoCodeEnum];

export type MissingMetadataErrorDto = {
    /**
     * @type string
    */
    code: MissingMetadataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingMetadataDetailsDto;
};

export type InvalidFileExtensionDetailsDto = {
    /**
     * @type string
    */
    fileName: string;
};

export const invalidFileExtensionErrorDtoCodeEnum = {
    INVALID_FILE_EXTENSION: "INVALID_FILE_EXTENSION"
} as const;

export type InvalidFileExtensionErrorDtoCodeEnumKey = (typeof invalidFileExtensionErrorDtoCodeEnum)[keyof typeof invalidFileExtensionErrorDtoCodeEnum];

export type InvalidFileExtensionErrorDto = {
    /**
     * @type string
    */
    code: InvalidFileExtensionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidFileExtensionDetailsDto;
};

export type FailedToGetTemplateDetailsDto = {
    /**
     * @type string
    */
    status: string;
    /**
     * @type string | undefined
    */
    templateId?: string;
};

export const failedToGetTemplateErrorDtoCodeEnum = {
    FAILED_TO_GET_TEMPLATE: "FAILED_TO_GET_TEMPLATE"
} as const;

export type FailedToGetTemplateErrorDtoCodeEnumKey = (typeof failedToGetTemplateErrorDtoCodeEnum)[keyof typeof failedToGetTemplateErrorDtoCodeEnum];

export type FailedToGetTemplateErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetTemplateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetTemplateDetailsDto;
};

export type FailedToFetchTemplatesDetailsDto = {
    /**
     * @type string
    */
    error: string;
};

export const failedToFetchTemplatesErrorDtoCodeEnum = {
    FAILED_TO_FETCH_TEMPLATES: "FAILED_TO_FETCH_TEMPLATES"
} as const;

export type FailedToFetchTemplatesErrorDtoCodeEnumKey = (typeof failedToFetchTemplatesErrorDtoCodeEnum)[keyof typeof failedToFetchTemplatesErrorDtoCodeEnum];

export type FailedToFetchTemplatesErrorDto = {
    /**
     * @type string
    */
    code: FailedToFetchTemplatesErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFetchTemplatesDetailsDto;
};

export type FailedToUploadReportDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    reportName?: string;
    /**
     * @type string | undefined
    */
    url?: string;
};

export const failedToUploadReportErrorDtoCodeEnum = {
    FAILED_TO_UPLOAD_REPORT: "FAILED_TO_UPLOAD_REPORT"
} as const;

export type FailedToUploadReportErrorDtoCodeEnumKey = (typeof failedToUploadReportErrorDtoCodeEnum)[keyof typeof failedToUploadReportErrorDtoCodeEnum];

export type FailedToUploadReportErrorDto = {
    /**
     * @type string
    */
    code: FailedToUploadReportErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToUploadReportDetailsDto;
};

export type WakamReportValidationFailedDetailsDto = {
    /**
     * @type string
    */
    submissionId: string;
    /**
     * @type string
    */
    reportName: string;
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const wakamReportValidationFailedErrorDtoCodeEnum = {
    WAKAM_REPORT_VALIDATION_FAILED: "WAKAM_REPORT_VALIDATION_FAILED"
} as const;

export type WakamReportValidationFailedErrorDtoCodeEnumKey = (typeof wakamReportValidationFailedErrorDtoCodeEnum)[keyof typeof wakamReportValidationFailedErrorDtoCodeEnum];

export type WakamReportValidationFailedErrorDto = {
    /**
     * @type string
    */
    code: WakamReportValidationFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WakamReportValidationFailedDetailsDto;
};

export type WakamValidationPollFailedDetailsDto = {
    /**
     * @type string
    */
    submissionId: string;
    /**
     * @type string
    */
    reportName: string;
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    error: string;
};

export const wakamValidationPollFailedErrorDtoCodeEnum = {
    WAKAM_VALIDATION_POLL_FAILED: "WAKAM_VALIDATION_POLL_FAILED"
} as const;

export type WakamValidationPollFailedErrorDtoCodeEnumKey = (typeof wakamValidationPollFailedErrorDtoCodeEnum)[keyof typeof wakamValidationPollFailedErrorDtoCodeEnum];

export type WakamValidationPollFailedErrorDto = {
    /**
     * @type string
    */
    code: WakamValidationPollFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WakamValidationPollFailedDetailsDto;
};

export type WakamValidationPollTimeoutDetailsDto = {
    /**
     * @type string
    */
    submissionId: string;
    /**
     * @type string
    */
    reportName: string;
    /**
     * @type string
    */
    documentId: string;
};

export const wakamValidationPollTimeoutErrorDtoCodeEnum = {
    WAKAM_VALIDATION_POLL_TIMEOUT: "WAKAM_VALIDATION_POLL_TIMEOUT"
} as const;

export type WakamValidationPollTimeoutErrorDtoCodeEnumKey = (typeof wakamValidationPollTimeoutErrorDtoCodeEnum)[keyof typeof wakamValidationPollTimeoutErrorDtoCodeEnum];

export type WakamValidationPollTimeoutErrorDto = {
    /**
     * @type string
    */
    code: WakamValidationPollTimeoutErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: WakamValidationPollTimeoutDetailsDto;
};

export type FailedToGetDocumentInfoDetailsDto = {
    /**
     * @type string
    */
    documentKey: string;
    /**
     * @type string
    */
    error: string;
};

export const failedToGetDocumentInfoErrorDtoCodeEnum = {
    FAILED_TO_GET_DOCUMENT_INFO: "FAILED_TO_GET_DOCUMENT_INFO"
} as const;

export type FailedToGetDocumentInfoErrorDtoCodeEnumKey = (typeof failedToGetDocumentInfoErrorDtoCodeEnum)[keyof typeof failedToGetDocumentInfoErrorDtoCodeEnum];

export type FailedToGetDocumentInfoErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetDocumentInfoErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetDocumentInfoDetailsDto;
};

export type FailedToGetDocumentBodyDetailsDto = {
    /**
     * @type string
    */
    documentKey: string;
    /**
     * @type string
    */
    error: string;
};

export const failedToGetDocumentBodyErrorDtoCodeEnum = {
    FAILED_TO_GET_DOCUMENT_BODY: "FAILED_TO_GET_DOCUMENT_BODY"
} as const;

export type FailedToGetDocumentBodyErrorDtoCodeEnumKey = (typeof failedToGetDocumentBodyErrorDtoCodeEnum)[keyof typeof failedToGetDocumentBodyErrorDtoCodeEnum];

export type FailedToGetDocumentBodyErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetDocumentBodyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetDocumentBodyDetailsDto;
};

export type DocumentTooLargeDetailsDto = {
    /**
     * @type string
    */
    documentKey: string;
};

export const documentTooLargeErrorDtoCodeEnum = {
    DOCUMENT_TOO_LARGE: "DOCUMENT_TOO_LARGE"
} as const;

export type DocumentTooLargeErrorDtoCodeEnumKey = (typeof documentTooLargeErrorDtoCodeEnum)[keyof typeof documentTooLargeErrorDtoCodeEnum];

export type DocumentTooLargeErrorDto = {
    /**
     * @type string
    */
    code: DocumentTooLargeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentTooLargeDetailsDto;
};

export type UnknownScanResultDetailsDto = {
    /**
     * @type string
    */
    status: string;
    /**
     * @type string
    */
    documentKey: string;
};

export const unknownScanResultErrorDtoCodeEnum = {
    UNKNOWN_SCAN_RESULT: "UNKNOWN_SCAN_RESULT"
} as const;

export type UnknownScanResultErrorDtoCodeEnumKey = (typeof unknownScanResultErrorDtoCodeEnum)[keyof typeof unknownScanResultErrorDtoCodeEnum];

export type UnknownScanResultErrorDto = {
    /**
     * @type string
    */
    code: UnknownScanResultErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownScanResultDetailsDto;
};

export type NoMandatesProvidedForMigrationDetailsDto = {
    /**
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @type number | undefined
    */
    providedCount?: number;
};

export const noMandatesProvidedForMigrationErrorDtoCodeEnum = {
    NO_MANDATES_PROVIDED_FOR_MIGRATION: "NO_MANDATES_PROVIDED_FOR_MIGRATION"
} as const;

export type NoMandatesProvidedForMigrationErrorDtoCodeEnumKey = (typeof noMandatesProvidedForMigrationErrorDtoCodeEnum)[keyof typeof noMandatesProvidedForMigrationErrorDtoCodeEnum];

export type NoMandatesProvidedForMigrationErrorDto = {
    /**
     * @type string
    */
    code: NoMandatesProvidedForMigrationErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoMandatesProvidedForMigrationDetailsDto;
};

export type TenantNotImplementedDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const tenantNotImplementedErrorDtoCodeEnum = {
    TENANT_NOT_IMPLEMENTED: "TENANT_NOT_IMPLEMENTED"
} as const;

export type TenantNotImplementedErrorDtoCodeEnumKey = (typeof tenantNotImplementedErrorDtoCodeEnum)[keyof typeof tenantNotImplementedErrorDtoCodeEnum];

export type TenantNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: TenantNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TenantNotImplementedDetailsDto;
};

export type OrchestratorNotImplementedDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const orchestratorNotImplementedErrorDtoCodeEnum = {
    ORCHESTRATOR_NOT_IMPLEMENTED: "ORCHESTRATOR_NOT_IMPLEMENTED"
} as const;

export type OrchestratorNotImplementedErrorDtoCodeEnumKey = (typeof orchestratorNotImplementedErrorDtoCodeEnum)[keyof typeof orchestratorNotImplementedErrorDtoCodeEnum];

export type OrchestratorNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: OrchestratorNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: OrchestratorNotImplementedDetailsDto;
};

export type PaymentMethodNotFoundForPolicyDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const paymentMethodNotFoundForPolicyErrorDtoCodeEnum = {
    PAYMENT_METHOD_NOT_FOUND_FOR_POLICY: "PAYMENT_METHOD_NOT_FOUND_FOR_POLICY"
} as const;

export type PaymentMethodNotFoundForPolicyErrorDtoCodeEnumKey = (typeof paymentMethodNotFoundForPolicyErrorDtoCodeEnum)[keyof typeof paymentMethodNotFoundForPolicyErrorDtoCodeEnum];

export type PaymentMethodNotFoundForPolicyErrorDto = {
    /**
     * @type string
    */
    code: PaymentMethodNotFoundForPolicyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PaymentMethodNotFoundForPolicyDetailsDto;
};

export type FailedToRetrieveCsvFromS3DetailsDto = {
    /**
     * @type string
    */
    fileName: string;
    /**
     * @type string | undefined
    */
    migrationDir?: string;
    /**
     * @type number | undefined
    */
    tries?: number;
};

export const failedToRetrieveCsvFromS3ErrorDtoCodeEnum = {
    FAILED_TO_RETRIEVE_CSV_FROM_S3: "FAILED_TO_RETRIEVE_CSV_FROM_S3"
} as const;

export type FailedToRetrieveCsvFromS3ErrorDtoCodeEnumKey = (typeof failedToRetrieveCsvFromS3ErrorDtoCodeEnum)[keyof typeof failedToRetrieveCsvFromS3ErrorDtoCodeEnum];

export type FailedToRetrieveCsvFromS3ErrorDto = {
    /**
     * @type string
    */
    code: FailedToRetrieveCsvFromS3ErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToRetrieveCsvFromS3DetailsDto;
};

export type FailedToLoadMigrationDataDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string
    */
    taskId: string;
    /**
     * @type string
    */
    migrationDir: string;
};

export const failedToLoadMigrationDataErrorDtoCodeEnum = {
    FAILED_TO_LOAD_MIGRATION_DATA: "FAILED_TO_LOAD_MIGRATION_DATA"
} as const;

export type FailedToLoadMigrationDataErrorDtoCodeEnumKey = (typeof failedToLoadMigrationDataErrorDtoCodeEnum)[keyof typeof failedToLoadMigrationDataErrorDtoCodeEnum];

export type FailedToLoadMigrationDataErrorDto = {
    /**
     * @type string
    */
    code: FailedToLoadMigrationDataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToLoadMigrationDataDetailsDto;
};

export type EventCountNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const eventCountNotFoundErrorDtoCodeEnum = {
    EVENT_COUNT_NOT_FOUND: "EVENT_COUNT_NOT_FOUND"
} as const;

export type EventCountNotFoundErrorDtoCodeEnumKey = (typeof eventCountNotFoundErrorDtoCodeEnum)[keyof typeof eventCountNotFoundErrorDtoCodeEnum];

export type EventCountNotFoundErrorDto = {
    /**
     * @type string
    */
    code: EventCountNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EventCountNotFoundDetailsDto;
};

export type PolicyNotFoundInIdsDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const policyNotFoundInIdsErrorDtoCodeEnum = {
    POLICY_NOT_FOUND_IN_IDS: "POLICY_NOT_FOUND_IN_IDS"
} as const;

export type PolicyNotFoundInIdsErrorDtoCodeEnumKey = (typeof policyNotFoundInIdsErrorDtoCodeEnum)[keyof typeof policyNotFoundInIdsErrorDtoCodeEnum];

export type PolicyNotFoundInIdsErrorDto = {
    /**
     * @type string
    */
    code: PolicyNotFoundInIdsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyNotFoundInIdsDetailsDto;
};

export type InvoiceNotFoundInIdsDetailsDto = {
    /**
     * @type string
    */
    invoiceInternalId: string;
};

export const invoiceNotFoundInIdsErrorDtoCodeEnum = {
    INVOICE_NOT_FOUND_IN_IDS: "INVOICE_NOT_FOUND_IN_IDS"
} as const;

export type InvoiceNotFoundInIdsErrorDtoCodeEnumKey = (typeof invoiceNotFoundInIdsErrorDtoCodeEnum)[keyof typeof invoiceNotFoundInIdsErrorDtoCodeEnum];

export type InvoiceNotFoundInIdsErrorDto = {
    /**
     * @type string
    */
    code: InvoiceNotFoundInIdsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvoiceNotFoundInIdsDetailsDto;
};

export type PolicyNotFoundForPaymentMethodDetailsDto = {
    /**
     * @type string
    */
    customerInternalId: string;
};

export const policyNotFoundForPaymentMethodErrorDtoCodeEnum = {
    POLICY_NOT_FOUND_FOR_PAYMENT_METHOD: "POLICY_NOT_FOUND_FOR_PAYMENT_METHOD"
} as const;

export type PolicyNotFoundForPaymentMethodErrorDtoCodeEnumKey = (typeof policyNotFoundForPaymentMethodErrorDtoCodeEnum)[keyof typeof policyNotFoundForPaymentMethodErrorDtoCodeEnum];

export type PolicyNotFoundForPaymentMethodErrorDto = {
    /**
     * @type string
    */
    code: PolicyNotFoundForPaymentMethodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyNotFoundForPaymentMethodDetailsDto;
};

export type PolicyIdsNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const policyIdsNotFoundErrorDtoCodeEnum = {
    POLICY_IDS_NOT_FOUND: "POLICY_IDS_NOT_FOUND"
} as const;

export type PolicyIdsNotFoundErrorDtoCodeEnumKey = (typeof policyIdsNotFoundErrorDtoCodeEnum)[keyof typeof policyIdsNotFoundErrorDtoCodeEnum];

export type PolicyIdsNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PolicyIdsNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyIdsNotFoundDetailsDto;
};

export type CustomerIdNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const customerIdNotFoundErrorDtoCodeEnum = {
    CUSTOMER_ID_NOT_FOUND: "CUSTOMER_ID_NOT_FOUND"
} as const;

export type CustomerIdNotFoundErrorDtoCodeEnumKey = (typeof customerIdNotFoundErrorDtoCodeEnum)[keyof typeof customerIdNotFoundErrorDtoCodeEnum];

export type CustomerIdNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CustomerIdNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CustomerIdNotFoundDetailsDto;
};

export type PolicyIdsIncompleteDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
    /**
     * @type string | undefined
    */
    missingFields?: string;
};

export const policyIdsIncompleteErrorDtoCodeEnum = {
    POLICY_IDS_INCOMPLETE: "POLICY_IDS_INCOMPLETE"
} as const;

export type PolicyIdsIncompleteErrorDtoCodeEnumKey = (typeof policyIdsIncompleteErrorDtoCodeEnum)[keyof typeof policyIdsIncompleteErrorDtoCodeEnum];

export type PolicyIdsIncompleteErrorDto = {
    /**
     * @type string
    */
    code: PolicyIdsIncompleteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyIdsIncompleteDetailsDto;
};

export type MigrationConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const migrationConfigNotFoundErrorDtoCodeEnum = {
    MIGRATION_CONFIG_NOT_FOUND: "MIGRATION_CONFIG_NOT_FOUND"
} as const;

export type MigrationConfigNotFoundErrorDtoCodeEnumKey = (typeof migrationConfigNotFoundErrorDtoCodeEnum)[keyof typeof migrationConfigNotFoundErrorDtoCodeEnum];

export type MigrationConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: MigrationConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MigrationConfigNotFoundDetailsDto;
};

export type ComponentConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    componentId: string;
};

export const componentConfigNotFoundErrorDtoCodeEnum = {
    COMPONENT_CONFIG_NOT_FOUND: "COMPONENT_CONFIG_NOT_FOUND"
} as const;

export type ComponentConfigNotFoundErrorDtoCodeEnumKey = (typeof componentConfigNotFoundErrorDtoCodeEnum)[keyof typeof componentConfigNotFoundErrorDtoCodeEnum];

export type ComponentConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ComponentConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ComponentConfigNotFoundDetailsDto;
};

export type PolicyIdMissingDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const policyIdMissingErrorDtoCodeEnum = {
    POLICY_ID_MISSING: "POLICY_ID_MISSING"
} as const;

export type PolicyIdMissingErrorDtoCodeEnumKey = (typeof policyIdMissingErrorDtoCodeEnum)[keyof typeof policyIdMissingErrorDtoCodeEnum];

export type PolicyIdMissingErrorDto = {
    /**
     * @type string
    */
    code: PolicyIdMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyIdMissingDetailsDto;
};

export type SignatureIdMissingDetailsDto = {
    /**
     * @type string
    */
    policyInternalId: string;
};

export const signatureIdMissingErrorDtoCodeEnum = {
    SIGNATURE_ID_MISSING: "SIGNATURE_ID_MISSING"
} as const;

export type SignatureIdMissingErrorDtoCodeEnumKey = (typeof signatureIdMissingErrorDtoCodeEnum)[keyof typeof signatureIdMissingErrorDtoCodeEnum];

export type SignatureIdMissingErrorDto = {
    /**
     * @type string
    */
    code: SignatureIdMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SignatureIdMissingDetailsDto;
};

export type CompanyInfoNotFoundDetailsDto = {
    /**
     * @type string
    */
    siret: string;
};

export const companyInfoNotFoundErrorDtoCodeEnum = {
    COMPANY_INFO_NOT_FOUND: "COMPANY_INFO_NOT_FOUND"
} as const;

export type CompanyInfoNotFoundErrorDtoCodeEnumKey = (typeof companyInfoNotFoundErrorDtoCodeEnum)[keyof typeof companyInfoNotFoundErrorDtoCodeEnum];

export type CompanyInfoNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CompanyInfoNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CompanyInfoNotFoundDetailsDto;
};

export type BrokerageFirmNotFoundInDictionaryDetailsDto = {
    /**
     * @type string
    */
    firmInternalId: string;
};

export const brokerageFirmNotFoundInDictionaryErrorDtoCodeEnum = {
    BROKERAGE_FIRM_NOT_FOUND_IN_DICTIONARY: "BROKERAGE_FIRM_NOT_FOUND_IN_DICTIONARY"
} as const;

export type BrokerageFirmNotFoundInDictionaryErrorDtoCodeEnumKey = (typeof brokerageFirmNotFoundInDictionaryErrorDtoCodeEnum)[keyof typeof brokerageFirmNotFoundInDictionaryErrorDtoCodeEnum];

export type BrokerageFirmNotFoundInDictionaryErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmNotFoundInDictionaryErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmNotFoundInDictionaryDetailsDto;
};

export type ParentIdMissingDetailsDto = {
    /**
     * @type string
    */
    firmInternalId: string;
};

export const parentIdMissingErrorDtoCodeEnum = {
    PARENT_ID_MISSING: "PARENT_ID_MISSING"
} as const;

export type ParentIdMissingErrorDtoCodeEnumKey = (typeof parentIdMissingErrorDtoCodeEnum)[keyof typeof parentIdMissingErrorDtoCodeEnum];

export type ParentIdMissingErrorDto = {
    /**
     * @type string
    */
    code: ParentIdMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ParentIdMissingDetailsDto;
};

export type BrokerageFirmHasNoProductsDetailsDto = {
    /**
     * @type string
    */
    firmInternalId: string;
};

export const brokerageFirmHasNoProductsErrorDtoCodeEnum = {
    BROKERAGE_FIRM_HAS_NO_PRODUCTS: "BROKERAGE_FIRM_HAS_NO_PRODUCTS"
} as const;

export type BrokerageFirmHasNoProductsErrorDtoCodeEnumKey = (typeof brokerageFirmHasNoProductsErrorDtoCodeEnum)[keyof typeof brokerageFirmHasNoProductsErrorDtoCodeEnum];

export type BrokerageFirmHasNoProductsErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmHasNoProductsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmHasNoProductsDetailsDto;
};

export type Crm1NotFoundDetailsDto = object;

export const crm1NotFoundErrorDtoCodeEnum = {
    CRM1_NOT_FOUND: "CRM1_NOT_FOUND"
} as const;

export type Crm1NotFoundErrorDtoCodeEnumKey = (typeof crm1NotFoundErrorDtoCodeEnum)[keyof typeof crm1NotFoundErrorDtoCodeEnum];

export type Crm1NotFoundErrorDto = {
    /**
     * @type string
    */
    code: Crm1NotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: Crm1NotFoundDetailsDto;
};

export type Crm2NotFoundDetailsDto = object;

export const crm2NotFoundErrorDtoCodeEnum = {
    CRM2_NOT_FOUND: "CRM2_NOT_FOUND"
} as const;

export type Crm2NotFoundErrorDtoCodeEnumKey = (typeof crm2NotFoundErrorDtoCodeEnum)[keyof typeof crm2NotFoundErrorDtoCodeEnum];

export type Crm2NotFoundErrorDto = {
    /**
     * @type string
    */
    code: Crm2NotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: Crm2NotFoundDetailsDto;
};

export type CrmKeysMissingInProductFieldsDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const crmKeysMissingInProductFieldsErrorDtoCodeEnum = {
    CRM_KEYS_MISSING_IN_PRODUCT_FIELDS: "CRM_KEYS_MISSING_IN_PRODUCT_FIELDS"
} as const;

export type CrmKeysMissingInProductFieldsErrorDtoCodeEnumKey = (typeof crmKeysMissingInProductFieldsErrorDtoCodeEnum)[keyof typeof crmKeysMissingInProductFieldsErrorDtoCodeEnum];

export type CrmKeysMissingInProductFieldsErrorDto = {
    /**
     * @type string
    */
    code: CrmKeysMissingInProductFieldsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CrmKeysMissingInProductFieldsDetailsDto;
};

export type InvalidCrmOrCrmDateDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const invalidCrmOrCrmDateErrorDtoCodeEnum = {
    INVALID_CRM_OR_CRM_DATE: "INVALID_CRM_OR_CRM_DATE"
} as const;

export type InvalidCrmOrCrmDateErrorDtoCodeEnumKey = (typeof invalidCrmOrCrmDateErrorDtoCodeEnum)[keyof typeof invalidCrmOrCrmDateErrorDtoCodeEnum];

export type InvalidCrmOrCrmDateErrorDto = {
    /**
     * @type string
    */
    code: InvalidCrmOrCrmDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidCrmOrCrmDateDetailsDto;
};

export type CrmEditionRulesMissingDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const crmEditionRulesMissingErrorDtoCodeEnum = {
    CRM_EDITION_RULES_MISSING: "CRM_EDITION_RULES_MISSING"
} as const;

export type CrmEditionRulesMissingErrorDtoCodeEnumKey = (typeof crmEditionRulesMissingErrorDtoCodeEnum)[keyof typeof crmEditionRulesMissingErrorDtoCodeEnum];

export type CrmEditionRulesMissingErrorDto = {
    /**
     * @type string
    */
    code: CrmEditionRulesMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CrmEditionRulesMissingDetailsDto;
};

export type CrmParametersNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const crmParametersNotFoundErrorDtoCodeEnum = {
    CRM_PARAMETERS_NOT_FOUND: "CRM_PARAMETERS_NOT_FOUND"
} as const;

export type CrmParametersNotFoundErrorDtoCodeEnumKey = (typeof crmParametersNotFoundErrorDtoCodeEnum)[keyof typeof crmParametersNotFoundErrorDtoCodeEnum];

export type CrmParametersNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CrmParametersNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CrmParametersNotFoundDetailsDto;
};

export type OriginalTriggerEventNotFoundDetailsDto = {
    /**
     * @type string
    */
    projectionBuiltEvent: string;
};

export const originalTriggerEventNotFoundErrorDtoCodeEnum = {
    ORIGINAL_TRIGGER_EVENT_NOT_FOUND: "ORIGINAL_TRIGGER_EVENT_NOT_FOUND"
} as const;

export type OriginalTriggerEventNotFoundErrorDtoCodeEnumKey = (typeof originalTriggerEventNotFoundErrorDtoCodeEnum)[keyof typeof originalTriggerEventNotFoundErrorDtoCodeEnum];

export type OriginalTriggerEventNotFoundErrorDto = {
    /**
     * @type string
    */
    code: OriginalTriggerEventNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: OriginalTriggerEventNotFoundDetailsDto;
};

export type ValidatorConfigurationErrorDetailsDto = {
    /**
     * @type string
    */
    message: string;
    /**
     * @type string | undefined
    */
    validatorType?: string;
};

export const validatorConfigurationErrorErrorDtoCodeEnum = {
    VALIDATOR_CONFIGURATION_ERROR: "VALIDATOR_CONFIGURATION_ERROR"
} as const;

export type ValidatorConfigurationErrorErrorDtoCodeEnumKey = (typeof validatorConfigurationErrorErrorDtoCodeEnum)[keyof typeof validatorConfigurationErrorErrorDtoCodeEnum];

export type ValidatorConfigurationErrorErrorDto = {
    /**
     * @type string
    */
    code: ValidatorConfigurationErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ValidatorConfigurationErrorDetailsDto;
};

export type OperatorNotSupportedDetailsDto = {
    /**
     * @type string
    */
    operator: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const operatorNotSupportedErrorDtoCodeEnum = {
    OPERATOR_NOT_SUPPORTED: "OPERATOR_NOT_SUPPORTED"
} as const;

export type OperatorNotSupportedErrorDtoCodeEnumKey = (typeof operatorNotSupportedErrorDtoCodeEnum)[keyof typeof operatorNotSupportedErrorDtoCodeEnum];

export type OperatorNotSupportedErrorDto = {
    /**
     * @type string
    */
    code: OperatorNotSupportedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: OperatorNotSupportedDetailsDto;
};

export type FailedToSendCustomerioEventDetailsDto = {
    /**
     * @type string
    */
    error: string;
};

export const failedToSendCustomerioEventErrorDtoCodeEnum = {
    FAILED_TO_SEND_CUSTOMERIO_EVENT: "FAILED_TO_SEND_CUSTOMERIO_EVENT"
} as const;

export type FailedToSendCustomerioEventErrorDtoCodeEnumKey = (typeof failedToSendCustomerioEventErrorDtoCodeEnum)[keyof typeof failedToSendCustomerioEventErrorDtoCodeEnum];

export type FailedToSendCustomerioEventErrorDto = {
    /**
     * @type string
    */
    code: FailedToSendCustomerioEventErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToSendCustomerioEventDetailsDto;
};

export type FailedToSendTransactionalEmailDetailsDto = {
    /**
     * @type string
    */
    templateId: string;
    /**
     * @type string
    */
    error: string;
};

export const failedToSendTransactionalEmailErrorDtoCodeEnum = {
    FAILED_TO_SEND_TRANSACTIONAL_EMAIL: "FAILED_TO_SEND_TRANSACTIONAL_EMAIL"
} as const;

export type FailedToSendTransactionalEmailErrorDtoCodeEnumKey = (typeof failedToSendTransactionalEmailErrorDtoCodeEnum)[keyof typeof failedToSendTransactionalEmailErrorDtoCodeEnum];

export type FailedToSendTransactionalEmailErrorDto = {
    /**
     * @type string
    */
    code: FailedToSendTransactionalEmailErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToSendTransactionalEmailDetailsDto;
};

export type FailedToSendSesEmailDetailsDto = {
    /**
     * @type string
    */
    error: string;
};

export const failedToSendSesEmailErrorDtoCodeEnum = {
    FAILED_TO_SEND_SES_EMAIL: "FAILED_TO_SEND_SES_EMAIL"
} as const;

export type FailedToSendSesEmailErrorDtoCodeEnumKey = (typeof failedToSendSesEmailErrorDtoCodeEnum)[keyof typeof failedToSendSesEmailErrorDtoCodeEnum];

export type FailedToSendSesEmailErrorDto = {
    /**
     * @type string
    */
    code: FailedToSendSesEmailErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToSendSesEmailDetailsDto;
};

export type FailedToConfirmSnsSubscriptionDetailsDto = {
    /**
     * @type number
    */
    status: number;
};

export const failedToConfirmSnsSubscriptionErrorDtoCodeEnum = {
    FAILED_TO_CONFIRM_SNS_SUBSCRIPTION: "FAILED_TO_CONFIRM_SNS_SUBSCRIPTION"
} as const;

export type FailedToConfirmSnsSubscriptionErrorDtoCodeEnumKey = (typeof failedToConfirmSnsSubscriptionErrorDtoCodeEnum)[keyof typeof failedToConfirmSnsSubscriptionErrorDtoCodeEnum];

export type FailedToConfirmSnsSubscriptionErrorDto = {
    /**
     * @type string
    */
    code: FailedToConfirmSnsSubscriptionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToConfirmSnsSubscriptionDetailsDto;
};

export type FailedToSendSlackMessageDetailsDto = {
    /**
     * @type string
    */
    error: string;
};

export const failedToSendSlackMessageErrorDtoCodeEnum = {
    FAILED_TO_SEND_SLACK_MESSAGE: "FAILED_TO_SEND_SLACK_MESSAGE"
} as const;

export type FailedToSendSlackMessageErrorDtoCodeEnumKey = (typeof failedToSendSlackMessageErrorDtoCodeEnum)[keyof typeof failedToSendSlackMessageErrorDtoCodeEnum];

export type FailedToSendSlackMessageErrorDto = {
    /**
     * @type string
    */
    code: FailedToSendSlackMessageErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToSendSlackMessageDetailsDto;
};

export type FailedToEnqueueRowsDetailsDto = {
    /**
     * @type string
    */
    operation: string;
    /**
     * @type string
    */
    ids: string;
};

export const failedToEnqueueRowsErrorDtoCodeEnum = {
    FAILED_TO_ENQUEUE_ROWS: "FAILED_TO_ENQUEUE_ROWS"
} as const;

export type FailedToEnqueueRowsErrorDtoCodeEnumKey = (typeof failedToEnqueueRowsErrorDtoCodeEnum)[keyof typeof failedToEnqueueRowsErrorDtoCodeEnum];

export type FailedToEnqueueRowsErrorDto = {
    /**
     * @type string
    */
    code: FailedToEnqueueRowsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToEnqueueRowsDetailsDto;
};

export type FailedToCreateCustomerioPersonDetailsDto = {
    /**
     * @type string
    */
    error: string;
};

export const failedToCreateCustomerioPersonErrorDtoCodeEnum = {
    FAILED_TO_CREATE_CUSTOMERIO_PERSON: "FAILED_TO_CREATE_CUSTOMERIO_PERSON"
} as const;

export type FailedToCreateCustomerioPersonErrorDtoCodeEnumKey = (typeof failedToCreateCustomerioPersonErrorDtoCodeEnum)[keyof typeof failedToCreateCustomerioPersonErrorDtoCodeEnum];

export type FailedToCreateCustomerioPersonErrorDto = {
    /**
     * @type string
    */
    code: FailedToCreateCustomerioPersonErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToCreateCustomerioPersonDetailsDto;
};

export type Ar24ApiErrorDetailsDto = {
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    endpoint?: string;
};

export const ar24ApiErrorErrorDtoCodeEnum = {
    AR24_API_ERROR: "AR24_API_ERROR"
} as const;

export type Ar24ApiErrorErrorDtoCodeEnumKey = (typeof ar24ApiErrorErrorDtoCodeEnum)[keyof typeof ar24ApiErrorErrorDtoCodeEnum];

export type Ar24ApiErrorErrorDto = {
    /**
     * @type string
    */
    code: Ar24ApiErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: Ar24ApiErrorDetailsDto;
};

export type FailedToUpdateProjectionDetailsDto = {
    /**
     * @type string
    */
    projectionTableName: string;
    /**
     * @type number
    */
    maxAttempts: number;
    /**
     * @type string
    */
    error: string;
};

export const failedToUpdateProjectionErrorDtoCodeEnum = {
    FAILED_TO_UPDATE_PROJECTION: "FAILED_TO_UPDATE_PROJECTION"
} as const;

export type FailedToUpdateProjectionErrorDtoCodeEnumKey = (typeof failedToUpdateProjectionErrorDtoCodeEnum)[keyof typeof failedToUpdateProjectionErrorDtoCodeEnum];

export type FailedToUpdateProjectionErrorDto = {
    /**
     * @type string
    */
    code: FailedToUpdateProjectionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToUpdateProjectionDetailsDto;
};

export type FailedToRetrieveEventVersionDetailsDto = {
    /**
     * @type string
    */
    rootId: string;
};

export const failedToRetrieveEventVersionErrorDtoCodeEnum = {
    FAILED_TO_RETRIEVE_EVENT_VERSION: "FAILED_TO_RETRIEVE_EVENT_VERSION"
} as const;

export type FailedToRetrieveEventVersionErrorDtoCodeEnumKey = (typeof failedToRetrieveEventVersionErrorDtoCodeEnum)[keyof typeof failedToRetrieveEventVersionErrorDtoCodeEnum];

export type FailedToRetrieveEventVersionErrorDto = {
    /**
     * @type string
    */
    code: FailedToRetrieveEventVersionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToRetrieveEventVersionDetailsDto;
};

export type UnsupportedTriggerTypeDetailsDto = {
    /**
     * @type string
    */
    eventType: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const unsupportedTriggerTypeErrorDtoCodeEnum = {
    UNSUPPORTED_TRIGGER_TYPE: "UNSUPPORTED_TRIGGER_TYPE"
} as const;

export type UnsupportedTriggerTypeErrorDtoCodeEnumKey = (typeof unsupportedTriggerTypeErrorDtoCodeEnum)[keyof typeof unsupportedTriggerTypeErrorDtoCodeEnum];

export type UnsupportedTriggerTypeErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedTriggerTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedTriggerTypeDetailsDto;
};

export type MissingProjectionVersionDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingProjectionVersionErrorDtoCodeEnum = {
    MISSING_PROJECTION_VERSION: "MISSING_PROJECTION_VERSION"
} as const;

export type MissingProjectionVersionErrorDtoCodeEnumKey = (typeof missingProjectionVersionErrorDtoCodeEnum)[keyof typeof missingProjectionVersionErrorDtoCodeEnum];

export type MissingProjectionVersionErrorDto = {
    /**
     * @type string
    */
    code: MissingProjectionVersionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingProjectionVersionDetailsDto;
};

export type BrokerageFeesMismatchDetailsDto = {
    /**
     * @type string
    */
    componentId: string;
    /**
     * @type number
    */
    totalFees: number;
    /**
     * @type number
    */
    calculatedFees: number;
    /**
     * @type string | undefined
    */
    policyId?: string;
};

export const brokerageFeesMismatchErrorDtoCodeEnum = {
    BROKERAGE_FEES_MISMATCH: "BROKERAGE_FEES_MISMATCH"
} as const;

export type BrokerageFeesMismatchErrorDtoCodeEnumKey = (typeof brokerageFeesMismatchErrorDtoCodeEnum)[keyof typeof brokerageFeesMismatchErrorDtoCodeEnum];

export type BrokerageFeesMismatchErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFeesMismatchErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFeesMismatchDetailsDto;
};

export type MergedComponentsTooLongDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const mergedComponentsTooLongErrorDtoCodeEnum = {
    MERGED_COMPONENTS_TOO_LONG: "MERGED_COMPONENTS_TOO_LONG"
} as const;

export type MergedComponentsTooLongErrorDtoCodeEnumKey = (typeof mergedComponentsTooLongErrorDtoCodeEnum)[keyof typeof mergedComponentsTooLongErrorDtoCodeEnum];

export type MergedComponentsTooLongErrorDto = {
    /**
     * @type string
    */
    code: MergedComponentsTooLongErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MergedComponentsTooLongDetailsDto;
};

export type ReportTypeNotFoundDetailsDto = {
    /**
     * @type string
    */
    reportType: string;
    /**
     * @type string | undefined
    */
    tenantId?: string;
};

export const reportTypeNotFoundErrorDtoCodeEnum = {
    REPORT_TYPE_NOT_FOUND: "REPORT_TYPE_NOT_FOUND"
} as const;

export type ReportTypeNotFoundErrorDtoCodeEnumKey = (typeof reportTypeNotFoundErrorDtoCodeEnum)[keyof typeof reportTypeNotFoundErrorDtoCodeEnum];

export type ReportTypeNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ReportTypeNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ReportTypeNotFoundDetailsDto;
};

export type ReportTypeNotConfiguredDetailsDto = {
    /**
     * @type string
    */
    reportType: string;
};

export const reportTypeNotConfiguredErrorDtoCodeEnum = {
    REPORT_TYPE_NOT_CONFIGURED: "REPORT_TYPE_NOT_CONFIGURED"
} as const;

export type ReportTypeNotConfiguredErrorDtoCodeEnumKey = (typeof reportTypeNotConfiguredErrorDtoCodeEnum)[keyof typeof reportTypeNotConfiguredErrorDtoCodeEnum];

export type ReportTypeNotConfiguredErrorDto = {
    /**
     * @type string
    */
    code: ReportTypeNotConfiguredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ReportTypeNotConfiguredDetailsDto;
};

export type ParentPolicyExternalIdNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const parentPolicyExternalIdNotFoundErrorDtoCodeEnum = {
    PARENT_POLICY_EXTERNAL_ID_NOT_FOUND: "PARENT_POLICY_EXTERNAL_ID_NOT_FOUND"
} as const;

export type ParentPolicyExternalIdNotFoundErrorDtoCodeEnumKey = (typeof parentPolicyExternalIdNotFoundErrorDtoCodeEnum)[keyof typeof parentPolicyExternalIdNotFoundErrorDtoCodeEnum];

export type ParentPolicyExternalIdNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ParentPolicyExternalIdNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ParentPolicyExternalIdNotFoundDetailsDto;
};

export type RootAggregateProjectionNotFoundDetailsDto = {
    /**
     * @type string
    */
    rootId: string;
};

export const rootAggregateProjectionNotFoundErrorDtoCodeEnum = {
    ROOT_AGGREGATE_PROJECTION_NOT_FOUND: "ROOT_AGGREGATE_PROJECTION_NOT_FOUND"
} as const;

export type RootAggregateProjectionNotFoundErrorDtoCodeEnumKey = (typeof rootAggregateProjectionNotFoundErrorDtoCodeEnum)[keyof typeof rootAggregateProjectionNotFoundErrorDtoCodeEnum];

export type RootAggregateProjectionNotFoundErrorDto = {
    /**
     * @type string
    */
    code: RootAggregateProjectionNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RootAggregateProjectionNotFoundDetailsDto;
};

export type PolicyAggregateProjectionNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const policyAggregateProjectionNotFoundErrorDtoCodeEnum = {
    POLICY_AGGREGATE_PROJECTION_NOT_FOUND: "POLICY_AGGREGATE_PROJECTION_NOT_FOUND"
} as const;

export type PolicyAggregateProjectionNotFoundErrorDtoCodeEnumKey = (typeof policyAggregateProjectionNotFoundErrorDtoCodeEnum)[keyof typeof policyAggregateProjectionNotFoundErrorDtoCodeEnum];

export type PolicyAggregateProjectionNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PolicyAggregateProjectionNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyAggregateProjectionNotFoundDetailsDto;
};

export type SignaturesNotFoundDetailsDto = {
    /**
     * @type string
    */
    batchNumber: string;
};

export const signaturesNotFoundErrorDtoCodeEnum = {
    SIGNATURES_NOT_FOUND: "SIGNATURES_NOT_FOUND"
} as const;

export type SignaturesNotFoundErrorDtoCodeEnumKey = (typeof signaturesNotFoundErrorDtoCodeEnum)[keyof typeof signaturesNotFoundErrorDtoCodeEnum];

export type SignaturesNotFoundErrorDto = {
    /**
     * @type string
    */
    code: SignaturesNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SignaturesNotFoundDetailsDto;
};

export type MissingCommissionDataDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const missingCommissionDataErrorDtoCodeEnum = {
    MISSING_COMMISSION_DATA: "MISSING_COMMISSION_DATA"
} as const;

export type MissingCommissionDataErrorDtoCodeEnumKey = (typeof missingCommissionDataErrorDtoCodeEnum)[keyof typeof missingCommissionDataErrorDtoCodeEnum];

export type MissingCommissionDataErrorDto = {
    /**
     * @type string
    */
    code: MissingCommissionDataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingCommissionDataDetailsDto;
};

export type ColumnSpacingKeyNotFoundDetailsDto = {
    /**
     * @type string
    */
    key: string;
};

export const columnSpacingKeyNotFoundErrorDtoCodeEnum = {
    COLUMN_SPACING_KEY_NOT_FOUND: "COLUMN_SPACING_KEY_NOT_FOUND"
} as const;

export type ColumnSpacingKeyNotFoundErrorDtoCodeEnumKey = (typeof columnSpacingKeyNotFoundErrorDtoCodeEnum)[keyof typeof columnSpacingKeyNotFoundErrorDtoCodeEnum];

export type ColumnSpacingKeyNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ColumnSpacingKeyNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ColumnSpacingKeyNotFoundDetailsDto;
};

export type UnknownRegisterCodeDetailsDto = {
    /**
     * @type string
    */
    code: string;
    /**
     * @type string | undefined
    */
    reportType?: string;
};

export const unknownRegisterCodeErrorDtoCodeEnum = {
    UNKNOWN_REGISTER_CODE: "UNKNOWN_REGISTER_CODE"
} as const;

export type UnknownRegisterCodeErrorDtoCodeEnumKey = (typeof unknownRegisterCodeErrorDtoCodeEnum)[keyof typeof unknownRegisterCodeErrorDtoCodeEnum];

export type UnknownRegisterCodeErrorDto = {
    /**
     * @type string
    */
    code: UnknownRegisterCodeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownRegisterCodeDetailsDto;
};

export type PolicyStopAppliedAtKeyNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyStopReason: string;
    /**
     * @type string
    */
    productId: string;
};

export const policyStopAppliedAtKeyNotFoundErrorDtoCodeEnum = {
    POLICY_STOP_APPLIED_AT_KEY_NOT_FOUND: "POLICY_STOP_APPLIED_AT_KEY_NOT_FOUND"
} as const;

export type PolicyStopAppliedAtKeyNotFoundErrorDtoCodeEnumKey = (typeof policyStopAppliedAtKeyNotFoundErrorDtoCodeEnum)[keyof typeof policyStopAppliedAtKeyNotFoundErrorDtoCodeEnum];

export type PolicyStopAppliedAtKeyNotFoundErrorDto = {
    /**
     * @type string
    */
    code: PolicyStopAppliedAtKeyNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyStopAppliedAtKeyNotFoundDetailsDto;
};

export type InvalidFinalizationTypeDetailsDto = {
    /**
     * @type string | undefined
    */
    finalizationType?: string;
};

export const invalidFinalizationTypeErrorDtoCodeEnum = {
    INVALID_FINALIZATION_TYPE: "INVALID_FINALIZATION_TYPE"
} as const;

export type InvalidFinalizationTypeErrorDtoCodeEnumKey = (typeof invalidFinalizationTypeErrorDtoCodeEnum)[keyof typeof invalidFinalizationTypeErrorDtoCodeEnum];

export type InvalidFinalizationTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidFinalizationTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidFinalizationTypeDetailsDto;
};

export type ParentBrokerageFirmNotFoundDetailsDto = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const parentBrokerageFirmNotFoundErrorDtoCodeEnum = {
    PARENT_BROKERAGE_FIRM_NOT_FOUND: "PARENT_BROKERAGE_FIRM_NOT_FOUND"
} as const;

export type ParentBrokerageFirmNotFoundErrorDtoCodeEnumKey = (typeof parentBrokerageFirmNotFoundErrorDtoCodeEnum)[keyof typeof parentBrokerageFirmNotFoundErrorDtoCodeEnum];

export type ParentBrokerageFirmNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ParentBrokerageFirmNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ParentBrokerageFirmNotFoundDetailsDto;
};

export type TooManyBrokerUserIdsDetailsDto = {
    /**
     * @type number
    */
    maxBrokerUserIds: number;
    /**
     * @type number
    */
    actualCount: number;
};

export const tooManyBrokerUserIdsErrorDtoCodeEnum = {
    TOO_MANY_BROKER_USER_IDS: "TOO_MANY_BROKER_USER_IDS"
} as const;

export type TooManyBrokerUserIdsErrorDtoCodeEnumKey = (typeof tooManyBrokerUserIdsErrorDtoCodeEnum)[keyof typeof tooManyBrokerUserIdsErrorDtoCodeEnum];

export type TooManyBrokerUserIdsErrorDto = {
    /**
     * @type string
    */
    code: TooManyBrokerUserIdsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TooManyBrokerUserIdsDetailsDto;
};

export type MissingEntityIdDetailsDto = {
    /**
     * @type string
    */
    aggregateId: string;
    /**
     * @type string | undefined
    */
    entityType?: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingEntityIdErrorDtoCodeEnum = {
    MISSING_ENTITY_ID: "MISSING_ENTITY_ID"
} as const;

export type MissingEntityIdErrorDtoCodeEnumKey = (typeof missingEntityIdErrorDtoCodeEnum)[keyof typeof missingEntityIdErrorDtoCodeEnum];

export type MissingEntityIdErrorDto = {
    /**
     * @type string
    */
    code: MissingEntityIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingEntityIdDetailsDto;
};

export type MissingFirstFailedAtDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export const missingFirstFailedAtErrorDtoCodeEnum = {
    MISSING_FIRST_FAILED_AT: "MISSING_FIRST_FAILED_AT"
} as const;

export type MissingFirstFailedAtErrorDtoCodeEnumKey = (typeof missingFirstFailedAtErrorDtoCodeEnum)[keyof typeof missingFirstFailedAtErrorDtoCodeEnum];

export type MissingFirstFailedAtErrorDto = {
    /**
     * @type string
    */
    code: MissingFirstFailedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingFirstFailedAtDetailsDto;
};

export type ProductConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const productConfigNotFoundErrorDtoCodeEnum = {
    PRODUCT_CONFIG_NOT_FOUND: "PRODUCT_CONFIG_NOT_FOUND"
} as const;

export type ProductConfigNotFoundErrorDtoCodeEnumKey = (typeof productConfigNotFoundErrorDtoCodeEnum)[keyof typeof productConfigNotFoundErrorDtoCodeEnum];

export type ProductConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ProductConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ProductConfigNotFoundDetailsDto;
};

export type ClaimExternalIdNotFoundDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
};

export const claimExternalIdNotFoundErrorDtoCodeEnum = {
    CLAIM_EXTERNAL_ID_NOT_FOUND: "CLAIM_EXTERNAL_ID_NOT_FOUND"
} as const;

export type ClaimExternalIdNotFoundErrorDtoCodeEnumKey = (typeof claimExternalIdNotFoundErrorDtoCodeEnum)[keyof typeof claimExternalIdNotFoundErrorDtoCodeEnum];

export type ClaimExternalIdNotFoundErrorDto = {
    /**
     * @type string
    */
    code: ClaimExternalIdNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimExternalIdNotFoundDetailsDto;
};

export type UnsupportedProjectionTableDetailsDto = {
    /**
     * @type string
    */
    projectionTable: string;
};

export const unsupportedProjectionTableErrorDtoCodeEnum = {
    UNSUPPORTED_PROJECTION_TABLE: "UNSUPPORTED_PROJECTION_TABLE"
} as const;

export type UnsupportedProjectionTableErrorDtoCodeEnumKey = (typeof unsupportedProjectionTableErrorDtoCodeEnum)[keyof typeof unsupportedProjectionTableErrorDtoCodeEnum];

export type UnsupportedProjectionTableErrorDto = {
    /**
     * @type string
    */
    code: UnsupportedProjectionTableErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnsupportedProjectionTableDetailsDto;
};

export type MissingRootIdDetailsDto = {
    /**
     * @type string
    */
    aggregateId: string;
};

export const missingRootIdErrorDtoCodeEnum = {
    MISSING_ROOT_ID: "MISSING_ROOT_ID"
} as const;

export type MissingRootIdErrorDtoCodeEnumKey = (typeof missingRootIdErrorDtoCodeEnum)[keyof typeof missingRootIdErrorDtoCodeEnum];

export type MissingRootIdErrorDto = {
    /**
     * @type string
    */
    code: MissingRootIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingRootIdDetailsDto;
};

export type StripeAccountNotFoundDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const stripeAccountNotFoundErrorDtoCodeEnum = {
    STRIPE_ACCOUNT_NOT_FOUND: "STRIPE_ACCOUNT_NOT_FOUND"
} as const;

export type StripeAccountNotFoundErrorDtoCodeEnumKey = (typeof stripeAccountNotFoundErrorDtoCodeEnum)[keyof typeof stripeAccountNotFoundErrorDtoCodeEnum];

export type StripeAccountNotFoundErrorDto = {
    /**
     * @type string
    */
    code: StripeAccountNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: StripeAccountNotFoundDetailsDto;
};

export type NoInvoicesFoundDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const noInvoicesFoundErrorDtoCodeEnum = {
    NO_INVOICES_FOUND: "NO_INVOICES_FOUND"
} as const;

export type NoInvoicesFoundErrorDtoCodeEnumKey = (typeof noInvoicesFoundErrorDtoCodeEnum)[keyof typeof noInvoicesFoundErrorDtoCodeEnum];

export type NoInvoicesFoundErrorDto = {
    /**
     * @type string
    */
    code: NoInvoicesFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoInvoicesFoundDetailsDto;
};

export type InvalidCacheValueDetailsDto = {
    /**
     * @type object
    */
    value: object;
};

export const invalidCacheValueErrorDtoCodeEnum = {
    INVALID_CACHE_VALUE: "INVALID_CACHE_VALUE"
} as const;

export type InvalidCacheValueErrorDtoCodeEnumKey = (typeof invalidCacheValueErrorDtoCodeEnum)[keyof typeof invalidCacheValueErrorDtoCodeEnum];

export type InvalidCacheValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidCacheValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidCacheValueDetailsDto;
};

export type IntegrationConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    target: string;
};

export const integrationConfigNotFoundErrorDtoCodeEnum = {
    INTEGRATION_CONFIG_NOT_FOUND: "INTEGRATION_CONFIG_NOT_FOUND"
} as const;

export type IntegrationConfigNotFoundErrorDtoCodeEnumKey = (typeof integrationConfigNotFoundErrorDtoCodeEnum)[keyof typeof integrationConfigNotFoundErrorDtoCodeEnum];

export type IntegrationConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: IntegrationConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: IntegrationConfigNotFoundDetailsDto;
};

export type TierConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    tier: string;
};

export const tierConfigNotFoundErrorDtoCodeEnum = {
    TIER_CONFIG_NOT_FOUND: "TIER_CONFIG_NOT_FOUND"
} as const;

export type TierConfigNotFoundErrorDtoCodeEnumKey = (typeof tierConfigNotFoundErrorDtoCodeEnum)[keyof typeof tierConfigNotFoundErrorDtoCodeEnum];

export type TierConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: TierConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TierConfigNotFoundDetailsDto;
};

export type FailedToGetFileFromS3DetailsDto = {
    /**
     * @type string
    */
    file: string;
    /**
     * @type string
    */
    bucket: string;
};

export const failedToGetFileFromS3ErrorDtoCodeEnum = {
    FAILED_TO_GET_FILE_FROM_S3: "FAILED_TO_GET_FILE_FROM_S3"
} as const;

export type FailedToGetFileFromS3ErrorDtoCodeEnumKey = (typeof failedToGetFileFromS3ErrorDtoCodeEnum)[keyof typeof failedToGetFileFromS3ErrorDtoCodeEnum];

export type FailedToGetFileFromS3ErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetFileFromS3ErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetFileFromS3DetailsDto;
};

export type MissingCustomerFirstNameDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingCustomerFirstNameErrorDtoCodeEnum = {
    MISSING_CUSTOMER_FIRST_NAME: "MISSING_CUSTOMER_FIRST_NAME"
} as const;

export type MissingCustomerFirstNameErrorDtoCodeEnumKey = (typeof missingCustomerFirstNameErrorDtoCodeEnum)[keyof typeof missingCustomerFirstNameErrorDtoCodeEnum];

export type MissingCustomerFirstNameErrorDto = {
    /**
     * @type string
    */
    code: MissingCustomerFirstNameErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingCustomerFirstNameDetailsDto;
};

export type MissingCustomerLastNameDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingCustomerLastNameErrorDtoCodeEnum = {
    MISSING_CUSTOMER_LAST_NAME: "MISSING_CUSTOMER_LAST_NAME"
} as const;

export type MissingCustomerLastNameErrorDtoCodeEnumKey = (typeof missingCustomerLastNameErrorDtoCodeEnum)[keyof typeof missingCustomerLastNameErrorDtoCodeEnum];

export type MissingCustomerLastNameErrorDto = {
    /**
     * @type string
    */
    code: MissingCustomerLastNameErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingCustomerLastNameDetailsDto;
};

export type MissingCustomerEmailDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingCustomerEmailErrorDtoCodeEnum = {
    MISSING_CUSTOMER_EMAIL: "MISSING_CUSTOMER_EMAIL"
} as const;

export type MissingCustomerEmailErrorDtoCodeEnumKey = (typeof missingCustomerEmailErrorDtoCodeEnum)[keyof typeof missingCustomerEmailErrorDtoCodeEnum];

export type MissingCustomerEmailErrorDto = {
    /**
     * @type string
    */
    code: MissingCustomerEmailErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingCustomerEmailDetailsDto;
};

export type Ar24UserNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const ar24UserNotFoundErrorDtoCodeEnum = {
    AR24_USER_NOT_FOUND: "AR24_USER_NOT_FOUND"
} as const;

export type Ar24UserNotFoundErrorDtoCodeEnumKey = (typeof ar24UserNotFoundErrorDtoCodeEnum)[keyof typeof ar24UserNotFoundErrorDtoCodeEnum];

export type Ar24UserNotFoundErrorDto = {
    /**
     * @type string
    */
    code: Ar24UserNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: Ar24UserNotFoundDetailsDto;
};

export type FailedToSendAttachmentToAr24DetailsDto = {
    /**
     * @type string
    */
    attachmentId: string;
};

export const failedToSendAttachmentToAr24ErrorDtoCodeEnum = {
    FAILED_TO_SEND_ATTACHMENT_TO_AR24: "FAILED_TO_SEND_ATTACHMENT_TO_AR24"
} as const;

export type FailedToSendAttachmentToAr24ErrorDtoCodeEnumKey = (typeof failedToSendAttachmentToAr24ErrorDtoCodeEnum)[keyof typeof failedToSendAttachmentToAr24ErrorDtoCodeEnum];

export type FailedToSendAttachmentToAr24ErrorDto = {
    /**
     * @type string
    */
    code: FailedToSendAttachmentToAr24ErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToSendAttachmentToAr24DetailsDto;
};

export type InvalidSignatureLengthDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const invalidSignatureLengthErrorDtoCodeEnum = {
    INVALID_SIGNATURE_LENGTH: "INVALID_SIGNATURE_LENGTH"
} as const;

export type InvalidSignatureLengthErrorDtoCodeEnumKey = (typeof invalidSignatureLengthErrorDtoCodeEnum)[keyof typeof invalidSignatureLengthErrorDtoCodeEnum];

export type InvalidSignatureLengthErrorDto = {
    /**
     * @type string
    */
    code: InvalidSignatureLengthErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidSignatureLengthDetailsDto;
};

export type InvalidSignatureDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const invalidSignatureErrorDtoCodeEnum = {
    INVALID_SIGNATURE: "INVALID_SIGNATURE"
} as const;

export type InvalidSignatureErrorDtoCodeEnumKey = (typeof invalidSignatureErrorDtoCodeEnum)[keyof typeof invalidSignatureErrorDtoCodeEnum];

export type InvalidSignatureErrorDto = {
    /**
     * @type string
    */
    code: InvalidSignatureErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidSignatureDetailsDto;
};

export type InvalidEmailEngineWebhookPayloadDetailsDto = {
    /**
     * @type array
    */
    errors: string[];
};

export const invalidEmailengineWebhookPayloadErrorDtoCodeEnum = {
    INVALID_EMAILENGINE_WEBHOOK_PAYLOAD: "INVALID_EMAILENGINE_WEBHOOK_PAYLOAD"
} as const;

export type InvalidEmailengineWebhookPayloadErrorDtoCodeEnumKey = (typeof invalidEmailengineWebhookPayloadErrorDtoCodeEnum)[keyof typeof invalidEmailengineWebhookPayloadErrorDtoCodeEnum];

export type InvalidEmailengineWebhookPayloadErrorDto = {
    /**
     * @type string
    */
    code: InvalidEmailengineWebhookPayloadErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEmailEngineWebhookPayloadDetailsDto;
};

export type FailedToGenerateReportRowDetailsDto = {
    /**
     * @type string
    */
    reportType: string;
    /**
     * @type string
    */
    aggregateId: string;
    /**
     * @type string
    */
    error: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToGenerateReportRowErrorDtoCodeEnum = {
    FAILED_TO_GENERATE_REPORT_ROW: "FAILED_TO_GENERATE_REPORT_ROW"
} as const;

export type FailedToGenerateReportRowErrorDtoCodeEnumKey = (typeof failedToGenerateReportRowErrorDtoCodeEnum)[keyof typeof failedToGenerateReportRowErrorDtoCodeEnum];

export type FailedToGenerateReportRowErrorDto = {
    /**
     * @type string
    */
    code: FailedToGenerateReportRowErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGenerateReportRowDetailsDto;
};

export type InternalServerErrorDetailsDto = {
    /**
     * @type string
    */
    message: string;
};

export const internalServerErrorErrorDtoCodeEnum = {
    INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR"
} as const;

export type InternalServerErrorErrorDtoCodeEnumKey = (typeof internalServerErrorErrorDtoCodeEnum)[keyof typeof internalServerErrorErrorDtoCodeEnum];

export type InternalServerErrorErrorDto = {
    /**
     * @type string
    */
    code: InternalServerErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InternalServerErrorDetailsDto;
};

export type FailedToDetermineEndorsementTypeDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToDetermineEndorsementTypeErrorDtoCodeEnum = {
    FAILED_TO_DETERMINE_ENDORSEMENT_TYPE: "FAILED_TO_DETERMINE_ENDORSEMENT_TYPE"
} as const;

export type FailedToDetermineEndorsementTypeErrorDtoCodeEnumKey = (typeof failedToDetermineEndorsementTypeErrorDtoCodeEnum)[keyof typeof failedToDetermineEndorsementTypeErrorDtoCodeEnum];

export type FailedToDetermineEndorsementTypeErrorDto = {
    /**
     * @type string
    */
    code: FailedToDetermineEndorsementTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToDetermineEndorsementTypeDetailsDto;
};

export type FailedToFindRootAggregateDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindRootAggregateErrorDtoCodeEnum = {
    FAILED_TO_FIND_ROOT_AGGREGATE: "FAILED_TO_FIND_ROOT_AGGREGATE"
} as const;

export type FailedToFindRootAggregateErrorDtoCodeEnumKey = (typeof failedToFindRootAggregateErrorDtoCodeEnum)[keyof typeof failedToFindRootAggregateErrorDtoCodeEnum];

export type FailedToFindRootAggregateErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindRootAggregateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindRootAggregateDetailsDto;
};

export type FailedToFindMatchingLinesDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindMatchingLinesErrorDtoCodeEnum = {
    FAILED_TO_FIND_MATCHING_LINES: "FAILED_TO_FIND_MATCHING_LINES"
} as const;

export type FailedToFindMatchingLinesErrorDtoCodeEnumKey = (typeof failedToFindMatchingLinesErrorDtoCodeEnum)[keyof typeof failedToFindMatchingLinesErrorDtoCodeEnum];

export type FailedToFindMatchingLinesErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindMatchingLinesErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindMatchingLinesDetailsDto;
};

export type FailedToFindLatestAssetDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindLatestAssetErrorDtoCodeEnum = {
    FAILED_TO_FIND_LATEST_ASSET: "FAILED_TO_FIND_LATEST_ASSET"
} as const;

export type FailedToFindLatestAssetErrorDtoCodeEnumKey = (typeof failedToFindLatestAssetErrorDtoCodeEnum)[keyof typeof failedToFindLatestAssetErrorDtoCodeEnum];

export type FailedToFindLatestAssetErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindLatestAssetErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindLatestAssetDetailsDto;
};

export type FailedToFindStartedAtDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindStartedAtErrorDtoCodeEnum = {
    FAILED_TO_FIND_STARTED_AT: "FAILED_TO_FIND_STARTED_AT"
} as const;

export type FailedToFindStartedAtErrorDtoCodeEnumKey = (typeof failedToFindStartedAtErrorDtoCodeEnum)[keyof typeof failedToFindStartedAtErrorDtoCodeEnum];

export type FailedToFindStartedAtErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindStartedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindStartedAtDetailsDto;
};

export type FailedToFindEndedAtDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindEndedAtErrorDtoCodeEnum = {
    FAILED_TO_FIND_ENDED_AT: "FAILED_TO_FIND_ENDED_AT"
} as const;

export type FailedToFindEndedAtErrorDtoCodeEnumKey = (typeof failedToFindEndedAtErrorDtoCodeEnum)[keyof typeof failedToFindEndedAtErrorDtoCodeEnum];

export type FailedToFindEndedAtErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindEndedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindEndedAtDetailsDto;
};

export type FailedToFindAssetQuoteIdDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindAssetQuoteIdErrorDtoCodeEnum = {
    FAILED_TO_FIND_ASSET_QUOTE_ID: "FAILED_TO_FIND_ASSET_QUOTE_ID"
} as const;

export type FailedToFindAssetQuoteIdErrorDtoCodeEnumKey = (typeof failedToFindAssetQuoteIdErrorDtoCodeEnum)[keyof typeof failedToFindAssetQuoteIdErrorDtoCodeEnum];

export type FailedToFindAssetQuoteIdErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindAssetQuoteIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindAssetQuoteIdDetailsDto;
};

export type FailedToFindPreviousWakamQuoteDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindPreviousWakamQuoteErrorDtoCodeEnum = {
    FAILED_TO_FIND_PREVIOUS_WAKAM_QUOTE: "FAILED_TO_FIND_PREVIOUS_WAKAM_QUOTE"
} as const;

export type FailedToFindPreviousWakamQuoteErrorDtoCodeEnumKey = (typeof failedToFindPreviousWakamQuoteErrorDtoCodeEnum)[keyof typeof failedToFindPreviousWakamQuoteErrorDtoCodeEnum];

export type FailedToFindPreviousWakamQuoteErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindPreviousWakamQuoteErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindPreviousWakamQuoteDetailsDto;
};

export type FailedToFindCustomerDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const failedToFindCustomerErrorDtoCodeEnum = {
    FAILED_TO_FIND_CUSTOMER: "FAILED_TO_FIND_CUSTOMER"
} as const;

export type FailedToFindCustomerErrorDtoCodeEnumKey = (typeof failedToFindCustomerErrorDtoCodeEnum)[keyof typeof failedToFindCustomerErrorDtoCodeEnum];

export type FailedToFindCustomerErrorDto = {
    /**
     * @type string
    */
    code: FailedToFindCustomerErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFindCustomerDetailsDto;
};

export type AmountRefundedMismatchDetailsDto = {
    /**
     * @type number
    */
    amountRefunded: number;
    /**
     * @type number
    */
    invoiceTotal: number;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const amountRefundedMismatchErrorDtoCodeEnum = {
    AMOUNT_REFUNDED_MISMATCH: "AMOUNT_REFUNDED_MISMATCH"
} as const;

export type AmountRefundedMismatchErrorDtoCodeEnumKey = (typeof amountRefundedMismatchErrorDtoCodeEnum)[keyof typeof amountRefundedMismatchErrorDtoCodeEnum];

export type AmountRefundedMismatchErrorDto = {
    /**
     * @type string
    */
    code: AmountRefundedMismatchErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AmountRefundedMismatchDetailsDto;
};

export type CustomerFlowProjectionNotFoundDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const customerFlowProjectionNotFoundErrorDtoCodeEnum = {
    CUSTOMER_FLOW_PROJECTION_NOT_FOUND: "CUSTOMER_FLOW_PROJECTION_NOT_FOUND"
} as const;

export type CustomerFlowProjectionNotFoundErrorDtoCodeEnumKey = (typeof customerFlowProjectionNotFoundErrorDtoCodeEnum)[keyof typeof customerFlowProjectionNotFoundErrorDtoCodeEnum];

export type CustomerFlowProjectionNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CustomerFlowProjectionNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CustomerFlowProjectionNotFoundDetailsDto;
};

export type NoAssetsFoundForPolicyDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const noAssetsFoundForPolicyErrorDtoCodeEnum = {
    NO_ASSETS_FOUND_FOR_POLICY: "NO_ASSETS_FOUND_FOR_POLICY"
} as const;

export type NoAssetsFoundForPolicyErrorDtoCodeEnumKey = (typeof noAssetsFoundForPolicyErrorDtoCodeEnum)[keyof typeof noAssetsFoundForPolicyErrorDtoCodeEnum];

export type NoAssetsFoundForPolicyErrorDto = {
    /**
     * @type string
    */
    code: NoAssetsFoundForPolicyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoAssetsFoundForPolicyDetailsDto;
};

export type AssetFlowProjectionNotFoundDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const assetFlowProjectionNotFoundErrorDtoCodeEnum = {
    ASSET_FLOW_PROJECTION_NOT_FOUND: "ASSET_FLOW_PROJECTION_NOT_FOUND"
} as const;

export type AssetFlowProjectionNotFoundErrorDtoCodeEnumKey = (typeof assetFlowProjectionNotFoundErrorDtoCodeEnum)[keyof typeof assetFlowProjectionNotFoundErrorDtoCodeEnum];

export type AssetFlowProjectionNotFoundErrorDto = {
    /**
     * @type string
    */
    code: AssetFlowProjectionNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AssetFlowProjectionNotFoundDetailsDto;
};

export type InvalidActivityIntervalDetailsDto = {
    /**
     * @type string
    */
    invalidReason: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const invalidActivityIntervalErrorDtoCodeEnum = {
    INVALID_ACTIVITY_INTERVAL: "INVALID_ACTIVITY_INTERVAL"
} as const;

export type InvalidActivityIntervalErrorDtoCodeEnumKey = (typeof invalidActivityIntervalErrorDtoCodeEnum)[keyof typeof invalidActivityIntervalErrorDtoCodeEnum];

export type InvalidActivityIntervalErrorDto = {
    /**
     * @type string
    */
    code: InvalidActivityIntervalErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidActivityIntervalDetailsDto;
};

export type FailedToFetchEllisphereDataDetailsDto = {
    /**
     * @type string
    */
    path: string;
    /**
     * @type string
    */
    errorMessage: string;
    /**
     * @type string | undefined
    */
    xmlBody?: string;
};

export const failedToFetchEllisphereDataErrorDtoCodeEnum = {
    FAILED_TO_FETCH_ELLISPHERE_DATA: "FAILED_TO_FETCH_ELLISPHERE_DATA"
} as const;

export type FailedToFetchEllisphereDataErrorDtoCodeEnumKey = (typeof failedToFetchEllisphereDataErrorDtoCodeEnum)[keyof typeof failedToFetchEllisphereDataErrorDtoCodeEnum];

export type FailedToFetchEllisphereDataErrorDto = {
    /**
     * @type string
    */
    code: FailedToFetchEllisphereDataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFetchEllisphereDataDetailsDto;
};

export type EfficialeApiConnectorConfigNotSetDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const efficialeApiConnectorConfigNotSetErrorDtoCodeEnum = {
    EFFICIALE_API_CONNECTOR_CONFIG_NOT_SET: "EFFICIALE_API_CONNECTOR_CONFIG_NOT_SET"
} as const;

export type EfficialeApiConnectorConfigNotSetErrorDtoCodeEnumKey = (typeof efficialeApiConnectorConfigNotSetErrorDtoCodeEnum)[keyof typeof efficialeApiConnectorConfigNotSetErrorDtoCodeEnum];

export type EfficialeApiConnectorConfigNotSetErrorDto = {
    /**
     * @type string
    */
    code: EfficialeApiConnectorConfigNotSetErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EfficialeApiConnectorConfigNotSetDetailsDto;
};

export type FailedToFetchEfficialeTokenDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const failedToFetchEfficialeTokenErrorDtoCodeEnum = {
    FAILED_TO_FETCH_EFFICIALE_TOKEN: "FAILED_TO_FETCH_EFFICIALE_TOKEN"
} as const;

export type FailedToFetchEfficialeTokenErrorDtoCodeEnumKey = (typeof failedToFetchEfficialeTokenErrorDtoCodeEnum)[keyof typeof failedToFetchEfficialeTokenErrorDtoCodeEnum];

export type FailedToFetchEfficialeTokenErrorDto = {
    /**
     * @type string
    */
    code: FailedToFetchEfficialeTokenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFetchEfficialeTokenDetailsDto;
};

export type FailedToFetchEfficialeDataDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const failedToFetchEfficialeDataErrorDtoCodeEnum = {
    FAILED_TO_FETCH_EFFICIALE_DATA: "FAILED_TO_FETCH_EFFICIALE_DATA"
} as const;

export type FailedToFetchEfficialeDataErrorDtoCodeEnumKey = (typeof failedToFetchEfficialeDataErrorDtoCodeEnum)[keyof typeof failedToFetchEfficialeDataErrorDtoCodeEnum];

export type FailedToFetchEfficialeDataErrorDto = {
    /**
     * @type string
    */
    code: FailedToFetchEfficialeDataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToFetchEfficialeDataDetailsDto;
};

export type InvalidEfficialeApiResponseDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const invalidEfficialeApiResponseErrorDtoCodeEnum = {
    INVALID_EFFICIALE_API_RESPONSE: "INVALID_EFFICIALE_API_RESPONSE"
} as const;

export type InvalidEfficialeApiResponseErrorDtoCodeEnumKey = (typeof invalidEfficialeApiResponseErrorDtoCodeEnum)[keyof typeof invalidEfficialeApiResponseErrorDtoCodeEnum];

export type InvalidEfficialeApiResponseErrorDto = {
    /**
     * @type string
    */
    code: InvalidEfficialeApiResponseErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEfficialeApiResponseDetailsDto;
};

export type MultipleDocumentsFoundDetailsDto = {
    /**
     * @type number
    */
    foundCount: number;
    /**
     * @type number
    */
    expectedCount: number;
    /**
     * @type string
    */
    invoiceId: string;
};

export const multipleDocumentsFoundErrorDtoCodeEnum = {
    MULTIPLE_DOCUMENTS_FOUND: "MULTIPLE_DOCUMENTS_FOUND"
} as const;

export type MultipleDocumentsFoundErrorDtoCodeEnumKey = (typeof multipleDocumentsFoundErrorDtoCodeEnum)[keyof typeof multipleDocumentsFoundErrorDtoCodeEnum];

export type MultipleDocumentsFoundErrorDto = {
    /**
     * @type string
    */
    code: MultipleDocumentsFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MultipleDocumentsFoundDetailsDto;
};

export type MissingAssetPriceDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    missingField?: string;
};

export const missingAssetPriceErrorDtoCodeEnum = {
    MISSING_ASSET_PRICE: "MISSING_ASSET_PRICE"
} as const;

export type MissingAssetPriceErrorDtoCodeEnumKey = (typeof missingAssetPriceErrorDtoCodeEnum)[keyof typeof missingAssetPriceErrorDtoCodeEnum];

export type MissingAssetPriceErrorDto = {
    /**
     * @type string
    */
    code: MissingAssetPriceErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAssetPriceDetailsDto;
};

export type FieldConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    key: string;
};

export const fieldConfigNotFoundErrorDtoCodeEnum = {
    FIELD_CONFIG_NOT_FOUND: "FIELD_CONFIG_NOT_FOUND"
} as const;

export type FieldConfigNotFoundErrorDtoCodeEnumKey = (typeof fieldConfigNotFoundErrorDtoCodeEnum)[keyof typeof fieldConfigNotFoundErrorDtoCodeEnum];

export type FieldConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: FieldConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FieldConfigNotFoundDetailsDto;
};

export type InvalidReducedCustomFieldConfigDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const invalidReducedCustomFieldConfigErrorDtoCodeEnum = {
    INVALID_REDUCED_CUSTOM_FIELD_CONFIG: "INVALID_REDUCED_CUSTOM_FIELD_CONFIG"
} as const;

export type InvalidReducedCustomFieldConfigErrorDtoCodeEnumKey = (typeof invalidReducedCustomFieldConfigErrorDtoCodeEnum)[keyof typeof invalidReducedCustomFieldConfigErrorDtoCodeEnum];

export type InvalidReducedCustomFieldConfigErrorDto = {
    /**
     * @type string
    */
    code: InvalidReducedCustomFieldConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidReducedCustomFieldConfigDetailsDto;
};

export type UnknownRelationTypeDetailsDto = {
    /**
     * @type string
    */
    relationType: string;
    /**
     * @type string
    */
    child: string;
};

export const unknownRelationTypeErrorDtoCodeEnum = {
    UNKNOWN_RELATION_TYPE: "UNKNOWN_RELATION_TYPE"
} as const;

export type UnknownRelationTypeErrorDtoCodeEnumKey = (typeof unknownRelationTypeErrorDtoCodeEnum)[keyof typeof unknownRelationTypeErrorDtoCodeEnum];

export type UnknownRelationTypeErrorDto = {
    /**
     * @type string
    */
    code: UnknownRelationTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownRelationTypeDetailsDto;
};

export type NodeNotFoundDetailsDto = {
    /**
     * @type string
    */
    nodeName: string;
    /**
     * @type string | undefined
    */
    workflowName?: string;
};

export const nodeNotFoundErrorDtoCodeEnum = {
    NODE_NOT_FOUND: "NODE_NOT_FOUND"
} as const;

export type NodeNotFoundErrorDtoCodeEnumKey = (typeof nodeNotFoundErrorDtoCodeEnum)[keyof typeof nodeNotFoundErrorDtoCodeEnum];

export type NodeNotFoundErrorDto = {
    /**
     * @type string
    */
    code: NodeNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NodeNotFoundDetailsDto;
};

export type NoValidPathDetailsDto = {
    /**
     * @type string
    */
    nodeName: string;
};

export const noValidPathErrorDtoCodeEnum = {
    NO_VALID_PATH: "NO_VALID_PATH"
} as const;

export type NoValidPathErrorDtoCodeEnumKey = (typeof noValidPathErrorDtoCodeEnum)[keyof typeof noValidPathErrorDtoCodeEnum];

export type NoValidPathErrorDto = {
    /**
     * @type string
    */
    code: NoValidPathErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoValidPathDetailsDto;
};

export type InputMappingMissingDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const inputMappingMissingErrorDtoCodeEnum = {
    INPUT_MAPPING_MISSING: "INPUT_MAPPING_MISSING"
} as const;

export type InputMappingMissingErrorDtoCodeEnumKey = (typeof inputMappingMissingErrorDtoCodeEnum)[keyof typeof inputMappingMissingErrorDtoCodeEnum];

export type InputMappingMissingErrorDto = {
    /**
     * @type string
    */
    code: InputMappingMissingErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InputMappingMissingDetailsDto;
};

export type InvalidWorkflowDefinitionDetailsDto = {
    /**
     * @type string | undefined
    */
    errors?: string;
};

export const invalidWorkflowDefinitionErrorDtoCodeEnum = {
    INVALID_WORKFLOW_DEFINITION: "INVALID_WORKFLOW_DEFINITION"
} as const;

export type InvalidWorkflowDefinitionErrorDtoCodeEnumKey = (typeof invalidWorkflowDefinitionErrorDtoCodeEnum)[keyof typeof invalidWorkflowDefinitionErrorDtoCodeEnum];

export type InvalidWorkflowDefinitionErrorDto = {
    /**
     * @type string
    */
    code: InvalidWorkflowDefinitionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidWorkflowDefinitionDetailsDto;
};

export type InvalidEnvironmentValueDetailsDto = {
    /**
     * @type string
    */
    value: string;
};

export const invalidEnvironmentValueErrorDtoCodeEnum = {
    INVALID_ENVIRONMENT_VALUE: "INVALID_ENVIRONMENT_VALUE"
} as const;

export type InvalidEnvironmentValueErrorDtoCodeEnumKey = (typeof invalidEnvironmentValueErrorDtoCodeEnum)[keyof typeof invalidEnvironmentValueErrorDtoCodeEnum];

export type InvalidEnvironmentValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidEnvironmentValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEnvironmentValueDetailsDto;
};

export type InvalidWorkspaceValueDetailsDto = {
    /**
     * @type string
    */
    value: string;
};

export const invalidWorkspaceValueErrorDtoCodeEnum = {
    INVALID_WORKSPACE_VALUE: "INVALID_WORKSPACE_VALUE"
} as const;

export type InvalidWorkspaceValueErrorDtoCodeEnumKey = (typeof invalidWorkspaceValueErrorDtoCodeEnum)[keyof typeof invalidWorkspaceValueErrorDtoCodeEnum];

export type InvalidWorkspaceValueErrorDto = {
    /**
     * @type string
    */
    code: InvalidWorkspaceValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidWorkspaceValueDetailsDto;
};

export type FieldHasNoValueDetailsDto = {
    /**
     * @type string
    */
    key: string;
};

export const fieldHasNoValueErrorDtoCodeEnum = {
    FIELD_HAS_NO_VALUE: "FIELD_HAS_NO_VALUE"
} as const;

export type FieldHasNoValueErrorDtoCodeEnumKey = (typeof fieldHasNoValueErrorDtoCodeEnum)[keyof typeof fieldHasNoValueErrorDtoCodeEnum];

export type FieldHasNoValueErrorDto = {
    /**
     * @type string
    */
    code: FieldHasNoValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FieldHasNoValueDetailsDto;
};

export type FailedToParseEntityDetailsDto = {
    /**
     * @type string
    */
    id: string;
};

export const failedToParseEntityErrorDtoCodeEnum = {
    FAILED_TO_PARSE_ENTITY: "FAILED_TO_PARSE_ENTITY"
} as const;

export type FailedToParseEntityErrorDtoCodeEnumKey = (typeof failedToParseEntityErrorDtoCodeEnum)[keyof typeof failedToParseEntityErrorDtoCodeEnum];

export type FailedToParseEntityErrorDto = {
    /**
     * @type string
    */
    code: FailedToParseEntityErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToParseEntityDetailsDto;
};

export type DateShouldNotBeNullDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const dateShouldNotBeNullErrorDtoCodeEnum = {
    DATE_SHOULD_NOT_BE_NULL: "DATE_SHOULD_NOT_BE_NULL"
} as const;

export type DateShouldNotBeNullErrorDtoCodeEnumKey = (typeof dateShouldNotBeNullErrorDtoCodeEnum)[keyof typeof dateShouldNotBeNullErrorDtoCodeEnum];

export type DateShouldNotBeNullErrorDto = {
    /**
     * @type string
    */
    code: DateShouldNotBeNullErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DateShouldNotBeNullDetailsDto;
};

export type FailedToUploadToPresignedUrlDetailsDto = {
    /**
     * @type string
    */
    errorMessage: string;
};

export const failedToUploadToPresignedUrlErrorDtoCodeEnum = {
    FAILED_TO_UPLOAD_TO_PRESIGNED_URL: "FAILED_TO_UPLOAD_TO_PRESIGNED_URL"
} as const;

export type FailedToUploadToPresignedUrlErrorDtoCodeEnumKey = (typeof failedToUploadToPresignedUrlErrorDtoCodeEnum)[keyof typeof failedToUploadToPresignedUrlErrorDtoCodeEnum];

export type FailedToUploadToPresignedUrlErrorDto = {
    /**
     * @type string
    */
    code: FailedToUploadToPresignedUrlErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToUploadToPresignedUrlDetailsDto;
};

export type FailedToGetS3MetadataDetailsDto = {
    /**
     * @type string
    */
    bucket: string;
    /**
     * @type string
    */
    key: string;
    /**
     * @type string | undefined
    */
    errorMessage?: string;
};

export const failedToGetS3MetadataErrorDtoCodeEnum = {
    FAILED_TO_GET_S3_METADATA: "FAILED_TO_GET_S3_METADATA"
} as const;

export type FailedToGetS3MetadataErrorDtoCodeEnumKey = (typeof failedToGetS3MetadataErrorDtoCodeEnum)[keyof typeof failedToGetS3MetadataErrorDtoCodeEnum];

export type FailedToGetS3MetadataErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetS3MetadataErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetS3MetadataDetailsDto;
};

export type FailedToGeneratePresignedUrlDetailsDto = {
    /**
     * @type string
    */
    bucket: string;
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    operation: string;
    /**
     * @type string | undefined
    */
    errorMessage?: string;
};

export const failedToGeneratePresignedUrlErrorDtoCodeEnum = {
    FAILED_TO_GENERATE_PRESIGNED_URL: "FAILED_TO_GENERATE_PRESIGNED_URL"
} as const;

export type FailedToGeneratePresignedUrlErrorDtoCodeEnumKey = (typeof failedToGeneratePresignedUrlErrorDtoCodeEnum)[keyof typeof failedToGeneratePresignedUrlErrorDtoCodeEnum];

export type FailedToGeneratePresignedUrlErrorDto = {
    /**
     * @type string
    */
    code: FailedToGeneratePresignedUrlErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGeneratePresignedUrlDetailsDto;
};

export type FailedToUploadFileToS3DetailsDto = {
    /**
     * @type string
    */
    bucket: string;
    /**
     * @type string
    */
    key: string;
    /**
     * @type string | undefined
    */
    errorMessage?: string;
};

export const failedToUploadFileToS3ErrorDtoCodeEnum = {
    FAILED_TO_UPLOAD_FILE_TO_S3: "FAILED_TO_UPLOAD_FILE_TO_S3"
} as const;

export type FailedToUploadFileToS3ErrorDtoCodeEnumKey = (typeof failedToUploadFileToS3ErrorDtoCodeEnum)[keyof typeof failedToUploadFileToS3ErrorDtoCodeEnum];

export type FailedToUploadFileToS3ErrorDto = {
    /**
     * @type string
    */
    code: FailedToUploadFileToS3ErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToUploadFileToS3DetailsDto;
};

export type FailedToDeleteS3ObjectsDetailsDto = {
    /**
     * @type string
    */
    bucket: string;
    /**
     * @type array
    */
    keys: string[];
    /**
     * @type string | undefined
    */
    errorMessage?: string;
};

export const failedToDeleteS3ObjectsErrorDtoCodeEnum = {
    FAILED_TO_DELETE_S3_OBJECTS: "FAILED_TO_DELETE_S3_OBJECTS"
} as const;

export type FailedToDeleteS3ObjectsErrorDtoCodeEnumKey = (typeof failedToDeleteS3ObjectsErrorDtoCodeEnum)[keyof typeof failedToDeleteS3ObjectsErrorDtoCodeEnum];

export type FailedToDeleteS3ObjectsErrorDto = {
    /**
     * @type string
    */
    code: FailedToDeleteS3ObjectsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToDeleteS3ObjectsDetailsDto;
};

export type InvalidPermissionsRecordDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const invalidPermissionsRecordErrorDtoCodeEnum = {
    INVALID_PERMISSIONS_RECORD: "INVALID_PERMISSIONS_RECORD"
} as const;

export type InvalidPermissionsRecordErrorDtoCodeEnumKey = (typeof invalidPermissionsRecordErrorDtoCodeEnum)[keyof typeof invalidPermissionsRecordErrorDtoCodeEnum];

export type InvalidPermissionsRecordErrorDto = {
    /**
     * @type string
    */
    code: InvalidPermissionsRecordErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPermissionsRecordDetailsDto;
};

export type CannotConvertToKeyValueDetailsDto = {
    /**
     * @type object
    */
    input: object;
    /**
     * @type string
    */
    path: string;
};

export const cannotConvertToKeyValueErrorDtoCodeEnum = {
    CANNOT_CONVERT_TO_KEY_VALUE: "CANNOT_CONVERT_TO_KEY_VALUE"
} as const;

export type CannotConvertToKeyValueErrorDtoCodeEnumKey = (typeof cannotConvertToKeyValueErrorDtoCodeEnum)[keyof typeof cannotConvertToKeyValueErrorDtoCodeEnum];

export type CannotConvertToKeyValueErrorDto = {
    /**
     * @type string
    */
    code: CannotConvertToKeyValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotConvertToKeyValueDetailsDto;
};

export type InvalidValueTypeDetailsDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type string
    */
    valueType: string;
};

export const invalidValueTypeErrorDtoCodeEnum = {
    INVALID_VALUE_TYPE: "INVALID_VALUE_TYPE"
} as const;

export type InvalidValueTypeErrorDtoCodeEnumKey = (typeof invalidValueTypeErrorDtoCodeEnum)[keyof typeof invalidValueTypeErrorDtoCodeEnum];

export type InvalidValueTypeErrorDto = {
    /**
     * @type string
    */
    code: InvalidValueTypeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidValueTypeDetailsDto;
};

export type FailedToGetMetadataValueDetailsDto = {
    /**
     * @type string
    */
    key: string;
    /**
     * @type number
    */
    entryCount: number;
};

export const failedToGetMetadataValueErrorDtoCodeEnum = {
    FAILED_TO_GET_METADATA_VALUE: "FAILED_TO_GET_METADATA_VALUE"
} as const;

export type FailedToGetMetadataValueErrorDtoCodeEnumKey = (typeof failedToGetMetadataValueErrorDtoCodeEnum)[keyof typeof failedToGetMetadataValueErrorDtoCodeEnum];

export type FailedToGetMetadataValueErrorDto = {
    /**
     * @type string
    */
    code: FailedToGetMetadataValueErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FailedToGetMetadataValueDetailsDto;
};

export type MergedBranchShouldHaveAppliedAtDetailsDto = {
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export const mergedBranchShouldHaveAppliedAtErrorDtoCodeEnum = {
    MERGED_BRANCH_SHOULD_HAVE_APPLIED_AT: "MERGED_BRANCH_SHOULD_HAVE_APPLIED_AT"
} as const;

export type MergedBranchShouldHaveAppliedAtErrorDtoCodeEnumKey = (typeof mergedBranchShouldHaveAppliedAtErrorDtoCodeEnum)[keyof typeof mergedBranchShouldHaveAppliedAtErrorDtoCodeEnum];

export type MergedBranchShouldHaveAppliedAtErrorDto = {
    /**
     * @type string
    */
    code: MergedBranchShouldHaveAppliedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MergedBranchShouldHaveAppliedAtDetailsDto;
};

export type MissingInputIdDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingInputIdErrorDtoCodeEnum = {
    MISSING_INPUT_ID: "MISSING_INPUT_ID"
} as const;

export type MissingInputIdErrorDtoCodeEnumKey = (typeof missingInputIdErrorDtoCodeEnum)[keyof typeof missingInputIdErrorDtoCodeEnum];

export type MissingInputIdErrorDto = {
    /**
     * @type string
    */
    code: MissingInputIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingInputIdDetailsDto;
};

export type UnknownLetterStateDetailsDto = {
    /**
     * @type string
    */
    state: string;
};

export const unknownLetterStateErrorDtoCodeEnum = {
    UNKNOWN_LETTER_STATE: "UNKNOWN_LETTER_STATE"
} as const;

export type UnknownLetterStateErrorDtoCodeEnumKey = (typeof unknownLetterStateErrorDtoCodeEnum)[keyof typeof unknownLetterStateErrorDtoCodeEnum];

export type UnknownLetterStateErrorDto = {
    /**
     * @type string
    */
    code: UnknownLetterStateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnknownLetterStateDetailsDto;
};

export type MissingStripeSignatureDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingStripeSignatureErrorDtoCodeEnum = {
    MISSING_STRIPE_SIGNATURE: "MISSING_STRIPE_SIGNATURE"
} as const;

export type MissingStripeSignatureErrorDtoCodeEnumKey = (typeof missingStripeSignatureErrorDtoCodeEnum)[keyof typeof missingStripeSignatureErrorDtoCodeEnum];

export type MissingStripeSignatureErrorDto = {
    /**
     * @type string
    */
    code: MissingStripeSignatureErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingStripeSignatureDetailsDto;
};

export type MissingRawBodyDetailsDto = {
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingRawBodyErrorDtoCodeEnum = {
    MISSING_RAW_BODY: "MISSING_RAW_BODY"
} as const;

export type MissingRawBodyErrorDtoCodeEnumKey = (typeof missingRawBodyErrorDtoCodeEnum)[keyof typeof missingRawBodyErrorDtoCodeEnum];

export type MissingRawBodyErrorDto = {
    /**
     * @type string
    */
    code: MissingRawBodyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingRawBodyDetailsDto;
};

export type MissingEmailEngineEventIdDetailsDto = object;

export const missingEmailengineEventIdErrorDtoCodeEnum = {
    MISSING_EMAILENGINE_EVENT_ID: "MISSING_EMAILENGINE_EVENT_ID"
} as const;

export type MissingEmailengineEventIdErrorDtoCodeEnumKey = (typeof missingEmailengineEventIdErrorDtoCodeEnum)[keyof typeof missingEmailengineEventIdErrorDtoCodeEnum];

export type MissingEmailengineEventIdErrorDto = {
    /**
     * @type string
    */
    code: MissingEmailengineEventIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingEmailEngineEventIdDetailsDto;
};

export type CouldNotReadStripeEventDetailsDto = {
    /**
     * @type string | undefined
    */
    error?: string;
};

export const couldNotReadStripeEventErrorDtoCodeEnum = {
    COULD_NOT_READ_STRIPE_EVENT: "COULD_NOT_READ_STRIPE_EVENT"
} as const;

export type CouldNotReadStripeEventErrorDtoCodeEnumKey = (typeof couldNotReadStripeEventErrorDtoCodeEnum)[keyof typeof couldNotReadStripeEventErrorDtoCodeEnum];

export type CouldNotReadStripeEventErrorDto = {
    /**
     * @type string
    */
    code: CouldNotReadStripeEventErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CouldNotReadStripeEventDetailsDto;
};

export type ServiceNoHealthCheckDetailsDto = {
    /**
     * @type string
    */
    service: string;
};

export const serviceNoHealthCheckErrorDtoCodeEnum = {
    SERVICE_NO_HEALTH_CHECK: "SERVICE_NO_HEALTH_CHECK"
} as const;

export type ServiceNoHealthCheckErrorDtoCodeEnumKey = (typeof serviceNoHealthCheckErrorDtoCodeEnum)[keyof typeof serviceNoHealthCheckErrorDtoCodeEnum];

export type ServiceNoHealthCheckErrorDto = {
    /**
     * @type string
    */
    code: ServiceNoHealthCheckErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ServiceNoHealthCheckDetailsDto;
};

export type RenewalNotEnabledDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const renewalNotEnabledErrorDtoCodeEnum = {
    RENEWAL_NOT_ENABLED: "RENEWAL_NOT_ENABLED"
} as const;

export type RenewalNotEnabledErrorDtoCodeEnumKey = (typeof renewalNotEnabledErrorDtoCodeEnum)[keyof typeof renewalNotEnabledErrorDtoCodeEnum];

export type RenewalNotEnabledErrorDto = {
    /**
     * @type string
    */
    code: RenewalNotEnabledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RenewalNotEnabledDetailsDto;
};

export type RenewalDateNotFoundDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const renewalDateNotFoundErrorDtoCodeEnum = {
    RENEWAL_DATE_NOT_FOUND: "RENEWAL_DATE_NOT_FOUND"
} as const;

export type RenewalDateNotFoundErrorDtoCodeEnumKey = (typeof renewalDateNotFoundErrorDtoCodeEnum)[keyof typeof renewalDateNotFoundErrorDtoCodeEnum];

export type RenewalDateNotFoundErrorDto = {
    /**
     * @type string
    */
    code: RenewalDateNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: RenewalDateNotFoundDetailsDto;
};

export type BrokerageFirmIdMismatchDetailsDto = object;

export const brokerageFirmIdMismatchErrorDtoCodeEnum = {
    BROKERAGE_FIRM_ID_MISMATCH: "BROKERAGE_FIRM_ID_MISMATCH"
} as const;

export type BrokerageFirmIdMismatchErrorDtoCodeEnumKey = (typeof brokerageFirmIdMismatchErrorDtoCodeEnum)[keyof typeof brokerageFirmIdMismatchErrorDtoCodeEnum];

export type BrokerageFirmIdMismatchErrorDto = {
    /**
     * @type string
    */
    code: BrokerageFirmIdMismatchErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BrokerageFirmIdMismatchDetailsDto;
};

export type PolicyStartedAtNotDefinedDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const policyStartedAtNotDefinedErrorDtoCodeEnum = {
    POLICY_STARTED_AT_NOT_DEFINED: "POLICY_STARTED_AT_NOT_DEFINED"
} as const;

export type PolicyStartedAtNotDefinedErrorDtoCodeEnumKey = (typeof policyStartedAtNotDefinedErrorDtoCodeEnum)[keyof typeof policyStartedAtNotDefinedErrorDtoCodeEnum];

export type PolicyStartedAtNotDefinedErrorDto = {
    /**
     * @type string
    */
    code: PolicyStartedAtNotDefinedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyStartedAtNotDefinedDetailsDto;
};

export type CannotDraftNextInvoiceNoStartDateDetailsDto = object;

export const cannotDraftNextInvoiceNoStartDateErrorDtoCodeEnum = {
    CANNOT_DRAFT_NEXT_INVOICE_NO_START_DATE: "CANNOT_DRAFT_NEXT_INVOICE_NO_START_DATE"
} as const;

export type CannotDraftNextInvoiceNoStartDateErrorDtoCodeEnumKey = (typeof cannotDraftNextInvoiceNoStartDateErrorDtoCodeEnum)[keyof typeof cannotDraftNextInvoiceNoStartDateErrorDtoCodeEnum];

export type CannotDraftNextInvoiceNoStartDateErrorDto = {
    /**
     * @type string
    */
    code: CannotDraftNextInvoiceNoStartDateErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotDraftNextInvoiceNoStartDateDetailsDto;
};

export type TooManyCustomersForBranchDetailsDto = {
    /**
     * @type string
    */
    branchId: string;
};

export const tooManyCustomersForBranchErrorDtoCodeEnum = {
    TOO_MANY_CUSTOMERS_FOR_BRANCH: "TOO_MANY_CUSTOMERS_FOR_BRANCH"
} as const;

export type TooManyCustomersForBranchErrorDtoCodeEnumKey = (typeof tooManyCustomersForBranchErrorDtoCodeEnum)[keyof typeof tooManyCustomersForBranchErrorDtoCodeEnum];

export type TooManyCustomersForBranchErrorDto = {
    /**
     * @type string
    */
    code: TooManyCustomersForBranchErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: TooManyCustomersForBranchDetailsDto;
};

export type PolicyDoesNotHavePaymentLevelDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const policyDoesNotHavePaymentLevelErrorDtoCodeEnum = {
    POLICY_DOES_NOT_HAVE_PAYMENT_LEVEL: "POLICY_DOES_NOT_HAVE_PAYMENT_LEVEL"
} as const;

export type PolicyDoesNotHavePaymentLevelErrorDtoCodeEnumKey = (typeof policyDoesNotHavePaymentLevelErrorDtoCodeEnum)[keyof typeof policyDoesNotHavePaymentLevelErrorDtoCodeEnum];

export type PolicyDoesNotHavePaymentLevelErrorDto = {
    /**
     * @type string
    */
    code: PolicyDoesNotHavePaymentLevelErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PolicyDoesNotHavePaymentLevelDetailsDto;
};

export type NoCustomerIdFoundForInvoiceDetailsDto = {
    /**
     * @type string
    */
    invoiceId: string;
};

export const noCustomerIdFoundForInvoiceErrorDtoCodeEnum = {
    NO_CUSTOMER_ID_FOUND_FOR_INVOICE: "NO_CUSTOMER_ID_FOUND_FOR_INVOICE"
} as const;

export type NoCustomerIdFoundForInvoiceErrorDtoCodeEnumKey = (typeof noCustomerIdFoundForInvoiceErrorDtoCodeEnum)[keyof typeof noCustomerIdFoundForInvoiceErrorDtoCodeEnum];

export type NoCustomerIdFoundForInvoiceErrorDto = {
    /**
     * @type string
    */
    code: NoCustomerIdFoundForInvoiceErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoCustomerIdFoundForInvoiceDetailsDto;
};

export type NoUnpaidComponentsConfiguredDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const noUnpaidComponentsConfiguredErrorDtoCodeEnum = {
    NO_UNPAID_COMPONENTS_CONFIGURED: "NO_UNPAID_COMPONENTS_CONFIGURED"
} as const;

export type NoUnpaidComponentsConfiguredErrorDtoCodeEnumKey = (typeof noUnpaidComponentsConfiguredErrorDtoCodeEnum)[keyof typeof noUnpaidComponentsConfiguredErrorDtoCodeEnum];

export type NoUnpaidComponentsConfiguredErrorDto = {
    /**
     * @type string
    */
    code: NoUnpaidComponentsConfiguredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoUnpaidComponentsConfiguredDetailsDto;
};

export type ExpectedPolicyStartDateToBeDefinedDetailsDto = object;

export const expectedPolicyStartDateToBeDefinedErrorDtoCodeEnum = {
    EXPECTED_POLICY_START_DATE_TO_BE_DEFINED: "EXPECTED_POLICY_START_DATE_TO_BE_DEFINED"
} as const;

export type ExpectedPolicyStartDateToBeDefinedErrorDtoCodeEnumKey = (typeof expectedPolicyStartDateToBeDefinedErrorDtoCodeEnum)[keyof typeof expectedPolicyStartDateToBeDefinedErrorDtoCodeEnum];

export type ExpectedPolicyStartDateToBeDefinedErrorDto = {
    /**
     * @type string
    */
    code: ExpectedPolicyStartDateToBeDefinedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ExpectedPolicyStartDateToBeDefinedDetailsDto;
};

export type NoPremiumScheduleForPolicyDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
};

export const noPremiumScheduleForPolicyErrorDtoCodeEnum = {
    NO_PREMIUM_SCHEDULE_FOR_POLICY: "NO_PREMIUM_SCHEDULE_FOR_POLICY"
} as const;

export type NoPremiumScheduleForPolicyErrorDtoCodeEnumKey = (typeof noPremiumScheduleForPolicyErrorDtoCodeEnum)[keyof typeof noPremiumScheduleForPolicyErrorDtoCodeEnum];

export type NoPremiumScheduleForPolicyErrorDto = {
    /**
     * @type string
    */
    code: NoPremiumScheduleForPolicyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoPremiumScheduleForPolicyDetailsDto;
};

export type UnableToFindPaymentMethodDetailsDto = {
    /**
     * @type string
    */
    paymentMethodId: string;
};

export const unableToFindPaymentMethodErrorDtoCodeEnum = {
    UNABLE_TO_FIND_PAYMENT_METHOD: "UNABLE_TO_FIND_PAYMENT_METHOD"
} as const;

export type UnableToFindPaymentMethodErrorDtoCodeEnumKey = (typeof unableToFindPaymentMethodErrorDtoCodeEnum)[keyof typeof unableToFindPaymentMethodErrorDtoCodeEnum];

export type UnableToFindPaymentMethodErrorDto = {
    /**
     * @type string
    */
    code: UnableToFindPaymentMethodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnableToFindPaymentMethodDetailsDto;
};

export type UnableToFindEarlyPaymentMethodDetailsDto = {
    /**
     * @type string
    */
    earlyPaymentMethodType: string;
};

export const unableToFindEarlyPaymentMethodErrorDtoCodeEnum = {
    UNABLE_TO_FIND_EARLY_PAYMENT_METHOD: "UNABLE_TO_FIND_EARLY_PAYMENT_METHOD"
} as const;

export type UnableToFindEarlyPaymentMethodErrorDtoCodeEnumKey = (typeof unableToFindEarlyPaymentMethodErrorDtoCodeEnum)[keyof typeof unableToFindEarlyPaymentMethodErrorDtoCodeEnum];

export type UnableToFindEarlyPaymentMethodErrorDto = {
    /**
     * @type string
    */
    code: UnableToFindEarlyPaymentMethodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnableToFindEarlyPaymentMethodDetailsDto;
};

export type UnableToFindPreferredPaymentMethodDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
};

export const unableToFindPreferredPaymentMethodErrorDtoCodeEnum = {
    UNABLE_TO_FIND_PREFERRED_PAYMENT_METHOD: "UNABLE_TO_FIND_PREFERRED_PAYMENT_METHOD"
} as const;

export type UnableToFindPreferredPaymentMethodErrorDtoCodeEnumKey = (typeof unableToFindPreferredPaymentMethodErrorDtoCodeEnum)[keyof typeof unableToFindPreferredPaymentMethodErrorDtoCodeEnum];

export type UnableToFindPreferredPaymentMethodErrorDto = {
    /**
     * @type string
    */
    code: UnableToFindPreferredPaymentMethodErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnableToFindPreferredPaymentMethodDetailsDto;
};

export type CannotChargeLessThan50CentsDetailsDto = object;

export const cannotChargeLessThan50CentsErrorDtoCodeEnum = {
    CANNOT_CHARGE_LESS_THAN_50_CENTS: "CANNOT_CHARGE_LESS_THAN_50_CENTS"
} as const;

export type CannotChargeLessThan50CentsErrorDtoCodeEnumKey = (typeof cannotChargeLessThan50CentsErrorDtoCodeEnum)[keyof typeof cannotChargeLessThan50CentsErrorDtoCodeEnum];

export type CannotChargeLessThan50CentsErrorDto = {
    /**
     * @type string
    */
    code: CannotChargeLessThan50CentsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotChargeLessThan50CentsDetailsDto;
};

export type EmailNotConfiguredForInvitationDetailsDto = object;

export const emailNotConfiguredForInvitationErrorDtoCodeEnum = {
    EMAIL_NOT_CONFIGURED_FOR_INVITATION: "EMAIL_NOT_CONFIGURED_FOR_INVITATION"
} as const;

export type EmailNotConfiguredForInvitationErrorDtoCodeEnumKey = (typeof emailNotConfiguredForInvitationErrorDtoCodeEnum)[keyof typeof emailNotConfiguredForInvitationErrorDtoCodeEnum];

export type EmailNotConfiguredForInvitationErrorDto = {
    /**
     * @type string
    */
    code: EmailNotConfiguredForInvitationErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EmailNotConfiguredForInvitationDetailsDto;
};

export type NoSubjectDefinedForEntityDetailsDto = {
    /**
     * @type string
    */
    entity: string;
};

export const noSubjectDefinedForEntityErrorDtoCodeEnum = {
    NO_SUBJECT_DEFINED_FOR_ENTITY: "NO_SUBJECT_DEFINED_FOR_ENTITY"
} as const;

export type NoSubjectDefinedForEntityErrorDtoCodeEnumKey = (typeof noSubjectDefinedForEntityErrorDtoCodeEnum)[keyof typeof noSubjectDefinedForEntityErrorDtoCodeEnum];

export type NoSubjectDefinedForEntityErrorDto = {
    /**
     * @type string
    */
    code: NoSubjectDefinedForEntityErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoSubjectDefinedForEntityDetailsDto;
};

export type InvalidEventTypeForHandlerLegacyDetailsDto = {
    /**
     * @type string
    */
    eventType: string;
    /**
     * @type string
    */
    handlerName: string;
};

export const invalidEventTypeForHandlerLegacyErrorDtoCodeEnum = {
    INVALID_EVENT_TYPE_FOR_HANDLER_LEGACY: "INVALID_EVENT_TYPE_FOR_HANDLER_LEGACY"
} as const;

export type InvalidEventTypeForHandlerLegacyErrorDtoCodeEnumKey = (typeof invalidEventTypeForHandlerLegacyErrorDtoCodeEnum)[keyof typeof invalidEventTypeForHandlerLegacyErrorDtoCodeEnum];

export type InvalidEventTypeForHandlerLegacyErrorDto = {
    /**
     * @type string
    */
    code: InvalidEventTypeForHandlerLegacyErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidEventTypeForHandlerLegacyDetailsDto;
};

export type CannotHandleMultiplePoliciesDetailsDto = object;

export const cannotHandleMultiplePoliciesErrorDtoCodeEnum = {
    CANNOT_HANDLE_MULTIPLE_POLICIES: "CANNOT_HANDLE_MULTIPLE_POLICIES"
} as const;

export type CannotHandleMultiplePoliciesErrorDtoCodeEnumKey = (typeof cannotHandleMultiplePoliciesErrorDtoCodeEnum)[keyof typeof cannotHandleMultiplePoliciesErrorDtoCodeEnum];

export type CannotHandleMultiplePoliciesErrorDto = {
    /**
     * @type string
    */
    code: CannotHandleMultiplePoliciesErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotHandleMultiplePoliciesDetailsDto;
};

export type CancellationConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    trigger: string;
};

export const cancellationConfigNotFoundErrorDtoCodeEnum = {
    CANCELLATION_CONFIG_NOT_FOUND: "CANCELLATION_CONFIG_NOT_FOUND"
} as const;

export type CancellationConfigNotFoundErrorDtoCodeEnumKey = (typeof cancellationConfigNotFoundErrorDtoCodeEnum)[keyof typeof cancellationConfigNotFoundErrorDtoCodeEnum];

export type CancellationConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: CancellationConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CancellationConfigNotFoundDetailsDto;
};

export type AppliedAtDateKeyNotFoundDetailsDto = {
    /**
     * @type string
    */
    stopReason: string;
    /**
     * @type string
    */
    productId: string;
};

export const appliedAtDateKeyNotFoundErrorDtoCodeEnum = {
    APPLIED_AT_DATE_KEY_NOT_FOUND: "APPLIED_AT_DATE_KEY_NOT_FOUND"
} as const;

export type AppliedAtDateKeyNotFoundErrorDtoCodeEnumKey = (typeof appliedAtDateKeyNotFoundErrorDtoCodeEnum)[keyof typeof appliedAtDateKeyNotFoundErrorDtoCodeEnum];

export type AppliedAtDateKeyNotFoundErrorDto = {
    /**
     * @type string
    */
    code: AppliedAtDateKeyNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AppliedAtDateKeyNotFoundDetailsDto;
};

export type InvalidDriverChosenDetailsDto = {
    /**
     * @type string
    */
    driverChosen: string;
    /**
     * @type string
    */
    productId: string;
};

export const invalidDriverChosenErrorDtoCodeEnum = {
    INVALID_DRIVER_CHOSEN: "INVALID_DRIVER_CHOSEN"
} as const;

export type InvalidDriverChosenErrorDtoCodeEnumKey = (typeof invalidDriverChosenErrorDtoCodeEnum)[keyof typeof invalidDriverChosenErrorDtoCodeEnum];

export type InvalidDriverChosenErrorDto = {
    /**
     * @type string
    */
    code: InvalidDriverChosenErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidDriverChosenDetailsDto;
};

export type SignatureMissesDocumentsDetailsDto = {
    /**
     * @type string
    */
    signatureRequestId: string;
    /**
     * @type array
    */
    missingDocuments: string[];
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    branchId: string;
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    whenAt: string;
};

export const signatureMissesDocumentsErrorDtoCodeEnum = {
    SIGNATURE_MISSES_DOCUMENTS: "SIGNATURE_MISSES_DOCUMENTS"
} as const;

export type SignatureMissesDocumentsErrorDtoCodeEnumKey = (typeof signatureMissesDocumentsErrorDtoCodeEnum)[keyof typeof signatureMissesDocumentsErrorDtoCodeEnum];

export type SignatureMissesDocumentsErrorDto = {
    /**
     * @type string
    */
    code: SignatureMissesDocumentsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: SignatureMissesDocumentsDetailsDto;
};

export type DeprecatedEndpointDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const deprecatedEndpointErrorDtoCodeEnum = {
    DEPRECATED_ENDPOINT: "DEPRECATED_ENDPOINT"
} as const;

export type DeprecatedEndpointErrorDtoCodeEnumKey = (typeof deprecatedEndpointErrorDtoCodeEnum)[keyof typeof deprecatedEndpointErrorDtoCodeEnum];

export type DeprecatedEndpointErrorDto = {
    /**
     * @type string
    */
    code: DeprecatedEndpointErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DeprecatedEndpointDetailsDto;
};

export type BillingAssignmentCustomerNotFoundDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
};

export const billingAssignmentCustomerNotFoundErrorDtoCodeEnum = {
    BILLING_ASSIGNMENT_CUSTOMER_NOT_FOUND: "BILLING_ASSIGNMENT_CUSTOMER_NOT_FOUND"
} as const;

export type BillingAssignmentCustomerNotFoundErrorDtoCodeEnumKey = (typeof billingAssignmentCustomerNotFoundErrorDtoCodeEnum)[keyof typeof billingAssignmentCustomerNotFoundErrorDtoCodeEnum];

export type BillingAssignmentCustomerNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BillingAssignmentCustomerNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BillingAssignmentCustomerNotFoundDetailsDto;
};

export type BillingAssignmentRoleNotFoundDetailsDto = {
    /**
     * @type string
    */
    role: string;
    /**
     * @type array
    */
    foundRoles: string[];
    /**
     * @type array
    */
    customerIds: string[];
};

export const billingAssignmentRoleNotFoundErrorDtoCodeEnum = {
    BILLING_ASSIGNMENT_ROLE_NOT_FOUND: "BILLING_ASSIGNMENT_ROLE_NOT_FOUND"
} as const;

export type BillingAssignmentRoleNotFoundErrorDtoCodeEnumKey = (typeof billingAssignmentRoleNotFoundErrorDtoCodeEnum)[keyof typeof billingAssignmentRoleNotFoundErrorDtoCodeEnum];

export type BillingAssignmentRoleNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BillingAssignmentRoleNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BillingAssignmentRoleNotFoundDetailsDto;
};

export type BillingAssignmentDuplicateRoleDetailsDto = {
    /**
     * @type string
    */
    role: string;
    /**
     * @type string
    */
    existingCustomerId: string;
    /**
     * @type string
    */
    duplicateCustomerId: string;
};

export const billingAssignmentDuplicateRoleErrorDtoCodeEnum = {
    BILLING_ASSIGNMENT_DUPLICATE_ROLE: "BILLING_ASSIGNMENT_DUPLICATE_ROLE"
} as const;

export type BillingAssignmentDuplicateRoleErrorDtoCodeEnumKey = (typeof billingAssignmentDuplicateRoleErrorDtoCodeEnum)[keyof typeof billingAssignmentDuplicateRoleErrorDtoCodeEnum];

export type BillingAssignmentDuplicateRoleErrorDto = {
    /**
     * @type string
    */
    code: BillingAssignmentDuplicateRoleErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BillingAssignmentDuplicateRoleDetailsDto;
};

export type BillingAssignmentConfigNotFoundDetailsDto = {
    /**
     * @type string
    */
    configId: string;
};

export const billingAssignmentConfigNotFoundErrorDtoCodeEnum = {
    BILLING_ASSIGNMENT_CONFIG_NOT_FOUND: "BILLING_ASSIGNMENT_CONFIG_NOT_FOUND"
} as const;

export type BillingAssignmentConfigNotFoundErrorDtoCodeEnumKey = (typeof billingAssignmentConfigNotFoundErrorDtoCodeEnum)[keyof typeof billingAssignmentConfigNotFoundErrorDtoCodeEnum];

export type BillingAssignmentConfigNotFoundErrorDto = {
    /**
     * @type string
    */
    code: BillingAssignmentConfigNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BillingAssignmentConfigNotFoundDetailsDto;
};

export type InvalidTargetIdForTargetDetailsDto = {
    /**
     * @type string
    */
    targetId: string;
    /**
     * @type string
    */
    target: string;
    /**
     * @type string
    */
    expectedEntity: string;
};

export const invalidTargetIdForTargetErrorDtoCodeEnum = {
    INVALID_TARGET_ID_FOR_TARGET: "INVALID_TARGET_ID_FOR_TARGET"
} as const;

export type InvalidTargetIdForTargetErrorDtoCodeEnumKey = (typeof invalidTargetIdForTargetErrorDtoCodeEnum)[keyof typeof invalidTargetIdForTargetErrorDtoCodeEnum];

export type InvalidTargetIdForTargetErrorDto = {
    /**
     * @type string
    */
    code: InvalidTargetIdForTargetErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidTargetIdForTargetDetailsDto;
};

export type EventTypeNotImplementedDetailsDto = {
    /**
     * @type string
    */
    eventType: string;
};

export const eventTypeNotImplementedErrorDtoCodeEnum = {
    EVENT_TYPE_NOT_IMPLEMENTED: "EVENT_TYPE_NOT_IMPLEMENTED"
} as const;

export type EventTypeNotImplementedErrorDtoCodeEnumKey = (typeof eventTypeNotImplementedErrorDtoCodeEnum)[keyof typeof eventTypeNotImplementedErrorDtoCodeEnum];

export type EventTypeNotImplementedErrorDto = {
    /**
     * @type string
    */
    code: EventTypeNotImplementedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: EventTypeNotImplementedDetailsDto;
};

export type NoTargetIdsForDocumentDetailsDto = {
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string
    */
    eventType: string;
    /**
     * @type string
    */
    target: string;
};

export const noTargetIdsForDocumentErrorDtoCodeEnum = {
    NO_TARGET_IDS_FOR_DOCUMENT: "NO_TARGET_IDS_FOR_DOCUMENT"
} as const;

export type NoTargetIdsForDocumentErrorDtoCodeEnumKey = (typeof noTargetIdsForDocumentErrorDtoCodeEnum)[keyof typeof noTargetIdsForDocumentErrorDtoCodeEnum];

export type NoTargetIdsForDocumentErrorDto = {
    /**
     * @type string
    */
    code: NoTargetIdsForDocumentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoTargetIdsForDocumentDetailsDto;
};

export type NoCoreObjectIdFoundDetailsDto = {
    /**
     * @type string
    */
    targetId: string;
};

export const noCoreObjectIdFoundErrorDtoCodeEnum = {
    NO_CORE_OBJECT_ID_FOUND: "NO_CORE_OBJECT_ID_FOUND"
} as const;

export type NoCoreObjectIdFoundErrorDtoCodeEnumKey = (typeof noCoreObjectIdFoundErrorDtoCodeEnum)[keyof typeof noCoreObjectIdFoundErrorDtoCodeEnum];

export type NoCoreObjectIdFoundErrorDto = {
    /**
     * @type string
    */
    code: NoCoreObjectIdFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: NoCoreObjectIdFoundDetailsDto;
};

export type MultipleOriginalDocumentsDetailsDto = object;

export const multipleOriginalDocumentsErrorDtoCodeEnum = {
    MULTIPLE_ORIGINAL_DOCUMENTS: "MULTIPLE_ORIGINAL_DOCUMENTS"
} as const;

export type MultipleOriginalDocumentsErrorDtoCodeEnumKey = (typeof multipleOriginalDocumentsErrorDtoCodeEnum)[keyof typeof multipleOriginalDocumentsErrorDtoCodeEnum];

export type MultipleOriginalDocumentsErrorDto = {
    /**
     * @type string
    */
    code: MultipleOriginalDocumentsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MultipleOriginalDocumentsDetailsDto;
};

export type OnlyIndividualPoliciesSupportedDetailsDto = object;

export const onlyIndividualPoliciesSupportedErrorDtoCodeEnum = {
    ONLY_INDIVIDUAL_POLICIES_SUPPORTED: "ONLY_INDIVIDUAL_POLICIES_SUPPORTED"
} as const;

export type OnlyIndividualPoliciesSupportedErrorDtoCodeEnumKey = (typeof onlyIndividualPoliciesSupportedErrorDtoCodeEnum)[keyof typeof onlyIndividualPoliciesSupportedErrorDtoCodeEnum];

export type OnlyIndividualPoliciesSupportedErrorDto = {
    /**
     * @type string
    */
    code: OnlyIndividualPoliciesSupportedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: OnlyIndividualPoliciesSupportedDetailsDto;
};

export type FeatureOnlyImplementedForEntityDetailsDto = {
    /**
     * @type string
    */
    feature: string;
    /**
     * @type string
    */
    entity: string;
};

export const featureOnlyImplementedForEntityErrorDtoCodeEnum = {
    FEATURE_ONLY_IMPLEMENTED_FOR_ENTITY: "FEATURE_ONLY_IMPLEMENTED_FOR_ENTITY"
} as const;

export type FeatureOnlyImplementedForEntityErrorDtoCodeEnumKey = (typeof featureOnlyImplementedForEntityErrorDtoCodeEnum)[keyof typeof featureOnlyImplementedForEntityErrorDtoCodeEnum];

export type FeatureOnlyImplementedForEntityErrorDto = {
    /**
     * @type string
    */
    code: FeatureOnlyImplementedForEntityErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FeatureOnlyImplementedForEntityDetailsDto;
};

export type PropertyCannotBeSetOnIndividualPoliciesDetailsDto = {
    /**
     * @type string
    */
    property: string;
};

export const propertyCannotBeSetOnIndividualPoliciesErrorDtoCodeEnum = {
    PROPERTY_CANNOT_BE_SET_ON_INDIVIDUAL_POLICIES: "PROPERTY_CANNOT_BE_SET_ON_INDIVIDUAL_POLICIES"
} as const;

export type PropertyCannotBeSetOnIndividualPoliciesErrorDtoCodeEnumKey = (typeof propertyCannotBeSetOnIndividualPoliciesErrorDtoCodeEnum)[keyof typeof propertyCannotBeSetOnIndividualPoliciesErrorDtoCodeEnum];

export type PropertyCannotBeSetOnIndividualPoliciesErrorDto = {
    /**
     * @type string
    */
    code: PropertyCannotBeSetOnIndividualPoliciesErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: PropertyCannotBeSetOnIndividualPoliciesDetailsDto;
};

export type MissingPricingConfigDetailsDto = {
    /**
     * @type string
    */
    productId: string;
};

export const missingPricingConfigErrorDtoCodeEnum = {
    MISSING_PRICING_CONFIG: "MISSING_PRICING_CONFIG"
} as const;

export type MissingPricingConfigErrorDtoCodeEnumKey = (typeof missingPricingConfigErrorDtoCodeEnum)[keyof typeof missingPricingConfigErrorDtoCodeEnum];

export type MissingPricingConfigErrorDto = {
    /**
     * @type string
    */
    code: MissingPricingConfigErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingPricingConfigDetailsDto;
};

export type MissingDocumentGenerationProviderDetailsDto = {
    /**
     * @type string | undefined
    */
    documentConfigName?: string;
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @type string | undefined
    */
    format?: string;
};

export const missingDocumentGenerationProviderErrorDtoCodeEnum = {
    MISSING_DOCUMENT_GENERATION_PROVIDER: "MISSING_DOCUMENT_GENERATION_PROVIDER"
} as const;

export type MissingDocumentGenerationProviderErrorDtoCodeEnumKey = (typeof missingDocumentGenerationProviderErrorDtoCodeEnum)[keyof typeof missingDocumentGenerationProviderErrorDtoCodeEnum];

export type MissingDocumentGenerationProviderErrorDto = {
    /**
     * @type string
    */
    code: MissingDocumentGenerationProviderErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingDocumentGenerationProviderDetailsDto;
};

export type IncompleteGenerationPayloadDetailsDto = {
    /**
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    configName: string;
    /**
     * @type string
    */
    targetId: string;
};

export const incompleteGenerationPayloadErrorDtoCodeEnum = {
    INCOMPLETE_GENERATION_PAYLOAD: "INCOMPLETE_GENERATION_PAYLOAD"
} as const;

export type IncompleteGenerationPayloadErrorDtoCodeEnumKey = (typeof incompleteGenerationPayloadErrorDtoCodeEnum)[keyof typeof incompleteGenerationPayloadErrorDtoCodeEnum];

export type IncompleteGenerationPayloadErrorDto = {
    /**
     * @type string
    */
    code: IncompleteGenerationPayloadErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: IncompleteGenerationPayloadDetailsDto;
};

export type MissingAssetStartedAtDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
};

export const missingAssetStartedAtErrorDtoCodeEnum = {
    MISSING_ASSET_STARTED_AT: "MISSING_ASSET_STARTED_AT"
} as const;

export type MissingAssetStartedAtErrorDtoCodeEnumKey = (typeof missingAssetStartedAtErrorDtoCodeEnum)[keyof typeof missingAssetStartedAtErrorDtoCodeEnum];

export type MissingAssetStartedAtErrorDto = {
    /**
     * @type string
    */
    code: MissingAssetStartedAtErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingAssetStartedAtDetailsDto;
};

export type MissingOriginAssetIdDetailsDto = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingOriginAssetIdErrorDtoCodeEnum = {
    MISSING_ORIGIN_ASSET_ID: "MISSING_ORIGIN_ASSET_ID"
} as const;

export type MissingOriginAssetIdErrorDtoCodeEnumKey = (typeof missingOriginAssetIdErrorDtoCodeEnum)[keyof typeof missingOriginAssetIdErrorDtoCodeEnum];

export type MissingOriginAssetIdErrorDto = {
    /**
     * @type string
    */
    code: MissingOriginAssetIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingOriginAssetIdDetailsDto;
};

export type MissingQuoteOnAssetDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @type string | undefined
    */
    context?: string;
};

export const missingQuoteOnAssetErrorDtoCodeEnum = {
    MISSING_QUOTE_ON_ASSET: "MISSING_QUOTE_ON_ASSET"
} as const;

export type MissingQuoteOnAssetErrorDtoCodeEnumKey = (typeof missingQuoteOnAssetErrorDtoCodeEnum)[keyof typeof missingQuoteOnAssetErrorDtoCodeEnum];

export type MissingQuoteOnAssetErrorDto = {
    /**
     * @type string
    */
    code: MissingQuoteOnAssetErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: MissingQuoteOnAssetDetailsDto;
};

export type AssetCannotHaveBothStoppedAndCancelledDetailsDto = {
    /**
     * @type string
    */
    assetId: string;
};

export const assetCannotHaveBothStoppedAndCancelledErrorDtoCodeEnum = {
    ASSET_CANNOT_HAVE_BOTH_STOPPED_AND_CANCELLED: "ASSET_CANNOT_HAVE_BOTH_STOPPED_AND_CANCELLED"
} as const;

export type AssetCannotHaveBothStoppedAndCancelledErrorDtoCodeEnumKey = (typeof assetCannotHaveBothStoppedAndCancelledErrorDtoCodeEnum)[keyof typeof assetCannotHaveBothStoppedAndCancelledErrorDtoCodeEnum];

export type AssetCannotHaveBothStoppedAndCancelledErrorDto = {
    /**
     * @type string
    */
    code: AssetCannotHaveBothStoppedAndCancelledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AssetCannotHaveBothStoppedAndCancelledDetailsDto;
};

export type InvalidPremiumForComponentDetailsDto = {
    /**
     * @type string
    */
    componentType: string;
    /**
     * @type string
    */
    componentId: string;
    /**
     * @type object
    */
    validatedPremium: object;
    /**
     * @type object
    */
    receivedPremium: object;
};

export const invalidPremiumForComponentErrorDtoCodeEnum = {
    INVALID_PREMIUM_FOR_COMPONENT: "INVALID_PREMIUM_FOR_COMPONENT"
} as const;

export type InvalidPremiumForComponentErrorDtoCodeEnumKey = (typeof invalidPremiumForComponentErrorDtoCodeEnum)[keyof typeof invalidPremiumForComponentErrorDtoCodeEnum];

export type InvalidPremiumForComponentErrorDto = {
    /**
     * @type string
    */
    code: InvalidPremiumForComponentErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: InvalidPremiumForComponentDetailsDto;
};

export type CannotChargeNoBrokerageFirmIdDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
};

export const cannotChargeNoBrokerageFirmIdErrorDtoCodeEnum = {
    CANNOT_CHARGE_NO_BROKERAGE_FIRM_ID: "CANNOT_CHARGE_NO_BROKERAGE_FIRM_ID"
} as const;

export type CannotChargeNoBrokerageFirmIdErrorDtoCodeEnumKey = (typeof cannotChargeNoBrokerageFirmIdErrorDtoCodeEnum)[keyof typeof cannotChargeNoBrokerageFirmIdErrorDtoCodeEnum];

export type CannotChargeNoBrokerageFirmIdErrorDto = {
    /**
     * @type string
    */
    code: CannotChargeNoBrokerageFirmIdErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: CannotChargeNoBrokerageFirmIdDetailsDto;
};

export type UnableToFindUniqueCustomerForBrokerageFirmDetailsDto = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type number
    */
    foundCount: number;
};

export const unableToFindUniqueCustomerForBrokerageFirmErrorDtoCodeEnum = {
    UNABLE_TO_FIND_UNIQUE_CUSTOMER_FOR_BROKERAGE_FIRM: "UNABLE_TO_FIND_UNIQUE_CUSTOMER_FOR_BROKERAGE_FIRM"
} as const;

export type UnableToFindUniqueCustomerForBrokerageFirmErrorDtoCodeEnumKey = (typeof unableToFindUniqueCustomerForBrokerageFirmErrorDtoCodeEnum)[keyof typeof unableToFindUniqueCustomerForBrokerageFirmErrorDtoCodeEnum];

export type UnableToFindUniqueCustomerForBrokerageFirmErrorDto = {
    /**
     * @type string
    */
    code: UnableToFindUniqueCustomerForBrokerageFirmErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: UnableToFindUniqueCustomerForBrokerageFirmDetailsDto;
};

export type DocumentExtractionFailedDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const documentExtractionFailedErrorDtoCodeEnum = {
    DOCUMENT_EXTRACTION_FAILED: "DOCUMENT_EXTRACTION_FAILED"
} as const;

export type DocumentExtractionFailedErrorDtoCodeEnumKey = (typeof documentExtractionFailedErrorDtoCodeEnum)[keyof typeof documentExtractionFailedErrorDtoCodeEnum];

export type DocumentExtractionFailedErrorDto = {
    /**
     * @type string
    */
    code: DocumentExtractionFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentExtractionFailedDetailsDto;
};

export type ExtractionFeedbackFailedDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string | undefined
    */
    reason?: string;
};

export const extractionFeedbackFailedErrorDtoCodeEnum = {
    EXTRACTION_FEEDBACK_FAILED: "EXTRACTION_FEEDBACK_FAILED"
} as const;

export type ExtractionFeedbackFailedErrorDtoCodeEnumKey = (typeof extractionFeedbackFailedErrorDtoCodeEnum)[keyof typeof extractionFeedbackFailedErrorDtoCodeEnum];

export type ExtractionFeedbackFailedErrorDto = {
    /**
     * @type string
    */
    code: ExtractionFeedbackFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ExtractionFeedbackFailedDetailsDto;
};

export type AIProviderTimeoutDetailsDto = {
    /**
     * @type string
    */
    operation: string;
    /**
     * @type number
    */
    timeoutMs: number;
};

export const aiProviderTimeoutErrorDtoCodeEnum = {
    AI_PROVIDER_TIMEOUT: "AI_PROVIDER_TIMEOUT"
} as const;

export type AiProviderTimeoutErrorDtoCodeEnumKey = (typeof aiProviderTimeoutErrorDtoCodeEnum)[keyof typeof aiProviderTimeoutErrorDtoCodeEnum];

export type AiProviderTimeoutErrorDto = {
    /**
     * @type string
    */
    code: AiProviderTimeoutErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIProviderTimeoutDetailsDto;
};

export type AIProviderUnavailableDetailsDto = {
    /**
     * @type string
    */
    operation: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const aiProviderUnavailableErrorDtoCodeEnum = {
    AI_PROVIDER_UNAVAILABLE: "AI_PROVIDER_UNAVAILABLE"
} as const;

export type AiProviderUnavailableErrorDtoCodeEnumKey = (typeof aiProviderUnavailableErrorDtoCodeEnum)[keyof typeof aiProviderUnavailableErrorDtoCodeEnum];

export type AiProviderUnavailableErrorDto = {
    /**
     * @type string
    */
    code: AiProviderUnavailableErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIProviderUnavailableDetailsDto;
};

export type AIImageFetchErrorDetailsDto = {
    /**
     * @type string
    */
    imageUrl: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const aiImageFetchErrorErrorDtoCodeEnum = {
    AI_IMAGE_FETCH_ERROR: "AI_IMAGE_FETCH_ERROR"
} as const;

export type AiImageFetchErrorErrorDtoCodeEnumKey = (typeof aiImageFetchErrorErrorDtoCodeEnum)[keyof typeof aiImageFetchErrorErrorDtoCodeEnum];

export type AiImageFetchErrorErrorDto = {
    /**
     * @type string
    */
    code: AiImageFetchErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIImageFetchErrorDetailsDto;
};

export type AIResponseParseErrorDetailsDto = {
    /**
     * @type string
    */
    operation: string;
    /**
     * @type string
    */
    errorMessage: string;
    /**
     * @description Raw LLM response (truncated to 500 chars)
     * @type string
    */
    rawResponse: string;
};

export const aiResponseParseErrorErrorDtoCodeEnum = {
    AI_RESPONSE_PARSE_ERROR: "AI_RESPONSE_PARSE_ERROR"
} as const;

export type AiResponseParseErrorErrorDtoCodeEnumKey = (typeof aiResponseParseErrorErrorDtoCodeEnum)[keyof typeof aiResponseParseErrorErrorDtoCodeEnum];

export type AiResponseParseErrorErrorDto = {
    /**
     * @type string
    */
    code: AiResponseParseErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIResponseParseErrorDetailsDto;
};

export type AIPromptNotFoundDetailsDto = {
    /**
     * @type string
    */
    slug: string;
    /**
     * @type string
    */
    tag: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const aiPromptNotFoundErrorDtoCodeEnum = {
    AI_PROMPT_NOT_FOUND: "AI_PROMPT_NOT_FOUND"
} as const;

export type AiPromptNotFoundErrorDtoCodeEnumKey = (typeof aiPromptNotFoundErrorDtoCodeEnum)[keyof typeof aiPromptNotFoundErrorDtoCodeEnum];

export type AiPromptNotFoundErrorDto = {
    /**
     * @type string
    */
    code: AiPromptNotFoundErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIPromptNotFoundDetailsDto;
};

export type AIObservabilityErrorDetailsDto = {
    /**
     * @type string
    */
    operation: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const aiObservabilityErrorErrorDtoCodeEnum = {
    AI_OBSERVABILITY_ERROR: "AI_OBSERVABILITY_ERROR"
} as const;

export type AiObservabilityErrorErrorDtoCodeEnumKey = (typeof aiObservabilityErrorErrorDtoCodeEnum)[keyof typeof aiObservabilityErrorErrorDtoCodeEnum];

export type AiObservabilityErrorErrorDto = {
    /**
     * @type string
    */
    code: AiObservabilityErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIObservabilityErrorDetailsDto;
};

export type AIClassificationPreparationErrorDetailsDto = {
    /**
     * @type string
    */
    documentKey: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const aiClassificationPreparationErrorErrorDtoCodeEnum = {
    AI_CLASSIFICATION_PREPARATION_ERROR: "AI_CLASSIFICATION_PREPARATION_ERROR"
} as const;

export type AiClassificationPreparationErrorErrorDtoCodeEnumKey = (typeof aiClassificationPreparationErrorErrorDtoCodeEnum)[keyof typeof aiClassificationPreparationErrorErrorDtoCodeEnum];

export type AiClassificationPreparationErrorErrorDto = {
    /**
     * @type string
    */
    code: AiClassificationPreparationErrorErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIClassificationPreparationErrorDetailsDto;
};

export type AIDocumentTooLargeDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type number
    */
    fileSizeBytes: number;
    /**
     * @type number
    */
    maxSizeBytes: number;
    /**
     * @type string
    */
    mediaType: string;
};

export const aiDocumentTooLargeErrorDtoCodeEnum = {
    AI_DOCUMENT_TOO_LARGE: "AI_DOCUMENT_TOO_LARGE"
} as const;

export type AiDocumentTooLargeErrorDtoCodeEnumKey = (typeof aiDocumentTooLargeErrorDtoCodeEnum)[keyof typeof aiDocumentTooLargeErrorDtoCodeEnum];

export type AiDocumentTooLargeErrorDto = {
    /**
     * @type string
    */
    code: AiDocumentTooLargeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIDocumentTooLargeDetailsDto;
};

export type AIDocumentResolutionTooLargeDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type number
    */
    pixels: number;
    /**
     * @type number
    */
    maxPixels: number;
};

export const aiDocumentResolutionTooLargeErrorDtoCodeEnum = {
    AI_DOCUMENT_RESOLUTION_TOO_LARGE: "AI_DOCUMENT_RESOLUTION_TOO_LARGE"
} as const;

export type AiDocumentResolutionTooLargeErrorDtoCodeEnumKey = (typeof aiDocumentResolutionTooLargeErrorDtoCodeEnum)[keyof typeof aiDocumentResolutionTooLargeErrorDtoCodeEnum];

export type AiDocumentResolutionTooLargeErrorDto = {
    /**
     * @type string
    */
    code: AiDocumentResolutionTooLargeErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIDocumentResolutionTooLargeDetailsDto;
};

export type AIInputTooLongDetailsDto = {
    /**
     * @type string
    */
    operation: string;
    /**
     * @type string
    */
    errorMessage: string;
};

export const aiInputTooLongErrorDtoCodeEnum = {
    AI_INPUT_TOO_LONG: "AI_INPUT_TOO_LONG"
} as const;

export type AiInputTooLongErrorDtoCodeEnumKey = (typeof aiInputTooLongErrorDtoCodeEnum)[keyof typeof aiInputTooLongErrorDtoCodeEnum];

export type AiInputTooLongErrorDto = {
    /**
     * @type string
    */
    code: AiInputTooLongErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: AIInputTooLongDetailsDto;
};

export type FcbWhatsappTenantNotConfiguredDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const fcbWhatsappTenantNotConfiguredErrorDtoCodeEnum = {
    FCB_WHATSAPP_TENANT_NOT_CONFIGURED: "FCB_WHATSAPP_TENANT_NOT_CONFIGURED"
} as const;

export type FcbWhatsappTenantNotConfiguredErrorDtoCodeEnumKey = (typeof fcbWhatsappTenantNotConfiguredErrorDtoCodeEnum)[keyof typeof fcbWhatsappTenantNotConfiguredErrorDtoCodeEnum];

export type FcbWhatsappTenantNotConfiguredErrorDto = {
    /**
     * @type string
    */
    code: FcbWhatsappTenantNotConfiguredErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FcbWhatsappTenantNotConfiguredDetailsDto;
};

export type FcbUpstreamRejectedDetailsDto = {
    /**
     * @type number
    */
    upstreamStatus: number;
    /**
     * @type string
    */
    upstreamBody: string;
};

export const fcbUpstreamRejectedErrorDtoCodeEnum = {
    FCB_UPSTREAM_REJECTED: "FCB_UPSTREAM_REJECTED"
} as const;

export type FcbUpstreamRejectedErrorDtoCodeEnumKey = (typeof fcbUpstreamRejectedErrorDtoCodeEnum)[keyof typeof fcbUpstreamRejectedErrorDtoCodeEnum];

export type FcbUpstreamRejectedErrorDto = {
    /**
     * @type string
    */
    code: FcbUpstreamRejectedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FcbUpstreamRejectedDetailsDto;
};

export type FcbUpstreamUnreachableDetailsDto = {
    /**
     * @type string
    */
    reason: string;
};

export const fcbUpstreamUnreachableErrorDtoCodeEnum = {
    FCB_UPSTREAM_UNREACHABLE: "FCB_UPSTREAM_UNREACHABLE"
} as const;

export type FcbUpstreamUnreachableErrorDtoCodeEnumKey = (typeof fcbUpstreamUnreachableErrorDtoCodeEnum)[keyof typeof fcbUpstreamUnreachableErrorDtoCodeEnum];

export type FcbUpstreamUnreachableErrorDto = {
    /**
     * @type string
    */
    code: FcbUpstreamUnreachableErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: FcbUpstreamUnreachableDetailsDto;
};

export type ClaimManagementNotDraftDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string
    */
    currentStatus: string;
};

export const claimManagementNotDraftErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_NOT_DRAFT: "CLAIM_MANAGEMENT_NOT_DRAFT"
} as const;

export type ClaimManagementNotDraftErrorDtoCodeEnumKey = (typeof claimManagementNotDraftErrorDtoCodeEnum)[keyof typeof claimManagementNotDraftErrorDtoCodeEnum];

export type ClaimManagementNotDraftErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementNotDraftErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementNotDraftDetailsDto;
};

export type ClaimManagementAlreadyExistsDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
};

export const claimManagementAlreadyExistsErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_ALREADY_EXISTS: "CLAIM_MANAGEMENT_ALREADY_EXISTS"
} as const;

export type ClaimManagementAlreadyExistsErrorDtoCodeEnumKey = (typeof claimManagementAlreadyExistsErrorDtoCodeEnum)[keyof typeof claimManagementAlreadyExistsErrorDtoCodeEnum];

export type ClaimManagementAlreadyExistsErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementAlreadyExistsErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementAlreadyExistsDetailsDto;
};

export type ClaimManagementBrokerageFirmNotResolvedDetailsDto = {
    /**
     * @type string
    */
    claimId: string;
};

export const claimManagementBrokerageFirmNotResolvedErrorDtoCodeEnum = {
    CLAIM_MANAGEMENT_BROKERAGE_FIRM_NOT_RESOLVED: "CLAIM_MANAGEMENT_BROKERAGE_FIRM_NOT_RESOLVED"
} as const;

export type ClaimManagementBrokerageFirmNotResolvedErrorDtoCodeEnumKey = (typeof claimManagementBrokerageFirmNotResolvedErrorDtoCodeEnum)[keyof typeof claimManagementBrokerageFirmNotResolvedErrorDtoCodeEnum];

export type ClaimManagementBrokerageFirmNotResolvedErrorDto = {
    /**
     * @type string
    */
    code: ClaimManagementBrokerageFirmNotResolvedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ClaimManagementBrokerageFirmNotResolvedDetailsDto;
};

export type ExternalClaimConflictDetailsDto = {
    /**
     * @type string
    */
    externalClaimId: string;
};

export const externalClaimConflictErrorDtoCodeEnum = {
    EXTERNAL_CLAIM_CONFLICT: "EXTERNAL_CLAIM_CONFLICT"
} as const;

export type ExternalClaimConflictErrorDtoCodeEnumKey = (typeof externalClaimConflictErrorDtoCodeEnum)[keyof typeof externalClaimConflictErrorDtoCodeEnum];

export type ExternalClaimConflictErrorDto = {
    /**
     * @type string
    */
    code: ExternalClaimConflictErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: ExternalClaimConflictDetailsDto;
};

export type BatchItemFailureDto = {
    /**
     * @description Position of the failing item in the submitted array
     * @type number
    */
    index: number;
    /**
     * @description Id of the failing item when it already has one
     * @type string | undefined
    */
    id?: string;
    /**
     * @description Error code the item failed with
     * @type string
    */
    code: string;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object | undefined
    */
    details?: {
        [key: string]: any;
    };
};

export type BatchOperationFailedDetailsDto = {
    /**
     * @description Batch operation that was rejected, e.g. batchCreateAssets
     * @type string
    */
    operation: string;
    /**
     * @type number
    */
    itemCount: number;
    /**
     * @type number
    */
    failureCount: number;
    /**
     * @type array
    */
    failures: BatchItemFailureDto[];
};

export const batchOperationFailedErrorDtoCodeEnum = {
    BATCH_OPERATION_FAILED: "BATCH_OPERATION_FAILED"
} as const;

export type BatchOperationFailedErrorDtoCodeEnumKey = (typeof batchOperationFailedErrorDtoCodeEnum)[keyof typeof batchOperationFailedErrorDtoCodeEnum];

export type BatchOperationFailedErrorDto = {
    /**
     * @type string
    */
    code: BatchOperationFailedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: BatchOperationFailedDetailsDto;
};

export type VendorTimeoutDetailsDto = {
    /**
     * @type string
    */
    host: string;
};

export const vendorTimeoutErrorDtoCodeEnum = {
    VENDOR_TIMEOUT: "VENDOR_TIMEOUT"
} as const;

export type VendorTimeoutErrorDtoCodeEnumKey = (typeof vendorTimeoutErrorDtoCodeEnum)[keyof typeof vendorTimeoutErrorDtoCodeEnum];

export type VendorTimeoutErrorDto = {
    /**
     * @type string
    */
    code: VendorTimeoutErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: VendorTimeoutDetailsDto;
};

export type DocumentConformityNotEnabledDetailsDto = {
    /**
     * @type string
    */
    tenantId: string;
};

export const documentConformityNotEnabledErrorDtoCodeEnum = {
    DOCUMENT_CONFORMITY_NOT_ENABLED: "DOCUMENT_CONFORMITY_NOT_ENABLED"
} as const;

export type DocumentConformityNotEnabledErrorDtoCodeEnumKey = (typeof documentConformityNotEnabledErrorDtoCodeEnum)[keyof typeof documentConformityNotEnabledErrorDtoCodeEnum];

export type DocumentConformityNotEnabledErrorDto = {
    /**
     * @type string
    */
    code: DocumentConformityNotEnabledErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConformityNotEnabledDetailsDto;
};

export type DocumentConformityAlreadyClosedDetailsDto = {
    /**
     * @type string
    */
    conformityId: string;
    /**
     * @type string
    */
    status: string;
};

export const documentConformityAlreadyClosedErrorDtoCodeEnum = {
    DOCUMENT_CONFORMITY_ALREADY_CLOSED: "DOCUMENT_CONFORMITY_ALREADY_CLOSED"
} as const;

export type DocumentConformityAlreadyClosedErrorDtoCodeEnumKey = (typeof documentConformityAlreadyClosedErrorDtoCodeEnum)[keyof typeof documentConformityAlreadyClosedErrorDtoCodeEnum];

export type DocumentConformityAlreadyClosedErrorDto = {
    /**
     * @type string
    */
    code: DocumentConformityAlreadyClosedErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConformityAlreadyClosedDetailsDto;
};

export type DocumentConformityConcurrentDecisionDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
};

export const documentConformityConcurrentDecisionErrorDtoCodeEnum = {
    DOCUMENT_CONFORMITY_CONCURRENT_DECISION: "DOCUMENT_CONFORMITY_CONCURRENT_DECISION"
} as const;

export type DocumentConformityConcurrentDecisionErrorDtoCodeEnumKey = (typeof documentConformityConcurrentDecisionErrorDtoCodeEnum)[keyof typeof documentConformityConcurrentDecisionErrorDtoCodeEnum];

export type DocumentConformityConcurrentDecisionErrorDto = {
    /**
     * @type string
    */
    code: DocumentConformityConcurrentDecisionErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConformityConcurrentDecisionDetailsDto;
};

export type DocumentConformityUnresolvedCategoryDetailsDto = {
    /**
     * @type string
    */
    documentId: string;
    /**
     * @type string
    */
    category: string;
};

export const documentConformityUnresolvedCategoryErrorDtoCodeEnum = {
    DOCUMENT_CONFORMITY_UNRESOLVED_CATEGORY: "DOCUMENT_CONFORMITY_UNRESOLVED_CATEGORY"
} as const;

export type DocumentConformityUnresolvedCategoryErrorDtoCodeEnumKey = (typeof documentConformityUnresolvedCategoryErrorDtoCodeEnum)[keyof typeof documentConformityUnresolvedCategoryErrorDtoCodeEnum];

export type DocumentConformityUnresolvedCategoryErrorDto = {
    /**
     * @type string
    */
    code: DocumentConformityUnresolvedCategoryErrorDtoCodeEnumKey;
    /**
     * @type string
    */
    message: string;
    /**
     * @type object
    */
    details: DocumentConformityUnresolvedCategoryDetailsDto;
};

export type AppControllerIndex200 = any;

export type AppControllerIndexQueryResponse = AppControllerIndex200;

export type AppControllerIndexQuery = {
    Response: AppControllerIndex200;
    Errors: any;
};

export type AuthControllerCheckEmail201 = CheckEmailOutput;

export type AuthControllerCheckEmailMutationRequest = CheckEmailBody;

export type AuthControllerCheckEmailMutationResponse = AuthControllerCheckEmail201;

export type AuthControllerCheckEmailMutation = {
    Response: AuthControllerCheckEmail201;
    Request: AuthControllerCheckEmailMutationRequest;
    Errors: any;
};

export type AikanControllerGetAikanDocumentByIdQueryParams = {
    /**
     * @description the document ids to retrieve
     * @type array
    */
    ids: string[];
    /**
     * @description include deleted documents
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description force download disposition for signed URLs (attachment instead of inline)
     * @type boolean | undefined
    */
    forceDownload?: boolean;
};

export type AikanControllerGetAikanDocumentById200 = GetDocumentsOutput;

export type AikanControllerGetAikanDocumentByIdQueryResponse = AikanControllerGetAikanDocumentById200;

export type AikanControllerGetAikanDocumentByIdQuery = {
    Response: AikanControllerGetAikanDocumentById200;
    QueryParams: AikanControllerGetAikanDocumentByIdQueryParams;
    Errors: any;
};

export type AikanControllerGetAikanAssetsQueryParams = {
    /**
     * @type array
    */
    ids: string[];
};

export type AikanControllerGetAikanAssets200 = AikanBatchGetAssetsOutput;

export type AikanControllerGetAikanAssetsQueryResponse = AikanControllerGetAikanAssets200;

export type AikanControllerGetAikanAssetsQuery = {
    Response: AikanControllerGetAikanAssets200;
    QueryParams: AikanControllerGetAikanAssetsQueryParams;
    Errors: any;
};

export type AssetControllerBatchCreateAssetsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
    /**
     * @description Skip the product\'s relative `assetStartedAtLimit.min` so an E2E run can start a policy right away. Honored only for a test-mode asset outside production; ignored otherwise.
     * @type boolean | undefined
    */
    skipStartedAtRelativeMinimum?: boolean;
};

export type AssetControllerBatchCreateAssets201 = BatchCreateAssetOutput;

export type AssetControllerBatchCreateAssetsMutationRequest = BatchCreateAssetBody;

export type AssetControllerBatchCreateAssetsMutationResponse = AssetControllerBatchCreateAssets201;

export type AssetControllerBatchCreateAssetsMutation = {
    Response: AssetControllerBatchCreateAssets201;
    Request: AssetControllerBatchCreateAssetsMutationRequest;
    QueryParams: AssetControllerBatchCreateAssetsQueryParams;
    Errors: any;
};

export type AssetControllerBatchEditAssetsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Skip the product\'s relative `assetStartedAtLimit.min` so an E2E run can start a policy right away. Honored only for a test-mode asset outside production; ignored otherwise.
     * @type boolean | undefined
    */
    skipStartedAtRelativeMinimum?: boolean;
};

export type AssetControllerBatchEditAssets200 = BatchEditAssetOutput;

export type AssetControllerBatchEditAssetsMutationRequest = BatchEditAssetBody;

export type AssetControllerBatchEditAssetsMutationResponse = AssetControllerBatchEditAssets200;

export type AssetControllerBatchEditAssetsMutation = {
    Response: AssetControllerBatchEditAssets200;
    Request: AssetControllerBatchEditAssetsMutationRequest;
    QueryParams: AssetControllerBatchEditAssetsQueryParams;
    Errors: any;
};

export type AssetControllerBatchRemoveAssetsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
};

export type AssetControllerBatchRemoveAssets201 = BatchRemoveAssetOutput;

export type AssetControllerBatchRemoveAssetsMutationRequest = BatchRemoveAssetInputBody;

export type AssetControllerBatchRemoveAssetsMutationResponse = AssetControllerBatchRemoveAssets201;

export type AssetControllerBatchRemoveAssetsMutation = {
    Response: AssetControllerBatchRemoveAssets201;
    Request: AssetControllerBatchRemoveAssetsMutationRequest;
    QueryParams: AssetControllerBatchRemoveAssetsQueryParams;
    Errors: any;
};

export type AssetControllerCreateAssetQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
    /**
     * @description Skip the product\'s relative `assetStartedAtLimit.min` so an E2E run can start a policy right away. Honored only for a test-mode asset outside production; ignored otherwise.
     * @type boolean | undefined
    */
    skipStartedAtRelativeMinimum?: boolean;
};

export type AssetControllerCreateAsset201 = CreateAssetOutput;

export type AssetControllerCreateAsset400 = (InvalidCustomFieldsErrorDto | InvalidEventCreationDateErrorDto | InvalidProductErrorDto | InvalidAssetStartedAtErrorDto);

export type AssetControllerCreateAsset403 = ForbiddenErrorDto;

export type AssetControllerCreateAsset404 = PolicyNotFoundErrorDto;

export type AssetControllerCreateAsset409 = (ConflictingContractTypeErrorDto | ConflictingFieldDefinitionErrorDto | ConflictingPolicyStatusErrorDto);

export type AssetControllerCreateAssetMutationRequest = CreateAssetBody;

export type AssetControllerCreateAssetMutationResponse = AssetControllerCreateAsset201;

export type AssetControllerCreateAssetMutation = {
    Response: AssetControllerCreateAsset201;
    Request: AssetControllerCreateAssetMutationRequest;
    QueryParams: AssetControllerCreateAssetQueryParams;
    Errors: AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409;
};

export type AssetControllerReplaceAssetPathParams = {
    /**
     * @description originAssetId
     * @type string
    */
    originAssetId: string;
};

export type AssetControllerReplaceAssetQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
    /**
     * @description Skip the product\'s relative `assetStartedAtLimit.min` so an E2E run can start a policy right away. Honored only for a test-mode asset outside production; ignored otherwise.
     * @type boolean | undefined
    */
    skipStartedAtRelativeMinimum?: boolean;
};

export type AssetControllerReplaceAsset201 = ReplaceAssetOutput;

export type AssetControllerReplaceAsset400 = InvalidAssetStartedAtErrorDto;

export type AssetControllerReplaceAsset404 = BranchNotFoundErrorDto;

export type AssetControllerReplaceAsset409 = (ConflictingPolicyStatusErrorDto | ConflictingConfigErrorDto | MaxActiveAssetsReachedErrorDto | ConflictingBranchStatusErrorDto | ConflictingBranchTypeErrorDto | ConflictingAssetStatusErrorDto | ConflictingFieldDefinitionErrorDto);

export type AssetControllerReplaceAssetMutationRequest = ReplaceAssetBody;

export type AssetControllerReplaceAssetMutationResponse = AssetControllerReplaceAsset201;

export type AssetControllerReplaceAssetMutation = {
    Response: AssetControllerReplaceAsset201;
    Request: AssetControllerReplaceAssetMutationRequest;
    PathParams: AssetControllerReplaceAssetPathParams;
    QueryParams: AssetControllerReplaceAssetQueryParams;
    Errors: AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409;
};

export type AssetControllerEditAssetPathParams = {
    /**
     * @description assetId
     * @type string
    */
    assetId: string;
};

export type AssetControllerEditAssetQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Skip the product\'s relative `assetStartedAtLimit.min` so an E2E run can start a policy right away. Honored only for a test-mode asset outside production; ignored otherwise.
     * @type boolean | undefined
    */
    skipStartedAtRelativeMinimum?: boolean;
};

export type AssetControllerEditAsset200 = EditAssetOutput;

export type AssetControllerEditAsset400 = (InvalidCustomFieldsErrorDto | InvalidEventCreationDateErrorDto | InvalidProductErrorDto);

export type AssetControllerEditAsset403 = ForbiddenErrorDto;

export type AssetControllerEditAsset404 = AssetNotFoundErrorDto;

export type AssetControllerEditAsset409 = (ConflictingFieldDefinitionErrorDto | ConflictingBranchTypeErrorDto | ConflictingAssetStatusErrorDto | ConflictingBranchStatusErrorDto | FieldsDoNotMeetRequirementsErrorDto);

export type AssetControllerEditAssetMutationRequest = EditAssetBody;

export type AssetControllerEditAssetMutationResponse = AssetControllerEditAsset200;

export type AssetControllerEditAssetMutation = {
    Response: AssetControllerEditAsset200;
    Request: AssetControllerEditAssetMutationRequest;
    PathParams: AssetControllerEditAssetPathParams;
    QueryParams: AssetControllerEditAssetQueryParams;
    Errors: AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409;
};

export type AssetControllerGetAssetPathParams = {
    /**
     * @description assetId
     * @type string
    */
    assetId: string;
};

export type AssetControllerGetAssetQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type AssetControllerGetAsset200 = AssetDto;

export type AssetControllerGetAsset403 = ForbiddenErrorDto;

export type AssetControllerGetAsset404 = AssetNotFoundErrorDto;

export type AssetControllerGetAssetQueryResponse = AssetControllerGetAsset200;

export type AssetControllerGetAssetQuery = {
    Response: AssetControllerGetAsset200;
    PathParams: AssetControllerGetAssetPathParams;
    QueryParams: AssetControllerGetAssetQueryParams;
    Errors: AssetControllerGetAsset403 | AssetControllerGetAsset404;
};

export type AssetControllerRemoveAssetPathParams = {
    /**
     * @description assetId
     * @type string
    */
    assetId: string;
};

export type AssetControllerRemoveAssetQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
};

export type AssetControllerRemoveAsset200 = RemoveAssetOutput;

export type AssetControllerRemoveAsset400 = InvalidEventCreationDateErrorDto;

export type AssetControllerRemoveAsset403 = ForbiddenErrorDto;

export type AssetControllerRemoveAsset404 = AssetNotFoundErrorDto;

export type AssetControllerRemoveAsset409 = (AssetNotCreatedOnThisBranchErrorDto | ConflictingAssetStatusErrorDto | ConflictingPolicyStatusErrorDto | ConflictingBranchStatusErrorDto);

export type AssetControllerRemoveAssetMutationResponse = AssetControllerRemoveAsset200;

export type AssetControllerRemoveAssetMutation = {
    Response: AssetControllerRemoveAsset200;
    PathParams: AssetControllerRemoveAssetPathParams;
    QueryParams: AssetControllerRemoveAssetQueryParams;
    Errors: AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409;
};

export type AssetControllerPushAssetEventPathParams = {
    /**
     * @description the asset id
     * @type string
    */
    assetId: string;
};

export type AssetControllerPushAssetEventQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
};

export type AssetControllerPushAssetEvent201 = PushAssetEventOutput;

export type AssetControllerPushAssetEvent400 = InvalidEventTypeErrorDto;

export type AssetControllerPushAssetEvent404 = AssetNotFoundErrorDto;

export type AssetControllerPushAssetEventMutationRequest = PushAssetEventInputBody;

export type AssetControllerPushAssetEventMutationResponse = AssetControllerPushAssetEvent201;

export type AssetControllerPushAssetEventMutation = {
    Response: AssetControllerPushAssetEvent201;
    Request: AssetControllerPushAssetEventMutationRequest;
    PathParams: AssetControllerPushAssetEventPathParams;
    QueryParams: AssetControllerPushAssetEventQueryParams;
    Errors: AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404;
};

export type AssetControllerGetAssetExternalQuotePathParams = {
    /**
     * @description assetId
     * @type string
    */
    assetId: string;
};

export type AssetControllerGetAssetExternalQuoteQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type AssetControllerGetAssetExternalQuote200 = GetAssetExternalQuoteOutput;

export type AssetControllerGetAssetExternalQuote404 = (ExternalQuoteNotFoundErrorDto | AssetNotFoundErrorDto | QuoteNotFoundErrorDto);

export type AssetControllerGetAssetExternalQuoteQueryResponse = AssetControllerGetAssetExternalQuote200;

export type AssetControllerGetAssetExternalQuoteQuery = {
    Response: AssetControllerGetAssetExternalQuote200;
    PathParams: AssetControllerGetAssetExternalQuotePathParams;
    QueryParams: AssetControllerGetAssetExternalQuoteQueryParams;
    Errors: AssetControllerGetAssetExternalQuote404;
};

export type BillingControllerGetInvoicesQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the invoice ids to retrieve
     * @type array
    */
    ids: string[];
};

export type BillingControllerGetInvoices200 = GetInvoicesOutput;

export type BillingControllerGetInvoicesQueryResponse = BillingControllerGetInvoices200;

export type BillingControllerGetInvoicesQuery = {
    Response: BillingControllerGetInvoices200;
    QueryParams: BillingControllerGetInvoicesQueryParams;
    Errors: any;
};

export type BillingControllerListInvoiceEventsPathParams = {
    /**
     * @description the invoice id
     * @type string
    */
    invoiceId: string;
};

export type BillingControllerListInvoiceEvents200 = ListInvoiceEventsOutput;

export type BillingControllerListInvoiceEvents404 = InvoiceNotFoundErrorDto;

export type BillingControllerListInvoiceEventsQueryResponse = BillingControllerListInvoiceEvents200;

export type BillingControllerListInvoiceEventsQuery = {
    Response: BillingControllerListInvoiceEvents200;
    PathParams: BillingControllerListInvoiceEventsPathParams;
    Errors: BillingControllerListInvoiceEvents404;
};

export type BillingControllerListInvoices201 = ListInvoicesOutput;

/**
 * @description Filter payload for listing invoices by metadata and attributes. All fields are optional.
*/
export type BillingControllerListInvoicesMutationRequest = ListInvoicesInputBody;

export type BillingControllerListInvoicesMutationResponse = BillingControllerListInvoices201;

export type BillingControllerListInvoicesMutation = {
    Response: BillingControllerListInvoices201;
    Request: BillingControllerListInvoicesMutationRequest;
    Errors: any;
};

export type BillingControllerCreateManualInvoice201 = CreateManualInvoiceOutputDto;

export type BillingControllerCreateManualInvoiceMutationRequest = CreateManualInvoiceInputBody;

export type BillingControllerCreateManualInvoiceMutationResponse = BillingControllerCreateManualInvoice201;

export type BillingControllerCreateManualInvoiceMutation = {
    Response: BillingControllerCreateManualInvoice201;
    Request: BillingControllerCreateManualInvoiceMutationRequest;
    Errors: any;
};

export type BillingControllerSetInvoiceCleanup201 = SetInvoiceCleanupOutputDto;

export type BillingControllerSetInvoiceCleanupMutationRequest = SetInvoiceCleanupInputBody;

export type BillingControllerSetInvoiceCleanupMutationResponse = BillingControllerSetInvoiceCleanup201;

export type BillingControllerSetInvoiceCleanupMutation = {
    Response: BillingControllerSetInvoiceCleanup201;
    Request: BillingControllerSetInvoiceCleanupMutationRequest;
    Errors: any;
};

export type BillingControllerIssueInvoices201 = IssueInvoicesOutput;

export type BillingControllerIssueInvoicesMutationRequest = IssueInvoicesInputBody;

export type BillingControllerIssueInvoicesMutationResponse = BillingControllerIssueInvoices201;

export type BillingControllerIssueInvoicesMutation = {
    Response: BillingControllerIssueInvoices201;
    Request: BillingControllerIssueInvoicesMutationRequest;
    Errors: any;
};

export type BillingControllerDeleteInvoices201 = DeleteInvoicesOutput;

export type BillingControllerDeleteInvoicesMutationRequest = DeleteInvoicesInputQueryParams;

export type BillingControllerDeleteInvoicesMutationResponse = BillingControllerDeleteInvoices201;

export type BillingControllerDeleteInvoicesMutation = {
    Response: BillingControllerDeleteInvoices201;
    Request: BillingControllerDeleteInvoicesMutationRequest;
    Errors: any;
};

export type BranchControllerEditBranchPathParams = {
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branchId: string;
};

export type BranchControllerEditBranch200 = EditBranchOutput;

export type BranchControllerEditBranch400 = RequestValidationFailedErrorDto;

export type BranchControllerEditBranch404 = BranchNotFoundErrorDto;

export type BranchControllerEditBranch409 = (ConflictingBranchStatusErrorDto | ConflictingBranchTypeErrorDto);

export type BranchControllerEditBranchMutationRequest = EditBranchInputBody;

export type BranchControllerEditBranchMutationResponse = BranchControllerEditBranch200;

export type BranchControllerEditBranchMutation = {
    Response: BranchControllerEditBranch200;
    Request: BranchControllerEditBranchMutationRequest;
    PathParams: BranchControllerEditBranchPathParams;
    Errors: BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409;
};

export type BranchControllerCreateBranchPathParams = {
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    policyId: string;
};

export type BranchControllerCreateBranchQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type BranchControllerCreateBranch201 = CreateBranchOutput;

export type BranchControllerCreateBranch400 = (InvalidBranchTypeErrorDto | InvalidProductErrorDto | InvalidEventCreationDateErrorDto);

export type BranchControllerCreateBranch404 = PolicyNotFoundErrorDto;

export type BranchControllerCreateBranch409 = (ConflictingConfigErrorDto | ConflictingPolicyStatusErrorDto | MaxBranchTypeOpenedErrorDto);

export type BranchControllerCreateBranchMutationRequest = CreateBranchInputBody;

export type BranchControllerCreateBranchMutationResponse = BranchControllerCreateBranch201;

export type BranchControllerCreateBranchMutation = {
    Response: BranchControllerCreateBranch201;
    Request: BranchControllerCreateBranchMutationRequest;
    PathParams: BranchControllerCreateBranchPathParams;
    QueryParams: BranchControllerCreateBranchQueryParams;
    Errors: BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409;
};

export type PolicyControllerListBranchesPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export const policyControllerListBranchesQueryParamsBranchTypeEnum = {
    BASE: "BASE",
    NEW_BUSINESS: "NEW_BUSINESS",
    MTA: "MTA",
    RENEWAL: "RENEWAL",
    REPRICING: "REPRICING",
    STOP: "STOP"
} as const;

export type PolicyControllerListBranchesQueryParamsBranchTypeEnumKey = (typeof policyControllerListBranchesQueryParamsBranchTypeEnum)[keyof typeof policyControllerListBranchesQueryParamsBranchTypeEnum];

export const policyControllerListBranchesQueryParamsBranchStatusEnum = {
    BRANCH_OPEN: "BRANCH_OPEN",
    BRANCH_MERGED: "BRANCH_MERGED",
    BRANCH_CLOSED: "BRANCH_CLOSED"
} as const;

export type PolicyControllerListBranchesQueryParamsBranchStatusEnumKey = (typeof policyControllerListBranchesQueryParamsBranchStatusEnum)[keyof typeof policyControllerListBranchesQueryParamsBranchStatusEnum];

export type PolicyControllerListBranchesQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description the branch type
     * @type string | undefined
    */
    branchType?: PolicyControllerListBranchesQueryParamsBranchTypeEnumKey;
    /**
     * @description the branch status
     * @type string | undefined
    */
    branchStatus?: PolicyControllerListBranchesQueryParamsBranchStatusEnumKey;
};

export type PolicyControllerListBranches200 = ListBranchesOutput;

export type PolicyControllerListBranches403 = ForbiddenErrorDto;

export type PolicyControllerListBranches404 = PolicyNotFoundErrorDto;

export type PolicyControllerListBranchesQueryResponse = PolicyControllerListBranches200;

export type PolicyControllerListBranchesQuery = {
    Response: PolicyControllerListBranches200;
    PathParams: PolicyControllerListBranchesPathParams;
    QueryParams: PolicyControllerListBranchesQueryParams;
    Errors: PolicyControllerListBranches403 | PolicyControllerListBranches404;
};

export type BranchControllerGetBranchEffectiveDatePathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branchId: string;
};

export type BranchControllerGetBranchEffectiveDateQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type BranchControllerGetBranchEffectiveDate200 = GetBranchEffectiveDateOutput;

export type BranchControllerGetBranchEffectiveDateQueryResponse = BranchControllerGetBranchEffectiveDate200;

export type BranchControllerGetBranchEffectiveDateQuery = {
    Response: BranchControllerGetBranchEffectiveDate200;
    PathParams: BranchControllerGetBranchEffectiveDatePathParams;
    QueryParams: BranchControllerGetBranchEffectiveDateQueryParams;
    Errors: any;
};

export type BranchControllerForkBranchPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branchId: string;
};

export type BranchControllerForkBranchQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type BranchControllerForkBranch201 = ForkBranchOutput;

export type BranchControllerForkBranch400 = (InvalidEventCreationDateErrorDto | InvalidEventCreationDateErrorDto);

export type BranchControllerForkBranch404 = (PolicyNotFoundErrorDto | BranchNotFoundErrorDto);

export type BranchControllerForkBranch409 = (ConflictingConfigErrorDto | ConflictingBranchTypeErrorDto | ConflictingPolicyStatusErrorDto);

export type BranchControllerForkBranchMutationRequest = ForkBranchInputBody;

export type BranchControllerForkBranchMutationResponse = BranchControllerForkBranch201;

export type BranchControllerForkBranchMutation = {
    Response: BranchControllerForkBranch201;
    Request: BranchControllerForkBranchMutationRequest;
    PathParams: BranchControllerForkBranchPathParams;
    QueryParams: BranchControllerForkBranchQueryParams;
    Errors: BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409;
};

export type BranchControllerForkBranchWithoutPolicyPathParams = {
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branchId: string;
};

export type BranchControllerForkBranchWithoutPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type BranchControllerForkBranchWithoutPolicy201 = ForkBranchOutput;

export type BranchControllerForkBranchWithoutPolicy400 = (InvalidEventCreationDateErrorDto | InvalidEventCreationDateErrorDto);

export type BranchControllerForkBranchWithoutPolicy404 = (PolicyNotFoundErrorDto | BranchNotFoundErrorDto);

export type BranchControllerForkBranchWithoutPolicy409 = (ConflictingConfigErrorDto | ConflictingBranchTypeErrorDto | ConflictingPolicyStatusErrorDto);

export type BranchControllerForkBranchWithoutPolicyMutationRequest = ForkBranchInputBody;

export type BranchControllerForkBranchWithoutPolicyMutationResponse = BranchControllerForkBranchWithoutPolicy201;

export type BranchControllerForkBranchWithoutPolicyMutation = {
    Response: BranchControllerForkBranchWithoutPolicy201;
    Request: BranchControllerForkBranchWithoutPolicyMutationRequest;
    PathParams: BranchControllerForkBranchWithoutPolicyPathParams;
    QueryParams: BranchControllerForkBranchWithoutPolicyQueryParams;
    Errors: BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409;
};

export type BranchControllerInvalidateBranchPathParams = {
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    policyId: string;
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branchId: string;
};

export type BranchControllerInvalidateBranchQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type BranchControllerInvalidateBranch201 = InvalidateBranchOutput;

export type BranchControllerInvalidateBranch403 = ForbiddenErrorDto;

export type BranchControllerInvalidateBranch404 = PolicyNotFoundErrorDto;

export type BranchControllerInvalidateBranch409 = ConflictingBranchStatusErrorDto;

export type BranchControllerInvalidateBranchMutationRequest = InvalidateBranchInputBody;

export type BranchControllerInvalidateBranchMutationResponse = BranchControllerInvalidateBranch201;

export type BranchControllerInvalidateBranchMutation = {
    Response: BranchControllerInvalidateBranch201;
    Request: BranchControllerInvalidateBranchMutationRequest;
    PathParams: BranchControllerInvalidateBranchPathParams;
    QueryParams: BranchControllerInvalidateBranchQueryParams;
    Errors: BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409;
};

/**
 * @description Brokerage context for the current user or empty when the user has no brokerage firm.
*/
export type BrokerControllerAtMe200 = BrokerAtMeOutput;

export type BrokerControllerAtMeQueryResponse = BrokerControllerAtMe200;

export type BrokerControllerAtMeQuery = {
    Response: BrokerControllerAtMe200;
    Errors: any;
};

export type BrokerControllerCreateBrokerPathParams = {
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Broker created successfully.
*/
export type BrokerControllerCreateBroker201 = CreateBrokerOutput;

export type BrokerControllerCreateBroker404 = (UserNotFoundErrorDto | BrokerageFirmNotFoundErrorDto);

/**
 * @description Broker payload including the target user id and optional profile/role fields
*/
export type BrokerControllerCreateBrokerMutationRequest = CreateBrokerInputBody;

export type BrokerControllerCreateBrokerMutationResponse = BrokerControllerCreateBroker201;

export type BrokerControllerCreateBrokerMutation = {
    Response: BrokerControllerCreateBroker201;
    Request: BrokerControllerCreateBrokerMutationRequest;
    PathParams: BrokerControllerCreateBrokerPathParams;
    Errors: BrokerControllerCreateBroker404;
};

export type BrokerControllerListBrokersPathParams = {
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerControllerListBrokersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

/**
 * @description Paginated list of brokers.
*/
export type BrokerControllerListBrokers200 = ListBrokersOutput;

export type BrokerControllerListBrokers404 = BrokerageFirmNotFoundErrorDto;

export type BrokerControllerListBrokersQueryResponse = BrokerControllerListBrokers200;

export type BrokerControllerListBrokersQuery = {
    Response: BrokerControllerListBrokers200;
    PathParams: BrokerControllerListBrokersPathParams;
    QueryParams: BrokerControllerListBrokersQueryParams;
    Errors: BrokerControllerListBrokers404;
};

export type BrokerControllerUpdateBrokerPathParams = {
    /**
     * @description Broker user id
     * @type string
    */
    brokerUserId: string;
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Broker updated successfully.
*/
export type BrokerControllerUpdateBroker200 = UpdateBrokerOutput;

export type BrokerControllerUpdateBroker404 = (UserNotFoundErrorDto | BrokerageFirmNotFoundErrorDto);

/**
 * @description Fields to update for the broker
*/
export type BrokerControllerUpdateBrokerMutationRequest = UpdateBrokerInputBody;

export type BrokerControllerUpdateBrokerMutationResponse = BrokerControllerUpdateBroker200;

export type BrokerControllerUpdateBrokerMutation = {
    Response: BrokerControllerUpdateBroker200;
    Request: BrokerControllerUpdateBrokerMutationRequest;
    PathParams: BrokerControllerUpdateBrokerPathParams;
    Errors: BrokerControllerUpdateBroker404;
};

export type BrokerControllerDeleteBrokerPathParams = {
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description Broker user id
     * @type string
    */
    brokerUserId: string;
};

/**
 * @description Broker deleted successfully.
*/
export type BrokerControllerDeleteBroker200 = DeleteBrokerOutput;

export type BrokerControllerDeleteBroker404 = UserNotFoundErrorDto;

export type BrokerControllerDeleteBrokerMutationResponse = BrokerControllerDeleteBroker200;

export type BrokerControllerDeleteBrokerMutation = {
    Response: BrokerControllerDeleteBroker200;
    PathParams: BrokerControllerDeleteBrokerPathParams;
    Errors: BrokerControllerDeleteBroker404;
};

export type BrokerControllerListDescendantBrokersPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerControllerListDescendantBrokersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    queryString?: string;
};

export type BrokerControllerListDescendantBrokers200 = ListDescendantBrokersOutput;

export type BrokerControllerListDescendantBrokers404 = BrokerageFirmNotFoundErrorDto;

export type BrokerControllerListDescendantBrokersQueryResponse = BrokerControllerListDescendantBrokers200;

export type BrokerControllerListDescendantBrokersQuery = {
    Response: BrokerControllerListDescendantBrokers200;
    PathParams: BrokerControllerListDescendantBrokersPathParams;
    QueryParams: BrokerControllerListDescendantBrokersQueryParams;
    Errors: BrokerControllerListDescendantBrokers404;
};

export type BrokerControllerGetBrokerPathParams = {
    /**
     * @description Broker user id
     * @type string
    */
    brokerUserId: string;
};

/**
 * @description Broker retrieved successfully.
*/
export type BrokerControllerGetBroker200 = GetBrokerOutput;

export type BrokerControllerGetBroker404 = BrokerNotFoundErrorDto;

export type BrokerControllerGetBrokerQueryResponse = BrokerControllerGetBroker200;

export type BrokerControllerGetBrokerQuery = {
    Response: BrokerControllerGetBroker200;
    PathParams: BrokerControllerGetBrokerPathParams;
    Errors: BrokerControllerGetBroker404;
};

export type EmailAccountControllerListMine200 = ListMyEmailAccountsOutput;

export type EmailAccountControllerListMineQueryResponse = EmailAccountControllerListMine200;

export type EmailAccountControllerListMineQuery = {
    Response: EmailAccountControllerListMine200;
    Errors: any;
};

export type EmailAccountControllerConnect200 = InitiateEmailAccountConnectionOutput;

export type EmailAccountControllerConnectMutationRequest = ConnectEmailAccountBody;

export type EmailAccountControllerConnectMutationResponse = EmailAccountControllerConnect200;

export type EmailAccountControllerConnectMutation = {
    Response: EmailAccountControllerConnect200;
    Request: EmailAccountControllerConnectMutationRequest;
    Errors: any;
};

export type EmailAccountControllerReconnectPathParams = {
    /**
     * @type string
    */
    emailAccountId: string;
};

export type EmailAccountControllerReconnect200 = InitiateEmailAccountConnectionOutput;

export type EmailAccountControllerReconnectMutationRequest = ReconnectEmailAccountBody;

export type EmailAccountControllerReconnectMutationResponse = EmailAccountControllerReconnect200;

export type EmailAccountControllerReconnectMutation = {
    Response: EmailAccountControllerReconnect200;
    Request: EmailAccountControllerReconnectMutationRequest;
    PathParams: EmailAccountControllerReconnectPathParams;
    Errors: any;
};

export type EmailAccountControllerDisconnectPathParams = {
    /**
     * @type string
    */
    emailAccountId: string;
};

export type EmailAccountControllerDisconnect200 = DisconnectEmailAccountOutput;

export type EmailAccountControllerDisconnectMutationResponse = EmailAccountControllerDisconnect200;

export type EmailAccountControllerDisconnectMutation = {
    Response: EmailAccountControllerDisconnect200;
    PathParams: EmailAccountControllerDisconnectPathParams;
    Errors: any;
};

export type EmailControllerAttachPoliciesPathParams = {
    /**
     * @type string
    */
    emailId: string;
};

export type EmailControllerAttachPolicies200 = EmailPolicyLinkOutput;

/**
 * @description Invalid policy list, unknown email or policy, or invisible email
*/
export type EmailControllerAttachPolicies400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailControllerAttachPolicies401 = any;

/**
 * @description The caller cannot access a policy
*/
export type EmailControllerAttachPolicies403 = any;

export type EmailControllerAttachPoliciesMutationRequest = AttachEmailPoliciesBody;

export type EmailControllerAttachPoliciesMutationResponse = EmailControllerAttachPolicies200;

export type EmailControllerAttachPoliciesMutation = {
    Response: EmailControllerAttachPolicies200;
    Request: EmailControllerAttachPoliciesMutationRequest;
    PathParams: EmailControllerAttachPoliciesPathParams;
    Errors: EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403;
};

export type EmailControllerDetachPolicies200 = EmailPolicyLinkOutput;

/**
 * @description Invalid lists, unknown policy, or an invisible email
*/
export type EmailControllerDetachPolicies400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailControllerDetachPolicies401 = any;

/**
 * @description The caller cannot access a policy
*/
export type EmailControllerDetachPolicies403 = any;

export type EmailControllerDetachPoliciesMutationRequest = DetachEmailsPoliciesBody;

export type EmailControllerDetachPoliciesMutationResponse = EmailControllerDetachPolicies200;

export type EmailControllerDetachPoliciesMutation = {
    Response: EmailControllerDetachPolicies200;
    Request: EmailControllerDetachPoliciesMutationRequest;
    Errors: EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403;
};

export type EmailControllerDetachPolicyPathParams = {
    /**
     * @type string
    */
    emailId: string;
    /**
     * @type string
    */
    policyId: string;
};

export type EmailControllerDetachPolicy200 = EmailPolicyLinkOutput;

/**
 * @description Unknown email or policy, or invisible email
*/
export type EmailControllerDetachPolicy400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailControllerDetachPolicy401 = any;

/**
 * @description The caller cannot access the policy
*/
export type EmailControllerDetachPolicy403 = any;

export type EmailControllerDetachPolicyMutationResponse = EmailControllerDetachPolicy200;

export type EmailControllerDetachPolicyMutation = {
    Response: EmailControllerDetachPolicy200;
    PathParams: EmailControllerDetachPolicyPathParams;
    Errors: EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403;
};

export type EmailControllerMovePolicyPathParams = {
    /**
     * @type string
    */
    emailId: string;
};

export type EmailControllerMovePolicy200 = EmailPolicyLinkOutput;

/**
 * @description Invalid or identical policies, source is not linked, or email is invisible
*/
export type EmailControllerMovePolicy400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailControllerMovePolicy401 = any;

/**
 * @description The caller cannot access a policy
*/
export type EmailControllerMovePolicy403 = any;

export type EmailControllerMovePolicyMutationRequest = MoveEmailPolicyBody;

export type EmailControllerMovePolicyMutationResponse = EmailControllerMovePolicy200;

export type EmailControllerMovePolicyMutation = {
    Response: EmailControllerMovePolicy200;
    Request: EmailControllerMovePolicyMutationRequest;
    PathParams: EmailControllerMovePolicyPathParams;
    Errors: EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403;
};

export type EmailControllerGetAttachmentDownloadUrlPathParams = {
    /**
     * @type string
    */
    emailId: string;
    /**
     * @type string
    */
    emailAttachmentId: string;
};

export type EmailControllerGetAttachmentDownloadUrl200 = GetEmailAttachmentDownloadUrlOutput;

/**
 * @description The caller is not an authenticated user
*/
export type EmailControllerGetAttachmentDownloadUrl401 = any;

/**
 * @description EMAIL_ATTACHMENT_NOT_STORED: the attachment is pending, skipped or failed; details carry status and failureReason
*/
export type EmailControllerGetAttachmentDownloadUrl409 = any;

export type EmailControllerGetAttachmentDownloadUrlQueryResponse = EmailControllerGetAttachmentDownloadUrl200;

export type EmailControllerGetAttachmentDownloadUrlQuery = {
    Response: EmailControllerGetAttachmentDownloadUrl200;
    PathParams: EmailControllerGetAttachmentDownloadUrlPathParams;
    Errors: EmailControllerGetAttachmentDownloadUrl401 | EmailControllerGetAttachmentDownloadUrl409;
};

export type EmailControllerGetEmailPathParams = {
    /**
     * @type string
    */
    emailId: string;
};

export type EmailControllerGetEmail200 = GetEmailOutput;

/**
 * @description Unknown email, or not visible to the caller
*/
export type EmailControllerGetEmail400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailControllerGetEmail401 = any;

export type EmailControllerGetEmailQueryResponse = EmailControllerGetEmail200;

export type EmailControllerGetEmailQuery = {
    Response: EmailControllerGetEmail200;
    PathParams: EmailControllerGetEmailPathParams;
    Errors: EmailControllerGetEmail400 | EmailControllerGetEmail401;
};

export const emailThreadControllerListThreadsQueryParamsModeEnum = {
    to_process: "to_process",
    processed: "processed"
} as const;

export type EmailThreadControllerListThreadsQueryParamsModeEnumKey = (typeof emailThreadControllerListThreadsQueryParamsModeEnum)[keyof typeof emailThreadControllerListThreadsQueryParamsModeEnum];

export const emailThreadControllerListThreadsQueryParamsProcessedFilterEnum = {
    all: "all",
    linked: "linked",
    archived: "archived"
} as const;

export type EmailThreadControllerListThreadsQueryParamsProcessedFilterEnumKey = (typeof emailThreadControllerListThreadsQueryParamsProcessedFilterEnum)[keyof typeof emailThreadControllerListThreadsQueryParamsProcessedFilterEnum];

export type EmailThreadControllerListThreadsQueryParams = {
    /**
     * @description Policy whose linked threads to list. Requires policy access, includes firm-shared mailboxes for every broker, and embeds every email in each thread. Cannot be combined with mode or processedFilter
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @description Opaque cursor returned as `nextCursor` by the previous page
     * @type string | undefined
    */
    cursor?: string;
    /**
     * @minLength 1
     * @maxLength 100
     * @default 50
     * @type integer | undefined
    */
    limit?: number;
    /**
     * @description Mailboxes to list. Empty lists every mailbox the caller may list; ids outside that set are ignored
     * @type array | undefined
    */
    accountIds?: string[];
    /**
     * @description to_process: at least one email neither archived nor linked. processed: every email archived or linked
     * @default "to_process"
     * @type string | undefined
    */
    mode?: EmailThreadControllerListThreadsQueryParamsModeEnumKey;
    /**
     * @description Only with mode=processed. linked: at least one linked email; archived: at least one archived email
     * @default "all"
     * @type string | undefined
    */
    processedFilter?: EmailThreadControllerListThreadsQueryParamsProcessedFilterEnumKey;
    /**
     * @description true lists only threads with at least one unread, non-archived email
     * @type boolean | undefined
    */
    unread?: boolean;
    /**
     * @description Only with policyId. Keeps threads with an email whose subject, sender or recipient name or address, or body text contains this text, ignoring case but not accents
     * @type string | undefined
    */
    search?: string;
};

export type EmailThreadControllerListThreads200 = ListEmailThreadsOutput;

/**
 * @description Malformed cursor, page size or filter, or processedFilter outside processed mode
*/
export type EmailThreadControllerListThreads400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailThreadControllerListThreads401 = any;

export type EmailThreadControllerListThreadsQueryResponse = EmailThreadControllerListThreads200;

export type EmailThreadControllerListThreadsQuery = {
    Response: EmailThreadControllerListThreads200;
    QueryParams: EmailThreadControllerListThreadsQueryParams;
    Errors: EmailThreadControllerListThreads400 | EmailThreadControllerListThreads401;
};

export type EmailThreadControllerSetThreadsArchived200 = SetEmailThreadArchivedOutput;

/**
 * @description Malformed body, or a malformed, unknown or invisible thread id
*/
export type EmailThreadControllerSetThreadsArchived400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailThreadControllerSetThreadsArchived401 = any;

export type EmailThreadControllerSetThreadsArchivedMutationRequest = SetEmailThreadArchivedBody;

export type EmailThreadControllerSetThreadsArchivedMutationResponse = EmailThreadControllerSetThreadsArchived200;

export type EmailThreadControllerSetThreadsArchivedMutation = {
    Response: EmailThreadControllerSetThreadsArchived200;
    Request: EmailThreadControllerSetThreadsArchivedMutationRequest;
    Errors: EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401;
};

export type EmailThreadControllerGetThreadPathParams = {
    /**
     * @type string
    */
    threadId: string;
};

export type EmailThreadControllerGetThread200 = GetEmailThreadOutput;

/**
 * @description Malformed or unknown thread id, or not visible to the caller
*/
export type EmailThreadControllerGetThread400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailThreadControllerGetThread401 = any;

export type EmailThreadControllerGetThreadQueryResponse = EmailThreadControllerGetThread200;

export type EmailThreadControllerGetThreadQuery = {
    Response: EmailThreadControllerGetThread200;
    PathParams: EmailThreadControllerGetThreadPathParams;
    Errors: EmailThreadControllerGetThread400 | EmailThreadControllerGetThread401;
};

export type EmailThreadControllerAttachThreadsPolicies200 = AttachEmailThreadsPoliciesOutput;

/**
 * @description Invalid policy list, unknown policy, or a malformed or invisible thread
*/
export type EmailThreadControllerAttachThreadsPolicies400 = any;

/**
 * @description The caller is not an authenticated user
*/
export type EmailThreadControllerAttachThreadsPolicies401 = any;

/**
 * @description The caller cannot access a policy
*/
export type EmailThreadControllerAttachThreadsPolicies403 = any;

export type EmailThreadControllerAttachThreadsPoliciesMutationRequest = AttachEmailThreadsPoliciesBody;

export type EmailThreadControllerAttachThreadsPoliciesMutationResponse = EmailThreadControllerAttachThreadsPolicies200;

export type EmailThreadControllerAttachThreadsPoliciesMutation = {
    Response: EmailThreadControllerAttachThreadsPolicies200;
    Request: EmailThreadControllerAttachThreadsPoliciesMutationRequest;
    Errors: EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403;
};

export type GeneralInboxControllerGetSummary200 = GeneralInboxSummaryOutput;

export type GeneralInboxControllerGetSummaryQueryResponse = GeneralInboxControllerGetSummary200;

export type GeneralInboxControllerGetSummaryQuery = {
    Response: GeneralInboxControllerGetSummary200;
    Errors: any;
};

export type ClaimManagementControllerLookupCustomer201 = LookupCustomerOutput;

export type ClaimManagementControllerLookupCustomer400 = InvalidTenantErrorDto;

export type ClaimManagementControllerLookupCustomer404 = ClaimManagementCustomerNotFoundErrorDto;

export type ClaimManagementControllerLookupCustomerMutationRequest = LookupCustomerInputBody;

export type ClaimManagementControllerLookupCustomerMutationResponse = ClaimManagementControllerLookupCustomer201;

export type ClaimManagementControllerLookupCustomerMutation = {
    Response: ClaimManagementControllerLookupCustomer201;
    Request: ClaimManagementControllerLookupCustomerMutationRequest;
    Errors: ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404;
};

export type ClaimManagementControllerCheckCoverage201 = CheckCoverageOutput;

export type ClaimManagementControllerCheckCoverage400 = InvalidTenantErrorDto;

export type ClaimManagementControllerCheckCoverage422 = ClaimManagementOnBehalfUnavailableErrorDto;

export type ClaimManagementControllerCheckCoverageMutationRequest = CheckCoverageInputBody;

export type ClaimManagementControllerCheckCoverageMutationResponse = ClaimManagementControllerCheckCoverage201;

export type ClaimManagementControllerCheckCoverageMutation = {
    Response: ClaimManagementControllerCheckCoverage201;
    Request: ClaimManagementControllerCheckCoverageMutationRequest;
    Errors: ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422;
};

export type ClaimManagementControllerGenerateFnolUploadUrl201 = GenerateFnolUploadUrlOutput;

export type ClaimManagementControllerGenerateFnolUploadUrl400 = InvalidTenantErrorDto;

export type ClaimManagementControllerGenerateFnolUploadUrl413 = ClaimDocumentTooLargeErrorDto;

export type ClaimManagementControllerGenerateFnolUploadUrlMutationRequest = GenerateFnolUploadUrlInputBody;

export type ClaimManagementControllerGenerateFnolUploadUrlMutationResponse = ClaimManagementControllerGenerateFnolUploadUrl201;

export type ClaimManagementControllerGenerateFnolUploadUrlMutation = {
    Response: ClaimManagementControllerGenerateFnolUploadUrl201;
    Request: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest;
    Errors: ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413;
};

export type ClaimManagementControllerBootstrap201 = BootstrapClaimOutput;

export type ClaimManagementControllerBootstrap400 = InvalidTenantErrorDto;

export type ClaimManagementControllerBootstrap422 = ClaimManagementOnBehalfUnavailableErrorDto;

export type ClaimManagementControllerBootstrapMutationRequest = BootstrapClaimInputBody;

export type ClaimManagementControllerBootstrapMutationResponse = ClaimManagementControllerBootstrap201;

export type ClaimManagementControllerBootstrapMutation = {
    Response: ClaimManagementControllerBootstrap201;
    Request: ClaimManagementControllerBootstrapMutationRequest;
    Errors: ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422;
};

export const claimManagementControllerListQueryParamsFraudVerdictEnum = {
    fraud: "fraud",
    review_needed: "review_needed",
    clean: "clean"
} as const;

export type ClaimManagementControllerListQueryParamsFraudVerdictEnumKey = (typeof claimManagementControllerListQueryParamsFraudVerdictEnum)[keyof typeof claimManagementControllerListQueryParamsFraudVerdictEnum];

export const claimManagementControllerListQueryParamsSortEnum = {
    risk: "risk",
    date: "date"
} as const;

export type ClaimManagementControllerListQueryParamsSortEnumKey = (typeof claimManagementControllerListQueryParamsSortEnum)[keyof typeof claimManagementControllerListQueryParamsSortEnum];

export type ClaimManagementControllerListQueryParams = {
    /**
     * @description Max claims to return.
     * @minLength 1
     * @maxLength 100
     * @type number | undefined
    */
    limit?: number;
    /**
     * @description 0-based offset into the list.
     * @minLength 0
     * @default 0
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description Filter to a single main status (DRAFT / INSTRUCTION / SETTLEMENT / CLOSED / DISCARDED).
     * @type string | undefined
    */
    status?: string;
    /**
     * @description Filter by module state — matches a claim when ANY sub-module is in this state (e.g. AWAITING_DOCUMENTS, UNDER_REVIEW; state names are unique across modules).
     * @type string | undefined
    */
    subStatus?: string;
    /**
     * @description Case-insensitive substring match on the partner claim number (`externalClaimId`). Drafts have no claim number yet and never match.
     * @type string | undefined
    */
    claimNumber?: string;
    /**
     * @description Filter to a single claim type (`incident.category` id, as in the product `claimTypes`).
     * @type string | undefined
    */
    claimType?: string;
    /**
     * @description Free-text search: case-insensitive substring of the partner claim number (`externalClaimId`) or of the contract number of the claim’s policy.
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Keep claims declared on or after this day (`YYYY-MM-DD`, UTC, inclusive).
     * @type string | undefined
    */
    createdFrom?: string;
    /**
     * @description Keep claims declared on or before this day (`YYYY-MM-DD`, UTC, inclusive).
     * @type string | undefined
    */
    createdTo?: string;
    /**
     * @description Keep claims whose incident occurred on or after this day (`YYYY-MM-DD`, inclusive).
     * @type string | undefined
    */
    occurredFrom?: string;
    /**
     * @description Keep claims whose incident occurred on or before this day (`YYYY-MM-DD`, inclusive).
     * @type string | undefined
    */
    occurredTo?: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @description Filter to a single Korint Claimant (`claimant_*` semantic id) owning the claims. Self-service routes ignore any client-supplied value and re-scope to the caller’s own claimantId.
     * @type string | undefined
    */
    claimantId?: string;
    /**
     * @description Triage filter: keep only claims whose worst per-document fraud verdict matches. Claims with no scored documents are excluded from every verdict filter.
     * @type string | undefined
    */
    fraudVerdict?: ClaimManagementControllerListQueryParamsFraudVerdictEnumKey;
    /**
     * @description Sort order. `risk` = highest fraud score first (most-suspicious on top); `date` (default) = newest first.
     * @type string | undefined
    */
    sort?: ClaimManagementControllerListQueryParamsSortEnumKey;
    /**
     * @description Super-user only: scope the list to a single tenant instead of every tenant.
     * @type string | undefined
    */
    filterTenantId?: string;
};

export type ClaimManagementControllerList200 = ListClaimsManagementOutput;

export type ClaimManagementControllerList400 = MissingTenantErrorDto;

export type ClaimManagementControllerListQueryResponse = ClaimManagementControllerList200;

export type ClaimManagementControllerListQuery = {
    Response: ClaimManagementControllerList200;
    QueryParams: ClaimManagementControllerListQueryParams;
    Errors: ClaimManagementControllerList400;
};

export type ClaimManagementControllerListMyClaimsQueryParams = {
    /**
     * @description Max claims to return.
     * @minLength 1
     * @maxLength 100
     * @type number | undefined
    */
    limit?: number;
    /**
     * @description 0-based offset into the list.
     * @minLength 0
     * @default 0
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description Filter by main status (DRAFT / INSTRUCTION / SETTLEMENT / CLOSED / DISCARDED).
     * @type string | undefined
    */
    status?: string;
    /**
     * @description Filter by module state — matches a claim when ANY sub-module is in this state (e.g. AWAITING_DOCUMENTS, UNDER_REVIEW; state names are unique across modules).
     * @type string | undefined
    */
    subStatus?: string;
};

export type ClaimManagementControllerListMyClaims200 = ListClaimsManagementOutput;

export type ClaimManagementControllerListMyClaims400 = InvalidTenantErrorDto;

export type ClaimManagementControllerListMyClaimsQueryResponse = ClaimManagementControllerListMyClaims200;

export type ClaimManagementControllerListMyClaimsQuery = {
    Response: ClaimManagementControllerListMyClaims200;
    QueryParams: ClaimManagementControllerListMyClaimsQueryParams;
    Errors: ClaimManagementControllerListMyClaims400;
};

export type ClaimManagementControllerUpdateDraftPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerUpdateDraft200 = UpdateClaimDraftOutput;

export type ClaimManagementControllerUpdateDraft400 = InvalidTenantErrorDto;

export type ClaimManagementControllerUpdateDraft404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerUpdateDraft409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerUpdateDraftMutationRequest = UpdateClaimDraftInputBody;

export type ClaimManagementControllerUpdateDraftMutationResponse = ClaimManagementControllerUpdateDraft200;

export type ClaimManagementControllerUpdateDraftMutation = {
    Response: ClaimManagementControllerUpdateDraft200;
    Request: ClaimManagementControllerUpdateDraftMutationRequest;
    PathParams: ClaimManagementControllerUpdateDraftPathParams;
    Errors: ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409;
};

export type ClaimManagementControllerGetPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerGet200 = GetClaimManagementOutput;

export type ClaimManagementControllerGet400 = InvalidTenantErrorDto;

export type ClaimManagementControllerGet404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerGetQueryResponse = ClaimManagementControllerGet200;

export type ClaimManagementControllerGetQuery = {
    Response: ClaimManagementControllerGet200;
    PathParams: ClaimManagementControllerGetPathParams;
    Errors: ClaimManagementControllerGet400 | ClaimManagementControllerGet404;
};

export type ClaimManagementControllerUpdateCustomFieldsPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerUpdateCustomFields200 = UpdateClaimDraftCustomFieldsOutput;

export type ClaimManagementControllerUpdateCustomFields400 = (InvalidTenantErrorDto | ClaimManagementInvalidCustomFieldErrorDto);

export type ClaimManagementControllerUpdateCustomFields404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerUpdateCustomFields409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerUpdateCustomFieldsMutationRequest = UpdateClaimDraftCustomFieldsInputBody;

export type ClaimManagementControllerUpdateCustomFieldsMutationResponse = ClaimManagementControllerUpdateCustomFields200;

export type ClaimManagementControllerUpdateCustomFieldsMutation = {
    Response: ClaimManagementControllerUpdateCustomFields200;
    Request: ClaimManagementControllerUpdateCustomFieldsMutationRequest;
    PathParams: ClaimManagementControllerUpdateCustomFieldsPathParams;
    Errors: ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409;
};

export type ClaimManagementControllerAttachDocumentPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerAttachDocument201 = AttachClaimDocumentOutput;

export type ClaimManagementControllerAttachDocument400 = InvalidTenantErrorDto;

export type ClaimManagementControllerAttachDocument404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerAttachDocument409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerAttachDocumentMutationRequest = AttachClaimDocumentInputBody;

export type ClaimManagementControllerAttachDocumentMutationResponse = ClaimManagementControllerAttachDocument201;

export type ClaimManagementControllerAttachDocumentMutation = {
    Response: ClaimManagementControllerAttachDocument201;
    Request: ClaimManagementControllerAttachDocumentMutationRequest;
    PathParams: ClaimManagementControllerAttachDocumentPathParams;
    Errors: ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409;
};

export type ClaimManagementControllerGenerateDocumentPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerGenerateDocument201 = GenerateClaimDocumentOutput;

export type ClaimManagementControllerGenerateDocument400 = InvalidTenantErrorDto;

export type ClaimManagementControllerGenerateDocument404 = (ClaimManagementNotFoundErrorDto | DocumentConfigNotFoundErrorDto);

export type ClaimManagementControllerGenerateDocument409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerGenerateDocumentMutationRequest = GenerateClaimDocumentInputBody;

export type ClaimManagementControllerGenerateDocumentMutationResponse = ClaimManagementControllerGenerateDocument201;

export type ClaimManagementControllerGenerateDocumentMutation = {
    Response: ClaimManagementControllerGenerateDocument201;
    Request: ClaimManagementControllerGenerateDocumentMutationRequest;
    PathParams: ClaimManagementControllerGenerateDocumentPathParams;
    Errors: ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409;
};

export type ClaimManagementControllerGetDocumentGenerationPayload201 = GetClaimDocumentGenerationPayloadOutput;

export type ClaimManagementControllerGetDocumentGenerationPayload400 = InvalidTenantErrorDto;

export type ClaimManagementControllerGetDocumentGenerationPayload404 = (ClaimManagementNotFoundErrorDto | DocumentConfigNotFoundErrorDto);

export type ClaimManagementControllerGetDocumentGenerationPayload409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest = GetClaimDocumentGenerationPayloadInputBody;

export type ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse = ClaimManagementControllerGetDocumentGenerationPayload201;

export type ClaimManagementControllerGetDocumentGenerationPayloadMutation = {
    Response: ClaimManagementControllerGetDocumentGenerationPayload201;
    Request: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest;
    Errors: ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409;
};

export type ClaimManagementControllerDetachDocumentPathParams = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    documentId: string;
};

export type ClaimManagementControllerDetachDocument200 = DetachClaimDocumentOutput;

export type ClaimManagementControllerDetachDocument400 = InvalidTenantErrorDto;

export type ClaimManagementControllerDetachDocument404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerDetachDocument409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerDetachDocumentMutationResponse = ClaimManagementControllerDetachDocument200;

export type ClaimManagementControllerDetachDocumentMutation = {
    Response: ClaimManagementControllerDetachDocument200;
    PathParams: ClaimManagementControllerDetachDocumentPathParams;
    Errors: ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409;
};

export type ClaimManagementControllerTransitionPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerTransition201 = TransitionClaimOutput;

export type ClaimManagementControllerTransition400 = (InvalidTenantErrorDto | ClaimManagementInvalidCustomFieldErrorDto);

export type ClaimManagementControllerTransition404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerTransition409 = ClaimManagementInvalidTransitionErrorDto;

export type ClaimManagementControllerTransitionMutationRequest = TransitionClaimInputBody;

export type ClaimManagementControllerTransitionMutationResponse = ClaimManagementControllerTransition201;

export type ClaimManagementControllerTransitionMutation = {
    Response: ClaimManagementControllerTransition201;
    Request: ClaimManagementControllerTransitionMutationRequest;
    PathParams: ClaimManagementControllerTransitionPathParams;
    Errors: ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409;
};

export type ClaimManagementControllerRetryForwardPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerRetryForward200 = RetryClaimForwardOutput;

export type ClaimManagementControllerRetryForward400 = InvalidTenantErrorDto;

export type ClaimManagementControllerRetryForward404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerRetryForwardMutationResponse = ClaimManagementControllerRetryForward200;

export type ClaimManagementControllerRetryForwardMutation = {
    Response: ClaimManagementControllerRetryForward200;
    PathParams: ClaimManagementControllerRetryForwardPathParams;
    Errors: ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404;
};

export type ClaimManagementControllerAddNotePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerAddNote201 = AddClaimNoteOutput;

export type ClaimManagementControllerAddNote400 = InvalidTenantErrorDto;

export type ClaimManagementControllerAddNote404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerAddNoteMutationRequest = AddClaimNoteInputBody;

export type ClaimManagementControllerAddNoteMutationResponse = ClaimManagementControllerAddNote201;

export type ClaimManagementControllerAddNoteMutation = {
    Response: ClaimManagementControllerAddNote201;
    Request: ClaimManagementControllerAddNoteMutationRequest;
    PathParams: ClaimManagementControllerAddNotePathParams;
    Errors: ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404;
};

export const claimManagementControllerStartClaimsExportQueryParamsFraudVerdictEnum = {
    fraud: "fraud",
    review_needed: "review_needed",
    clean: "clean"
} as const;

export type ClaimManagementControllerStartClaimsExportQueryParamsFraudVerdictEnumKey = (typeof claimManagementControllerStartClaimsExportQueryParamsFraudVerdictEnum)[keyof typeof claimManagementControllerStartClaimsExportQueryParamsFraudVerdictEnum];

export const claimManagementControllerStartClaimsExportQueryParamsSortEnum = {
    risk: "risk",
    date: "date"
} as const;

export type ClaimManagementControllerStartClaimsExportQueryParamsSortEnumKey = (typeof claimManagementControllerStartClaimsExportQueryParamsSortEnum)[keyof typeof claimManagementControllerStartClaimsExportQueryParamsSortEnum];

export type ClaimManagementControllerStartClaimsExportQueryParams = {
    /**
     * @description Filter to a single main status (DRAFT / INSTRUCTION / SETTLEMENT / CLOSED / DISCARDED).
     * @type string | undefined
    */
    status?: string;
    /**
     * @description Filter by module state — matches a claim when ANY sub-module is in this state (e.g. AWAITING_DOCUMENTS, UNDER_REVIEW; state names are unique across modules).
     * @type string | undefined
    */
    subStatus?: string;
    /**
     * @description Case-insensitive substring match on the partner claim number (`externalClaimId`). Drafts have no claim number yet and never match.
     * @type string | undefined
    */
    claimNumber?: string;
    /**
     * @description Filter to a single claim type (`incident.category` id, as in the product `claimTypes`).
     * @type string | undefined
    */
    claimType?: string;
    /**
     * @description Free-text search: case-insensitive substring of the partner claim number (`externalClaimId`) or of the contract number of the claim’s policy.
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Keep claims declared on or after this day (`YYYY-MM-DD`, UTC, inclusive).
     * @type string | undefined
    */
    createdFrom?: string;
    /**
     * @description Keep claims declared on or before this day (`YYYY-MM-DD`, UTC, inclusive).
     * @type string | undefined
    */
    createdTo?: string;
    /**
     * @description Keep claims whose incident occurred on or after this day (`YYYY-MM-DD`, inclusive).
     * @type string | undefined
    */
    occurredFrom?: string;
    /**
     * @description Keep claims whose incident occurred on or before this day (`YYYY-MM-DD`, inclusive).
     * @type string | undefined
    */
    occurredTo?: string;
    /**
     * @type string | undefined
    */
    policyId?: string;
    /**
     * @type string | undefined
    */
    productId?: string;
    /**
     * @description Filter to a single Korint Claimant (`claimant_*` semantic id) owning the claims. Self-service routes ignore any client-supplied value and re-scope to the caller’s own claimantId.
     * @type string | undefined
    */
    claimantId?: string;
    /**
     * @description Triage filter: keep only claims whose worst per-document fraud verdict matches. Claims with no scored documents are excluded from every verdict filter.
     * @type string | undefined
    */
    fraudVerdict?: ClaimManagementControllerStartClaimsExportQueryParamsFraudVerdictEnumKey;
    /**
     * @description Sort order. `risk` = highest fraud score first (most-suspicious on top); `date` (default) = newest first.
     * @type string | undefined
    */
    sort?: ClaimManagementControllerStartClaimsExportQueryParamsSortEnumKey;
    /**
     * @description Super-user only: scope the list to a single tenant instead of every tenant.
     * @type string | undefined
    */
    filterTenantId?: string;
};

export type ClaimManagementControllerStartClaimsExport201 = StartClaimsExportOutput;

export type ClaimManagementControllerStartClaimsExport400 = MissingTenantErrorDto;

export type ClaimManagementControllerStartClaimsExportMutationResponse = ClaimManagementControllerStartClaimsExport201;

export type ClaimManagementControllerStartClaimsExportMutation = {
    Response: ClaimManagementControllerStartClaimsExport201;
    QueryParams: ClaimManagementControllerStartClaimsExportQueryParams;
    Errors: ClaimManagementControllerStartClaimsExport400;
};

export type ClaimManagementControllerGetClaimsExportStatusPathParams = {
    /**
     * @type string
    */
    jobId: string;
};

export type ClaimManagementControllerGetClaimsExportStatus200 = ClaimsExportStatusOutput;

export type ClaimManagementControllerGetClaimsExportStatus400 = MissingTenantErrorDto;

export type ClaimManagementControllerGetClaimsExportStatusQueryResponse = ClaimManagementControllerGetClaimsExportStatus200;

export type ClaimManagementControllerGetClaimsExportStatusQuery = {
    Response: ClaimManagementControllerGetClaimsExportStatus200;
    PathParams: ClaimManagementControllerGetClaimsExportStatusPathParams;
    Errors: ClaimManagementControllerGetClaimsExportStatus400;
};

export type ClaimManagementControllerAvailableTransitionsPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerAvailableTransitions200 = GetAvailableTransitionsOutput;

export type ClaimManagementControllerAvailableTransitions400 = InvalidTenantErrorDto;

export type ClaimManagementControllerAvailableTransitions404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerAvailableTransitionsQueryResponse = ClaimManagementControllerAvailableTransitions200;

export type ClaimManagementControllerAvailableTransitionsQuery = {
    Response: ClaimManagementControllerAvailableTransitions200;
    PathParams: ClaimManagementControllerAvailableTransitionsPathParams;
    Errors: ClaimManagementControllerAvailableTransitions400 | ClaimManagementControllerAvailableTransitions404;
};

export type ClaimManagementControllerGetClaimExtractionsPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerGetClaimExtractions200 = GetClaimExtractionsOutput;

export type ClaimManagementControllerGetClaimExtractions400 = InvalidTenantErrorDto;

export type ClaimManagementControllerGetClaimExtractions404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerGetClaimExtractionsQueryResponse = ClaimManagementControllerGetClaimExtractions200;

export type ClaimManagementControllerGetClaimExtractionsQuery = {
    Response: ClaimManagementControllerGetClaimExtractions200;
    PathParams: ClaimManagementControllerGetClaimExtractionsPathParams;
    Errors: ClaimManagementControllerGetClaimExtractions400 | ClaimManagementControllerGetClaimExtractions404;
};

export type ClaimManagementControllerStatusHistoryPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerStatusHistory200 = GetClaimStatusHistoryOutput;

export type ClaimManagementControllerStatusHistory400 = InvalidTenantErrorDto;

export type ClaimManagementControllerStatusHistory404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerStatusHistoryQueryResponse = ClaimManagementControllerStatusHistory200;

export type ClaimManagementControllerStatusHistoryQuery = {
    Response: ClaimManagementControllerStatusHistory200;
    PathParams: ClaimManagementControllerStatusHistoryPathParams;
    Errors: ClaimManagementControllerStatusHistory400 | ClaimManagementControllerStatusHistory404;
};

export type ClaimManagementControllerDocumentFraudScoresPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerDocumentFraudScores200 = GetClaimDocumentFraudScoresOutput;

export type ClaimManagementControllerDocumentFraudScores400 = MissingTenantErrorDto;

export type ClaimManagementControllerDocumentFraudScoresQueryResponse = ClaimManagementControllerDocumentFraudScores200;

export type ClaimManagementControllerDocumentFraudScoresQuery = {
    Response: ClaimManagementControllerDocumentFraudScores200;
    PathParams: ClaimManagementControllerDocumentFraudScoresPathParams;
    Errors: ClaimManagementControllerDocumentFraudScores400;
};

export type ClaimManagementControllerFraudNarrativePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerFraudNarrative200 = GetClaimFraudNarrativeOutput;

export type ClaimManagementControllerFraudNarrative400 = MissingTenantErrorDto;

export type ClaimManagementControllerFraudNarrativeQueryResponse = ClaimManagementControllerFraudNarrative200;

export type ClaimManagementControllerFraudNarrativeQuery = {
    Response: ClaimManagementControllerFraudNarrative200;
    PathParams: ClaimManagementControllerFraudNarrativePathParams;
    Errors: ClaimManagementControllerFraudNarrative400;
};

export type ClaimManagementControllerCorrectDocumentFraudVerdictPathParams = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    documentId: string;
};

export type ClaimManagementControllerCorrectDocumentFraudVerdict201 = CorrectClaimDocumentFraudVerdictOutput;

export type ClaimManagementControllerCorrectDocumentFraudVerdict400 = MissingTenantErrorDto;

export type ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest = CorrectClaimDocumentFraudVerdictInputBody;

export type ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse = ClaimManagementControllerCorrectDocumentFraudVerdict201;

export type ClaimManagementControllerCorrectDocumentFraudVerdictMutation = {
    Response: ClaimManagementControllerCorrectDocumentFraudVerdict201;
    Request: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest;
    PathParams: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams;
    Errors: ClaimManagementControllerCorrectDocumentFraudVerdict400;
};

export type ClaimManagementControllerTimelinePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimManagementControllerTimeline200 = GetClaimManagementTimelineOutput;

export type ClaimManagementControllerTimeline400 = MissingTenantErrorDto;

export type ClaimManagementControllerTimeline404 = ClaimManagementNotFoundErrorDto;

export type ClaimManagementControllerTimelineQueryResponse = ClaimManagementControllerTimeline200;

export type ClaimManagementControllerTimelineQuery = {
    Response: ClaimManagementControllerTimeline200;
    PathParams: ClaimManagementControllerTimelinePathParams;
    Errors: ClaimManagementControllerTimeline400 | ClaimManagementControllerTimeline404;
};

export type ExternalClaimsControllerCreate200 = any;

export type ExternalClaimsControllerCreateMutationRequest = CreateExternalClaimInputBody;

export type ExternalClaimsControllerCreateMutationResponse = ExternalClaimsControllerCreate200;

export type ExternalClaimsControllerCreateMutation = {
    Response: ExternalClaimsControllerCreate200;
    Request: ExternalClaimsControllerCreateMutationRequest;
    Errors: any;
};

export type ExternalClaimsControllerResyncPathParams = {
    /**
     * @type string
    */
    claimId: string;
};

export type ExternalClaimsControllerResync202 = any;

export type ExternalClaimsControllerResyncMutationResponse = ExternalClaimsControllerResync202;

export type ExternalClaimsControllerResyncMutation = {
    Response: ExternalClaimsControllerResync202;
    PathParams: ExternalClaimsControllerResyncPathParams;
    Errors: any;
};

export type ClaimsControllerCreate201 = CreateClaimOutput;

export type ClaimsControllerCreate400 = (MissingTenantErrorDto | InvalidClaimCategoryErrorDto);

export type ClaimsControllerCreate409 = ConflictingConfigErrorDto;

export type ClaimsControllerCreateMutationRequest = CreateClaimInputBody;

export type ClaimsControllerCreateMutationResponse = ClaimsControllerCreate201;

export type ClaimsControllerCreateMutation = {
    Response: ClaimsControllerCreate201;
    Request: ClaimsControllerCreateMutationRequest;
    Errors: ClaimsControllerCreate400 | ClaimsControllerCreate409;
};

export type ClaimsControllerListQueryParams = {
    /**
     * @description the page info
     * @type object | undefined
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @type object | undefined
    */
    metadata?: MetadataSearch;
    /**
     * @type string
    */
    externalId: string;
};

export type ClaimsControllerList200 = ListClaimsOutput;

export type ClaimsControllerList400 = MissingTenantErrorDto;

export type ClaimsControllerListQueryResponse = ClaimsControllerList200;

export type ClaimsControllerListQuery = {
    Response: ClaimsControllerList200;
    QueryParams: ClaimsControllerListQueryParams;
    Errors: ClaimsControllerList400;
};

export type ClaimsControllerUpdatePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimsControllerUpdate200 = UpdateClaimOutput;

export type ClaimsControllerUpdate400 = (MissingTenantErrorDto | InvalidClaimCategoryErrorDto);

export type ClaimsControllerUpdate404 = ClaimNotFoundErrorDto;

export type ClaimsControllerUpdate409 = ConflictingConfigErrorDto;

export type ClaimsControllerUpdateMutationRequest = UpdateClaimInputBody;

export type ClaimsControllerUpdateMutationResponse = ClaimsControllerUpdate200;

export type ClaimsControllerUpdateMutation = {
    Response: ClaimsControllerUpdate200;
    Request: ClaimsControllerUpdateMutationRequest;
    PathParams: ClaimsControllerUpdatePathParams;
    Errors: ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409;
};

export type ClaimsControllerDeletePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimsControllerDelete200 = DeleteClaimOutput;

export type ClaimsControllerDelete400 = MissingTenantErrorDto;

export type ClaimsControllerDelete404 = ClaimNotFoundErrorDto;

export type ClaimsControllerDeleteMutationResponse = ClaimsControllerDelete200;

export type ClaimsControllerDeleteMutation = {
    Response: ClaimsControllerDelete200;
    PathParams: ClaimsControllerDeletePathParams;
    Errors: ClaimsControllerDelete400 | ClaimsControllerDelete404;
};

export type ClaimsControllerGetPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type ClaimsControllerGet200 = GetClaimOutput;

export type ClaimsControllerGet400 = MissingTenantErrorDto;

export type ClaimsControllerGet404 = ClaimNotFoundErrorDto;

export type ClaimsControllerGetQueryResponse = ClaimsControllerGet200;

export type ClaimsControllerGetQuery = {
    Response: ClaimsControllerGet200;
    PathParams: ClaimsControllerGetPathParams;
    Errors: ClaimsControllerGet400 | ClaimsControllerGet404;
};

export type ConfigControllerListTenants200 = ListTenantsOutput;

export type ConfigControllerListTenantsQueryResponse = ConfigControllerListTenants200;

export type ConfigControllerListTenantsQuery = {
    Response: ConfigControllerListTenants200;
    Errors: any;
};

export type ConfigControllerGetTenantConfig200 = KorintTenantConfigDto;

export type ConfigControllerGetTenantConfig400 = InvalidProductErrorDto;

export type ConfigControllerGetTenantConfigQueryResponse = ConfigControllerGetTenantConfig200;

export type ConfigControllerGetTenantConfigQuery = {
    Response: ConfigControllerGetTenantConfig200;
    Errors: ConfigControllerGetTenantConfig400;
};

export type ConfigControllerGetProductConfigPathParams = {
    /**
     * @type string
    */
    productId: string;
};

export type ConfigControllerGetProductConfig200 = KorintProductConfigWithProductNameDto;

export type ConfigControllerGetProductConfig400 = InvalidProductErrorDto;

export type ConfigControllerGetProductConfigQueryResponse = ConfigControllerGetProductConfig200;

export type ConfigControllerGetProductConfigQuery = {
    Response: ConfigControllerGetProductConfig200;
    PathParams: ConfigControllerGetProductConfigPathParams;
    Errors: ConfigControllerGetProductConfig400;
};

export type ConfigControllerGetPublicTenantConfigByDomainQueryParams = {
    /**
     * @description Hostname the tenant frontend is being served on
     * @type string
    */
    domain: string;
};

export type ConfigControllerGetPublicTenantConfigByDomain200 = GetPublicTenantConfigByDomainOutput;

export type ConfigControllerGetPublicTenantConfigByDomain400 = InvalidTenantErrorDto;

export type ConfigControllerGetPublicTenantConfigByDomainQueryResponse = ConfigControllerGetPublicTenantConfigByDomain200;

export type ConfigControllerGetPublicTenantConfigByDomainQuery = {
    Response: ConfigControllerGetPublicTenantConfigByDomain200;
    QueryParams: ConfigControllerGetPublicTenantConfigByDomainQueryParams;
    Errors: ConfigControllerGetPublicTenantConfigByDomain400;
};

export type ConfigControllerGetPublicProductConfigPathParams = {
    /**
     * @type string
    */
    productId: string;
};

export type ConfigControllerGetPublicProductConfig200 = GetPublicProductConfigOutput;

export type ConfigControllerGetPublicProductConfig400 = InvalidProductErrorDto;

export type ConfigControllerGetPublicProductConfigQueryResponse = ConfigControllerGetPublicProductConfig200;

export type ConfigControllerGetPublicProductConfigQuery = {
    Response: ConfigControllerGetPublicProductConfig200;
    PathParams: ConfigControllerGetPublicProductConfigPathParams;
    Errors: ConfigControllerGetPublicProductConfig400;
};

export type ConfigControllerGetPublicTenantConfig200 = KorintPublicTenantConfigDto;

export type ConfigControllerGetPublicTenantConfig400 = InvalidTenantErrorDto;

export type ConfigControllerGetPublicTenantConfigQueryResponse = ConfigControllerGetPublicTenantConfig200;

export type ConfigControllerGetPublicTenantConfigQuery = {
    Response: ConfigControllerGetPublicTenantConfig200;
    Errors: ConfigControllerGetPublicTenantConfig400;
};

export type ConfigControllerGetProductsForTenant200 = GetProductsForTenantOutput;

export type ConfigControllerGetProductsForTenant400 = InvalidTenantErrorDto;

export type ConfigControllerGetProductsForTenantQueryResponse = ConfigControllerGetProductsForTenant200;

export type ConfigControllerGetProductsForTenantQuery = {
    Response: ConfigControllerGetProductsForTenant200;
    Errors: ConfigControllerGetProductsForTenant400;
};

export type ConfigControllerGetBusinessRolePermissionsQueryParams = {
    /**
     * @description Business role id
     * @type string
    */
    businessRoleId: string;
    /**
     * @type string | undefined
    */
    productId?: string;
};

export type ConfigControllerGetBusinessRolePermissions200 = GetBusinessRolePermissionsOutput;

export type ConfigControllerGetBusinessRolePermissions400 = (InvalidTenantErrorDto | InvalidBusinessRoleErrorDto | InvalidProductErrorDto);

export type ConfigControllerGetBusinessRolePermissionsQueryResponse = ConfigControllerGetBusinessRolePermissions200;

export type ConfigControllerGetBusinessRolePermissionsQuery = {
    Response: ConfigControllerGetBusinessRolePermissions200;
    QueryParams: ConfigControllerGetBusinessRolePermissionsQueryParams;
    Errors: ConfigControllerGetBusinessRolePermissions400;
};

export const featureFlagControllerAtMeQueryParamsKeyEnum = {
    perm_ai_classification: "perm_ai_classification",
    perm_ai_extraction: "perm_ai_extraction",
    perm_ai_validity: "perm_ai_validity",
    perm_ai_autofill: "perm_ai_autofill",
    perm_ai_claim_doc_classifier: "perm_ai_claim_doc_classifier",
    perm_ai_claim_doc_extractor: "perm_ai_claim_doc_extractor",
    ops_product_feature_flag: "ops_product_feature_flag",
    ops_marsh_replay_logging: "ops_marsh_replay_logging",
    ops_shadow_document_generation: "ops_shadow_document_generation",
    ops_policy_stop_branch: "ops_policy_stop_branch",
    ops_ai_coherence: "ops_ai_coherence",
    ops_ai_document_models: "ops_ai_document_models",
    ops_yeet_vtc_assistance_suspended: "ops_yeet_vtc_assistance_suspended",
    ops_axece_vtc_assistance_suspended: "ops_axece_vtc_assistance_suspended",
    ops_alptis_connect: "ops_alptis_connect",
    feat_automatic_unpaid_retry: "feat_automatic_unpaid_retry",
    feat_automatic_unpaid_recovery_execution: "feat_automatic_unpaid_recovery_execution",
    feat_commission_statements: "feat_commission_statements",
    feat_anonymous_funnel_links: "feat_anonymous_funnel_links",
    feat_connected_email_accounts: "feat_connected_email_accounts",
    feat_document_conformity: "feat_document_conformity",
    feat_notifications_v2: "feat_notifications_v2",
    feat_finalize_new_business_buttons: "feat_finalize_new_business_buttons",
    feat_accelerant_vtc_pricing: "feat_accelerant_vtc_pricing",
    feat_local_spreadsheet_engine: "feat_local_spreadsheet_engine",
    feat_policy_fraud_detection: "feat_policy_fraud_detection",
    feat_document_review: "feat_document_review",
    feat_claims_management: "feat_claims_management",
    test_static: "test_static",
    test_dynamic: "test_dynamic"
} as const;

export type FeatureFlagControllerAtMeQueryParamsKeyEnumKey = (typeof featureFlagControllerAtMeQueryParamsKeyEnum)[keyof typeof featureFlagControllerAtMeQueryParamsKeyEnum];

export type FeatureFlagControllerAtMeQueryParams = {
    /**
     * @type string
    */
    key: FeatureFlagControllerAtMeQueryParamsKeyEnumKey;
    /**
     * @type string | undefined
    */
    productId?: string;
};

export type FeatureFlagControllerAtMe200 = EvaluateFeatureFlagOutput;

export type FeatureFlagControllerAtMeQueryResponse = FeatureFlagControllerAtMe200;

export type FeatureFlagControllerAtMeQuery = {
    Response: FeatureFlagControllerAtMe200;
    QueryParams: FeatureFlagControllerAtMeQueryParams;
    Errors: any;
};

export type FeatureFlagControllerFindAll200 = ListFeatureFlagsOutput;

export type FeatureFlagControllerFindAllQueryResponse = FeatureFlagControllerFindAll200;

export type FeatureFlagControllerFindAllQuery = {
    Response: FeatureFlagControllerFindAll200;
    Errors: any;
};

export type FeatureFlagControllerUpdate200 = UpdateFeatureFlagOutput;

export type FeatureFlagControllerUpdateMutationRequest = UpdateFeatureFlagInput;

export type FeatureFlagControllerUpdateMutationResponse = FeatureFlagControllerUpdate200;

export type FeatureFlagControllerUpdateMutation = {
    Response: FeatureFlagControllerUpdate200;
    Request: FeatureFlagControllerUpdateMutationRequest;
    Errors: any;
};

export type CustomerControllerGetCustomerPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetCustomerQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type CustomerControllerGetCustomer200 = CustomerDto;

export type CustomerControllerGetCustomer404 = CustomerNotFoundErrorDto;

export type CustomerControllerGetCustomerQueryResponse = CustomerControllerGetCustomer200;

export type CustomerControllerGetCustomerQuery = {
    Response: CustomerControllerGetCustomer200;
    PathParams: CustomerControllerGetCustomerPathParams;
    QueryParams: CustomerControllerGetCustomerQueryParams;
    Errors: CustomerControllerGetCustomer404;
};

export type CustomerControllerEditCustomerPathParams = {
    /**
     * @description the customer\'s id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerEditCustomerQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type CustomerControllerEditCustomer200 = EditCustomerOutput;

export type CustomerControllerEditCustomer400 = (InvalidCustomFieldsErrorDto | InvalidEventCreationDateErrorDto);

export type CustomerControllerEditCustomer404 = (CompanyNotFoundErrorDto | CustomerNotFoundErrorDto);

export type CustomerControllerEditCustomer409 = (ConflictingPolicyStatusErrorDto | ConflictingBranchStatusErrorDto | FieldsDoNotMeetRequirementsErrorDto);

export type CustomerControllerEditCustomerMutationRequest = EditCustomerInputBody;

export type CustomerControllerEditCustomerMutationResponse = CustomerControllerEditCustomer200;

export type CustomerControllerEditCustomerMutation = {
    Response: CustomerControllerEditCustomer200;
    Request: CustomerControllerEditCustomerMutationRequest;
    PathParams: CustomerControllerEditCustomerPathParams;
    QueryParams: CustomerControllerEditCustomerQueryParams;
    Errors: CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409;
};

export type CustomerControllerGetCustomerPaymentMethodsPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetCustomerPaymentMethodsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Include soft-deleted payment methods (super-user only)
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
};

export type CustomerControllerGetCustomerPaymentMethods200 = GetCustomerPaymentMethodsOutput;

export type CustomerControllerGetCustomerPaymentMethods404 = CustomerNotFoundErrorDto;

export type CustomerControllerGetCustomerPaymentMethodsQueryResponse = CustomerControllerGetCustomerPaymentMethods200;

export type CustomerControllerGetCustomerPaymentMethodsQuery = {
    Response: CustomerControllerGetCustomerPaymentMethods200;
    PathParams: CustomerControllerGetCustomerPaymentMethodsPathParams;
    QueryParams: CustomerControllerGetCustomerPaymentMethodsQueryParams;
    Errors: CustomerControllerGetCustomerPaymentMethods404;
};

export type CustomerControllerGetPaymentMethodSetupSecretPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetPaymentMethodSetupSecretQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type CustomerControllerGetPaymentMethodSetupSecret200 = GetPaymentMethodSetupSecretOutput;

export type CustomerControllerGetPaymentMethodSetupSecret400 = InvalidProductErrorDto;

export type CustomerControllerGetPaymentMethodSetupSecret404 = (CustomerNotFoundErrorDto | PaymentCustomerNotFoundErrorDto);

export type CustomerControllerGetPaymentMethodSetupSecret409 = ConflictingConfigErrorDto;

export type CustomerControllerGetPaymentMethodSetupSecretQueryResponse = CustomerControllerGetPaymentMethodSetupSecret200;

export type CustomerControllerGetPaymentMethodSetupSecretQuery = {
    Response: CustomerControllerGetPaymentMethodSetupSecret200;
    PathParams: CustomerControllerGetPaymentMethodSetupSecretPathParams;
    QueryParams: CustomerControllerGetPaymentMethodSetupSecretQueryParams;
    Errors: CustomerControllerGetPaymentMethodSetupSecret400 | CustomerControllerGetPaymentMethodSetupSecret404 | CustomerControllerGetPaymentMethodSetupSecret409;
};

export type CustomerControllerListCustomersQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description the pagination offset
     * @default 0
     * @type number | undefined
    */
    offset?: number;
    /**
     * @description the pagination page size
     * @default 50
     * @type number | undefined
    */
    pageSize?: number;
};

export type CustomerControllerListCustomers200 = ListCustomersOutput;

export type CustomerControllerListCustomersQueryResponse = CustomerControllerListCustomers200;

export type CustomerControllerListCustomersQuery = {
    Response: CustomerControllerListCustomers200;
    QueryParams: CustomerControllerListCustomersQueryParams;
    Errors: any;
};

export type CustomerControllerInitializeCustomerQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description The productId
     * @type string
    */
    productId: string;
};

export type CustomerControllerInitializeCustomer201 = InitializeCustomerOutput;

export type CustomerControllerInitializeCustomer400 = (InvalidProductErrorDto | InvalidBrokerageFirmErrorDto);

export type CustomerControllerInitializeCustomer404 = (PolicyNotFoundErrorDto | BrokerageFirmNotFoundErrorDto | BrokerageFirmFeesNotFoundErrorDto);

export type CustomerControllerInitializeCustomer409 = (ConflictingPolicyTypeErrorDto | ConflictingPolicyTypeErrorDto | ConflictingPolicyStatusErrorDto);

export type CustomerControllerInitializeCustomerMutationRequest = InitializeCustomerInputBody;

export type CustomerControllerInitializeCustomerMutationResponse = CustomerControllerInitializeCustomer201;

export type CustomerControllerInitializeCustomerMutation = {
    Response: CustomerControllerInitializeCustomer201;
    Request: CustomerControllerInitializeCustomerMutationRequest;
    QueryParams: CustomerControllerInitializeCustomerQueryParams;
    Errors: CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409;
};

export type CustomerControllerPushCustomerEventPathParams = {
    /**
     * @description the customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerPushCustomerEventQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branch id
     * @type string | undefined
    */
    branchId?: string;
};

export type CustomerControllerPushCustomerEvent201 = PushCustomerEventOutput;

export type CustomerControllerPushCustomerEvent400 = InvalidEventTypeErrorDto;

export type CustomerControllerPushCustomerEvent404 = CustomerNotFoundErrorDto;

export type CustomerControllerPushCustomerEventMutationRequest = PushCustomerEventInputBody;

export type CustomerControllerPushCustomerEventMutationResponse = CustomerControllerPushCustomerEvent201;

export type CustomerControllerPushCustomerEventMutation = {
    Response: CustomerControllerPushCustomerEvent201;
    Request: CustomerControllerPushCustomerEventMutationRequest;
    PathParams: CustomerControllerPushCustomerEventPathParams;
    QueryParams: CustomerControllerPushCustomerEventQueryParams;
    Errors: CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404;
};

export type CustomerControllerGetInvoicingSchedulePathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetInvoicingScheduleQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Invoice IDs to exclude from currentInvoiceIds when calculating the schedule
     * @type array | undefined
    */
    excludeInvoiceIds?: string[];
};

export type CustomerControllerGetInvoicingSchedule200 = CustomerGetInvoicingScheduleOutput;

export type CustomerControllerGetInvoicingSchedule400 = InvalidProductErrorDto;

export type CustomerControllerGetInvoicingSchedule404 = (CustomerNotFoundErrorDto | PolicyNotFoundErrorDto);

export type CustomerControllerGetInvoicingScheduleQueryResponse = CustomerControllerGetInvoicingSchedule200;

export type CustomerControllerGetInvoicingScheduleQuery = {
    Response: CustomerControllerGetInvoicingSchedule200;
    PathParams: CustomerControllerGetInvoicingSchedulePathParams;
    QueryParams: CustomerControllerGetInvoicingScheduleQueryParams;
    Errors: CustomerControllerGetInvoicingSchedule400 | CustomerControllerGetInvoicingSchedule404;
};

export type CustomerControllerGenerateMandateSignatureRequestPathParams = {
    /**
     * @description the customer id
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export type CustomerControllerGenerateMandateSignatureRequestQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type CustomerControllerGenerateMandateSignatureRequest201 = GenerateMandateSignatureRequestOutput;

export type CustomerControllerGenerateMandateSignatureRequest400 = (InvalidProductErrorDto | MissingCustomerContactFieldsErrorDto);

export type CustomerControllerGenerateMandateSignatureRequest404 = (CustomerNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type CustomerControllerGenerateMandateSignatureRequest409 = (ConflictingConfigErrorDto | ConflictingPaymentMethodStatusErrorDto);

export type CustomerControllerGenerateMandateSignatureRequest425 = NoUniqueDocumentTypeReadyToBeSignedErrorDto;

export type CustomerControllerGenerateMandateSignatureRequestMutationRequest = GenerateMandateSignatureRequestInputBody;

export type CustomerControllerGenerateMandateSignatureRequestMutationResponse = CustomerControllerGenerateMandateSignatureRequest201;

export type CustomerControllerGenerateMandateSignatureRequestMutation = {
    Response: CustomerControllerGenerateMandateSignatureRequest201;
    Request: CustomerControllerGenerateMandateSignatureRequestMutationRequest;
    PathParams: CustomerControllerGenerateMandateSignatureRequestPathParams;
    QueryParams: CustomerControllerGenerateMandateSignatureRequestQueryParams;
    Errors: CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425;
};

export type CustomerControllerUpdatePreferredPaymentMethodPathParams = {
    /**
     * @description the customer id
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export type CustomerControllerUpdatePreferredPaymentMethodQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type CustomerControllerUpdatePreferredPaymentMethod200 = UpdatePreferredPaymentMethodOutput;

export type CustomerControllerUpdatePreferredPaymentMethod400 = (InvalidProductErrorDto | InvalidPaymentMethodErrorDto);

export type CustomerControllerUpdatePreferredPaymentMethod404 = (CustomerNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type CustomerControllerUpdatePreferredPaymentMethod409 = (ConflictingConfigErrorDto | ConflictingPaymentMethodStatusErrorDto);

export type CustomerControllerUpdatePreferredPaymentMethodMutationResponse = CustomerControllerUpdatePreferredPaymentMethod200;

export type CustomerControllerUpdatePreferredPaymentMethodMutation = {
    Response: CustomerControllerUpdatePreferredPaymentMethod200;
    PathParams: CustomerControllerUpdatePreferredPaymentMethodPathParams;
    QueryParams: CustomerControllerUpdatePreferredPaymentMethodQueryParams;
    Errors: CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409;
};

export type CustomerControllerDeletePaymentMethodPathParams = {
    /**
     * @description the customer id
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export type CustomerControllerDeletePaymentMethod200 = DeleteCustomerPaymentMethodOutput;

export type CustomerControllerDeletePaymentMethod404 = PaymentMethodNotFoundErrorDto;

export type CustomerControllerDeletePaymentMethod409 = CannotDeleteLastPaymentMethodErrorDto;

export type CustomerControllerDeletePaymentMethodMutationResponse = CustomerControllerDeletePaymentMethod200;

export type CustomerControllerDeletePaymentMethodMutation = {
    Response: CustomerControllerDeletePaymentMethod200;
    PathParams: CustomerControllerDeletePaymentMethodPathParams;
    Errors: CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409;
};

export type CustomerControllerUpdatePaymentModePathParams = {
    /**
     * @description the customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerUpdatePaymentModeQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type CustomerControllerUpdatePaymentMode200 = UpdatePaymentModeOutput;

export type CustomerControllerUpdatePaymentMode400 = (InvalidProductErrorDto | PaymentMethodRequiredErrorDto | InvalidPaymentModeErrorDto);

export type CustomerControllerUpdatePaymentMode404 = (CustomerNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type CustomerControllerUpdatePaymentMode409 = (ConflictingConfigErrorDto | ConflictingPaymentMethodStatusErrorDto);

export type CustomerControllerUpdatePaymentModeMutationRequest = UpdatePaymentModeInputBody;

export type CustomerControllerUpdatePaymentModeMutationResponse = CustomerControllerUpdatePaymentMode200;

export type CustomerControllerUpdatePaymentModeMutation = {
    Response: CustomerControllerUpdatePaymentMode200;
    Request: CustomerControllerUpdatePaymentModeMutationRequest;
    PathParams: CustomerControllerUpdatePaymentModePathParams;
    QueryParams: CustomerControllerUpdatePaymentModeQueryParams;
    Errors: CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409;
};

export type CustomerControllerGetBankTransferAccountPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetBankTransferAccount200 = GetCustomerBankTransferAccountOutput;

export type CustomerControllerGetBankTransferAccount400 = (InvalidProductErrorDto | InvalidPaymentModeErrorDto);

export type CustomerControllerGetBankTransferAccount404 = CustomerNotFoundErrorDto;

export type CustomerControllerGetBankTransferAccount409 = ConflictingConfigErrorDto;

export type CustomerControllerGetBankTransferAccountQueryResponse = CustomerControllerGetBankTransferAccount200;

export type CustomerControllerGetBankTransferAccountQuery = {
    Response: CustomerControllerGetBankTransferAccount200;
    PathParams: CustomerControllerGetBankTransferAccountPathParams;
    Errors: CustomerControllerGetBankTransferAccount400 | CustomerControllerGetBankTransferAccount404 | CustomerControllerGetBankTransferAccount409;
};

export type CustomerControllerChargePathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerChargeQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type CustomerControllerCharge201 = RetryChargeOutput;

export type CustomerControllerCharge400 = InvalidProductErrorDto;

export type CustomerControllerCharge404 = (CustomerNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type CustomerControllerChargeMutationRequest = RetryChargeInputBody;

export type CustomerControllerChargeMutationResponse = CustomerControllerCharge201;

export type CustomerControllerChargeMutation = {
    Response: CustomerControllerCharge201;
    Request: CustomerControllerChargeMutationRequest;
    PathParams: CustomerControllerChargePathParams;
    QueryParams: CustomerControllerChargeQueryParams;
    Errors: CustomerControllerCharge400 | CustomerControllerCharge404;
};

export type CustomerControllerManuallyMarkInvoicePathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerManuallyMarkInvoice201 = ManuallyMarkInvoiceOutput;

export type CustomerControllerManuallyMarkInvoice400 = InvalidPaymentModeErrorDto;

export type CustomerControllerManuallyMarkInvoice404 = InvoiceNotFoundErrorDto;

export type CustomerControllerManuallyMarkInvoice409 = (InvoiceDoesNotBelongToCustomerErrorDto | InvalidChargeAttemptErrorDto);

export type CustomerControllerManuallyMarkInvoice500 = InvalidInvoiceStatusErrorDto;

export type CustomerControllerManuallyMarkInvoiceMutationRequest = ManuallyMarkInvoiceInputBody;

export type CustomerControllerManuallyMarkInvoiceMutationResponse = CustomerControllerManuallyMarkInvoice201;

export type CustomerControllerManuallyMarkInvoiceMutation = {
    Response: CustomerControllerManuallyMarkInvoice201;
    Request: CustomerControllerManuallyMarkInvoiceMutationRequest;
    PathParams: CustomerControllerManuallyMarkInvoicePathParams;
    Errors: CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500;
};

export type CustomerControllerGetCustomerBalancePathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetCustomerBalance200 = GetCustomerBalanceOutput;

export type CustomerControllerGetCustomerBalance404 = CustomerNotFoundErrorDto;

export type CustomerControllerGetCustomerBalanceQueryResponse = CustomerControllerGetCustomerBalance200;

export type CustomerControllerGetCustomerBalanceQuery = {
    Response: CustomerControllerGetCustomerBalance200;
    PathParams: CustomerControllerGetCustomerBalancePathParams;
    Errors: CustomerControllerGetCustomerBalance404;
};

export type CustomerControllerGetMigratedBillingTakeoverPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type CustomerControllerGetMigratedBillingTakeover200 = GetMigratedBillingTakeoverOutput;

export type CustomerControllerGetMigratedBillingTakeoverQueryResponse = CustomerControllerGetMigratedBillingTakeover200;

export type CustomerControllerGetMigratedBillingTakeoverQuery = {
    Response: CustomerControllerGetMigratedBillingTakeover200;
    PathParams: CustomerControllerGetMigratedBillingTakeoverPathParams;
    Errors: any;
};

export type CustomerControllerSetMigratedBillingTakeoverPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
    /**
     * @description The policy id
     * @type string
    */
    policyId: string;
};

export type CustomerControllerSetMigratedBillingTakeover200 = SetMigratedBillingTakeoverOutput;

export type CustomerControllerSetMigratedBillingTakeoverMutationRequest = SetMigratedBillingTakeoverBody;

export type CustomerControllerSetMigratedBillingTakeoverMutationResponse = CustomerControllerSetMigratedBillingTakeover200;

export type CustomerControllerSetMigratedBillingTakeoverMutation = {
    Response: CustomerControllerSetMigratedBillingTakeover200;
    Request: CustomerControllerSetMigratedBillingTakeoverMutationRequest;
    PathParams: CustomerControllerSetMigratedBillingTakeoverPathParams;
    Errors: any;
};

export type CustomerControllerUnlockMigratedBillingTakeoverPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
    /**
     * @description The policy id
     * @type string
    */
    policyId: string;
};

export type CustomerControllerUnlockMigratedBillingTakeover200 = UnlockMigratedBillingTakeoverOutput;

export type CustomerControllerUnlockMigratedBillingTakeoverMutationResponse = CustomerControllerUnlockMigratedBillingTakeover200;

export type CustomerControllerUnlockMigratedBillingTakeoverMutation = {
    Response: CustomerControllerUnlockMigratedBillingTakeover200;
    PathParams: CustomerControllerUnlockMigratedBillingTakeoverPathParams;
    Errors: any;
};

export type CustomerControllerCreateCustomerForPolicyPathParams = {
    /**
     * @description The policy id to attach the new customer to
     * @type string
    */
    policyId: string;
};

export type CustomerControllerCreateCustomerForPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type CustomerControllerCreateCustomerForPolicy201 = CreateCustomerForPolicyOutput;

export type CustomerControllerCreateCustomerForPolicy404 = PolicyNotFoundErrorDto;

export type CustomerControllerCreateCustomerForPolicyMutationRequest = CreateCustomerForPolicyInputBody;

export type CustomerControllerCreateCustomerForPolicyMutationResponse = CustomerControllerCreateCustomerForPolicy201;

export type CustomerControllerCreateCustomerForPolicyMutation = {
    Response: CustomerControllerCreateCustomerForPolicy201;
    Request: CustomerControllerCreateCustomerForPolicyMutationRequest;
    PathParams: CustomerControllerCreateCustomerForPolicyPathParams;
    QueryParams: CustomerControllerCreateCustomerForPolicyQueryParams;
    Errors: CustomerControllerCreateCustomerForPolicy404;
};

export type CustomerControllerDeleteCustomerFromPolicyPathParams = {
    /**
     * @description The policy id
     * @type string
    */
    policyId: string;
    /**
     * @description The customer id to delete
     * @type string
    */
    customerId: string;
};

export type CustomerControllerDeleteCustomerFromPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type CustomerControllerDeleteCustomerFromPolicy200 = DeleteCustomerFromPolicyOutput;

export type CustomerControllerDeleteCustomerFromPolicy403 = ForbiddenErrorDto;

export type CustomerControllerDeleteCustomerFromPolicy404 = (PolicyNotFoundErrorDto | CustomerNotFoundErrorDto);

export type CustomerControllerDeleteCustomerFromPolicy409 = (CannotDeleteLastCustomerErrorDto | ConflictingPolicyStatusErrorDto);

export type CustomerControllerDeleteCustomerFromPolicyMutationResponse = CustomerControllerDeleteCustomerFromPolicy200;

export type CustomerControllerDeleteCustomerFromPolicyMutation = {
    Response: CustomerControllerDeleteCustomerFromPolicy200;
    PathParams: CustomerControllerDeleteCustomerFromPolicyPathParams;
    QueryParams: CustomerControllerDeleteCustomerFromPolicyQueryParams;
    Errors: CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409;
};

export type DebugControllerClearTestData201 = ClearLegacyTestDataOutputDto;

export type DebugControllerClearTestDataMutationResponse = DebugControllerClearTestData201;

export type DebugControllerClearTestDataMutation = {
    Response: DebugControllerClearTestData201;
    Errors: any;
};

export type DebugControllerClearProjectionsDataQueryParams = {
    /**
     * @type boolean | undefined
    */
    rebuild?: boolean;
    /**
     * @type number | undefined
    */
    timeout?: number;
};

export type DebugControllerClearProjectionsData201 = ClearLegacyProjectionsDataOutputDto;

export type DebugControllerClearProjectionsDataMutationResponse = DebugControllerClearProjectionsData201;

export type DebugControllerClearProjectionsDataMutation = {
    Response: DebugControllerClearProjectionsData201;
    QueryParams: DebugControllerClearProjectionsDataQueryParams;
    Errors: any;
};

export type DebugControllerClearLegacyCacheQueryParams = {
    /**
     * @description Cache key prefix to clear
     * @type string | undefined
    */
    prefix?: string;
    /**
     * @description Specify to clear only expired cache entries
     * @type boolean | undefined
    */
    expired?: boolean;
};

export type DebugControllerClearLegacyCache201 = ClearLegacyCacheOutputDto;

export type DebugControllerClearLegacyCacheMutationResponse = DebugControllerClearLegacyCache201;

export type DebugControllerClearLegacyCacheMutation = {
    Response: DebugControllerClearLegacyCache201;
    QueryParams: DebugControllerClearLegacyCacheQueryParams;
    Errors: any;
};

export const debugControllerGetProjectionsPathParamsProjectionTableEnum = {
    coreAggregatesProjection: "coreAggregatesProjection",
    policyAggregateProjection: "policyAggregateProjection",
    policyAggregateFlowProjection: "policyAggregateFlowProjection",
    customerAggregateProjection: "customerAggregateProjection",
    customerAggregateFlowProjection: "customerAggregateFlowProjection",
    assetAggregateProjection: "assetAggregateProjection",
    assetAggregateFlowProjection: "assetAggregateFlowProjection",
    migratedBillingTakeoverProjection: "migratedBillingTakeoverProjection",
    coreAggregatesFlowProjection: "coreAggregatesFlowProjection"
} as const;

export type DebugControllerGetProjectionsPathParamsProjectionTableEnumKey = (typeof debugControllerGetProjectionsPathParamsProjectionTableEnum)[keyof typeof debugControllerGetProjectionsPathParamsProjectionTableEnum];

export type DebugControllerGetProjectionsPathParams = {
    /**
     * @description Projection table to get
     * @type string
    */
    projectionTable: DebugControllerGetProjectionsPathParamsProjectionTableEnumKey;
};

export type DebugControllerGetProjectionsQueryParams = {
    /**
     * @type string
    */
    resourceId: string;
};

export type DebugControllerGetProjections200 = GetProjectionsOutput;

export type DebugControllerGetProjectionsQueryResponse = DebugControllerGetProjections200;

export type DebugControllerGetProjectionsQuery = {
    Response: DebugControllerGetProjections200;
    PathParams: DebugControllerGetProjectionsPathParams;
    QueryParams: DebugControllerGetProjectionsQueryParams;
    Errors: any;
};

export type DebugControllerCountCoreEventsPathParams = {
    /**
     * @type string
    */
    aggregateId: string;
};

export type DebugControllerCountCoreEventsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @type string | undefined
    */
    eventType?: string;
};

export type DebugControllerCountCoreEvents200 = CountCoreEventsOutput;

export type DebugControllerCountCoreEventsQueryResponse = DebugControllerCountCoreEvents200;

export type DebugControllerCountCoreEventsQuery = {
    Response: DebugControllerCountCoreEvents200;
    PathParams: DebugControllerCountCoreEventsPathParams;
    QueryParams: DebugControllerCountCoreEventsQueryParams;
    Errors: any;
};

export type DebugControllerToggleIgnoreCoreEvents201 = ToggleIgnoreCoreEventsOutput;

export type DebugControllerToggleIgnoreCoreEventsMutationRequest = ToggleIgnoreCoreEventsInputBody;

export type DebugControllerToggleIgnoreCoreEventsMutationResponse = DebugControllerToggleIgnoreCoreEvents201;

export type DebugControllerToggleIgnoreCoreEventsMutation = {
    Response: DebugControllerToggleIgnoreCoreEvents201;
    Request: DebugControllerToggleIgnoreCoreEventsMutationRequest;
    Errors: any;
};

export type DebugControllerBillCustomerPathParams = {
    /**
     * @description Customer id
     * @type string
    */
    customerId: string;
};

export type DebugControllerBillCustomerQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type boolean | undefined
    */
    bypass?: boolean;
    /**
     * @description If true, the invoice will not be replaced even if it is unpaid
     * @type boolean | undefined
    */
    shouldNotReplace?: boolean;
};

export type DebugControllerBillCustomer201 = BillCustomerOutput;

export type DebugControllerBillCustomerMutationResponse = DebugControllerBillCustomer201;

export type DebugControllerBillCustomerMutation = {
    Response: DebugControllerBillCustomer201;
    PathParams: DebugControllerBillCustomerPathParams;
    QueryParams: DebugControllerBillCustomerQueryParams;
    Errors: any;
};

export type DebugControllerBatchBillCustomersQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type boolean | undefined
    */
    bypass?: boolean;
    /**
     * @description If true, the invoice will not be replaced even if it is unpaid
     * @type boolean | undefined
    */
    shouldNotReplace?: boolean;
};

export type DebugControllerBatchBillCustomers201 = BatchBillCustomersOutput;

export type DebugControllerBatchBillCustomersMutationRequest = BatchBillCustomersInputBody;

export type DebugControllerBatchBillCustomersMutationResponse = DebugControllerBatchBillCustomers201;

export type DebugControllerBatchBillCustomersMutation = {
    Response: DebugControllerBatchBillCustomers201;
    Request: DebugControllerBatchBillCustomersMutationRequest;
    QueryParams: DebugControllerBatchBillCustomersQueryParams;
    Errors: any;
};

export type DebugControllerBatchChargeInvoices201 = DebugRetryChargeOutput;

export type DebugControllerBatchChargeInvoicesMutationRequest = DebugRetryChargeInputBody;

export type DebugControllerBatchChargeInvoicesMutationResponse = DebugControllerBatchChargeInvoices201;

export type DebugControllerBatchChargeInvoicesMutation = {
    Response: DebugControllerBatchChargeInvoices201;
    Request: DebugControllerBatchChargeInvoicesMutationRequest;
    Errors: any;
};

export type DebugControllerStartDailyStagingCleanup201 = any;

export type DebugControllerStartDailyStagingCleanupMutationResponse = DebugControllerStartDailyStagingCleanup201;

export type DebugControllerStartDailyStagingCleanupMutation = {
    Response: DebugControllerStartDailyStagingCleanup201;
    Errors: any;
};

export type DebugControllerCreateDistributionRequestsAndFees201 = CreateDistributionRequestsAndFeesOutput;

export type DebugControllerCreateDistributionRequestsAndFeesMutationRequest = CreateDistributionRequestsAndFeesBody;

export type DebugControllerCreateDistributionRequestsAndFeesMutationResponse = DebugControllerCreateDistributionRequestsAndFees201;

export type DebugControllerCreateDistributionRequestsAndFeesMutation = {
    Response: DebugControllerCreateDistributionRequestsAndFees201;
    Request: DebugControllerCreateDistributionRequestsAndFeesMutationRequest;
    Errors: any;
};

export type DebugControllerCreatePaymentFromStripe201 = CreatePaymentFromStripeOutput;

export type DebugControllerCreatePaymentFromStripeMutationRequest = CreatePaymentFromStripeInputBody;

export type DebugControllerCreatePaymentFromStripeMutationResponse = DebugControllerCreatePaymentFromStripe201;

export type DebugControllerCreatePaymentFromStripeMutation = {
    Response: DebugControllerCreatePaymentFromStripe201;
    Request: DebugControllerCreatePaymentFromStripeMutationRequest;
    Errors: any;
};

export type DebugControllerUpdatePaymentStatus201 = UpdatePaymentStatusOutput;

export type DebugControllerUpdatePaymentStatusMutationRequest = UpdatePaymentStatusInputBody;

export type DebugControllerUpdatePaymentStatusMutationResponse = DebugControllerUpdatePaymentStatus201;

export type DebugControllerUpdatePaymentStatusMutation = {
    Response: DebugControllerUpdatePaymentStatus201;
    Request: DebugControllerUpdatePaymentStatusMutationRequest;
    Errors: any;
};

export type DebugControllerRefreshInvoiceStatus201 = RefreshInvoiceStatusOutput;

export type DebugControllerRefreshInvoiceStatusMutationRequest = RefreshInvoiceStatusInputBody;

export type DebugControllerRefreshInvoiceStatusMutationResponse = DebugControllerRefreshInvoiceStatus201;

export type DebugControllerRefreshInvoiceStatusMutation = {
    Response: DebugControllerRefreshInvoiceStatus201;
    Request: DebugControllerRefreshInvoiceStatusMutationRequest;
    Errors: any;
};

export type DebugControllerBatchGenerateDocuments201 = BatchGenerateDocumentsOutput;

export type DebugControllerBatchGenerateDocumentsMutationRequest = BatchGenerateDocumentsInputBody;

export type DebugControllerBatchGenerateDocumentsMutationResponse = DebugControllerBatchGenerateDocuments201;

export type DebugControllerBatchGenerateDocumentsMutation = {
    Response: DebugControllerBatchGenerateDocuments201;
    Request: DebugControllerBatchGenerateDocumentsMutationRequest;
    Errors: any;
};

export type DebugControllerBatchCreateUserRelations201 = BatchCreateUserRelationsOutput;

export type DebugControllerBatchCreateUserRelationsMutationRequest = BatchCreateUserRelationsInputBody;

export type DebugControllerBatchCreateUserRelationsMutationResponse = DebugControllerBatchCreateUserRelations201;

export type DebugControllerBatchCreateUserRelationsMutation = {
    Response: DebugControllerBatchCreateUserRelations201;
    Request: DebugControllerBatchCreateUserRelationsMutationRequest;
    Errors: any;
};

export type DebugControllerCheckAllDocuments201 = CheckAllDocumentsOutput;

export type DebugControllerCheckAllDocumentsMutationRequest = CheckAllDocumentsInput;

export type DebugControllerCheckAllDocumentsMutationResponse = DebugControllerCheckAllDocuments201;

export type DebugControllerCheckAllDocumentsMutation = {
    Response: DebugControllerCheckAllDocuments201;
    Request: DebugControllerCheckAllDocumentsMutationRequest;
    Errors: any;
};

export type DebugControllerRetriggerClaimDocumentFraudCheck201 = RetriggerClaimDocumentFraudCheckOutput;

export type DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest = RetriggerClaimDocumentFraudCheckInputBody;

export type DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse = DebugControllerRetriggerClaimDocumentFraudCheck201;

export type DebugControllerRetriggerClaimDocumentFraudCheckMutation = {
    Response: DebugControllerRetriggerClaimDocumentFraudCheck201;
    Request: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest;
    Errors: any;
};

export type DebugControllerSuperDeletePoliciesPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type DebugControllerSuperDeletePolicies200 = SuperDeletePoliciesOutputDto;

export type DebugControllerSuperDeletePoliciesMutationResponse = DebugControllerSuperDeletePolicies200;

export type DebugControllerSuperDeletePoliciesMutation = {
    Response: DebugControllerSuperDeletePolicies200;
    PathParams: DebugControllerSuperDeletePoliciesPathParams;
    Errors: any;
};

export type DocumentsControllerValidateAndProcessDocumentQueryParams = {
    /**
     * @type string
    */
    key: string;
    /**
     * @description Bypass FILE_ALREADY_UPLOADED on an existing document and re-run the AI pipeline (classify/extract/validity). The legacy upload event is not re-published.
     * @type boolean | undefined
    */
    force?: boolean;
};

export type DocumentsControllerValidateAndProcessDocument200 = any;

export type DocumentsControllerValidateAndProcessDocumentQueryResponse = DocumentsControllerValidateAndProcessDocument200;

export type DocumentsControllerValidateAndProcessDocumentQuery = {
    Response: DocumentsControllerValidateAndProcessDocument200;
    QueryParams: DocumentsControllerValidateAndProcessDocumentQueryParams;
    Errors: any;
};

export type DocumentsControllerGetDocumentsQueryParams = {
    /**
     * @description the document ids to retrieve
     * @type array
    */
    ids: string[];
    /**
     * @description include deleted documents
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description force download disposition for signed URLs (attachment instead of inline)
     * @type boolean | undefined
    */
    forceDownload?: boolean;
};

export type DocumentsControllerGetDocuments200 = GetDocumentsOutput;

export type DocumentsControllerGetDocumentsQueryResponse = DocumentsControllerGetDocuments200;

export type DocumentsControllerGetDocumentsQuery = {
    Response: DocumentsControllerGetDocuments200;
    QueryParams: DocumentsControllerGetDocumentsQueryParams;
    Errors: any;
};

export type DocumentsControllerGenerateDocumentUploadUrls201 = GenerateDocumentUploadUrlOutput;

export type DocumentsControllerGenerateDocumentUploadUrlsMutationRequest = GenerateDocumentUploadUrlInputBody;

export type DocumentsControllerGenerateDocumentUploadUrlsMutationResponse = DocumentsControllerGenerateDocumentUploadUrls201;

export type DocumentsControllerGenerateDocumentUploadUrlsMutation = {
    Response: DocumentsControllerGenerateDocumentUploadUrls201;
    Request: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest;
    Errors: any;
};

export type DocumentsControllerDeleteDocumentsQueryParams = {
    /**
     * @description the document ids to delete
     * @type array
    */
    ids: string[];
};

export type DocumentsControllerDeleteDocuments200 = DeleteDocumentsOutput;

export type DocumentsControllerDeleteDocumentsMutationResponse = DocumentsControllerDeleteDocuments200;

export type DocumentsControllerDeleteDocumentsMutation = {
    Response: DocumentsControllerDeleteDocuments200;
    QueryParams: DocumentsControllerDeleteDocumentsQueryParams;
    Errors: any;
};

export type DocumentsControllerArchiveDocuments201 = ArchiveDocumentsOutput;

export type DocumentsControllerArchiveDocuments403 = ForbiddenErrorDto;

export type DocumentsControllerArchiveDocuments404 = DocumentNotFoundErrorDto;

export type DocumentsControllerArchiveDocumentsMutationRequest = ArchiveDocumentsInputBody;

export type DocumentsControllerArchiveDocumentsMutationResponse = DocumentsControllerArchiveDocuments201;

export type DocumentsControllerArchiveDocumentsMutation = {
    Response: DocumentsControllerArchiveDocuments201;
    Request: DocumentsControllerArchiveDocumentsMutationRequest;
    Errors: DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404;
};

export type DocumentsControllerRestoreDocuments201 = RestoreDocumentsOutput;

export type DocumentsControllerRestoreDocuments403 = ForbiddenErrorDto;

export type DocumentsControllerRestoreDocuments404 = DocumentNotFoundErrorDto;

export type DocumentsControllerRestoreDocumentsMutationRequest = RestoreDocumentsInputBody;

export type DocumentsControllerRestoreDocumentsMutationResponse = DocumentsControllerRestoreDocuments201;

export type DocumentsControllerRestoreDocumentsMutation = {
    Response: DocumentsControllerRestoreDocuments201;
    Request: DocumentsControllerRestoreDocumentsMutationRequest;
    Errors: DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404;
};

export type DocumentsControllerSetDocumentCategoryPathParams = {
    /**
     * @description the document id to patch metadata
     * @type string
    */
    documentId: string;
};

export type DocumentsControllerSetDocumentCategory200 = SetDocumentCategoryOutput;

export type DocumentsControllerSetDocumentCategory400 = DuplicateNonDelegatedDocumentTypeErrorDto;

export type DocumentsControllerSetDocumentCategory403 = ForbiddenErrorDto;

export type DocumentsControllerSetDocumentCategory404 = DocumentNotFoundErrorDto;

export type DocumentsControllerSetDocumentCategoryMutationRequest = SetDocumentCategoryInputBody;

export type DocumentsControllerSetDocumentCategoryMutationResponse = DocumentsControllerSetDocumentCategory200;

export type DocumentsControllerSetDocumentCategoryMutation = {
    Response: DocumentsControllerSetDocumentCategory200;
    Request: DocumentsControllerSetDocumentCategoryMutationRequest;
    PathParams: DocumentsControllerSetDocumentCategoryPathParams;
    Errors: DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404;
};

export type DocumentsControllerListDocumentsWithPresignedUrl201 = ListDocumentsWithPresignedUrlOutput;

export type DocumentsControllerListDocumentsWithPresignedUrlMutationRequest = ListDocumentsWithPresignedUrlInputBody;

export type DocumentsControllerListDocumentsWithPresignedUrlMutationResponse = DocumentsControllerListDocumentsWithPresignedUrl201;

export type DocumentsControllerListDocumentsWithPresignedUrlMutation = {
    Response: DocumentsControllerListDocumentsWithPresignedUrl201;
    Request: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest;
    Errors: any;
};

export type DocumentsControllerCreatePdf201 = GenerateDocumentPdfOutput;

export type DocumentsControllerCreatePdfMutationRequest = GenerateDocumentPdfInputBody;

export type DocumentsControllerCreatePdfMutationResponse = DocumentsControllerCreatePdf201;

export type DocumentsControllerCreatePdfMutation = {
    Response: DocumentsControllerCreatePdf201;
    Request: DocumentsControllerCreatePdfMutationRequest;
    Errors: any;
};

export type DocumentsControllerScheduleHandleMalwareProtectionScanResult201 = any;

export type DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest = ScheduleHandleMalwareProtectionScanResultInputBody;

export type DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse = DocumentsControllerScheduleHandleMalwareProtectionScanResult201;

export type DocumentsControllerScheduleHandleMalwareProtectionScanResultMutation = {
    Response: DocumentsControllerScheduleHandleMalwareProtectionScanResult201;
    Request: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest;
    Errors: any;
};

export type HealthControllerIndex200 = any;

export type HealthControllerIndexQueryResponse = HealthControllerIndex200;

export type HealthControllerIndexQuery = {
    Response: HealthControllerIndex200;
    Errors: any;
};

export const healthControllerCheckPathParamsServiceEnum = {
    LEGACY: "LEGACY"
} as const;

export type HealthControllerCheckPathParamsServiceEnumKey = (typeof healthControllerCheckPathParamsServiceEnum)[keyof typeof healthControllerCheckPathParamsServiceEnum];

export type HealthControllerCheckPathParams = {
    /**
     * @type string
    */
    service: HealthControllerCheckPathParamsServiceEnumKey;
};

export type HealthControllerCheck200 = any;

export type HealthControllerCheckQueryResponse = HealthControllerCheck200;

export type HealthControllerCheckQuery = {
    Response: HealthControllerCheck200;
    PathParams: HealthControllerCheckPathParams;
    Errors: any;
};

export type InvitationControllerInvite201 = InviteOutput;

export type InvitationControllerInvite400 = (InvalidProductErrorDto | InvalidEmailErrorDto);

export type InvitationControllerInviteMutationRequest = InviteInputBody;

export type InvitationControllerInviteMutationResponse = InvitationControllerInvite201;

export type InvitationControllerInviteMutation = {
    Response: InvitationControllerInvite201;
    Request: InvitationControllerInviteMutationRequest;
    Errors: InvitationControllerInvite400;
};

export type InvitationControllerAdminInvite201 = InviteOutput;

export type InvitationControllerAdminInvite400 = (InvalidProductErrorDto | InvalidEmailErrorDto);

export type InvitationControllerAdminInviteMutationRequest = InviteInputBody;

export type InvitationControllerAdminInviteMutationResponse = InvitationControllerAdminInvite201;

export type InvitationControllerAdminInviteMutation = {
    Response: InvitationControllerAdminInvite201;
    Request: InvitationControllerAdminInviteMutationRequest;
    Errors: InvitationControllerAdminInvite400;
};

export type InvitationControllerBrokerInvite201 = InviteOutput;

export type InvitationControllerBrokerInvite400 = InvalidEmailErrorDto;

export type InvitationControllerBrokerInviteMutationRequest = BrokerInviteBody;

export type InvitationControllerBrokerInviteMutationResponse = InvitationControllerBrokerInvite201;

export type InvitationControllerBrokerInviteMutation = {
    Response: InvitationControllerBrokerInvite201;
    Request: InvitationControllerBrokerInviteMutationRequest;
    Errors: InvitationControllerBrokerInvite400;
};

export type InvitationControllerCreateAnonymousSessionQueryParams = {
    /**
     * @description Session id for resumption
     * @type string | undefined
    */
    sessionId?: string;
};

export type InvitationControllerCreateAnonymousSession201 = CreateAnonymousSessionOutput;

export type InvitationControllerCreateAnonymousSessionMutationResponse = InvitationControllerCreateAnonymousSession201;

export type InvitationControllerCreateAnonymousSessionMutation = {
    Response: InvitationControllerCreateAnonymousSession201;
    QueryParams: InvitationControllerCreateAnonymousSessionQueryParams;
    Errors: any;
};

export type InvitationControllerHandoffAnonymousSession201 = HandoffAnonymousSessionOutput;

export type InvitationControllerHandoffAnonymousSessionMutationRequest = HandoffAnonymousSessionBody;

export type InvitationControllerHandoffAnonymousSessionMutationResponse = InvitationControllerHandoffAnonymousSession201;

export type InvitationControllerHandoffAnonymousSessionMutation = {
    Response: InvitationControllerHandoffAnonymousSession201;
    Request: InvitationControllerHandoffAnonymousSessionMutationRequest;
    Errors: any;
};

export type InvitationControllerResolveAnonymousSessionEntities200 = ResolveAnonymousSessionEntitiesOutput;

export type InvitationControllerResolveAnonymousSessionEntitiesQueryResponse = InvitationControllerResolveAnonymousSessionEntities200;

export type InvitationControllerResolveAnonymousSessionEntitiesQuery = {
    Response: InvitationControllerResolveAnonymousSessionEntities200;
    Errors: any;
};

export type JobSchedulersControllerGetJobSchedulers200 = GetJobSchedulersBullMqOutput;

export type JobSchedulersControllerGetJobSchedulersQueryResponse = JobSchedulersControllerGetJobSchedulers200;

export type JobSchedulersControllerGetJobSchedulersQuery = {
    Response: JobSchedulersControllerGetJobSchedulers200;
    Errors: any;
};

export type JobSchedulersControllerList201 = ListJobSchedulersOutput;

export type JobSchedulersControllerListMutationRequest = ListJobSchedulersInput;

export type JobSchedulersControllerListMutationResponse = JobSchedulersControllerList201;

export type JobSchedulersControllerListMutation = {
    Response: JobSchedulersControllerList201;
    Request: JobSchedulersControllerListMutationRequest;
    Errors: any;
};

export type JobSchedulersControllerGetPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobSchedulersControllerGet200 = GetJobSchedulerOutput;

export type JobSchedulersControllerGet404 = JobSchedulerNotFoundErrorDto;

export type JobSchedulersControllerGetQueryResponse = JobSchedulersControllerGet200;

export type JobSchedulersControllerGetQuery = {
    Response: JobSchedulersControllerGet200;
    PathParams: JobSchedulersControllerGetPathParams;
    Errors: JobSchedulersControllerGet404;
};

export type JobSchedulersControllerUpsertPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobSchedulersControllerUpsert201 = UpsertJobSchedulerOutput;

export type JobSchedulersControllerUpsertMutationRequest = UpsertJobSchedulerBody;

export type JobSchedulersControllerUpsertMutationResponse = JobSchedulersControllerUpsert201;

export type JobSchedulersControllerUpsertMutation = {
    Response: JobSchedulersControllerUpsert201;
    Request: JobSchedulersControllerUpsertMutationRequest;
    PathParams: JobSchedulersControllerUpsertPathParams;
    Errors: any;
};

export type JobSchedulersControllerUpdatePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobSchedulersControllerUpdate200 = UpdateJobSchedulerOutput;

export type JobSchedulersControllerUpdate404 = JobSchedulerNotFoundErrorDto;

export type JobSchedulersControllerUpdateMutationRequest = UpdateJobSchedulerBody;

export type JobSchedulersControllerUpdateMutationResponse = JobSchedulersControllerUpdate200;

export type JobSchedulersControllerUpdateMutation = {
    Response: JobSchedulersControllerUpdate200;
    Request: JobSchedulersControllerUpdateMutationRequest;
    PathParams: JobSchedulersControllerUpdatePathParams;
    Errors: JobSchedulersControllerUpdate404;
};

export type JobSchedulersControllerDeletePathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobSchedulersControllerDelete200 = DeleteJobSchedulerOutput;

export type JobSchedulersControllerDelete404 = JobSchedulerNotFoundErrorDto;

export type JobSchedulersControllerDeleteMutationResponse = JobSchedulersControllerDelete200;

export type JobSchedulersControllerDeleteMutation = {
    Response: JobSchedulersControllerDelete200;
    PathParams: JobSchedulersControllerDeletePathParams;
    Errors: JobSchedulersControllerDelete404;
};

export type JobsControllerCreateJob201 = CreateJobOutput;

export type JobsControllerCreateJobMutationRequest = CreateJobInputBody;

export type JobsControllerCreateJobMutationResponse = JobsControllerCreateJob201;

export type JobsControllerCreateJobMutation = {
    Response: JobsControllerCreateJob201;
    Request: JobsControllerCreateJobMutationRequest;
    Errors: any;
};

export type JobsControllerCreateJobs201 = CreateJobsOutput;

export type JobsControllerCreateJobsMutationRequest = CreateJobsInput;

export type JobsControllerCreateJobsMutationResponse = JobsControllerCreateJobs201;

export type JobsControllerCreateJobsMutation = {
    Response: JobsControllerCreateJobs201;
    Request: JobsControllerCreateJobsMutationRequest;
    Errors: any;
};

export type JobsControllerUpdateJobPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobsControllerUpdateJob200 = UpdateJobOutput;

export type JobsControllerUpdateJobMutationRequest = UpdateJobInputBody;

export type JobsControllerUpdateJobMutationResponse = JobsControllerUpdateJob200;

export type JobsControllerUpdateJobMutation = {
    Response: JobsControllerUpdateJob200;
    Request: JobsControllerUpdateJobMutationRequest;
    PathParams: JobsControllerUpdateJobPathParams;
    Errors: any;
};

export type JobsControllerGetJobPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobsControllerGetJob200 = GetJobOutput;

export type JobsControllerGetJobQueryResponse = JobsControllerGetJob200;

export type JobsControllerGetJobQuery = {
    Response: JobsControllerGetJob200;
    PathParams: JobsControllerGetJobPathParams;
    Errors: any;
};

export type JobsControllerCancelJobPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type JobsControllerCancelJob200 = CancelJobOutput;

export type JobsControllerCancelJobMutationResponse = JobsControllerCancelJob200;

export type JobsControllerCancelJobMutation = {
    Response: JobsControllerCancelJob200;
    PathParams: JobsControllerCancelJobPathParams;
    Errors: any;
};

export type JobsControllerCancelJobs201 = CancelJobsOutput;

export type JobsControllerCancelJobsMutationRequest = CancelJobsInput;

export type JobsControllerCancelJobsMutationResponse = JobsControllerCancelJobs201;

export type JobsControllerCancelJobsMutation = {
    Response: JobsControllerCancelJobs201;
    Request: JobsControllerCancelJobsMutationRequest;
    Errors: any;
};

export type JobsControllerRetryJobs201 = RetryJobsOutput;

export type JobsControllerRetryJobsMutationRequest = RetryJobsInput;

export type JobsControllerRetryJobsMutationResponse = JobsControllerRetryJobs201;

export type JobsControllerRetryJobsMutation = {
    Response: JobsControllerRetryJobs201;
    Request: JobsControllerRetryJobsMutationRequest;
    Errors: any;
};

export type JobsControllerListJobs201 = ListJobsOutput;

export type JobsControllerListJobsMutationRequest = ListJobsInput;

export type JobsControllerListJobsMutationResponse = JobsControllerListJobs201;

export type JobsControllerListJobsMutation = {
    Response: JobsControllerListJobs201;
    Request: JobsControllerListJobsMutationRequest;
    Errors: any;
};

export type JobsControllerCountJobs201 = CountJobsOutput;

export type JobsControllerCountJobsMutationRequest = CountJobsInput;

export type JobsControllerCountJobsMutationResponse = JobsControllerCountJobs201;

export type JobsControllerCountJobsMutation = {
    Response: JobsControllerCountJobs201;
    Request: JobsControllerCountJobsMutationRequest;
    Errors: any;
};

export type JobsControllerClearJobsData201 = any;

export type JobsControllerClearJobsDataMutationResponse = JobsControllerClearJobsData201;

export type JobsControllerClearJobsDataMutation = {
    Response: JobsControllerClearJobsData201;
    Errors: any;
};

export type JobsControllerClearWorkflowsData201 = any;

export type JobsControllerClearWorkflowsDataMutationResponse = JobsControllerClearWorkflowsData201;

export type JobsControllerClearWorkflowsDataMutation = {
    Response: JobsControllerClearWorkflowsData201;
    Errors: any;
};

export type JobsControllerCancelPushProjectionJobs201 = any;

export type JobsControllerCancelPushProjectionJobsMutationResponse = JobsControllerCancelPushProjectionJobs201;

export type JobsControllerCancelPushProjectionJobsMutation = {
    Response: JobsControllerCancelPushProjectionJobs201;
    Errors: any;
};

export type QueueManagementControllerPause201 = QueuePauseOutput;

export type QueueManagementControllerPauseMutationResponse = QueueManagementControllerPause201;

export type QueueManagementControllerPauseMutation = {
    Response: QueueManagementControllerPause201;
    Errors: any;
};

export type QueueManagementControllerResume201 = QueueResumeOutput;

export type QueueManagementControllerResumeMutationResponse = QueueManagementControllerResume201;

export type QueueManagementControllerResumeMutation = {
    Response: QueueManagementControllerResume201;
    Errors: any;
};

export type QueueManagementControllerGetStatus200 = QueueStatusOutput;

export type QueueManagementControllerGetStatusQueryResponse = QueueManagementControllerGetStatus200;

export type QueueManagementControllerGetStatusQuery = {
    Response: QueueManagementControllerGetStatus200;
    Errors: any;
};

export type QueueManagementControllerPauseSinglePathParams = {
    /**
     * @type string
    */
    queueName: string;
};

export type QueueManagementControllerPauseSingle201 = SingleQueuePauseOutput;

export type QueueManagementControllerPauseSingleMutationResponse = QueueManagementControllerPauseSingle201;

export type QueueManagementControllerPauseSingleMutation = {
    Response: QueueManagementControllerPauseSingle201;
    PathParams: QueueManagementControllerPauseSinglePathParams;
    Errors: any;
};

export type QueueManagementControllerResumeSinglePathParams = {
    /**
     * @type string
    */
    queueName: string;
};

export type QueueManagementControllerResumeSingle201 = SingleQueueResumeOutput;

export type QueueManagementControllerResumeSingleMutationResponse = QueueManagementControllerResumeSingle201;

export type QueueManagementControllerResumeSingleMutation = {
    Response: QueueManagementControllerResumeSingle201;
    PathParams: QueueManagementControllerResumeSinglePathParams;
    Errors: any;
};

export type LegacyDocumentsControllerGenerateDocumentOnDemand201 = LegacyGenerateDocumentOutput;

export type LegacyDocumentsControllerGenerateDocumentOnDemand400 = InvalidProductErrorDto;

export type LegacyDocumentsControllerGenerateDocumentOnDemand404 = (DocumentConfigNotFoundErrorDto | CustomerNotFoundErrorDto | PolicyNotFoundErrorDto | AssetNotFoundErrorDto);

export type LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest = LegacyGenerateDocumentInputBody;

export type LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse = LegacyDocumentsControllerGenerateDocumentOnDemand201;

export type LegacyDocumentsControllerGenerateDocumentOnDemandMutation = {
    Response: LegacyDocumentsControllerGenerateDocumentOnDemand201;
    Request: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest;
    Errors: LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404;
};

export type LegacyDocumentsControllerGetOnDemandDocumentsQueryParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @type string
    */
    targetId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type LegacyDocumentsControllerGetOnDemandDocuments200 = GetOnDemandDocumentsOutput;

export type LegacyDocumentsControllerGetOnDemandDocuments400 = InvalidProductErrorDto;

export type LegacyDocumentsControllerGetOnDemandDocuments404 = (CustomerNotFoundErrorDto | PolicyNotFoundErrorDto | AssetNotFoundErrorDto);

export type LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse = LegacyDocumentsControllerGetOnDemandDocuments200;

export type LegacyDocumentsControllerGetOnDemandDocumentsQuery = {
    Response: LegacyDocumentsControllerGetOnDemandDocuments200;
    QueryParams: LegacyDocumentsControllerGetOnDemandDocumentsQueryParams;
    Errors: LegacyDocumentsControllerGetOnDemandDocuments400 | LegacyDocumentsControllerGetOnDemandDocuments404;
};

export type LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type LegacyDocumentsControllerGetExpectedGeneratedDocuments200 = GetExpectedGeneratedDocumentsOutput;

export type LegacyDocumentsControllerGetExpectedGeneratedDocuments400 = InvalidProductErrorDto;

export type LegacyDocumentsControllerGetExpectedGeneratedDocuments404 = PolicyNotFoundErrorDto;

export type LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse = LegacyDocumentsControllerGetExpectedGeneratedDocuments200;

export type LegacyDocumentsControllerGetExpectedGeneratedDocumentsQuery = {
    Response: LegacyDocumentsControllerGetExpectedGeneratedDocuments200;
    QueryParams: LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams;
    Errors: LegacyDocumentsControllerGetExpectedGeneratedDocuments400 | LegacyDocumentsControllerGetExpectedGeneratedDocuments404;
};

export type LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description A policy or brokerage firm id; the entity is read from its prefix
     * @type string
    */
    targetId: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type LegacyDocumentsControllerGetExpectedUploadedDocuments200 = GetExpectedUploadedDocumentsOutput;

export type LegacyDocumentsControllerGetExpectedUploadedDocuments400 = InvalidProductErrorDto;

export type LegacyDocumentsControllerGetExpectedUploadedDocuments404 = (PolicyNotFoundErrorDto | BrokerageFirmNotFoundErrorDto);

export type LegacyDocumentsControllerGetExpectedUploadedDocuments501 = TargetNotImplementedErrorDto;

export type LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse = LegacyDocumentsControllerGetExpectedUploadedDocuments200;

export type LegacyDocumentsControllerGetExpectedUploadedDocumentsQuery = {
    Response: LegacyDocumentsControllerGetExpectedUploadedDocuments200;
    QueryParams: LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams;
    Errors: LegacyDocumentsControllerGetExpectedUploadedDocuments400 | LegacyDocumentsControllerGetExpectedUploadedDocuments404 | LegacyDocumentsControllerGetExpectedUploadedDocuments501;
};

export type LegacyDocumentsControllerGetGenerationPayloadQueryParams = {
    /**
     * @type string
    */
    whenAt: string;
};

export type LegacyDocumentsControllerGetGenerationPayload201 = GetGenerationPayloadOutput;

export type LegacyDocumentsControllerGetGenerationPayload400 = InvalidProductErrorDto;

export type LegacyDocumentsControllerGetGenerationPayload404 = (DocumentConfigNotFoundErrorDto | PaymentMethodNotFoundErrorDto | InvoiceNotFoundErrorDto | CustomerNotFoundErrorDto | PolicyNotFoundErrorDto | AssetNotFoundErrorDto);

export type LegacyDocumentsControllerGetGenerationPayloadMutationRequest = LegacyGenerateDocumentInputBody;

export type LegacyDocumentsControllerGetGenerationPayloadMutationResponse = LegacyDocumentsControllerGetGenerationPayload201;

export type LegacyDocumentsControllerGetGenerationPayloadMutation = {
    Response: LegacyDocumentsControllerGetGenerationPayload201;
    Request: LegacyDocumentsControllerGetGenerationPayloadMutationRequest;
    QueryParams: LegacyDocumentsControllerGetGenerationPayloadQueryParams;
    Errors: LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404;
};

export type LegacyDocumentsControllerRegenerateDocument201 = RegenerateDocumentOutput;

export type LegacyDocumentsControllerRegenerateDocument404 = (DocumentNotFoundErrorDto | DocumentConfigNotFoundErrorDto | PolicyNotFoundErrorDto);

export type LegacyDocumentsControllerRegenerateDocument500 = FailedToGeneratePdfErrorDto;

export type LegacyDocumentsControllerRegenerateDocumentMutationRequest = RegenerateDocumentInputBody;

export type LegacyDocumentsControllerRegenerateDocumentMutationResponse = LegacyDocumentsControllerRegenerateDocument201;

export type LegacyDocumentsControllerRegenerateDocumentMutation = {
    Response: LegacyDocumentsControllerRegenerateDocument201;
    Request: LegacyDocumentsControllerRegenerateDocumentMutationRequest;
    Errors: LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500;
};

export type LockControllerListLocksQueryParams = {
    /**
     * @description the number of items to return
     * @maxLength 100
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type LockControllerListLocks200 = ListLocksOutputType;

export type LockControllerListLocksQueryResponse = LockControllerListLocks200;

export type LockControllerListLocksQuery = {
    Response: LockControllerListLocks200;
    QueryParams: LockControllerListLocksQueryParams;
    Errors: any;
};

export type LockControllerGetLockPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type LockControllerGetLock200 = GetLockOutputType;

export type LockControllerGetLockQueryResponse = LockControllerGetLock200;

export type LockControllerGetLockQuery = {
    Response: LockControllerGetLock200;
    PathParams: LockControllerGetLockPathParams;
    Errors: any;
};

export type LockControllerDeleteLockPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type LockControllerDeleteLock200 = DeleteLockOutputType;

export type LockControllerDeleteLockMutationResponse = LockControllerDeleteLock200;

export type LockControllerDeleteLockMutation = {
    Response: LockControllerDeleteLock200;
    PathParams: LockControllerDeleteLockPathParams;
    Errors: any;
};

export type LockControllerCreateLockPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type LockControllerCreateLock201 = CreateLockOutputType;

export type LockControllerCreateLockMutationRequest = CreateLockBody;

export type LockControllerCreateLockMutationResponse = LockControllerCreateLock201;

export type LockControllerCreateLockMutation = {
    Response: LockControllerCreateLock201;
    Request: LockControllerCreateLockMutationRequest;
    PathParams: LockControllerCreateLockPathParams;
    Errors: any;
};

export type LockControllerBatchCreateLocks201 = BatchCreateLocksOutputType;

export type LockControllerBatchCreateLocksMutationRequest = BatchCreateLocksBody;

export type LockControllerBatchCreateLocksMutationResponse = LockControllerBatchCreateLocks201;

export type LockControllerBatchCreateLocksMutation = {
    Response: LockControllerBatchCreateLocks201;
    Request: LockControllerBatchCreateLocksMutationRequest;
    Errors: any;
};

export type LockControllerBatchGetLocks201 = BatchGetLocksOutputType;

export type LockControllerBatchGetLocksMutationRequest = BatchGetLocksBody;

export type LockControllerBatchGetLocksMutationResponse = LockControllerBatchGetLocks201;

export type LockControllerBatchGetLocksMutation = {
    Response: LockControllerBatchGetLocks201;
    Request: LockControllerBatchGetLocksMutationRequest;
    Errors: any;
};

export type LockControllerBatchDeleteLocks201 = BatchDeleteLocksOutputType;

export type LockControllerBatchDeleteLocksMutationRequest = BatchDeleteLocksBody;

export type LockControllerBatchDeleteLocksMutationResponse = LockControllerBatchDeleteLocks201;

export type LockControllerBatchDeleteLocksMutation = {
    Response: LockControllerBatchDeleteLocks201;
    Request: LockControllerBatchDeleteLocksMutationRequest;
    Errors: any;
};

export type NotificationControllerSendEmail400 = InvalidProductErrorDto;

export type NotificationControllerSendEmailMutationRequest = SendEmailInput;

export type NotificationControllerSendEmailMutationResponse = any;

export type NotificationControllerSendEmailMutation = {
    Response: any;
    Request: NotificationControllerSendEmailMutationRequest;
    Errors: NotificationControllerSendEmail400;
};

export type NotificationControllerListEmailTemplatesQueryParams = {
    /**
     * @description Only the templates declared in this tenant\'s and its products\' configs.
     * @type string | undefined
    */
    filterTenantId?: string;
};

export type NotificationControllerListEmailTemplates200 = ListEmailTemplatesOutput;

export type NotificationControllerListEmailTemplatesQueryResponse = NotificationControllerListEmailTemplates200;

export type NotificationControllerListEmailTemplatesQuery = {
    Response: NotificationControllerListEmailTemplates200;
    QueryParams: NotificationControllerListEmailTemplatesQueryParams;
    Errors: any;
};

export type NotificationControllerRenderEmailTemplatePathParams = {
    /**
     * @type string
    */
    key: string;
};

export type NotificationControllerRenderEmailTemplate200 = RenderEmailTemplateOutput;

export type NotificationControllerRenderEmailTemplate404 = EmailTemplateNotFoundErrorDto;

export type NotificationControllerRenderEmailTemplateMutationRequest = RenderEmailTemplateBodyDto;

export type NotificationControllerRenderEmailTemplateMutationResponse = NotificationControllerRenderEmailTemplate200;

export type NotificationControllerRenderEmailTemplateMutation = {
    Response: NotificationControllerRenderEmailTemplate200;
    Request: NotificationControllerRenderEmailTemplateMutationRequest;
    PathParams: NotificationControllerRenderEmailTemplatePathParams;
    Errors: NotificationControllerRenderEmailTemplate404;
};

export type NotificationControllerSendTestEmailPathParams = {
    /**
     * @type string
    */
    key: string;
};

export type NotificationControllerSendTestEmail200 = SendTestEmailOutput;

export type NotificationControllerSendTestEmail404 = (EmailTemplateNotFoundErrorDto | UserEmailNotFoundErrorDto);

export type NotificationControllerSendTestEmailMutationRequest = SendTestEmailBodyDto;

export type NotificationControllerSendTestEmailMutationResponse = NotificationControllerSendTestEmail200;

export type NotificationControllerSendTestEmailMutation = {
    Response: NotificationControllerSendTestEmail200;
    Request: NotificationControllerSendTestEmailMutationRequest;
    PathParams: NotificationControllerSendTestEmailPathParams;
    Errors: NotificationControllerSendTestEmail404;
};

export const notificationControllerListNotificationsQueryParamsTypeEnum = {
    EMAIL: "EMAIL",
    LRE: "LRE",
    ERE: "ERE"
} as const;

export type NotificationControllerListNotificationsQueryParamsTypeEnumKey = (typeof notificationControllerListNotificationsQueryParamsTypeEnum)[keyof typeof notificationControllerListNotificationsQueryParamsTypeEnum];

export const notificationControllerListNotificationsQueryParamsStatusEnum = {
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    BOUNCED: "BOUNCED",
    COMPLAINED: "COMPLAINED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    NEGLECTED: "NEGLECTED"
} as const;

export type NotificationControllerListNotificationsQueryParamsStatusEnumKey = (typeof notificationControllerListNotificationsQueryParamsStatusEnum)[keyof typeof notificationControllerListNotificationsQueryParamsStatusEnum];

export type NotificationControllerListNotificationsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    externalId?: string;
    /**
     * @type string | undefined, date-time
    */
    before?: string;
    /**
     * @type string | undefined, date-time
    */
    after?: string;
    /**
     * @type string | undefined
    */
    type?: NotificationControllerListNotificationsQueryParamsTypeEnumKey;
    /**
     * @type string | undefined
    */
    status?: NotificationControllerListNotificationsQueryParamsStatusEnumKey;
    /**
     * @description Case-insensitive partial match on the recipient email address.
     * @type string | undefined
    */
    recipientEmail?: string;
    /**
     * @description Exact reason; EMAIL notifications store their template id here.
     * @type string | undefined
    */
    reason?: string;
    /**
     * @description Filter to a single tenant. Super-user only; ignored for regular users.
     * @type string | undefined
    */
    filterTenantId?: string;
};

export type NotificationControllerListNotifications200 = ListNotificationsOutput;

export type NotificationControllerListNotificationsQueryResponse = NotificationControllerListNotifications200;

export type NotificationControllerListNotificationsQuery = {
    Response: NotificationControllerListNotifications200;
    QueryParams: NotificationControllerListNotificationsQueryParams;
    Errors: any;
};

export type NotificationControllerCreateNotification201 = CreateNotificationOutput;

export type NotificationControllerCreateNotificationMutationRequest = CreateNotificationBodyDto;

export type NotificationControllerCreateNotificationMutationResponse = NotificationControllerCreateNotification201;

export type NotificationControllerCreateNotificationMutation = {
    Response: NotificationControllerCreateNotification201;
    Request: NotificationControllerCreateNotificationMutationRequest;
    Errors: any;
};

export type NotificationControllerGetNotificationPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type NotificationControllerGetNotification200 = GetNotificationOutput;

export type NotificationControllerGetNotification404 = NotificationNotFoundErrorDto;

export type NotificationControllerGetNotificationQueryResponse = NotificationControllerGetNotification200;

export type NotificationControllerGetNotificationQuery = {
    Response: NotificationControllerGetNotification200;
    PathParams: NotificationControllerGetNotificationPathParams;
    Errors: NotificationControllerGetNotification404;
};

export type NotificationControllerPatchNotificationPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type NotificationControllerPatchNotification200 = PatchNotificationOutput;

export type NotificationControllerPatchNotificationMutationRequest = PatchNotificationBodyDto;

export type NotificationControllerPatchNotificationMutationResponse = NotificationControllerPatchNotification200;

export type NotificationControllerPatchNotificationMutation = {
    Response: NotificationControllerPatchNotification200;
    Request: NotificationControllerPatchNotificationMutationRequest;
    PathParams: NotificationControllerPatchNotificationPathParams;
    Errors: any;
};

export type NotificationControllerDeleteNotificationPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type NotificationControllerDeleteNotification200 = DeleteNotificationOutput;

export type NotificationControllerDeleteNotificationMutationResponse = NotificationControllerDeleteNotification200;

export type NotificationControllerDeleteNotificationMutation = {
    Response: NotificationControllerDeleteNotification200;
    PathParams: NotificationControllerDeleteNotificationPathParams;
    Errors: any;
};

export type NotificationControllerSendNotification201 = SendNotificationOutput;

export type NotificationControllerSendNotification400 = (EreReasonNotSupportedErrorDto | FormalNoticeNotEnabledErrorDto | NonRenewalNotEnabledErrorDto);

export type NotificationControllerSendNotificationMutationRequest = SendNotificationBody;

export type NotificationControllerSendNotificationMutationResponse = NotificationControllerSendNotification201;

export type NotificationControllerSendNotificationMutation = {
    Response: NotificationControllerSendNotification201;
    Request: NotificationControllerSendNotificationMutationRequest;
    Errors: NotificationControllerSendNotification400;
};

export type PaymentsControllerCreateCustomer201 = CreateCustomerOutput;

export type PaymentsControllerCreateCustomerMutationRequest = CreateCustomerInputBody;

export type PaymentsControllerCreateCustomerMutationResponse = PaymentsControllerCreateCustomer201;

export type PaymentsControllerCreateCustomerMutation = {
    Response: PaymentsControllerCreateCustomer201;
    Request: PaymentsControllerCreateCustomerMutationRequest;
    Errors: any;
};

export type PaymentsControllerListCustomers201 = ListPaymentCustomersOutput;

export type PaymentsControllerListCustomersMutationRequest = ListPaymentCustomersInputBody;

export type PaymentsControllerListCustomersMutationResponse = PaymentsControllerListCustomers201;

export type PaymentsControllerListCustomersMutation = {
    Response: PaymentsControllerListCustomers201;
    Request: PaymentsControllerListCustomersMutationRequest;
    Errors: any;
};

export type PaymentsControllerCreatePayment201 = CreatePaymentOutput;

export type PaymentsControllerCreatePayment404 = PaymentMethodNotFoundErrorDto;

export type PaymentsControllerCreatePaymentMutationRequest = CreatePaymentInputBody;

export type PaymentsControllerCreatePaymentMutationResponse = PaymentsControllerCreatePayment201;

export type PaymentsControllerCreatePaymentMutation = {
    Response: PaymentsControllerCreatePayment201;
    Request: PaymentsControllerCreatePaymentMutationRequest;
    Errors: PaymentsControllerCreatePayment404;
};

export type PaymentsControllerGetPaymentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description the ids of the payments
     * @type array
    */
    ids: string[];
};

export type PaymentsControllerGetPayments200 = GetPaymentsOutput;

export type PaymentsControllerGetPaymentsQueryResponse = PaymentsControllerGetPayments200;

export type PaymentsControllerGetPaymentsQuery = {
    Response: PaymentsControllerGetPayments200;
    QueryParams: PaymentsControllerGetPaymentsQueryParams;
    Errors: any;
};

export type PaymentsControllerSetupIntent201 = SetupIntentOutput;

export type PaymentsControllerSetupIntent404 = StripeCustomerNotFoundErrorDto;

export type PaymentsControllerSetupIntentMutationRequest = SetupIntentInputBody;

export type PaymentsControllerSetupIntentMutationResponse = PaymentsControllerSetupIntent201;

export type PaymentsControllerSetupIntentMutation = {
    Response: PaymentsControllerSetupIntent201;
    Request: PaymentsControllerSetupIntentMutationRequest;
    Errors: PaymentsControllerSetupIntent404;
};

export type PaymentsControllerGetCustomersPaymentMethodsQueryParams = {
    /**
     * @description the id of the stripe customer
     * @type string
    */
    id: string;
};

export type PaymentsControllerGetCustomersPaymentMethods200 = GetCustomersPaymentMethodsOutput;

export type PaymentsControllerGetCustomersPaymentMethodsQueryResponse = PaymentsControllerGetCustomersPaymentMethods200;

export type PaymentsControllerGetCustomersPaymentMethodsQuery = {
    Response: PaymentsControllerGetCustomersPaymentMethods200;
    QueryParams: PaymentsControllerGetCustomersPaymentMethodsQueryParams;
    Errors: any;
};

export type PaymentsControllerGetCustomerPaymentsPathParams = {
    /**
     * @description the id of the stripe customer
     * @type string
    */
    customerId: string;
};

export type PaymentsControllerGetCustomerPaymentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PaymentsControllerGetCustomerPayments200 = GetCustomerPaymentsOutput;

export type PaymentsControllerGetCustomerPaymentsQueryResponse = PaymentsControllerGetCustomerPayments200;

export type PaymentsControllerGetCustomerPaymentsQuery = {
    Response: PaymentsControllerGetCustomerPayments200;
    PathParams: PaymentsControllerGetCustomerPaymentsPathParams;
    QueryParams: PaymentsControllerGetCustomerPaymentsQueryParams;
    Errors: any;
};

export type PaymentsControllerCancelPaymentPathParams = {
    /**
     * @description the id of the payment
     * @type string
    */
    paymentId: string;
};

export type PaymentsControllerCancelPayment201 = CancelPaymentOutput;

export type PaymentsControllerCancelPaymentMutationRequest = CancelPaymentInputBody;

export type PaymentsControllerCancelPaymentMutationResponse = PaymentsControllerCancelPayment201;

export type PaymentsControllerCancelPaymentMutation = {
    Response: PaymentsControllerCancelPayment201;
    Request: PaymentsControllerCancelPaymentMutationRequest;
    PathParams: PaymentsControllerCancelPaymentPathParams;
    Errors: any;
};

export type PaymentsControllerSoftDeletePaymentMethodPathParams = {
    /**
     * @description the id of the payment method to soft-delete
     * @type string
    */
    paymentMethodId: string;
};

export type PaymentsControllerSoftDeletePaymentMethod200 = SoftDeletePaymentMethodOutput;

export type PaymentsControllerSoftDeletePaymentMethodMutationResponse = PaymentsControllerSoftDeletePaymentMethod200;

export type PaymentsControllerSoftDeletePaymentMethodMutation = {
    Response: PaymentsControllerSoftDeletePaymentMethod200;
    PathParams: PaymentsControllerSoftDeletePaymentMethodPathParams;
    Errors: any;
};

export type PolicyControllerGetPolicyPathParams = {
    /**
     * @description the policy\'s id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerGetPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerGetPolicy200 = PolicyDto;

export type PolicyControllerGetPolicy403 = ForbiddenErrorDto;

export type PolicyControllerGetPolicy404 = PolicyNotFoundErrorDto;

export type PolicyControllerGetPolicyQueryResponse = PolicyControllerGetPolicy200;

export type PolicyControllerGetPolicyQuery = {
    Response: PolicyControllerGetPolicy200;
    PathParams: PolicyControllerGetPolicyPathParams;
    QueryParams: PolicyControllerGetPolicyQueryParams;
    Errors: PolicyControllerGetPolicy403 | PolicyControllerGetPolicy404;
};

export type PolicyControllerEditPolicyPathParams = {
    /**
     * @description the policy\'s id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerEditPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerEditPolicy200 = EditPolicyOutput;

export type PolicyControllerEditPolicy400 = (InvalidInvoicingConfigErrorDto | InvalidEventCreationDateErrorDto);

export type PolicyControllerEditPolicy403 = ForbiddenErrorDto;

export type PolicyControllerEditPolicy404 = PolicyNotFoundErrorDto;

export type PolicyControllerEditPolicy409 = (ConflictingPolicyStatusErrorDto | ConflictingBranchStatusErrorDto | FieldsDoNotMeetRequirementsErrorDto);

export type PolicyControllerEditPolicyMutationRequest = EditPolicyInputBody;

export type PolicyControllerEditPolicyMutationResponse = PolicyControllerEditPolicy200;

export type PolicyControllerEditPolicyMutation = {
    Response: PolicyControllerEditPolicy200;
    Request: PolicyControllerEditPolicyMutationRequest;
    PathParams: PolicyControllerEditPolicyPathParams;
    QueryParams: PolicyControllerEditPolicyQueryParams;
    Errors: PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409;
};

export type PolicyControllerGenerateIncrementalIdPathParams = {
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    policyId: string;
};

export type PolicyControllerGenerateIncrementalId201 = GenerateIncrementalPolicyIdOutput;

export type PolicyControllerGenerateIncrementalId400 = InvalidProductErrorDto;

export type PolicyControllerGenerateIncrementalIdMutationResponse = PolicyControllerGenerateIncrementalId201;

export type PolicyControllerGenerateIncrementalIdMutation = {
    Response: PolicyControllerGenerateIncrementalId201;
    PathParams: PolicyControllerGenerateIncrementalIdPathParams;
    Errors: PolicyControllerGenerateIncrementalId400;
};

export type PolicyControllerGenerateDocumentUploadUrlPathParams = {
    /**
     * @description the policy\'s id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerGenerateDocumentUploadUrlQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerGenerateDocumentUploadUrl201 = GenerateDocumentUploadUrlOutput;

export type PolicyControllerGenerateDocumentUploadUrl400 = (InvalidEventCreationDateErrorDto | InvalidNonDelegatedDocumentTypeErrorDto | DuplicateNonDelegatedDocumentTypeErrorDto);

export type PolicyControllerGenerateDocumentUploadUrl403 = ForbiddenErrorDto;

export type PolicyControllerGenerateDocumentUploadUrl404 = (PolicyNotFoundErrorDto | NonDelegatedDocumentsConfigNotFoundErrorDto);

/**
 * @description Upload a supporting or non-delegated policy document. Set its role in type and its classification in category. For legacy requests, metadata.documenttype infers non_delegated when type is omitted and supplies a missing category only for non-delegated uploads. Explicit type and category take precedence. Legacy classification metadata is not stored.
*/
export type PolicyControllerGenerateDocumentUploadUrlMutationRequest = PolicyGenerateDocumentUploadUrlInputBody;

export type PolicyControllerGenerateDocumentUploadUrlMutationResponse = PolicyControllerGenerateDocumentUploadUrl201;

export type PolicyControllerGenerateDocumentUploadUrlMutation = {
    Response: PolicyControllerGenerateDocumentUploadUrl201;
    Request: PolicyControllerGenerateDocumentUploadUrlMutationRequest;
    PathParams: PolicyControllerGenerateDocumentUploadUrlPathParams;
    QueryParams: PolicyControllerGenerateDocumentUploadUrlQueryParams;
    Errors: PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404;
};

export type PolicyControllerListPolicyDocumentsPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerListPolicyDocumentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Are documents archives
     * @type boolean | undefined
    */
    archived?: boolean;
    /**
     * @description Are documents only on branch
     * @type boolean | undefined
    */
    onlyOnBranch?: boolean;
    /**
     * @description Include deleted documents
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
};

export type PolicyControllerListPolicyDocuments200 = ListPolicyDocumentsOutput;

export type PolicyControllerListPolicyDocuments403 = ForbiddenErrorDto;

export type PolicyControllerListPolicyDocuments404 = PolicyNotFoundErrorDto;

export type PolicyControllerListPolicyDocumentsQueryResponse = PolicyControllerListPolicyDocuments200;

export type PolicyControllerListPolicyDocumentsQuery = {
    Response: PolicyControllerListPolicyDocuments200;
    PathParams: PolicyControllerListPolicyDocumentsPathParams;
    QueryParams: PolicyControllerListPolicyDocumentsQueryParams;
    Errors: PolicyControllerListPolicyDocuments403 | PolicyControllerListPolicyDocuments404;
};

export type PolicyControllerDeletePolicyDocumentsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyControllerDeletePolicyDocumentsQueryParams = {
    /**
     * @description the document ids to delete
     * @type array
    */
    ids: string[];
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerDeletePolicyDocuments200 = DeletePolicyDocumentsOutput;

export type PolicyControllerDeletePolicyDocuments403 = ForbiddenErrorDto;

export type PolicyControllerDeletePolicyDocuments404 = (PolicyNotFoundErrorDto | DocumentNotFoundErrorDto);

export type PolicyControllerDeletePolicyDocumentsMutationResponse = PolicyControllerDeletePolicyDocuments200;

export type PolicyControllerDeletePolicyDocumentsMutation = {
    Response: PolicyControllerDeletePolicyDocuments200;
    PathParams: PolicyControllerDeletePolicyDocumentsPathParams;
    QueryParams: PolicyControllerDeletePolicyDocumentsQueryParams;
    Errors: PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404;
};

export type PolicyControllerEditPolicyExternalIdPathParams = {
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    policyId: string;
};

export type PolicyControllerEditPolicyExternalId201 = EditPolicyExternalIdOutput;

export type PolicyControllerEditPolicyExternalId409 = (ConflictingConfigErrorDto | ExternalIdAlreadyInUseErrorDto);

export type PolicyControllerEditPolicyExternalIdMutationRequest = EditPolicyExternalIdInputBody;

export type PolicyControllerEditPolicyExternalIdMutationResponse = PolicyControllerEditPolicyExternalId201;

export type PolicyControllerEditPolicyExternalIdMutation = {
    Response: PolicyControllerEditPolicyExternalId201;
    Request: PolicyControllerEditPolicyExternalIdMutationRequest;
    PathParams: PolicyControllerEditPolicyExternalIdPathParams;
    Errors: PolicyControllerEditPolicyExternalId409;
};

export type PolicyControllerConfirmPolicyPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerConfirmPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
    /**
     * @description Debug: force a quote to happen even if there are no changes to quote
     * @type boolean | undefined
    */
    skipValidation?: boolean;
};

export type PolicyControllerConfirmPolicy201 = ConfirmPolicyOutput;

export type PolicyControllerConfirmPolicy400 = (InvalidEventCreationDateErrorDto | InvalidConfirmationDateErrorDto);

export type PolicyControllerConfirmPolicy403 = ForbiddenErrorDto;

export type PolicyControllerConfirmPolicy404 = PolicyNotFoundErrorDto;

export type PolicyControllerConfirmPolicy409 = (ConflictingPolicyStatusErrorDto | ConflictingFieldDefinitionErrorDto | ConflictingBranchStatusErrorDto | InvoicingConfigNotSetErrorDto | NoChangesToSignErrorDto | FieldsDoNotMeetRequirementsErrorDto);

export type PolicyControllerConfirmPolicyMutationResponse = PolicyControllerConfirmPolicy201;

export type PolicyControllerConfirmPolicyMutation = {
    Response: PolicyControllerConfirmPolicy201;
    PathParams: PolicyControllerConfirmPolicyPathParams;
    QueryParams: PolicyControllerConfirmPolicyQueryParams;
    Errors: PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409;
};

export type PolicyControllerGeneratePolicySignatureRequestPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerGeneratePolicySignatureRequestQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerGeneratePolicySignatureRequest201 = GeneratePolicySignatureRequestOutput;

export type PolicyControllerGeneratePolicySignatureRequest400 = (NoSignedDocumentsOnProductErrorDto | InvalidEventCreationDateErrorDto);

export type PolicyControllerGeneratePolicySignatureRequest403 = ForbiddenErrorDto;

export type PolicyControllerGeneratePolicySignatureRequest404 = PolicyNotFoundErrorDto;

export type PolicyControllerGeneratePolicySignatureRequest409 = (NoValidPaymentMethodsErrorDto | ConflictingBranchStatusErrorDto | ConflictingBranchTypeErrorDto);

export type PolicyControllerGeneratePolicySignatureRequest425 = (NoUniqueDocumentTypeReadyToBeSignedErrorDto | NoDocumentReadyToBeSignedErrorDto);

export type PolicyControllerGeneratePolicySignatureRequestMutationRequest = GeneratePolicySignatureRequestInputBody;

export type PolicyControllerGeneratePolicySignatureRequestMutationResponse = PolicyControllerGeneratePolicySignatureRequest201;

export type PolicyControllerGeneratePolicySignatureRequestMutation = {
    Response: PolicyControllerGeneratePolicySignatureRequest201;
    Request: PolicyControllerGeneratePolicySignatureRequestMutationRequest;
    PathParams: PolicyControllerGeneratePolicySignatureRequestPathParams;
    QueryParams: PolicyControllerGeneratePolicySignatureRequestQueryParams;
    Errors: PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425;
};

export type PolicyControllerGetPremiumSchedulePathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerGetPremiumScheduleQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description when to start the premium schedule
     * @type string
    */
    startAt: string;
    /**
     * @description when to end the premium schedule
     * @type string | undefined
    */
    endAt?: string;
    /**
     * @type boolean | undefined
    */
    includeComponents?: boolean;
};

export type PolicyControllerGetPremiumSchedule200 = GetPremiumScheduleOutput;

export type PolicyControllerGetPremiumSchedule403 = ForbiddenErrorDto;

export type PolicyControllerGetPremiumSchedule404 = PolicyNotFoundErrorDto;

export type PolicyControllerGetPremiumScheduleQueryResponse = PolicyControllerGetPremiumSchedule200;

export type PolicyControllerGetPremiumScheduleQuery = {
    Response: PolicyControllerGetPremiumSchedule200;
    PathParams: PolicyControllerGetPremiumSchedulePathParams;
    QueryParams: PolicyControllerGetPremiumScheduleQueryParams;
    Errors: PolicyControllerGetPremiumSchedule403 | PolicyControllerGetPremiumSchedule404;
};

export type PolicyControllerListPolicyDocumentsAdminPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerListPolicyDocumentsAdminQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Are documents archives
     * @type boolean | undefined
    */
    archived?: boolean;
    /**
     * @description Are documents only on branch
     * @type boolean | undefined
    */
    onlyOnBranch?: boolean;
    /**
     * @description Include deleted documents
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
};

export type PolicyControllerListPolicyDocumentsAdmin200 = ListPolicyDocumentsOutput;

export type PolicyControllerListPolicyDocumentsAdmin403 = ForbiddenErrorDto;

export type PolicyControllerListPolicyDocumentsAdmin404 = PolicyNotFoundErrorDto;

export type PolicyControllerListPolicyDocumentsAdminQueryResponse = PolicyControllerListPolicyDocumentsAdmin200;

export type PolicyControllerListPolicyDocumentsAdminQuery = {
    Response: PolicyControllerListPolicyDocumentsAdmin200;
    PathParams: PolicyControllerListPolicyDocumentsAdminPathParams;
    QueryParams: PolicyControllerListPolicyDocumentsAdminQueryParams;
    Errors: PolicyControllerListPolicyDocumentsAdmin403 | PolicyControllerListPolicyDocumentsAdmin404;
};

export type PolicyControllerListPolicyEventsPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerListPolicyEvents200 = ListPolicyEventsOutput;

export type PolicyControllerListPolicyEvents404 = PolicyNotFoundErrorDto;

export type PolicyControllerListPolicyEventsQueryResponse = PolicyControllerListPolicyEvents200;

export type PolicyControllerListPolicyEventsQuery = {
    Response: PolicyControllerListPolicyEvents200;
    PathParams: PolicyControllerListPolicyEventsPathParams;
    Errors: PolicyControllerListPolicyEvents404;
};

export type PolicyControllerPushPolicyEventPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerPushPolicyEventQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branch id
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerPushPolicyEvent201 = PushEventOutput;

export type PolicyControllerPushPolicyEvent400 = InvalidEventTypeErrorDto;

export type PolicyControllerPushPolicyEvent404 = PolicyNotFoundErrorDto;

export type PolicyControllerPushPolicyEventMutationRequest = PushEventInputBody;

export type PolicyControllerPushPolicyEventMutationResponse = PolicyControllerPushPolicyEvent201;

export type PolicyControllerPushPolicyEventMutation = {
    Response: PolicyControllerPushPolicyEvent201;
    Request: PolicyControllerPushPolicyEventMutationRequest;
    PathParams: PolicyControllerPushPolicyEventPathParams;
    QueryParams: PolicyControllerPushPolicyEventQueryParams;
    Errors: PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404;
};

export type PolicyControllerPlanTasksPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyControllerPlanTasksQueryParams = {
    /**
     * @description the day to plan from, ISO-8601; defaults to today
     * @type string | undefined
    */
    from?: string;
    /**
     * @description consecutive days to plan from \"from\"
     * @minLength 1
     * @maxLength 366
     * @default 1
     * @type number | undefined
    */
    days?: number;
};

export type PolicyControllerPlanTasks200 = PlanTasksOutput;

export type PolicyControllerPlanTasks403 = ForbiddenErrorDto;

export type PolicyControllerPlanTasks404 = PolicyNotFoundErrorDto;

export type PolicyControllerPlanTasksQueryResponse = PolicyControllerPlanTasks200;

export type PolicyControllerPlanTasksQuery = {
    Response: PolicyControllerPlanTasks200;
    PathParams: PolicyControllerPlanTasksPathParams;
    QueryParams: PolicyControllerPlanTasksQueryParams;
    Errors: PolicyControllerPlanTasks403 | PolicyControllerPlanTasks404;
};

export type PolicyControllerQuotePolicyPathParams = {
    /**
     * @description the policy\'s id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerQuotePolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
};

export type PolicyControllerQuotePolicy201 = PolicyQuoteOutput;

export type PolicyControllerQuotePolicy400 = (InvalidProductErrorDto | InvalidEventCreationDateErrorDto | InvalidCustomFieldsErrorDto | MissingAssetOptionsErrorDto | InvalidPricingDetailsErrorDto | InvalidQuoteOptionsInvalidPerilOptionErrorDto | InvalidQuoteOptionsMissingRequiredPerilsErrorDto | InvalidQuoteOptionsTierAndExcessErrorDto);

export type PolicyControllerQuotePolicy403 = ForbiddenErrorDto;

export type PolicyControllerQuotePolicy404 = (PolicyNotFoundErrorDto | QuoteNotFoundErrorDto | BrokerageFirmNotFoundErrorDto | BranchNotFoundErrorDto | BranchNotFoundErrorDto);

export type PolicyControllerQuotePolicy409 = (ConflictingContractTypeErrorDto | ConflictingPolicyStatusErrorDto | ConflictingBranchStatusErrorDto | ConflictingFieldDefinitionErrorDto | FieldsDoNotMeetRequirementsErrorDto | QuoteFailedErrorDto | CfdpPricingEngineChangedErrorDto | NoChangesToQuoteErrorDto);

export type PolicyControllerQuotePolicyMutationRequest = PolicyQuoteBodyInput;

export type PolicyControllerQuotePolicyMutationResponse = PolicyControllerQuotePolicy201;

export type PolicyControllerQuotePolicyMutation = {
    Response: PolicyControllerQuotePolicy201;
    Request: PolicyControllerQuotePolicyMutationRequest;
    PathParams: PolicyControllerQuotePolicyPathParams;
    QueryParams: PolicyControllerQuotePolicyQueryParams;
    Errors: PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409;
};

export type PolicyControllerGetAggregateQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description the aggregate id
     * @type string
    */
    aggregateId: string;
};

export type PolicyControllerGetAggregate200 = GetAggregateOutput;

export type PolicyControllerGetAggregate404 = PolicyNotFoundErrorDto;

export type PolicyControllerGetAggregateQueryResponse = PolicyControllerGetAggregate200;

export type PolicyControllerGetAggregateQuery = {
    Response: PolicyControllerGetAggregate200;
    QueryParams: PolicyControllerGetAggregateQueryParams;
    Errors: PolicyControllerGetAggregate404;
};

export type PolicyControllerCalculatePolicyQuotePathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerCalculatePolicyQuoteQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerCalculatePolicyQuote201 = CalculatePolicyQuoteOutput;

export type PolicyControllerCalculatePolicyQuote400 = (InvalidPricingDetailsErrorDto | InvalidQuoteOptionsInvalidPerilOptionErrorDto | InvalidQuoteOptionsMissingRequiredPerilsErrorDto | InvalidQuoteOptionsTierAndExcessErrorDto | MissingAssetOptionsErrorDto);

export type PolicyControllerCalculatePolicyQuote404 = (PolicyNotFoundErrorDto | BranchNotFoundErrorDto);

export type PolicyControllerCalculatePolicyQuote409 = (ConflictingPolicyStatusErrorDto | ConflictingFieldDefinitionErrorDto | ConflictingContractTypeErrorDto | QuoteFailedErrorDto | CfdpPricingEngineChangedErrorDto);

export type PolicyControllerCalculatePolicyQuoteMutationRequest = CalculatePolicyQuoteInputBody;

export type PolicyControllerCalculatePolicyQuoteMutationResponse = PolicyControllerCalculatePolicyQuote201;

export type PolicyControllerCalculatePolicyQuoteMutation = {
    Response: PolicyControllerCalculatePolicyQuote201;
    Request: PolicyControllerCalculatePolicyQuoteMutationRequest;
    PathParams: PolicyControllerCalculatePolicyQuotePathParams;
    QueryParams: PolicyControllerCalculatePolicyQuoteQueryParams;
    Errors: PolicyControllerCalculatePolicyQuote400 | PolicyControllerCalculatePolicyQuote404 | PolicyControllerCalculatePolicyQuote409;
};

export type PolicyControllerStopPolicyPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerStopPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Save the request without committing to it: the stop is recorded on its branch so it can be resumed later, but coverage, billing and reporting are untouched and no execution is scheduled. Stop dates are not checked against the notice periods, since a draft is saved mid-funnel before one is picked. Saving again replaces the draft. Requires the branch stop model; without it the request fails with FEATURE_NOT_IMPLEMENTED.
     * @type boolean | undefined
    */
    draft?: boolean;
};

export type PolicyControllerStopPolicy201 = StopPolicyOutput;

export type PolicyControllerStopPolicy400 = (InvalidEventCreationDateErrorDto | InvalidStopReasonErrorDto | InvalidStopReasonDetailsErrorDto);

export type PolicyControllerStopPolicy403 = ForbiddenErrorDto;

export type PolicyControllerStopPolicy404 = PolicyNotFoundErrorDto;

export type PolicyControllerStopPolicy409 = ConflictingPolicyStatusErrorDto;

export type PolicyControllerStopPolicy501 = FeatureNotImplementedErrorDto;

export type PolicyControllerStopPolicyMutationRequest = StopPolicyInputBody;

export type PolicyControllerStopPolicyMutationResponse = PolicyControllerStopPolicy201;

export type PolicyControllerStopPolicyMutation = {
    Response: PolicyControllerStopPolicy201;
    Request: PolicyControllerStopPolicyMutationRequest;
    PathParams: PolicyControllerStopPolicyPathParams;
    QueryParams: PolicyControllerStopPolicyQueryParams;
    Errors: PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501;
};

export type PolicyControllerRegisterAdditionalQuoteComponentsPathParams = {
    /**
     * @description the policy\'s id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerRegisterAdditionalQuoteComponentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerRegisterAdditionalQuoteComponents201 = RegisterAdditionalQuoteComponentsOutput;

export type PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest = RegisterAdditionalQuoteComponentsInputBody;

export type PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse = PolicyControllerRegisterAdditionalQuoteComponents201;

export type PolicyControllerRegisterAdditionalQuoteComponentsMutation = {
    Response: PolicyControllerRegisterAdditionalQuoteComponents201;
    Request: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest;
    PathParams: PolicyControllerRegisterAdditionalQuoteComponentsPathParams;
    QueryParams: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams;
    Errors: any;
};

export type PolicyControllerUpdatePolicyQuotePathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyControllerUpdatePolicyQuoteQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
};

export type PolicyControllerUpdatePolicyQuote201 = UpdatePolicyQuoteOutput;

export type PolicyControllerUpdatePolicyQuote404 = PolicyNotFoundErrorDto;

export type PolicyControllerUpdatePolicyQuote409 = (ConflictingPolicyStatusErrorDto | ConflictingAdditionalQuoteComponentsErrorDto);

export type PolicyControllerUpdatePolicyQuoteMutationRequest = UpdatePolicyQuoteInputBody;

export type PolicyControllerUpdatePolicyQuoteMutationResponse = PolicyControllerUpdatePolicyQuote201;

export type PolicyControllerUpdatePolicyQuoteMutation = {
    Response: PolicyControllerUpdatePolicyQuote201;
    Request: PolicyControllerUpdatePolicyQuoteMutationRequest;
    PathParams: PolicyControllerUpdatePolicyQuotePathParams;
    QueryParams: PolicyControllerUpdatePolicyQuoteQueryParams;
    Errors: PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409;
};

export type PolicyControllerSuspendPolicyPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerSuspendPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type PolicyControllerSuspendPolicy201 = SuspendPolicyOutput;

export type PolicyControllerSuspendPolicy404 = PolicyNotFoundErrorDto;

export type PolicyControllerSuspendPolicy409 = ConflictingPolicyStatusErrorDto;

export type PolicyControllerSuspendPolicyMutationResponse = PolicyControllerSuspendPolicy201;

export type PolicyControllerSuspendPolicyMutation = {
    Response: PolicyControllerSuspendPolicy201;
    PathParams: PolicyControllerSuspendPolicyPathParams;
    QueryParams: PolicyControllerSuspendPolicyQueryParams;
    Errors: PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409;
};

export type PolicyControllerActivatePolicyPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerActivatePolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type PolicyControllerActivatePolicy201 = ActivatePolicyOutput;

export type PolicyControllerActivatePolicy400 = (InvalidActivationDateErrorDto | InvalidDateStringErrorDto);

export type PolicyControllerActivatePolicy404 = PolicyNotFoundErrorDto;

export type PolicyControllerActivatePolicy409 = ConflictingPolicyStatusErrorDto;

export type PolicyControllerActivatePolicyMutationRequest = ActivatePolicyInputBody;

export type PolicyControllerActivatePolicyMutationResponse = PolicyControllerActivatePolicy201;

export type PolicyControllerActivatePolicyMutation = {
    Response: PolicyControllerActivatePolicy201;
    Request: PolicyControllerActivatePolicyMutationRequest;
    PathParams: PolicyControllerActivatePolicyPathParams;
    QueryParams: PolicyControllerActivatePolicyQueryParams;
    Errors: PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409;
};

export type PolicyControllerSetPolicyFeesPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerSetPolicyFeesQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyControllerSetPolicyFees201 = SetPolicyFeesOutput;

export type PolicyControllerSetPolicyFees400 = (InvalidCommissionRangeErrorDto | InvalidBrokerageFeeErrorDto | InvalidTotalBrokerageFeeErrorDto);

export type PolicyControllerSetPolicyFees404 = PolicyNotFoundErrorDto;

export type PolicyControllerSetPolicyFeesMutationRequest = SetPolicyFeesBody;

export type PolicyControllerSetPolicyFeesMutationResponse = PolicyControllerSetPolicyFees201;

export type PolicyControllerSetPolicyFeesMutation = {
    Response: PolicyControllerSetPolicyFees201;
    Request: PolicyControllerSetPolicyFeesMutationRequest;
    PathParams: PolicyControllerSetPolicyFeesPathParams;
    QueryParams: PolicyControllerSetPolicyFeesQueryParams;
    Errors: PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404;
};

export type PolicyControllerManualQuotePolicyPathParams = {
    /**
     * @description the policy id
     * @type string
    */
    policyId: string;
};

export type PolicyControllerManualQuotePolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description the branchId
     * @type string
    */
    branchId: string;
};

export type PolicyControllerManualQuotePolicy201 = ManualQuotePolicyOutput;

export type PolicyControllerManualQuotePolicy400 = (InvalidProductErrorDto | InvalidEventCreationDateErrorDto);

export type PolicyControllerManualQuotePolicy404 = (PolicyNotFoundErrorDto | BranchNotFoundErrorDto);

export type PolicyControllerManualQuotePolicy409 = (ConflictingContractTypeErrorDto | ConflictingPolicyStatusErrorDto | ConflictingBranchStatusErrorDto);

export type PolicyControllerManualQuotePolicyMutationRequest = ManualQuotePolicyInputBody;

export type PolicyControllerManualQuotePolicyMutationResponse = PolicyControllerManualQuotePolicy201;

export type PolicyControllerManualQuotePolicyMutation = {
    Response: PolicyControllerManualQuotePolicy201;
    Request: PolicyControllerManualQuotePolicyMutationRequest;
    PathParams: PolicyControllerManualQuotePolicyPathParams;
    QueryParams: PolicyControllerManualQuotePolicyQueryParams;
    Errors: PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409;
};

export type PricingControllerComputePricingPathParams = {
    /**
     * @description Policy ID
     * @type string
    */
    policyId: string;
};

export type PricingControllerComputePricingQueryParams = {
    /**
     * @description Tier ID, as returned in `GET /policies/{policyId}/available-pricing`. Tiers are computed per policy, so there is no fixed list.
     * @type string
    */
    tierId: string;
    /**
     * @description Selected peril IDs
     * @type array | undefined
    */
    selectedPerilIds?: string[];
    /**
     * @description Peril parameter values as JSON string (e.g. {\"financialLossPerilSelected\":true})
     * @type string | undefined
    */
    policyCustomFieldsInputs?: string;
    /**
     * @description Branch ID (optional, defaults to latest)
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Filter assets active at this date (ISO-8601)
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Policy custom fields as JSON string (e.g. [{\"key\":\"insuredValue\",\"value\":\"RANGE_0_2500\"}])
     * @type string | undefined
    */
    policyCustomFields?: string;
    /**
     * @description Asset custom fields as JSON string (e.g. [{\"key\":\"equineValue\",\"value\":5000}])
     * @type string | undefined
    */
    assetCustomFields?: string;
    /**
     * @description Manual component values as a JSON-encoded string, e.g. {\"values\":{\"RETAIL_SUBSCRIPTION_FEE\":5000}}.
     * @type string | undefined
    */
    manualComponentValues?: string;
};

export type PricingControllerComputePricing200 = ComputePricingOutput;

export type PricingControllerComputePricing400 = InvalidPricingDetailsErrorDto;

export type PricingControllerComputePricing404 = PolicyNotFoundErrorDto;

export type PricingControllerComputePricingQueryResponse = PricingControllerComputePricing200;

export type PricingControllerComputePricingQuery = {
    Response: PricingControllerComputePricing200;
    PathParams: PricingControllerComputePricingPathParams;
    QueryParams: PricingControllerComputePricingQueryParams;
    Errors: PricingControllerComputePricing400 | PricingControllerComputePricing404;
};

export type PricingControllerGetPricePathParams = {
    /**
     * @description Policy ID
     * @type string
    */
    policyId: string;
};

export type PricingControllerGetPriceQueryParams = {
    /**
     * @description Branch ID (optional, defaults to latest)
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Filter assets active at this date (ISO-8601)
     * @type string | undefined
    */
    whenAt?: string;
};

export type PricingControllerGetPrice200 = GetPriceOutput;

export type PricingControllerGetPrice404 = PolicyNotFoundErrorDto;

export type PricingControllerGetPriceQueryResponse = PricingControllerGetPrice200;

export type PricingControllerGetPriceQuery = {
    Response: PricingControllerGetPrice200;
    PathParams: PricingControllerGetPricePathParams;
    QueryParams: PricingControllerGetPriceQueryParams;
    Errors: PricingControllerGetPrice404;
};

export type PricingControllerSavePricingSelectionPathParams = {
    /**
     * @description Policy ID
     * @type string
    */
    policyId: string;
};

export type PricingControllerSavePricingSelectionQueryParams = {
    /**
     * @description Branch ID (optional, defaults to latest)
     * @type string | undefined
    */
    branchId?: string;
};

export type PricingControllerSavePricingSelection200 = SavePricingSelectionOutput;

export type PricingControllerSavePricingSelection404 = PolicyNotFoundErrorDto;

export type PricingControllerSavePricingSelectionMutationRequest = SavePricingSelectionInputBody;

export type PricingControllerSavePricingSelectionMutationResponse = PricingControllerSavePricingSelection200;

export type PricingControllerSavePricingSelectionMutation = {
    Response: PricingControllerSavePricingSelection200;
    Request: PricingControllerSavePricingSelectionMutationRequest;
    PathParams: PricingControllerSavePricingSelectionPathParams;
    QueryParams: PricingControllerSavePricingSelectionQueryParams;
    Errors: PricingControllerSavePricingSelection404;
};

export type QuoteControllerGetQuotePathParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
};

export type QuoteControllerGetQuote201 = GetQuoteOutput;

export type QuoteControllerGetQuote400 = (InvalidCustomFieldsErrorDto | MissingAssetOptionsErrorDto | InvalidProductErrorDto | InvalidPricingDetailsErrorDto);

export type QuoteControllerGetQuote404 = BrokerageFirmNotFoundErrorDto;

/**
 * @description Quote computation input payload
*/
export type QuoteControllerGetQuoteMutationRequest = GetQuoteInputBody;

export type QuoteControllerGetQuoteMutationResponse = QuoteControllerGetQuote201;

export type QuoteControllerGetQuoteMutation = {
    Response: QuoteControllerGetQuote201;
    Request: QuoteControllerGetQuoteMutationRequest;
    PathParams: QuoteControllerGetQuotePathParams;
    Errors: QuoteControllerGetQuote400 | QuoteControllerGetQuote404;
};

export type QuoteControllerGetExternalQuoteQueryParams = {
    /**
     * @description Internal Korint quote id
     * @type string
    */
    quoteId: string;
};

export type QuoteControllerGetExternalQuote200 = GetExternalQuoteOutput;

export type QuoteControllerGetExternalQuote404 = ExternalQuoteNotFoundErrorDto;

export type QuoteControllerGetExternalQuoteQueryResponse = QuoteControllerGetExternalQuote200;

export type QuoteControllerGetExternalQuoteQuery = {
    Response: QuoteControllerGetExternalQuote200;
    QueryParams: QuoteControllerGetExternalQuoteQueryParams;
    Errors: QuoteControllerGetExternalQuote404;
};

export type RenewalControllerFinalizeRenewalBranchPathParams = {
    /**
     * @description Unique identifier for the policy
     * @type string
    */
    policyId: string;
    /**
     * @description Unique identifier for the branch
     * @type string
    */
    branchId: string;
};

export const renewalControllerFinalizeRenewalBranchQueryParamsFinalizationTypeEnum = {
    ACCEPTED: "ACCEPTED",
    REFUSED: "REFUSED"
} as const;

export type RenewalControllerFinalizeRenewalBranchQueryParamsFinalizationTypeEnumKey = (typeof renewalControllerFinalizeRenewalBranchQueryParamsFinalizationTypeEnum)[keyof typeof renewalControllerFinalizeRenewalBranchQueryParamsFinalizationTypeEnum];

export type RenewalControllerFinalizeRenewalBranchQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Finalization type
     * @type string
    */
    finalizationType: RenewalControllerFinalizeRenewalBranchQueryParamsFinalizationTypeEnumKey;
};

export type RenewalControllerFinalizeRenewalBranch201 = FinalizeRenewalBranchOutput;

export type RenewalControllerFinalizeRenewalBranch404 = (BranchNotFoundErrorDto | PolicyNotFoundErrorDto);

export type RenewalControllerFinalizeRenewalBranch409 = (ConflictingBranchTypeErrorDto | ConflictingBranchStatusErrorDto);

export type RenewalControllerFinalizeRenewalBranchMutationResponse = RenewalControllerFinalizeRenewalBranch201;

export type RenewalControllerFinalizeRenewalBranchMutation = {
    Response: RenewalControllerFinalizeRenewalBranch201;
    PathParams: RenewalControllerFinalizeRenewalBranchPathParams;
    QueryParams: RenewalControllerFinalizeRenewalBranchQueryParams;
    Errors: RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409;
};

export type MonitoringControllerGetReports200 = GetReportsOutput;

export type MonitoringControllerGetReportsQueryResponse = MonitoringControllerGetReports200;

export type MonitoringControllerGetReportsQuery = {
    Response: MonitoringControllerGetReports200;
    Errors: any;
};

export type MonitoringControllerGetChecks200 = ListChecksOutput;

export type MonitoringControllerGetChecksQueryResponse = MonitoringControllerGetChecks200;

export type MonitoringControllerGetChecksQuery = {
    Response: MonitoringControllerGetChecks200;
    Errors: any;
};

export type ReportingControllerGenerateReport201 = GenerateReportOutput;

export type ReportingControllerGenerateReport400 = InvalidReportParamsErrorDto;

export type ReportingControllerGenerateReportMutationRequest = GenerateReportInputBody;

export type ReportingControllerGenerateReportMutationResponse = ReportingControllerGenerateReport201;

export type ReportingControllerGenerateReportMutation = {
    Response: ReportingControllerGenerateReport201;
    Request: ReportingControllerGenerateReportMutationRequest;
    Errors: ReportingControllerGenerateReport400;
};

export const reportingControllerGetReportConfigPathParamsTypeEnum = {
    WORKFLOWS: "WORKFLOWS",
    POLICY_EXPORT: "POLICY_EXPORT",
    INVOICE_EXPORT: "INVOICE_EXPORT",
    BROKERAGE_FIRM_EXPORT: "BROKERAGE_FIRM_EXPORT",
    CLAIMS_EXPORT: "CLAIMS_EXPORT",
    COMMISSION_TRANSFER: "COMMISSION_TRANSFER",
    COMMISSION_TRANSFER_DETAIL: "COMMISSION_TRANSFER_DETAIL",
    YEET_VTC_IMA_ASSISTANCE: "YEET_VTC_IMA_ASSISTANCE",
    YEET_VTC_CASH_STATEMENT: "YEET_VTC_CASH_STATEMENT",
    YEET_VTC_POLICIES_V2: "YEET_VTC_POLICIES_V2",
    YEET_VTC_POLICY_PARTY: "YEET_VTC_POLICY_PARTY",
    YEET_VTC_KPI: "YEET_VTC_KPI",
    YEET_VTC_POLICY_INVOICE: "YEET_VTC_POLICY_INVOICE",
    YEET_VTC_POLICY_INVOICE_WAKAM: "YEET_VTC_POLICY_INVOICE_WAKAM",
    YEET_FVA_EXPORT: "YEET_FVA_EXPORT",
    YEET_STARTED_UNPAID_POLICIES: "YEET_STARTED_UNPAID_POLICIES",
    GARANTIE_PLUS_SALES_REPORT: "GARANTIE_PLUS_SALES_REPORT",
    GARANTIE_PLUS_SALES_RECAP_BY_GARAGE: "GARANTIE_PLUS_SALES_RECAP_BY_GARAGE",
    GARANTIE_PLUS_CAREA_CASH_STATEMENT: "GARANTIE_PLUS_CAREA_CASH_STATEMENT",
    GARANTIE_PLUS_CAAREA_DAILY_REPORT: "GARANTIE_PLUS_CAAREA_DAILY_REPORT",
    AXECE_POLICY: "AXECE_POLICY",
    AXECE_POLICY_INVOICE: "AXECE_POLICY_INVOICE",
    AXECE_POLICY_PARTY: "AXECE_POLICY_PARTY",
    AXECE_KPI: "AXECE_KPI",
    AXECE_MRPRO_KPI: "AXECE_MRPRO_KPI",
    AXECE_POLICY_INVOICE_WAKAM: "AXECE_POLICY_INVOICE_WAKAM",
    AXECE_VTC_IMA_ASSISTANCE: "AXECE_VTC_IMA_ASSISTANCE",
    AXECE_COMMISSION: "AXECE_COMMISSION",
    AXECE_BROKERAGE_FIRM_POLICIES: "AXECE_BROKERAGE_FIRM_POLICIES",
    AXECE_CASH_STATEMENT: "AXECE_CASH_STATEMENT",
    AXECE_MRPRO_POLICY: "AXECE_MRPRO_POLICY",
    AXECE_FVA_EXPORT: "AXECE_FVA_EXPORT",
    AXECE_STARTED_UNPAID_POLICIES: "AXECE_STARTED_UNPAID_POLICIES",
    ACCELERANT_VTC_IMA_ASSISTANCE: "ACCELERANT_VTC_IMA_ASSISTANCE",
    TUTASSUR_MILA_PNO_ASSUREUR_EXPORT: "TUTASSUR_MILA_PNO_ASSUREUR_EXPORT",
    TUTASSUR_MILA_MRH_ASSUREUR_EXPORT: "TUTASSUR_MILA_MRH_ASSUREUR_EXPORT",
    TUTASSUR_AXA_PORTFOLIO_EXPORT: "TUTASSUR_AXA_PORTFOLIO_EXPORT",
    TUTASSUR_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_COMPANY_STATEMENT: "TUTASSUR_COMPANY_STATEMENT",
    TUTASSUR_BROKER_STATEMENT: "TUTASSUR_BROKER_STATEMENT",
    TUTASSUR_CASH_STATEMENT: "TUTASSUR_CASH_STATEMENT",
    TUTASSUR_HISCOX_COLLECTED_PREMIUMS: "TUTASSUR_HISCOX_COLLECTED_PREMIUMS",
    TUTASSUR_HISCOX_UNPAID_PREMIUMS: "TUTASSUR_HISCOX_UNPAID_PREMIUMS",
    TUTASSUR_HISCOX_BORDEREAU_PRODUCTION: "TUTASSUR_HISCOX_BORDEREAU_PRODUCTION",
    TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_PJPRO_CFDP_MTA_EXPORT: "TUTASSUR_PJPRO_CFDP_MTA_EXPORT",
    TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT: "TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT",
    EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_ACCOUNTING_STATEMENT: "EGA_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT",
    EGA_RCPRO_ACCOUNTING_STATEMENT: "EGA_RCPRO_ACCOUNTING_STATEMENT",
    EGA_RCPRO_MADP_EXPORT: "EGA_RCPRO_MADP_EXPORT",
    EGA_CASH_STATEMENT: "EGA_CASH_STATEMENT",
    EGA_RETAIL_PERFORMANCE: "EGA_RETAIL_PERFORMANCE",
    EGA_TEAM_PERFORMANCE: "EGA_TEAM_PERFORMANCE",
    LUKO_MRH_POLICY: "LUKO_MRH_POLICY",
    LUKO_MRH_POLICY_INVOICE_WAKAM: "LUKO_MRH_POLICY_INVOICE_WAKAM",
    LUKO_MRH_POLICY_PAYMENT_WAKAM: "LUKO_MRH_POLICY_PAYMENT_WAKAM",
    LUKO_MRH_KPI: "LUKO_MRH_KPI",
    LUKO_CASH_STATEMENT: "LUKO_CASH_STATEMENT",
    ASSUREQUINE_CASH_STATEMENT: "ASSUREQUINE_CASH_STATEMENT",
    ASSUREQUINE_PORTFOLIO_STATEMENT: "ASSUREQUINE_PORTFOLIO_STATEMENT",
    ASSUREQUINE_PREMIUM_STATEMENT: "ASSUREQUINE_PREMIUM_STATEMENT",
    ARCHIMEDE_CFDP_MSG002_STOCK: "ARCHIMEDE_CFDP_MSG002_STOCK",
    ARCHIMEDE_CFDP_MSG002_STOCK_CSV: "ARCHIMEDE_CFDP_MSG002_STOCK_CSV",
    PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT: "PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT",
    PLEBAGNAC_CFDP_STATEMENT: "PLEBAGNAC_CFDP_STATEMENT",
    PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT: "PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT",
    PLEBAGNAC_MSC_SCOOTER_STATEMENT: "PLEBAGNAC_MSC_SCOOTER_STATEMENT",
    PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT: "PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT"
} as const;

export type ReportingControllerGetReportConfigPathParamsTypeEnumKey = (typeof reportingControllerGetReportConfigPathParamsTypeEnum)[keyof typeof reportingControllerGetReportConfigPathParamsTypeEnum];

export type ReportingControllerGetReportConfigPathParams = {
    /**
     * @description The type of report
     * @type string
    */
    type: ReportingControllerGetReportConfigPathParamsTypeEnumKey;
};

export type ReportingControllerGetReportConfig200 = GetReportConfigOutput;

export type ReportingControllerGetReportConfigQueryResponse = ReportingControllerGetReportConfig200;

export type ReportingControllerGetReportConfigQuery = {
    Response: ReportingControllerGetReportConfig200;
    PathParams: ReportingControllerGetReportConfigPathParams;
    Errors: any;
};

export type ReportingControllerGetReports200 = GetReportsOutput;

export type ReportingControllerGetReportsMutationRequest = GetReportsInputBody;

export type ReportingControllerGetReportsMutationResponse = ReportingControllerGetReports200;

export type ReportingControllerGetReportsMutation = {
    Response: ReportingControllerGetReports200;
    Request: ReportingControllerGetReportsMutationRequest;
    Errors: any;
};

export type ReportingControllerGenerateCustomReport201 = GenerateCustomReportOutput;

export type ReportingControllerGenerateCustomReportMutationRequest = GenerateCustomReportInputBody;

export type ReportingControllerGenerateCustomReportMutationResponse = ReportingControllerGenerateCustomReport201;

export type ReportingControllerGenerateCustomReportMutation = {
    Response: ReportingControllerGenerateCustomReport201;
    Request: ReportingControllerGenerateCustomReportMutationRequest;
    Errors: any;
};

export type RepricingControllerExecuteRepricingForPolicyPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type RepricingControllerExecuteRepricingForPolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type RepricingControllerExecuteRepricingForPolicy201 = RepricingDispatchOutput;

export type RepricingControllerExecuteRepricingForPolicyMutationResponse = RepricingControllerExecuteRepricingForPolicy201;

export type RepricingControllerExecuteRepricingForPolicyMutation = {
    Response: RepricingControllerExecuteRepricingForPolicy201;
    PathParams: RepricingControllerExecuteRepricingForPolicyPathParams;
    QueryParams: RepricingControllerExecuteRepricingForPolicyQueryParams;
    Errors: any;
};

export type SearchControllerSearchQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type SearchControllerSearch201 = SearchOutput;

export type SearchControllerSearchMutationRequest = SearchInputBody;

export type SearchControllerSearchMutationResponse = SearchControllerSearch201;

export type SearchControllerSearchMutation = {
    Response: SearchControllerSearch201;
    Request: SearchControllerSearchMutationRequest;
    QueryParams: SearchControllerSearchQueryParams;
    Errors: any;
};

export type SearchControllerGenericSearchPathParams = {
    /**
     * @description Name of a search configured for the product. An unconfigured name fails with INVALID_SEARCH_CONFIG.
     * @type string
    */
    name: string;
};

export type SearchControllerGenericSearchQueryParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
};

export type SearchControllerGenericSearch201 = ConfigurableSearchOutput;

export type SearchControllerGenericSearchMutationRequest = ConfigurableSearchInputBody;

export type SearchControllerGenericSearchMutationResponse = SearchControllerGenericSearch201;

export type SearchControllerGenericSearchMutation = {
    Response: SearchControllerGenericSearch201;
    Request: SearchControllerGenericSearchMutationRequest;
    PathParams: SearchControllerGenericSearchPathParams;
    QueryParams: SearchControllerGenericSearchQueryParams;
    Errors: any;
};

export type SearchControllerGenericSearchSwaggerPathParams = {
    /**
     * @description Name of a search configured for the product. An unconfigured name fails with INVALID_SEARCH_CONFIG.
     * @type string
    */
    name: string;
};

export type SearchControllerGenericSearchSwaggerQueryParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
};

export type SearchControllerGenericSearchSwagger200 = any;

export type SearchControllerGenericSearchSwaggerQueryResponse = SearchControllerGenericSearchSwagger200;

export type SearchControllerGenericSearchSwaggerQuery = {
    Response: SearchControllerGenericSearchSwagger200;
    PathParams: SearchControllerGenericSearchSwaggerPathParams;
    QueryParams: SearchControllerGenericSearchSwaggerQueryParams;
    Errors: any;
};

export type SearchControllerCount201 = CountOutput;

export type SearchControllerCountMutationRequest = CountInputBody;

export type SearchControllerCountMutationResponse = SearchControllerCount201;

export type SearchControllerCountMutation = {
    Response: SearchControllerCount201;
    Request: SearchControllerCountMutationRequest;
    Errors: any;
};

export const searchControllerSuggestQueryParamsDirectionEnum = {
    asc: "asc",
    desc: "desc"
} as const;

export type SearchControllerSuggestQueryParamsDirectionEnumKey = (typeof searchControllerSuggestQueryParamsDirectionEnum)[keyof typeof searchControllerSuggestQueryParamsDirectionEnum];

export const searchControllerSuggestQueryParamsEntityTypeEnum = {
    PAYMENT_METHOD: "PAYMENT_METHOD",
    PAYMENT: "PAYMENT",
    POLICY: "POLICY",
    CUSTOMER: "CUSTOMER",
    ASSET: "ASSET",
    INVOICE: "INVOICE",
    DOCUMENT: "DOCUMENT",
    DOCUMENT_CONFORMITY: "DOCUMENT_CONFORMITY",
    SIGNATURE: "SIGNATURE",
    TENANT: "TENANT",
    PRODUCT: "PRODUCT",
    QUOTE: "QUOTE",
    BROKERAGE_FIRM: "BROKERAGE_FIRM",
    CLAIM: "CLAIM",
    CLAIM_MANAGEMENT: "CLAIM_MANAGEMENT",
    CLAIMANT: "CLAIMANT",
    EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
    NOTIFICATION: "NOTIFICATION",
    PREMIUM_SCHEDULE: "PREMIUM_SCHEDULE",
    CHECK: "CHECK",
    ALERT: "ALERT",
    DISTRIBUTION_REQUEST: "DISTRIBUTION_REQUEST",
    DEROGATION: "DEROGATION",
    BROKERAGE_FEE: "BROKERAGE_FEE",
    COMMENT: "COMMENT",
    CONVERSATION: "CONVERSATION",
    CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
    EMAIL_ACCOUNT: "EMAIL_ACCOUNT",
    EMAIL: "EMAIL",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EMAIL_IMPORT: "EMAIL_IMPORT",
    EMAIL_ENTITY_LINK: "EMAIL_ENTITY_LINK",
    EMAIL_THREAD_ANALYSIS: "EMAIL_THREAD_ANALYSIS",
    COMMISSION_STATEMENT: "COMMISSION_STATEMENT"
} as const;

export type SearchControllerSuggestQueryParamsEntityTypeEnumKey = (typeof searchControllerSuggestQueryParamsEntityTypeEnum)[keyof typeof searchControllerSuggestQueryParamsEntityTypeEnum];

export type SearchControllerSuggestQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @type string
    */
    property: string;
    /**
     * @type string | undefined
    */
    direction?: SearchControllerSuggestQueryParamsDirectionEnumKey;
    /**
     * @type string
    */
    entityType: SearchControllerSuggestQueryParamsEntityTypeEnumKey;
    /**
     * @type string | undefined
    */
    queryString?: string;
};

export type SearchControllerSuggest200 = SuggestOutput;

export type SearchControllerSuggestQueryResponse = SearchControllerSuggest200;

export type SearchControllerSuggestQuery = {
    Response: SearchControllerSuggest200;
    QueryParams: SearchControllerSuggestQueryParams;
    Errors: any;
};

export type SearchControllerReindex201 = ReindexAllCollectionsOutput;

export type SearchControllerReindexMutationRequest = ReindexAllCollectionsInputBody;

export type SearchControllerReindexMutationResponse = SearchControllerReindex201;

export type SearchControllerReindexMutation = {
    Response: SearchControllerReindex201;
    Request: SearchControllerReindexMutationRequest;
    Errors: any;
};

export type SearchControllerReindexAll201 = ReindexAllOutput;

export type SearchControllerReindexAllMutationRequest = ReindexAllInputBody;

export type SearchControllerReindexAllMutationResponse = SearchControllerReindexAll201;

export type SearchControllerReindexAllMutation = {
    Response: SearchControllerReindexAll201;
    Request: SearchControllerReindexAllMutationRequest;
    Errors: any;
};

export type SignatureControllerFakePathParams = {
    /**
     * @type string
    */
    signature_id: string;
};

export type SignatureControllerFake200 = UpdateSignatureSignedStatusOutput;

export type SignatureControllerFakeMutationResponse = SignatureControllerFake200;

export type SignatureControllerFakeMutation = {
    Response: SignatureControllerFake200;
    PathParams: SignatureControllerFakePathParams;
    Errors: any;
};

export type SignatureControllerYousignSecurityCheck200 = YousignSecurityCheckOutputDto;

export type SignatureControllerYousignSecurityCheckQueryResponse = SignatureControllerYousignSecurityCheck200;

export type SignatureControllerYousignSecurityCheckQuery = {
    Response: SignatureControllerYousignSecurityCheck200;
    Errors: any;
};

export type SignatureControllerGetSignatureRequestsByExternalIdPathParams = {
    /**
     * @type string
    */
    externalId: string;
};

export type SignatureControllerGetSignatureRequestsByExternalId200 = GetSignatureRequestsByExternalIdOutput;

export type SignatureControllerGetSignatureRequestsByExternalIdQueryResponse = SignatureControllerGetSignatureRequestsByExternalId200;

export type SignatureControllerGetSignatureRequestsByExternalIdQuery = {
    Response: SignatureControllerGetSignatureRequestsByExternalId200;
    PathParams: SignatureControllerGetSignatureRequestsByExternalIdPathParams;
    Errors: any;
};

export type SignatureControllerGetSignerLinkPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    signatureId: string;
    /**
     * @type string
    */
    signerCustomerId: string;
};

export type SignatureControllerGetSignerLink200 = GetSignerLinkOutput;

export type SignatureControllerGetSignerLinkQueryResponse = SignatureControllerGetSignerLink200;

export type SignatureControllerGetSignerLinkQuery = {
    Response: SignatureControllerGetSignerLink200;
    PathParams: SignatureControllerGetSignerLinkPathParams;
    Errors: any;
};

export type SignatureControllerResendSignatureReminderPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    signatureId: string;
    /**
     * @type string
    */
    signerCustomerId: string;
};

export type SignatureControllerResendSignatureReminder201 = ResendSignatureReminderOutput;

export type SignatureControllerResendSignatureReminderMutationResponse = SignatureControllerResendSignatureReminder201;

export type SignatureControllerResendSignatureReminderMutation = {
    Response: SignatureControllerResendSignatureReminder201;
    PathParams: SignatureControllerResendSignatureReminderPathParams;
    Errors: any;
};

export type SirenControllerSearchSirenQueryParams = {
    /**
     * @description Siren number. Provide at least one of `siren`, `siret` or `name`.
     * @type string | undefined
    */
    siren?: string;
    /**
     * @description Optional: Siret number
     * @type string | undefined
    */
    siret?: string;
    /**
     * @description Optional: Company name
     * @type string | undefined
    */
    name?: string;
};

export type SirenControllerSearchSiren200 = SearchSirenOutput;

export type SirenControllerSearchSiren400 = (InvalidCustomerSiretErrorDto | InvalidCustomerSirenErrorDto | RequestValidationFailedErrorDto);

export type SirenControllerSearchSirenQueryResponse = SirenControllerSearchSiren200;

export type SirenControllerSearchSirenQuery = {
    Response: SirenControllerSearchSiren200;
    QueryParams: SirenControllerSearchSirenQueryParams;
    Errors: SirenControllerSearchSiren400;
};

export const addressAutocompleteControllerSuggestQueryParamsPartEnum = {
    address: "address",
    postalCode: "postalCode",
    city: "city",
    country: "country"
} as const;

export type AddressAutocompleteControllerSuggestQueryParamsPartEnumKey = (typeof addressAutocompleteControllerSuggestQueryParamsPartEnum)[keyof typeof addressAutocompleteControllerSuggestQueryParamsPartEnum];

export type AddressAutocompleteControllerSuggestQueryParams = {
    /**
     * @description Partial address typed by the user
     * @type string
    */
    q: string;
    /**
     * @description Client-generated id grouping one search (maps to the provider billing session)
     * @type string
    */
    searchSessionId: string;
    /**
     * @description UI language (ISO 639-1); clamped to the provider set
     * @type string | undefined
    */
    language?: string;
    /**
     * @description Restrict results to this country (ISO 3166-1 alpha-2). Empty = worldwide
     * @type string | undefined
    */
    country?: string;
    /**
     * @description Address part this field represents; scopes suggestions to the matching feature types
     * @type string | undefined
    */
    part?: AddressAutocompleteControllerSuggestQueryParamsPartEnumKey;
};

export type AddressAutocompleteControllerSuggest200 = AddressAutocompleteSuggestOutput;

export type AddressAutocompleteControllerSuggestQueryResponse = AddressAutocompleteControllerSuggest200;

export type AddressAutocompleteControllerSuggestQuery = {
    Response: AddressAutocompleteControllerSuggest200;
    QueryParams: AddressAutocompleteControllerSuggestQueryParams;
    Errors: any;
};

export type SivControllerSearchSivQueryParams = {
    /**
     * @pattern (^[A-Za-z]{2}[ -]?[0-9]{3}[ -]?[A-Za-z]{1,2}$)|(^[0-9]{1,4}[ -]?[A-Za-z]{1,3}[ -]?[0-9]{2}$)
     * @type string
    */
    registrationNumber: string;
};

export type SivControllerSearchSiv200 = SearchSivOutput;

export type SivControllerSearchSiv404 = RegistrationNumberNotFoundErrorDto;

export type SivControllerSearchSivQueryResponse = SivControllerSearchSiv200;

export type SivControllerSearchSivQuery = {
    Response: SivControllerSearchSiv200;
    QueryParams: SivControllerSearchSivQueryParams;
    Errors: SivControllerSearchSiv404;
};

export type SivControllerSearchSivAtLegacyPathQueryParams = {
    /**
     * @pattern (^[A-Za-z]{2}[ -]?[0-9]{3}[ -]?[A-Za-z]{1,2}$)|(^[0-9]{1,4}[ -]?[A-Za-z]{1,3}[ -]?[0-9]{2}$)
     * @type string
    */
    registrationNumber: string;
};

export type SivControllerSearchSivAtLegacyPath200 = SearchSivOutput;

export type SivControllerSearchSivAtLegacyPath404 = RegistrationNumberNotFoundErrorDto;

export type SivControllerSearchSivAtLegacyPathQueryResponse = SivControllerSearchSivAtLegacyPath200;

export type SivControllerSearchSivAtLegacyPathQuery = {
    Response: SivControllerSearchSivAtLegacyPath200;
    QueryParams: SivControllerSearchSivAtLegacyPathQueryParams;
    Errors: SivControllerSearchSivAtLegacyPath404;
};

export type DerogationControllerCreateDerogationPathParams = {
    /**
     * @description Id of the branch
     * @type string
    */
    branchId: string;
};

export type DerogationControllerCreateDerogationQueryParams = {
    /**
     * @description Action for the derogation
     * @type string
    */
    action: DerogationAction;
};

export type DerogationControllerCreateDerogation201 = DerogationCreateOutput;

export type DerogationControllerCreateDerogation404 = BranchNotFoundErrorDto;

export type DerogationControllerCreateDerogation409 = (NoDerogationToCreateErrorDto | DerogationAlreadyExistsErrorDto);

export type DerogationControllerCreateDerogationMutationResponse = DerogationControllerCreateDerogation201;

export type DerogationControllerCreateDerogationMutation = {
    Response: DerogationControllerCreateDerogation201;
    PathParams: DerogationControllerCreateDerogationPathParams;
    QueryParams: DerogationControllerCreateDerogationQueryParams;
    Errors: DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409;
};

export type DerogationControllerApproveDerogationPathParams = {
    /**
     * @description Id of the branch
     * @type string
    */
    branchId: string;
    /**
     * @description Id of the derogation
     * @type string
    */
    derogationId: string;
};

export type DerogationControllerApproveDerogation201 = DerogationApproveOutput;

export type DerogationControllerApproveDerogation404 = (BranchNotFoundErrorDto | DerogationNotFoundErrorDto);

export type DerogationControllerApproveDerogationMutationResponse = DerogationControllerApproveDerogation201;

export type DerogationControllerApproveDerogationMutation = {
    Response: DerogationControllerApproveDerogation201;
    PathParams: DerogationControllerApproveDerogationPathParams;
    Errors: DerogationControllerApproveDerogation404;
};

export type DerogationControllerDenyDerogationPathParams = {
    /**
     * @description Id of the derogation
     * @type string
    */
    derogationId: string;
    /**
     * @description Id of the branch
     * @type string
    */
    branchId: string;
};

export type DerogationControllerDenyDerogation201 = DerogationDenyOutput;

export type DerogationControllerDenyDerogation404 = (BranchNotFoundErrorDto | DerogationNotFoundErrorDto);

export type DerogationControllerDenyDerogationMutationRequest = DerogationDenyInputBody;

export type DerogationControllerDenyDerogationMutationResponse = DerogationControllerDenyDerogation201;

export type DerogationControllerDenyDerogationMutation = {
    Response: DerogationControllerDenyDerogation201;
    Request: DerogationControllerDenyDerogationMutationRequest;
    PathParams: DerogationControllerDenyDerogationPathParams;
    Errors: DerogationControllerDenyDerogation404;
};

export type DerogationControllerCheckDerogationRequirementPathParams = {
    /**
     * @description Id of the branch
     * @type string
    */
    branchId: string;
};

export type DerogationControllerCheckDerogationRequirementQueryParams = {
    /**
     * @description Action for the derogation
     * @type string
    */
    action: DerogationAction;
};

export type DerogationControllerCheckDerogationRequirement201 = CheckDerogationRequirementOutput;

export type DerogationControllerCheckDerogationRequirementMutationRequest = CheckDerogationRequirementInputBody;

export type DerogationControllerCheckDerogationRequirementMutationResponse = DerogationControllerCheckDerogationRequirement201;

export type DerogationControllerCheckDerogationRequirementMutation = {
    Response: DerogationControllerCheckDerogationRequirement201;
    Request: DerogationControllerCheckDerogationRequirementMutationRequest;
    PathParams: DerogationControllerCheckDerogationRequirementPathParams;
    QueryParams: DerogationControllerCheckDerogationRequirementQueryParams;
    Errors: any;
};

export type AiAdminControllerListConversationsQueryParams = {
    /**
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @minLength 1
     * @maxLength 100
     * @default 20
     * @type number | undefined
    */
    limit?: number;
};

export type AiAdminControllerListConversations200 = AdminListConversationsOutput;

export type AiAdminControllerListConversationsQueryResponse = AiAdminControllerListConversations200;

export type AiAdminControllerListConversationsQuery = {
    Response: AiAdminControllerListConversations200;
    QueryParams: AiAdminControllerListConversationsQueryParams;
    Errors: any;
};

export type AiAdminControllerGetConversationMessagesPathParams = {
    /**
     * @type string
    */
    conversationId: string;
};

export type AiAdminControllerGetConversationMessages200 = GetConversationMessagesOutput;

export type AiAdminControllerGetConversationMessagesQueryResponse = AiAdminControllerGetConversationMessages200;

export type AiAdminControllerGetConversationMessagesQuery = {
    Response: AiAdminControllerGetConversationMessages200;
    PathParams: AiAdminControllerGetConversationMessagesPathParams;
    Errors: any;
};

export type CommentsControllerCreateCommentPathParams = {
    /**
     * @description Id of the entity (policy, customer, branch, ...)
     * @type string
    */
    entityId: string;
};

export type CommentsControllerCreateCommentQueryParams = {
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type CommentsControllerCreateComment201 = CreateCommentOutput;

export type CommentsControllerCreateComment409 = CommentAlreadyExistsErrorDto;

export type CommentsControllerCreateCommentMutationRequest = CreateCommentInputBody;

export type CommentsControllerCreateCommentMutationResponse = CommentsControllerCreateComment201;

export type CommentsControllerCreateCommentMutation = {
    Response: CommentsControllerCreateComment201;
    Request: CommentsControllerCreateCommentMutationRequest;
    PathParams: CommentsControllerCreateCommentPathParams;
    QueryParams: CommentsControllerCreateCommentQueryParams;
    Errors: CommentsControllerCreateComment409;
};

export type CommentsControllerUpdateCommentPathParams = {
    /**
     * @description Id of the comment
     * @type string
    */
    commentId: string;
};

export type CommentsControllerUpdateComment200 = UpdateCommentOutput;

export type CommentsControllerUpdateComment404 = CommentNotFoundErrorDto;

export type CommentsControllerUpdateCommentMutationRequest = UpdateCommentInputBody;

export type CommentsControllerUpdateCommentMutationResponse = CommentsControllerUpdateComment200;

export type CommentsControllerUpdateCommentMutation = {
    Response: CommentsControllerUpdateComment200;
    Request: CommentsControllerUpdateCommentMutationRequest;
    PathParams: CommentsControllerUpdateCommentPathParams;
    Errors: CommentsControllerUpdateComment404;
};

export type CommentsControllerDeleteCommentPathParams = {
    /**
     * @description Id of the comment
     * @type string
    */
    commentId: string;
};

export type CommentsControllerDeleteComment200 = DeleteCommentOutput;

export type CommentsControllerDeleteComment404 = CommentNotFoundErrorDto;

export type CommentsControllerDeleteCommentMutationResponse = CommentsControllerDeleteComment200;

export type CommentsControllerDeleteCommentMutation = {
    Response: CommentsControllerDeleteComment200;
    PathParams: CommentsControllerDeleteCommentPathParams;
    Errors: CommentsControllerDeleteComment404;
};

export type CommentsControllerGetCommentPathParams = {
    /**
     * @description Id of the comment
     * @type string
    */
    commentId: string;
};

export type CommentsControllerGetComment200 = GetCommentOutput;

export type CommentsControllerGetComment404 = CommentNotFoundErrorDto;

export type CommentsControllerGetCommentQueryResponse = CommentsControllerGetComment200;

export type CommentsControllerGetCommentQuery = {
    Response: CommentsControllerGetComment200;
    PathParams: CommentsControllerGetCommentPathParams;
    Errors: CommentsControllerGetComment404;
};

export type CommentsControllerListCommentsPathParams = {
    /**
     * @description Id of the entity (policy, customer, branch, ...)
     * @type string
    */
    entityId: string;
};

export type CommentsControllerListCommentsQueryParams = {
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type CommentsControllerListComments200 = ListCommentsOutput;

export type CommentsControllerListCommentsQueryResponse = CommentsControllerListComments200;

export type CommentsControllerListCommentsQuery = {
    Response: CommentsControllerListComments200;
    PathParams: CommentsControllerListCommentsPathParams;
    QueryParams: CommentsControllerListCommentsQueryParams;
    Errors: any;
};

export type InternalNotesControllerCreatePathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type InternalNotesControllerCreate201 = CreateInternalNoteOutput;

export type InternalNotesControllerCreate400 = InternalNoteContentTooLongErrorDto;

export type InternalNotesControllerCreateMutationRequest = CreateInternalNoteInputBody;

export type InternalNotesControllerCreateMutationResponse = InternalNotesControllerCreate201;

export type InternalNotesControllerCreateMutation = {
    Response: InternalNotesControllerCreate201;
    Request: InternalNotesControllerCreateMutationRequest;
    PathParams: InternalNotesControllerCreatePathParams;
    Errors: InternalNotesControllerCreate400;
};

export type InternalNotesControllerListPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type InternalNotesControllerListQueryParams = {
    /**
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @minLength 1
     * @maxLength 200
     * @default 50
     * @type number | undefined
    */
    count?: number;
    /**
     * @description Include soft-deleted notes (super-admin only)
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
};

export type InternalNotesControllerList200 = ListInternalNotesOutput;

export type InternalNotesControllerListQueryResponse = InternalNotesControllerList200;

export type InternalNotesControllerListQuery = {
    Response: InternalNotesControllerList200;
    PathParams: InternalNotesControllerListPathParams;
    QueryParams: InternalNotesControllerListQueryParams;
    Errors: any;
};

export type InternalNotesControllerGetPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    noteId: string;
};

export type InternalNotesControllerGet200 = GetInternalNoteOutput;

export type InternalNotesControllerGet404 = CommentNotFoundErrorDto;

export type InternalNotesControllerGetQueryResponse = InternalNotesControllerGet200;

export type InternalNotesControllerGetQuery = {
    Response: InternalNotesControllerGet200;
    PathParams: InternalNotesControllerGetPathParams;
    Errors: InternalNotesControllerGet404;
};

export type InternalNotesControllerUpdatePathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    noteId: string;
};

export type InternalNotesControllerUpdate200 = UpdateInternalNoteOutput;

export type InternalNotesControllerUpdate403 = InternalNoteNotAuthorErrorDto;

export type InternalNotesControllerUpdate404 = CommentNotFoundErrorDto;

export type InternalNotesControllerUpdateMutationRequest = UpdateInternalNoteInputBody;

export type InternalNotesControllerUpdateMutationResponse = InternalNotesControllerUpdate200;

export type InternalNotesControllerUpdateMutation = {
    Response: InternalNotesControllerUpdate200;
    Request: InternalNotesControllerUpdateMutationRequest;
    PathParams: InternalNotesControllerUpdatePathParams;
    Errors: InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404;
};

export type InternalNotesControllerDeletePathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    noteId: string;
};

export type InternalNotesControllerDeleteQueryParams = {
    /**
     * @type string
    */
    hard: string;
};

export type InternalNotesControllerDelete200 = SoftDeleteInternalNoteOutput;

export type InternalNotesControllerDelete403 = InternalNoteNotAuthorErrorDto;

export type InternalNotesControllerDelete404 = CommentNotFoundErrorDto;

export type InternalNotesControllerDeleteMutationResponse = InternalNotesControllerDelete200;

export type InternalNotesControllerDeleteMutation = {
    Response: InternalNotesControllerDelete200;
    PathParams: InternalNotesControllerDeletePathParams;
    QueryParams: InternalNotesControllerDeleteQueryParams;
    Errors: InternalNotesControllerDelete403 | InternalNotesControllerDelete404;
};

export type ClaimInternalNotesControllerCreatePathParams = {
    /**
     * @type string
    */
    claimId: string;
};

export type ClaimInternalNotesControllerCreate201 = ClaimInternalNoteOutput;

export type ClaimInternalNotesControllerCreate400 = InternalNoteContentTooLongErrorDto;

export type ClaimInternalNotesControllerCreateMutationRequest = CreateInternalNoteInputBody;

export type ClaimInternalNotesControllerCreateMutationResponse = ClaimInternalNotesControllerCreate201;

export type ClaimInternalNotesControllerCreateMutation = {
    Response: ClaimInternalNotesControllerCreate201;
    Request: ClaimInternalNotesControllerCreateMutationRequest;
    PathParams: ClaimInternalNotesControllerCreatePathParams;
    Errors: ClaimInternalNotesControllerCreate400;
};

export type ClaimInternalNotesControllerListPathParams = {
    /**
     * @type string
    */
    claimId: string;
};

export type ClaimInternalNotesControllerListQueryParams = {
    /**
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @minLength 1
     * @maxLength 200
     * @default 50
     * @type number | undefined
    */
    count?: number;
    /**
     * @description Include soft-deleted notes (super-admin only)
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
};

export type ClaimInternalNotesControllerList200 = ListClaimInternalNotesOutput;

export type ClaimInternalNotesControllerListQueryResponse = ClaimInternalNotesControllerList200;

export type ClaimInternalNotesControllerListQuery = {
    Response: ClaimInternalNotesControllerList200;
    PathParams: ClaimInternalNotesControllerListPathParams;
    QueryParams: ClaimInternalNotesControllerListQueryParams;
    Errors: any;
};

export type ClaimInternalNotesControllerGetPathParams = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string
    */
    noteId: string;
};

export type ClaimInternalNotesControllerGet200 = ClaimInternalNoteOutput;

export type ClaimInternalNotesControllerGet404 = CommentNotFoundErrorDto;

export type ClaimInternalNotesControllerGetQueryResponse = ClaimInternalNotesControllerGet200;

export type ClaimInternalNotesControllerGetQuery = {
    Response: ClaimInternalNotesControllerGet200;
    PathParams: ClaimInternalNotesControllerGetPathParams;
    Errors: ClaimInternalNotesControllerGet404;
};

export type ClaimInternalNotesControllerUpdatePathParams = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string
    */
    noteId: string;
};

export type ClaimInternalNotesControllerUpdate200 = ClaimInternalNoteOutput;

export type ClaimInternalNotesControllerUpdate403 = InternalNoteNotAuthorErrorDto;

export type ClaimInternalNotesControllerUpdate404 = CommentNotFoundErrorDto;

export type ClaimInternalNotesControllerUpdateMutationRequest = UpdateInternalNoteInputBody;

export type ClaimInternalNotesControllerUpdateMutationResponse = ClaimInternalNotesControllerUpdate200;

export type ClaimInternalNotesControllerUpdateMutation = {
    Response: ClaimInternalNotesControllerUpdate200;
    Request: ClaimInternalNotesControllerUpdateMutationRequest;
    PathParams: ClaimInternalNotesControllerUpdatePathParams;
    Errors: ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404;
};

export type ClaimInternalNotesControllerDeletePathParams = {
    /**
     * @type string
    */
    claimId: string;
    /**
     * @type string
    */
    noteId: string;
};

export type ClaimInternalNotesControllerDeleteQueryParams = {
    /**
     * @type string
    */
    hard: string;
};

export type ClaimInternalNotesControllerDelete200 = SoftDeleteInternalNoteOutput;

export type ClaimInternalNotesControllerDelete403 = InternalNoteNotAuthorErrorDto;

export type ClaimInternalNotesControllerDelete404 = CommentNotFoundErrorDto;

export type ClaimInternalNotesControllerDeleteMutationResponse = ClaimInternalNotesControllerDelete200;

export type ClaimInternalNotesControllerDeleteMutation = {
    Response: ClaimInternalNotesControllerDelete200;
    PathParams: ClaimInternalNotesControllerDeletePathParams;
    QueryParams: ClaimInternalNotesControllerDeleteQueryParams;
    Errors: ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404;
};

export type ConversationControllerCreateConversation201 = CreateConversationOutput;

export type ConversationControllerCreateConversationMutationRequest = CreateConversationBody;

export type ConversationControllerCreateConversationMutationResponse = ConversationControllerCreateConversation201;

export type ConversationControllerCreateConversationMutation = {
    Response: ConversationControllerCreateConversation201;
    Request: ConversationControllerCreateConversationMutationRequest;
    Errors: any;
};

export type ConversationControllerListConversations200 = ListConversationsOutput;

export type ConversationControllerListConversationsQueryResponse = ConversationControllerListConversations200;

export type ConversationControllerListConversationsQuery = {
    Response: ConversationControllerListConversations200;
    Errors: any;
};

export type ConversationControllerGetConversationPathParams = {
    /**
     * @type string
    */
    conversationId: string;
};

export type ConversationControllerGetConversation200 = GetConversationOutput;

export type ConversationControllerGetConversation404 = ConversationNotFoundErrorDto;

export type ConversationControllerGetConversationQueryResponse = ConversationControllerGetConversation200;

export type ConversationControllerGetConversationQuery = {
    Response: ConversationControllerGetConversation200;
    PathParams: ConversationControllerGetConversationPathParams;
    Errors: ConversationControllerGetConversation404;
};

export type ConversationControllerDeleteConversationPathParams = {
    /**
     * @type string
    */
    conversationId: string;
};

export type ConversationControllerDeleteConversation200 = DeleteConversationOutput;

export type ConversationControllerDeleteConversation404 = ConversationNotFoundErrorDto;

export type ConversationControllerDeleteConversationMutationResponse = ConversationControllerDeleteConversation200;

export type ConversationControllerDeleteConversationMutation = {
    Response: ConversationControllerDeleteConversation200;
    PathParams: ConversationControllerDeleteConversationPathParams;
    Errors: ConversationControllerDeleteConversation404;
};

export type ConversationControllerGetConversationMessagesPathParams = {
    /**
     * @type string
    */
    conversationId: string;
};

export type ConversationControllerGetConversationMessages200 = GetConversationMessagesOutput;

export type ConversationControllerGetConversationMessages404 = ConversationNotFoundErrorDto;

export type ConversationControllerGetConversationMessagesQueryResponse = ConversationControllerGetConversationMessages200;

export type ConversationControllerGetConversationMessagesQuery = {
    Response: ConversationControllerGetConversationMessages200;
    PathParams: ConversationControllerGetConversationMessagesPathParams;
    Errors: ConversationControllerGetConversationMessages404;
};

export type ConversationControllerSendConversationMessagePathParams = {
    /**
     * @type string
    */
    conversationId: string;
};

export type ConversationControllerSendConversationMessage201 = SendConversationMessageOutput;

export type ConversationControllerSendConversationMessage404 = ConversationNotFoundErrorDto;

export type ConversationControllerSendConversationMessageMutationRequest = SendMessageBody;

export type ConversationControllerSendConversationMessageMutationResponse = ConversationControllerSendConversationMessage201;

export type ConversationControllerSendConversationMessageMutation = {
    Response: ConversationControllerSendConversationMessage201;
    Request: ConversationControllerSendConversationMessageMutationRequest;
    PathParams: ConversationControllerSendConversationMessagePathParams;
    Errors: ConversationControllerSendConversationMessage404;
};

export type ConversationControllerSendConversationMessageStreamPathParams = {
    /**
     * @type string
    */
    conversationId: string;
};

export type ConversationControllerSendConversationMessageStream201 = any;

export type ConversationControllerSendConversationMessageStreamMutationRequest = SendMessageBody;

export type ConversationControllerSendConversationMessageStreamMutationResponse = ConversationControllerSendConversationMessageStream201;

export type ConversationControllerSendConversationMessageStreamMutation = {
    Response: ConversationControllerSendConversationMessageStream201;
    Request: ConversationControllerSendConversationMessageStreamMutationRequest;
    PathParams: ConversationControllerSendConversationMessageStreamPathParams;
    Errors: any;
};

export type ConversationControllerSendConversationFeedbackPathParams = {
    /**
     * @type string
    */
    conversationId: string;
    /**
     * @type string
    */
    messageId: string;
};

export type ConversationControllerSendConversationFeedback201 = SendConversationFeedbackOutput;

export type ConversationControllerSendConversationFeedback404 = ConversationNotFoundErrorDto;

export type ConversationControllerSendConversationFeedbackMutationRequest = SendFeedbackBody;

export type ConversationControllerSendConversationFeedbackMutationResponse = ConversationControllerSendConversationFeedback201;

export type ConversationControllerSendConversationFeedbackMutation = {
    Response: ConversationControllerSendConversationFeedback201;
    Request: ConversationControllerSendConversationFeedbackMutationRequest;
    PathParams: ConversationControllerSendConversationFeedbackPathParams;
    Errors: ConversationControllerSendConversationFeedback404;
};

export const sraControllerGetFacetQueryParamsFacetNameEnum = {
    brand: "brand",
    model: "model",
    version: "version",
    energyCode: "energyCode",
    fiscalPower: "fiscalPower"
} as const;

export type SraControllerGetFacetQueryParamsFacetNameEnumKey = (typeof sraControllerGetFacetQueryParamsFacetNameEnum)[keyof typeof sraControllerGetFacetQueryParamsFacetNameEnum];

export type SraControllerGetFacetQueryParams = {
    /**
     * @description Optional: The brand code
     * @type string | undefined
    */
    brand?: string;
    /**
     * @description Optional: The model
     * @type string | undefined
    */
    model?: string;
    /**
     * @description Optional: the version
     * @type string | undefined
    */
    version?: string;
    /**
     * @description The facetName possible values
     * @type string
    */
    facetName: SraControllerGetFacetQueryParamsFacetNameEnumKey;
    /**
     * @description The fiscalPower value
     * @minLength 1
     * @type number | undefined
    */
    fiscalPower?: number;
    /**
     * @description The energy
     * @type string | undefined
    */
    energyCode?: string;
    /**
     * @description The first circulation date
     * @type string | undefined, date-time
    */
    entryIntoCirculationDate?: string;
    /**
     * @description Years of tolerance added to entryIntoCirculationDate before filtering on the commercialisation date. SRA commercialisation dates are year-precise at best, so a version released shortly after the vehicle entered circulation is still a plausible match. Defaults to an exact cut-off.
     * @minLength 0
     * @default 0
     * @type number | undefined
    */
    commercialisationToleranceInYears?: number;
};

export type SraControllerGetFacet200 = GetFacetOutput;

export type SraControllerGetFacetQueryResponse = SraControllerGetFacet200;

export type SraControllerGetFacetQuery = {
    Response: SraControllerGetFacet200;
    QueryParams: SraControllerGetFacetQueryParams;
    Errors: any;
};

export type SraControllerGetVehicleDetailsQueryParams = {
    /**
     * @description The brand
     * @type string
    */
    brand: string;
    /**
     * @description The model
     * @type string
    */
    model: string;
    /**
     * @description version
     * @type string
    */
    version: string;
    /**
     * @description fiscal power
     * @minLength 1
     * @type number | undefined
    */
    fiscalPower?: number;
    /**
     * @description number of seats
     * @type number | undefined
    */
    numberOfSeats?: number;
};

export type SraControllerGetVehicleDetails200 = GetVehicleDetailsOutput;

export type SraControllerGetVehicleDetailsQueryResponse = SraControllerGetVehicleDetails200;

export type SraControllerGetVehicleDetailsQuery = {
    Response: SraControllerGetVehicleDetails200;
    QueryParams: SraControllerGetVehicleDetailsQueryParams;
    Errors: any;
};

export type SraControllerGetVersionInformationFromBrandAndModelQueryParams = {
    /**
     * @description The brand
     * @type string
    */
    brand: string;
    /**
     * @description The model
     * @type string
    */
    model: string;
    /**
     * @description The fiscalPower value
     * @minLength 1
     * @type number | undefined
    */
    fiscalPower?: number;
    /**
     * @description The energy
     * @type string | undefined
    */
    energyCode?: string;
    /**
     * @description The first circulation date
     * @type string | undefined, date-time
    */
    entryIntoCirculationDate?: string;
    /**
     * @description Years of tolerance added to entryIntoCirculationDate before filtering on the commercialisation date. SRA commercialisation dates are year-precise at best, so a version released shortly after the vehicle entered circulation is still a plausible match. Defaults to an exact cut-off.
     * @minLength 0
     * @default 0
     * @type number | undefined
    */
    commercialisationToleranceInYears?: number;
};

export type SraControllerGetVersionInformationFromBrandAndModel200 = GetVersionInformationFromBrandAndModelOutput;

export type SraControllerGetVersionInformationFromBrandAndModelQueryResponse = SraControllerGetVersionInformationFromBrandAndModel200;

export type SraControllerGetVersionInformationFromBrandAndModelQuery = {
    Response: SraControllerGetVersionInformationFromBrandAndModel200;
    QueryParams: SraControllerGetVersionInformationFromBrandAndModelQueryParams;
    Errors: any;
};

export type HiscoxControllerGetActivitiesBySectorQueryParams = {
    /**
     * @description Activity name to find sector for
     * @type string
    */
    activity: string;
};

export type HiscoxControllerGetActivitiesBySector200 = GetHiscoxActivitiesBySectorOutput;

export type HiscoxControllerGetActivitiesBySectorQueryResponse = HiscoxControllerGetActivitiesBySector200;

export type HiscoxControllerGetActivitiesBySectorQuery = {
    Response: HiscoxControllerGetActivitiesBySector200;
    QueryParams: HiscoxControllerGetActivitiesBySectorQueryParams;
    Errors: any;
};

export type StripeWebhookControllerWebhookHeaderParams = {
    /**
     * @type string
    */
    "stripe-signature": string;
};

export type StripeWebhookControllerWebhook201 = any;

export type StripeWebhookControllerWebhookMutationResponse = StripeWebhookControllerWebhook201;

export type StripeWebhookControllerWebhookMutation = {
    Response: StripeWebhookControllerWebhook201;
    HeaderParams: StripeWebhookControllerWebhookHeaderParams;
    Errors: any;
};

export type StripeWebhookControllerConnectWebhookHeaderParams = {
    /**
     * @type string
    */
    "stripe-signature": string;
};

export type StripeWebhookControllerConnectWebhook201 = any;

export type StripeWebhookControllerConnectWebhookMutationResponse = StripeWebhookControllerConnectWebhook201;

export type StripeWebhookControllerConnectWebhookMutation = {
    Response: StripeWebhookControllerConnectWebhook201;
    HeaderParams: StripeWebhookControllerConnectWebhookHeaderParams;
    Errors: any;
};

export type StripeWebhookControllerTestWebhook201 = any;

export type StripeWebhookControllerTestWebhookMutationResponse = StripeWebhookControllerTestWebhook201;

export type StripeWebhookControllerTestWebhookMutation = {
    Response: StripeWebhookControllerTestWebhook201;
    Errors: any;
};

export type StripeWebhookControllerTenantWebhookPathParams = {
    /**
     * @type string
    */
    tenant: string;
};

export type StripeWebhookControllerTenantWebhookHeaderParams = {
    /**
     * @type string
    */
    "stripe-signature": string;
};

export type StripeWebhookControllerTenantWebhook201 = any;

export type StripeWebhookControllerTenantWebhookMutationResponse = StripeWebhookControllerTenantWebhook201;

export type StripeWebhookControllerTenantWebhookMutation = {
    Response: StripeWebhookControllerTenantWebhook201;
    PathParams: StripeWebhookControllerTenantWebhookPathParams;
    HeaderParams: StripeWebhookControllerTenantWebhookHeaderParams;
    Errors: any;
};

export type StripeWebhookControllerTenantConnectWebhookPathParams = {
    /**
     * @type string
    */
    tenant: string;
};

export type StripeWebhookControllerTenantConnectWebhookHeaderParams = {
    /**
     * @type string
    */
    "stripe-signature": string;
};

export type StripeWebhookControllerTenantConnectWebhook201 = any;

export type StripeWebhookControllerTenantConnectWebhookMutationResponse = StripeWebhookControllerTenantConnectWebhook201;

export type StripeWebhookControllerTenantConnectWebhookMutation = {
    Response: StripeWebhookControllerTenantConnectWebhook201;
    PathParams: StripeWebhookControllerTenantConnectWebhookPathParams;
    HeaderParams: StripeWebhookControllerTenantConnectWebhookHeaderParams;
    Errors: any;
};

export type SydiaControllerListClaims201 = SydiaListClaimsOutput;

export type SydiaControllerListClaimsMutationRequest = SydiaListClaimsInput;

export type SydiaControllerListClaimsMutationResponse = SydiaControllerListClaims201;

export type SydiaControllerListClaimsMutation = {
    Response: SydiaControllerListClaims201;
    Request: SydiaControllerListClaimsMutationRequest;
    Errors: any;
};

export type SydiaControllerGetClaim201 = SydiaGetClaimOutput;

export type SydiaControllerGetClaimMutationRequest = SydiaGetClaimInput;

export type SydiaControllerGetClaimMutationResponse = SydiaControllerGetClaim201;

export type SydiaControllerGetClaimMutation = {
    Response: SydiaControllerGetClaim201;
    Request: SydiaControllerGetClaimMutationRequest;
    Errors: any;
};

export type SydiaControllerUpsertPolicyClaims200 = SydiaUpsertClaimOutput;

export type SydiaControllerUpsertPolicyClaimsMutationRequest = SydiaUpsertClaimInput;

export type SydiaControllerUpsertPolicyClaimsMutationResponse = SydiaControllerUpsertPolicyClaims200;

export type SydiaControllerUpsertPolicyClaimsMutation = {
    Response: SydiaControllerUpsertPolicyClaims200;
    Request: SydiaControllerUpsertPolicyClaimsMutationRequest;
    Errors: any;
};

export type SydiaControllerGetCustomer201 = SydiaGetCustomerOutput;

export type SydiaControllerGetCustomerMutationRequest = SydiaGetCustomerInput;

export type SydiaControllerGetCustomerMutationResponse = SydiaControllerGetCustomer201;

export type SydiaControllerGetCustomerMutation = {
    Response: SydiaControllerGetCustomer201;
    Request: SydiaControllerGetCustomerMutationRequest;
    Errors: any;
};

export type SydiaControllerListCustomers201 = SydiaListCustomersOutput;

export type SydiaControllerListCustomersMutationRequest = SydiaListCustomersInput;

export type SydiaControllerListCustomersMutationResponse = SydiaControllerListCustomers201;

export type SydiaControllerListCustomersMutation = {
    Response: SydiaControllerListCustomers201;
    Request: SydiaControllerListCustomersMutationRequest;
    Errors: any;
};

export type SydiaControllerListPolicies201 = SydiaListPoliciesOutput;

export type SydiaControllerListPoliciesMutationRequest = SydiaListPoliciesInput;

export type SydiaControllerListPoliciesMutationResponse = SydiaControllerListPolicies201;

export type SydiaControllerListPoliciesMutation = {
    Response: SydiaControllerListPolicies201;
    Request: SydiaControllerListPoliciesMutationRequest;
    Errors: any;
};

export type UserControllerGetMyUserWithDrivequantDataQueryParams = {
    /**
     * @description The productId
     * @type string | undefined
    */
    productId?: string;
};

export type UserControllerGetMyUserWithDrivequantData200 = GetServiceUserDataOutput;

export type UserControllerGetMyUserWithDrivequantData404 = (UserNotFoundErrorDto | UserEmailNotFoundErrorDto);

export type UserControllerGetMyUserWithDrivequantDataQueryResponse = UserControllerGetMyUserWithDrivequantData200;

export type UserControllerGetMyUserWithDrivequantDataQuery = {
    Response: UserControllerGetMyUserWithDrivequantData200;
    QueryParams: UserControllerGetMyUserWithDrivequantDataQueryParams;
    Errors: UserControllerGetMyUserWithDrivequantData404;
};

export type WorkflowsControllerStartWorkflow201 = StartWorkflowOutput;

export type WorkflowsControllerStartWorkflowMutationRequest = StartWorkflowInput;

export type WorkflowsControllerStartWorkflowMutationResponse = WorkflowsControllerStartWorkflow201;

export type WorkflowsControllerStartWorkflowMutation = {
    Response: WorkflowsControllerStartWorkflow201;
    Request: WorkflowsControllerStartWorkflowMutationRequest;
    Errors: any;
};

export type WorkflowsControllerListWorkflowRuns200 = ListWorkflowRunsOutput;

export type WorkflowsControllerListWorkflowRunsMutationRequest = ListWorkflowRunsInput;

export type WorkflowsControllerListWorkflowRunsMutationResponse = WorkflowsControllerListWorkflowRuns200;

export type WorkflowsControllerListWorkflowRunsMutation = {
    Response: WorkflowsControllerListWorkflowRuns200;
    Request: WorkflowsControllerListWorkflowRunsMutationRequest;
    Errors: any;
};

export type WorkflowsControllerGetWorkflowRunPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type WorkflowsControllerGetWorkflowRun200 = GetWorkflowRunOutput;

export type WorkflowsControllerGetWorkflowRunQueryResponse = WorkflowsControllerGetWorkflowRun200;

export type WorkflowsControllerGetWorkflowRunQuery = {
    Response: WorkflowsControllerGetWorkflowRun200;
    PathParams: WorkflowsControllerGetWorkflowRunPathParams;
    Errors: any;
};

export type WorkflowsControllerListWorkflowRunNodesPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type WorkflowsControllerListWorkflowRunNodesQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type WorkflowsControllerListWorkflowRunNodes200 = ListWorkflowRunNodesOutput;

export type WorkflowsControllerListWorkflowRunNodesQueryResponse = WorkflowsControllerListWorkflowRunNodes200;

export type WorkflowsControllerListWorkflowRunNodesQuery = {
    Response: WorkflowsControllerListWorkflowRunNodes200;
    PathParams: WorkflowsControllerListWorkflowRunNodesPathParams;
    QueryParams: WorkflowsControllerListWorkflowRunNodesQueryParams;
    Errors: any;
};

export type WorkflowsControllerCancelWorkflowRuns201 = CancelWorkflowRunsOutput;

export type WorkflowsControllerCancelWorkflowRunsMutationRequest = CancelWorkflowRunsInputBody;

export type WorkflowsControllerCancelWorkflowRunsMutationResponse = WorkflowsControllerCancelWorkflowRuns201;

export type WorkflowsControllerCancelWorkflowRunsMutation = {
    Response: WorkflowsControllerCancelWorkflowRuns201;
    Request: WorkflowsControllerCancelWorkflowRunsMutationRequest;
    Errors: any;
};

export type WorkflowsControllerRetryWorkflowRunPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type WorkflowsControllerRetryWorkflowRun200 = RetryWorkflowRunOutput;

export type WorkflowsControllerRetryWorkflowRunMutationRequest = RetryWorkflowRunInputBody;

export type WorkflowsControllerRetryWorkflowRunMutationResponse = WorkflowsControllerRetryWorkflowRun200;

export type WorkflowsControllerRetryWorkflowRunMutation = {
    Response: WorkflowsControllerRetryWorkflowRun200;
    Request: WorkflowsControllerRetryWorkflowRunMutationRequest;
    PathParams: WorkflowsControllerRetryWorkflowRunPathParams;
    Errors: any;
};

export type YeetControllerListDrivequantAverageScoresPathParams = {
    /**
     * @description Policy id
     * @type string
    */
    policyId: string;
};

export type YeetControllerListDrivequantAverageScoresQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type YeetControllerListDrivequantAverageScores200 = YeetListDrivequantAverageScoresOutput;

export type YeetControllerListDrivequantAverageScoresQueryResponse = YeetControllerListDrivequantAverageScores200;

export type YeetControllerListDrivequantAverageScoresQuery = {
    Response: YeetControllerListDrivequantAverageScores200;
    PathParams: YeetControllerListDrivequantAverageScoresPathParams;
    QueryParams: YeetControllerListDrivequantAverageScoresQueryParams;
    Errors: any;
};

export type YeetControllerSurchargePolicyPathParams = {
    /**
     * @description Policy id
     * @type string
    */
    policyId: string;
};

export type YeetControllerSurchargePolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type YeetControllerSurchargePolicy201 = YeetSurchargePolicyOutput;

export type YeetControllerSurchargePolicyMutationRequest = YeetSurchargePolicyInputBody;

export type YeetControllerSurchargePolicyMutationResponse = YeetControllerSurchargePolicy201;

export type YeetControllerSurchargePolicyMutation = {
    Response: YeetControllerSurchargePolicy201;
    Request: YeetControllerSurchargePolicyMutationRequest;
    PathParams: YeetControllerSurchargePolicyPathParams;
    QueryParams: YeetControllerSurchargePolicyQueryParams;
    Errors: any;
};

export type YeetControllerListPossibleDrivequantUsersPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type YeetControllerListPossibleDrivequantUsersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Keep only the user linked to this Drivequant user id
     * @type string | undefined
    */
    externalServiceId?: string;
};

export type YeetControllerListPossibleDrivequantUsers200 = YeetListPossibleDrivequantUsersOutput;

export type YeetControllerListPossibleDrivequantUsersQueryResponse = YeetControllerListPossibleDrivequantUsers200;

export type YeetControllerListPossibleDrivequantUsersQuery = {
    Response: YeetControllerListPossibleDrivequantUsers200;
    PathParams: YeetControllerListPossibleDrivequantUsersPathParams;
    QueryParams: YeetControllerListPossibleDrivequantUsersQueryParams;
    Errors: any;
};

export type YeetControllerListDrivequantHistoricalUsersPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type YeetControllerListDrivequantHistoricalUsers200 = YeetListDrivequantHistoricalUsersOutput;

export type YeetControllerListDrivequantHistoricalUsersQueryResponse = YeetControllerListDrivequantHistoricalUsers200;

export type YeetControllerListDrivequantHistoricalUsersQuery = {
    Response: YeetControllerListDrivequantHistoricalUsers200;
    PathParams: YeetControllerListDrivequantHistoricalUsersPathParams;
    Errors: any;
};

export type YeetControllerAttachDrivequantUserIdToCustomerPathParams = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    drivequantUserId: string;
};

export type YeetControllerAttachDrivequantUserIdToCustomer201 = YeetAttachDrivequantUserIdToCustomerOutput;

export type YeetControllerAttachDrivequantUserIdToCustomerMutationResponse = YeetControllerAttachDrivequantUserIdToCustomer201;

export type YeetControllerAttachDrivequantUserIdToCustomerMutation = {
    Response: YeetControllerAttachDrivequantUserIdToCustomer201;
    PathParams: YeetControllerAttachDrivequantUserIdToCustomerPathParams;
    Errors: any;
};

export type AxeceControllerListDrivequantAverageScoresPathParams = {
    /**
     * @description Policy id
     * @type string
    */
    policyId: string;
};

export type AxeceControllerListDrivequantAverageScoresQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type AxeceControllerListDrivequantAverageScores200 = AxeceListDrivequantAverageScoresOutput;

export type AxeceControllerListDrivequantAverageScoresQueryResponse = AxeceControllerListDrivequantAverageScores200;

export type AxeceControllerListDrivequantAverageScoresQuery = {
    Response: AxeceControllerListDrivequantAverageScores200;
    PathParams: AxeceControllerListDrivequantAverageScoresPathParams;
    QueryParams: AxeceControllerListDrivequantAverageScoresQueryParams;
    Errors: any;
};

export type AxeceControllerSurchargePolicyPathParams = {
    /**
     * @description Policy id
     * @type string
    */
    policyId: string;
};

export type AxeceControllerSurchargePolicyQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
};

export type AxeceControllerSurchargePolicy201 = AxeceSurchargePolicyOutput;

export type AxeceControllerSurchargePolicyMutationRequest = AxeceSurchargePolicyInputBody;

export type AxeceControllerSurchargePolicyMutationResponse = AxeceControllerSurchargePolicy201;

export type AxeceControllerSurchargePolicyMutation = {
    Response: AxeceControllerSurchargePolicy201;
    Request: AxeceControllerSurchargePolicyMutationRequest;
    PathParams: AxeceControllerSurchargePolicyPathParams;
    QueryParams: AxeceControllerSurchargePolicyQueryParams;
    Errors: any;
};

export type AxeceControllerListPossibleDrivequantUsersPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type AxeceControllerListPossibleDrivequantUsersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Keep only the user linked to this Drivequant user id
     * @type string | undefined
    */
    externalServiceId?: string;
};

export type AxeceControllerListPossibleDrivequantUsers200 = AxeceListPossibleDrivequantUsersOutput;

export type AxeceControllerListPossibleDrivequantUsersQueryResponse = AxeceControllerListPossibleDrivequantUsers200;

export type AxeceControllerListPossibleDrivequantUsersQuery = {
    Response: AxeceControllerListPossibleDrivequantUsers200;
    PathParams: AxeceControllerListPossibleDrivequantUsersPathParams;
    QueryParams: AxeceControllerListPossibleDrivequantUsersQueryParams;
    Errors: any;
};

export type AxeceControllerListDrivequantHistoricalUsersPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type AxeceControllerListDrivequantHistoricalUsers200 = AxeceListDrivequantHistoricalUsersOutput;

export type AxeceControllerListDrivequantHistoricalUsersQueryResponse = AxeceControllerListDrivequantHistoricalUsers200;

export type AxeceControllerListDrivequantHistoricalUsersQuery = {
    Response: AxeceControllerListDrivequantHistoricalUsers200;
    PathParams: AxeceControllerListDrivequantHistoricalUsersPathParams;
    Errors: any;
};

export type AxeceControllerAttachDrivequantUserIdToCustomerPathParams = {
    /**
     * @type string
    */
    customerId: string;
    /**
     * @type string
    */
    drivequantUserId: string;
};

export type AxeceControllerAttachDrivequantUserIdToCustomer201 = AxeceAttachDrivequantUserIdToCustomerOutput;

export type AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse = AxeceControllerAttachDrivequantUserIdToCustomer201;

export type AxeceControllerAttachDrivequantUserIdToCustomerMutation = {
    Response: AxeceControllerAttachDrivequantUserIdToCustomer201;
    PathParams: AxeceControllerAttachDrivequantUserIdToCustomerPathParams;
    Errors: any;
};

export type YousignControllerWebhook201 = any;

export type YousignControllerWebhookMutationResponse = YousignControllerWebhook201;

export type YousignControllerWebhookMutation = {
    Response: YousignControllerWebhook201;
    Errors: any;
};

export type YousignControllerTenantWebhookPathParams = {
    /**
     * @type string
    */
    tenant: string;
};

export type YousignControllerTenantWebhook201 = any;

export type YousignControllerTenantWebhookMutationResponse = YousignControllerTenantWebhook201;

export type YousignControllerTenantWebhookMutation = {
    Response: YousignControllerTenantWebhook201;
    PathParams: YousignControllerTenantWebhookPathParams;
    Errors: any;
};

export type EmailEngineWebhookControllerWebhook200 = any;

export type EmailEngineWebhookControllerWebhookMutationResponse = EmailEngineWebhookControllerWebhook200;

export type EmailEngineWebhookControllerWebhookMutation = {
    Response: EmailEngineWebhookControllerWebhook200;
    Errors: any;
};

export type Ar24ControllerRegisteredLetter200 = any;

export type Ar24ControllerRegisteredLetterMutationResponse = Ar24ControllerRegisteredLetter200;

export type Ar24ControllerRegisteredLetterMutation = {
    Response: Ar24ControllerRegisteredLetter200;
    Errors: any;
};

export type AdminAr24ControllerListUsers200 = ListAR24UsersOutput;

export type AdminAr24ControllerListUsersQueryResponse = AdminAr24ControllerListUsers200;

export type AdminAr24ControllerListUsersQuery = {
    Response: AdminAr24ControllerListUsers200;
    Errors: any;
};

export type AdminAr24ControllerCreateUser200 = CreateAR24UserOutput;

export type AdminAr24ControllerCreateUserMutationRequest = CreateAR24UserInput;

export type AdminAr24ControllerCreateUserMutationResponse = AdminAr24ControllerCreateUser200;

export type AdminAr24ControllerCreateUserMutation = {
    Response: AdminAr24ControllerCreateUser200;
    Request: AdminAr24ControllerCreateUserMutationRequest;
    Errors: any;
};

export type AdminAr24ControllerRequestUserAccess200 = AR24UserRelaunchOutput;

export type AdminAr24ControllerRequestUserAccessMutationRequest = RequestAR24UserAccessInput;

export type AdminAr24ControllerRequestUserAccessMutationResponse = AdminAr24ControllerRequestUserAccess200;

export type AdminAr24ControllerRequestUserAccessMutation = {
    Response: AdminAr24ControllerRequestUserAccess200;
    Request: AdminAr24ControllerRequestUserAccessMutationRequest;
    Errors: any;
};

export type AdminAr24ControllerGetUserPathParams = {
    /**
     * @type string
    */
    userId: string;
};

export type AdminAr24ControllerGetUser200 = GetAR24UserOutput;

export type AdminAr24ControllerGetUserQueryResponse = AdminAr24ControllerGetUser200;

export type AdminAr24ControllerGetUserQuery = {
    Response: AdminAr24ControllerGetUser200;
    PathParams: AdminAr24ControllerGetUserPathParams;
    Errors: any;
};

export type AdminAr24ControllerUpdateUserPathParams = {
    /**
     * @type string
    */
    userId: string;
};

export type AdminAr24ControllerUpdateUser200 = UpdateAR24UserOutput;

export type AdminAr24ControllerUpdateUserMutationRequest = UpdateAR24UserBodyDto;

export type AdminAr24ControllerUpdateUserMutationResponse = AdminAr24ControllerUpdateUser200;

export type AdminAr24ControllerUpdateUserMutation = {
    Response: AdminAr24ControllerUpdateUser200;
    Request: AdminAr24ControllerUpdateUserMutationRequest;
    PathParams: AdminAr24ControllerUpdateUserPathParams;
    Errors: any;
};

export type AdminAr24ControllerRequestUserEulaPathParams = {
    /**
     * @type string
    */
    userId: string;
};

export type AdminAr24ControllerRequestUserEula200 = AR24UserRelaunchOutput;

export type AdminAr24ControllerRequestUserEulaMutationResponse = AdminAr24ControllerRequestUserEula200;

export type AdminAr24ControllerRequestUserEulaMutation = {
    Response: AdminAr24ControllerRequestUserEula200;
    PathParams: AdminAr24ControllerRequestUserEulaPathParams;
    Errors: any;
};

export type AdminAr24ControllerResendUserConfirmationPathParams = {
    /**
     * @type string
    */
    userId: string;
};

export type AdminAr24ControllerResendUserConfirmation200 = AR24UserRelaunchOutput;

export type AdminAr24ControllerResendUserConfirmationMutationResponse = AdminAr24ControllerResendUserConfirmation200;

export type AdminAr24ControllerResendUserConfirmationMutation = {
    Response: AdminAr24ControllerResendUserConfirmation200;
    PathParams: AdminAr24ControllerResendUserConfirmationPathParams;
    Errors: any;
};

export type SesControllerSesEvent200 = any;

export type SesControllerSesEventMutationResponse = SesControllerSesEvent200;

export type SesControllerSesEventMutation = {
    Response: SesControllerSesEvent200;
    Errors: any;
};

export const viewSpecificControllerAccountingSummaryQueryParamsStatusesEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type ViewSpecificControllerAccountingSummaryQueryParamsStatusesEnumKey = (typeof viewSpecificControllerAccountingSummaryQueryParamsStatusesEnum)[keyof typeof viewSpecificControllerAccountingSummaryQueryParamsStatusesEnum];

export type ViewSpecificControllerAccountingSummaryQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedBefore?: string;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedAfter?: string;
    /**
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @description Product id
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description Full text search
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @description Statuses to filter by
     * @type array | undefined
    */
    statuses?: ViewSpecificControllerAccountingSummaryQueryParamsStatusesEnumKey[];
    /**
     * @description Termination reasons to filter by
     * @type array | undefined
    */
    terminationReasons?: string[];
    /**
     * @description Filter by whether a formal notice has been sent
     * @type boolean | undefined
    */
    hasFormalNotice?: boolean;
    /**
     * @description Filter by whether one of the unpaid invoices has a planned automatic retry
     * @type boolean | undefined
    */
    hasAutomaticRetry?: boolean;
    /**
     * @description Filter policies by unpaid duration in days (greater than or equal)
     * @type number | undefined
    */
    unpaidDurationDays?: number;
};

export type ViewSpecificControllerAccountingSummary200 = AccountingSummaryOutput;

export type ViewSpecificControllerAccountingSummaryQueryResponse = ViewSpecificControllerAccountingSummary200;

export type ViewSpecificControllerAccountingSummaryQuery = {
    Response: ViewSpecificControllerAccountingSummary200;
    QueryParams: ViewSpecificControllerAccountingSummaryQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListComplianceChecksOnPolicyPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type ViewSpecificControllerListComplianceChecksOnPolicyQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type ViewSpecificControllerListComplianceChecksOnPolicy200 = ListPolicyComplianceChecksOutput;

export type ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse = ViewSpecificControllerListComplianceChecksOnPolicy200;

export type ViewSpecificControllerListComplianceChecksOnPolicyQuery = {
    Response: ViewSpecificControllerListComplianceChecksOnPolicy200;
    PathParams: ViewSpecificControllerListComplianceChecksOnPolicyPathParams;
    QueryParams: ViewSpecificControllerListComplianceChecksOnPolicyQueryParams;
    Errors: any;
};

export type ViewSpecificControllerAcknowledgeComplianceAlertPathParams = {
    /**
     * @type string
    */
    alertId: string;
};

export type ViewSpecificControllerAcknowledgeComplianceAlert200 = UpdateAlertOutput;

export type ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse = ViewSpecificControllerAcknowledgeComplianceAlert200;

export type ViewSpecificControllerAcknowledgeComplianceAlertMutation = {
    Response: ViewSpecificControllerAcknowledgeComplianceAlert200;
    PathParams: ViewSpecificControllerAcknowledgeComplianceAlertPathParams;
    Errors: any;
};

export type ViewSpecificControllerListPolicyComplianceAlertsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type ViewSpecificControllerListPolicyComplianceAlertsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type ViewSpecificControllerListPolicyComplianceAlerts200 = ListPolicyComplianceAlertsOutput;

export type ViewSpecificControllerListPolicyComplianceAlertsQueryResponse = ViewSpecificControllerListPolicyComplianceAlerts200;

export type ViewSpecificControllerListPolicyComplianceAlertsQuery = {
    Response: ViewSpecificControllerListPolicyComplianceAlerts200;
    PathParams: ViewSpecificControllerListPolicyComplianceAlertsPathParams;
    QueryParams: ViewSpecificControllerListPolicyComplianceAlertsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListChildBrokerageFirmsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const viewSpecificControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type ViewSpecificControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnumKey = (typeof viewSpecificControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnum)[keyof typeof viewSpecificControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnum];

export const viewSpecificControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnum = {
    and: "and",
    or: "or"
} as const;

export type ViewSpecificControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnumKey = (typeof viewSpecificControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnum)[keyof typeof viewSpecificControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnum];

export type ViewSpecificControllerListChildBrokerageFirmsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type array | undefined
    */
    hasSomeDistributionRequestWithStatus?: ViewSpecificControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnumKey[];
    /**
     * @description Product id
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description Product filter mode: \"and\" to require all products, \"or\" to require any product
     * @default "or"
     * @type string | undefined
    */
    productFilterMode?: ViewSpecificControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnumKey;
    /**
     * @description Search query string
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: BrokerageFirmOrderDto;
};

export type ViewSpecificControllerListChildBrokerageFirms200 = ListChildBrokerageFirmsOutput;

export type ViewSpecificControllerListChildBrokerageFirmsQueryResponse = ViewSpecificControllerListChildBrokerageFirms200;

export type ViewSpecificControllerListChildBrokerageFirmsQuery = {
    Response: ViewSpecificControllerListChildBrokerageFirms200;
    PathParams: ViewSpecificControllerListChildBrokerageFirmsPathParams;
    QueryParams: ViewSpecificControllerListChildBrokerageFirmsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey = (typeof viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnum)[keyof typeof viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnum];

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type array | undefined
    */
    statuses?: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey[];
    /**
     * @description Product id
     * @type array | undefined
    */
    productIds?: string[];
};

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequests200 = ListWholesaleBrokerageFirmDistributionRequestsOutput;

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse = ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequests200;

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQuery = {
    Response: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequests200;
    PathParams: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams;
    QueryParams: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const viewSpecificControllerListBrokerageFirmDistributionRequestsQueryParamsStatusesEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey = (typeof viewSpecificControllerListBrokerageFirmDistributionRequestsQueryParamsStatusesEnum)[keyof typeof viewSpecificControllerListBrokerageFirmDistributionRequestsQueryParamsStatusesEnum];

export type ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams = {
    /**
     * @description Status of the distribution request
     * @type array | undefined
    */
    statuses?: ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey[];
};

export type ViewSpecificControllerListBrokerageFirmDistributionRequests201 = ListWholesaleBrokerageFirmDistributionRequestsOutput;

export type ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse = ViewSpecificControllerListBrokerageFirmDistributionRequests201;

export type ViewSpecificControllerListBrokerageFirmDistributionRequestsMutation = {
    Response: ViewSpecificControllerListBrokerageFirmDistributionRequests201;
    PathParams: ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams;
    QueryParams: ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListPolicyAssetsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type ViewSpecificControllerListPolicyAssetsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type ViewSpecificControllerListPolicyAssets200 = ListPolicyAssetsOutput;

export type ViewSpecificControllerListPolicyAssets403 = ForbiddenErrorDto;

export type ViewSpecificControllerListPolicyAssets404 = PolicyNotFoundErrorDto;

export type ViewSpecificControllerListPolicyAssetsQueryResponse = ViewSpecificControllerListPolicyAssets200;

export type ViewSpecificControllerListPolicyAssetsQuery = {
    Response: ViewSpecificControllerListPolicyAssets200;
    PathParams: ViewSpecificControllerListPolicyAssetsPathParams;
    QueryParams: ViewSpecificControllerListPolicyAssetsQueryParams;
    Errors: ViewSpecificControllerListPolicyAssets403 | ViewSpecificControllerListPolicyAssets404;
};

export type ViewSpecificControllerGetAvailablePricingPathParams = {
    /**
     * @description Policy ID
     * @type string
    */
    policyId: string;
};

export type ViewSpecificControllerGetAvailablePricingQueryParams = {
    /**
     * @description Branch ID (optional, defaults to latest)
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Policy custom fields as JSON string (e.g. [{\"key\":\"breed\",\"value\":\"Arabian\"}])
     * @type string | undefined
    */
    policyCustomFields?: string;
    /**
     * @description Asset custom fields as JSON string (e.g. [{\"key\":\"equineValue\",\"value\":5000}])
     * @type string | undefined
    */
    assetCustomFields?: string;
    /**
     * @description Peril parameters as JSON string (e.g. {\"peril-ASSISTANCE\":true,\"peril-GLASS_BREAKAGE\":false})
     * @type string | undefined
    */
    policyCustomFieldsInputs?: string;
    /**
     * @description Manual component values as a JSON-encoded string, e.g. {\"values\":{\"RETAIL_SUBSCRIPTION_FEE\":5000}}.
     * @type string | undefined
    */
    manualComponentValues?: string;
};

export type ViewSpecificControllerGetAvailablePricing200 = GetAvailablePricingOutput;

export type ViewSpecificControllerGetAvailablePricing400 = InvalidPricingDetailsErrorDto;

export type ViewSpecificControllerGetAvailablePricing404 = PolicyNotFoundErrorDto;

export type ViewSpecificControllerGetAvailablePricingQueryResponse = ViewSpecificControllerGetAvailablePricing200;

export type ViewSpecificControllerGetAvailablePricingQuery = {
    Response: ViewSpecificControllerGetAvailablePricing200;
    PathParams: ViewSpecificControllerGetAvailablePricingPathParams;
    QueryParams: ViewSpecificControllerGetAvailablePricingQueryParams;
    Errors: ViewSpecificControllerGetAvailablePricing400 | ViewSpecificControllerGetAvailablePricing404;
};

export type ViewSpecificControllerListPolicyCustomersPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type ViewSpecificControllerListPolicyCustomersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type ViewSpecificControllerListPolicyCustomers200 = ListPolicyCustomersOutput;

export type ViewSpecificControllerListPolicyCustomers403 = ForbiddenErrorDto;

export type ViewSpecificControllerListPolicyCustomers404 = PolicyNotFoundErrorDto;

export type ViewSpecificControllerListPolicyCustomersQueryResponse = ViewSpecificControllerListPolicyCustomers200;

export type ViewSpecificControllerListPolicyCustomersQuery = {
    Response: ViewSpecificControllerListPolicyCustomers200;
    PathParams: ViewSpecificControllerListPolicyCustomersPathParams;
    QueryParams: ViewSpecificControllerListPolicyCustomersQueryParams;
    Errors: ViewSpecificControllerListPolicyCustomers403 | ViewSpecificControllerListPolicyCustomers404;
};

export type ViewSpecificControllerListCustomerInvoicesPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type ViewSpecificControllerListCustomerInvoicesQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description the issuedAt sort direction
     * @default "asc"
     * @type string | undefined
    */
    issuedAtOrder?: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Return cancelled and zero-amount invoices, excluded by default
     * @default false
     * @type boolean | undefined
    */
    includeCancelledAndZeroAmount?: boolean;
};

export type ViewSpecificControllerListCustomerInvoices200 = ListCustomerInvoicesOutput;

export type ViewSpecificControllerListCustomerInvoices404 = CustomerNotFoundErrorDto;

export type ViewSpecificControllerListCustomerInvoicesQueryResponse = ViewSpecificControllerListCustomerInvoices200;

export type ViewSpecificControllerListCustomerInvoicesQuery = {
    Response: ViewSpecificControllerListCustomerInvoices200;
    PathParams: ViewSpecificControllerListCustomerInvoicesPathParams;
    QueryParams: ViewSpecificControllerListCustomerInvoicesQueryParams;
    Errors: ViewSpecificControllerListCustomerInvoices404;
};

export type ViewSpecificControllerListCustomerPaymentsPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type ViewSpecificControllerListCustomerPaymentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type ViewSpecificControllerListCustomerPayments200 = ListCustomerPaymentsOutput;

export type ViewSpecificControllerListCustomerPayments404 = CustomerNotFoundErrorDto;

export type ViewSpecificControllerListCustomerPaymentsQueryResponse = ViewSpecificControllerListCustomerPayments200;

export type ViewSpecificControllerListCustomerPaymentsQuery = {
    Response: ViewSpecificControllerListCustomerPayments200;
    PathParams: ViewSpecificControllerListCustomerPaymentsPathParams;
    QueryParams: ViewSpecificControllerListCustomerPaymentsQueryParams;
    Errors: ViewSpecificControllerListCustomerPayments404;
};

export type ViewSpecificControllerListCustomerPaymentMethodsPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type ViewSpecificControllerListCustomerPaymentMethodsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type ViewSpecificControllerListCustomerPaymentMethods200 = ListCustomerPaymentMethodsOutput;

export type ViewSpecificControllerListCustomerPaymentMethods404 = CustomerNotFoundErrorDto;

export type ViewSpecificControllerListCustomerPaymentMethodsQueryResponse = ViewSpecificControllerListCustomerPaymentMethods200;

export type ViewSpecificControllerListCustomerPaymentMethodsQuery = {
    Response: ViewSpecificControllerListCustomerPaymentMethods200;
    PathParams: ViewSpecificControllerListCustomerPaymentMethodsPathParams;
    QueryParams: ViewSpecificControllerListCustomerPaymentMethodsQueryParams;
    Errors: ViewSpecificControllerListCustomerPaymentMethods404;
};

export type ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type ViewSpecificControllerListBrokerageFirmPaymentMethods200 = ListBrokerageFirmPaymentMethodsOutput;

export type ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse = ViewSpecificControllerListBrokerageFirmPaymentMethods200;

export type ViewSpecificControllerListBrokerageFirmPaymentMethodsQuery = {
    Response: ViewSpecificControllerListBrokerageFirmPaymentMethods200;
    PathParams: ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams;
    QueryParams: ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListBrokerageFirmPoliciesPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type ViewSpecificControllerListBrokerageFirmPolicies201 = ListBrokerageFirmPoliciesOutput;

export type ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest = ListBrokerageFirmPoliciesInputBody;

export type ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse = ViewSpecificControllerListBrokerageFirmPolicies201;

export type ViewSpecificControllerListBrokerageFirmPoliciesMutation = {
    Response: ViewSpecificControllerListBrokerageFirmPolicies201;
    Request: ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest;
    PathParams: ViewSpecificControllerListBrokerageFirmPoliciesPathParams;
    Errors: any;
};

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParamsStatusesEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParamsStatusesEnumKey = (typeof viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParamsStatusesEnum)[keyof typeof viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParamsStatusesEnum];

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedBefore?: string;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedAfter?: string;
    /**
     * @description Product ids
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description Full text search
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @description Statuses to filter by
     * @type array | undefined
    */
    statuses?: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParamsStatusesEnumKey[];
    /**
     * @description Termination reasons to filter by
     * @type array | undefined
    */
    terminationReasons?: string[];
    /**
     * @description Filter by whether a formal notice has been sent
     * @type boolean | undefined
    */
    hasFormalNotice?: boolean;
    /**
     * @description Filter by whether one of the unpaid invoices has a planned automatic retry
     * @type boolean | undefined
    */
    hasAutomaticRetry?: boolean;
    /**
     * @description Filter policies by unpaid duration in days (greater than or equal)
     * @type number | undefined
    */
    unpaidDurationDays?: number;
};

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirm200 = AccountingSummaryOutput;

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse = ViewSpecificControllerGetAccountingSummaryForBrokerageFirm200;

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQuery = {
    Response: ViewSpecificControllerGetAccountingSummaryForBrokerageFirm200;
    PathParams: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams;
    QueryParams: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListCustomerRelationsPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type ViewSpecificControllerListCustomerRelationsQueryParams = {
    /**
     * @description the page info
     * @type object | undefined
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type array | undefined
    */
    types?: string[];
};

export type ViewSpecificControllerListCustomerRelations200 = ListCustomerRelationsOutput;

export type ViewSpecificControllerListCustomerRelationsQueryResponse = ViewSpecificControllerListCustomerRelations200;

export type ViewSpecificControllerListCustomerRelationsQuery = {
    Response: ViewSpecificControllerListCustomerRelations200;
    PathParams: ViewSpecificControllerListCustomerRelationsPathParams;
    QueryParams: ViewSpecificControllerListCustomerRelationsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListBrokerageFirmDerogationsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type ViewSpecificControllerListBrokerageFirmDerogationsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type ViewSpecificControllerListBrokerageFirmDerogations201 = ListBrokerageFirmDerogationsOutput;

export type ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest = ListBrokerageFirmDerogationsInputBody;

export type ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse = ViewSpecificControllerListBrokerageFirmDerogations201;

export type ViewSpecificControllerListBrokerageFirmDerogationsMutation = {
    Response: ViewSpecificControllerListBrokerageFirmDerogations201;
    Request: ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest;
    PathParams: ViewSpecificControllerListBrokerageFirmDerogationsPathParams;
    QueryParams: ViewSpecificControllerListBrokerageFirmDerogationsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerListProductCommonDocumentsPathParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
};

export type ViewSpecificControllerListProductCommonDocumentsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type ViewSpecificControllerListProductCommonDocuments200 = ListProductCommonDocumentsOutput;

export type ViewSpecificControllerListProductCommonDocumentsQueryResponse = ViewSpecificControllerListProductCommonDocuments200;

export type ViewSpecificControllerListProductCommonDocumentsQuery = {
    Response: ViewSpecificControllerListProductCommonDocuments200;
    PathParams: ViewSpecificControllerListProductCommonDocumentsPathParams;
    QueryParams: ViewSpecificControllerListProductCommonDocumentsQueryParams;
    Errors: any;
};

export type ViewSpecificControllerCreateActiveTeamPathParams = {
    /**
     * @description Brokerage firm ID
     * @type string
    */
    brokerageFirmId: string;
};

export type ViewSpecificControllerCreateActiveTeam201 = CreateActiveTeamOutput;

export type ViewSpecificControllerCreateActiveTeamMutationRequest = CreateActiveTeamInputBody;

export type ViewSpecificControllerCreateActiveTeamMutationResponse = ViewSpecificControllerCreateActiveTeam201;

export type ViewSpecificControllerCreateActiveTeamMutation = {
    Response: ViewSpecificControllerCreateActiveTeam201;
    Request: ViewSpecificControllerCreateActiveTeamMutationRequest;
    PathParams: ViewSpecificControllerCreateActiveTeamPathParams;
    Errors: any;
};

export const billingReadsControllerGetAccountingSummaryQueryParamsStatusesEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type BillingReadsControllerGetAccountingSummaryQueryParamsStatusesEnumKey = (typeof billingReadsControllerGetAccountingSummaryQueryParamsStatusesEnum)[keyof typeof billingReadsControllerGetAccountingSummaryQueryParamsStatusesEnum];

export type BillingReadsControllerGetAccountingSummaryQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedBefore?: string;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedAfter?: string;
    /**
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @description Product id
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description Full text search
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @description Statuses to filter by
     * @type array | undefined
    */
    statuses?: BillingReadsControllerGetAccountingSummaryQueryParamsStatusesEnumKey[];
    /**
     * @description Termination reasons to filter by
     * @type array | undefined
    */
    terminationReasons?: string[];
    /**
     * @description Filter by whether a formal notice has been sent
     * @type boolean | undefined
    */
    hasFormalNotice?: boolean;
    /**
     * @description Filter by whether one of the unpaid invoices has a planned automatic retry
     * @type boolean | undefined
    */
    hasAutomaticRetry?: boolean;
    /**
     * @description Filter policies by unpaid duration in days (greater than or equal)
     * @type number | undefined
    */
    unpaidDurationDays?: number;
};

export type BillingReadsControllerGetAccountingSummary200 = AccountingSummaryOutput;

export type BillingReadsControllerGetAccountingSummaryQueryResponse = BillingReadsControllerGetAccountingSummary200;

export type BillingReadsControllerGetAccountingSummaryQuery = {
    Response: BillingReadsControllerGetAccountingSummary200;
    QueryParams: BillingReadsControllerGetAccountingSummaryQueryParams;
    Errors: any;
};

export type BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const billingReadsControllerGetBrokerageFirmAccountingSummaryQueryParamsStatusesEnum = {
    POLICY_CREATED: "POLICY_CREATED",
    POLICY_QUOTED: "POLICY_QUOTED",
    POLICY_CONFIRMED: "POLICY_CONFIRMED",
    POLICY_SIGNED: "POLICY_SIGNED",
    POLICY_STARTED: "POLICY_STARTED",
    POLICY_STOPPED: "POLICY_STOPPED",
    POLICY_SUSPENDED: "POLICY_SUSPENDED"
} as const;

export type BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParamsStatusesEnumKey = (typeof billingReadsControllerGetBrokerageFirmAccountingSummaryQueryParamsStatusesEnum)[keyof typeof billingReadsControllerGetBrokerageFirmAccountingSummaryQueryParamsStatusesEnum];

export type BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedBefore?: string;
    /**
     * @type string | undefined
    */
    unpaidInvoiceIssuedAfter?: string;
    /**
     * @description Product ids
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description Full text search
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @description Statuses to filter by
     * @type array | undefined
    */
    statuses?: BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParamsStatusesEnumKey[];
    /**
     * @description Termination reasons to filter by
     * @type array | undefined
    */
    terminationReasons?: string[];
    /**
     * @description Filter by whether a formal notice has been sent
     * @type boolean | undefined
    */
    hasFormalNotice?: boolean;
    /**
     * @description Filter by whether one of the unpaid invoices has a planned automatic retry
     * @type boolean | undefined
    */
    hasAutomaticRetry?: boolean;
    /**
     * @description Filter policies by unpaid duration in days (greater than or equal)
     * @type number | undefined
    */
    unpaidDurationDays?: number;
};

export type BillingReadsControllerGetBrokerageFirmAccountingSummary200 = AccountingSummaryOutput;

export type BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse = BillingReadsControllerGetBrokerageFirmAccountingSummary200;

export type BillingReadsControllerGetBrokerageFirmAccountingSummaryQuery = {
    Response: BillingReadsControllerGetBrokerageFirmAccountingSummary200;
    PathParams: BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams;
    QueryParams: BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams;
    Errors: any;
};

export type BillingReadsControllerListCustomerInvoicesPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type BillingReadsControllerListCustomerInvoicesQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description the issuedAt sort direction
     * @default "asc"
     * @type string | undefined
    */
    issuedAtOrder?: string;
    /**
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Return cancelled and zero-amount invoices, excluded by default
     * @default false
     * @type boolean | undefined
    */
    includeCancelledAndZeroAmount?: boolean;
};

export type BillingReadsControllerListCustomerInvoices200 = ListCustomerInvoicesOutput;

export type BillingReadsControllerListCustomerInvoices404 = CustomerNotFoundErrorDto;

export type BillingReadsControllerListCustomerInvoicesQueryResponse = BillingReadsControllerListCustomerInvoices200;

export type BillingReadsControllerListCustomerInvoicesQuery = {
    Response: BillingReadsControllerListCustomerInvoices200;
    PathParams: BillingReadsControllerListCustomerInvoicesPathParams;
    QueryParams: BillingReadsControllerListCustomerInvoicesQueryParams;
    Errors: BillingReadsControllerListCustomerInvoices404;
};

export type PaymentsReadsControllerListCustomerPaymentsPathParams = {
    /**
     * @description The customer id
     * @type string
    */
    customerId: string;
};

export type PaymentsReadsControllerListCustomerPaymentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type PaymentsReadsControllerListCustomerPayments200 = ListCustomerPaymentsOutput;

export type PaymentsReadsControllerListCustomerPayments404 = CustomerNotFoundErrorDto;

export type PaymentsReadsControllerListCustomerPaymentsQueryResponse = PaymentsReadsControllerListCustomerPayments200;

export type PaymentsReadsControllerListCustomerPaymentsQuery = {
    Response: PaymentsReadsControllerListCustomerPayments200;
    PathParams: PaymentsReadsControllerListCustomerPaymentsPathParams;
    QueryParams: PaymentsReadsControllerListCustomerPaymentsQueryParams;
    Errors: PaymentsReadsControllerListCustomerPayments404;
};

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments200 = ListCustomerPaymentMethodsOutput;

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404 = CustomerNotFoundErrorDto;

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse = PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments200;

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQuery = {
    Response: PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments200;
    PathParams: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams;
    QueryParams: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams;
    Errors: PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404;
};

export type PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
};

export type PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments200 = ListBrokerageFirmPaymentMethodsOutput;

export type PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse = PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments200;

export type PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQuery = {
    Response: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments200;
    PathParams: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams;
    QueryParams: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams;
    Errors: any;
};

export type CustomerReadsControllerListCustomerRelationsPathParams = {
    /**
     * @type string
    */
    customerId: string;
};

export type CustomerReadsControllerListCustomerRelationsQueryParams = {
    /**
     * @description the page info
     * @type object | undefined
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type array | undefined
    */
    types?: string[];
};

export type CustomerReadsControllerListCustomerRelations200 = ListCustomerRelationsOutput;

export type CustomerReadsControllerListCustomerRelationsQueryResponse = CustomerReadsControllerListCustomerRelations200;

export type CustomerReadsControllerListCustomerRelationsQuery = {
    Response: CustomerReadsControllerListCustomerRelations200;
    PathParams: CustomerReadsControllerListCustomerRelationsPathParams;
    QueryParams: CustomerReadsControllerListCustomerRelationsQueryParams;
    Errors: any;
};

export type CustomerReadsControllerListPolicyCustomersPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type CustomerReadsControllerListPolicyCustomersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type CustomerReadsControllerListPolicyCustomers200 = ListPolicyCustomersOutput;

export type CustomerReadsControllerListPolicyCustomers403 = ForbiddenErrorDto;

export type CustomerReadsControllerListPolicyCustomers404 = PolicyNotFoundErrorDto;

export type CustomerReadsControllerListPolicyCustomersQueryResponse = CustomerReadsControllerListPolicyCustomers200;

export type CustomerReadsControllerListPolicyCustomersQuery = {
    Response: CustomerReadsControllerListPolicyCustomers200;
    PathParams: CustomerReadsControllerListPolicyCustomersPathParams;
    QueryParams: CustomerReadsControllerListPolicyCustomersQueryParams;
    Errors: CustomerReadsControllerListPolicyCustomers403 | CustomerReadsControllerListPolicyCustomers404;
};

export type AssetReadsControllerListPolicyAssetsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type AssetReadsControllerListPolicyAssetsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the simulatedAt datetime
     * @type string | undefined
    */
    simulatedAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

export type AssetReadsControllerListPolicyAssets200 = ListPolicyAssetsOutput;

export type AssetReadsControllerListPolicyAssets403 = ForbiddenErrorDto;

export type AssetReadsControllerListPolicyAssets404 = PolicyNotFoundErrorDto;

export type AssetReadsControllerListPolicyAssetsQueryResponse = AssetReadsControllerListPolicyAssets200;

export type AssetReadsControllerListPolicyAssetsQuery = {
    Response: AssetReadsControllerListPolicyAssets200;
    PathParams: AssetReadsControllerListPolicyAssetsPathParams;
    QueryParams: AssetReadsControllerListPolicyAssetsQueryParams;
    Errors: AssetReadsControllerListPolicyAssets403 | AssetReadsControllerListPolicyAssets404;
};

export type PricingReadsControllerGetAvailablePricingPathParams = {
    /**
     * @description Policy ID
     * @type string
    */
    policyId: string;
};

export type PricingReadsControllerGetAvailablePricingQueryParams = {
    /**
     * @description Branch ID (optional, defaults to latest)
     * @type string | undefined
    */
    branchId?: string;
    /**
     * @description Policy custom fields as JSON string (e.g. [{\"key\":\"breed\",\"value\":\"Arabian\"}])
     * @type string | undefined
    */
    policyCustomFields?: string;
    /**
     * @description Asset custom fields as JSON string (e.g. [{\"key\":\"equineValue\",\"value\":5000}])
     * @type string | undefined
    */
    assetCustomFields?: string;
    /**
     * @description Peril parameters as JSON string (e.g. {\"peril-ASSISTANCE\":true,\"peril-GLASS_BREAKAGE\":false})
     * @type string | undefined
    */
    policyCustomFieldsInputs?: string;
    /**
     * @description Manual component values as a JSON-encoded string, e.g. {\"values\":{\"RETAIL_SUBSCRIPTION_FEE\":5000}}.
     * @type string | undefined
    */
    manualComponentValues?: string;
};

export type PricingReadsControllerGetAvailablePricing200 = GetAvailablePricingOutput;

export type PricingReadsControllerGetAvailablePricing400 = InvalidPricingDetailsErrorDto;

export type PricingReadsControllerGetAvailablePricing404 = PolicyNotFoundErrorDto;

export type PricingReadsControllerGetAvailablePricingQueryResponse = PricingReadsControllerGetAvailablePricing200;

export type PricingReadsControllerGetAvailablePricingQuery = {
    Response: PricingReadsControllerGetAvailablePricing200;
    PathParams: PricingReadsControllerGetAvailablePricingPathParams;
    QueryParams: PricingReadsControllerGetAvailablePricingQueryParams;
    Errors: PricingReadsControllerGetAvailablePricing400 | PricingReadsControllerGetAvailablePricing404;
};

export type DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type DerogationsReadsControllerSearchBrokerageFirmDerogations201 = ListBrokerageFirmDerogationsOutput;

export type DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest = ListBrokerageFirmDerogationsInputBody;

export type DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse = DerogationsReadsControllerSearchBrokerageFirmDerogations201;

export type DerogationsReadsControllerSearchBrokerageFirmDerogationsMutation = {
    Response: DerogationsReadsControllerSearchBrokerageFirmDerogations201;
    Request: DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest;
    PathParams: DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams;
    QueryParams: DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams;
    Errors: any;
};

export type ComplianceReadsControllerListPolicyComplianceAlertsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type ComplianceReadsControllerListPolicyComplianceAlertsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type ComplianceReadsControllerListPolicyComplianceAlerts200 = ListPolicyComplianceAlertsOutput;

export type ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse = ComplianceReadsControllerListPolicyComplianceAlerts200;

export type ComplianceReadsControllerListPolicyComplianceAlertsQuery = {
    Response: ComplianceReadsControllerListPolicyComplianceAlerts200;
    PathParams: ComplianceReadsControllerListPolicyComplianceAlertsPathParams;
    QueryParams: ComplianceReadsControllerListPolicyComplianceAlertsQueryParams;
    Errors: any;
};

export type ComplianceReadsControllerListPolicyComplianceChecksPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type ComplianceReadsControllerListPolicyComplianceChecksQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type ComplianceReadsControllerListPolicyComplianceChecks200 = ListPolicyComplianceChecksOutput;

export type ComplianceReadsControllerListPolicyComplianceChecksQueryResponse = ComplianceReadsControllerListPolicyComplianceChecks200;

export type ComplianceReadsControllerListPolicyComplianceChecksQuery = {
    Response: ComplianceReadsControllerListPolicyComplianceChecks200;
    PathParams: ComplianceReadsControllerListPolicyComplianceChecksPathParams;
    QueryParams: ComplianceReadsControllerListPolicyComplianceChecksQueryParams;
    Errors: any;
};

export type ComplianceReadsControllerAcknowledgeComplianceAlertPathParams = {
    /**
     * @type string
    */
    alertId: string;
};

export type ComplianceReadsControllerAcknowledgeComplianceAlert200 = UpdateAlertOutput;

export type ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse = ComplianceReadsControllerAcknowledgeComplianceAlert200;

export type ComplianceReadsControllerAcknowledgeComplianceAlertMutation = {
    Response: ComplianceReadsControllerAcknowledgeComplianceAlert200;
    PathParams: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams;
    Errors: any;
};

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const brokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnumKey = (typeof brokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnum)[keyof typeof brokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnum];

export const brokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnum = {
    and: "and",
    or: "or"
} as const;

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnumKey = (typeof brokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnum)[keyof typeof brokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnum];

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type array | undefined
    */
    hasSomeDistributionRequestWithStatus?: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsHasSomeDistributionRequestWithStatusEnumKey[];
    /**
     * @description Product id
     * @type array | undefined
    */
    productIds?: string[];
    /**
     * @description Product filter mode: \"and\" to require all products, \"or\" to require any product
     * @default "or"
     * @type string | undefined
    */
    productFilterMode?: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParamsProductFilterModeEnumKey;
    /**
     * @description Search query string
     * @type string | undefined
    */
    queryString?: string;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: BrokerageFirmOrderDto;
};

export type BrokerageFirmsReadsControllerListChildBrokerageFirms200 = ListChildBrokerageFirmsOutput;

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse = BrokerageFirmsReadsControllerListChildBrokerageFirms200;

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsQuery = {
    Response: BrokerageFirmsReadsControllerListChildBrokerageFirms200;
    PathParams: BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams;
    QueryParams: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams;
    Errors: any;
};

export type BrokerageFirmsReadsControllerCreateActiveTeamPathParams = {
    /**
     * @description Brokerage firm ID
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmsReadsControllerCreateActiveTeam201 = CreateActiveTeamOutput;

export type BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest = CreateActiveTeamInputBody;

export type BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse = BrokerageFirmsReadsControllerCreateActiveTeam201;

export type BrokerageFirmsReadsControllerCreateActiveTeamMutation = {
    Response: BrokerageFirmsReadsControllerCreateActiveTeam201;
    Request: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest;
    PathParams: BrokerageFirmsReadsControllerCreateActiveTeamPathParams;
    Errors: any;
};

export type PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type PolicyReadsControllerSearchBrokerageFirmPolicies201 = ListBrokerageFirmPoliciesOutput;

export type PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest = ListBrokerageFirmPoliciesInputBody;

export type PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse = PolicyReadsControllerSearchBrokerageFirmPolicies201;

export type PolicyReadsControllerSearchBrokerageFirmPoliciesMutation = {
    Response: PolicyReadsControllerSearchBrokerageFirmPolicies201;
    Request: PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest;
    PathParams: PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams;
    Errors: any;
};

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParamsStatusesEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey = (typeof distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParamsStatusesEnum)[keyof typeof distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParamsStatusesEnum];

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams = {
    /**
     * @description Status of the distribution request
     * @type array | undefined
    */
    statuses?: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey[];
};

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests201 = ListBrokerageFirmDistributionRequestsOutput;

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse = DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests201;

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutation = {
    Response: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests201;
    PathParams: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams;
    QueryParams: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams;
    Errors: any;
};

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export const distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey = (typeof distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnum)[keyof typeof distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnum];

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type array | undefined
    */
    statuses?: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParamsStatusesEnumKey[];
    /**
     * @description Product id
     * @type array | undefined
    */
    productIds?: string[];
};

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests200 = ListWholesaleBrokerageFirmDistributionRequestsOutput;

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse = DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests200;

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQuery = {
    Response: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests200;
    PathParams: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams;
    QueryParams: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams;
    Errors: any;
};

export type DocumentsReadsControllerListProductCommonDocumentsPathParams = {
    /**
     * @description The productId
     * @type string
    */
    productId: string;
};

export type DocumentsReadsControllerListProductCommonDocumentsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
};

export type DocumentsReadsControllerListProductCommonDocuments200 = ListProductCommonDocumentsOutput;

export type DocumentsReadsControllerListProductCommonDocumentsQueryResponse = DocumentsReadsControllerListProductCommonDocuments200;

export type DocumentsReadsControllerListProductCommonDocumentsQuery = {
    Response: DocumentsReadsControllerListProductCommonDocuments200;
    PathParams: DocumentsReadsControllerListProductCommonDocumentsPathParams;
    QueryParams: DocumentsReadsControllerListProductCommonDocumentsQueryParams;
    Errors: any;
};

export type McpServerControllerHandleServerSentEvents200 = any;

export type McpServerControllerHandleServerSentEventsQueryResponse = McpServerControllerHandleServerSentEvents200;

export type McpServerControllerHandleServerSentEventsQuery = {
    Response: McpServerControllerHandleServerSentEvents200;
    Errors: any;
};

export type McpServerControllerHandleRequest201 = any;

export type McpServerControllerHandleRequestMutationResponse = McpServerControllerHandleRequest201;

export type McpServerControllerHandleRequestMutation = {
    Response: McpServerControllerHandleRequest201;
    Errors: any;
};

export type ComplianceControllerCreateCheck201 = CreateComplianceCheckOutput;

export type ComplianceControllerCreateCheckMutationRequest = CreateComplianceCheckInputBody;

export type ComplianceControllerCreateCheckMutationResponse = ComplianceControllerCreateCheck201;

export type ComplianceControllerCreateCheckMutation = {
    Response: ComplianceControllerCreateCheck201;
    Request: ComplianceControllerCreateCheckMutationRequest;
    Errors: any;
};

export type ComplianceControllerListChecksQueryParams = {
    /**
     * @type number | undefined
    */
    page?: number;
    /**
     * @type number | undefined
    */
    limit?: number;
    /**
     * @type string | undefined
    */
    entityId?: string;
};

export type ComplianceControllerListChecks200 = ListComplianceChecksOutput;

export type ComplianceControllerListChecksQueryResponse = ComplianceControllerListChecks200;

export type ComplianceControllerListChecksQuery = {
    Response: ComplianceControllerListChecks200;
    QueryParams: ComplianceControllerListChecksQueryParams;
    Errors: any;
};

export type ComplianceControllerUpdateCheckPathParams = {
    /**
     * @type string
    */
    checkId: string;
};

export type ComplianceControllerUpdateCheck200 = UpdateComplianceCheckOutput;

export type ComplianceControllerUpdateCheck404 = CheckNotFoundErrorDto;

export type ComplianceControllerUpdateCheckMutationRequest = UpdateComplianceCheckInputBody;

export type ComplianceControllerUpdateCheckMutationResponse = ComplianceControllerUpdateCheck200;

export type ComplianceControllerUpdateCheckMutation = {
    Response: ComplianceControllerUpdateCheck200;
    Request: ComplianceControllerUpdateCheckMutationRequest;
    PathParams: ComplianceControllerUpdateCheckPathParams;
    Errors: ComplianceControllerUpdateCheck404;
};

export type ComplianceControllerDeleteCheckPathParams = {
    /**
     * @type string
    */
    checkId: string;
};

export type ComplianceControllerDeleteCheck200 = DeleteComplianceCheckOutput;

export type ComplianceControllerDeleteCheck404 = CheckNotFoundErrorDto;

export type ComplianceControllerDeleteCheckMutationResponse = ComplianceControllerDeleteCheck200;

export type ComplianceControllerDeleteCheckMutation = {
    Response: ComplianceControllerDeleteCheck200;
    PathParams: ComplianceControllerDeleteCheckPathParams;
    Errors: ComplianceControllerDeleteCheck404;
};

export type ComplianceControllerGetCheckPathParams = {
    /**
     * @type string
    */
    checkId: string;
};

export type ComplianceControllerGetCheck200 = GetComplianceCheckOutput;

export type ComplianceControllerGetCheck404 = CheckNotFoundErrorDto;

export type ComplianceControllerGetCheckQueryResponse = ComplianceControllerGetCheck200;

export type ComplianceControllerGetCheckQuery = {
    Response: ComplianceControllerGetCheck200;
    PathParams: ComplianceControllerGetCheckPathParams;
    Errors: ComplianceControllerGetCheck404;
};

export type ComplianceControllerCreateAlert201 = CreateAlertOutput;

export type ComplianceControllerCreateAlert404 = CheckNotFoundErrorDto;

export type ComplianceControllerCreateAlertMutationRequest = CreateAlertInputBody;

export type ComplianceControllerCreateAlertMutationResponse = ComplianceControllerCreateAlert201;

export type ComplianceControllerCreateAlertMutation = {
    Response: ComplianceControllerCreateAlert201;
    Request: ComplianceControllerCreateAlertMutationRequest;
    Errors: ComplianceControllerCreateAlert404;
};

export type ComplianceControllerListAlertsQueryParams = {
    /**
     * @type number | undefined
    */
    page?: number;
    /**
     * @type number | undefined
    */
    limit?: number;
    /**
     * @type boolean | undefined
    */
    acknowledged?: boolean;
    /**
     * @description Filter alerts by entity ID (via associated check)
     * @type string | undefined
    */
    entityId?: string;
    /**
     * @description Filter alerts by check target
     * @type string | undefined
    */
    target?: string;
};

export type ComplianceControllerListAlerts200 = ListAlertsOutput;

export type ComplianceControllerListAlertsQueryResponse = ComplianceControllerListAlerts200;

export type ComplianceControllerListAlertsQuery = {
    Response: ComplianceControllerListAlerts200;
    QueryParams: ComplianceControllerListAlertsQueryParams;
    Errors: any;
};

export type ComplianceControllerAcknowledgeAlertsByEntityPathParams = {
    /**
     * @description Entity ID to acknowledge all alerts for
     * @type string
    */
    entityId: string;
};

export type ComplianceControllerAcknowledgeAlertsByEntity200 = AcknowledgeAlertsByEntityOutput;

export type ComplianceControllerAcknowledgeAlertsByEntityMutationResponse = ComplianceControllerAcknowledgeAlertsByEntity200;

export type ComplianceControllerAcknowledgeAlertsByEntityMutation = {
    Response: ComplianceControllerAcknowledgeAlertsByEntity200;
    PathParams: ComplianceControllerAcknowledgeAlertsByEntityPathParams;
    Errors: any;
};

export type ComplianceControllerAcknowledgeAlertsByCheckIds200 = AcknowledgeAlertsByCheckIdsOutput;

export type ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest = AcknowledgeAlertsByCheckIdsInputBody;

export type ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse = ComplianceControllerAcknowledgeAlertsByCheckIds200;

export type ComplianceControllerAcknowledgeAlertsByCheckIdsMutation = {
    Response: ComplianceControllerAcknowledgeAlertsByCheckIds200;
    Request: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest;
    Errors: any;
};

export type ComplianceControllerUpdateAlertPathParams = {
    /**
     * @type string
    */
    alertId: string;
};

export type ComplianceControllerUpdateAlert200 = UpdateAlertOutput;

export type ComplianceControllerUpdateAlert404 = AlertNotFoundErrorDto;

export type ComplianceControllerUpdateAlertMutationRequest = UpdateAlertInputBody;

export type ComplianceControllerUpdateAlertMutationResponse = ComplianceControllerUpdateAlert200;

export type ComplianceControllerUpdateAlertMutation = {
    Response: ComplianceControllerUpdateAlert200;
    Request: ComplianceControllerUpdateAlertMutationRequest;
    PathParams: ComplianceControllerUpdateAlertPathParams;
    Errors: ComplianceControllerUpdateAlert404;
};

export type ComplianceControllerDeleteAlertPathParams = {
    /**
     * @type string
    */
    alertId: string;
};

export type ComplianceControllerDeleteAlert200 = DeleteAlertOutput;

export type ComplianceControllerDeleteAlert404 = (AlertNotFoundErrorDto | CheckNotFoundErrorDto);

export type ComplianceControllerDeleteAlertMutationResponse = ComplianceControllerDeleteAlert200;

export type ComplianceControllerDeleteAlertMutation = {
    Response: ComplianceControllerDeleteAlert200;
    PathParams: ComplianceControllerDeleteAlertPathParams;
    Errors: ComplianceControllerDeleteAlert404;
};

export type ComplianceControllerGetAlertPathParams = {
    /**
     * @type string
    */
    alertId: string;
};

export type ComplianceControllerGetAlert200 = GetAlertOutput;

export type ComplianceControllerGetAlert404 = (AlertNotFoundErrorDto | CheckNotFoundErrorDto);

export type ComplianceControllerGetAlertQueryResponse = ComplianceControllerGetAlert200;

export type ComplianceControllerGetAlertQuery = {
    Response: ComplianceControllerGetAlert200;
    PathParams: ComplianceControllerGetAlertPathParams;
    Errors: ComplianceControllerGetAlert404;
};

export type RelationsControllerCreateRelation201 = CreateRelationOutput;

export type RelationsControllerCreateRelationMutationRequest = CreateRelationInputBody;

export type RelationsControllerCreateRelationMutationResponse = RelationsControllerCreateRelation201;

export type RelationsControllerCreateRelationMutation = {
    Response: RelationsControllerCreateRelation201;
    Request: RelationsControllerCreateRelationMutationRequest;
    Errors: any;
};

export type RelationsControllerGetPermissionRelationsForUserQueryParams = {
    /**
     * @description The productId
     * @type string | undefined
    */
    productId?: string;
    /**
     * @type string
    */
    userId: string;
};

export type RelationsControllerGetPermissionRelationsForUser200 = GetPermissionRelationsForUserOutput;

export type RelationsControllerGetPermissionRelationsForUserQueryResponse = RelationsControllerGetPermissionRelationsForUser200;

export type RelationsControllerGetPermissionRelationsForUserQuery = {
    Response: RelationsControllerGetPermissionRelationsForUser200;
    QueryParams: RelationsControllerGetPermissionRelationsForUserQueryParams;
    Errors: any;
};

export type RelationsControllerDeleteRelationPathParams = {
    /**
     * @type string
    */
    relationId: string;
};

export type RelationsControllerDeleteRelation200 = DeleteRelationOutput;

export type RelationsControllerDeleteRelationMutationResponse = RelationsControllerDeleteRelation200;

export type RelationsControllerDeleteRelationMutation = {
    Response: RelationsControllerDeleteRelation200;
    PathParams: RelationsControllerDeleteRelationPathParams;
    Errors: any;
};

export type RelationsControllerListTenantUsersQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type array | undefined
    */
    userIds?: string[];
    /**
     * @description Resolves to the Cognito users owning that email
     * @type string | undefined
    */
    email?: string;
    /**
     * @description Admin only: filter to a single tenant
     * @type string | undefined
    */
    filterTenantId?: string;
};

export type RelationsControllerListTenantUsers200 = ListTenantUsersOutput;

export type RelationsControllerListTenantUsersQueryResponse = RelationsControllerListTenantUsers200;

export type RelationsControllerListTenantUsersQuery = {
    Response: RelationsControllerListTenantUsers200;
    QueryParams: RelationsControllerListTenantUsersQueryParams;
    Errors: any;
};

export type RelationsControllerListRelationsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type string | undefined
    */
    userId?: string;
    /**
     * @type string | undefined
    */
    resourceId?: string;
    /**
     * @type array | undefined
    */
    resourceIds?: string[];
    /**
     * @type array | undefined
    */
    types?: string[];
};

export type RelationsControllerListRelations200 = ListRelationsOutput;

export type RelationsControllerListRelationsQueryResponse = RelationsControllerListRelations200;

export type RelationsControllerListRelationsQuery = {
    Response: RelationsControllerListRelations200;
    QueryParams: RelationsControllerListRelationsQueryParams;
    Errors: any;
};

export type LegacyPermissionsControllerAtMe200 = LegacyAtMeOutput;

export type LegacyPermissionsControllerAtMe404 = (UserNotFoundErrorDto | UserEmailNotFoundErrorDto);

export type LegacyPermissionsControllerAtMeQueryResponse = LegacyPermissionsControllerAtMe200;

export type LegacyPermissionsControllerAtMeQuery = {
    Response: LegacyPermissionsControllerAtMe200;
    Errors: LegacyPermissionsControllerAtMe404;
};

/**
 * @description Brokerage firm created successfully.
*/
export type BrokerageFirmControllerCreateBrokerageFirm201 = CreateBrokerageFirmOutput;

export type BrokerageFirmControllerCreateBrokerageFirm400 = (MissingProductErrorDto | InvalidProductTypeErrorDto | InvalidCommissionRangeErrorDto | ImpossibleCommissionRangeErrorDto);

export type BrokerageFirmControllerCreateBrokerageFirm404 = (CompanyNotFoundErrorDto | ProductNotFoundErrorDto);

/**
 * @description Brokerage firm creation payload
*/
export type BrokerageFirmControllerCreateBrokerageFirmMutationRequest = CreateBrokerageFirmInputBody;

export type BrokerageFirmControllerCreateBrokerageFirmMutationResponse = BrokerageFirmControllerCreateBrokerageFirm201;

export type BrokerageFirmControllerCreateBrokerageFirmMutation = {
    Response: BrokerageFirmControllerCreateBrokerageFirm201;
    Request: BrokerageFirmControllerCreateBrokerageFirmMutationRequest;
    Errors: BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404;
};

export type BrokerageFirmControllerListBrokerageFirmsQueryParams = {
    /**
     * @description the page info
     * @type object | undefined
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @type string | undefined
    */
    parentBrokerageFirmId?: string;
};

/**
 * @description Paginated list of brokerage firms.
*/
export type BrokerageFirmControllerListBrokerageFirms200 = ListBrokerageFirmsOutput;

export type BrokerageFirmControllerListBrokerageFirmsQueryResponse = BrokerageFirmControllerListBrokerageFirms200;

export type BrokerageFirmControllerListBrokerageFirmsQuery = {
    Response: BrokerageFirmControllerListBrokerageFirms200;
    QueryParams: BrokerageFirmControllerListBrokerageFirmsQueryParams;
    Errors: any;
};

export type BrokerageFirmControllerUpdateBrokerageFirmPathParams = {
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Brokerage firm updated successfully.
*/
export type BrokerageFirmControllerUpdateBrokerageFirm200 = UpdateBrokerageFirmOutput;

export type BrokerageFirmControllerUpdateBrokerageFirm400 = DuplicatedProductErrorDto;

export type BrokerageFirmControllerUpdateBrokerageFirm404 = (BrokerageFirmNotFoundErrorDto | CompanyNotFoundErrorDto | ProductNotFoundErrorDto);

/**
 * @description Fields to update in the brokerage firm
*/
export type BrokerageFirmControllerUpdateBrokerageFirmMutationRequest = UpdateBrokerageFirmInputBody;

export type BrokerageFirmControllerUpdateBrokerageFirmMutationResponse = BrokerageFirmControllerUpdateBrokerageFirm200;

export type BrokerageFirmControllerUpdateBrokerageFirmMutation = {
    Response: BrokerageFirmControllerUpdateBrokerageFirm200;
    Request: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest;
    PathParams: BrokerageFirmControllerUpdateBrokerageFirmPathParams;
    Errors: BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404;
};

export type BrokerageFirmControllerGetBrokerageFirmPathParams = {
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Brokerage firm retrieved successfully.
*/
export type BrokerageFirmControllerGetBrokerageFirm200 = GetBrokerageFirmOutput;

export type BrokerageFirmControllerGetBrokerageFirm404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerGetBrokerageFirmQueryResponse = BrokerageFirmControllerGetBrokerageFirm200;

export type BrokerageFirmControllerGetBrokerageFirmQuery = {
    Response: BrokerageFirmControllerGetBrokerageFirm200;
    PathParams: BrokerageFirmControllerGetBrokerageFirmPathParams;
    Errors: BrokerageFirmControllerGetBrokerageFirm404;
};

export type BrokerageFirmControllerGenerateUploadDocumentUrlPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams = {
    /**
     * @description Optional: the whenAt datetime
     * @type string | undefined
    */
    whenAt?: string;
    /**
     * @description Optional: the branchId
     * @type string | undefined
    */
    branchId?: string;
};

/**
 * @description Upload URL generated successfully.
*/
export type BrokerageFirmControllerGenerateUploadDocumentUrl201 = BrokerageFirmGenerateDocumentUploadUrlOutput;

export type BrokerageFirmControllerGenerateUploadDocumentUrl400 = InvalidEventCreationDateErrorDto;

export type BrokerageFirmControllerGenerateUploadDocumentUrl403 = ForbiddenErrorDto;

export type BrokerageFirmControllerGenerateUploadDocumentUrl404 = PolicyNotFoundErrorDto;

/**
 * @description Document metadata for upload
*/
export type BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest = BrokerageFirmGenerateDocumentUploadUrlInputBody;

export type BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse = BrokerageFirmControllerGenerateUploadDocumentUrl201;

export type BrokerageFirmControllerGenerateUploadDocumentUrlMutation = {
    Response: BrokerageFirmControllerGenerateUploadDocumentUrl201;
    Request: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest;
    PathParams: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams;
    QueryParams: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams;
    Errors: BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404;
};

export type BrokerageFirmControllerListDocumentsPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerListDocumentsQueryParams = {
    /**
     * @description the page info
     * @type object | undefined
    */
    pageInfo?: PageInfo;
    /**
     * @description the sort options
     * @type object | undefined
    */
    order?: OrderDto;
    /**
     * @type array | undefined
    */
    categories?: string[];
    /**
     * @type boolean | undefined
    */
    includeArchived?: boolean;
};

/**
 * @description Documents listed successfully.
*/
export type BrokerageFirmControllerListDocuments200 = BrokerageFirmListDocumentsOutput;

export type BrokerageFirmControllerListDocuments400 = InvalidEventCreationDateErrorDto;

export type BrokerageFirmControllerListDocuments403 = ForbiddenErrorDto;

export type BrokerageFirmControllerListDocuments404 = PolicyNotFoundErrorDto;

export type BrokerageFirmControllerListDocumentsQueryResponse = BrokerageFirmControllerListDocuments200;

export type BrokerageFirmControllerListDocumentsQuery = {
    Response: BrokerageFirmControllerListDocuments200;
    PathParams: BrokerageFirmControllerListDocumentsPathParams;
    QueryParams: BrokerageFirmControllerListDocumentsQueryParams;
    Errors: BrokerageFirmControllerListDocuments400 | BrokerageFirmControllerListDocuments403 | BrokerageFirmControllerListDocuments404;
};

export type BrokerageFirmControllerDeleteDocumentsPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerDeleteDocumentsQueryParams = {
    /**
     * @description the document ids to delete
     * @type array
    */
    ids: string[];
};

/**
 * @description Documents deleted successfully.
*/
export type BrokerageFirmControllerDeleteDocuments200 = BrokerageFirmDeleteDocumentsOutput;

export type BrokerageFirmControllerDeleteDocuments400 = InvalidEventCreationDateErrorDto;

export type BrokerageFirmControllerDeleteDocuments403 = ForbiddenErrorDto;

export type BrokerageFirmControllerDeleteDocuments404 = PolicyNotFoundErrorDto;

export type BrokerageFirmControllerDeleteDocumentsMutationResponse = BrokerageFirmControllerDeleteDocuments200;

export type BrokerageFirmControllerDeleteDocumentsMutation = {
    Response: BrokerageFirmControllerDeleteDocuments200;
    PathParams: BrokerageFirmControllerDeleteDocumentsPathParams;
    QueryParams: BrokerageFirmControllerDeleteDocumentsQueryParams;
    Errors: BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404;
};

export type BrokerageFirmControllerGenerateReportPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Report generation started or completed successfully.
*/
export type BrokerageFirmControllerGenerateReport201 = GenerateReportForBrokerageFirmOutput;

/**
 * @description Report generation parameters
*/
export type BrokerageFirmControllerGenerateReportMutationRequest = GenerateReportInputBody;

export type BrokerageFirmControllerGenerateReportMutationResponse = BrokerageFirmControllerGenerateReport201;

export type BrokerageFirmControllerGenerateReportMutation = {
    Response: BrokerageFirmControllerGenerateReport201;
    Request: BrokerageFirmControllerGenerateReportMutationRequest;
    PathParams: BrokerageFirmControllerGenerateReportPathParams;
    Errors: any;
};

export type BrokerageFirmControllerListReportsPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerListReportsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @type array | undefined
    */
    reportTypes?: string[];
};

/**
 * @description Reports listed successfully.
*/
export type BrokerageFirmControllerListReports200 = ListReportsForBrokerageFirmOutput;

export type BrokerageFirmControllerListReportsQueryResponse = BrokerageFirmControllerListReports200;

export type BrokerageFirmControllerListReportsQuery = {
    Response: BrokerageFirmControllerListReports200;
    PathParams: BrokerageFirmControllerListReportsPathParams;
    QueryParams: BrokerageFirmControllerListReportsQueryParams;
    Errors: any;
};

export const brokerageFirmControllerGetReportConfigPathParamsTypeEnum = {
    WORKFLOWS: "WORKFLOWS",
    POLICY_EXPORT: "POLICY_EXPORT",
    INVOICE_EXPORT: "INVOICE_EXPORT",
    BROKERAGE_FIRM_EXPORT: "BROKERAGE_FIRM_EXPORT",
    CLAIMS_EXPORT: "CLAIMS_EXPORT",
    COMMISSION_TRANSFER: "COMMISSION_TRANSFER",
    COMMISSION_TRANSFER_DETAIL: "COMMISSION_TRANSFER_DETAIL",
    YEET_VTC_IMA_ASSISTANCE: "YEET_VTC_IMA_ASSISTANCE",
    YEET_VTC_CASH_STATEMENT: "YEET_VTC_CASH_STATEMENT",
    YEET_VTC_POLICIES_V2: "YEET_VTC_POLICIES_V2",
    YEET_VTC_POLICY_PARTY: "YEET_VTC_POLICY_PARTY",
    YEET_VTC_KPI: "YEET_VTC_KPI",
    YEET_VTC_POLICY_INVOICE: "YEET_VTC_POLICY_INVOICE",
    YEET_VTC_POLICY_INVOICE_WAKAM: "YEET_VTC_POLICY_INVOICE_WAKAM",
    YEET_FVA_EXPORT: "YEET_FVA_EXPORT",
    YEET_STARTED_UNPAID_POLICIES: "YEET_STARTED_UNPAID_POLICIES",
    GARANTIE_PLUS_SALES_REPORT: "GARANTIE_PLUS_SALES_REPORT",
    GARANTIE_PLUS_SALES_RECAP_BY_GARAGE: "GARANTIE_PLUS_SALES_RECAP_BY_GARAGE",
    GARANTIE_PLUS_CAREA_CASH_STATEMENT: "GARANTIE_PLUS_CAREA_CASH_STATEMENT",
    GARANTIE_PLUS_CAAREA_DAILY_REPORT: "GARANTIE_PLUS_CAAREA_DAILY_REPORT",
    AXECE_POLICY: "AXECE_POLICY",
    AXECE_POLICY_INVOICE: "AXECE_POLICY_INVOICE",
    AXECE_POLICY_PARTY: "AXECE_POLICY_PARTY",
    AXECE_KPI: "AXECE_KPI",
    AXECE_MRPRO_KPI: "AXECE_MRPRO_KPI",
    AXECE_POLICY_INVOICE_WAKAM: "AXECE_POLICY_INVOICE_WAKAM",
    AXECE_VTC_IMA_ASSISTANCE: "AXECE_VTC_IMA_ASSISTANCE",
    AXECE_COMMISSION: "AXECE_COMMISSION",
    AXECE_BROKERAGE_FIRM_POLICIES: "AXECE_BROKERAGE_FIRM_POLICIES",
    AXECE_CASH_STATEMENT: "AXECE_CASH_STATEMENT",
    AXECE_MRPRO_POLICY: "AXECE_MRPRO_POLICY",
    AXECE_FVA_EXPORT: "AXECE_FVA_EXPORT",
    AXECE_STARTED_UNPAID_POLICIES: "AXECE_STARTED_UNPAID_POLICIES",
    ACCELERANT_VTC_IMA_ASSISTANCE: "ACCELERANT_VTC_IMA_ASSISTANCE",
    TUTASSUR_MILA_PNO_ASSUREUR_EXPORT: "TUTASSUR_MILA_PNO_ASSUREUR_EXPORT",
    TUTASSUR_MILA_MRH_ASSUREUR_EXPORT: "TUTASSUR_MILA_MRH_ASSUREUR_EXPORT",
    TUTASSUR_AXA_PORTFOLIO_EXPORT: "TUTASSUR_AXA_PORTFOLIO_EXPORT",
    TUTASSUR_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_COMPANY_STATEMENT: "TUTASSUR_COMPANY_STATEMENT",
    TUTASSUR_BROKER_STATEMENT: "TUTASSUR_BROKER_STATEMENT",
    TUTASSUR_CASH_STATEMENT: "TUTASSUR_CASH_STATEMENT",
    TUTASSUR_HISCOX_COLLECTED_PREMIUMS: "TUTASSUR_HISCOX_COLLECTED_PREMIUMS",
    TUTASSUR_HISCOX_UNPAID_PREMIUMS: "TUTASSUR_HISCOX_UNPAID_PREMIUMS",
    TUTASSUR_HISCOX_BORDEREAU_PRODUCTION: "TUTASSUR_HISCOX_BORDEREAU_PRODUCTION",
    TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT: "TUTASSUR_PJPRO_CFDP_PORTFOLIO_EXPORT",
    TUTASSUR_PJPRO_CFDP_MTA_EXPORT: "TUTASSUR_PJPRO_CFDP_MTA_EXPORT",
    TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT: "TUTASSUR_PJPRO_CFDP_RESILIATION_EXPORT",
    EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505227_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505228_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJPRO_505229_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505239_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT: "EGA_PJAUTO_505240_GROUPAMA_PORTFOLIO_EXPORT",
    EGA_ACCOUNTING_STATEMENT: "EGA_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PRO_ACCOUNTING_STATEMENT",
    EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT: "EGA_PJAUTO_PARTICULIER_ACCOUNTING_STATEMENT",
    EGA_RCPRO_ACCOUNTING_STATEMENT: "EGA_RCPRO_ACCOUNTING_STATEMENT",
    EGA_RCPRO_MADP_EXPORT: "EGA_RCPRO_MADP_EXPORT",
    EGA_CASH_STATEMENT: "EGA_CASH_STATEMENT",
    EGA_RETAIL_PERFORMANCE: "EGA_RETAIL_PERFORMANCE",
    EGA_TEAM_PERFORMANCE: "EGA_TEAM_PERFORMANCE",
    LUKO_MRH_POLICY: "LUKO_MRH_POLICY",
    LUKO_MRH_POLICY_INVOICE_WAKAM: "LUKO_MRH_POLICY_INVOICE_WAKAM",
    LUKO_MRH_POLICY_PAYMENT_WAKAM: "LUKO_MRH_POLICY_PAYMENT_WAKAM",
    LUKO_MRH_KPI: "LUKO_MRH_KPI",
    LUKO_CASH_STATEMENT: "LUKO_CASH_STATEMENT",
    ASSUREQUINE_CASH_STATEMENT: "ASSUREQUINE_CASH_STATEMENT",
    ASSUREQUINE_PORTFOLIO_STATEMENT: "ASSUREQUINE_PORTFOLIO_STATEMENT",
    ASSUREQUINE_PREMIUM_STATEMENT: "ASSUREQUINE_PREMIUM_STATEMENT",
    ARCHIMEDE_CFDP_MSG002_STOCK: "ARCHIMEDE_CFDP_MSG002_STOCK",
    ARCHIMEDE_CFDP_MSG002_STOCK_CSV: "ARCHIMEDE_CFDP_MSG002_STOCK_CSV",
    PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT: "PLEBAGNAC_CAPITAL_COMPLIANCE_JIREFCLIENT",
    PLEBAGNAC_CFDP_STATEMENT: "PLEBAGNAC_CFDP_STATEMENT",
    PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT: "PLEBAGNAC_MSC_WHEELCHAIR_STATEMENT",
    PLEBAGNAC_MSC_SCOOTER_STATEMENT: "PLEBAGNAC_MSC_SCOOTER_STATEMENT",
    PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT: "PLEBAGNAC_SCOOTER_ACCOUNTING_STATEMENT"
} as const;

export type BrokerageFirmControllerGetReportConfigPathParamsTypeEnumKey = (typeof brokerageFirmControllerGetReportConfigPathParamsTypeEnum)[keyof typeof brokerageFirmControllerGetReportConfigPathParamsTypeEnum];

export type BrokerageFirmControllerGetReportConfigPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @description The type of report
     * @type string
    */
    type: BrokerageFirmControllerGetReportConfigPathParamsTypeEnumKey;
};

/**
 * @description Report configuration retrieved successfully.
*/
export type BrokerageFirmControllerGetReportConfig200 = GetReportConfigForBrokerageFirmOutput;

export type BrokerageFirmControllerGetReportConfigQueryResponse = BrokerageFirmControllerGetReportConfig200;

export type BrokerageFirmControllerGetReportConfigQuery = {
    Response: BrokerageFirmControllerGetReportConfig200;
    PathParams: BrokerageFirmControllerGetReportConfigPathParams;
    Errors: any;
};

export type BrokerageFirmControllerListCommissionStatementsPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerListCommissionStatementsQueryParams = {
    /**
     * @description The calendar year to read, in Europe/Paris; defaults to the current one
     * @type number | undefined
    */
    year?: number;
};

/**
 * @description Commission statements listed successfully.
*/
export type BrokerageFirmControllerListCommissionStatements200 = ListCommissionStatementsForBrokerageFirmOutput;

export type BrokerageFirmControllerListCommissionStatements403 = ForbiddenErrorDto;

export type BrokerageFirmControllerListCommissionStatements404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerListCommissionStatementsQueryResponse = BrokerageFirmControllerListCommissionStatements200;

export type BrokerageFirmControllerListCommissionStatementsQuery = {
    Response: BrokerageFirmControllerListCommissionStatements200;
    PathParams: BrokerageFirmControllerListCommissionStatementsPathParams;
    QueryParams: BrokerageFirmControllerListCommissionStatementsQueryParams;
    Errors: BrokerageFirmControllerListCommissionStatements403 | BrokerageFirmControllerListCommissionStatements404;
};

export type BrokerageFirmControllerGetCommissionStatementDocumentPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Document ready to download.
*/
export type BrokerageFirmControllerGetCommissionStatementDocument201 = CommissionStatementFileDto;

export type BrokerageFirmControllerGetCommissionStatementDocument400 = RequestValidationFailedErrorDto;

export type BrokerageFirmControllerGetCommissionStatementDocument403 = ForbiddenErrorDto;

export type BrokerageFirmControllerGetCommissionStatementDocument404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest = GetCommissionStatementDocumentInputBody;

export type BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse = BrokerageFirmControllerGetCommissionStatementDocument201;

export type BrokerageFirmControllerGetCommissionStatementDocumentMutation = {
    Response: BrokerageFirmControllerGetCommissionStatementDocument201;
    Request: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest;
    PathParams: BrokerageFirmControllerGetCommissionStatementDocumentPathParams;
    Errors: BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404;
};

export type BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Payment method setup secret retrieved.
*/
export type BrokerageFirmControllerGetPaymentMethodSetupSecret200 = GetPaymentMethodSetupSecretForBrokerageFirmOutput;

export type BrokerageFirmControllerGetPaymentMethodSetupSecret404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse = BrokerageFirmControllerGetPaymentMethodSetupSecret200;

export type BrokerageFirmControllerGetPaymentMethodSetupSecretQuery = {
    Response: BrokerageFirmControllerGetPaymentMethodSetupSecret200;
    PathParams: BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams;
    Errors: BrokerageFirmControllerGetPaymentMethodSetupSecret404;
};

export type BrokerageFirmControllerGetPaymentMethodsPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Payment methods retrieved successfully.
*/
export type BrokerageFirmControllerGetPaymentMethods200 = GetBrokerageFirmPaymentMethodsOutput;

export type BrokerageFirmControllerGetPaymentMethods404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerGetPaymentMethodsQueryResponse = BrokerageFirmControllerGetPaymentMethods200;

export type BrokerageFirmControllerGetPaymentMethodsQuery = {
    Response: BrokerageFirmControllerGetPaymentMethods200;
    PathParams: BrokerageFirmControllerGetPaymentMethodsPathParams;
    Errors: BrokerageFirmControllerGetPaymentMethods404;
};

export type BrokerageFirmControllerGenerateDocumentsForSignaturePathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams = {
    /**
     * @type array | undefined
    */
    documentTypes?: GenerateDocumentsForSignatureDocumentType[];
    /**
     * @type boolean | undefined
    */
    includeApproved?: boolean;
};

/**
 * @description Documents for signature generated successfully.
*/
export type BrokerageFirmControllerGenerateDocumentsForSignature201 = GenerateDocumentsForSignatureOutput;

export type BrokerageFirmControllerGenerateDocumentsForSignature404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse = BrokerageFirmControllerGenerateDocumentsForSignature201;

export type BrokerageFirmControllerGenerateDocumentsForSignatureMutation = {
    Response: BrokerageFirmControllerGenerateDocumentsForSignature201;
    PathParams: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams;
    QueryParams: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams;
    Errors: BrokerageFirmControllerGenerateDocumentsForSignature404;
};

export type BrokerageFirmControllerGenerateSignatureRequestPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
};

/**
 * @description Signature request generated successfully.
*/
export type BrokerageFirmControllerGenerateSignatureRequest201 = GenerateSignatureRequestForBrokerageFirmOutput;

export type BrokerageFirmControllerGenerateSignatureRequest404 = BrokerageFirmNotFoundErrorDto;

/**
 * @description Signature request payload
*/
export type BrokerageFirmControllerGenerateSignatureRequestMutationRequest = GenerateSignatureRequestForBrokerageFirmInputBody;

export type BrokerageFirmControllerGenerateSignatureRequestMutationResponse = BrokerageFirmControllerGenerateSignatureRequest201;

export type BrokerageFirmControllerGenerateSignatureRequestMutation = {
    Response: BrokerageFirmControllerGenerateSignatureRequest201;
    Request: BrokerageFirmControllerGenerateSignatureRequestMutationRequest;
    PathParams: BrokerageFirmControllerGenerateSignatureRequestPathParams;
    Errors: BrokerageFirmControllerGenerateSignatureRequest404;
};

export type BrokerageFirmControllerGenerateMandateSignatureRequestPathParams = {
    /**
     * @description the brokerageFirm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export type BrokerageFirmControllerGenerateMandateSignatureRequest201 = GenerateMandateSignatureRequestForBrokerageFirmOutput;

export type BrokerageFirmControllerGenerateMandateSignatureRequest400 = MissingBrokerageFirmContactFieldsErrorDto;

export type BrokerageFirmControllerGenerateMandateSignatureRequest404 = (BrokerageFirmNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type BrokerageFirmControllerGenerateMandateSignatureRequest409 = (ConflictingConfigErrorDto | ConflictingPaymentMethodStatusErrorDto);

export type BrokerageFirmControllerGenerateMandateSignatureRequest425 = NoUniqueDocumentTypeReadyToBeSignedErrorDto;

export type BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest = GenerateMandateSignatureRequestForBrokerageFirmInputBody;

export type BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse = BrokerageFirmControllerGenerateMandateSignatureRequest201;

export type BrokerageFirmControllerGenerateMandateSignatureRequestMutation = {
    Response: BrokerageFirmControllerGenerateMandateSignatureRequest201;
    Request: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest;
    PathParams: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams;
    Errors: BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425;
};

export type BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams = {
    /**
     * @description the brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export type BrokerageFirmControllerUpdatePreferredPaymentMethod200 = UpdatePreferredPaymentMethodOutput;

export type BrokerageFirmControllerUpdatePreferredPaymentMethod400 = InvalidPaymentMethodErrorDto;

export type BrokerageFirmControllerUpdatePreferredPaymentMethod404 = (BrokerageFirmNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type BrokerageFirmControllerUpdatePreferredPaymentMethod409 = ConflictingPaymentMethodStatusErrorDto;

export type BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse = BrokerageFirmControllerUpdatePreferredPaymentMethod200;

export type BrokerageFirmControllerUpdatePreferredPaymentMethodMutation = {
    Response: BrokerageFirmControllerUpdatePreferredPaymentMethod200;
    PathParams: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams;
    Errors: BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409;
};

export type BrokerageFirmControllerDeletePaymentMethodPathParams = {
    /**
     * @description the brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    paymentMethodId: string;
};

export type BrokerageFirmControllerDeletePaymentMethod200 = DeleteBrokerageFirmPaymentMethodOutput;

export type BrokerageFirmControllerDeletePaymentMethod404 = (BrokerageFirmNotFoundErrorDto | PaymentMethodNotFoundErrorDto);

export type BrokerageFirmControllerDeletePaymentMethod409 = CannotDeleteLastPaymentMethodErrorDto;

export type BrokerageFirmControllerDeletePaymentMethodMutationResponse = BrokerageFirmControllerDeletePaymentMethod200;

export type BrokerageFirmControllerDeletePaymentMethodMutation = {
    Response: BrokerageFirmControllerDeletePaymentMethod200;
    PathParams: BrokerageFirmControllerDeletePaymentMethodPathParams;
    Errors: BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409;
};

export type BrokerageFirmControllerTransferPoliciesPathParams = {
    /**
     * @description the brokerage firm to transfer the policies to
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmControllerTransferPolicies200 = TransferPoliciesToBrokerageFirmOutput;

export type BrokerageFirmControllerTransferPolicies404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFirmControllerTransferPoliciesMutationRequest = TransferPoliciesToBrokerageFirmInputBody;

export type BrokerageFirmControllerTransferPoliciesMutationResponse = BrokerageFirmControllerTransferPolicies200;

export type BrokerageFirmControllerTransferPoliciesMutation = {
    Response: BrokerageFirmControllerTransferPolicies200;
    Request: BrokerageFirmControllerTransferPoliciesMutationRequest;
    PathParams: BrokerageFirmControllerTransferPoliciesPathParams;
    Errors: BrokerageFirmControllerTransferPolicies404;
};

export type DistributionRequestControllerCreateManyDistributionRequests201 = CreateManyDistributionRequestsOutput;

export type DistributionRequestControllerCreateManyDistributionRequests409 = DistributionRequestConflictErrorDto;

export type DistributionRequestControllerCreateManyDistributionRequestsMutationRequest = CreateManyDistributionRequestsBody;

export type DistributionRequestControllerCreateManyDistributionRequestsMutationResponse = DistributionRequestControllerCreateManyDistributionRequests201;

export type DistributionRequestControllerCreateManyDistributionRequestsMutation = {
    Response: DistributionRequestControllerCreateManyDistributionRequests201;
    Request: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest;
    Errors: DistributionRequestControllerCreateManyDistributionRequests409;
};

export type DistributionRequestControllerApproveDistributionRequestPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type DistributionRequestControllerApproveDistributionRequest201 = ApproveDistributionRequestOutput;

export type DistributionRequestControllerApproveDistributionRequest404 = DistributionRequestNotFoundErrorDto;

export type DistributionRequestControllerApproveDistributionRequest409 = DistributionRequestConflictErrorDto;

export type DistributionRequestControllerApproveDistributionRequestMutationResponse = DistributionRequestControllerApproveDistributionRequest201;

export type DistributionRequestControllerApproveDistributionRequestMutation = {
    Response: DistributionRequestControllerApproveDistributionRequest201;
    PathParams: DistributionRequestControllerApproveDistributionRequestPathParams;
    Errors: DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409;
};

export type DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type DistributionRequestControllerWaitingForSignatureDistributionRequest201 = WaitingForSignatureDistributionRequestOutput;

export type DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse = DistributionRequestControllerWaitingForSignatureDistributionRequest201;

export type DistributionRequestControllerWaitingForSignatureDistributionRequestMutation = {
    Response: DistributionRequestControllerWaitingForSignatureDistributionRequest201;
    PathParams: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams;
    Errors: any;
};

export type DistributionRequestControllerDenyDistributionRequestPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type DistributionRequestControllerDenyDistributionRequest201 = DenyDistributionRequestOutput;

export type DistributionRequestControllerDenyDistributionRequest404 = DistributionRequestNotFoundErrorDto;

export type DistributionRequestControllerDenyDistributionRequest409 = DistributionRequestConflictErrorDto;

export type DistributionRequestControllerDenyDistributionRequestMutationResponse = DistributionRequestControllerDenyDistributionRequest201;

export type DistributionRequestControllerDenyDistributionRequestMutation = {
    Response: DistributionRequestControllerDenyDistributionRequest201;
    PathParams: DistributionRequestControllerDenyDistributionRequestPathParams;
    Errors: DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409;
};

export type DistributionRequestControllerRevokeDistributionRequestPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type DistributionRequestControllerRevokeDistributionRequest201 = RevokeDistributionRequestOutput;

export type DistributionRequestControllerRevokeDistributionRequest404 = DistributionRequestNotFoundErrorDto;

export type DistributionRequestControllerRevokeDistributionRequest409 = DistributionRequestConflictErrorDto;

export type DistributionRequestControllerRevokeDistributionRequestMutationResponse = DistributionRequestControllerRevokeDistributionRequest201;

export type DistributionRequestControllerRevokeDistributionRequestMutation = {
    Response: DistributionRequestControllerRevokeDistributionRequest201;
    PathParams: DistributionRequestControllerRevokeDistributionRequestPathParams;
    Errors: DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409;
};

export type DistributionRequestControllerGetDistributionRequestPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type DistributionRequestControllerGetDistributionRequest200 = GetDistributionRequestOutput;

export type DistributionRequestControllerGetDistributionRequest404 = DistributionRequestNotFoundErrorDto;

export type DistributionRequestControllerGetDistributionRequestQueryResponse = DistributionRequestControllerGetDistributionRequest200;

export type DistributionRequestControllerGetDistributionRequestQuery = {
    Response: DistributionRequestControllerGetDistributionRequest200;
    PathParams: DistributionRequestControllerGetDistributionRequestPathParams;
    Errors: DistributionRequestControllerGetDistributionRequest404;
};

export type DistributionRequestControllerDeleteDistributionRequestPathParams = {
    /**
     * @type string
    */
    id: string;
};

export type DistributionRequestControllerDeleteDistributionRequest200 = DeleteDistributionRequestOutput;

export type DistributionRequestControllerDeleteDistributionRequest404 = DistributionRequestNotFoundErrorDto;

export type DistributionRequestControllerDeleteDistributionRequestMutationResponse = DistributionRequestControllerDeleteDistributionRequest200;

export type DistributionRequestControllerDeleteDistributionRequestMutation = {
    Response: DistributionRequestControllerDeleteDistributionRequest200;
    PathParams: DistributionRequestControllerDeleteDistributionRequestPathParams;
    Errors: DistributionRequestControllerDeleteDistributionRequest404;
};

export const distributionRequestControllerListDistributionRequestsQueryParamsStatusesEnum = {
    PENDING: "PENDING",
    WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED"
} as const;

export type DistributionRequestControllerListDistributionRequestsQueryParamsStatusesEnumKey = (typeof distributionRequestControllerListDistributionRequestsQueryParamsStatusesEnum)[keyof typeof distributionRequestControllerListDistributionRequestsQueryParamsStatusesEnum];

export type DistributionRequestControllerListDistributionRequestsQueryParams = {
    /**
     * @description Status of the distribution request
     * @type array | undefined
    */
    statuses?: DistributionRequestControllerListDistributionRequestsQueryParamsStatusesEnumKey[];
    /**
     * @description Brokerage firm the request is attached to
     * @type string | undefined
    */
    brokerageFirmId?: string;
    /**
     * @description Product id
     * @type string | undefined
    */
    productId?: string;
};

export type DistributionRequestControllerListDistributionRequests201 = ListDistributionRequestsOutput;

export type DistributionRequestControllerListDistributionRequestsMutationRequest = ListDistributionRequestsBody;

export type DistributionRequestControllerListDistributionRequestsMutationResponse = DistributionRequestControllerListDistributionRequests201;

export type DistributionRequestControllerListDistributionRequestsMutation = {
    Response: DistributionRequestControllerListDistributionRequests201;
    Request: DistributionRequestControllerListDistributionRequestsMutationRequest;
    QueryParams: DistributionRequestControllerListDistributionRequestsQueryParams;
    Errors: any;
};

export type BrokerageFeeControllerCreateBrokerageFeePathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFeeControllerCreateBrokerageFee201 = CreateBrokerageFeeOutput;

export type BrokerageFeeControllerCreateBrokerageFee404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFeeControllerCreateBrokerageFeeMutationRequest = CreateBrokerageFeeBody;

export type BrokerageFeeControllerCreateBrokerageFeeMutationResponse = BrokerageFeeControllerCreateBrokerageFee201;

export type BrokerageFeeControllerCreateBrokerageFeeMutation = {
    Response: BrokerageFeeControllerCreateBrokerageFee201;
    Request: BrokerageFeeControllerCreateBrokerageFeeMutationRequest;
    PathParams: BrokerageFeeControllerCreateBrokerageFeePathParams;
    Errors: BrokerageFeeControllerCreateBrokerageFee404;
};

export type BrokerageFeeControllerUpdateBrokerageFeePathParams = {
    /**
     * @type string
    */
    brokerageFeeId: string;
};

export type BrokerageFeeControllerUpdateBrokerageFee200 = UpdateBrokerageFeeOutput;

export type BrokerageFeeControllerUpdateBrokerageFee404 = BrokerageFeeNotFoundErrorDto;

export type BrokerageFeeControllerUpdateBrokerageFeeMutationRequest = UpdateBrokerageFeeBody;

export type BrokerageFeeControllerUpdateBrokerageFeeMutationResponse = BrokerageFeeControllerUpdateBrokerageFee200;

export type BrokerageFeeControllerUpdateBrokerageFeeMutation = {
    Response: BrokerageFeeControllerUpdateBrokerageFee200;
    Request: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest;
    PathParams: BrokerageFeeControllerUpdateBrokerageFeePathParams;
    Errors: BrokerageFeeControllerUpdateBrokerageFee404;
};

export type BrokerageFeeControllerDeleteBrokerageFeePathParams = {
    /**
     * @type string
    */
    brokerageFeeId: string;
};

export type BrokerageFeeControllerDeleteBrokerageFee200 = DeleteBrokerageFeeOutput;

export type BrokerageFeeControllerDeleteBrokerageFee404 = BrokerageFeeNotFoundErrorDto;

export type BrokerageFeeControllerDeleteBrokerageFeeMutationResponse = BrokerageFeeControllerDeleteBrokerageFee200;

export type BrokerageFeeControllerDeleteBrokerageFeeMutation = {
    Response: BrokerageFeeControllerDeleteBrokerageFee200;
    PathParams: BrokerageFeeControllerDeleteBrokerageFeePathParams;
    Errors: BrokerageFeeControllerDeleteBrokerageFee404;
};

export type BrokerageFeeControllerGetBrokerFeesQueryParams = {
    /**
     * @description Brokerage firm id
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFeeControllerGetBrokerFees200 = GetBrokerageFeesOutput;

export type BrokerageFeeControllerGetBrokerFees404 = BrokerageFirmNotFoundErrorDto;

export type BrokerageFeeControllerGetBrokerFeesQueryResponse = BrokerageFeeControllerGetBrokerFees200;

export type BrokerageFeeControllerGetBrokerFeesQuery = {
    Response: BrokerageFeeControllerGetBrokerFees200;
    QueryParams: BrokerageFeeControllerGetBrokerFeesQueryParams;
    Errors: BrokerageFeeControllerGetBrokerFees404;
};

export type TelematicsControllerUpsertExternalServiceUserId201 = UpsertExternalServiceUserIdOutput;

export type TelematicsControllerUpsertExternalServiceUserIdMutationRequest = UpsertExternalServiceUserIdInputBody;

export type TelematicsControllerUpsertExternalServiceUserIdMutationResponse = TelematicsControllerUpsertExternalServiceUserId201;

export type TelematicsControllerUpsertExternalServiceUserIdMutation = {
    Response: TelematicsControllerUpsertExternalServiceUserId201;
    Request: TelematicsControllerUpsertExternalServiceUserIdMutationRequest;
    Errors: any;
};

export type TenantOnboardingControllerCreateAccount201 = CreateAccountOutput;

export type TenantOnboardingControllerCreateAccountMutationRequest = CreateAccountInputBody;

export type TenantOnboardingControllerCreateAccountMutationResponse = TenantOnboardingControllerCreateAccount201;

export type TenantOnboardingControllerCreateAccountMutation = {
    Response: TenantOnboardingControllerCreateAccount201;
    Request: TenantOnboardingControllerCreateAccountMutationRequest;
    Errors: any;
};

export type TenantOnboardingControllerCreateAccountLinkPathParams = {
    /**
     * @type string
    */
    accountId: string;
};

export type TenantOnboardingControllerCreateAccountLink201 = CreateAccountLinkOutput;

export type TenantOnboardingControllerCreateAccountLinkMutationResponse = TenantOnboardingControllerCreateAccountLink201;

export type TenantOnboardingControllerCreateAccountLinkMutation = {
    Response: TenantOnboardingControllerCreateAccountLink201;
    PathParams: TenantOnboardingControllerCreateAccountLinkPathParams;
    Errors: any;
};

export type PortfolioMigrationControllerStartMigrationWorkflow201 = StartMigrationWorkflowOutput;

export type PortfolioMigrationControllerStartMigrationWorkflowMutationRequest = StartMigrationWorkflowBody;

export type PortfolioMigrationControllerStartMigrationWorkflowMutationResponse = PortfolioMigrationControllerStartMigrationWorkflow201;

export type PortfolioMigrationControllerStartMigrationWorkflowMutation = {
    Response: PortfolioMigrationControllerStartMigrationWorkflow201;
    Request: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest;
    Errors: any;
};

export type PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow201 = StartPaymentMethodsMigrationOutput;

export type PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest = StartPaymentMethodsMigrationBody;

export type PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse = PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow201;

export type PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutation = {
    Response: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow201;
    Request: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest;
    Errors: any;
};

export type EfficialeControllerCheckComplianceQueryParams = {
    /**
     * @type object
    */
    searchParams: _Object;
    /**
     * @description Internal ID of the individual or organization
     * @type string | undefined
    */
    internalId?: string;
    /**
     * @description Tags
     * @type string | undefined
    */
    tags?: string;
    /**
     * @description Alert found
     * @type object | undefined
    */
    alertData?: ComplianceDataItem;
    /**
     * @description Control list to check against (gel, ppe_nat, ppe_inter)
     * @type string | undefined
    */
    controlList?: string;
};

export type EfficialeControllerCheckCompliance200 = EfficialeCheckComplianceOutput;

export type EfficialeControllerCheckComplianceQueryResponse = EfficialeControllerCheckCompliance200;

export type EfficialeControllerCheckComplianceQuery = {
    Response: EfficialeControllerCheckCompliance200;
    QueryParams: EfficialeControllerCheckComplianceQueryParams;
    Errors: any;
};

export type EfficialeControllerGetAlertsQueryParams = {
    /**
     * @description Start date of the alerts
     * @type string | undefined
    */
    from?: string;
    /**
     * @description End date of the alerts
     * @type string | undefined
    */
    to?: string;
};

export type EfficialeControllerGetAlerts200 = GetAlertsOutput;

export type EfficialeControllerGetAlertsQueryResponse = EfficialeControllerGetAlerts200;

export type EfficialeControllerGetAlertsQuery = {
    Response: EfficialeControllerGetAlerts200;
    QueryParams: EfficialeControllerGetAlertsQueryParams;
    Errors: any;
};

export type EllisphereControllerOrderOnline201 = EllisphereOnlineOrderOutput;

export type EllisphereControllerOrderOnlineMutationRequest = GetSolvabilityScoreInputBody;

export type EllisphereControllerOrderOnlineMutationResponse = EllisphereControllerOrderOnline201;

export type EllisphereControllerOrderOnlineMutation = {
    Response: EllisphereControllerOrderOnline201;
    Request: EllisphereControllerOrderOnlineMutationRequest;
    Errors: any;
};

export type SolvabilityControllerGetScore201 = GetSolvabilityScoreOutput;

export type SolvabilityControllerGetScoreMutationRequest = GetSolvabilityScoreInputBody;

export type SolvabilityControllerGetScoreMutationResponse = SolvabilityControllerGetScore201;

export type SolvabilityControllerGetScoreMutation = {
    Response: SolvabilityControllerGetScore201;
    Request: SolvabilityControllerGetScoreMutationRequest;
    Errors: any;
};

export type MetabaseControllerGetIframeUrlQueryParams = {
    /**
     * @type string | undefined
    */
    name?: string;
};

export type MetabaseControllerGetIframeUrl200 = GetMetabaseIframeUrlOutput;

export type MetabaseControllerGetIframeUrlQueryResponse = MetabaseControllerGetIframeUrl200;

export type MetabaseControllerGetIframeUrlQuery = {
    Response: MetabaseControllerGetIframeUrl200;
    QueryParams: MetabaseControllerGetIframeUrlQueryParams;
    Errors: any;
};

export type FvaControllerUploadFileQueryParams = {
    /**
     * @description Document ID of the ZIP file containing FVA XML
     * @type string
    */
    documentId: string;
};

export type FvaControllerUploadFile201 = FvaUploadFileOutput;

export type FvaControllerUploadFileMutationResponse = FvaControllerUploadFile201;

export type FvaControllerUploadFileMutation = {
    Response: FvaControllerUploadFile201;
    QueryParams: FvaControllerUploadFileQueryParams;
    Errors: any;
};

export type FvaControllerRetrieveReportOutcomeQueryParams = {
    /**
     * @description FVA operation code
     * @type number
    */
    operationCode: number;
};

export type FvaControllerRetrieveReportOutcome200 = FvaRetrieveReportOutcomeOutput;

export type FvaControllerRetrieveReportOutcomeQueryResponse = FvaControllerRetrieveReportOutcome200;

export type FvaControllerRetrieveReportOutcomeQuery = {
    Response: FvaControllerRetrieveReportOutcome200;
    QueryParams: FvaControllerRetrieveReportOutcomeQueryParams;
    Errors: any;
};

export type DocumentValidityControllerGetPolicyValidityPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type DocumentValidityControllerGetPolicyValidityQueryParams = {
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type DocumentValidityControllerGetPolicyValidity200 = GetPolicyValidityOutput;

export type DocumentValidityControllerGetPolicyValidity404 = PolicyNotFoundErrorDto;

export type DocumentValidityControllerGetPolicyValidityQueryResponse = DocumentValidityControllerGetPolicyValidity200;

export type DocumentValidityControllerGetPolicyValidityQuery = {
    Response: DocumentValidityControllerGetPolicyValidity200;
    PathParams: DocumentValidityControllerGetPolicyValidityPathParams;
    QueryParams: DocumentValidityControllerGetPolicyValidityQueryParams;
    Errors: DocumentValidityControllerGetPolicyValidity404;
};

export type DocumentValidityControllerGetDocumentValidityPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type DocumentValidityControllerGetDocumentValidity200 = GetDocumentValidityOutput;

export type DocumentValidityControllerGetDocumentValidity500 = DocumentValidityFailedErrorDto;

export type DocumentValidityControllerGetDocumentValidityQueryResponse = DocumentValidityControllerGetDocumentValidity200;

export type DocumentValidityControllerGetDocumentValidityQuery = {
    Response: DocumentValidityControllerGetDocumentValidity200;
    PathParams: DocumentValidityControllerGetDocumentValidityPathParams;
    Errors: DocumentValidityControllerGetDocumentValidity500;
};

export type DocumentValidityControllerOverrideDocumentValidityPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type DocumentValidityControllerOverrideDocumentValidity200 = GetDocumentValidityOutput;

export type DocumentValidityControllerOverrideDocumentValidity500 = DocumentValidityFailedErrorDto;

export type DocumentValidityControllerOverrideDocumentValidityMutationRequest = OverrideValidityBody;

export type DocumentValidityControllerOverrideDocumentValidityMutationResponse = DocumentValidityControllerOverrideDocumentValidity200;

export type DocumentValidityControllerOverrideDocumentValidityMutation = {
    Response: DocumentValidityControllerOverrideDocumentValidity200;
    Request: DocumentValidityControllerOverrideDocumentValidityMutationRequest;
    PathParams: DocumentValidityControllerOverrideDocumentValidityPathParams;
    Errors: DocumentValidityControllerOverrideDocumentValidity500;
};

export type BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidity200 = GetBrokerageFirmValidityOutput;

export type BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse = BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidity200;

export type BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQuery = {
    Response: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidity200;
    PathParams: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams;
    Errors: any;
};

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidity200 = GetDocumentValidityOutput;

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500 = DocumentValidityFailedErrorDto;

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest = OverrideValidityBody;

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse = BrokerageFirmDocumentValidityControllerOverrideDocumentValidity200;

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutation = {
    Response: BrokerageFirmDocumentValidityControllerOverrideDocumentValidity200;
    Request: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest;
    PathParams: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams;
    Errors: BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500;
};

export type DocumentCoherenceControllerGetDocumentCoherencePathParams = {
    /**
     * @description Policy or brokerage firm ID
     * @type string
    */
    entityId: string;
};

export type DocumentCoherenceControllerGetDocumentCoherenceQueryParams = {
    /**
     * @description Policy branch, BASE when omitted; ignored for a brokerage firm
     * @type string | undefined
    */
    branchId?: string;
};

export type DocumentCoherenceControllerGetDocumentCoherence200 = GetDocumentCoherenceOutput;

export type DocumentCoherenceControllerGetDocumentCoherence400 = DocumentCoherenceUnsupportedEntityErrorDto;

export type DocumentCoherenceControllerGetDocumentCoherence404 = BrokerageFirmNotFoundErrorDto;

export type DocumentCoherenceControllerGetDocumentCoherenceQueryResponse = DocumentCoherenceControllerGetDocumentCoherence200;

export type DocumentCoherenceControllerGetDocumentCoherenceQuery = {
    Response: DocumentCoherenceControllerGetDocumentCoherence200;
    PathParams: DocumentCoherenceControllerGetDocumentCoherencePathParams;
    QueryParams: DocumentCoherenceControllerGetDocumentCoherenceQueryParams;
    Errors: DocumentCoherenceControllerGetDocumentCoherence400 | DocumentCoherenceControllerGetDocumentCoherence404;
};

export type PolicyDocumentControllerAcceptPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type PolicyDocumentControllerAccept200 = DocumentConformityDto;

export type PolicyDocumentControllerAccept404 = DocumentNotFoundErrorDto;

export type PolicyDocumentControllerAcceptMutationRequest = AcceptDocumentInputBody;

export type PolicyDocumentControllerAcceptMutationResponse = PolicyDocumentControllerAccept200;

export type PolicyDocumentControllerAcceptMutation = {
    Response: PolicyDocumentControllerAccept200;
    Request: PolicyDocumentControllerAcceptMutationRequest;
    PathParams: PolicyDocumentControllerAcceptPathParams;
    Errors: PolicyDocumentControllerAccept404;
};

export type PolicyDocumentControllerRejectPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type PolicyDocumentControllerReject200 = DocumentConformityDto;

export type PolicyDocumentControllerReject404 = DocumentNotFoundErrorDto;

export type PolicyDocumentControllerRejectMutationRequest = RejectDocumentInputBody;

export type PolicyDocumentControllerRejectMutationResponse = PolicyDocumentControllerReject200;

export type PolicyDocumentControllerRejectMutation = {
    Response: PolicyDocumentControllerReject200;
    Request: PolicyDocumentControllerRejectMutationRequest;
    PathParams: PolicyDocumentControllerRejectPathParams;
    Errors: PolicyDocumentControllerReject404;
};

export type PolicyDocumentControllerAcceptAllPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyDocumentControllerAcceptAll200 = AcceptAllDocumentsOutput;

export type PolicyDocumentControllerAcceptAll409 = DocumentConformityUntypedDocumentsErrorDto;

export type PolicyDocumentControllerAcceptAllMutationRequest = AcceptAllDocumentsInputBody;

export type PolicyDocumentControllerAcceptAllMutationResponse = PolicyDocumentControllerAcceptAll200;

export type PolicyDocumentControllerAcceptAllMutation = {
    Response: PolicyDocumentControllerAcceptAll200;
    Request: PolicyDocumentControllerAcceptAllMutationRequest;
    PathParams: PolicyDocumentControllerAcceptAllPathParams;
    Errors: PolicyDocumentControllerAcceptAll409;
};

export type PolicyDocumentControllerCancelPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    conformityId: string;
};

export type PolicyDocumentControllerCancel200 = DocumentConformityDto;

export type PolicyDocumentControllerCancel404 = DocumentConformityNotFoundErrorDto;

export type PolicyDocumentControllerCancelMutationResponse = PolicyDocumentControllerCancel200;

export type PolicyDocumentControllerCancelMutation = {
    Response: PolicyDocumentControllerCancel200;
    PathParams: PolicyDocumentControllerCancelPathParams;
    Errors: PolicyDocumentControllerCancel404;
};

export type PolicyDocumentControllerGetPolicyDocumentConformityPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyDocumentControllerGetPolicyDocumentConformityQueryParams = {
    /**
     * @type string
    */
    branchId: string;
};

export type PolicyDocumentControllerGetPolicyDocumentConformity200 = GetPolicyDocumentConformityOutput;

export type PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse = PolicyDocumentControllerGetPolicyDocumentConformity200;

export type PolicyDocumentControllerGetPolicyDocumentConformityQuery = {
    Response: PolicyDocumentControllerGetPolicyDocumentConformity200;
    PathParams: PolicyDocumentControllerGetPolicyDocumentConformityPathParams;
    QueryParams: PolicyDocumentControllerGetPolicyDocumentConformityQueryParams;
    Errors: any;
};

export type PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams = {
    /**
     * @type string
    */
    branchId: string;
};

export type PolicyDocumentControllerGetPolicyDocumentVerdicts200 = GetPolicyDocumentVerdictsOutput;

export type PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse = PolicyDocumentControllerGetPolicyDocumentVerdicts200;

export type PolicyDocumentControllerGetPolicyDocumentVerdictsQuery = {
    Response: PolicyDocumentControllerGetPolicyDocumentVerdicts200;
    PathParams: PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams;
    QueryParams: PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams;
    Errors: any;
};

export type PolicyDocumentControllerGetPolicyDocumentFraudPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyDocumentControllerGetPolicyDocumentFraudQueryParams = {
    /**
     * @type string
    */
    branchId: string;
};

export type PolicyDocumentControllerGetPolicyDocumentFraud200 = GetPolicyDocumentFraudOutput;

export type PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse = PolicyDocumentControllerGetPolicyDocumentFraud200;

export type PolicyDocumentControllerGetPolicyDocumentFraudQuery = {
    Response: PolicyDocumentControllerGetPolicyDocumentFraud200;
    PathParams: PolicyDocumentControllerGetPolicyDocumentFraudPathParams;
    QueryParams: PolicyDocumentControllerGetPolicyDocumentFraudQueryParams;
    Errors: any;
};

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams = {
    /**
     * @type string
    */
    policyId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict200 = CorrectPolicyDocumentFraudVerdictOutput;

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 = DocumentNotFoundErrorDto;

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409 = DocumentFraudVerdictConflictErrorDto;

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest = CorrectPolicyDocumentFraudVerdictInputBody;

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse = PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict200;

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutation = {
    Response: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict200;
    Request: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest;
    PathParams: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams;
    Errors: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409;
};

export type BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument200 = BrokerageFirmDocumentConformityDto;

export type BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404 = DocumentNotFoundErrorDto;

export type BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse = BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument200;

export type BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutation = {
    Response: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument200;
    PathParams: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams;
    Errors: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404;
};

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocument200 = BrokerageFirmDocumentConformityDto;

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404 = DocumentNotFoundErrorDto;

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest = RejectBrokerageFirmDocumentInputBody;

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse = BrokerageFirmDocumentControllerRejectBrokerageFirmDocument200;

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutation = {
    Response: BrokerageFirmDocumentControllerRejectBrokerageFirmDocument200;
    Request: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest;
    PathParams: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams;
    Errors: BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404;
};

export type BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments200 = AcceptAllBrokerageFirmDocumentsOutput;

export type BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409 = BrokerageFirmDocumentConformityUntypedDocumentsErrorDto;

export type BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse = BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments200;

export type BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutation = {
    Response: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments200;
    PathParams: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams;
    Errors: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409;
};

export type BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    conformityId: string;
};

export type BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity200 = BrokerageFirmDocumentConformityDto;

export type BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404 = BrokerageFirmDocumentConformityNotFoundErrorDto;

export type BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse = BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity200;

export type BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutation = {
    Response: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity200;
    PathParams: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams;
    Errors: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404;
};

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity200 = GetBrokerageFirmDocumentConformityOutput;

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity200;

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQuery = {
    Response: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity200;
    PathParams: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams;
    Errors: any;
};

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud200 = GetBrokerageFirmDocumentFraudOutput;

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud200;

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQuery = {
    Response: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud200;
    PathParams: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams;
    Errors: any;
};

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
    /**
     * @type string
    */
    documentId: string;
};

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict200 = CorrectBrokerageFirmDocumentFraudVerdictOutput;

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 = DocumentNotFoundErrorDto;

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409 = DocumentFraudVerdictConflictErrorDto;

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest = CorrectPolicyDocumentFraudVerdictInputBody;

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse = BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict200;

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutation = {
    Response: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict200;
    Request: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest;
    PathParams: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams;
    Errors: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409;
};

export type PolicyDocumentCollectionControllerGetCollectionStatePathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyDocumentCollectionControllerGetCollectionStateQueryParams = {
    /**
     * @type string
    */
    branchId: string;
};

export type PolicyDocumentCollectionControllerGetCollectionState200 = GetDocumentCollectionStateOutput;

export type PolicyDocumentCollectionControllerGetCollectionStateQueryResponse = PolicyDocumentCollectionControllerGetCollectionState200;

export type PolicyDocumentCollectionControllerGetCollectionStateQuery = {
    Response: PolicyDocumentCollectionControllerGetCollectionState200;
    PathParams: PolicyDocumentCollectionControllerGetCollectionStatePathParams;
    QueryParams: PolicyDocumentCollectionControllerGetCollectionStateQueryParams;
    Errors: any;
};

export type PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams = {
    /**
     * @type string
    */
    policyId: string;
};

export type PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams = {
    /**
     * @type string | undefined
    */
    branchId?: string;
};

export type PolicyDocumentExtractionControllerGetPolicyExtractions200 = GetPolicyExtractionsOutput;

export type PolicyDocumentExtractionControllerGetPolicyExtractions404 = PolicyNotFoundErrorDto;

export type PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse = PolicyDocumentExtractionControllerGetPolicyExtractions200;

export type PolicyDocumentExtractionControllerGetPolicyExtractionsQuery = {
    Response: PolicyDocumentExtractionControllerGetPolicyExtractions200;
    PathParams: PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams;
    QueryParams: PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams;
    Errors: PolicyDocumentExtractionControllerGetPolicyExtractions404;
};

export type DocumentExtractionControllerGetDocumentExtractionPathParams = {
    /**
     * @type string
    */
    documentId: string;
};

export type DocumentExtractionControllerGetDocumentExtraction200 = GetDocumentExtractionOutput;

export type DocumentExtractionControllerGetDocumentExtraction404 = DocumentExtractionNotFoundErrorDto;

export type DocumentExtractionControllerGetDocumentExtractionQueryResponse = DocumentExtractionControllerGetDocumentExtraction200;

export type DocumentExtractionControllerGetDocumentExtractionQuery = {
    Response: DocumentExtractionControllerGetDocumentExtraction200;
    PathParams: DocumentExtractionControllerGetDocumentExtractionPathParams;
    Errors: DocumentExtractionControllerGetDocumentExtraction404;
};

export type DocumentExtractionControllerRetryDocumentExtractionPathParams = {
    /**
     * @type string
    */
    documentId: string;
};

export type DocumentExtractionControllerRetryDocumentExtraction201 = ExtractDocumentOutput;

export type DocumentExtractionControllerRetryDocumentExtraction404 = DocumentExtractionNotFoundErrorDto;

export type DocumentExtractionControllerRetryDocumentExtractionMutationResponse = DocumentExtractionControllerRetryDocumentExtraction201;

export type DocumentExtractionControllerRetryDocumentExtractionMutation = {
    Response: DocumentExtractionControllerRetryDocumentExtraction201;
    PathParams: DocumentExtractionControllerRetryDocumentExtractionPathParams;
    Errors: DocumentExtractionControllerRetryDocumentExtraction404;
};

export type DocumentExtractionControllerSubmitExtractionFeedbackPathParams = {
    /**
     * @type string
    */
    documentId: string;
};

export type DocumentExtractionControllerSubmitExtractionFeedback201 = SubmitExtractionFeedbackOutput;

export type DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest = SubmitFeedbackBody;

export type DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse = DocumentExtractionControllerSubmitExtractionFeedback201;

export type DocumentExtractionControllerSubmitExtractionFeedbackMutation = {
    Response: DocumentExtractionControllerSubmitExtractionFeedback201;
    Request: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest;
    PathParams: DocumentExtractionControllerSubmitExtractionFeedbackPathParams;
    Errors: any;
};

export type DocumentExtractionControllerGetExtractionFeedbackPathParams = {
    /**
     * @type string
    */
    documentId: string;
};

export type DocumentExtractionControllerGetExtractionFeedback200 = GetExtractionFeedbackOutput;

export type DocumentExtractionControllerGetExtractionFeedbackQueryResponse = DocumentExtractionControllerGetExtractionFeedback200;

export type DocumentExtractionControllerGetExtractionFeedbackQuery = {
    Response: DocumentExtractionControllerGetExtractionFeedback200;
    PathParams: DocumentExtractionControllerGetExtractionFeedbackPathParams;
    Errors: any;
};

export type BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams = {
    /**
     * @type string
    */
    brokerageFirmId: string;
};

export type BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions200 = GetBrokerageFirmExtractionsOutput;

export type BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse = BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions200;

export type BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQuery = {
    Response: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions200;
    PathParams: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams;
    Errors: any;
};

export type DocumentPrefillControllerRecordOutcome201 = RecordPrefillOutcomeOutput;

export type DocumentPrefillControllerRecordOutcomeMutationRequest = RecordPrefillOutcomeBody;

export type DocumentPrefillControllerRecordOutcomeMutationResponse = DocumentPrefillControllerRecordOutcome201;

export type DocumentPrefillControllerRecordOutcomeMutation = {
    Response: DocumentPrefillControllerRecordOutcome201;
    Request: DocumentPrefillControllerRecordOutcomeMutationRequest;
    Errors: any;
};

export type JwksControllerGetJwks200 = any;

export type JwksControllerGetJwksQueryResponse = JwksControllerGetJwks200;

export type JwksControllerGetJwksQuery = {
    Response: JwksControllerGetJwks200;
    Errors: any;
};

export type ImpersonationControllerCreateSession200 = CreateImpersonationSessionResponse;

export type ImpersonationControllerCreateSessionMutationRequest = CreateImpersonationSessionBody;

export type ImpersonationControllerCreateSessionMutationResponse = ImpersonationControllerCreateSession200;

export type ImpersonationControllerCreateSessionMutation = {
    Response: ImpersonationControllerCreateSession200;
    Request: ImpersonationControllerCreateSessionMutationRequest;
    Errors: any;
};

export const impersonationControllerListSessionsQueryParamsFilterEnum = {
    LIVE: "LIVE",
    PAST: "PAST",
    ALL: "ALL"
} as const;

export type ImpersonationControllerListSessionsQueryParamsFilterEnumKey = (typeof impersonationControllerListSessionsQueryParamsFilterEnum)[keyof typeof impersonationControllerListSessionsQueryParamsFilterEnum];

export type ImpersonationControllerListSessionsQueryParams = {
    /**
     * @description the number of items to return
     * @default 10
     * @type number | undefined
    */
    count?: number;
    /**
     * @description the page to retrieve
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Restrict to one tenant. Omitted lists every tenant.
     * @type string | undefined
    */
    tenantId?: string;
    /**
     * @description Which slice of the audit trail to return. Defaults to live sessions only.
     * @default "LIVE"
     * @type string | undefined
    */
    filter?: ImpersonationControllerListSessionsQueryParamsFilterEnumKey;
};

export type ImpersonationControllerListSessions200 = ListImpersonationSessionsOutput;

export type ImpersonationControllerListSessionsQueryResponse = ImpersonationControllerListSessions200;

export type ImpersonationControllerListSessionsQuery = {
    Response: ImpersonationControllerListSessions200;
    QueryParams: ImpersonationControllerListSessionsQueryParams;
    Errors: any;
};

export type ImpersonationControllerRevokeCurrentSession200 = RevokeImpersonationSessionResponse;

export type ImpersonationControllerRevokeCurrentSessionMutationResponse = ImpersonationControllerRevokeCurrentSession200;

export type ImpersonationControllerRevokeCurrentSessionMutation = {
    Response: ImpersonationControllerRevokeCurrentSession200;
    Errors: any;
};

export type ImpersonationControllerRevokeSessionPathParams = {
    /**
     * @type string
    */
    sessionId: string;
};

export type ImpersonationControllerRevokeSession200 = RevokeImpersonationSessionResponse;

export type ImpersonationControllerRevokeSessionMutationResponse = ImpersonationControllerRevokeSession200;

export type ImpersonationControllerRevokeSessionMutation = {
    Response: ImpersonationControllerRevokeSession200;
    PathParams: ImpersonationControllerRevokeSessionPathParams;
    Errors: any;
};

export type FederatedSessionControllerRevokeCurrentSession200 = RevokeFederatedSessionResponse;

export type FederatedSessionControllerRevokeCurrentSessionMutationResponse = FederatedSessionControllerRevokeCurrentSession200;

export type FederatedSessionControllerRevokeCurrentSessionMutation = {
    Response: FederatedSessionControllerRevokeCurrentSession200;
    Errors: any;
};

export type SpeechToTextControllerGetCredentials201 = ((AwsTranscribeCredentialsDto & {
    provider: "aws-transcribe";
}) | (ElevenLabsCredentialsDto & {
    provider: "elevenlabs";
}));

export type SpeechToTextControllerGetCredentialsMutationRequest = SpeechToTextCredentialsRequestDto;

export type SpeechToTextControllerGetCredentialsMutationResponse = SpeechToTextControllerGetCredentials201;

export type SpeechToTextControllerGetCredentialsMutation = {
    Response: SpeechToTextControllerGetCredentials201;
    Request: SpeechToTextControllerGetCredentialsMutationRequest;
    Errors: any;
};

export type FcbWidgetControllerMintToken200 = any;

export type FcbWidgetControllerMintTokenQueryResponse = FcbWidgetControllerMintToken200;

export type FcbWidgetControllerMintTokenQuery = {
    Response: FcbWidgetControllerMintToken200;
    Errors: any;
};

export type FcbWidgetControllerInitWhatsappConversation201 = InitWhatsappConversationOutput;

export type FcbWidgetControllerInitWhatsappConversationMutationRequest = InitWhatsappConversationInput;

export type FcbWidgetControllerInitWhatsappConversationMutationResponse = FcbWidgetControllerInitWhatsappConversation201;

export type FcbWidgetControllerInitWhatsappConversationMutation = {
    Response: FcbWidgetControllerInitWhatsappConversation201;
    Request: FcbWidgetControllerInitWhatsappConversationMutationRequest;
    Errors: any;
};